/* Built by harness/build-scene-pages.cjs from src/scene-pages/pages/library/book.js, borders.js, cards.js, favorites.js, fight.js, gallery.js, games.js, jukebox.js, ledger.js, memories.js, moods.js, offer.js, pack.js, study.js, waitlist.js + pages/library.js. Edit the source, then rebuild. */
/* ===== src/scene-pages/pages/library/book.js ===== */
/* library/book.js: the Commissioner’s Guide as a book in Zhaunil’s library (a part of the library page, id library).
   Jan (2026-10-05): "try to make the experiece immersive so i think its better to actually have it all within the
   experience including the blogs ... make it so that the label is clear when they open each section all 140 articles
   dont need to show up so many times either also too many options at the bottom, just do return to the library or read
   another book thats it". The spec is docs/scene-pages/demo2/research/LIBRARY-V2-SPEC.md (section 4, and its part on
   the Guide book).

   A leather-bound book opens over the dimmed room: on a wide screen about 760 px wide in the middle, the room around
   it; on a phone the whole frame. Parchment, gilt corners, a red ribbon. Every view carries the same head, "The
   Commissioner’s Guide" with "Guide" in gold italic, and under it the line the room chose ("From the gift shelf").
     contents   the lead entry with its cover framed as a plate, then three rows with small covers. Turn the page for
                the next four of that shelf (or of the whole Guide), and back. The whole Guide link shows once, as one
                quiet line on the last contents page. Its own words name where it goes, so it goes at once (goNow).
     reading    an entry turns the page into its article. The ribbon fills as the reader goes; the end counts the book
                as read (api.finished) and offers exactly two choices, Return to the library and Read another book.
     links      a link to another Guide article opens it in the book; any other link in an article's own text asks inside
                the book first ("Go there" or "Stay in the book") and only Go there calls api.go(href). A button that
                already names the Guide ("The whole Guide on FramedFantasy", "Read it in the Guide") is its own yes and
                calls api.go(href) at once, with no slip (Jan, 2026-10-11, on asking the same thing twice).
   The interface (the room calls the factory once, after its frame exists):
     FFD.parts['library/book'](api) -> { open({ bay, book, from }) -> Promise<'library' | 'another'>, close(), isOpen() }
   The book never speaks in the box and never reads the room’s variables. It draws itself inside api.F.el, styles itself
   with one style element (id ffd-css-library-book, every rule under .ffd-page--library), and cleans up everything on
   close() or when api.alive() turns false. Nothing a reader does here is stored or sent by the book itself. */
(() => {
  'use strict';
  const FFD = window.FFD;
  if (!FFD) return;
  const CSS_ID = 'ffd-css-library-book';
  const P = '.ffd-page--library';

  /* small drawn things: the close cross, the chevrons, the ornaments and the gilt corners */
  const X_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.6 3.6l8.8 8.8M12.4 3.6l-8.8 8.8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  const PREV_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M10 3.5 5.5 8l4.5 4.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const NEXT_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M6 3.5 10.5 8 6 12.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const svgUrl = (s) => 'url("data:image/svg+xml,' + encodeURIComponent(s) + '")';
  const GILT = svgUrl("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'><defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='#f6e3a4'/><stop offset='.45' stop-color='#d0a54e'/><stop offset='1' stop-color='#7a561a'/></linearGradient></defs><path d='M0 0H32C26 3 21.5 6.5 18 10.5S11 19 9 23.5 4.5 29.5 0 32Z' fill='url(#g)' stroke='#4e3410' stroke-width='.9'/><path d='M3.2 3.2H23.5C19.5 5.6 16.4 8.4 14 11.4S9.2 18 7.6 21.4 5 25.8 3.2 27Z' fill='none' stroke='#fff5cf' stroke-opacity='.55' stroke-width='.7'/><circle cx='7.4' cy='7.4' r='1.7' fill='#fff2c2' fill-opacity='.85' stroke='#6b4a14' stroke-width='.5'/></svg>");
  const ORN = svgUrl("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 12'><path d='M2 6H49M71 6H118' stroke='#8a6a1f' stroke-width='.8' stroke-linecap='round' opacity='.75'/><path d='M60 1.2 64.8 6 60 10.8 55.2 6Z' fill='#8a6a1f'/><path d='M50.5 6 53 3.5 55.5 6 53 8.5ZM64.5 6 67 3.5 69.5 6 67 8.5Z' fill='#8a6a1f' opacity='.6'/></svg>");
  const TAIL = svgUrl("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 22'><path d='M32 2 37 11 32 20 27 11Z' fill='#8a6a1f'/><path d='M4 11C12 11 18 6 25 10M60 11C52 11 46 6 39 10' fill='none' stroke='#8a6a1f' stroke-width='.9' stroke-linecap='round' opacity='.7'/><circle cx='4' cy='11' r='1.4' fill='#8a6a1f' opacity='.7'/><circle cx='60' cy='11' r='1.4' fill='#8a6a1f' opacity='.7'/></svg>");
  const GRAIN = svgUrl("<svg xmlns='http://www.w3.org/2000/svg' width='220' height='220'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='.82' numOctaves='3' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 .36 0 0 0 0 .25 0 0 0 0 .1 0 0 0 .12 0'/></filter><rect width='100%' height='100%' filter='url(#n)'/></svg>");
  const LEATHER = svgUrl("<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='.55' numOctaves='4' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 .08 0 0 0 0 .03 0 0 0 0 .01 0 0 0 .5 0'/></filter><rect width='100%' height='100%' filter='url(#n)'/></svg>");

  const PAPER = `
  --pp: #efe3c8; --ink: #2a2016; --ink-2: rgba(42, 32, 22, .86); --ink-3: rgba(42, 32, 22, .7); --line: rgba(42, 32, 22, .14); --line-2: rgba(42, 32, 22, .24);
  --gold: #8a6a1f; --gold-ink: #75591a; --gold-hi: #b48d36; --rib: #8f1f25; --rib-hi: #b8343a; --focus: #1f5f63;
  --ffb-bg: #efe3c8; --ffb-surface: rgba(122, 88, 40, .075); --ffb-surface-2: rgba(122, 88, 40, .11); --ffb-ink: #2a2016; --ffb-ink-2: rgba(42, 32, 22, .86); --ffb-ink-3: rgba(42, 32, 22, .7);
  --ffb-line: rgba(42, 32, 22, .14); --ffb-line-2: rgba(42, 32, 22, .22); --ffb-gold-hi: #b48d36; --ffb-gold-lo: #8a6a1f; --ffb-gold-text: #75591a; --ffb-gold-ink: #fbf3df;
  --ffb-radius: 5px; --ffb-serif: var(--f-aside, 'Cormorant Garamond', Georgia, serif); --ffb-sans: var(--f-body, 'Spectral', Georgia, serif); --ffb-ease: cubic-bezier(.2, .7, .2, 1); --ffb-gutter: 20px; --ffb-teal: #1f5f63;`;
  const PAPER_BG = `radial-gradient(130% 105% at 50% 42%, rgba(255, 249, 232, 0) 58%, rgba(140, 100, 48, .2) 100%), linear-gradient(90deg, rgba(92, 62, 26, .2), rgba(92, 62, 26, 0) 28px), ${GRAIN} 0 0 / 220px 220px, linear-gradient(180deg, #f2e7cf, #ecdfc2)`;

  const CSS = `
/* ---------- the book over the room ---------- */
${P} .lbk { position: absolute; inset: 0; z-index: 9; display: block; ${PAPER} color: var(--ink); font: 400 17px/1.6 var(--f-body); -webkit-tap-highlight-color: transparent; }
/* a drag on the parts that never scroll moves nothing (never on an ancestor of the reading area, which must pan) */
${P} .lbk-dim, ${P} .lbk-head, ${P} .lbk-slip, ${P} .lbk-gilt { touch-action: none; }
/* every empty element here says its display: the store's Dawn hides an empty div or p (div:empty { display: none }) */
${P} .lbk-dim { position: absolute; inset: 0; display: block; background: radial-gradient(ellipse 72% 70% at 50% 50%, rgba(10, 7, 4, .5), rgba(10, 7, 4, .84)); opacity: 0; transition: opacity .26s ease; }
${P} .lbk.is-in .lbk-dim { opacity: 1; }
${P} .lbk.is-out .lbk-dim { opacity: 0; transition-duration: .22s; }
${P} .lbk-book { position: absolute; inset: 0; display: flex; padding: 5px 5px 5px 7px; border-radius: 0;
  background: radial-gradient(120% 80% at 28% 12%, rgba(255, 214, 160, .1), rgba(255, 214, 160, 0) 60%), ${LEATHER} 0 0 / 160px 160px, linear-gradient(160deg, #5b2b1a, #3e1c11 58%, #2b130b);
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .55), inset 0 0 0 3px rgba(212, 170, 90, .16), inset 0 1px 0 4px rgba(255, 220, 170, .05);
  opacity: 0; transform: translateY(14px) scale(.985); transition: opacity .26s ease, transform .3s cubic-bezier(.2, .8, .2, 1); }
${P} .lbk.is-in .lbk-book { opacity: 1; transform: none; }
${P} .lbk.is-out .lbk-book { opacity: 0; transform: translateY(10px) scale(.985); transition-duration: .2s; }
/* a wide screen: the book in the middle (centred by its margins, so its text never sits on half a pixel) */
@media (min-width: 720px) {
  ${P} .lbk-book { left: 0; right: 0; top: 18px; bottom: 18px; width: min(760px, calc(100% - 48px)); margin: 0 auto; padding: 13px 13px 13px 19px; border-radius: 5px 9px 9px 5px;
    box-shadow: 0 34px 80px rgba(0, 0, 0, .62), 0 6px 18px rgba(0, 0, 0, .4), inset 0 0 0 1px rgba(0, 0, 0, .55), inset 0 0 0 4px rgba(212, 170, 90, .14), inset 7px 0 10px -6px rgba(0, 0, 0, .55); }
}
/* a very tall window keeps the book at a book’s height, in the middle */
@media (min-width: 720px) { ${P} .lbk-book { top: max(18px, calc(50% - 520px)); bottom: max(18px, calc(50% - 520px)); } }
@media (min-width: 720px) and (min-height: 820px) { ${P} .lbk-book { top: max(26px, calc(50% - 520px)); bottom: max(26px, calc(50% - 520px)); } }
${P} .lbk-book { perspective: 2200px; }
/* the front cover, open for a moment as the book arrives, with the Guide’s name in gilt */
${P} .lbk-flap { position: absolute; inset: 0; z-index: 6; display: grid; place-items: center; border-radius: inherit; transform-origin: 0 50%; backface-visibility: hidden; pointer-events: none;
  background: radial-gradient(90% 70% at 40% 30%, rgba(255, 214, 160, .12), rgba(255, 214, 160, 0) 65%), ${LEATHER} 0 0 / 160px 160px, linear-gradient(160deg, #61301d, #431f13 58%, #2e150c);
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .6), inset 0 0 0 7px rgba(43, 20, 11, .9), inset 0 0 0 8px rgba(212, 170, 90, .35), inset 0 0 0 12px rgba(43, 20, 11, .6), inset 0 0 0 13px rgba(212, 170, 90, .2), -10px 0 24px rgba(0, 0, 0, .35); }
${P} .lbk-flap-t { display: grid; justify-items: center; gap: 6px; color: #e9c979; text-shadow: 0 1px 0 rgba(0, 0, 0, .65), 0 0 18px rgba(233, 201, 121, .25); }
${P} .lbk-flap-t small { font: 600 12px/1 var(--f-display); letter-spacing: .3em; text-transform: uppercase; }
${P} .lbk-flap-t em { font: italic 600 46px/1 var(--f-aside); }
@media (min-width: 720px) { ${P} .lbk-flap-t small { font-size: 14px; } ${P} .lbk-flap-t em { font-size: 60px; } }
/* the gilt corners on the leather */
${P} .lbk-gilt { position: absolute; z-index: 4; width: 20px; height: 20px; background: ${GILT} center / 100% 100% no-repeat; pointer-events: none; filter: drop-shadow(0 1px 1px rgba(0, 0, 0, .45)); }
${P} .lbk-gilt.is-tl { top: 0; left: 0; }
${P} .lbk-gilt.is-tr { top: 0; right: 0; transform: scaleX(-1); }
${P} .lbk-gilt.is-bl { bottom: 0; left: 0; transform: scaleY(-1); }
${P} .lbk-gilt.is-br { bottom: 0; right: 0; transform: scale(-1, -1); }
@media (min-width: 720px) { ${P} .lbk-gilt { width: 34px; height: 34px; } }

/* the parchment page: the head on top, the reading under it */
${P} .lbk-page { position: relative; flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; overflow: hidden; border-radius: 2px 4px 4px 2px; background: ${PAPER_BG};
  box-shadow: 1px 1px 0 #d6c59f, 2px 2px 0 #c4b086, 3px 2px 0 #dccdaa, 4px 3px 0 #b39e72, inset 0 0 0 1px rgba(90, 60, 25, .18); }
${P} .lbk-head { position: relative; z-index: 3; flex: 0 0 auto; display: grid; grid-template-columns: 48px minmax(0, 1fr) 48px; align-items: center; gap: 4px; padding: 6px 4px 7px; border-bottom: 1px solid var(--line); }
${P} .lbk-head::after { content: ''; position: absolute; left: 50%; bottom: -1px; width: 64px; height: 1px; transform: translateX(-50%); background: linear-gradient(90deg, rgba(138, 106, 31, 0), var(--gold), rgba(138, 106, 31, 0)); }
${P} .lbk-brandwrap { min-width: 0; text-align: center; }
${P} .lbk-brand { margin: 0; font: 500 18.5px/1.15 var(--f-body); letter-spacing: -.008em; color: var(--ink); text-wrap: balance; }
${P} .lbk-brand em { font: italic 600 1.24em/.9 var(--f-aside); letter-spacing: -.005em; color: var(--gold); }
${P} .lbk-from { margin: 2px 0 0; font: italic 500 14.5px/1.25 var(--f-aside); color: var(--ink-3); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
@media (min-width: 720px) { ${P} .lbk-head { padding: 9px 8px 10px; } ${P} .lbk-brand { font-size: 21px; } ${P} .lbk-from { font-size: 15.5px; } }
${P} .lbk-ic { position: relative; display: grid; place-items: center; width: 44px; height: 44px; margin: 0; padding: 0; border: 0; border-radius: 50%; background: none; color: var(--ink-2); cursor: pointer; transition: background-color .18s ease, color .18s ease, opacity .18s ease; }
${P} .lbk-ic svg { width: 18px; height: 18px; }
${P} .lbk-ic:hover { background: rgba(122, 88, 40, .1); color: var(--ink); }
${P} .lbk-ic[hidden] { display: grid !important; visibility: hidden; opacity: 0; pointer-events: none; }
${P} .lbk-x { justify-self: end; }
${P} .lbk-back { justify-self: start; }
${P} .lbk-sr { position: absolute; display: block; width: 1px; height: 1px; margin: 0; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
${P} .lbk :focus { outline: none; }
${P} .lbk :focus-visible { outline: 2px solid var(--focus); outline-offset: 2px; }

/* the ribbon: it hangs from the head and fills as the reader goes; the end turns its tip gold */
${P} .lbk-rib { position: absolute; z-index: 2; right: 24px; top: 100%; display: block; width: 11px; height: var(--rl, 70px); pointer-events: none;
  -webkit-mask: linear-gradient(#000, #000) top / 100% calc(100% - 6px) no-repeat, linear-gradient(135deg, #000 50%, transparent 50%) left bottom / 50% 6px no-repeat, linear-gradient(225deg, #000 50%, transparent 50%) right bottom / 50% 6px no-repeat;
  mask: linear-gradient(#000, #000) top / 100% calc(100% - 6px) no-repeat, linear-gradient(135deg, #000 50%, transparent 50%) left bottom / 50% 6px no-repeat, linear-gradient(225deg, #000 50%, transparent 50%) right bottom / 50% 6px no-repeat;
  background: rgba(143, 31, 37, .2); filter: drop-shadow(0 2px 2px rgba(60, 20, 10, .35)); transition: height .3s ease; }
${P} .lbk-rib i { position: absolute; left: 0; top: 0; display: block; width: 100%; height: calc(var(--p, 0) * 100%); min-height: 8px;
  background: linear-gradient(90deg, #6f161b, var(--rib-hi) 45%, #7d1a20); transition: height .22s ease; }
${P} .lbk-rib.is-done i { height: 100%; background: linear-gradient(90deg, #6f161b, var(--rib-hi) 45%, #7d1a20) top / 100% calc(100% - 9px) no-repeat, linear-gradient(90deg, #a07a2a, #f1d58a 50%, #a07a2a) bottom / 100% 9px no-repeat; }
${P} .lbk.is-contents .lbk-rib { --p: 1; height: 26px; }
@media (max-width: 719px) { ${P} .lbk-rib { right: 5px; width: 10px; } }
@media (min-width: 720px) { ${P} .lbk-rib { right: 12px; width: 12px; --rl: 96px; } }

/* the reading area, and the page that turns over it */
${P} .lbk-scroll { position: relative; z-index: 1; flex: 1 1 auto; min-height: 0; overflow-x: hidden; overflow-y: auto; overscroll-behavior: contain; -webkit-overflow-scrolling: touch; scrollbar-width: thin; scrollbar-color: rgba(122, 88, 40, .4) transparent; }
${P} .lbk-view { display: block; max-width: 640px; margin: 0 auto; padding: 18px 20px 30px; }
/* the turn box is the reading area’s exact twin (the same container size), so a page on the leaf keeps its layout */
${P} .lbk-turnbox { position: absolute; z-index: 2; left: 0; right: 0; bottom: 0; overflow: hidden; perspective: 1800px; pointer-events: none; container: lbkpage / size; }
${P} .lbk-leaf { position: absolute; inset: 0; overflow: hidden; background: ${PAPER_BG}; transform-origin: 0 50%; backface-visibility: hidden; will-change: transform; box-shadow: 0 0 0 1px rgba(90, 60, 25, .1), 8px 0 18px rgba(50, 30, 10, .18); }
${P} .lbk-leaf-in { position: absolute; left: 0; right: 0; top: 0; height: 100%; }
${P} .lbk-leaf-sh { position: absolute; inset: 0; display: block; background: linear-gradient(90deg, rgba(60, 38, 14, 0) 25%, rgba(60, 38, 14, .4)); opacity: 0; }
${P} .lbk-turnsh { position: absolute; inset: 0; display: block; background: linear-gradient(90deg, rgba(50, 30, 10, .3), rgba(50, 30, 10, 0) 72%); }

/* ---------- the contents ---------- */
${P} .lbk-cgrid { display: grid; gap: 20px; }
${P} .lbk-entry { position: relative; display: grid; min-width: 0; }
${P} .lbk-entry.is-lead { gap: 12px; }
${P} .lbk-plate { position: relative; display: block; margin: 0; padding: 4px; aspect-ratio: 1424 / 848; border: 1px solid rgba(138, 106, 31, .62); background: rgba(255, 250, 236, .35); box-shadow: 0 1px 0 rgba(255, 252, 240, .6), 0 8px 18px -12px rgba(60, 38, 14, .7); }
${P} .lbk-plate > span, ${P} .lbk-plate > img { display: block; width: 100%; height: 100%; }
${P} .lbk-plate img { display: block; width: 100%; height: 100%; max-width: none; object-fit: cover; object-position: var(--focus-at, 50% 40%); box-shadow: 0 0 0 1px rgba(42, 32, 22, .38); background: #d9caa7; opacity: 0; transition: opacity .3s ease, transform .9s cubic-bezier(.2, .7, .2, 1); }
${P} .lbk-plate img.is-on { opacity: 1; }
${P} .lbk-plate.is-wait::before, ${P} .lbk-skel { content: ''; position: absolute; inset: 4px; display: block; background: linear-gradient(100deg, rgba(122, 88, 40, .1) 30%, rgba(122, 88, 40, .2) 50%, rgba(122, 88, 40, .1) 70%) 0 0 / 300% 100%; animation: lbk-shim 1.4s linear infinite; }
${P} .lbk-skel { position: relative; inset: auto; border-radius: 3px; }
@keyframes lbk-shim { to { background-position: -150% 0; } }
${P} .lbk-plate.is-blank::after { content: ''; position: absolute; inset: 4px; background: ${ORN} center / 96px 10px no-repeat, rgba(122, 88, 40, .08); }
${P} .lbk-ebody { display: grid; gap: 6px; min-width: 0; }
${P} .lbk-meta { display: flex; flex-wrap: wrap; align-items: center; gap: 4px 9px; margin: 0; font: 400 13px/1.4 var(--f-body); letter-spacing: .02em; color: var(--ink-3); font-variant-numeric: tabular-nums; }
${P} .lbk-meta > * + *::before { content: ''; display: inline-block; width: 3px; height: 3px; margin-right: 9px; vertical-align: middle; background: currentColor; transform: rotate(45deg); opacity: .8; }
${P} .lbk-readmark { color: var(--rib); font-style: italic; }
${P} .lbk-etitle { margin: 0; font: 500 21px/1.2 var(--f-body); letter-spacing: -.01em; color: var(--ink); text-wrap: balance; overflow-wrap: break-word; }
${P} .lbk-elink { color: inherit; text-decoration: none; transition: color .2s ease; }
${P} .lbk-elink::after { content: ''; position: absolute; inset: -6px; z-index: 2; border-radius: 6px; }
${P} .lbk-elink:focus-visible { outline: none; }
${P} .lbk-elink:focus-visible::after { outline: 2px solid var(--focus); outline-offset: 0; }
${P} .lbk-edek { margin: 0; font: italic 500 17.5px/1.38 var(--f-aside); color: var(--ink-2); text-wrap: pretty; }
${P} .lbk-rows { display: grid; margin: 0; padding: 0; list-style: none; border-top: 1px solid var(--line); }
${P} .lbk-rows > li { display: block; padding: 12px 0; border-bottom: 1px solid var(--line); }
${P} .lbk-entry.is-row { grid-template-columns: 92px minmax(0, 1fr); align-items: center; gap: 14px; }
${P} .lbk-entry.is-row .lbk-plate { padding: 3px; aspect-ratio: 4 / 3; }
${P} .lbk-entry.is-row .lbk-plate.is-wait::before, ${P} .lbk-entry.is-row .lbk-plate.is-blank::after { inset: 3px; }
${P} .lbk-entry.is-row .lbk-etitle { font-size: 16.5px; line-height: 1.28; }
${P} .lbk-entry.is-row .lbk-meta { font-size: 12.5px; }
@media (hover: hover) {
  ${P} .lbk-entry:hover .lbk-elink { color: var(--gold-ink); }
  ${P} .lbk-entry:hover .lbk-plate img { transform: scale(1.03); }
}
/* the contents fill the page they are on (a container query on the reading area): a page wide enough sets the lead
   beside the three; a page also tall enough sets the lead on top and the three as small cards under it. The page
   number keeps to the foot of the page, as in a printed book. */
${P} .lbk-scroll { container: lbkpage / size; }
${P} .lbk-contents { display: flex; flex-direction: column; min-height: 100%; }
${P} .lbk-cgrid { flex: 0 0 auto; margin-block: auto; }
@container lbkpage (min-width: 600px) {
  ${P} .lbk-contents { max-width: none; padding: 22px 30px 18px; }
  ${P} .lbk-cgrid { flex: 1 0 auto; margin-block: 0; grid-template-columns: minmax(0, 7fr) minmax(0, 5fr); gap: 0; align-items: stretch; }
  ${P} .lbk-cgrid > .lbk-entry.is-lead { display: flex; flex-direction: column; justify-content: center; padding-right: 24px; border-right: 1px solid var(--line); }
  /* the lead plate takes the height the page has left (never squarer than 1.42 to 1, so a cover’s own lettering stays
     whole), and the three rows share the column evenly */
  ${P} .lbk-entry.is-lead .lbk-plate { flex: 1 1 0; aspect-ratio: auto; height: auto; min-height: 180px; max-height: min(300px, calc(41cqw - 41px)); }
  ${P} .lbk-cgrid > .lbk-rows { grid-template-rows: repeat(3, minmax(0, 1fr)); margin-left: 22px; border-top: 0; }
  ${P} .lbk-cgrid > .lbk-rows > li { display: flex; align-items: center; }
  ${P} .lbk-cgrid > .lbk-rows > li > .lbk-entry { width: 100%; }
  ${P} .lbk-cgrid > .lbk-rows > li:first-child { padding-top: 0; }
  ${P} .lbk-cgrid > .lbk-rows > li:last-child { border-bottom: 0; padding-bottom: 0; }
  ${P} .lbk-entry.is-lead .lbk-etitle { font-size: 24px; line-height: 1.16; }
  ${P} .lbk-entry.is-row { grid-template-columns: 84px minmax(0, 1fr); gap: 12px; }
  ${P} .lbk-entry.is-row .lbk-etitle { font-size: 16px; }
  ${P} .lbk-stuck { margin-top: 60px; }
}
@container lbkpage (min-width: 600px) and (min-height: 700px) {
  ${P} .lbk-contents { padding-top: 26px; }
  ${P} .lbk-cgrid { grid-template-columns: minmax(0, 1fr); grid-template-rows: 1fr auto; }
  ${P} .lbk-cgrid > .lbk-entry.is-lead { padding: 0 0 22px; border-right: 0; }
  /* the lead plate takes what the page has left over, so the page number stays on the page */
  ${P} .lbk-entry.is-lead .lbk-plate { min-height: 214px; max-height: 420px; }
  ${P} .lbk-entry.is-lead .lbk-etitle { font-size: 27px; }
  ${P} .lbk-entry.is-lead .lbk-edek { display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow: hidden; font-size: 18.5px; max-width: 62ch; }
  ${P} .lbk-cgrid > .lbk-rows { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); grid-template-rows: none; gap: 20px; margin: 0; padding: 22px 0 0; border-top: 1px solid var(--line); }
  ${P} .lbk-cgrid > .lbk-rows > li { display: block; padding: 0; border: 0; }
  ${P} .lbk-entry.is-row { grid-template-columns: minmax(0, 1fr); align-content: start; gap: 10px; }
  ${P} .lbk-entry.is-row .lbk-plate { aspect-ratio: 16 / 10; }
  ${P} .lbk-entry.is-row .lbk-etitle { font-size: 16.5px; }
}
/* a short, wide page (a phone on its side): one spread with nothing below the fold. The lead's cover sits beside its
   words across the top (its width follows the page's height, at the cover's own shape, so the three below and the page
   number always fit), and the three sit in a row under it, each a small cover beside two lines of title */
@container lbkpage (min-width: 520px) and (max-height: 470px) {
  ${P} .lbk-contents { padding: 8px 24px 2px; }
  ${P} .lbk-cgrid { flex: 1 0 auto; margin-block: 0; grid-template-columns: minmax(0, 1fr); grid-template-rows: none; gap: 0; align-content: center; align-items: stretch; }
  ${P} .lbk-cgrid > .lbk-entry.is-lead { display: grid; flex-direction: row; grid-template-columns: min(31%, calc((100cqh - 156px) * 1.679)) minmax(0, 1fr); align-items: center; column-gap: 18px; padding: 0 0 10px; border-right: 0; }
  ${P} .lbk-entry.is-lead .lbk-plate { flex: none; aspect-ratio: 1424 / 848; height: auto; min-height: 0; max-height: none; }
  ${P} .lbk-entry.is-lead .lbk-ebody { gap: 4px; }
  ${P} .lbk-entry.is-lead .lbk-etitle { display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow: hidden; font-size: 20px; line-height: 1.18; }
  ${P} .lbk-entry.is-lead .lbk-edek { display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; font-size: 15.5px; line-height: 1.32; }
  ${P} .lbk-cgrid > .lbk-rows { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); grid-template-rows: none; gap: 16px; margin: 0; padding: 10px 0 0; border-top: 1px solid var(--line); }
  ${P} .lbk-cgrid > .lbk-rows > li { display: block; padding: 0; border: 0; }
  ${P} .lbk-entry.is-row { grid-template-columns: 62px minmax(0, 1fr); align-items: start; gap: 10px; }
  ${P} .lbk-entry.is-row .lbk-plate { padding: 2px; aspect-ratio: 4 / 3; }
  ${P} .lbk-entry.is-row .lbk-plate.is-wait::before, ${P} .lbk-entry.is-row .lbk-plate.is-blank::after { inset: 2px; }
  ${P} .lbk-entry.is-row .lbk-ebody { gap: 2px; }
  ${P} .lbk-entry.is-row .lbk-meta { font-size: 12px; line-height: 1.25; }
  ${P} .lbk-entry.is-row .lbk-etitle { display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; font-size: 14.5px; line-height: 1.24; }
  ${P} .lbk-cfoot { min-height: 44px; padding-top: 4px; }
  ${P} .lbk-whole { margin: 0; }
  ${P} .lbk-stuck { margin: 18px 0 4px; }
  /* an article opens on its cover whole, at the cover's own shape, sized so the title shows under it */
  ${P} .lbk-view.lbk-art .lbk-art-plate { width: min(100%, calc(62cqh * 1.679)); margin: 2px auto 0; }
}
/* a little taller (a large phone on its side): the three titles get a third line instead of an ellipsis */
@container lbkpage (min-width: 520px) and (min-height: 262px) and (max-height: 470px) {
  ${P} .lbk-entry.is-row .lbk-etitle { -webkit-line-clamp: 3; }
}
/* the foot of a contents page: turn back, the page number, turn the page; the whole Guide once, on the last page */
${P} .lbk-cfoot { display: grid; grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr); align-items: center; gap: 8px; min-height: 52px; margin: 0; padding: 18px 0 0; }
${P} .lbk-turn { display: inline-flex; align-items: center; gap: 6px; min-height: 44px; padding: 0 6px; border: 0; background: none; color: var(--gold-ink); font: 500 15.5px/1.2 var(--f-body); cursor: pointer; text-decoration: underline; text-decoration-color: rgba(117, 89, 26, .35); text-underline-offset: 5px; transition: color .18s ease, text-decoration-color .18s ease; }
${P} .lbk-turn svg { width: 15px; height: 15px; flex: 0 0 auto; }
${P} .lbk-turn:hover { color: var(--ink); text-decoration-color: var(--gold); }
${P} .lbk-turn.is-prev { justify-self: start; }
${P} .lbk-turn.is-next { justify-self: end; }
${P} .lbk-turn[hidden] { display: inline-flex !important; visibility: hidden; }
${P} .lbk-folio { font: italic 500 16px/1 var(--f-aside); color: var(--ink-3); letter-spacing: .06em; }
${P} .lbk-whole { display: flex; justify-content: center; margin: 2px 0 0; }
${P} .lbk-quiet { display: inline-flex; align-items: center; min-height: 44px; padding: 0 6px; border: 0; background: none; color: var(--ink-3); font: italic 500 16.5px/1.2 var(--f-aside); cursor: pointer; text-decoration: underline; text-decoration-color: rgba(42, 32, 22, .25); text-underline-offset: 5px; transition: color .18s ease; }
${P} .lbk-quiet:hover { color: var(--ink); }
${P} .lbk-stuck { grid-column: 1 / -1; margin: 30px 0 6px; text-align: center; font: italic 500 19px/1.4 var(--f-aside); color: var(--ink-2); }
${P} .lbk-stuck::before { content: ''; display: block; width: 120px; height: 12px; margin: 0 auto 18px; background: ${ORN} center / 100% 100% no-repeat; }

/* ---------- an article ---------- */
${P} .lbk-art .lbk-plate { margin: 2px 0 0; }
${P} .lbk-ahead { margin: 22px 0 0; text-align: center; }
${P} .lbk-title { margin: 0; font: 500 clamp(26px, 6.4vw, 34px)/1.12 var(--f-body); letter-spacing: -.014em; color: var(--ink); text-wrap: balance; }
${P} .lbk-title:focus { outline: none; }
${P} .lbk-nb { white-space: nowrap; }
${P} .lbk-acc { display: block; margin-top: .16em; font: italic 600 .84em/1.08 var(--f-aside); letter-spacing: -.004em; color: var(--gold); text-wrap: balance; }
${P} .lbk-ameta { margin: 12px 0 0; font: 400 14px/1.4 var(--f-body); color: var(--ink-3); font-variant-numeric: tabular-nums; }
${P} .lbk-dek { margin: 14px auto 0; max-width: 34ch; font: italic 500 clamp(19px, 2.6vw, 22px)/1.38 var(--f-aside); color: var(--ink-2); text-wrap: balance; }
${P} .lbk-orn { display: block; width: 120px; height: 12px; margin: 24px auto 28px; background: ${ORN} center / 100% 100% no-repeat; }
${P} .lbk-wait { margin: 6px 0 0; text-align: center; font: italic 500 18px/1.5 var(--f-aside); color: var(--ink-3); }
${P} .lbk-away { display: grid; justify-items: center; gap: 4px; margin: 4px 0 0; text-align: center; }
${P} .lbk-away p { margin: 0; font: italic 500 18.5px/1.45 var(--f-aside); color: var(--ink-2); }
${P} .lbk-end { margin: 40px 0 0; text-align: center; }
${P} .lbk-tail { display: block; width: 64px; height: 22px; margin: 0 auto 22px; background: ${TAIL} center / 100% 100% no-repeat; }
${P} .lbk-endbtns { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; max-width: 470px; margin: 0 auto; }
${P} .lbk-btn { display: inline-flex; align-items: center; justify-content: center; min-height: 48px; padding: 8px 14px; border-radius: 6px; border: 1px solid rgba(138, 106, 31, .55); background: rgba(255, 250, 236, .45); color: #4a3510; font: 500 15.5px/1.2 var(--f-body); text-align: center; cursor: pointer; transition: background-color .18s ease, border-color .18s ease, color .18s ease, transform .14s ease; }
${P} .lbk-btn:hover { background: rgba(255, 250, 236, .8); border-color: var(--gold); color: var(--ink); }
${P} .lbk-btn:active { transform: scale(.98); }
${P} .lbk-btn.is-main { border-color: #2a140b; background: linear-gradient(180deg, #5a2a19, #3d1c11); color: #f4e6c3; box-shadow: inset 0 0 0 1px rgba(212, 170, 90, .28), 0 4px 10px -6px rgba(40, 20, 8, .8); }
${P} .lbk-btn.is-main:hover { background: linear-gradient(180deg, #67321e, #451f13); color: #fff4d8; }
@media (max-width: 400px) { ${P} .lbk-endbtns { grid-template-columns: minmax(0, 1fr); } }

/* the question before a link leaves: one quiet line and two choices, on a slip at the foot of the page */
/* it is wider than the end's two buttons, and a haze of paper rises behind it, so nothing on the page peeks round it */
${P} .lbk-slip { position: absolute; z-index: 6; left: 12px; right: 12px; bottom: 12px; max-width: 520px; margin: 0 auto; padding: 14px 14px 12px; border: 1px solid rgba(138, 106, 31, .55); border-radius: 8px;
  background: linear-gradient(180deg, #f7eedb, #efe2c4); box-shadow: 0 -16px 30px 8px rgba(240, 230, 206, .94), 0 16px 34px -10px rgba(40, 25, 10, .55), 0 2px 0 rgba(255, 252, 240, .7) inset; transform: translateY(18px); opacity: 0; visibility: hidden;
  transition: opacity .22s ease, transform .26s cubic-bezier(.2, .8, .2, 1), visibility 0s linear .26s; }
${P} .lbk-slip.is-in { opacity: 1; visibility: visible; transform: none; transition: opacity .22s ease, transform .26s cubic-bezier(.2, .8, .2, 1), visibility 0s; }
${P} .lbk-slip p { margin: 0 0 10px; font: italic 500 18px/1.35 var(--f-aside); color: var(--ink); text-align: center; text-wrap: balance; }
${P} .lbk-slip-btns { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
${P} .lbk-slip .lbk-btn { min-height: 46px; }

/* ---------- the article’s own text, re-tuned for paper (assets/ff-blog.css, prose to tables) ---------- */
${P} .lbk-prose { font: 400 18px/1.66 var(--ffb-sans); color: var(--ffb-ink-2); overflow-wrap: break-word; }
@media (min-width: 720px) { ${P} .lbk-prose { font-size: 19px; } }
${P} .lbk-prose > :first-child { margin-top: 0 !important; }
${P} .lbk-prose :is(p, ul, ol, dl, table, figure, blockquote, details, pre) { margin: 0 0 1.15em; }
${P} .lbk-prose :is(h2, h3, h4) { text-wrap: balance; font-family: var(--ffb-sans); }
${P} .lbk-prose h2 { margin: 2.1em 0 .7em; font-size: clamp(25px, 2.6vw, 30px); line-height: 1.18; font-weight: 500; letter-spacing: -.014em; color: var(--ffb-ink); border: 0; padding: 0; }
${P} .lbk-prose h2::before { content: ''; display: block; width: 36px; height: 2px; margin-bottom: 15px; border-radius: 2px; background: linear-gradient(90deg, var(--ffb-gold-hi), var(--ffb-gold-lo)); }
${P} .lbk-prose h3 { margin: 1.7em 0 .55em; font-size: clamp(20px, 2vw, 23px); line-height: 1.26; font-weight: 500; color: var(--ffb-ink); border: 0; padding: 0; }
${P} .lbk-prose h4 { margin: 1.4em 0 .5em; font-size: 19px; line-height: 1.3; font-weight: 600; color: var(--ffb-ink); }
${P} .lbk-prose :is(strong, b) { font-weight: 600; color: var(--ffb-ink); }
${P} .lbk-prose :is(h1, h2, h3, h4, th, a, summary) :is(strong, b) { color: inherit; font-weight: inherit; }
${P} .lbk-prose a { color: var(--ffb-gold-text); text-decoration: underline; text-decoration-color: rgba(117, 89, 26, .4); text-underline-offset: 4px; text-decoration-thickness: 1px; transition: text-decoration-color .2s ease, color .2s ease; }
${P} .lbk-prose a:hover { color: var(--ffb-ink); text-decoration-color: var(--ffb-gold-lo); }
${P} .lbk-prose :is(ul, ol) { padding-left: 1.4em; }
${P} .lbk-prose li { margin: 0 0 .5em; padding-left: .2em; }
${P} .lbk-prose ul > li::marker { content: "\\25C6  "; font-size: .62em; color: var(--ffb-gold-lo); }
${P} .lbk-prose ol > li::marker { font-weight: 600; color: var(--ffb-gold-text); font-variant-numeric: tabular-nums; }
${P} .lbk-prose hr { height: 0; margin: 2.4em auto; border: 0; border-top: 1px solid var(--ffb-line-2); width: 40%; }
${P} .lbk-prose img { display: block; width: auto; max-width: 100%; height: auto; max-height: 82cqh; margin: 0 auto; border-radius: 2px; box-shadow: 0 0 0 1px rgba(42, 32, 22, .3), 0 0 0 5px rgba(255, 250, 236, .5), 0 0 0 6px rgba(138, 106, 31, .45), 0 10px 22px -14px rgba(60, 38, 14, .8); }
${P} .lbk-prose p > img:only-child { margin: 1.6em auto; }
${P} .lbk-prose :is(.container, .content, .intro, .conclusion, article, section) { width: auto; max-width: none; margin-left: 0; margin-right: 0; padding-left: 0; padding-right: 0; background: none; border: 0; }
${P} .lbk-prose p:empty, ${P} .lbk-prose div:empty { display: none; }
${P} .lbk-prose figure { margin: 2em 0; }
${P} .lbk-prose figcaption { margin-top: 14px; font: italic 500 16px/1.45 var(--ffb-serif); color: var(--ffb-ink-3); text-align: center; }
${P} .lbk-prose .ffb-table { margin: 1.8em 0; overflow-x: auto; border-radius: var(--ffb-radius); box-shadow: inset 0 0 0 1px var(--ffb-line-2); -webkit-overflow-scrolling: touch; }
${P} .lbk-prose table { width: 100% !important; min-width: 520px; margin: 0 !important; border-collapse: collapse; border: 0 !important; font-size: 16px; line-height: 1.5; background: none; }
${P} .lbk-prose :is(th, td) { padding: 12px 15px !important; text-align: left; vertical-align: top; border: 0 !important; border-bottom: 1px solid var(--ffb-line) !important; }
${P} .lbk-prose th, ${P} .lbk-prose thead td { font-size: 14px; font-weight: 600; letter-spacing: .02em; color: var(--ffb-ink); background: rgba(138, 106, 31, .1) !important; }
${P} .lbk-prose tbody tr:nth-child(even) { background: rgba(122, 88, 40, .045); }
${P} .lbk-prose tr:last-child > * { border-bottom: 0 !important; }
${P} .lbk-prose table.ffb-fit { min-width: 0; }
${P} .lbk-prose :is(blockquote, .ffb-pull) { position: relative; margin: 2.1em 0; padding: 1.1em 0; border: 0; text-align: center; font-family: var(--ffb-serif); font-style: italic; font-weight: 500; font-size: 1.3em; line-height: 1.4; color: var(--ffb-gold-text); text-wrap: balance; }
${P} .lbk-prose :is(blockquote, .ffb-pull)::before, ${P} .lbk-prose :is(blockquote, .ffb-pull)::after { content: ''; display: block; width: 56px; height: 1px; margin: 0 auto; background: linear-gradient(90deg, rgba(138, 106, 31, 0), var(--ffb-gold-lo), rgba(138, 106, 31, 0)); }
${P} .lbk-prose :is(blockquote, .ffb-pull)::before { margin-bottom: .85em; }
${P} .lbk-prose :is(blockquote, .ffb-pull)::after { margin-top: .85em; }
${P} .lbk-prose blockquote p { margin: 0 0 .4em; }
/* boxes the older articles define: one panel design for all of them, a shade darker than the page with an inked line */
${P} .lbk-prose :is(.quick-answer, .highlight-box, .highlight, .tip-box, .warning-box, .timeline-box, .checklist-box, .price-breakdown, .stage-breakdown, .author-note, .quote-box, .transformation-box, .comparison-card, .gift-card, .best-for, .step, .key-takeaways, .tldr, .summary-box, .info-box, .note, .callout, .character-details, .variation-details, .review, .testimonial, .faq-item, .pros, .cons, .cta-box, .cta-section, .cta, .sign-card, .process-step, .reason-card, .reaction-card, .step-card, .step-box, .comparison-box, .mistake-box, .solution-box, .info-card, .psychology-card, .phase, .cost-highlight) {
  margin: 1.8em 0; padding: 20px 22px; border: 0 !important; border-radius: var(--ffb-radius); background: var(--ffb-surface) !important; box-shadow: inset 0 0 0 1px var(--ffb-line-2), inset 0 1px 0 rgba(255, 252, 240, .55); color: var(--ffb-ink-2); }
${P} .lbk-prose :is(.quick-answer, .key-takeaways, .tldr, .summary-box) { background: linear-gradient(180deg, rgba(180, 141, 54, .16), rgba(180, 141, 54, .07)) !important; box-shadow: inset 0 0 0 1px rgba(138, 106, 31, .42), inset 0 2px 0 rgba(138, 106, 31, .5); }
${P} .lbk-prose :is(.warning-box, .mistake-box) { background: linear-gradient(180deg, rgba(160, 60, 30, .1), rgba(160, 60, 30, .045)) !important; box-shadow: inset 0 0 0 1px rgba(150, 60, 30, .32); }
${P} .lbk-prose :is(.quick-answer, .highlight-box, .tip-box, .warning-box, .timeline-box, .checklist-box, .price-breakdown, .comparison-card, .gift-card, .cta-box, .cta-section, .faq-item, .pros, .cons, .sign-card, .process-step, .reason-card, .step-card, .step-box, .mistake-box, .solution-box, .info-card) > :is(h2, h3, h4):first-child { margin-top: 0; font-size: 20px; }
${P} .lbk-prose :is(.quick-answer, .highlight-box, .tip-box, .warning-box, .timeline-box, .checklist-box, .price-breakdown, .comparison-card, .gift-card, .cta-box, .cta-section, .faq-item, .pros, .cons, .review, .testimonial, .sign-card, .process-step, .reason-card, .step-card, .step-box, .mistake-box, .solution-box, .info-card) > :is(h2, h3, h4):first-child::before { display: none; }
${P} .lbk-prose :is(.quick-answer, .highlight-box, .tip-box, .warning-box, .timeline-box, .checklist-box, .price-breakdown, .comparison-card, .gift-card, .cta-box, .cta-section, .faq-item, .pros, .cons, .review, .testimonial, .sign-card, .process-step, .reason-card, .step-card, .step-box, .mistake-box, .solution-box, .info-card) > :last-child { margin-bottom: 0; }
${P} .lbk-prose :is(.comparison-grid, .pros-cons, .gift-grid, .pro-con-grid, .breakdown-grid) { display: grid; gap: 14px; margin: 1.8em 0; }
${P} .lbk-prose :is(.comparison-grid, .pros-cons, .gift-grid, .pro-con-grid, .breakdown-grid) > * { margin: 0 !important; }
@media (min-width: 720px) { ${P} .lbk-prose :is(.comparison-grid, .pros-cons, .pro-con-grid, .breakdown-grid) { grid-template-columns: 1fr 1fr; } }
/* the small marks the older articles print inline: numbers in gold rounds, scores and prices as stamped tags */
${P} .lbk-prose :is(.step-number, .number-circle, .number-badge, .mistake-number, .gift-rank) { display: inline-grid; place-items: center; min-width: 30px; height: 30px; margin-right: 10px; padding: 0 6px; border-radius: 999px; font: 600 15px/1 var(--ffb-sans); color: var(--ffb-gold-ink); background: linear-gradient(180deg, var(--ffb-gold-hi), var(--ffb-gold-lo)); vertical-align: .15em; }
${P} .lbk-prose :is(.score-badge, .price-tag, .winner-badge, .price-range, .gift-price) { display: inline-block; margin: 0 6px 8px 0; padding: 3px 10px 4px; border-radius: 4px; font: 500 14px/1.3 var(--ffb-sans); color: var(--ffb-ink); background: rgba(255, 250, 236, .55); box-shadow: inset 0 0 0 1px var(--ffb-line-2); }
${P} .lbk-prose :is(.price-tag, .gift-price, .winner-badge) { color: var(--ffb-gold-text); box-shadow: inset 0 0 0 1px rgba(138, 106, 31, .5); }
${P} .lbk-prose .score-high { box-shadow: inset 0 0 0 1px rgba(70, 110, 50, .45); }
${P} .lbk-prose .score-low { box-shadow: inset 0 0 0 1px rgba(150, 60, 30, .38); }
${P} .lbk-prose :is(.cta-button, .button, a.btn) { display: inline-flex; align-items: center; justify-content: center; min-height: 48px; padding: 0 22px; margin: .4em 0; border-radius: 6px; border: 1px solid rgba(138, 106, 31, .6); background: rgba(255, 250, 236, .5) !important; color: var(--ffb-gold-text) !important; font: 500 15px/1.2 var(--ffb-sans); letter-spacing: .02em; text-decoration: none; }
${P} .lbk-prose :is(.cta-button, .button, a.btn):hover { background: rgba(255, 250, 236, .85) !important; color: var(--ffb-ink) !important; }
${P} .lbk-prose :is(.cta-box, .cta-section, .cta) { text-align: center; }
${P} .lbk-prose .faq-question, ${P} .lbk-prose .faq dt { font-weight: 600; color: var(--ffb-ink); }
${P} .lbk-prose .meta { font-size: 14px; color: var(--ffb-ink-3); }
${P} .lbk-prose details { border-radius: var(--ffb-radius); background: var(--ffb-surface); box-shadow: inset 0 0 0 1px var(--ffb-line-2); padding: 0 18px; }
${P} .lbk-prose details > summary { min-height: 52px; display: flex; align-items: center; justify-content: space-between; gap: 14px; list-style: none; cursor: pointer; font-weight: 500; color: var(--ffb-ink); }
${P} .lbk-prose details > summary::-webkit-details-marker { display: none; }
${P} .lbk-prose details > summary::after { content: ''; flex: 0 0 auto; width: 8px; height: 8px; margin-right: 4px; border-right: 1.5px solid var(--ffb-gold-lo); border-bottom: 1.5px solid var(--ffb-gold-lo); transform: translateY(-2px) rotate(45deg); transition: transform .24s ease; }
${P} .lbk-prose details[open] > summary::after { transform: translateY(2px) rotate(225deg); }
${P} .lbk-prose details[open] { padding-bottom: 14px; }
/* pieces for new article bodies (2026-09-30): art side by side, a stage rail, an index card, pairs, a screenshot strip */
${P} .lbk-prose :is(.ffb-duo, .ffb-trio, .ffb-shots) { display: grid; gap: 14px; margin: 2.2em 0; }
${P} .lbk-prose .ffb-duo { grid-template-columns: repeat(2, minmax(0, 1fr)); }
${P} .lbk-prose .ffb-trio { grid-template-columns: repeat(3, minmax(0, 1fr)); }
${P} .lbk-prose .ffb-shots { grid-template-columns: repeat(2, minmax(0, 1fr)); }
${P} .lbk-prose :is(.ffb-duo, .ffb-trio, .ffb-shots) figure { margin: 0; min-width: 0; }
${P} .lbk-prose :is(.ffb-duo, .ffb-trio) img { width: 100%; aspect-ratio: 1; object-fit: cover; object-position: var(--pos, 50% 30%); }
${P} .lbk-prose .ffb-shots img { width: 100%; aspect-ratio: 16 / 9; object-fit: cover; object-position: 50% 0; }
${P} .lbk-prose :is(.ffb-duo, .ffb-trio, .ffb-shots) figcaption { margin-top: 12px; font-size: 15px; line-height: 1.4; }
${P} .lbk-prose :is(.ffb-duo, .ffb-trio, .ffb-shots) figcaption strong { display: block; font: 600 15px/1.3 var(--ffb-sans); font-style: normal; color: var(--ffb-ink); }
@media (max-width: 719px) {
  ${P} .lbk-prose :is(.ffb-trio, .ffb-shots) { grid-template-columns: none; grid-auto-flow: column; grid-auto-columns: 76%; overflow-x: auto; overscroll-behavior-x: contain; scroll-snap-type: x mandatory; scrollbar-width: none; margin-inline: -20px; padding: 8px 20px; scroll-padding-inline: 20px; }
  ${P} .lbk-prose .ffb-shots { grid-auto-columns: 86%; }
  ${P} .lbk-prose :is(.ffb-trio, .ffb-shots)::-webkit-scrollbar { display: none; }
  ${P} .lbk-prose :is(.ffb-trio, .ffb-shots) > * { scroll-snap-align: start; }
}
${P} .lbk-prose ol.ffb-steps { counter-reset: ffbstep; margin: 2em 0; padding: 0; list-style: none; }
${P} .lbk-prose ol.ffb-steps > li { counter-increment: ffbstep; position: relative; margin: 0; padding: 0 0 24px 52px; font-size: 17px; line-height: 1.55; }
${P} .lbk-prose ol.ffb-steps > li::marker { content: none; }
${P} .lbk-prose ol.ffb-steps > li::before { content: counter(ffbstep); position: absolute; left: 0; top: 0; z-index: 1; display: grid; place-items: center; width: 34px; height: 34px; border-radius: 50%; font: 600 15px/1 var(--ffb-sans); color: var(--ffb-gold-ink); background: linear-gradient(180deg, var(--ffb-gold-hi), var(--ffb-gold-lo)); box-shadow: 0 0 0 4px var(--ffb-bg), 0 2px 6px rgba(90, 60, 20, .3); }
${P} .lbk-prose ol.ffb-steps > li::after { content: ''; position: absolute; left: 16px; top: 38px; bottom: 4px; width: 2px; border-radius: 2px; background: linear-gradient(180deg, rgba(138, 106, 31, .55), rgba(138, 106, 31, .12)); }
${P} .lbk-prose ol.ffb-steps > li:last-child { padding-bottom: 0; }
${P} .lbk-prose ol.ffb-steps > li:last-child::after { display: none; }
${P} .lbk-prose ol.ffb-steps > li > strong:first-child { display: block; padding-top: 4px; margin-bottom: 2px; font-size: 18px; }
${P} .lbk-prose .ffb-note { margin: 2.2em 0; padding: 22px 22px 8px; border-radius: 6px; background: linear-gradient(180deg, rgba(255, 250, 236, .6), rgba(255, 250, 236, .3)); box-shadow: inset 0 0 0 1px var(--ffb-line-2), inset 0 3px 0 rgba(138, 106, 31, .55), 0 10px 20px -16px rgba(60, 38, 14, .7); }
${P} .lbk-prose .ffb-note__title { margin: 0 0 10px; font-family: var(--ffb-serif); font-style: italic; font-weight: 600; font-size: 27px; line-height: 1.15; color: var(--ffb-gold-text); }
${P} .lbk-prose .ffb-note dl { margin: 0; }
${P} .lbk-prose .ffb-note dl > div { display: grid; gap: 2px; padding: 11px 0; border-top: 1px solid var(--ffb-line); }
${P} .lbk-prose .ffb-note dt { font-size: 12.5px; font-weight: 600; letter-spacing: .08em; text-transform: uppercase; color: var(--ffb-gold-text); }
${P} .lbk-prose .ffb-note dd { margin: 0; font-size: 17px; line-height: 1.5; color: var(--ffb-ink); }
${P} .lbk-prose .ffb-note > p:not([class]) { margin: 0 0 14px; font-size: 18px; line-height: 1.55; color: var(--ffb-ink); }
@media (min-width: 720px) { ${P} .lbk-prose .ffb-note dl > div { grid-template-columns: 140px minmax(0, 1fr); gap: 16px; align-items: baseline; } }
${P} .lbk-prose .ffb-compare { display: grid; gap: 12px; margin: 2em 0; }
${P} .lbk-prose .ffb-compare > div { margin: 0; padding: 16px 18px; border-radius: 6px; background: var(--ffb-surface); box-shadow: inset 0 0 0 1px var(--ffb-line-2); }
${P} .lbk-prose .ffb-compare > div:nth-child(even) { background: linear-gradient(180deg, rgba(180, 141, 54, .15), rgba(180, 141, 54, .06)); box-shadow: inset 0 0 0 1px rgba(138, 106, 31, .45); }
${P} .lbk-prose .ffb-compare__label { margin: 0 0 6px !important; font-size: 12.5px; font-weight: 600; letter-spacing: .08em; text-transform: uppercase; color: var(--ffb-ink-3); }
${P} .lbk-prose .ffb-compare > div:nth-child(even) .ffb-compare__label { color: var(--ffb-gold-text); }
${P} .lbk-prose .ffb-compare > div > p:last-child { margin: 0; font-size: 17px; line-height: 1.5; color: var(--ffb-ink); }
@media (min-width: 720px) { ${P} .lbk-prose .ffb-compare { grid-template-columns: repeat(2, minmax(0, 1fr)); } }

/* the walk out with the frame (FFD.leaveTo fades the frame; the book goes with it) */
${P} .ffs.is-leaving .lbk { opacity: 0; transition: opacity .28s ease; }
@media (prefers-reduced-motion: reduce) {
  ${P} .lbk-dim, ${P} .lbk-book, ${P} .lbk-slip, ${P} .lbk-rib, ${P} .lbk-rib i, ${P} .lbk-plate img { transition: none; }
  ${P} .lbk-book, ${P} .lbk.is-in .lbk-book, ${P} .lbk.is-out .lbk-book { transform: none; }
  ${P} .lbk-slip, ${P} .lbk-slip.is-in { transform: none; }
  ${P} .lbk-plate.is-wait::before, ${P} .lbk-skel { animation: none; }
  ${P} .lbk-entry:hover .lbk-plate img, ${P} .lbk-btn:active { transform: none; }
}
`;

  /* the Guide’s title split: the part after a colon, a question mark, or into a closing parenthesis is the gold line */
  function splitTitle(t) {
    t = String(t || '');
    let m = t.match(/^(.+?):\s+(.+)$/);
    if (m) return [m[1], m[2]];
    m = t.match(/^(.+?\?)\s+(.+)$/);
    if (m) return [m[1], m[2]];
    m = t.match(/^(.+?)\s+(\([^)]+\))$/);
    if (m) return [m[1], m[2]];
    return [t, ''];
  }
  const roman = (n) => { let s = ''; [[10, 'x'], [9, 'ix'], [5, 'v'], [4, 'iv'], [1, 'i']].forEach(([v, r]) => { while (n >= v) { s += r; n -= v; } }); return s; };
  /* a title never breaks inside a hyphenated word ("Thigh-Up" stays whole) */
  const whole = (h, s) => String(s || '').split(/(\S*\w-\w\S*)/).filter(Boolean).map((p) => (/\w-\w/.test(p) ? h('span', { class: 'lbk-nb', text: p }) : p));
  const plainClick = (e) => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
  let uid = 0;

  /* the bottom of any bar fixed or stuck at the window’s top (the demo’s review bar, the store’s header), found by what
     sits at the top edge; nothing inside skip counts (the room’s own topInset, the same idea) */
  function topInset(skip) {
    const vw = window.innerWidth || 0, vh = window.innerHeight || 0, seen = new Set();
    let inset = 0;
    [0.2, 0.5, 0.8].forEach((fx) => {
      let at = [];
      try { at = document.elementsFromPoint(Math.round(vw * fx), 2); } catch (e) { at = []; }
      for (const el of at) {
        if (skip && skip.contains(el)) continue;
        for (let n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
          if (seen.has(n)) break;
          seen.add(n);
          const pos = getComputedStyle(n).position;
          if (pos !== 'fixed' && pos !== 'sticky') continue;
          const r = n.getBoundingClientRect();
          if (r.top <= 2 && r.bottom > inset && r.bottom < vh * 0.5) inset = r.bottom;
          break;
        }
      }
    });
    return Math.ceil(inset);
  }
  const goTo = (y) => { y = Math.max(0, Math.round(y)); try { window.scrollTo({ top: y, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); } };

  (FFD.parts = FFD.parts || {})['library/book'] = function makeBook(api) {
    const h = api.h || FFD.h;
    const RM = () => { try { return !!api.RM(); } catch (e) { return false; } };
    const WIDE = () => { try { return !!api.WIDE(); } catch (e) { return false; } };
    const alive = () => { try { return api.alive() !== false; } catch (e) { return false; } };
    const snd = (n) => { try { if (api.snd) api.snd(n); } catch (e) { /* a sound never breaks the book */ } };
    const call = (fn, ...a) => { try { return typeof fn === 'function' ? fn(...a) : undefined; } catch (e) { return undefined; } };
    let S = null;

    function open(o) {
      o = o || {};
      if (S) S.end('library', true);
      const F = api.F;
      if (!F || !F.el || !alive()) return Promise.resolve('library');
      if (!document.getElementById(CSS_ID)) document.head.append(h('style', { id: CSS_ID, text: CSS }));
      return new Promise((res) => { S = session(o, res); });
    }
    function close() { if (S) S.end('library', true); }
    function isOpen() { return !!S; }

    /* ---------- one opening of the book ---------- */
    function session(o, res) {
      const F = api.F, frame = F.el;
      const opener = document.activeElement;
      const undo = [];
      const on = (t, ev, fn, opt) => { t.addEventListener(ev, fn, opt); undo.push(() => t.removeEventListener(ev, fn, opt)); };
      const timers = new Set();
      const later = (fn, ms) => { const t = setTimeout(() => { timers.delete(t); if (!done) fn(); }, ms); timers.add(t); return t; };
      let done = false;
      const t0 = Date.now();
      const s = { end };

      /* where the reader came from, under the head */
      let from = o.from ? String(o.from) : '';
      if (!from && o.bay) from = call(api.shelfName, o.bay) || '';
      if (!from && o.book && o.book.k) from = call(api.shelfName, o.book.k) || '';

      const hid = 'lbk-h' + (++uid);
      const xBtn = h('button', { type: 'button', class: 'lbk-ic lbk-x', 'aria-label': 'Return to the library', title: 'Return to the library', html: X_SVG });
      const backBtn = h('button', { type: 'button', class: 'lbk-ic lbk-back', 'aria-label': 'Back to the contents', title: 'Back to the contents', hidden: true, html: PREV_SVG });
      const rib = h('i', { class: 'lbk-rib', 'aria-hidden': 'true' }, h('i'));
      const fromEl = from ? h('p', { class: 'lbk-from', text: from }) : null;
      const head = h('header', { class: 'lbk-head' }, backBtn,
        h('div', { class: 'lbk-brandwrap' }, h('p', { class: 'lbk-brand', id: hid }, 'The Commissioner’s ', h('em', { text: 'Guide' })), fromEl),
        xBtn, rib);
      const scroll = h('div', { class: 'lbk-scroll' });
      const slip = h('div', { class: 'lbk-slip', role: 'group', 'aria-label': 'Leaving the library' });
      const page = h('div', { class: 'lbk-page' }, head, scroll, slip);
      const book = h('div', { class: 'lbk-book' }, page, ['tl', 'tr', 'bl', 'br'].map((k) => h('i', { class: 'lbk-gilt is-' + k, 'aria-hidden': 'true' })));
      const dim = h('div', { class: 'lbk-dim' });
      const live = h('p', { class: 'lbk-sr', 'aria-live': 'polite' });
      const root = h('div', { class: 'lbk', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': hid }, dim, book, live);
      frame.append(root);
      bringIntoView();
      requestAnimationFrame(() => requestAnimationFrame(() => { if (!done) root.classList.add('is-in'); }));
      /* On a phone the book covers the whole frame, so the pixel scene under it stops drawing: the scene runtime runs its
         loop only while its box is in view, so once the book is fully in, the art steps outside the frame's clip, and it
         is back in place before the book starts to go (its last picture shows until the loop wakes, a frame later). A
         wide screen keeps the room alive around the book; reduced motion draws one still picture and has no loop. */
      const art = F.art;
      let parked = false;
      const park = (on) => {
        if (!art) return;
        if (on && !parked && !done && !WIDE() && !RM()) { parked = true; art.style.transform = 'translateX(-300%)'; }
        else if (!on && parked) { parked = false; art.style.transform = ''; }
      };
      later(() => park(true), RM() ? 0 : 360);
      on(window, 'resize', () => { if (done) return; if (WIDE()) park(false); else if (root.classList.contains('is-in')) park(true); });
      snd('rustle');
      /* the leather cover swings open as the book arrives (under reduced motion the book is simply there, open) */
      if (!RM()) {
        const flap = h('div', { class: 'lbk-flap', 'aria-hidden': 'true' },
          h('span', { class: 'lbk-flap-t' }, h('small', { text: 'The Commissioner’s' }), h('em', { text: 'Guide' })));
        book.append(flap);
        try {
          const a = flap.animate([{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(-100deg)' }], { duration: 320, delay: 110, easing: 'cubic-bezier(.55, .05, .65, .95)', fill: 'forwards' });
          a.finished.then(() => flap.remove(), () => flap.remove());
        } catch (e) { flap.remove(); }
      }

      /* ---------- the views and the way back through them ---------- */
      let view = null;
      const hist = [];
      function syncBack() {
        const prev = hist[hist.length - 1];
        backBtn.hidden = !prev;
        const t = prev && prev.kind === 'article' ? 'Back to ' + (prev.b && prev.b.t ? prev.b.t : 'the last page') : 'Back to the contents';
        backBtn.setAttribute('aria-label', t); backBtn.title = t;
      }
      backBtn.addEventListener('click', () => { if (Date.now() - t0 < 350 || !hist.length) return; snd('tap'); goBack(); });
      function goBack() {
        const prev = hist.pop();
        if (!prev) return;
        syncBack();
        swap(prev, -1);
      }

      /* a turn of the page: forward, the page lifts away to the left and shows the next; back, the page before swings in
         over this one. Reduced motion: a short fade, no movement. */
      let turn = null;
      function swap(next, dir) {
        if (turn) turn();
        const old = view;
        if (old) old.y = scroll.scrollTop;
        view = next;
        /* the line under the head follows the page: a book reached by a link says which shelf it came from */
        const line = next.from || from;
        if (fromEl && line && fromEl.textContent !== line) {
          fromEl.textContent = line;
          if (!RM()) fromEl.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 240, easing: 'ease-out' });
        }
        root.classList.toggle('is-contents', next.kind === 'contents');
        root.classList.toggle('is-reading', next.kind === 'article');
        rib.classList.toggle('is-done', next.kind === 'article' && !!next.done);
        rib.style.setProperty('--p', next.kind === 'article' ? String(next.p || 0) : '1');
        const land = () => { if (next.onShow) next.onShow(); focusIn(next); };
        if (!old || !dir || RM()) {
          if (old) old.el.remove();
          scroll.append(next.el);
          scroll.scrollTop = next.y || 0;
          if (old && RM()) next.el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 160, easing: 'ease-out' });
          land();
          return;
        }
        snd('rustle');
        const top = scroll.offsetTop, gutter = Math.max(0, scroll.offsetWidth - scroll.clientWidth);
        const inner = h('div', { class: 'lbk-leaf-in' });
        const shade = h('i', { class: 'lbk-leaf-sh' });
        const leaf = h('div', { class: 'lbk-leaf' }, inner, shade);
        const under = h('i', { class: 'lbk-turnsh' });
        /* the turn happens in the reading area only: the head stays printed where it is */
        const box = h('div', { class: 'lbk-turnbox', 'aria-hidden': 'true', style: 'top:' + top + 'px;right:' + gutter + 'px' }, under, leaf);
        let anims = [];
        const finish = () => {
          if (!turn) return;
          turn = null;
          anims.forEach((a) => { try { a.cancel(); } catch (e) { /* fine */ } });
          if (dir < 0 && next.el.parentNode !== scroll) { old.el.remove(); scroll.append(next.el); scroll.scrollTop = next.y || 0; }
          box.remove();
          land();
        };
        turn = finish;
        if (dir > 0) {
          /* the old page moves onto the leaf exactly where it was read, and the new one waits under it */
          inner.style.transform = 'translateY(' + (-(old.y || 0)) + 'px)';
          inner.append(old.el);
          scroll.append(next.el);
          scroll.scrollTop = next.y || 0;
          page.append(box);
          anims = [
            leaf.animate([{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(-94deg)' }], { duration: 320, easing: 'cubic-bezier(.42, .02, .74, .86)', fill: 'forwards' }),
            shade.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, easing: 'ease-in', fill: 'forwards' }),
            under.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 320, easing: 'ease-in', fill: 'forwards' })
          ];
        } else {
          inner.style.transform = 'translateY(' + (-(next.y || 0)) + 'px)';
          inner.append(next.el);
          page.append(box);
          anims = [
            leaf.animate([{ transform: 'rotateY(-94deg)' }, { transform: 'rotateY(0deg)' }], { duration: 320, easing: 'cubic-bezier(.22, .6, .32, 1)', fill: 'forwards' }),
            shade.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 320, easing: 'ease-out', fill: 'forwards' }),
            under.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, easing: 'ease-out', fill: 'forwards' })
          ];
        }
        anims[0].finished.then(finish, finish);
      }
      const shown = (x) => !!(x && x.isConnected && !x.hidden && x.getClientRects().length && getComputedStyle(x).visibility !== 'hidden');
      const focusOn = (x) => { if (x && typeof x.focus === 'function') { try { x.focus({ preventScroll: true }); } catch (e) { /* fine */ } } };
      /* where the focus lands on a new page: the entry the reader left from, an article’s title, the first entry of a
         contents page (or, by the keys, the same turn control), and the close control while nothing else is there yet */
      function focusIn(v) {
        if (done || !v) return;
        if (v.kind === 'contents' && v.keys) {
          const dir = v.keys; v.keys = 0;
          v.ready.then(() => {
            if (done || view !== v) return;
            const pref = dir > 0 ? v.nextBtn : v.prevBtn, other = dir > 0 ? v.prevBtn : v.nextBtn;
            focusOn(shown(pref) ? pref : shown(other) ? other : v.el.querySelector('.lbk-elink') || xBtn);
          });
          return;
        }
        let t = v.focus && shown(v.focus) ? v.focus : null;
        v.focus = null;
        if (!t) t = v.el.querySelector('[data-focus]');
        if (!t && v.kind === 'contents') t = v.el.querySelector('.lbk-elink');
        focusOn(t || xBtn);
      }

      /* ---------- the contents ---------- */
      const bay = o.bay || null;
      let firstP = null, allP = null;
      function loadContents() {
        if (firstP) return;
        firstP = Promise.resolve().then(() => api.stories(bay)).then((l) => (Array.isArray(l) ? l.filter(Boolean) : null), () => null);
        allP = Promise.resolve().then(() => api.shelf(bay)).then((l) => (Array.isArray(l) ? l.filter(Boolean) : null), () => null);
      }
      const restOf = (first, all) => { const seen = new Set((first || []).map((b) => b.h)); return (all || []).filter((b) => !seen.has(b.h)); };
      function contents(i) {
        loadContents();
        const v = { kind: 'contents', i, y: 0 };
        const grid = h('div', { class: 'lbk-cgrid' });
        const prev = h('button', { type: 'button', class: 'lbk-turn is-prev', hidden: i === 0 }, h('span', { html: PREV_SVG }), 'Turn back');
        const next = h('button', { type: 'button', class: 'lbk-turn is-next', hidden: true }, 'Turn the page', h('span', { html: NEXT_SVG }));
        const folio = h('span', { class: 'lbk-folio', 'aria-hidden': 'true', text: '· ' + roman(i + 1) + ' ·' });
        const foot = h('nav', { class: 'lbk-cfoot', 'aria-label': 'Turn the pages' }, prev, folio, next);
        const whole = h('p', { class: 'lbk-whole', hidden: true }, (() => {
          const b = h('button', { type: 'button', class: 'lbk-quiet', text: 'The whole Guide on FramedFantasy' });
          b.addEventListener('click', () => goNow(api.guideHref));
          return b;
        })());
        v.el = h('section', { class: 'lbk-view lbk-contents', 'aria-label': 'Contents, page ' + (i + 1) }, grid, foot, whole);
        prev.addEventListener('click', () => { snd('tap'); turnTo(i - 1, -1); });
        next.addEventListener('click', () => { snd('tap'); turnTo(i + 1, 1); });
        v.prevBtn = prev; v.nextBtn = next;
        skeleton(grid);
        const list = i === 0 ? firstP : Promise.all([firstP, allP]).then(([f, a]) => restOf(f, a).slice((i - 1) * 4, i * 4));
        const filled = list.then((l) => { if (!done) fill(grid, l, v); });
        const counted = Promise.all([firstP, allP]).then(([f, a]) => {
          if (done) return;
          const pages = f && f.length ? 1 + Math.ceil(restOf(f, a).length / 4) : 1;
          v.pages = pages;
          next.hidden = i >= pages - 1;
          whole.hidden = i < pages - 1;
        });
        v.ready = Promise.all([filled, counted]).catch(() => {});
        /* back on this page after reading, the entries say which books are now read */
        v.metas = [];
        v.onShow = () => v.metas.forEach(([b, el, row]) => el.replaceChildren(...metaOf(b, row)));
        return v;
      }
      /* a turn keeps the reader on the same control on the new page (or the other one, at either end), and a screen
         reader hears which page it is */
      function turnTo(i, dir) {
        if (i < 0 || (view && view.kind === 'contents' && view.pages && i >= view.pages)) return;
        const v = contents(i);
        v.keys = dir;
        swap(v, dir);
        live.textContent = 'Contents, page ' + (i + 1);
      }
      function skeleton(grid) {
        grid.innerHTML = '';
        const lead = h('div', { class: 'lbk-entry is-lead', 'aria-hidden': 'true' },
          h('span', { class: 'lbk-plate is-wait' }),
          h('span', { class: 'lbk-ebody' }, h('span', { class: 'lbk-skel', style: 'height:14px;width:40%' }), h('span', { class: 'lbk-skel', style: 'height:52px;width:92%' }), h('span', { class: 'lbk-skel', style: 'height:40px;width:80%' })));
        const ul = h('ul', { class: 'lbk-rows', 'aria-hidden': 'true' });
        for (let k = 0; k < 3; k++) ul.append(h('li', null, h('div', { class: 'lbk-entry is-row' }, h('span', { class: 'lbk-plate is-wait' }), h('span', { class: 'lbk-ebody' }, h('span', { class: 'lbk-skel', style: 'height:38px' }), h('span', { class: 'lbk-skel', style: 'height:12px;width:50%' })))));
        grid.append(lead, ul);
      }
      function fill(grid, list, v) {
        grid.innerHTML = '';
        if (!list || !list.length) {
          grid.append(h('p', { class: 'lbk-stuck', text: 'These pages are stuck together tonight.' }));
          return;
        }
        grid.append(entry(list[0], true, v));
        if (list.length > 1) grid.append(h('ul', { class: 'lbk-rows', role: 'list' }, list.slice(1, 4).map((b) => h('li', null, entry(b, false, v)))));
      }
      /* the minutes over an entry ("6 min read" over the lead, "5 min" over a row). No dates on the books (Jan, 2026-10-07) */
      function metaOf(b, row) {
        const m = +call(api.mins, b) || 0;
        return [m ? h('span', { text: m + (row ? ' min' : ' min read') }) : null,
          call(api.isRead, b) ? h('span', { class: 'lbk-readmark', text: 'Read' }) : null].filter(Boolean);
      }
      function plate(b, w, cls) {
        const p = h('span', { class: 'lbk-plate is-wait' + (cls ? ' ' + cls : ''), 'aria-hidden': 'true' });
        Promise.resolve().then(() => api.cover(b, w)).then((src) => {
          p.classList.remove('is-wait');
          if (!src || done) { p.classList.add('is-blank'); return; }
          const im = h('img', { src, alt: '', decoding: 'async' });
          if (b.f) im.style.setProperty('--focus-at', String(b.f));
          else if (b.cw && b.ch && b.cw / b.ch < 1.05) im.style.setProperty('--focus-at', '50% 28%');
          const onLoad = () => im.classList.add('is-on');
          im.addEventListener('load', onLoad, { once: true });
          im.addEventListener('error', () => { im.remove(); p.classList.add('is-blank'); }, { once: true });
          p.append(im);
          if (im.complete && im.naturalWidth) onLoad();
        }, () => { p.classList.remove('is-wait'); p.classList.add('is-blank'); });
        return p;
      }
      function entry(b, lead, v) {
        const a = h('a', { class: 'lbk-elink', href: b.u || '#' }, whole(h, b.t));
        a.addEventListener('click', (e) => { if (!plainClick(e)) return; e.preventDefault(); snd('tap'); v.focus = a; openArticle(b, 1); });
        const meta = h('p', { class: 'lbk-meta' }, metaOf(b, !lead));
        if (v.metas) v.metas.push([b, meta, !lead]);
        const body = h('div', { class: 'lbk-ebody' }, meta, h('h3', { class: 'lbk-etitle' }, a), lead && b.d ? h('p', { class: 'lbk-edek', text: b.d }) : null);
        return h('article', { class: 'lbk-entry ' + (lead ? 'is-lead' : 'is-row') }, plate(b, lead ? 800 : 240), body);
      }

      /* ---------- an article ---------- */
      function openArticle(b, dir, link) {
        if (!b || done) return;
        if (view) hist.push(view);
        syncBack();
        const v = article(b);
        if (link) v.from = call(api.shelfName, b.k) || '';
        swap(v, dir);
      }
      function article(b) {
        call(api.opened, b);
        const v = { kind: 'article', b, y: 0, p: 0, done: false };
        const wasRead = !!call(api.isRead, b);
        const [main, acc] = splitTitle(b.t);
        const title = h('h2', { class: 'lbk-title', tabindex: '-1', 'data-focus': '' }, whole(h, main), acc ? h('span', { class: 'lbk-acc' }, whole(h, acc)) : null);
        const m = +call(api.mins, b) || 0;
        const meta = m ? m + ' minute read' : '';
        const prose = h('div', { class: 'lbk-prose' }, h('p', { class: 'lbk-wait', text: 'Finding the page.' }));
        const ret = h('button', { type: 'button', class: 'lbk-btn', text: 'Return to the library' });
        const again = h('button', { type: 'button', class: 'lbk-btn is-main', text: 'Read another book' });
        ret.addEventListener('click', () => { if (Date.now() - t0 < 350) return; snd('tap'); end('library'); });
        again.addEventListener('click', () => { if (Date.now() - t0 < 350) return; snd('tap'); end('another'); });
        const endEl = h('footer', { class: 'lbk-end' }, h('i', { class: 'lbk-tail', 'aria-hidden': 'true' }), h('div', { class: 'lbk-endbtns' }, ret, again));
        const pl = h('figure', { class: 'lbk-plate lbk-art-plate is-wait', 'aria-hidden': 'true' });
        v.el = h('article', { class: 'lbk-view lbk-art', 'aria-label': b.t },
          pl,
          h('header', { class: 'lbk-ahead' }, title, meta ? h('p', { class: 'lbk-ameta', text: meta }) : null, b.d ? h('p', { class: 'lbk-dek', text: b.d }) : null, h('i', { class: 'lbk-orn', 'aria-hidden': 'true' })),
          prose, endEl);
        /* a book with no cover has no plate; a cover that fails to load folds its plate away smoothly */
        const fold = () => {
          if (!pl.isConnected || RM()) { pl.remove(); return; }
          pl.animate([{ height: pl.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0, paddingTop: '0px', paddingBottom: '0px', borderWidth: '0px' }], { duration: 240, easing: 'ease-in-out' })
            .finished.then(() => pl.remove(), () => pl.remove());
        };
        Promise.resolve().then(() => api.cover(b, 800)).then((src) => {
          pl.classList.remove('is-wait');
          if (!src || done) { fold(); return; }
          const im = h('img', { src, alt: b.alt || '', decoding: 'async' });
          if (b.f) im.style.setProperty('--focus-at', String(b.f));
          else if (b.cw && b.ch && b.cw / b.ch < 1.05) im.style.setProperty('--focus-at', '50% 28%');
          im.addEventListener('load', () => im.classList.add('is-on'), { once: true });
          im.addEventListener('error', fold, { once: true });
          pl.append(im);
          if (im.complete && im.naturalWidth) im.classList.add('is-on');
        }, fold);
        /* the text, cleaned by the room; the demo’s pictures come from its picture files by number */
        Promise.resolve().then(() => api.text(b)).then((r) => {
          if (done) return;
          prose.innerHTML = '';
          if (!r || r.pf || !r.html) {
            const go = h('button', { type: 'button', class: 'lbk-btn', text: 'Read it in the Guide' });
            go.addEventListener('click', () => goNow(b.u));
            prose.append(h('div', { class: 'lbk-away' }, h('p', { text: r && r.pf ? 'This one reads best in the Guide itself.' : 'This one wouldn’t open here. It reads in the Guide.' }), go));
            v.away = true;
            return;
          }
          prose.innerHTML = r.html;
          tidy(prose);
          v.full = true;
          if (view === v) track();
        }, () => {
          if (done) return;
          prose.innerHTML = '';
          prose.append(h('p', { class: 'lbk-wait', text: 'This one wouldn’t open here. It reads in the Guide.' }));
        });
        prose.addEventListener('click', (e) => {
          const a = e.target.closest && e.target.closest('a[href]');
          if (!a || !prose.contains(a) || !plainClick(e)) return;
          e.preventDefault();
          follow(a.getAttribute('href'), a);
        });
        /* the ribbon follows the reader; the end of the text counts the book as read */
        v.track = () => {
          const max = scroll.scrollHeight - scroll.clientHeight;
          const p = max > 0 ? Math.min(1, Math.max(0, scroll.scrollTop / max)) : 1;
          v.p = p;
          if (!v.done) rib.style.setProperty('--p', p.toFixed(3));
          if (scroll.scrollTop > 120) v.moved = true;
          if (!v.done && v.full && v.moved && (p > 0.92 || endEl.getBoundingClientRect().top < scroll.getBoundingClientRect().bottom - 40)) {
            v.done = true;
            rib.style.setProperty('--p', '1');
            rib.classList.add('is-done');
            if (!wasRead) call(api.finished, b);
          }
        };
        v.onShow = () => track();
        return v;
      }
      function track() { if (view && view.track) view.track(); }
      on(scroll, 'scroll', () => track(), { passive: true });
      /* on a touch screen a sideways swipe over the contents turns its page, as a finger turns paper */
      let sw = null;
      on(scroll, 'touchstart', (e) => { sw = view && view.kind === 'contents' && e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null; }, { passive: true });
      on(scroll, 'touchend', (e) => {
        if (!sw || !view || view.kind !== 'contents' || !e.changedTouches.length) { sw = null; return; }
        const t = e.changedTouches[0], dx = t.clientX - sw.x, dy = t.clientY - sw.y;
        sw = null;
        if (Math.abs(dx) < 56 || Math.abs(dx) < Math.abs(dy) * 1.6) return;
        const b = dx < 0 ? view.nextBtn : view.prevBtn;
        if (shown(b)) { snd('tap'); turnTo(view.i + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); }
      }, { passive: true });
      /* a text with no room to scroll counts as read once its end has been in view a few seconds */
      const idle = setInterval(() => { if (view && view.kind === 'article' && view.full && !view.done && scroll.scrollHeight - scroll.clientHeight <= 0) { view.moved = true; track(); } }, 4000);
      undo.push(() => clearInterval(idle));

      /* the article’s own markup, made ready for the page: the demo’s numbered pictures, tables that scroll on their own,
         links that the book follows itself */
      function tidy(prose) {
        prose.querySelectorAll('img').forEach((im) => {
          if (!im.getAttribute('src') && im.hasAttribute('data-i')) {
            const n = +im.getAttribute('data-i');
            let u = null;
            for (const m of (window.FFD_LIBRARY_PICS || [])) if (m && m[n] != null) { u = m[n]; break; }
            if (u) im.setAttribute('src', u); else { im.remove(); return; }
          }
          im.setAttribute('loading', 'lazy'); im.setAttribute('decoding', 'async');
          im.addEventListener('error', () => im.remove(), { once: true });
        });
        prose.querySelectorAll('table').forEach((t) => { if (!t.closest('.ffb-table')) { const w = h('div', { class: 'ffb-table', tabindex: '0' }); t.replaceWith(w); w.append(t); } });
        prose.querySelectorAll('a[href]').forEach((a) => { a.removeAttribute('target'); a.setAttribute('rel', 'noopener'); });
      }

      /* ---------- links: another Guide article opens here; anything else asks first ---------- */
      const ffHost = (host) => !host || host === location.host || /(^|\.)framedfantasy\.com$/i.test(host) || /\.myshopify\.com$/i.test(host);
      function guideBook(u) {
        if (/^https?:$/.test(u.protocol) && !ffHost(u.host)) return null;
        const m = u.pathname.replace(/\/+$/, '').match(/\/blogs\/[^/]+\/([^/]+)$/);
        if (!m || m[1] === 'tagged') return null;
        let hd = m[1];
        try { hd = decodeURIComponent(hd); } catch (e) { /* fine */ }
        return call(api.bookByHandle, hd) || null;
      }
      function placeOf(u) {
        if (u.protocol === 'mailto:') return 'your email';
        if (u.protocol === 'tel:') return 'your phone';
        if (!ffHost(u.host)) return u.host.replace(/^www\./i, '');
        const p = u.pathname.replace(/\/+$/, '').toLowerCase();
        if (/\/products\/dnd-character-commission$/.test(p)) return 'FramedFantasy’s commission page';
        if (/\/(products|collections)(\/|$)/.test(p)) return 'FramedFantasy’s shop';
        if (/\/pages\/dnd-character-quest$/.test(p)) return 'FramedFantasy’s Character Quest';
        if (/\/pages\/(hall-of-heroes|hero)$/.test(p)) return 'FramedFantasy’s Hall of Heroes';
        if (/\/pages\/battlegrounds$/.test(p)) return 'FramedFantasy’s Battlegrounds';
        if (/\/pages\/reviews$/.test(p)) return 'FramedFantasy’s reviews';
        if (/\/pages\/design-their-gift$/.test(p)) return 'FramedFantasy’s gift page';
        if (/\/blogs(\/|$)/.test(p)) return 'FramedFantasy’s Guide';
        const m = p.match(/\/pages\/([^/]+)$/);
        if (m) return 'FramedFantasy’s ' + m[1].replace(/[-_]+/g, ' ') + ' page';
        if (!p) return 'FramedFantasy’s home page';
        return 'FramedFantasy’s site';
      }
      function leaveLine(href) {
        let u = null;
        try { u = new URL(href, location.href); } catch (e) { u = null; }
        if (!u) return null;
        return 'This leaves the library for ' + placeOf(u) + '. Go there?';
      }
      function follow(href, link) {
        let u = null;
        try { u = new URL(href, location.href); } catch (e) { u = null; }
        if (!u || !/^(https?|mailto|tel):$/.test(u.protocol)) return;
        const b = guideBook(u);
        /* back from the linked book, the focus returns to the link that was followed */
        if (b) { snd('tap'); if (view) view.focus = link; openArticle(b, 1, true); return; }
        snd('tap');
        ask(leaveLine(href), href, link);
      }

      /* a way out the reader chose by a button that names it ("The whole Guide on FramedFantasy", "Read it in the Guide"):
         no slip saying the same thing again, straight to the room's fade (Jan, 2026-10-11: "it says the same thing again
         then you click it again to open the page"). A second tap while the frame fades does nothing; the time guard
         (not a flag) lets the button work again if the reader comes Back to this page from the browser's cache */
      let goneAt = 0;
      function goNow(href) {
        if (!href || done || Date.now() - goneAt < 1500) return;
        goneAt = Date.now();
        snd('tap');
        hideSlip(false);
        call(api.go, href);
      }

      /* the question before leaving a link in an article's own text, on a slip at the foot of the page */
      let asking = null;
      function ask(line, href, back) {
        if (!href) return;
        hideSlip(false);
        const go = h('button', { type: 'button', class: 'lbk-btn is-main', text: 'Go there' });
        const stay = h('button', { type: 'button', class: 'lbk-btn', text: 'Stay in the book' });
        slip.innerHTML = '';
        slip.append(h('p', { text: line || 'This leaves the library. Go there?' }), h('div', { class: 'lbk-slip-btns' }, stay, go));
        const at = Date.now();
        asking = { back };
        go.addEventListener('click', () => { if (Date.now() - at < 300) return; snd('tap'); hideSlip(false); call(api.go, href); });
        stay.addEventListener('click', () => { if (Date.now() - at < 300) return; snd('tap'); hideSlip(true); });
        requestAnimationFrame(() => { if (!done) slip.classList.add('is-in'); });
        later(() => { try { go.focus({ preventScroll: true }); } catch (e) { /* fine */ } }, RM() ? 0 : 60);
      }
      function hideSlip(refocus) {
        if (!asking) return;
        const a = asking; asking = null;
        slip.classList.remove('is-in');
        if (refocus && a.back && a.back.isConnected) { try { a.back.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
      }

      /* ---------- the room around the book, the keys, the end ---------- */
      xBtn.addEventListener('click', () => { if (Date.now() - t0 < 350) return; snd('tap'); end('library'); });
      dim.addEventListener('click', () => { if (Date.now() - t0 < 400 || !WIDE()) return; end('library'); });
      /* the page under the frame never scrolls while the book is open; the book’s own pages do (a touch is held by the
         CSS touch-action on the dim, the head and the slip, so no touch listener ever holds up the scrolling) */
      const inScroll = (e) => !!(e.target && e.target.closest && (e.target.closest('.lbk-scroll') || e.target.closest('.ffb-table')));
      on(root, 'wheel', (e) => { if (!inScroll(e)) e.preventDefault(); }, { passive: false });
      /* the keys: Escape closes (the question first), Tab stays in the book, the arrows turn the contents, and the frame’s
         tap to continue never takes a key meant for the book (this listener runs before the frame’s own) */
      on(window, 'keydown', (e) => {
        if (done) return;
        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault(); e.stopPropagation();
          if (asking) hideSlip(true); else end('library');
          return;
        }
        const ae = document.activeElement, inside = ae && root.contains(ae);
        if (e.key === 'Tab') { trap(e); return; }
        if (!inside && ae && ae !== document.body) return;
        /* the scrolling keys always move the book’s page, never the store page under it (focus on the head or nowhere
           would otherwise scroll the window) */
        if (!(inside && scroll.contains(ae)) && !e.altKey && !e.metaKey && !e.ctrlKey && /^(ArrowDown|ArrowUp|PageDown|PageUp|Home|End| )$/.test(e.key)
          && !(e.key === ' ' && ae && ae.closest && ae.closest('button, a, summary'))) {
          e.preventDefault(); e.stopPropagation();
          const pg = scroll.clientHeight * 0.85, k = e.key === ' ' ? (e.shiftKey ? 'PageUp' : 'PageDown') : e.key;
          const y = k === 'Home' ? 0 : k === 'End' ? scroll.scrollHeight : scroll.scrollTop + ({ ArrowDown: 48, ArrowUp: -48, PageDown: pg, PageUp: -pg })[k];
          scroll.scrollTo({ top: y, behavior: RM() ? 'auto' : 'smooth' });
          return;
        }
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.stopPropagation();
          if (view && view.kind === 'contents' && !asking && (e.key === 'ArrowRight' || e.key === 'ArrowLeft') && !e.altKey && !e.metaKey && !e.ctrlKey) {
            const b = e.key === 'ArrowRight' ? view.nextBtn : view.prevBtn;
            if (b && !b.hidden) { e.preventDefault(); b.click(); }
          }
        }
      }, true);
      function trap(e) {
        const list = [...root.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), summary')]
          .filter((x) => !x.closest('[hidden]') && !x.closest('.lbk-leaf') && !(x.closest('.lbk-slip') && !asking) && x.getClientRects().length && getComputedStyle(x).visibility !== 'hidden');
        if (!list.length) return;
        const first = list[0], last = list[list.length - 1], ae = document.activeElement;
        if (!root.contains(ae)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
        if (e.shiftKey && ae === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && ae === last) { e.preventDefault(); first.focus(); }
      }
      /* the room going away under the book (a page change, the browser’s back button) ends it too */
      const watch = setInterval(() => { if (!alive() || !frame.isConnected) end('library', true); }, 700);
      undo.push(() => clearInterval(watch));

      /* the book takes the frame: when the frame sits partly off the window, the page moves to show all of it, at once */
      function bringIntoView() {
        try {
          const r = frame.getBoundingClientRect(), vh = window.innerHeight || 0, top = topInset(frame);
          if (r.top < top - 1 || (r.bottom > vh + 1 && r.height <= vh - top + 1)) goTo((window.scrollY || 0) + r.top - top);
        } catch (e) { /* fine */ }
      }

      function end(v, now) {
        if (done) return;
        park(false);
        done = true;
        if (S === s) S = null;
        if (turn) { try { turn(); } catch (e) { turn = null; } }
        undo.forEach((f) => { try { f(); } catch (e) { /* fine */ } });
        timers.forEach((t) => clearTimeout(t)); timers.clear();
        const quick = now || RM() || !frame.isConnected;
        if (quick) root.remove();
        else { root.classList.remove('is-in'); root.classList.add('is-out'); setTimeout(() => root.remove(), 240); }
        if (!now && opener && opener !== document.body && opener.isConnected && typeof opener.focus === 'function') { try { opener.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
        res(v === 'another' ? 'another' : 'library');
      }

      /* the first page: straight to the book asked for, or the contents of that shelf */
      if (o.book) swap(article(o.book), 0);
      else swap(contents(0), 0);
      return s;
    }

    return { open, close, isOpen };
  };
})();

/* ===== src/scene-pages/pages/library/borders.js ===== */
/* library/borders.js: Jan's token borders, hidden in Zhaunil's library as twenty-three single finds (a part of the library page).
   Jan (2026-10-06): "add them to the library scene as free easter eggs, they can find hand drawn token borders by jan
   make them easter eggs and add a tiny sparkle or something but hide them in a fun way with subtle hints and give the
   user a real download once they get it ... make it exciting and fun when they discover one". Jan (2026-10-07, the
   jukebox): the 23 borders are given one at a time with no choosing and hidden better; a found border has one button,
   "Add to my collection", and flies into a collection button in the corner; downloads happen from the collection, one
   border at a time. The plan: docs/scene-pages/jukebox/README.md ("The 23 borders, one find each").

   Every colourway is its own find, keyed '<set>-<colourway, lowercased, spaces to dashes>' (fighter-goldspire,
   druid-radiance, monk-black-and-white). Eight wait on any calm record (quiet, hearth, after), each colourway 0 of its
   set, behind something the room already does:
     fighter-goldspire     a wish on the shooting star (games note 'wish'), a sparkle high in the window
     barbarian-fanghide    in the mimic's mouth, once it has given its card and sulks (notes 'mimic-gave', 'mimic-sulk')
     necromancer-deathrend beside Bartholomew after his fifth joke this visit (note 'pun')
     paladin-emerald       on Zhaunil's ledger, after its third tap this visit (the room notes 'ledger')
     sorcerer-bloodvein    in the potions' smoke (note 'bubble' n 5)
     rogue-dusk            low by the door while every candle is out (notes 'dark' and 'light'); it goes with the light
     druid-radiance        under Soryndel after the feather hunt is won (note 'hunt-win')
     monk-black-and-white  on the window sill after fifteen seconds of touching nothing at all
   Two more come on a calm record of their own: monk-tan-and-brown on Hearthside (note 'cinders' n 3) and
   druid-wintershade on After Hours (note 'owl-wake' n 3). monk-blue-and-gray is the stillness clock again, under the
   water of Blackwater ('flood'). The other twelve are the road records' gifts, handed over by the guests through
   borders.give(). A sparkle is a real button (44 px) that shows only once it is earned, never before; a tap flies the
   border out of the room into its card. The hints, from faint to plain: a single twinkle as a find gets close (the
   second ledger tap, the third joke, the third bubble, the mimic's card), and Ask Zhaunil's "Is anything hidden in
   here?": one riddle at a time for a border findable in this record, plainer the second time round, or a line
   pointing at the jukebox when this record has nothing left.

   The card: the border at size with a real Hall hero inside it (a hero of that class, Jan's picks first, else
   Zhaunil), "Token border, n of 23", the colourway's name, its set, the giver's line and name, and one button, "Add
   to my collection", which flies it into the corner. A border already owned gets a quiet card: "Already in your
   collection." and "Back to the library". The collection (the corner tool, which appears with the first find) shows
   every set: each border found is a button that downloads its PNG, each one still hidden is a quiet '?'.
   On the store the files are Shopify Files (uploaded 2026-10-06, the CDN sends CORS headers, so a download never
   leaves the page). Without FFD_SITE (the review demo) the previews are img/borders/*.webp and the full PNGs
   img/borders/full/*.png, and a save goes through the artifact's downloads capability when there is one.

   The interface (the room calls it once in render, after the games):
     FFD.parts['library/borders'](api) -> borders
       borders.note(what, d)   what the room and the games saw: 'ledger', 'pun' { n }, 'bubble' { n }, 'mimic-gave',
                               'mimic-sulk', 'dark', 'light', 'hunt-win', 'wish', 'cinders' { n, from?, at? },
                               'owl-wake' { n, from?, at? }
       borders.give(key, { from?, line?, who? }) -> Promise   a guest hands a border over: a fresh one is added to the
                               collection (+1 'borders') and its card opens; an owned one gets the quiet card. Resolves
                               when the card closes (a second give waits for the first card). from is a DOMRect (the
                               giver on screen, for the flight), line and who replace the find's own words
       borders.has(key) -> bool   the border is in this reader's collection (a giver stops offering it)
       borders.hint() -> [lines] | null   Zhaunil's answer to "Is anything hidden in here?" (null once all are found)
       borders.left() -> n     borders still hidden (of 23)     borders.busy() -> the card or the collection is open
       borders.close()         stop every timer and listener, take the sparkles and any card away
   The room gives: h, RM(), WIDE(), alive(), F, snd(name), SITE, ZH, cards, talk(lines), free(), sceneOk(),
   intoView(), tally(key, n), total(key), yield() (whoever speaks gives way before a sparkle's card opens), rec() (the
   record playing: quiet, hearth, after, regal, bog, tinker, tavern, flood, ash) and calm() (a calm record is on). The
   calm finds and their notes count only while calm() is true; without rec() the room counts as Quiet Alehouse.
   Per reader, in this browser only (localStorage 'ffd-library-borders'): got (the borders found, in collection order),
   found (the sets held whole, which is what builds before the jukebox read and write), hi and told (the riddles
   given). A save from before the jukebox, found: ['paladin'], keeps every Paladin colourway. Shared (FFD.tally, page
   library): 'borders' borders found, 'border-dl' files saved. Nothing typed or chosen is sent. */
(() => {
  'use strict';
  const FFD = window.FFD = window.FFD || {};
  const CSS_ID = 'ffd-css-library-borders';
  const STORE = 'ffd-library-borders';
  const CDN = 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/';
  const DEMO_IMG = 'img/borders/';
  const STILL_MS = 15000;
  const CALM = new Set(['quiet', 'hearth', 'after']);

  /* ---------- the sets: each colourway is [name, file part, width, height, hole centre x, y, hole radius] (the hole
     in fractions of the picture, its radius of the shorter side, measured from the PNGs' transparency) ---------- */
  const SETS = {
    fighter: { label: 'Fighter', c: '#f4d68a',
      ways: [['Goldspire', 'Fighter-Goldspire', 1000, 1000, 0.49, 0.542, 0.306], ['Ironhide', 'Fighter-Ironhide', 1000, 1000, 0.493, 0.54, 0.306],
        ['Steelveil', 'Fighter-Steelveil', 1000, 1000, 0.494, 0.54, 0.306]] },
    barbarian: { label: 'Barbarian', c: '#e8a35c',
      ways: [['Fanghide', 'Barbarian-Fanghide', 1000, 1000, 0.507, 0.509, 0.299], ['Marbleborn', 'Barbarian-Marbleborn', 1000, 1000, 0.509, 0.5, 0.298]] },
    necromancer: { label: 'Necromancer', c: '#9be08a',
      ways: [['Deathrend', 'Necromancer-Deathrend', 1000, 1000, 0.499, 0.473, 0.38], ['Gravebloom', 'Necromancer-Gravebloom', 1000, 1000, 0.499, 0.473, 0.38],
        ['Lichspire', 'Necromancer-Lichspire', 1000, 1000, 0.499, 0.473, 0.38]] },
    paladin: { label: 'Paladin', c: '#fff1c4',
      ways: [['Emerald', 'Paladin-Emerald', 1000, 1000, 0.504, 0.496, 0.304], ['Imperial', 'Paladin-Imperial', 1000, 1000, 0.504, 0.496, 0.304],
        ['Regal', 'Paladin-Regal', 1000, 1000, 0.504, 0.496, 0.304]] },
    sorcerer: { label: 'Sorcerer', c: '#f08aa0',
      ways: [['Bloodvein', 'Sorcerer-Bloodvein', 2000, 2000, 0.462, 0.466, 0.291], ['Umbral', 'Sorcerer-Umbral', 2000, 2000, 0.462, 0.466, 0.291],
        ['Verdictus', 'Sorcerer-Verdictus', 2000, 2000, 0.462, 0.466, 0.291]] },
    rogue: { label: 'Rogue', c: '#c9a6ff',
      ways: [['Dusk', 'Rogue-Dusk', 1800, 1800, 0.493, 0.503, 0.298], ['Nightshade', 'Rogue-Nightshade', 1800, 1800, 0.493, 0.503, 0.298],
        ['Thorncloak', 'Rogue-Thorncloak', 1800, 1800, 0.493, 0.503, 0.298]] },
    druid: { label: 'Druid and Ranger', c: '#a8e08a',
      ways: [['Radiance', 'Druid-Ranger-Radiance', 2000, 1862, 0.495, 0.52, 0.325], ['Verdant', 'Druid-Ranger-Verdant', 2000, 1862, 0.495, 0.52, 0.325],
        ['Wintershade', 'Druid-Ranger-Wintershade', 2000, 1862, 0.495, 0.52, 0.325]] },
    monk: { label: 'Monk', c: '#cfe6ff',
      ways: [['Black and White', 'Monk-Black-and-White', 1000, 1000, 0.487, 0.488, 0.301], ['Blue and Gray', 'Monk-Blue-and-Gray', 1000, 1000, 0.487, 0.488, 0.301],
        ['Tan and Brown', 'Monk-Tan-and-Brown', 1000, 1000, 0.487, 0.488, 0.301]] }
  };
  const ORDER = ['fighter', 'barbarian', 'necromancer', 'paladin', 'sorcerer', 'rogue', 'druid', 'monk'];
  const slug = (k, way) => k + '-' + way.toLowerCase().replace(/ /g, '-');
  /* every border's key, in collection order (the sets in ORDER, then their colourways), and what it is */
  const KEYS = [], WAY = {};
  ORDER.forEach((k) => SETS[k].ways.forEach((w, i) => { const key = slug(k, w[0]); KEYS.push(key); WAY[key] = { k, i, w }; }));
  const TOTAL = KEYS.length;

  /* ---------- the finds: where each one waits (rec 'home' is any calm record), the sparkle's anchors for the ones that
     sparkle ([spot id, fraction x, fraction y, dx px, dy px], the first spot that exists wins), Zhaunil's riddle and
     plainer hint, and the giver's name and line on the card (a give() may bring its own) ---------- */
  const FINDS = {
    'fighter-goldspire': { rec: 'home', at: [['window', 0.5, 0.18, 0, 0]],
      riddle: 'Wishes come true in here, if you’re quick about it.', plain: 'Tap a shooting star while it crosses the window, and make a wish.',
      who: 'A shooting star', line: 'It came down with the star you wished on.' },
    'fighter-ironhide': { rec: 'tinker',
      riddle: 'Yost’s mule is chewing on something that isn’t oats.', plain: 'Tap Yost’s mule three times.',
      who: 'Old Yost', line: 'Found that in a sack of oats. Don’t ask whose.' },
    'fighter-steelveil': { rec: 'regal',
      riddle: 'A good soldier answers a salute. Wait for the music to rise.', plain: 'When the music swells, return the guards’ salute.',
      who: 'Sergeant Maren Vos', line: 'You saluted right on the beat. That earns a soldier’s colours.' },
    'barbarian-fanghide': { rec: 'home', at: [['mimic', 0.5, 0.32, 0, -2]],
      riddle: 'Teeth guard one of them. Ask for more than they want to give.', plain: 'Tap the mimic until it spits out a card, then three more times.',
      who: 'The mimic', line: 'It spat this out to make you stop poking.' },
    'barbarian-marbleborn': { rec: 'tinker',
      riddle: 'A tinker’s boots carry more than his feet.', plain: 'Tap Yost’s boots three times. He’ll flip a coin for it.',
      who: 'Old Yost', line: 'The coin says it’s yours. I never argue with the coin.' },
    'necromancer-deathrend': { rec: 'home', at: [['skull', 1, 0.7, 18, 0], ['skull', 0, 0.7, -18, 0]],
      riddle: 'An old friend trades one for a good audience.', plain: 'Hear five of Bartholomew’s jokes. He’s the skull.',
      who: 'Bartholomew', line: 'Five jokes and you’re still here. You earned this.' },
    'necromancer-gravebloom': { rec: 'bog',
      riddle: 'One light in the bog isn’t going where the others go.', plain: 'Follow the stray wisp. Tap it three times.',
      who: 'A stray wisp', line: 'It led you off the path and left this where it went out.' },
    'necromancer-lichspire': { rec: 'ash',
      riddle: 'When she falls, the cold keeps something behind.', plain: 'Beat the Iron Matron, then look in the ice where she stood.',
      who: 'Zhaunil', line: 'Something glints in the ice where she stood.' },
    'paladin-emerald': { rec: 'home', at: [['ledger', 0.78, 0.72, 0, 0]],
      riddle: 'A careful keeper seals one inside the count.', plain: 'Tap my ledger three times.',
      who: 'Zhaunil’s ledger', line: 'It was pressed between two pages, right where the count stops.' },
    'paladin-imperial': { rec: 'regal',
      riddle: 'The quiet guard has a tickle in his nose.', plain: 'Tap Pike five times.',
      who: 'Pike', line: 'Pike says nothing. He holds out a folded cloth and looks straight ahead.' },
    'paladin-regal': { rec: 'regal',
      riddle: 'The sergeant notices good manners.', plain: 'Salute Sergeant Maren Vos.',
      who: 'Sergeant Maren Vos', line: 'Wear them on the road. The watch will know you.' },
    'sorcerer-bloodvein': { rec: 'home', at: [['potions', 0.5, 0, 0, -16]],
      riddle: 'Something settles out of the smoke.', plain: 'Tap the bottles until they smoke.',
      who: 'Three bottles', line: 'It came down with the smoke, still warm.' },
    'sorcerer-umbral': { rec: 'flood',
      riddle: 'One drowned book still turns its pages.', plain: 'Tap the turning book three times as it drifts past.',
      who: 'A drowned book', line: 'The pages fell open, and this floated out.' },
    'sorcerer-verdictus': { rec: 'bog',
      riddle: 'The frog is sitting on something green. It won’t give it up without a chase.', plain: 'Chase the frog. Three taps, three hops.',
      who: 'Zhaunil', line: 'The bog keeps a sorcerer’s green. The frog was holding it for you.' },
    'rogue-dusk': { rec: 'home', at: [['door', 0.12, 0.95, 0, 0], ['ladder', 0.5, 0.86, 0, 0]],
      riddle: 'A thief’s border only shows itself in the dark.', plain: 'Put out every candle, then look low.',
      who: 'The dark', line: 'It was there the whole time. It only shows with the candles out.' },
    'rogue-nightshade': { rec: 'tavern',
      riddle: 'Quick hands do well in a room full of eyes. Wait for them to look away.', plain: 'Pocket all three coins while nobody’s looking.',
      who: 'A patron', line: 'A hooded patron slides a card across the table without looking up.' },
    'rogue-thorncloak': { rec: 'ash',
      riddle: 'She can’t watch everything. Watch her feet when her eyes close.', plain: 'Tap the glint at her feet while her eyes are shut.',
      who: 'Zhaunil', line: 'You took it while she wasn’t looking. A thief’s cloak, for a thief.' },
    'druid-radiance': { rec: 'home', at: [['owl', 0.5, 1, 0, 14]],
      riddle: 'Soryndel repays help with something from the nest.', plain: 'Turn the hourglass and catch all three feathers in time.',
      who: 'Soryndel', line: 'You found all three feathers. She left this in their place.' },
    'druid-verdant': { rec: 'bog',
      riddle: 'Little lights in the reeds. Catch a few.', plain: 'Catch three fireflies.',
      who: 'The fireflies', line: 'The third one went out in your hand and left this behind.' },
    'druid-wintershade': { rec: 'after', at: [['owl', 0.5, 0.5, 0, 0]],
      riddle: 'Soryndel is trying to sleep. She keeps something under her wing.', plain: 'Wake the dozing owl three times.',
      who: 'Soryndel', line: 'She drops it in a huff and goes back to sleep.' },
    'monk-black-and-white': { rec: 'home', at: [['window', 0.5, 0.9, 0, -4]],
      riddle: 'The patient find what the busy miss.', plain: 'Touch nothing at all for fifteen seconds.',
      who: 'The window', line: 'It sat on the sill all along. You kept still long enough to see it.' },
    'monk-tan-and-brown': { rec: 'hearth',
      riddle: 'The hearth sends up a few sparks. Catch them before they cool.', plain: 'Catch three cinders as they rise.',
      who: 'The hearth', line: 'The third cinder cooled in your hand and left this.' },
    'monk-blue-and-gray': { rec: 'flood', at: [['window', 0.5, 0.9, 0, -4], ['zhaunil', 0.5, 0.2, 0, 0]],
      riddle: 'Hold your breath and keep still. The water brings things to the patient.', plain: 'Touch nothing for fifteen seconds while the room is under water.',
      who: 'The water', line: 'You held still, and the water brought it to you.' }
  };
  const PLACE = { window: 'the window', mimic: 'the mimic', skull: 'Bartholomew', ledger: 'my ledger', potions: 'the bottles', ladder: 'the ladder',
    jukebox: 'the jukebox', globe: 'the globe', door: 'the door', owl: 'Soryndel', zhaunil: 'me' };
  /* a Hall hero of the set's class shows inside the border */
  const CLS = { fighter: /fighter|swashbuckler|gunslinger|knight|warrior/i, barbarian: /barbarian|blood hunter|monster hunter|berserk/i,
    necromancer: /necromancer|grave|witch|warlock|illrigger/i, paladin: /paladin|cleric|priest/i, sorcerer: /sorcerer|wizard|warlock/i,
    rogue: /rogue|swashbuckler|thief/i, druid: /druid|ranger/i, monk: /monk/i };
  const COUNT = ['none', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen',
    'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty', 'twenty-one', 'twenty-two', 'twenty-three'];

  /* ---------- Zhaunil's words ---------- */
  const L = {
    first: ['Jan left twenty-three of those in my library. I keep finding them in odd places.', 'Yours wait up in the corner. Tap there to download them.'],
    more: ['Another one. Jan will be glad somebody found it.', 'I’d been looking for that one since spring.', 'Soryndel saw you take that, and has no objections.', 'That makes {n}. Keep your eyes open.'],
    last: 'Twenty-two. One left, and it’s a shy one.',
    all: ['All twenty-three. Not even Soryndel has found them all.', 'Every one is yours to keep. And if you want your own character painted, Ember is at the easel.'],
    hintFirst: 'Jan left twenty-three token borders somewhere in here. Free ones, for your table.',
    hintUp: 'Something by {place} is catching the light right now.',
    hintMore: 'You’ve found {n}. Here’s a riddle for one of the others.',
    plainer: 'Plainer, then.',
    elsewhere: 'The jukebox knows where a few more are. Some only come out with their own song.'
  };

  const P = '.ffd-page--library';
  const STAR = 'radial-gradient(circle, #fffaf0 0 1.6px, var(--c, #f4d68a) 2.8px, rgba(244, 214, 138, 0) 8px), linear-gradient(90deg, rgba(255, 246, 220, 0) 0 46%, #fff6dc 50%, rgba(255, 246, 220, 0) 54%), linear-gradient(0deg, rgba(255, 246, 220, 0) 0 46%, #fff6dc 50%, rgba(255, 246, 220, 0) 54%)';
  const CSS = `
${P} .lbb-layer { position: absolute; inset: 0; z-index: 3; pointer-events: none; }
${P} .ffs.lb-portal .lbb-layer { visibility: hidden; }
${P} .lbb-g { position: absolute; width: 44px; height: 44px; margin: -22px 0 0 -22px; padding: 0; border: 0; border-radius: 50%; background: transparent; cursor: pointer; pointer-events: auto; -webkit-tap-highlight-color: transparent; animation: lbb-in .7s cubic-bezier(.2, .9, .3, 1.35) both; }
${P} .lbb-g[hidden] { display: none; }
${P} .lbb-g:focus { outline: none; }
${P} .lbb-g:focus-visible { outline: 1.5px dashed var(--gold-hi, #e7c97f); outline-offset: 0; }
${P} .lbb-g.is-gone { animation: lbb-out .45s ease forwards; pointer-events: none; }
${P} .lbb-gs { position: absolute; left: 50%; top: 50%; width: 26px; height: 26px; margin: -13px 0 0 -13px; pointer-events: none; background: ${STAR}; filter: drop-shadow(0 0 4px rgba(255, 228, 160, .8)); animation: lbb-tw 2.6s ease-in-out var(--d, 0s) infinite; }
${P} .lbb-gs::after { content: ''; position: absolute; inset: 8px; transform: rotate(45deg); background: linear-gradient(90deg, rgba(255, 246, 220, 0) 0 42%, rgba(255, 246, 220, .8) 50%, rgba(255, 246, 220, 0) 58%), linear-gradient(0deg, rgba(255, 246, 220, 0) 0 42%, rgba(255, 246, 220, .8) 50%, rgba(255, 246, 220, 0) 58%); }
${P} .lbb-tell { position: absolute; width: 22px; height: 22px; margin: -11px 0 0 -11px; pointer-events: none; background: ${STAR}; opacity: 0; animation: lbb-tell 1.4s ease both; }
@keyframes lbb-tw { 0%, 100% { transform: scale(.55) rotate(0deg); opacity: .6; } 45% { transform: scale(1.12) rotate(28deg); opacity: 1; } 62% { transform: scale(.9) rotate(38deg); opacity: .92; } }
@keyframes lbb-in { 0% { opacity: 0; transform: scale(.2); } 100% { opacity: 1; transform: scale(1); } }
@keyframes lbb-out { to { opacity: 0; transform: scale(.3); } }
@keyframes lbb-tell { 0% { opacity: 0; transform: scale(.2) rotate(0deg); } 30% { opacity: .9; transform: scale(1) rotate(25deg); } 100% { opacity: 0; transform: scale(.35) rotate(60deg); } }

${P} .lbb-ov { position: absolute; inset: 0; z-index: 8; display: grid; place-items: center; overflow: hidden; box-sizing: border-box; padding: 12px 16px; color: var(--fg, #ece6da); background: radial-gradient(90% 70% at var(--rx, 50%) var(--ry, 34%), rgba(46, 32, 12, .8), rgba(6, 4, 2, .95) 70%); opacity: 0; transition: opacity .26s ease; }
${P} .lbb-ov.is-in { opacity: 1; }
${P} .ffs.lbb-up > .ffs-box { opacity: 0; visibility: hidden; transition: opacity .2s ease, visibility 0s linear .2s; }
${P} .lbb-ov.is-out { opacity: 0; transition-duration: .22s; }
${P} .lbb-rays { position: absolute; left: var(--rx, 50%); top: var(--ry, 30%); width: 150vmax; height: 150vmax; margin: -75vmax 0 0 -75vmax; pointer-events: none; opacity: 0; background: repeating-conic-gradient(from 0deg, rgba(255, 214, 140, .2) 0deg 5deg, rgba(255, 214, 140, 0) 5deg 16deg); -webkit-mask: radial-gradient(circle, #000 0, rgba(0, 0, 0, .55) 9vmax, transparent 30vmax); mask: radial-gradient(circle, #000 0, rgba(0, 0, 0, .55) 9vmax, transparent 30vmax); animation: lbb-spin 48s linear infinite; transition: opacity .9s ease .15s; }
${P} .lbb-ov.is-lit .lbb-rays { opacity: 1; }
@keyframes lbb-spin { to { transform: rotate(360deg); } }
${P} .lbb-card { position: relative; box-sizing: border-box; width: min(440px, 100%); max-height: 100%; overflow-y: auto; overscroll-behavior: contain; scrollbar-width: none; display: flex; flex-direction: column; align-items: center; text-align: center; padding: 4px 2px 6px; }
${P} .lbb-card::-webkit-scrollbar { display: none; }
${P} .lbb-info { display: flex; flex-direction: column; align-items: center; width: 100%; }
${P} .lbb-info > * { transition: opacity .38s ease calc(var(--i, 0) * 70ms), transform .38s ease calc(var(--i, 0) * 70ms); }
${P} .lbb-card.is-pre .lbb-info > * { opacity: 0; transform: translateY(10px); }
${P} .lbb-ov.is-wide .lbb-card:not(.is-coll) { width: min(820px, 100%); flex-direction: row; justify-content: center; gap: 36px; text-align: left; }
${P} .lbb-ov.is-wide .lbb-card:not(.is-coll) .lbb-stage { margin: 0; }
${P} .lbb-ov.is-wide .lbb-info { align-items: flex-start; width: min(340px, 100%); }
${P} .lbb-ov.is-wide .lbb-info .lbb-x { margin-left: -14px; }
${P} .lbb-stage { position: relative; flex: none; width: var(--ts, min(62vw, 290px, 36svh)); margin: 0 auto 8px; }
${P} .lbb-token { position: relative; width: 100%; aspect-ratio: var(--ar, 1); }
${P} .lbb-face { position: absolute; overflow: hidden; border-radius: 50%; background: radial-gradient(circle at 50% 38%, #3d2e1a, #120d08); opacity: 0; transition: opacity .5s ease; pointer-events: none; }
${P} .lbb-face.is-on { opacity: 1; }
${P} .lbb-face img { position: absolute; left: 0; top: 0; width: 100%; height: 100%; object-fit: cover; user-select: none; -webkit-user-drag: none; pointer-events: none; }
${P} .lbb-ring { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: contain; pointer-events: none; filter: drop-shadow(0 8px 20px rgba(0, 0, 0, .55)); }
${P} .lbb-flash { position: absolute; left: 50%; top: 50%; width: 100%; aspect-ratio: 1; margin: -50% 0 0 -50%; border-radius: 50%; border: 3px solid rgba(255, 232, 176, .95); box-shadow: 0 0 24px rgba(255, 214, 140, .7), inset 0 0 18px rgba(255, 214, 140, .5); opacity: 0; pointer-events: none; }
${P} .lbb-k { margin: 0 0 4px; font: 600 11.5px/1.3 var(--f-body, 'Spectral', Georgia, serif); letter-spacing: .16em; text-transform: uppercase; color: var(--gold-hi, #e7c97f); }
${P} .lbb-t { margin: 2px 0 2px; font: 600 clamp(22px, 5.8vw, 30px)/1.15 var(--f-display, 'Cinzel', Georgia, serif); color: #fff3d6; text-wrap: balance; }
${P} .lbb-l { margin: 4px 0 2px; font: italic 500 17px/1.35 var(--f-aside, 'Cormorant Garamond', Georgia, serif); color: var(--fg-2, #c9bea8); text-wrap: balance; }
${P} .lbb-s { margin: 0 0 8px; font: 13px/1.4 var(--f-body, 'Spectral', Georgia, serif); color: #b0a48c; text-wrap: balance; }
${P} .lbb-who { margin: 0 0 12px; font: 600 13px/1.3 var(--f-body, 'Spectral', Georgia, serif); color: #d8c9a8; }
${P} .lbb-btns { display: grid; gap: 8px; width: min(320px, 100%); }
${P} .lbb-b { display: flex; align-items: center; justify-content: center; gap: 8px; box-sizing: border-box; min-height: 46px; margin: 0; padding: 6px 18px; border-radius: 999px; border: 1px solid rgba(231, 201, 127, .55); background: rgba(20, 14, 8, .72); color: #f3e6c8; font: 600 15px/1.2 var(--f-body, 'Spectral', Georgia, serif); cursor: pointer; transition: background .18s ease, transform .14s ease, border-color .18s ease; -webkit-tap-highlight-color: transparent; }
${P} .lbb-b:hover { background: rgba(44, 32, 16, .92); border-color: #e7c97f; }
${P} .lbb-b:active { transform: scale(.97); }
${P} .lbb-b.is-main { background: linear-gradient(180deg, #f1d796, #d4ad5c); border-color: #f6e2ae; color: #24180a; box-shadow: 0 6px 20px rgba(212, 173, 92, .28); }
${P} .lbb-b.is-main:hover { background: linear-gradient(180deg, #f7e1a8, #dcb666); }
${P} .lbb-x { min-height: 44px; margin: 4px auto 0; padding: 0 14px; border: 0; background: none; color: var(--fg-2, #c9bea8); font: 600 14px/1 var(--f-body, 'Spectral', Georgia, serif); text-decoration: underline; text-underline-offset: 4px; text-decoration-color: rgba(231, 201, 127, .5); cursor: pointer; }
${P} .lbb-card.is-coll { width: min(940px, 100%); }
${P} .lbb-sets { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; width: 100%; margin: 10px 0 4px; padding: 0; list-style: none; }
${P} .lbb-set { display: grid; align-content: start; gap: 4px; min-width: 0; padding: 7px 4px 4px; border: 1px solid rgba(231, 201, 127, .16); border-radius: 12px; background: rgba(20, 14, 8, .55); }
${P} .lbb-set > b { font: 600 11px/1.2 var(--f-body, 'Spectral', Georgia, serif); letter-spacing: .12em; text-transform: uppercase; color: var(--gold-hi, #e7c97f); }
${P} .lbb-tiles { display: flex; justify-content: center; gap: 2px; margin: 0; padding: 0; list-style: none; }
${P} .lbb-tiles > li { flex: 0 1 33.333%; min-width: 0; display: flex; }
${P} .lbb-tile { display: grid; justify-items: center; align-content: start; gap: 3px; width: 100%; min-height: 44px; box-sizing: border-box; padding: 4px 2px 5px; border: 0; border-radius: 10px; background: none; color: var(--fg-2, #c9bea8); font: 12px/1.15 var(--f-body, 'Spectral', Georgia, serif); cursor: pointer; -webkit-tap-highlight-color: transparent; transition: background .18s ease; }
${P} button.lbb-tile:hover { background: rgba(44, 32, 16, .85); }
${P} button.lbb-tile:active { transform: scale(.97); }
${P} .lbb-tile img, ${P} .lbb-tile .lbb-q { width: 100%; max-width: 76px; aspect-ratio: 1; object-fit: contain; }
${P} .lbb-tile small { font: 600 11.5px/1.1 var(--f-body, 'Spectral', Georgia, serif); color: #e7c97f; text-decoration: underline; text-underline-offset: 3px; text-decoration-color: rgba(231, 201, 127, .45); }
${P} .lbb-tile[aria-busy="true"] { cursor: progress; }
${P} .lbb-tile.is-q { cursor: default; }
${P} .lbb-tile .lbb-q { display: grid; place-items: center; box-sizing: border-box; border-radius: 50%; border: 2px dashed rgba(231, 201, 127, .26); color: rgba(231, 201, 127, .5); font: 600 20px/1 var(--f-display, 'Cinzel', Georgia, serif); }
${P} .lbb-sr { position: absolute; width: 1px; height: 1px; margin: -1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
@media (min-width: 900px) {
  ${P} .lbb-sets { grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 10px; }
  ${P} .lbb-set { padding: 9px 6px 6px; }
}
/* a phone on its side: all eight sets in four columns with smaller tiles, so the whole collection and its way back fit
   on the screen (the tiles stay 44 px taps) */
@media (max-height: 500px) and (min-width: 600px) {
  ${P} .lbb-card.is-coll { padding-top: 0; }
  ${P} .lbb-card.is-coll .lbb-k { margin-bottom: 0; }
  ${P} .lbb-card.is-coll .lbb-t { font-size: 22px; margin: 0; }
  ${P} .lbb-card.is-coll .lbb-s { margin-bottom: 2px; }
  ${P} .lbb-sets { grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 6px; margin: 6px 0 0; }
  ${P} .lbb-set { gap: 2px; padding: 5px 4px 3px; border-radius: 10px; }
  ${P} .lbb-tile { gap: 1px; padding: 2px 2px 3px; }
  ${P} .lbb-tile img, ${P} .lbb-tile .lbb-q { max-width: 46px; }
  ${P} .lbb-tile .lbb-q { font-size: 16px; }
  ${P} .lbb-tile small { font-size: 11px; }
  ${P} .lbb-card.is-coll .lbb-x { margin-top: 2px; }
}
${P} .ffs-tool.lbb-tool { color: #f4d68a; }
${P} .lbb-tool .lbb-ti { position: absolute; inset: 7px; border-radius: 50%; border: 2px solid currentColor; box-shadow: 0 0 6px rgba(244, 214, 138, .4), inset 0 0 4px rgba(244, 214, 138, .3); pointer-events: none; }
${P} .lbb-tool .ffs-tool-t { position: relative; font-size: 11px; }
${P} .lbb-tool.is-hid { visibility: hidden; }
${P} .lbb-tool.is-bump { animation: lbb-bump .7s cubic-bezier(.2, .9, .3, 1.5); }
@keyframes lbb-bump { 0% { transform: scale(1); } 35% { transform: scale(1.35); box-shadow: 0 0 18px rgba(244, 214, 138, .8); } 100% { transform: scale(1); } }
@media (prefers-reduced-motion: reduce) {
  ${P} .lbb-g, ${P} .lbb-gs, ${P} .lbb-rays, ${P} .lbb-tool.is-bump { animation: none; }
  ${P} .lbb-gs { opacity: 1; transform: none; }
  ${P} .lbb-info > * { transition: none; }
}
`;

  /* ---------- small helpers ---------- */
  const rnd = (n) => Math.floor(Math.random() * n);
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const q = (t) => ({ text: '“' + t + '”', cls: 'say' });
  const race = (p, ms, dflt) => Promise.race([Promise.resolve(p).catch(() => dflt), new Promise((res) => setTimeout(() => res(dflt), ms))]);
  const load = () => { try { const v = JSON.parse(localStorage.getItem(STORE) || 'null'); return v && typeof v === 'object' && !Array.isArray(v) ? v : {}; } catch (e) { return {}; } };
  const keep = (st) => { try { localStorage.setItem(STORE, JSON.stringify(st)); } catch (e) { /* this browser only, and only when it can */ } };
  const pngName = (w) => 'FramedFantasy-Token-Border-' + w[1] + '.png';
  const isRect = (r) => !!(r && isFinite(r.left) && isFinite(r.top) && isFinite(r.width) && isFinite(r.height));
  const whoName = (who) => (who && typeof who === 'object' ? String(who.name || '') : String(who || ''));
  /* the hole as percentages of the picture box, a little past the ring's inner edge so the ring overlaps the picture */
  function holeBox(w) {
    const W = w[2], H = w[3], m = Math.min(W, H), R = w[6] * m * 1.04;
    return { left: (w[4] * W - R) / W * 100, top: (w[5] * H - R) / H * 100, width: 2 * R / W * 100, height: 2 * R / H * 100 };
  }

  (FFD.parts = FFD.parts || {})['library/borders'] = function makeBorders(api) {
    api = api || {};
    const F = api.F, h = api.h || FFD.h, SITE = api.SITE || null;
    const none = { note() {}, give: () => Promise.resolve(), has: () => false, hint: () => null, left: () => 0, busy: () => false, close() {} };
    if (!F || !F.el || !F.art || !h) return none;
    const RM = () => { try { return api.RM ? !!api.RM() : !!(FFD.RM && FFD.RM()); } catch (e) { return false; } };
    const alive = () => { try { return !api.alive || api.alive() !== false; } catch (e) { return false; } };
    const snd = (n) => { try { if (api.snd) api.snd(n); } catch (e) { /* a sound never breaks a find */ } };
    const free = () => { try { return !api.free || !!api.free(); } catch (e) { return false; } };
    const sceneOk = () => { try { return !api.sceneOk || !!api.sceneOk(); } catch (e) { return false; } };
    /* the record on the jukebox, and whether it is a calm one (the room without a jukebox is Quiet Alehouse) */
    const rec = () => { try { const r = api.rec ? api.rec() : null; return r ? String(r) : 'quiet'; } catch (e) { return 'quiet'; } };
    const calm = () => { try { return api.calm ? !!api.calm() : CALM.has(rec()); } catch (e) { return true; } };
    /* a find counts in this record: the calm finds on any calm record, every other find on its own record */
    const here = (key) => { const f = FINDS[key]; return !!f && (f.rec === 'home' ? calm() : f.rec === rec()); };
    if (!document.getElementById(CSS_ID)) document.head.append(h('style', { id: CSS_ID, text: CSS }));
    let closed = false;
    const live = () => !closed && alive();

    /* ---- what this reader holds. A set in st.found (any build before the jukebox) brings every colourway of it,
       on every load: idempotent, and never a tally, so nothing is counted twice ---- */
    const st = load();
    const got = new Set((Array.isArray(st.got) ? st.got : []).filter((k) => WAY[k]));
    const save = () => {
      /* a find made in another tab since this one loaded is kept, never written over */
      const cur = load();
      (Array.isArray(cur.got) ? cur.got : []).forEach((k) => { if (WAY[k]) got.add(k); });
      (Array.isArray(cur.found) ? cur.found : []).forEach((k) => { if (SETS[k]) SETS[k].ways.forEach((w) => got.add(slug(k, w[0]))); });
      st.got = KEYS.filter((k) => got.has(k));
      /* the sets held whole, so a cached build from before the jukebox still shows them */
      st.found = ORDER.filter((k) => SETS[k].ways.every((w) => got.has(slug(k, w[0]))));
      keep(st);
    };
    let moved = Array.isArray(st.got) && st.got.length !== got.size;
    (Array.isArray(st.found) ? st.found : []).forEach((k) => {
      if (!SETS[k]) return;
      SETS[k].ways.forEach((w) => { const key = slug(k, w[0]); if (!got.has(key)) { got.add(key); moved = true; } });
    });
    if (moved) save();
    const tally = (k) => { try { if (api.tally) api.tally(k, 1); } catch (e) { /* fine */ } };

    /* ---- the files: the store's Shopify Files, or the demo's own copies ---- */
    const view = (w, px) => (SITE ? CDN + pngName(w) + '?width=' + px : DEMO_IMG + 'FramedFantasy-Token-Border-' + w[1] + '.webp');
    const fullUrl = (w) => (SITE ? CDN + pngName(w) : DEMO_IMG + 'full/' + pngName(w));

    /* ---- timers and listeners: close() stops every one ---- */
    const timers = new Set(), offs = [];
    const later = (fn, ms) => { const t = setTimeout(() => { timers.delete(t); if (live()) fn(); }, Math.max(0, ms || 0)); timers.add(t); return t; };
    const on = (el, type, fn, o) => { el.addEventListener(type, fn, o); offs.push(() => el.removeEventListener(type, fn, o)); };

    /* ================= the sparkles ================= */
    const layer = h('div', { class: 'lbb-layer' });
    F.art.append(layer);
    const glints = {};
    function anchor(key) {
      const W = F.art.clientWidth, H = F.art.clientHeight, at = (FINDS[key] && FINDS[key].at) || [];
      for (const a of at) {
        let r = null;
        try { r = F.spotCss(a[0]); } catch (e) { r = null; }
        if (!r || !W) continue;
        return { id: a[0], x: clamp(r.x + r.w * a[1] + (a[3] || 0), 24, W - 24), y: clamp(r.y + r.h * a[2] + (a[4] || 0), 24, H - 24) };
      }
      return null;
    }
    /* a spot in the art as a rect on the screen (where a giver stands, for the flight) */
    function spotRect(id) {
      try {
        const r = id && F.spotCss(id); if (!r) return null;
        const a = F.art.getBoundingClientRect();
        return { left: a.left + r.x, top: a.top + r.y, width: r.w, height: r.h };
      } catch (e) { return null; }
    }
    function showGlint(key, quiet) {
      if (!live() || glints[key] || got.has(key) || !here(key)) return;
      const pos = anchor(key), s = SETS[WAY[key].k];
      const b = h('button', { type: 'button', class: 'lbb-g', 'aria-label': 'Something sparkling by ' + (PLACE[(pos && pos.id) || FINDS[key].at[0][0]] || 'the shelves'), style: '--c:' + s.c + ';--d:' + (-rnd(2600)) + 'ms' },
        h('i', { class: 'lbb-gs', 'aria-hidden': 'true' }));
      b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); take(key); });
      glints[key] = { el: b, at: pos ? pos.id : null };
      place(key);
      layer.append(b);
      if (!quiet) {
        snd('chime');
        if (pos && FFD.fx && !RM()) { const ar = F.art.getBoundingClientRect(); FFD.fx.sparks(F.art, { x: ar.left + pos.x, y: ar.top + pos.y, n: 10, spread: 34, colors: [s.c, '#fff6dc', '#f4d68a'] }); }
      }
    }
    /* a sparkle keeps to its spot, and hides while its record isn't playing (an earned one comes back with it) */
    function place(key) {
      const g = glints[key]; if (!g) return;
      const pos = here(key) ? anchor(key) : null;
      if (!pos) { g.el.hidden = true; return; }
      g.el.hidden = false; g.at = pos.id;
      const l = Math.round(pos.x) + 'px', t = Math.round(pos.y) + 'px';
      if (g.el.style.left !== l) g.el.style.left = l;
      if (g.el.style.top !== t) g.el.style.top = t;
    }
    function hideGlint(key) {
      const g = glints[key]; if (!g) return;
      delete glints[key];
      g.el.classList.add('is-gone');
      later(() => g.el.remove(), 480);
    }
    /* a single twinkle as a find gets close: earned, never at random */
    function tell(key) {
      if (!live() || RM() || got.has(key) || glints[key] || !here(key)) return;
      const pos = anchor(key); if (!pos) return;
      const t = h('i', { class: 'lbb-tell', 'aria-hidden': 'true', style: 'left:' + pos.x + 'px;top:' + pos.y + 'px;--c:' + SETS[WAY[key].k].c });
      layer.append(t);
      later(() => t.remove(), 1500);
    }

    /* ---- what the room, the curios and the records saw ---- */
    let ledgerN = 0, dark = false;
    function note(what, d) {
      if (!live()) return;
      d = d || {};
      if (what === 'light') { dark = false; if (!got.has('rogue-dusk')) hideGlint('rogue-dusk'); return; }
      /* the two calm records with a find of their own: three catches give it straight away */
      if (what === 'cinders' || what === 'owl-wake') {
        const key = what === 'cinders' ? 'monk-tan-and-brown' : 'druid-wintershade';
        if (!here(key) || (+d.n || 0) !== 3) return;
        give(key, { from: isRect(d.from) ? d.from : spotRect(d.at || (what === 'owl-wake' ? 'owl' : null)) });
        return;
      }
      /* everything else is the calm room's: the road records' rooms don't count toward these */
      if (!calm()) return;
      if (what === 'ledger') { ledgerN++; if (ledgerN === 2) later(() => tell('paladin-emerald'), 500); if (ledgerN >= 3) later(() => showGlint('paladin-emerald'), 700); return; }
      if (what === 'pun') { const n = +d.n || 0; if (n === 3 || n === 4) later(() => tell('necromancer-deathrend'), 700); if (n >= 5) later(() => showGlint('necromancer-deathrend'), 900); return; }
      if (what === 'bubble') { const n = +d.n || 0; if (n === 3) later(() => tell('sorcerer-bloodvein'), 300); if (n === 5) later(() => showGlint('sorcerer-bloodvein'), RM() ? 0 : 1000); return; }
      if (what === 'mimic-gave') { later(() => tell('barbarian-fanghide'), 2600); return; }
      if (what === 'mimic-sulk') { later(() => showGlint('barbarian-fanghide'), RM() ? 0 : 650); return; }
      if (what === 'dark') { dark = true; later(() => { if (dark) showGlint('rogue-dusk'); }, RM() ? 0 : 1300); return; }
      if (what === 'hunt-win') { later(() => showGlint('druid-radiance'), RM() ? 0 : 2200); return; }
      if (what === 'wish') { later(() => showGlint('fighter-goldspire'), RM() ? 0 : 1200); return; }
    }

    /* ---- the clock: keeps the sparkles on their spots, shows the corner tool once the room settles, watches for
       stillness (on a calm record, and under the water of Blackwater) ---- */
    /* stillness counts from the latest of the last touch, the moment the room was last busy (a card, a book, a line) and
       the last change of record */
    let started = false, lastAct = Date.now(), calmAt = Date.now(), lastRec = rec();
    const mark = () => { lastAct = Date.now(); };
    on(window, 'pointerdown', mark, true);
    on(window, 'keydown', mark, true);
    on(window, 'wheel', mark, { passive: true });
    on(window, 'touchmove', mark, { passive: true });
    on(document, 'visibilitychange', () => { if (document.visibilityState === 'visible') mark(); });
    function inView() {
      try { const r = F.el.getBoundingClientRect(), vh = window.innerHeight || 0; return Math.min(r.bottom, vh) - Math.max(r.top, 0) > Math.min(r.height * 0.5, vh * 0.4); } catch (e) { return false; }
    }
    const stillKey = () => (rec() === 'flood' ? 'monk-blue-and-gray' : calm() ? 'monk-black-and-white' : null);
    const tick = setInterval(() => {
      if (!live()) { clearInterval(tick); return; }
      Object.keys(glints).forEach(place);
      if (!sceneOk()) return;
      const r = rec();
      if (r !== lastRec) { lastRec = r; calmAt = Date.now(); }
      const quietNow = free() && !ov && document.visibilityState === 'visible' && inView();
      if (!quietNow) calmAt = Date.now();
      if (!started) {
        if (!quietNow) return;
        started = true;
        if (got.size) ringTool(false);
        return;
      }
      if (!quietNow) return;
      const sk = stillKey();
      if (sk && !got.has(sk) && !glints[sk] && Date.now() - Math.max(lastAct, calmAt) > STILL_MS) showGlint(sk);
    }, 350);
    offs.push(() => clearInterval(tick));

    /* ================= the files ================= */
    let dlCap;
    function downloadsCap() {
      if (dlCap !== undefined) return dlCap;
      const c = window.claude;
      dlCap = c && typeof c.use === 'function' ? race(c.use('downloads'), 3000, null) : Promise.resolve(null);
      return dlCap;
    }
    async function blobOf(url) {
      const r = await fetch(url, { mode: 'cors', credentials: 'omit' });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.blob();
    }
    /* a picture that isn't a PNG (the demo's previews) becomes one */
    async function asPng(blob) {
      if (/png/i.test(blob.type || '')) return blob;
      const bmp = await createImageBitmap(blob);
      const c = document.createElement('canvas'); c.width = bmp.width; c.height = bmp.height;
      c.getContext('2d').drawImage(bmp, 0, 0);
      return new Promise((res, rej) => c.toBlob((b) => (b ? res(b) : rej(new Error('png'))), 'image/png'));
    }
    /* hand a file to the reader: the artifact's downloads (the demo), else a link to the file in memory, so the page
       never goes anywhere. Returns 'saved', 'declined' or 'opened' (the file opened in a new tab as a last resort) */
    async function hand(blob, filename) {
      if (!SITE) {
        const cap = await downloadsCap();
        if (cap && typeof cap.save === 'function') {
          try { await cap.save({ filename, data: blob }); return 'saved'; } catch (e) {
            if (e && (e.code === 'declined' || e.code === 'rate_limited')) return 'declined';
          }
        }
      }
      const u = URL.createObjectURL(blob);
      const a = h('a', { href: u, download: filename, style: 'display:none' });
      document.body.append(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(u), 60000);
      return 'saved';
    }
    /* a button that works for a moment: its label (slot, the whole button by default) says so, then "Saved." */
    async function busyButton(btn, wait, fn, slot, said) {
      slot = slot || btn;
      if (btn.getAttribute('aria-busy') === 'true') return;
      const was = [...slot.childNodes];
      btn.setAttribute('aria-busy', 'true');
      slot.replaceChildren(document.createTextNode(wait));
      let res = 'failed';
      try { res = await fn(); } catch (e) { console.error(e); res = 'failed'; }
      if (!btn.isConnected) return;
      btn.removeAttribute('aria-busy');
      if (res === 'saved') {
        snd('gold');
        tally('border-dl');
        try { if (FFD.fx && !RM()) FFD.fx.sparks(btn, { n: 12, spread: 60 }); } catch (e) { /* fine */ }
        slot.replaceChildren(document.createTextNode('Saved.'));
        if (said) said();
        later(() => { if (slot.isConnected) slot.replaceChildren(...was); }, 2600);
      } else slot.replaceChildren(...was);
    }
    async function getOne(w, btn, slot, said) {
      await busyButton(btn, 'Saving', async () => {
        try { return await hand(await asPng(await blobOf(fullUrl(w))), pngName(w)); } catch (e) {
          if (SITE) { window.open(fullUrl(w), '_blank', 'noopener'); return 'opened'; }
          throw e;
        }
      }, slot, said);
    }

    /* ---- a hero of the set's class for inside the border (Jan's picks first, never the same hero twice a visit) ---- */
    const heroOf = {}, usedHeroes = new Set();
    const zhImg = () => (api.ZH && api.ZH.img) || (SITE && SITE.portraits && SITE.portraits.zhaunil) || 'img/heroes/zhaunil.jpg';
    async function heroFor(k) {
      if (heroOf[k]) return heroOf[k];
      let pick = null;
      try {
        const cards = api.cards;
        if (cards && typeof cards.all === 'function' && typeof cards.portrait === 'function') {
          if (typeof cards.ready === 'function') await race(cards.ready(), 1800, false);
          const all = (cards.all() || []).filter((c) => c && c.cls && CLS[k].test(String(c.cls)) && !usedHeroes.has(c.slug || c.id) && cards.portrait(c));
          const picks = all.filter((c) => c.pick), pool = picks.length ? picks : all;
          if (pool.length) { const c = pool[rnd(pool.length)]; usedHeroes.add(c.slug || c.id); pick = { src: cards.portrait(c), name: c.name || '' }; }
        }
      } catch (e) { pick = null; }
      return (heroOf[k] = pick || { src: zhImg(), name: 'Zhaunil' });
    }

    /* ================= the card ================= */
    let ov = null, ovInfo = null, lastFocus = null, tool = null;
    function shell(cls) {
      const card = h('div', { class: 'lbb-card' + (cls ? ' ' + cls : '') });
      const box = h('div', { class: 'lbb-ov', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'lbb-t' }, h('i', { class: 'lbb-rays', 'aria-hidden': 'true' }), card);
      box.addEventListener('click', (e) => { e.stopPropagation(); if (e.target === box) closeCard(); });
      box.addEventListener('pointerdown', (e) => e.stopPropagation());
      return { box, card };
    }
    let resizeOn = false;
    function openBox(box) {
      try { if (api.intoView) api.intoView(); } catch (e) { /* fine */ }
      if (!resizeOn) { resizeOn = true; on(window, 'resize', () => { if (ov && ovInfo && ovInfo.T) { sizeCard(ov); aimRays(ov, ovInfo.T.tok); } }); }
      lastFocus = document.activeElement;
      F.el.append(box);
      ov = box;
      /* the room's box steps back while a card or the collection is up, so a line still being said never shows through */
      F.el.classList.add('lbb-up');
      on(document, 'keydown', onKey, true);
      requestAnimationFrame(() => { if (ov === box) box.classList.add('is-in'); });
    }
    function onKey(e) {
      if (!ov) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeCard(); return; }
      if (e.key !== 'Tab') return;
      const f = [...ov.querySelectorAll('button, input, [href]')].filter((x) => !x.disabled && x.offsetParent !== null);
      if (!f.length) return;
      const i = f.indexOf(document.activeElement);
      if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    }
    const stagger = (col) => [...col.children].forEach((c, i) => c.style.setProperty('--i', String(i)));
    /* the card's size from the room's own: a wide short frame puts the border left of the words, so nothing scrolls */
    function sizeCard(box) {
      const ow = box.clientWidth, oh = box.clientHeight, wide = ow >= 640 && ow > oh * 1.15;
      box.classList.toggle('is-wide', wide);
      box.style.setProperty('--ts', Math.round(wide ? Math.min(400, oh * 0.8, ow * 0.4) : Math.min(300, ow * 0.68, oh * 0.42)) + 'px');
    }
    function aimRays(box, tok) {
      try {
        const b = box.getBoundingClientRect(), r = tok.getBoundingClientRect();
        box.style.setProperty('--rx', ((r.left + r.width / 2 - b.left) / Math.max(1, b.width) * 100).toFixed(1) + '%');
        box.style.setProperty('--ry', ((r.top + r.height / 2 - b.top) / Math.max(1, b.height) * 100).toFixed(1) + '%');
      } catch (e) { /* the rays stay where they were */ }
    }

    /* the border at size, with a face in its hole */
    function token(s, w) {
      const ring = h('img', { class: 'lbb-ring', alt: s.label + ' token border, ' + w[0] + ', drawn by Jan', src: view(w, 640), decoding: 'async' });
      const faceImg = h('img', { alt: '', decoding: 'async' });
      const face = h('div', { class: 'lbb-face' }, faceImg);
      const tok = h('div', { class: 'lbb-token', style: '--ar:' + (w[2] / w[3]).toFixed(4) }, face, ring);
      const flash = h('i', { class: 'lbb-flash', 'aria-hidden': 'true' });
      const stage = h('div', { class: 'lbb-stage' }, tok, flash);
      const b = holeBox(w);
      face.style.cssText = 'left:' + b.left + '%;top:' + b.top + '%;width:' + b.width + '%;height:' + b.height + '%';
      return { stage, tok, ring, face, faceImg, flash };
    }

    /* one border's card: fresh (one button, it flies into the collection) or already owned (a quiet way back).
       Resolves when the card closes, or at once when it can't open */
    function openCard(key, o) {
      o = o || {};
      return new Promise((done) => {
        if (ov || !live() || !WAY[key]) { done(); return; }
        const { k, w } = WAY[key], s = SETS[k], f = FINDS[key];
        const fresh = !!o.fresh;
        const { box, card } = shell(fresh && !RM() ? 'is-pre' : '');
        const T = token(s, w);
        const who = whoName(o.who) || f.who, line = String(o.line || f.line || '');
        const btn = fresh
          ? h('button', { type: 'button', class: 'lbb-b is-main', text: 'Add to my collection' })
          : h('button', { type: 'button', class: 'lbb-x', text: 'Back to the library' });
        btn.addEventListener('click', (e) => { e.stopPropagation(); closeCard(); });
        const info = h('div', { class: 'lbb-info' },
          h('p', { class: 'lbb-k', text: 'Token border · ' + got.size + ' of ' + TOTAL }),
          h('h2', { class: 'lbb-t', id: 'lbb-t', text: w[0] }),
          h('p', { class: 'lbb-s', text: s.label + ' set' }),
          line ? h('p', { class: 'lbb-l', text: line }) : null,
          who ? h('p', { class: 'lbb-who', text: who }) : null,
          fresh ? h('div', { class: 'lbb-btns' }, btn) : h('p', { class: 'lbb-s', text: 'Already in your collection.' }),
          fresh ? null : btn);
        card.append(T.stage, info);
        stagger(info);
        ovInfo = { key, fresh, T, done, src: o.src || 'take' };
        openBox(box);
        sizeCard(box);
        if (fresh) snd('whoosh');
        /* the face: a hero of this class from the Hall */
        heroFor(k).then((hero) => {
          if (!T.faceImg.isConnected) return;
          T.faceImg.onerror = () => { if (T.faceImg.src.indexOf(zhImg()) < 0) { T.faceImg.src = zhImg(); T.faceImg.alt = 'Shown with Zhaunil from the Hall of Heroes'; } };
          T.faceImg.src = hero.src;
          T.faceImg.alt = hero.name ? 'Shown with ' + hero.name + ' from the Hall of Heroes' : 'Shown with a hero from the Hall of Heroes';
          T.face.classList.add('is-on');
        });
        const focusBtn = () => later(() => { if (ov === box) btn.focus({ preventScroll: true }); }, RM() ? 0 : 500);
        /* the flight: from the sparkle (or the giver) to the middle of the card, then the light */
        if (fresh && !RM() && isRect(o.from) && typeof T.tok.animate === 'function') {
          requestAnimationFrame(async () => {
            if (ov !== box) return;
            const to = T.tok.getBoundingClientRect();
            const fx = o.from.left + o.from.width / 2 - (to.left + to.width / 2), fy = o.from.top + o.from.height / 2 - (to.top + to.height / 2);
            aimRays(box, T.tok);
            const fly = T.tok.animate([
              { transform: 'translate(' + fx + 'px,' + fy + 'px) scale(.08) rotate(-220deg)', opacity: 0 },
              { transform: 'translate(' + fx * 0.6 + 'px,' + (fy * 0.6 - 60) + 'px) scale(.35) rotate(-120deg)', opacity: 1, offset: 0.35 },
              { transform: 'translate(0, 0) scale(1.06) rotate(6deg)', opacity: 1, offset: 0.82 },
              { transform: 'none', opacity: 1 }
            ], { duration: 1050, easing: 'cubic-bezier(.3, .7, .25, 1)' });
            later(() => snd('chime'), 380);
            await fly.finished.catch(() => {});
            if (ov !== box) return;
            landed(box, card, T, s);
            focusBtn();
          });
        } else {
          aimRays(box, T.tok);
          if (fresh) landed(box, card, T, s);
          else { box.classList.add('is-lit'); card.classList.remove('is-pre'); }
          focusBtn();
        }
      });
    }
    function landed(box, card, T, s) {
      snd('crit');
      box.classList.add('is-lit');
      try { FFD.fx.flash('rgba(244, 214, 138, .3)', box); } catch (e) { /* fine */ }
      if (!RM()) {
        T.flash.animate([{ transform: 'scale(.6)', opacity: 1 }, { transform: 'scale(1.5)', opacity: 0 }], { duration: 700, easing: 'cubic-bezier(.2, .7, .3, 1)' });
        try {
          const r = T.tok.getBoundingClientRect();
          FFD.fx.sparks(T.tok, { n: 30, spread: Math.max(120, r.width * 0.75), colors: [s.c, '#fff6dc', '#f4d68a', '#e8c674'] });
          later(() => FFD.fx.sparks(T.tok, { n: 16, spread: r.width * 0.55 }), 260);
        } catch (e) { /* fine */ }
        try { if (FFD.buzz) FFD.buzz([18, 40, 18]); } catch (e) { /* fine */ }
      }
      card.classList.remove('is-pre');
      later(() => snd('pop'), RM() ? 0 : 1050);
    }

    /* any way out of a fresh card (the button, Esc, the backdrop) flies the border into the collection */
    function closeCard(quiet) {
      if (!ov) return;
      const box = ov, info = ovInfo;
      ov = null; ovInfo = null;
      F.el.classList.remove('lbb-up');
      document.removeEventListener('keydown', onKey, true);
      if (info && info.fresh && !quiet) flyHome(info);
      box.classList.remove('is-in'); box.classList.add('is-out');
      setTimeout(() => box.remove(), RM() ? 0 : 240);
      try { if (!quiet && lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true }); } catch (e) { /* fine */ }
      if (info && info.fresh && !quiet) later(() => afterFind(info), RM() ? 100 : 900);
      if (info && info.done) info.done();
    }

    /* ---- the collection in the corner: every border found, each one to download ---- */
    function ringTool(hidden) {
      if (tool || typeof F.tool !== 'function') { if (tool) updTool(); return tool; }
      tool = F.tool({ label: 'Your token borders', cls: 'lbb-tool' + (hidden ? ' is-hid' : ''), html: '<i class="lbb-ti" aria-hidden="true"></i>', text: String(got.size), onClick: () => openCollection() });
      updTool();
      return tool;
    }
    function updTool() {
      if (!tool) return;
      const t = tool.querySelector('.ffs-tool-t'); if (t) t.textContent = String(got.size);
      const lab = 'Your token borders, ' + got.size + ' of ' + TOTAL + ' found';
      tool.setAttribute('aria-label', lab); tool.title = lab;
    }
    /* the border flies from the card into the corner */
    function flyHome(info) {
      const first = !tool;
      ringTool(first);
      if (!tool) return;
      const bump = () => { if (!tool) return; tool.classList.remove('is-hid'); updTool(); tool.classList.remove('is-bump'); void tool.offsetWidth; tool.classList.add('is-bump'); snd('pop'); try { if (FFD.fx) FFD.fx.sparks(tool, { n: 10, spread: 40 }); } catch (e) { /* fine */ } };
      const a = info.T.tok.getBoundingClientRect(), b = tool.getBoundingClientRect();
      if (RM() || !a.width || !b.width) { bump(); return; }
      const img = h('img', { src: info.T.ring.src, alt: '', 'aria-hidden': 'true', style: 'position:fixed;z-index:2147483000;pointer-events:none;left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;object-fit:contain;filter:drop-shadow(0 0 10px rgba(244,214,138,.6))' });
      document.body.append(img);
      const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2), sc = b.width / a.width;
      const an = img.animate([{ transform: 'none', opacity: 1 }, { transform: 'translate(' + dx * 0.4 + 'px,' + (dy * 0.4 - 40) + 'px) scale(' + (0.5 + sc * 0.5) + ') rotate(90deg)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sc + ') rotate(220deg)', opacity: 0.2 }], { duration: 760, easing: 'cubic-bezier(.45, .05, .35, 1)' });
      let done = false;
      const fin = () => { if (done) return; done = true; img.remove(); bump(); };
      an.onfinish = fin; an.oncancel = fin;
      setTimeout(fin, 1100);
    }
    /* Zhaunil's word after a find: every sparkle find, and for a guest's gift only the first and the last two (the
       guest's own flow does the talking) */
    let moreI = rnd(L.more.length);
    async function afterFind(info) {
      if (!live() || !api.talk) return;
      const n = got.size;
      if (n >= TOTAL) { await celebrate(); return; }
      let lines;
      if (n === 1) lines = L.first;
      else if (n === TOTAL - 1) lines = [L.last];
      else if (info.src === 'give') return;
      else { moreI = (moreI + 1) % L.more.length; lines = [L.more[moreI].replace('{n}', COUNT[n])]; }
      try { await api.talk(lines.map(q)); } catch (e) { /* the find stands */ }
    }
    async function celebrate() {
      snd('applause');
      try {
        if (FFD.fx) {
          FFD.fx.flash('rgba(244, 214, 138, .34)', F.el);
          const ar = F.el.getBoundingClientRect();
          if (!RM()) for (let i = 0; i < 6; i++) later(() => FFD.fx.sparks(F.el, { x: ar.left + ar.width * (0.15 + Math.random() * 0.7), y: ar.top + ar.height * (0.15 + Math.random() * 0.5), n: 22, spread: 110 }), i * 220);
        }
      } catch (e) { /* fine */ }
      try { await api.talk(L.all.map(q)); } catch (e) { /* fine */ }
      if (!live()) return;
      try { if (F.beacon && F.spotCss('easel')) { F.beacon(['easel'], true); later(() => F.beacon(['easel'], false), 7000); } } catch (e) { /* fine */ }
    }

    function openCollection() {
      if (ov || !live()) return;
      snd('flip');
      const { box, card } = shell('is-coll');
      const n = got.size;
      const sr = h('p', { class: 'lbb-sr', 'aria-live': 'polite' });
      let shared = '';
      /* a count across readers only once totals come from every player (FFD.tally.shared); until then this browser's
         own count is all there is, and the collection says nothing about others */
      try { const t = api.total && FFD.tally && FFD.tally.shared ? +api.total('borders') || 0 : 0; if (t > n) shared = ' Readers have found ' + t.toLocaleString('en-US') + ' borders so far.'; } catch (e) { /* fine */ }
      const sets = ORDER.map((k) => {
        const s = SETS[k];
        const tiles = s.ways.map((w) => {
          const key = slug(k, w[0]);
          if (!got.has(key)) return h('li', null, h('span', { class: 'lbb-tile is-q', role: 'img', 'aria-label': 'Not found yet' }, h('span', { class: 'lbb-q', 'aria-hidden': 'true', text: '?' })));
          const lab = h('small', { text: 'Download' });
          const b = h('button', { type: 'button', class: 'lbb-tile', 'data-key': key },
            h('img', { src: view(w, 160), alt: '', decoding: 'async', loading: 'lazy' }), h('span', { text: w[0] }), lab);
          b.addEventListener('click', (e) => { e.stopPropagation(); snd('tap'); getOne(w, b, lab, () => { sr.textContent = s.label + ', ' + w[0] + ' saved.'; }); });
          return h('li', null, b);
        });
        return h('li', { class: 'lbb-set' }, h('b', { text: s.label }), h('ul', { class: 'lbb-tiles', 'aria-label': s.label + ' set' }, tiles));
      });
      const back = h('button', { type: 'button', class: 'lbb-x', text: 'Back to the library' });
      back.addEventListener('click', (e) => { e.stopPropagation(); closeCard(); });
      card.append(
        h('p', { class: 'lbb-k', text: 'Your token borders' }),
        h('h2', { class: 'lbb-t', id: 'lbb-t', text: n + ' of ' + TOTAL + ' found' }),
        h('p', { class: 'lbb-s', text: (n >= TOTAL ? 'All twenty-three found. Every one is yours to keep.' : 'Drawn by Jan, free to use at your table. Tap one to download it.') + shared }),
        h('ul', { class: 'lbb-sets' }, sets),
        sr, back);
      ovInfo = { key: null, fresh: false };
      openBox(box);
      box.style.setProperty('--ry', '2%');
      box.classList.add('is-lit');
      later(() => { if (ov === box) { const f = card.querySelector('button.lbb-tile') || back; f.focus({ preventScroll: true }); } }, RM() ? 0 : 200);
    }

    /* ================= the find ================= */
    /* fresh: into the collection (+1 'borders') before the card opens, so a closed tab never loses it */
    function reveal(key, o) {
      const fresh = !got.has(key);
      if (fresh) { got.add(key); save(); tally('borders'); }
      if (glints[key]) hideGlint(key);
      if (ov || !live()) { if (fresh) { ringTool(false); updTool(); } return Promise.resolve(); }
      return openCard(key, Object.assign({}, o, { fresh }));
    }
    /* a sparkle tapped */
    function take(key) {
      if (ov || !live()) return;
      /* whoever is speaking in the room gives way first (their words fade), when they can */
      try { if (api.yield) api.yield(); } catch (e) { /* the card still opens */ }
      const g = glints[key];
      const from = g ? g.el.getBoundingClientRect() : null;
      if (g) { delete glints[key]; g.el.remove(); }
      if (from && FFD.fx && !RM()) FFD.fx.sparks(F.art, { x: from.left + from.width / 2, y: from.top + from.height / 2, n: 22, spread: 80, colors: [SETS[WAY[key].k].c, '#fff6dc', '#f4d68a'] });
      if (g && g.at) { try { F.act('hot', g.at); } catch (e) { /* fine */ } }
      reveal(key, { from, src: 'take' });
    }
    /* a guest hands one over: it waits for a card already open, never makes the room give way (the guest's flow is
       the one speaking), and resolves when its card closes */
    let queue = Promise.resolve();
    function give(key, o) {
      if (!WAY[key] || !live()) return Promise.resolve();
      o = o || {};
      const run = queue.then(async () => {
        while (ov && live()) await new Promise((r) => setTimeout(r, 150));
        if (!live()) return;
        await reveal(key, { from: isRect(o.from) ? o.from : null, line: o.line, who: o.who, src: 'give' });
      });
      queue = run.catch(() => {});
      return run.then(() => {}, () => {});
    }

    /* ---- Zhaunil's answer to "Is anything hidden in here?": one riddle at a time for a border this record holds
       (plainer the second time round), or the jukebox when this record has nothing left ---- */
    function hint() {
      const left = KEYS.filter((k) => !got.has(k));
      if (!left.length) return null;
      const now = left.filter(here);
      const up = now.find((k) => glints[k] && glints[k].at && !glints[k].el.hidden);
      if (up) return [L.hintUp.replace('{place}', PLACE[glints[up].at] || 'the shelves')];
      if (!now.length) return [L.elsewhere];
      const i = (Number.isInteger(st.hi) ? st.hi : -1) + 1;
      const key = now[i % now.length];
      st.hi = i % 64;
      if (!st.told || typeof st.told !== 'object' || Array.isArray(st.told)) st.told = {};
      const before = +st.told[key] || 0;
      st.told[key] = Math.min(9, before + 1);
      save();
      const f = FINDS[key];
      if (before) return [f.riddle, L.plainer + ' ' + f.plain];
      return [got.size ? L.hintMore.replace('{n}', COUNT[got.size]) : L.hintFirst, f.riddle];
    }

    const borders = {
      note,
      give,
      has: (key) => got.has(key),
      hint,
      left: () => TOTAL - got.size,
      busy: () => !!ov,
      close() {
        if (closed) return;
        closed = true;
        timers.forEach((t) => clearTimeout(t)); timers.clear();
        offs.splice(0).forEach((off) => { try { off(); } catch (e) { /* fine */ } });
        const info = ovInfo;
        if (ov) { ov.remove(); ov = null; ovInfo = null; }
        F.el.classList.remove('lbb-up');
        if (info && info.done) info.done();
        layer.remove();
        try { delete F.el.__lbBorders; } catch (e) { /* fine */ }
      }
    };
    /* for the review harness (the page never reads it): the same note/give/has/hint, and what this reader holds */
    try { Object.defineProperty(F.el, '__lbBorders', { configurable: true, value: { note, give, has: borders.has, hint, left: borders.left, got: () => KEYS.filter((k) => got.has(k)), keys: () => KEYS.slice(), open: openCollection, rec, calm } }); } catch (e) { /* fine */ }
    return borders;
  };
})();

/* ===== src/scene-pages/pages/library/cards.js ===== */
/* library/cards.js: the Hall cards and the reader’s collection in Zhaunil’s library. A part of pages/library.js (both
   builds put it in front of that file); the spec is docs/scene-pages/demo2/research/LIBRARY-V2-SPEC.md, sections 5 and 6
   and “The Hall cards (cards.js)”.
   Jan (2026-10-05): “make the card a bit smaller and make sure its just like the demo in the actual hall so it can flip
   and has the same formatting ... have another character actually walk in ... show you their card, and have you add it
   to your collection”.

   THE CARD is the Hall’s own, drawn the way the hero page’s card view draws it (assets/hoh-hero-page.js ensureCardKit
   and drawCard): hoh-shop.js writes it (hohShopCardHtml, the brand back, public-hall, no hearts, the stored tier and
   the collector number), wires it (hohShopWireCard: the Hall’s turn and text fitters) and leans it (hohCardLean, with
   the warm mote). window.__hohShopCardOnly keeps hoh-shop.js to drawing. A stand-in window.hohGetAllCharacters hands
   it the Hall’s rows, so the collector number reads as in the Hall.
   THE FRAMING (Jan, 2026-10-07: “make sure the card collection updates the reframe from the main hall as well”). Every
   face this file draws (the card view, a pocket, a pocket’s picture before the kit comes, the pack’s faces, the copy that
   flies to the binder) wears the Hall’s reframe by the Hall’s own rule (hoh-section-core.js hohGetImageOffsetX and Y,
   hohGetImageZoom and hohImgStyle, which hoh-shop.js asks for on the Hall’s own cards): this device’s own map first
   (localStorage hoh-img-offsets-v1, which the Hall writes when someone reframes here), then the Hall row’s
   image_offset_x, image_offset_y and image_zoom, each only when it is a number in range, else the middle at 100. The rows are the live Hall’s, asked once a page view; no framing is ever
   kept by this page. A pocket draws the stored thumb, which the Hall makes as a plain resize of the same picture, so
   the same numbers land on the same spot; the card view puts the full picture in behind it, as the Hall card does.
     - The kit is about 1 MB before compression, so it loads only once a card is wanted (next, find, show, or the album
       with cards in it): on the store FFD_SITE.shop.js and .css, in the demo js/vendor/hoh-shop.js and
       css/hoh-shop.css (byte copies of the theme’s assets).
     - Rows carry only HALL_SELECT’s public columns. No card prints a player except Ember’s: her card is Jan’s own,
       and the product page prints JAN on it.
     - A row with no written legend gets the Hall’s neutral line, so hohShopWireCard never asks the card-text Worker
       to write one from this page.
     - The Hall turns no card on a touch screen (R578). Here a tap on a phone runs the Hall’s own turn
       (ffshopInspTurn), the move every card makes as it arrives.
   THE DAILY PACK (Jan, 2026-10-07: “when someone clicks on the deck” it opens a pack of three, “after that it can still
   pull random cards but they cant keep it and it will pull 1 at a time like normal”, the first button says “open a
   pack”, “a timer once they open it to opens tomorrows pack”, and “give mythic cards ... more rarely”). The first tap on
   the deck each day opens today’s pack: up to three different heroes from Jan’s portraits, heroes the reader doesn’t
   hold first, each hero weighted by its tier (PACK_W) so a lone hero in a tier stays rare, at most one Mythic, lowest
   tier first. All three go in the binder and the day is marked BEFORE the pack’s screen
   opens (library/pack.js; without it the three show one after another). After that the deck deals single cards to look
   at, never kept: one button, Draw another, and under it the time until tomorrow’s pack, ticking. The walker’s card is
   a gift and is kept; the mimic’s is look only. The day is the reader’s own calendar day; a clock set back never hands
   the pack back (rollDay).
   THE DEAL to look at: Jan’s picks first, shuffled, then the rest; a hero the reader already holds comes after every
   hero still missing; no card twice in a visit until the deck runs out. Never ford or allagis. Each dealt card (a pack’s
   three too) counts in the shared tally (page library, key cards).
   THE COLLECTION, for a reader who isn’t signed in to the Hall, lives in this browser only: localStorage
   ffd-library-binder (Jan’s portraits, Hall slugs) and the yost list below. Nothing is sent. A reader signed in to the
   Hall has the account’s binder instead (BINDER-04, “the Hall binder” below). ONE BINDER (Jan, 2026-10-07: “all the cards should all stay in the binder not have from
   yost and hall cards, and let the user drag and rearrange them”): the album shows every card held, Jan’s and Yost’s,
   in one grid (a Books tab beside it). The reader’s own order is localStorage ffd-library-order, slugs of both kinds;
   a card got since goes on the end (noteGot), and a held card missing from it goes after it in the order it was got.
   Moving a card: a mouse drags it; a finger holds it about 300 ms, then drags (a quick swipe still turns the page); the
   other cards make room, holding it at the spread’s outer edge for 0.6 s turns the page, Escape or a drop off the
   binder puts it back; Shift and an arrow key moves the focused card. Old Yost’s trade mode never drags.
   OLD YOST (the Tinker record): a cart of players’ own heroes from the Hall, never Jan’s. Only approved, unhidden heroes
   that are not FramedFantasy portraits, stored at epic or above (a mythic would read as legendary), never ford, allagis
   or Ember, never one this reader holds. The first pack in a browser is free. After that one of Jan’s portraits from
   the binder buys a pack of three (Ember stays: “Not that one. She’d come looking for it.”, and a Mythic or one of
   Jan’s picks asks once more). Slots one and two are epic while the cart has one, the third legendary while it has
   one, best last. Nothing is written until the pack tears. A Yost card is drawn as the Hall draws a player’s card: no
   FramedFantasy mark, no owner’s name, no collector number, the Hall’s own story-echo guard (each pack asks the Hall
   for its three heroes’ stories, held in memory only and never shown). The cart is never counted in the shared tally.
     localStorage ffd-library-cards (its own key; ffd-library is the room’s and keeps only its own fields):
       { v: 1, day: 'YYYY-MM-DD' (the reader’s own date), pack: the day today’s pack was opened ('' before the first),
         seen: the latest clock reading, yost: [slugs, oldest first], gift: 1 once Yost’s free pack is open,
         log: [[ms, the FF slug given or '', [slugs got], 1 once the binder lost the given card]] (last 40; a pack cut off
         between its two writes is put right on the next load), echo: [slugs whose legend the Hall hides] }

   The room calls makeCards(api) once in render, after the frame exists:
     ready() -> Promise<boolean>        the deck loaded (false: no deck). The kit waits for the first card.
     next() -> Promise<card|null>       the next card in the deal
     find(slug) -> Promise<card|null>   one hero (Ember, a walker): the Hall slug, or the demo’s own id
     portrait(card) -> url | null       a square picture for the box
     line(card) -> string               the card’s quote, else its epithet, else '' (plain, no quote marks; a line that
                                        breaks the copy rules is passed over)
     story(card) -> string              one or two sentences of the legend, cut at a sentence end ('' when none)
     show(card, o) -> Promise<'again' | 'library'>   one card over the dimmed room, one button under it. Look only
                                        unless o.free.
        o.from DOMRect (or { left, top, width, height }, or the room’s { cx, cy, w, h }) where the card comes from;
        o.label (default “A card from the Hall of Heroes”); o.by a line under it;
        o.draw a deck draw: Draw another ('again'), and the time to tomorrow’s pack under it (o.again false: no button
        but Back to the library); o.free a gift, kept as it opens (its line says so); o.cont the next draw after Draw
        another: nothing opens if the reader closed the waiting dim meanwhile. After 'again' the dim stays up to 2.6 s
        for the next show(), so a redraw never flashes the room.
     openPack({ from, cont }) -> Promise<'opened' | 'empty' | 'cancelled'>   today’s pack (see THE DAILY PACK), resolved
                                        once its screen is gone. 'empty': no deck, nothing shown. 'cancelled': o.cont
                                        and the reader closed the waiting dim, or today’s pack was opened in another tab
     today() -> { pack, nextAt }        pack: true while today’s pack waits; nextAt: ms of the moment the next one comes
                                        (the next local midnight)
     binder() -> Promise<void>          the album: one grid of every card held, and the books read
     has(slug)  count() (Jan’s portraits held)  countAll() (and Yost’s)  total()  all() -> card[]  close()
     busy() -> boolean                  a card, the album, the daily pack or Yost’s pack is up
     yost.load() -> Promise<number>     fetch the cart (once, when the Tinker record starts; it also warms the card kit):
                                        how many heroes the cart can still deal this reader (0 when it can’t load)
     yost.freeLeft() -> boolean         the free pack is still unopened in this browser
     yost.open({ free: true, from }) -> Promise<'opened' | 'empty' | 'cancelled'>   the free pack; 'empty' (nothing
                                        shown) when the cart has nobody left, 'cancelled' when the reader stepped back
                                        before the tear or the free pack is gone. open({ free: false }) is trade()
     yost.trade({ from }) -> Promise<'opened' | 'none' | 'spare' | 'empty' | 'cancelled'>   the album in trade mode, then
                                        the pack: 'none' (nothing shown) with no portrait to trade, 'spare' the same for a
                                        signed-in reader with no portrait held twice (BINDER-04), 'empty' (nothing shown)
                                        when the cart has nobody left. o.from is optional: where the pack comes from.
                                        Both resolve once the reader is back in the room (after a pack they may trade
                                        again or open their collection first).
   A card: { slug (the Hall slug), name, race, cls, campaign, img, thumb, hasThumb, tier, title, epithet, legend,
   quote, pick, id }; the demo’s cards also carry demo (the demo’s own id); Yost’s carry ff: false, yost: true, edited.
   The room gives: h, esc, RM(), WIDE(), alive(), F, snd(name), SITE, booksRead(), openBook(b), added(card | null) (the
   collection changed: a gift, today’s pack, or a Yost pack that took a portrait and gave three), and may
   give cover(b, w) -> Promise<url|null> for the album’s book covers (the store’s covers work without it),
   trophies() -> { feathers } for the gold feathers the feather hunt put in the binder (shown in the album’s head) and
   zh { name, img } for Zhaunil’s portrait on the pack’s screen.
   The daily pack’s screen is FFD.parts['library/pack'] (library/pack.js, its own head has the contract): this file
   calls open(cards, { from, title, sub, button, back, done }) and hands it F, h, RM, snd, buzz, zh, face(card, el)
   (the card’s Hall face drawn into el, scaled by el’s own width or the overlay’s --lbc-k), zoom(card) (the card view,
   look only, over the pack; a Promise that settles when it closes) and mythicLine(card) (Zhaunil, on a Mythic). */
(() => {
  'use strict';
  const FFD = window.FFD = window.FFD || {};

  /* ---------------- the deck’s rules and the Hall’s public columns ---------------- */
  const DENY = ['ford', 'allagis'];
  const GENERIC_LEGEND = 'A brave hero of the Hall.';
  const TIERS = ['common', 'uncommon', 'rare', 'epic', 'legendary', 'mythic'];
  /* the Hall card view’s breathing glow per tier (hoh-hero-page.js CV_GLOW): size, low point, period */
  const GLOW = { common: ['11px', '.42', '5.2s'], uncommon: ['13px', '.44', '4.8s'], rare: ['16px', '.46', '4.4s'], epic: ['19px', '.48', '4.0s'], legendary: ['22px', '.50', '3.6s'], mythic: ['26px', '.52', '3.2s'] };
  const EMBER_ID = 'c844a24c-8972-430c-b55d-445e9721f35d';
  const LABEL = 'A card from the Hall of Heroes';
  const COLS = 'id,slug,name,race,character_class,campaign,image_url,image_thumb_url,image_offset_x,image_offset_y,image_zoom,created_at,' +
    'title:card_meta->>title,epithet:card_meta->>epithet,legend:card_meta->>legend,quote:card_meta->>quote,order:card_meta->order,' +
    'jan_featured:quest_meta->jan_featured,hero_rarity(tier)';
  const HALL_SELECT = 'select=' + COLS + '&approved=eq.true&or=(is_hidden.is.null,is_hidden.eq.false)&image_url=not.is.null&is_ff_portrait=eq.true' +
    '&slug=not.in.(ford,allagis)&order=created_at.desc&limit=400';
  /* the collector number counts every FramedFantasy portrait the Hall shows, oldest first: the hero page’s own query
     (ids and dates only) */
  const POOL_SELECT = 'select=id,created_at&approved=eq.true&or=(is_hidden.is.null,is_hidden.eq.false)&is_ff_portrait=eq.true&order=created_at.asc&limit=2000';
  /* Old Yost’s cart: players’ own heroes, public columns only (no quote, no pick, no owner, no artwork_cover). The
     rarity join is inner, so a hero with no stored rarity is left out; a join that fails gives no cart at all, never
     every player’s hero (the deck’s PGRST200 retry is not copied here). is_ff_portrait comes back to be checked again */
  const YOST_COLS = 'id,slug,name,race,character_class,campaign,image_url,image_thumb_url,image_offset_x,image_offset_y,image_zoom,created_at,is_ff_portrait,' +
    'title:card_meta->>title,epithet:card_meta->>epithet,legend:card_meta->>legend,edited:card_meta->edited,hero_rarity!inner(tier)';
  const YOST_SELECT = 'select=' + YOST_COLS +
    '&approved=eq.true&or=(is_hidden.is.null,is_hidden.eq.false)&image_url=not.is.null&is_ff_portrait=eq.false&slug=not.in.(ford,allagis)' +
    '&hero_rarity.tier=in.(epic,legendary,mythic)&order=created_at.desc&limit=400';
  const YOST_TIERS = ['epic', 'legendary'];
  /* today’s pack: three heroes, each tier this likely (renormalised over the tiers that still have a hero to give),
     never more than one Mythic */
  const PACK_N = 3;
  const PACK_W = { common: 30, uncommon: 26, rare: 22, epic: 13, legendary: 7, mythic: 2 };
  /* Zhaunil, when a Mythic turns over in today’s pack */
  const MYTHIC = [
    'Jan doesn’t paint many of those. Keep it somewhere safe.',
    'A Mythic. I’ve dealt this deck for years and seen a handful.',
    'Put that one at the front of your binder. Jan paints very few like it.',
    'Soryndel has been eyeing that one since it left the deck.',
    'Keep that one away from the mimic. It has taste.'
  ];
  const BK = 'ffd-library-binder', CK = 'ffd-library-cards', OK = 'ffd-library-order';
  /* the Hall’s own framing map on this device (hoh-section-core.js HOH_IMG_OFFSETS_KEY), read, never written */
  const HALL_OFF = 'hoh-img-offsets-v1';
  const BANNED = /\b(legendary|epic|masterpiece|unleash\w*|elevat\w*|leverag\w*|unlock\w*|transform\w*|seamless\w*|journey\w*|curat\w*|vibrant|boon|embark\w*|muster\w*|spoils)\b/i;
  const EMOJI = /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/u;
  const ICON_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14.5 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ICON_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9.5 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  /* a small gold quill in pixels for the album's head, beside the gold feathers the hunt put in the binder */
  const QUILL = (() => {
    const rows = ['.....g.', '....glg', '...glg.', '..glg..', '.glgg..', '.gdg...', '..d....', '.d.....', 'd......'], col = { g: '#d9b25c', l: '#fff2c2', d: '#8a6a1f' };
    let p = '';
    rows.forEach((r, y) => { for (let x = 0; x < r.length; x++) if (col[r[x]]) p += "<rect x='" + x + "' y='" + y + "' width='1' height='1' fill='" + col[r[x]] + "'/>"; });
    return 'url("data:image/svg+xml,' + encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 7 9' shape-rendering='crispEdges'>" + p + '</svg>') + '")';
  })();
  /* the fibres of Old Yost's brown paper (fine grain and long streaks), and the mark pressed into his wax (a ring and a
     diamond, no letters) */
  const svgU = (x) => 'url("data:image/svg+xml,' + encodeURIComponent(x) + '")';
  const KRAFT = svgU("<svg xmlns='http://www.w3.org/2000/svg' width='180' height='180'><filter id='g'><feTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='3' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 .3 0 0 0 0 .2 0 0 0 0 .1 0 0 0 .22 0'/></filter><filter id='f'><feTurbulence type='fractalNoise' baseFrequency='.012 .55' numOctaves='2' seed='4' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 .28 0 0 0 0 .18 0 0 0 0 .08 0 0 0 .3 -.06'/></filter><rect width='100%' height='100%' filter='url(#f)'/><rect width='100%' height='100%' filter='url(#g)'/></svg>");
  const SEAL = svgU("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'><circle cx='20' cy='20.6' r='13' fill='none' stroke='#ffb4a0' stroke-opacity='.3' stroke-width='1.2'/><circle cx='20' cy='20' r='13' fill='none' stroke='#4a060c' stroke-opacity='.55' stroke-width='1.4'/><path d='M20 10.6 25.2 20.6 20 30.6 14.8 20.6Z' fill='#ffb4a0' fill-opacity='.28'/><path d='M20 10 25.2 20 20 30 14.8 20Z' fill='#4a060c' fill-opacity='.5'/><circle cx='20' cy='20' r='2.1' fill='#ffcbb8' fill-opacity='.5'/></svg>");

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const rnd = (n) => Math.floor(Math.random() * n);
  const shuffle = (a) => { for (let i = a.length - 1; i > 0; i--) { const j = rnd(i + 1); const t = a[i]; a[i] = a[j]; a[j] = t; } return a; };
  const lc = (s) => String(s == null ? '' : s).trim().toLowerCase();
  const coarse = () => { try { return matchMedia('(pointer: coarse)').matches; } catch (e) { return false; } };
  const saveData = () => { try { return !!(navigator.connection && navigator.connection.saveData); } catch (e) { return false; } };
  const plainText = (s) => String(s == null ? '' : s).replace(/\s+/g, ' ').trim();
  const cleanLine = (s) => !!s && !/[!—–;]/.test(s) && !BANNED.test(s) && !EMOJI.test(s);

  /* ---------------- what every mount of the room shares (one page view) ---------------- */
  const S = { deckP: null, deck: null, bySlug: null, pool: null, poolP: null, list: null, kitP: null, kitOk: false, logo: null, order: null, dealt: new Set(), held: null, imgs: new Map(),
    yostP: null, yost: null, yostBy: null, echo: null, ckMem: null, repaired: false, off: null, orderMem: null, byId: null, byIdOf: null };

  /* the collection: Hall slugs, in the order they went in */
  function held() {
    if (S.held) return S.held;
    let v = [];
    try { v = JSON.parse(localStorage.getItem(BK) || '[]'); } catch (e) { v = []; }
    S.held = [...new Set((Array.isArray(v) ? v : []).filter((x) => typeof x === 'string' && x && x.length < 160).map(lc))];
    return S.held;
  }
  const keepHeld = () => { try { localStorage.setItem(BK, JSON.stringify(S.held.slice(-2000))); } catch (e) { /* this visit only */ } };
  try {
    window.addEventListener('storage', (e) => {
      if (!e) return;
      if (e.key === BK || e.key === null) S.held = null;
      if (e.key === CK || e.key === null) { S.echo = null; if (e.newValue != null) S.ckMem = null; }
      if (e.key === HALL_OFF || e.key === null) S.off = null;
    });
  } catch (e) { /* fine */ }

  /* ---------------- the Hall binder (BINDER-04) ----------------
     Jan (2026-10-23, the library binder merge: “go with all your recommended”): a reader signed in to the Hall has ONE
     binder, the account’s (assets/ff-binder.js, which snippets/ff-binder.liquid loads on this page only for a reader
     with the Hall’s token and PIN). Once that binder is ready and BINDER-04’s door (sql/BINDER-04-UPDATE.sql,
     hoh_binder_library) answers its status, this file is in account mode (A.on):
       - the deck’s first tap opens the binder’s waiting pack (its daily pack, the same one the Hall gives: one a day
         wherever it’s opened first, a FramedFantasy pack every fifth day back), on the binder’s own pack screen. Draws
         after it are look only, as before, timed to the binder’s next free pack;
       - the binder on the table opens the Hall binder, with “Books you’ve read” (and the gold feathers) as a tab of its own;
       - a walker’s card (Ember’s) goes into the account, once;
       - Old Yost’s free pack is once an account; a trade takes a spare copy of one of Jan’s portraits (one held twice or
         more, status spares), so it never empties a sleeve; the server deals his three by his own rule;
       - the cards this browser’s binder holds move into the account once (import); they stay in this browser as well.
     Everyone else (signed out, a PIN that no longer works, a Hall without BINDER-04) keeps this browser’s binder exactly
     as it was. A signed-in reader’s first deck tap, binder, walker card or Yost visit waits up to a few seconds for the
     account to answer, so nothing goes into this browser’s binder by mistake. */
  const A = { on: false, st: null, acct: '', p: null, side: false, mount: null, wait: null, missAt: 0, gaveUp: 0 };
  const MOVED = 'ffd-library-moved';
  const TELL = new Set();
  const FB = () => { const b = window.FFBinder; return b && typeof b.state === 'function' && typeof b.library === 'function' ? b : null; };
  let signAt = 0, signVal = false;
  function hallSigned() {
    const now = Date.now();
    if (now - signAt < 1000) return signVal;
    signAt = now;
    try { const t = JSON.parse(localStorage.getItem('hoh-your-hall-token') || 'null'); signVal = !!(t && t.email && t.pin && !(t.savedAt && now - Number(t.savedAt) > 365 * 864e5)); }
    catch (e) { signVal = false; }
    return signVal;
  }
  const acctOn = () => A.on && !!A.st && hallSigned() && !!FB();
  const acctHas = (c) => { const fb = FB(); return !!(c && c.id && fb && fb.has(c.id)); };
  function acctTell() { TELL.forEach((fn) => { try { fn(); } catch (e) { /* fine */ } }); }
  /* the account’s binder answered (or stopped answering): account mode on or off, and every mounted room told */
  function acctSync() {
    const fb = FB(), st = fb ? fb.state() : null;
    if (!st || st.phase !== 'ready' || !hallSigned()) {
      if (A.on || A.p) { A.on = false; A.st = null; A.p = null; A.acct = ''; acctTell(); }
      return Promise.resolve(false);
    }
    if (A.acct === st.acct && (A.on || A.p)) return A.p || Promise.resolve(A.on);
    /* no answer a moment ago (BINDER-04 not installed yet, or offline): asked again after a minute, not on every change */
    if (A.acct === st.acct && Date.now() - A.missAt < 60000) return Promise.resolve(false);
    A.acct = st.acct; A.on = false; A.st = null;
    const p = A.p = Promise.resolve(fb.library('status')).then((j) => {
      if (A.p !== p) return A.on;
      A.p = null;
      if (!j || j.ok !== true) { A.missAt = Date.now(); return false; }
      A.st = statusOf(j);
      A.on = true;
      sideOnce(fb);
      moveOnce(fb, st.acct);
      acctTell();
      return true;
    }, () => { if (A.p === p) { A.p = null; A.missAt = Date.now(); } return false; });
    return p;
  }
  /* the account’s status again (after the move, a Yost pack or a deck pack, any of which can change the spares) */
  function statusOf(j) {
    return {
      imported: !!j.imported, yostFree: j.yost_free !== false,
      spares: new Map((Array.isArray(j.spares) ? j.spares : []).filter((x) => Array.isArray(x)).map((x) => [String(x[0]), +x[1] || 0])),
      gifts: new Set((Array.isArray(j.gifts) ? j.gifts : []).map(String))
    };
  }
  function acctRefresh() {
    const fb = FB(), acct = A.acct;
    if (!fb || !A.on) return Promise.resolve();
    return Promise.resolve(fb.library('status')).then((j) => { if (j && j.ok === true && A.on && A.acct === acct) { A.st = statusOf(j); acctTell(); } }, () => {});
  }
  /* account mode, or this browser’s binder: a reader with the Hall’s token waits up to ms for the account to answer */
  function acctReady(ms) {
    if (acctOn()) return Promise.resolve(true);
    if (!hallSigned()) return Promise.resolve(false);
    /* the binder never answered a moment ago (its file blocked, or offline): this browser’s binder at once for a minute */
    if (Date.now() - A.gaveUp < 60000) return Promise.resolve(false);
    if (A.wait) return A.wait;
    const w = A.wait = new Promise((res) => {
      let done = false, t = 0;
      const fin = (v) => { if (done) return; done = true; clearTimeout(t); document.removeEventListener('ffbinder:change', check); res(!!v && acctOn()); };
      const check = () => {
        const fb = FB(), st = fb ? fb.state() : null;
        if (!st) return;
        if (st.phase === 'ready') acctSync().then(fin);
        else if (st.phase !== 'loading' && st.phase !== 'idle') fin(false);
      };
      document.addEventListener('ffbinder:change', check);
      t = setTimeout(() => { if (!acctOn()) A.gaveUp = Date.now(); fin(acctOn()); }, ms || 4000);
      check();
    }).then((v) => { if (A.wait === w) A.wait = null; return v; });
    return w;
  }
  try { document.addEventListener('ffbinder:change', () => { acctSync(); acctTell(); }); } catch (e) { /* fine */ }
  /* the library’s books, a tab of the Hall binder (drawn by the room that mounted last) */
  function sideOnce(fb) {
    if (A.side || typeof fb.addSide !== 'function') return;
    A.side = true;
    fb.addSide({
      id: 'books', label: 'Books you’ve read', short: 'Books',
      count: () => (A.mount ? A.mount.books().length : 0),
      render: (el, o) => { if (A.mount) A.mount.renderBooks(el, o); }
    });
  }
  /* this browser’s binder into the account, once an account (BINDER-04 import). The cards stay here too, for when the
     reader is signed out. A browser with nothing in it yet asks nothing (a later visit with cards still moves them) */
  function moveOnce(fb, acct) {
    let done = [];
    try { done = JSON.parse(localStorage.getItem(MOVED) || '[]'); } catch (e) { done = []; }
    if (!Array.isArray(done)) done = [];
    if (!acct || done.includes(acct)) return;
    const mark = () => { try { localStorage.setItem(MOVED, JSON.stringify(done.concat(acct).slice(-20))); } catch (e) { /* the server answers already next time */ } };
    if (A.st.imported) { mark(); return; }
    S.held = null;
    const ff = held(), yo = readCk().yost;
    if (!ff.length && !yo.length) return;
    Promise.resolve(fb.library('import', { ff: ff.slice(0, 600), yost: yo.slice(0, 600) })).then((j) => {
      if (!j || j.ok !== true) return;
      mark();
      if (A.st) A.st.imported = true;
      acctTell();
      acctRefresh();
    }, () => { /* asked again next visit */ });
  }

  /* the reader’s own order of the binder: slugs of both kinds, read fresh each time (a second tab may have moved a
     card); this visit’s copy stands in when the browser keeps nothing */
  function readOrder() {
    let v = null;
    try { const raw = localStorage.getItem(OK); v = raw == null ? S.orderMem : JSON.parse(raw); } catch (e) { v = S.orderMem; }
    return slugs(v, 4000);
  }
  function writeOrder(list) {
    S.orderMem = slugs(list, 4000);
    try { localStorage.setItem(OK, JSON.stringify(S.orderMem)); } catch (e) { /* this visit only */ }
  }

  /* today’s pack and Old Yost’s cards: ffd-library-cards (see the head of this file). Read fresh before every
     write, so a second tab’s pack is never undone; this visit’s copy stands in when the browser keeps nothing */
  const dayKey = (t) => { const d = new Date(t); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); };
  const slugs = (a, cap) => [...new Set((Array.isArray(a) ? a : []).filter((x) => typeof x === 'string' && x && x.length < 160).map(lc))].slice(-cap);
  function readCk() {
    let raw = null, ok = true;
    try { raw = localStorage.getItem(CK); } catch (e) { ok = false; }
    let v = null;
    if (ok && raw != null) { try { v = JSON.parse(raw); } catch (e) { v = null; } }
    else if (S.ckMem) v = JSON.parse(JSON.stringify(S.ckMem));
    if (!v || typeof v !== 'object' || Array.isArray(v)) v = {};
    const num = (x, lo, hi) => (typeof x === 'number' && isFinite(x) ? Math.max(lo, Math.min(hi, Math.floor(x))) : lo);
    const date = (x) => (typeof x === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(x) ? x : '');
    return {
      v: 1, day: date(v.day), pack: date(v.pack), seen: num(v.seen, 0, 8.64e15),
      yost: slugs(v.yost, 400), gift: v.gift === 1 ? 1 : 0,
      log: (Array.isArray(v.log) ? v.log : []).filter((e) => Array.isArray(e) && typeof e[0] === 'number').map((e) => [e[0], typeof e[1] === 'string' ? lc(e[1]) : '', slugs(e[2], 3), e[3] === 1 ? 1 : 0]).slice(-40),
      echo: slugs(v.echo, 400)
    };
  }
  function writeCk(st) {
    S.ckMem = st;
    try { localStorage.setItem(CK, JSON.stringify(st)); return true; } catch (e) { return false; }
  }
  /* the reader’s day. A new calendar day (by their own clock, later than any reading before) brings a new pack.
     A clock set back never hands one back: a little (under 36 hours) changes nothing, a lot (a clock put right after it
     ran ahead) moves the day to the clock’s own day with today’s pack still opened, so the next one comes at that
     day’s midnight */
  function rollDay(st, now) {
    const dk = dayKey(now), opened = !!st.day && st.pack === st.day;
    if (!st.day) st.day = dk;
    else if (now < st.seen - 36 * 3600e3) { st.day = dk; st.seen = now; if (opened) st.pack = dk; }
    else if (now >= st.seen && dk > st.day) st.day = dk;
    st.seen = Math.max(st.seen, now);
    return st;
  }
  /* the midnight that ends the day `day` ('YYYY-MM-DD'), in the reader’s own time */
  function dayEnd(day) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day || '');
    if (!m) { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1).getTime(); }
    return new Date(+m[1], +m[2] - 1, +m[3] + 1).getTime();
  }
  function todayNow() {
    /* signed in: a pack waiting in the account’s binder, and the binder’s next free pack (midnight in the Hall’s day) */
    if (acctOn()) {
      const fb = FB(), d = typeof fb.daily === 'function' ? fb.daily() : null, n = typeof fb.packs === 'function' ? fb.packs().length : 0;
      return { pack: n > 0, nextAt: d && d.nextAt > Date.now() ? d.nextAt : dayEnd(dayKey(Date.now())) };
    }
    const st = rollDay(readCk(), Date.now()); return { pack: st.pack !== st.day, nextAt: dayEnd(st.day) };
  }
  /* today’s pack, marked opened (false when it already was: another tab, or a second tap) */
  function markPack() {
    const st = rollDay(readCk(), Date.now());
    if (st.pack === st.day) return false;
    st.pack = st.day;
    writeCk(st);
    return true;
  }
  /* the story echo: a Yost hero whose legend the Hall would hide, remembered so a pocket hides it without asking again */
  const echoSet = () => (S.echo || (S.echo = new Set(readCk().echo)));
  const echoed = (s) => echoSet().has(lc(s));
  function markEcho(list) {
    const add = list.map(lc).filter((s) => s && !echoed(s));
    if (!add.length) return;
    add.forEach((s) => S.echo.add(s));
    const st = readCk(); st.echo = slugs(st.echo.concat(add), 400); writeCk(st);
  }
  const yostHeld = () => readCk().yost.filter((s) => !(S.bySlug && S.bySlug.has(s)));
  /* a pack cut off between its two writes (the cards in, then the portrait out of the binder) is finished on load */
  function repair() {
    if (S.repaired) return;
    S.repaired = true;
    const st = readCk(), last = st.log[st.log.length - 1];
    if (!last || last[3] === 1) return;
    if (last[1] && last[2].every((g) => st.yost.includes(g))) { S.held = null; const L = held(), i = L.indexOf(last[1]); if (i >= 0) { L.splice(i, 1); keepHeld(); } }
    last[3] = 1; writeCk(st);
  }

  /* files and sheets, once each */
  const scripts = {}, sheets = {};
  function loadScript(src) {
    if (scripts[src]) return scripts[src];
    return (scripts[src] = new Promise((res, rej) => {
      const s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = () => res(true);
      s.onerror = () => { delete scripts[src]; s.remove(); rej(new Error('script ' + src)); };
      document.head.appendChild(s);
    }));
  }
  function loadCss(href) {
    if (sheets[href]) return sheets[href];
    return (sheets[href] = new Promise((res, rej) => {
      const have = [...document.querySelectorAll('link[rel="stylesheet"]')].find((l) => l.getAttribute('href') === href);
      if (have) {
        if (have.sheet) { res(true); return; }
        have.addEventListener('load', () => res(true)); have.addEventListener('error', () => { delete sheets[href]; rej(new Error('css')); });
        return;
      }
      const l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = href; l.setAttribute('data-lbc-css', '');
      l.onload = () => res(true);
      l.onerror = () => { delete sheets[href]; l.remove(); rej(new Error('css ' + href)); };
      document.head.appendChild(l);
    }));
  }
  /* a picture decoded before it is shown (a slow or broken one never holds the card back for long) */
  function preload(src, cap) {
    if (!src) return Promise.resolve(false);
    if (!S.imgs.has(src)) {
      S.imgs.set(src, new Promise((res) => {
        const im = new Image(); im.decoding = 'async';
        let done = false; const fin = (ok) => { if (!done) { done = true; res(ok); } };
        im.onload = () => { (im.decode ? im.decode().catch(() => {}) : Promise.resolve()).then(() => fin(true)); };
        im.onerror = () => fin(false);
        im.src = src;
        setTimeout(() => fin(false), 8000);
      }));
    }
    const p = S.imgs.get(src);
    return cap ? Promise.race([p, sleep(cap).then(() => false)]) : p;
  }

  /* ---------------- the deck ---------------- */
  function tierOf(t) { t = lc(t); if (!TIERS.includes(t) || t === 'common') t = 'uncommon'; return t; }
  const denied = (c) => [c.slug, c.demo, c.base].some((s) => s && DENY.includes(lc(s)));
  const hallOn = (SITE) => !!(SITE && SITE.hall && SITE.hall.url && SITE.hall.key);
  function hallGet(SITE, q) {
    const key = SITE.hall.key;
    return fetch(String(SITE.hall.url).replace(/\/$/, '') + '/rest/v1/characters?' + q, { headers: { apikey: key, Authorization: 'Bearer ' + key } });
  }
  function fromRow(x) {
    let order = x.order; if (typeof order === 'string') { try { order = JSON.parse(order); } catch (e) { order = null; } }
    let tr = x.hero_rarity; if (Array.isArray(tr)) tr = tr[0];
    return {
      slug: lc(x.slug || x.id), id: x.id != null ? String(x.id) : 'hall-' + lc(x.slug), name: x.name || 'Hero', race: x.race || '', cls: x.character_class || '', campaign: x.campaign || '',
      img: x.image_url, thumb: x.image_thumb_url || x.image_url, hasThumb: !!x.image_thumb_url, offX: x.image_offset_x, offY: x.image_offset_y, zoom: x.image_zoom,
      at: x.created_at || '', title: x.title || '', epithet: x.epithet || '', legend: x.legend || '', quote: x.quote || '',
      order: Array.isArray(order) ? order.map(String) : null, pick: x.jan_featured === true, tier: tierOf(tr && tr.tier)
    };
  }
  function fromDemo(x) {
    const img = String(x.img || '');
    return {
      slug: lc(x.hall || x.slug), demo: lc(x.slug), base: img.split('/').pop().replace(/\.\w+$/, ''), id: x.id ? String(x.id) : 'demo-' + lc(x.hall || x.slug),
      name: x.name || 'Hero', race: x.race || '', cls: x.cls || '', campaign: x.campaign || '', img, thumb: img, hasThumb: x.thumb !== false,
      offX: x.offX, offY: x.offY, zoom: x.zoom, at: x.at || (x.created ? x.created + '-15T12:00:00Z' : ''), title: x.title || '', epithet: x.epithet || '',
      legend: x.legend || '', quote: x.quote || '', order: Array.isArray(x.order) ? x.order.map(String) : null, pick: x.pick === true, tier: tierOf(x.tier)
    };
  }
  function loadDeck(SITE) {
    if (S.deckP) return S.deckP;
    S.deckP = (async () => {
      let cards = [];
      if (hallOn(SITE)) {
        let rows = null;
        try {
          const r = await hallGet(SITE, HALL_SELECT);
          if (r.ok) rows = await r.json();
          else {
            const e = await r.json().catch(() => ({}));
            /* the rarity table can’t be joined (PGRST200 or 201): once more without it, and every card shows uncommon */
            if (e && (e.code === 'PGRST200' || e.code === 'PGRST201' || /hero_rarity/i.test(String(e.message || '') + String(e.details || '') + String(e.hint || '')))) {
              const r2 = await hallGet(SITE, HALL_SELECT.replace(',hero_rarity(tier)', ''));
              if (r2.ok) rows = await r2.json();
            }
          }
        } catch (e) { rows = null; }
        cards = (Array.isArray(rows) ? rows : []).filter((x) => x && x.image_url).map(fromRow);
      } else {
        if (!window.FFD_HALL_DECK) await loadScript('js/hall-deck-data.js').catch(() => false);
        const D = window.FFD_HALL_DECK;
        if (D && Array.isArray(D.cards) && D.cards.length) {
          cards = D.cards.filter((x) => x && x.img).map(fromDemo);
          if (D.logo) S.logo = D.logo;
          if (Array.isArray(D.ff) && D.ff.length) S.pool = D.ff.filter((p) => Array.isArray(p) && p[0]).map((p) => ({ id: String(p[0]), created_at: p[1] || null }));
        } else {
          /* no deck file: Jan’s featured heroes from the demo’s own cast make plain cards */
          cards = (window.FFD_HEROES || []).filter((x) => x && x.img && x.ff !== false).map((x) => fromDemo({
            slug: x.slug, hall: x.hall && x.hall.slug, name: (x.hall && x.hall.name) || x.name, race: x.race, cls: x.cls,
            campaign: x.hall && x.hall.campaign, img: x.img, pick: x.featured === true, tier: 'uncommon'
          }));
        }
      }
      const seen = new Set();
      return cards.filter((c) => c.slug && !denied(c) && !seen.has(c.slug) && seen.add(c.slug));
    })().then((cards) => {
      if (!cards.length) { S.deckP = null; return cards; }
      S.deck = cards; S.list = null;
      S.bySlug = new Map();
      cards.forEach((c) => { [c.slug, c.demo, c.base].forEach((k) => { if (k && !S.bySlug.has(k)) S.bySlug.set(k, c); }); });
      return cards;
    }, () => { S.deckP = null; return []; });
    return S.deckP;
  }
  function loadPool(SITE) {
    if (S.pool) return Promise.resolve(S.pool);
    if (!hallOn(SITE)) return Promise.resolve(null);
    if (S.poolP) return S.poolP;
    S.poolP = hallGet(SITE, POOL_SELECT).then((r) => (r.ok ? r.json() : null)).then((rows) => {
      const list = (Array.isArray(rows) ? rows : []).filter((x) => x && x.id != null).map((x) => ({ id: String(x.id), created_at: x.created_at || null }));
      if (list.length) { S.pool = list; S.list = null; }
      return S.pool;
    }).catch(() => null).then((v) => { S.poolP = null; return v; });
    return S.poolP;
  }
  /* a Yost hero: the stored tier as it is (a mythic reads as legendary), a player’s card (ff false: no FramedFantasy
     mark, no quote), and whether the owner wrote its words (edited: the Hall prints those as they are) */
  function fromYost(x) {
    const c = fromRow(x);
    let tr = x.hero_rarity; if (Array.isArray(tr)) tr = tr[0];
    const t = lc(tr && tr.tier);
    c.tier = t === 'mythic' ? 'legendary' : t;
    c.ff = false; c.yost = true; c.edited = x.edited === true; c.pick = false; c.quote = '';
    return c;
  }
  /* the cart, once a page view (fetched only when the Tinker record starts). Never a hero the deck holds as Jan’s */
  function loadYost(SITE) {
    if (S.yost) return Promise.resolve(S.yost);
    if (S.yostP) return S.yostP;
    S.yostP = (async () => {
      await Promise.race([loadDeck(SITE), sleep(6000)]).catch(() => null);
      let rows = null;
      if (hallOn(SITE)) {
        try { const r = await hallGet(SITE, YOST_SELECT); rows = r.ok ? await r.json() : null; } catch (e) { rows = null; }
      } else {
        if (!window.FFD_HALL_YOST) await loadScript('js/hall-yost-data.js').catch(() => false);
        const D = window.FFD_HALL_YOST;
        rows = D && Array.isArray(D.rows) ? D.rows : null;
      }
      if (!Array.isArray(rows)) return null;
      const seen = new Set();
      return rows.filter((x) => x && x.image_url && x.is_ff_portrait === false).map(fromYost).filter((c) => c.slug && YOST_TIERS.includes(c.tier) && !denied(c) &&
        c.id !== EMBER_ID && c.slug !== 'ember' && !(S.bySlug && S.bySlug.has(c.slug)) && !seen.has(c.slug) && seen.add(c.slug));
    })().then((list) => {
      S.yostP = null;
      if (!list) return [];
      S.yost = list; S.yostBy = new Map(list.map((c) => [c.slug, c]));
      return list;
    }, () => { S.yostP = null; return []; });
    return S.yostP;
  }
  /* signed in (BINDER-04): a deck card by its Hall id, and Yost’s heroes by id (a hero the cart didn’t bring is asked
     for with the cart’s own columns) */
  function deckById() {
    if (S.byIdOf !== S.deck) { S.byId = new Map((S.deck || []).map((c) => [c.id, c])); S.byIdOf = S.deck; }
    return S.byId || new Map();
  }
  const yostById = (id) => (S.yost || []).find((c) => c.id === id) || null;
  async function yostRows(SITE, ids) {
    const m = new Map();
    if (!hallOn(SITE) || !ids.length) return m;
    try {
      const r = await hallGet(SITE, 'select=' + YOST_COLS + '&id=in.(' + ids.map(encodeURIComponent).join(',') + ')');
      const rows = r.ok ? await r.json() : null;
      (Array.isArray(rows) ? rows : []).filter((x) => x && x.image_url && x.is_ff_portrait === false).map(fromYost).forEach((c) => m.set(c.id, c));
    } catch (e) { /* the pack shows the heroes the cart knows */ }
    return m;
  }
  /* the three heroes’ stories, for the Hall’s echo guard only: in memory, never shown, never kept. A hero whose story
     can’t be asked gets the Hall’s neutral line (c.unsure; the pack remembers it as an echo once it tears) */
  async function yostStories(SITE, deal) {
    const need = deal.filter((c) => c.legend && c.edited !== true && c.story === undefined && !c.unsure && !echoed(c.slug));
    if (!need.length) return;
    let rows = null;
    if (hallOn(SITE)) {
      try { const r = await hallGet(SITE, 'select=id,story&id=in.(' + need.map((c) => encodeURIComponent(c.id)).join(',') + ')'); if (r.ok) rows = await r.json(); } catch (e) { rows = null; }
    } else rows = [];   /* the demo’s cart file already leaves every echo out (tools/hall-yost-data.cjs) */
    if (!Array.isArray(rows)) { need.forEach((c) => { c.unsure = true; c.row = null; }); return; }
    const by = new Map(rows.filter((x) => x && x.id != null).map((x) => [String(x.id), typeof x.story === 'string' ? x.story : '']));
    need.forEach((c) => { c.story = by.has(c.id) ? by.get(c.id) : ''; c.row = null; });
  }
  /* the hero as the Hall’s renderer reads it: public columns only, the Hall’s neutral line for a missing legend.
     A Yost hero is a player’s card (is_ff_portrait false: the Hall’s classic face, no “Portrait by Jan” mark, no quote),
     never with an owner’s name or an artwork_cover, its title and epithet only when the owner wrote them (the Hall’s
     rule), and its story (memory only) so the Hall’s own echo guard runs */
  function rowOf(c) {
    if (c.row) return c.row;
    const ff = c.ff !== false;
    const jan = ff && (c.id === EMBER_ID || c.slug === 'ember');
    const meta = { title: c.title || '', epithet: c.epithet || '', legend: c.legend || GENERIC_LEGEND, quote: ff ? c.quote || '' : '', order: c.order || undefined };
    if (!ff) {
      meta.edited = c.edited === true;
      if (!meta.edited && (c.unsure || echoed(c.slug))) meta.legend = GENERIC_LEGEND;
    }
    c.row = {
      id: c.id, slug: c.slug, name: c.name, race: c.race || '', character_class: c.cls || '', campaign: c.campaign || '',
      image_url: c.img, image_thumb_url: c.hasThumb ? c.thumb : null, image_offset_x: c.offX, image_offset_y: c.offY, image_zoom: c.zoom,
      created_at: c.at || null, is_ff_portrait: ff, approved: true, is_hidden: false, hearts: 0, legacy_hearts: 0, player_name: jan ? 'Jan' : '',
      card_meta: meta
    };
    if (!ff && typeof c.story === 'string') c.row.story = c.story;
    return c.row;
  }
  /* window.hohGetAllCharacters stand-in: every FramedFantasy portrait the Hall numbers, the deck’s heroes in full */
  function poolList() {
    if (S.list) return S.list;
    const m = new Map();
    (S.pool || []).forEach((p) => m.set(p.id, { id: p.id, created_at: p.created_at, is_ff_portrait: true, approved: true, is_hidden: false, hearts: 0, card_meta: { legend: GENERIC_LEGEND } }));
    (S.deck || []).forEach((c) => m.set(c.id, rowOf(c)));
    S.list = [...m.values()];
    return S.list;
  }
  const numbered = () => !!(S.pool && S.pool.length);
  function ensureKit(SITE) {
    if (S.kitP) return S.kitP;
    window.__hohShopCardOnly = true;
    /* the Hall binder (BINDER-04) may have put in its own small stand-in first (marked __ffb); this fuller one wins */
    if (typeof window.hohGetAllCharacters !== 'function' || window.hohGetAllCharacters.__ffb) { const pool = () => poolList(); pool.__ffd = true; window.hohGetAllCharacters = pool; }
    const shop = SITE && SITE.shop ? SITE.shop : null;
    const js = (shop && shop.js) || 'js/vendor/hoh-shop.js', css = (shop && shop.css) || 'css/hoh-shop.css';
    /* the kit once a page: the binder may have loaded it already */
    const have = typeof window.hohShopCardHtml === 'function' && typeof window.hohShopWireCard === 'function';
    S.kitP = Promise.all([loadCss(css), have ? true : loadScript(js), loadPool(SITE).catch(() => null)]).then(() => {
      if (typeof window.hohShopCardHtml !== 'function' || typeof window.hohShopWireCard !== 'function') throw new Error('renderer');
      S.kitOk = true;
      return true;
    });
    S.kitP.catch(() => { S.kitP = null; });
    return S.kitP;
  }
  /* the Hall’s reframe, by the Hall’s own rule (see THE FRAMING at the head): this device’s map (keys id:primary,
     id:primary:x, id:primary:zoom), then the row, each only when it is a number in range, else 50, 50 and 100 */
  function hallMap() {
    if (S.off) return S.off;
    let m = null;
    try { m = JSON.parse(localStorage.getItem(HALL_OFF) || '{}'); } catch (e) { m = null; }
    S.off = m && typeof m === 'object' && !Array.isArray(m) ? m : {};
    return S.off;
  }
  function framing(c) {
    const ok = (v, lo, hi) => typeof v === 'number' && isFinite(v) && v >= lo && v <= hi;
    const m = hallMap(), id = String(c.id || ''), k = id + ':primary';
    const pick = (local, row, lo, hi, dflt) => (ok(local, lo, hi) ? local : ok(row, lo, hi) ? row : dflt);
    return { x: pick(m[k + ':x'], c.offX, 0, 100, 50), y: pick(m[k], c.offY, 0, 100, 50), zoom: pick(m[k + ':zoom'], c.zoom, 100, 200, 100) };
  }
  /* one inline style, written exactly as the Hall’s hohImgStyle writes it (the Hall’s shop card, this file’s kit, asks
     for that same string). A row with no saved value is centred, as in the Hall */
  function frameStyle(c) {
    const f = framing(c), pos = f.x + '% ' + f.y + '%';
    return 'object-position:' + pos + ';transform-origin:' + pos + ';scale:' + (Math.round(f.zoom) / 100) + ';';
  }
  /* one real card: { box (.ffshop-cardbox), art (the article), img, coll (the collector number, or null) } */
  function drawCard(c, o) {
    o = o || {};
    let html = '';
    const row = Object.assign({}, rowOf(c), { image_url: o.src || c.img });
    const ff = c.ff !== false;
    try { html = window.hohShopCardHtml(c.id, { back: 'brand', context: 'public-hall', hideHearts: true, hero: row, tier: c.tier, showCollectorNumber: ff && !!o.number && numbered() }); } catch (e) { html = ''; }
    if (!html) return null;
    /* the Hall printed its neutral line over a written legend: that legend echoes the player’s story, so every later
       pocket hides it too, without asking for the story again */
    if (!ff && typeof row.story === 'string' && !c.edited && c.legend && c.legend !== GENERIC_LEGEND && html.indexOf(GENERIC_LEGEND) >= 0 && !echoed(c.slug)) markEcho([c.slug]);
    const t = document.createElement('div');
    t.innerHTML = html;
    const box = t.querySelector('.ffshop-cardbox'), art = box && box.querySelector('.ffshop-card');
    if (!art) return null;
    const img = art.querySelector('.ffshop-flipzone img');
    if (img) img.setAttribute('style', frameStyle(c));
    /* the demo carries the FF mark as its own file (its review copy can’t reach Shopify’s CDN) */
    if (S.logo) art.querySelectorAll('img').forEach((im) => { if (/Logo_Clean/.test(im.getAttribute('src') || '')) im.setAttribute('src', S.logo); });
    return { box, art, img, coll: t.querySelector('.ffshop-collno') };
  }
  /* which face the reader and a screen reader get (hoh-shop.js syncCardFaceState, for the turns this file runs) */
  function syncFaces(art) {
    const on = art.classList.contains('on'), fr = art.querySelector('.ffshop-face.is-front'), bk = art.querySelector('.ffshop-face.is-back');
    if (fr) { fr.setAttribute('aria-hidden', on ? 'true' : 'false'); fr.toggleAttribute('inert', on); }
    if (bk) { bk.setAttribute('aria-hidden', on ? 'false' : 'true'); bk.toggleAttribute('inert', !on); }
    const name = art.getAttribute('data-card-name') || 'Hero';
    art.setAttribute('aria-label', name + (on ? ' card back. Press Enter to show the card art.' : ' card front. Press Enter to show the card back.'));
    try { void (on ? bk : fr).offsetHeight; } catch (e) { /* the WebKit paint kick, R572 */ }
  }
  function willAnimate(el) {
    try { const cs = getComputedStyle(el); return !!cs.animationName && cs.animationName !== 'none' && (parseFloat(cs.animationDuration) || 0) > 0.02; } catch (e) { return true; }
  }
  /* the Hall’s turn (hoh-shop.css ffshopInspTurn): squeeze edge on with a lift, the faces swap at the edge, spring out.
     Both beats hang off the animation’s own start (R563), with a guard for an animation that never comes (R571) */
  function turnCard(art) {
    return new Promise((res) => {
      let swapped = false, done = false, tMid = 0, tEnd = 0, tGuard = 0;
      const swap = () => { if (swapped) return; swapped = true; art.classList.toggle('on'); syncFaces(art); };
      const finish = () => {
        if (done) return; done = true;
        clearTimeout(tMid); clearTimeout(tEnd); clearTimeout(tGuard);
        art.removeEventListener('animationstart', onStart); art.removeEventListener('animationend', onEnd);
        swap(); art.classList.remove('ffshop-turn'); res();
      };
      const onStart = (e) => {
        if (e.target !== art || e.animationName !== 'ffshopInspTurn') return;
        let d = 430; try { d = Math.max(120, (parseFloat(getComputedStyle(art).animationDuration) || 0.43) * 1000); } catch (x) { /* fine */ }
        clearTimeout(tGuard); clearTimeout(tMid); clearTimeout(tEnd);
        tMid = setTimeout(swap, d / 2); tEnd = setTimeout(finish, d + 30);
      };
      const onEnd = (e) => { if (e.target === art && e.animationName === 'ffshopInspTurn') finish(); };
      art.addEventListener('animationstart', onStart); art.addEventListener('animationend', onEnd);
      art.classList.add('ffshop-turn');
      if (!willAnimate(art)) { finish(); return; }
      tGuard = setTimeout(finish, 720);
    });
  }
  /* any rect the room hands over, as { left, top, width, height } in the window */
  function rectOf(r) {
    if (!r) return null;
    try {
      if (typeof r.getBoundingClientRect === 'function') r = r.getBoundingClientRect();
      if (r.cx != null && r.w != null) return { left: r.cx - r.w / 2, top: r.cy - (r.h || r.w) / 2, width: r.w, height: r.h || r.w };
      const left = r.left != null ? r.left : r.x, top = r.top != null ? r.top : r.y;
      if (!(r.width > 0) || !(r.height > 0) || !isFinite(left) || !isFinite(top)) return null;
      return { left, top, width: r.width, height: r.height };
    } catch (e) { return null; }
  }
  /* the move from a small rect (the deck in the art, a pocket) to where the stage stands */
  function fromTransform(r, d, tilt) {
    const s = Math.max(0.05, Math.min(d.width / r.width, d.height / r.height) * 1.08);
    const dx = (d.left + d.width / 2) - (r.left + r.width / 2), dy = (d.top + d.height / 2) - (r.top + r.height / 2);
    return 'translate(' + Math.round(dx) + 'px, ' + Math.round(dy) + 'px) scale(' + s.toFixed(3) + ')' + (tilt ? ' rotate(' + tilt + 'deg)' : '');
  }
  function sized(u, w) {
    try { const x = new URL(u, location.href); if (!/\/cdn\/shop\/|cdn\.shopify\.com/.test(x.href)) return u; x.searchParams.set('width', String(w)); return x.href; } catch (e) { return u; }
  }

  /* ---------------- the look: every rule under .ffd-page--library (hoh-shop.css itself is the Hall’s, global) ---------------- */
  const CSS = `
.ffd-page--library .lbc { position: absolute; inset: 0; z-index: 30; display: grid; place-items: center; overflow: hidden; -webkit-tap-highlight-color: transparent; }
/* every empty div here says its display: the store's Dawn hides an empty div (div:empty { display: none }) */
/* deep enough that the room's bright spines and posters never fight the words over the card */
.ffd-page--library .lbc-dim { position: absolute; inset: 0; display: block; background: radial-gradient(ellipse 85% 75% at 50% 46%, rgba(14, 10, 6, .64), rgba(6, 4, 3, .9)); opacity: 0; transition: opacity .26s ease; }
.ffd-page--library .lbc.is-in > .lbc-dim { opacity: 1; }
.ffd-page--library .lbc-col { position: relative; z-index: 1; display: flex; flex-direction: column; align-items: center; gap: 10px; width: 100%; max-height: 100%; padding: 14px 12px calc(14px + env(safe-area-inset-bottom, 0px)); }
.ffd-page--library .lbc-label { margin: 0; max-width: 100%; font: 600 12.5px/1.35 var(--f-display); letter-spacing: .2em; text-transform: uppercase; color: var(--gold-hi); text-align: center; text-wrap: balance; text-shadow: 0 1px 10px rgba(0, 0, 0, .7); }
.ffd-page--library .lbc-by { margin: -5px 0 0; max-width: 100%; font: italic 500 16.5px/1.35 var(--f-aside); color: #ecdfc2; text-align: center; text-wrap: balance; text-shadow: 0 1px 10px rgba(0, 0, 0, .7); }
.ffd-page--library .lbc-label, .ffd-page--library .lbc-by { opacity: 0; transform: translateY(6px); transition: opacity .24s ease, transform .3s cubic-bezier(.2, .8, .2, 1); }
.ffd-page--library .lbc-col.is-titled .lbc-label, .ffd-page--library .lbc-col.is-titled .lbc-by { opacity: 1; transform: none; }
.ffd-page--library .lbc-under, .ffd-page--library .lbc-acts { opacity: 0; transform: translateY(6px); visibility: hidden; transition: opacity .24s ease, transform .3s cubic-bezier(.2, .8, .2, 1), visibility 0s linear .3s; }
.ffd-page--library .lbc-col.is-shown .lbc-under, .ffd-page--library .lbc-col.is-shown .lbc-acts { opacity: 1; transform: none; visibility: visible; transition: opacity .24s ease, transform .3s cubic-bezier(.2, .8, .2, 1), visibility 0s linear 0s; }
.ffd-page--library .lbc-under { display: flex; justify-content: center; min-height: 0; }
.ffd-page--library .lbc-under:empty { display: none; }
.ffd-page--library .lbc-under .ffshop-collno { margin: 0; }
/* the stage: the Hall’s card at the frame’s scale (the hero page’s .hhp-cv-stage rules; that class also tells
   hohShopWireCard to leave the lean to hohCardLean, which leans the whole stage) */
.ffd-page--library .lbc-stage { position: relative; display: block; flex: 0 0 auto; isolation: isolate; width: calc(380px * var(--lbc-k, .6)); height: calc(650px * var(--lbc-k, .6)); }
/* the type the card inherits in the Hall (the store body it sits in there: 16 px, line height 1.8, letter spacing .06rem
   on a 10 px root), so its lines wrap exactly as in the Hall’s card view */
.ffd-page--library .lbc-stage, .ffd-page--library .lbc-pocket, .ffd-page--library .lbc-under { font-size: 16px; line-height: 1.8; letter-spacing: .6px; }
.ffd-page--library .lbc-stage > .ffshop-cardbox { width: 100% !important; max-width: none !important; height: 100% !important; margin: 0 !important; }
.ffd-page--library .lbc-stage .ffshop-tiltwrap { width: 380px; transform: scale(var(--lbc-k, 1)) !important; transform-origin: top left !important; transition: none !important; will-change: auto !important; }
.ffd-page--library .lbc-stage .ffshop-card { box-shadow: 0 14px 28px -16px rgba(0, 0, 0, .75), 0 0 13px -6px color-mix(in srgb, var(--rar) 32%, transparent); }
.ffd-page--library .lbc-stage.is-arriving { pointer-events: none; }
.ffd-page--library .lbc-stage[data-glow]::after { content: ''; position: absolute; inset: 0; z-index: -1; border-radius: calc(16px * var(--lbc-k, 1)); pointer-events: none; box-shadow: 0 0 var(--lbc-glow-size, 26px) -6px var(--lbc-glow-col, transparent); opacity: var(--lbc-glow-min, .55); animation: lbcGlow var(--lbc-glow-dur, 4.4s) ease-in-out infinite; }
@keyframes lbcGlow { 0%, 100% { opacity: var(--lbc-glow-min, .45); } 50% { opacity: .78; } }
.ffd-page--library .lbc-stage[data-glow].is-turning::after { animation: lbcGlowTurn .43s cubic-bezier(.45, .05, .35, 1) both; }
@keyframes lbcGlowTurn { 0% { transform: scaleX(1); opacity: var(--lbc-glow-min, .45); } 46%, 54% { transform: translateY(-7px) scaleX(.05); opacity: 0; } 100% { transform: scaleX(1); opacity: var(--lbc-glow-min, .45); } }
.ffd-page--library .lbc-stage.is-wait::before { content: ''; position: absolute; inset: 0; border-radius: calc(16px * var(--lbc-k, 1)); border: 1px solid rgba(200, 164, 94, .3); background: repeating-linear-gradient(45deg, rgba(200, 164, 94, .05) 0 1px, transparent 1px 13px), linear-gradient(170deg, #14101e, #0a0a0f 70%); opacity: 0; animation: lbcWait 1.4s ease-in-out .18s infinite; }
@keyframes lbcWait { 0%, 100% { opacity: .55; } 50% { opacity: .9; } }
.ffd-page--library .lbc-ring { position: absolute; display: block; inset: -5px; z-index: 3; border-radius: calc(18px * var(--lbc-k, 1) + 4px); border: 2px solid rgba(255, 220, 150, .95); box-shadow: 0 0 24px rgba(255, 196, 102, .65), inset 0 0 20px rgba(255, 196, 102, .35); pointer-events: none; opacity: 0; }
.ffd-page--library .lbc-ghost { position: absolute; display: block; left: 0; top: 0; z-index: 6; width: 40px; height: 68px; overflow: hidden; border-radius: 4px; background: #0a0a0f; box-shadow: 0 0 0 1px rgba(232, 198, 116, .8), 0 8px 18px rgba(0, 0, 0, .6); pointer-events: none; }
.ffd-page--library .lbc-ghost > img { display: block; width: 100%; height: 100%; object-fit: cover; }
.ffd-page--library .lbc-fail { display: grid; place-items: center; width: 100%; height: 100%; padding: 18px; border-radius: 14px; border: 1px solid rgba(200, 164, 94, .26); background: linear-gradient(170deg, #14101e, #0a0a0f 70%); color: var(--fg-2); font: italic 500 16px/1.45 var(--f-aside); text-align: center; text-wrap: balance; }
/* the Hall’s warm mote over the card (hall-of-heroes.css .hoh-card-mote), moved by hohCardLean */
.ffd-page--library .lbc-mote { position: fixed; left: 0; top: 0; z-index: 40; width: 22px; height: 22px; margin: -11px 0 0 -11px; border-radius: 50%; pointer-events: none !important; opacity: 0; transition: opacity .16s ease; will-change: transform;
  background: radial-gradient(circle, rgba(255, 219, 166, .95) 0%, rgba(255, 158, 66, .64) 34%, rgba(232, 108, 28, .2) 60%, rgba(232, 108, 28, 0) 74%); filter: drop-shadow(0 0 10px rgba(255, 150, 60, .5)); }
.ffd-page--library .lbc-mote.is-in { opacity: 1; }
.ffd-page--library .lbc-stage.lbc-mote-host, .ffd-page--library .lbc-stage.lbc-mote-host * { cursor: none !important; }
/* the choices under the card: the box’s own chips (core.css .ffs-chip) */
.ffd-page--library .lbc-acts { display: flex; flex-wrap: wrap; justify-content: center; gap: 8px; width: min(600px, 100%); }
.ffd-page--library .lbc-btn { position: relative; display: inline-flex; align-items: center; justify-content: center; gap: 8px; min-height: 44px; padding: 8px 18px; border-radius: 9px; border: 1px solid rgba(200, 164, 94, .26); background: rgba(14, 10, 7, .74); color: #eadfc9; font: 500 15px/1.25 var(--f-body); text-align: center; cursor: pointer; text-wrap: balance;
  transition: border-color .18s ease, background-color .18s ease, color .18s ease, opacity .2s ease, transform .14s ease; }
.ffd-page--library .lbc-btn:hover { border-color: rgba(232, 198, 116, .6); background: rgba(40, 30, 18, .86); color: #fff3dc; }
.ffd-page--library .lbc-btn:active { transform: scale(.98); }
.ffd-page--library .lbc-btn:disabled { opacity: .45; cursor: default; }
.ffd-page--library .lbc-btn.is-main { border-color: rgba(232, 198, 116, .62); background: rgba(52, 38, 18, .84); color: #f3dfa8; font-weight: 600; }
.ffd-page--library .lbc-btn.is-main:hover { border-color: #e8c674; color: #fff1cc; }
.ffd-page--library .lbc-btn.is-quiet { border-color: transparent; background: transparent; color: var(--fg-2); text-decoration: underline; text-underline-offset: 3px; text-decoration-color: rgba(200, 164, 94, .4); }
.ffd-page--library .lbc-btn.is-quiet:hover { color: #f1e6cf; background: transparent; border-color: transparent; }
.ffd-page--library .lbc-btn.is-bump { animation: lbcBump .5s cubic-bezier(.2, 1.5, .4, 1); }
@keyframes lbcBump { 0% { transform: scale(1); } 35% { transform: scale(1.06); } 100% { transform: scale(1); } }
/* the card’s one button, and under a deck draw the time until tomorrow’s pack (its own fixed line, so the ticking
   never moves anything) */
.ffd-page--library .lbc-one { display: flex; flex-direction: column; align-items: center; gap: 8px; }
.ffd-page--library .lbc-one > .lbc-btn { min-width: 220px; }
.ffd-page--library .lbc-timer { margin: 0; min-height: 1.35em; font: italic 500 15px/1.35 var(--f-aside); color: #d9c48e; text-align: center; font-variant-numeric: tabular-nums; text-shadow: 0 1px 8px rgba(0, 0, 0, .7); }
.ffd-page--library .lbc-timer b { font-weight: 600; color: #f3dfa8; }
@media (max-width: 719px) {
  .ffd-page--library .lbc-acts { display: grid; grid-template-columns: 1fr 1fr; width: min(100%, 344px); gap: 6px; }
  .ffd-page--library .lbc-acts > .lbc-btn { width: 100%; padding-inline: 10px; }
  .ffd-page--library .lbc-acts > .is-wide { grid-column: 1 / -1; }
  .ffd-page--library .lbc-acts > .lbc-one { width: 100%; }
  .ffd-page--library .lbc-one > .lbc-btn { width: 100%; min-width: 0; padding-inline: 10px; }
}
/* a short, wide screen (a phone on its side): the way back sits beside Draw another and the time to tomorrow’s pack under
   both, so the card keeps its size and nothing falls off the foot */
@media (max-height: 500px) and (min-width: 600px) {
  .ffd-page--library .lbc-one { display: grid; grid-template-columns: auto auto; justify-content: center; align-items: center; column-gap: 8px; row-gap: 4px; }
  .ffd-page--library .lbc-one > .lbc-timer { grid-column: 1 / -1; grid-row: 2; }
  .ffd-page--library .lbc-one > .lbc-btn.is-quiet { min-width: 0; }
}
/* a card’s face drawn for the daily pack’s screen (library/pack.js gives the box, the card’s own size) */
.ffd-page--library .lbc-face { font-size: 16px; line-height: 1.8; letter-spacing: .6px; }
.ffd-page--library .lbc-face > .ffshop-cardbox { width: 100% !important; max-width: none !important; height: 100% !important; margin: 0 !important; pointer-events: none; }
.ffd-page--library .lbc-face .ffshop-tiltwrap { width: 380px; transform: scale(var(--lbc-fk, var(--lbc-k, 1))) !important; transform-origin: top left !important; transition: none !important; will-change: auto !important; }
.ffd-page--library .lbc-sr { position: absolute !important; width: 1px; height: 1px; margin: -1px; padding: 0; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; border: 0; }

/* ---- Old Yost’s pack: brown paper, a string tied across it and his red seal ---- */
.ffd-page--library .lbc-packcol { gap: 12px; }
.ffd-page--library .lbc-pack { position: relative; display: block; flex: 0 0 auto; width: max(120px, min(52vw, 30svh, calc((100svh - 270px) * .75))); aspect-ratio: 3 / 4; container-type: inline-size; margin: 4px 0 2px; padding: 0; border: 0; border-radius: 8px; background: transparent; cursor: pointer;
  filter: drop-shadow(0 18px 22px rgba(0, 0, 0, .55)); transition: transform .2s ease; -webkit-tap-highlight-color: transparent; }
.ffd-page--library .lbc-pack:hover { transform: translateY(-3px) rotate(-1deg); }
.ffd-page--library .lbc-pack:focus-visible { outline: 2px solid var(--gold); outline-offset: 5px; }
.ffd-page--library .lbc-pack:disabled { cursor: default; }
.ffd-page--library .lbc-pack.is-idle { animation: lbcPackIdle 3.8s ease-in-out 1.2s infinite; }
@keyframes lbcPackIdle { 0%, 84%, 100% { transform: none; } 88% { transform: rotate(-2deg); } 92% { transform: rotate(1.6deg); } 96% { transform: rotate(-.8deg); } }
.ffd-page--library .lbc-pack-half { position: absolute; display: block; inset: 0; border-radius: 8px;
  background: repeating-linear-gradient(90deg, rgba(60, 40, 20, .3) 0 2px, rgba(60, 40, 20, 0) 2px 6px) top / 100% 9px no-repeat, repeating-linear-gradient(90deg, rgba(60, 40, 20, .3) 0 2px, rgba(60, 40, 20, 0) 2px 6px) bottom / 100% 9px no-repeat,
    linear-gradient(24deg, rgba(255, 240, 210, 0) 58%, rgba(255, 240, 210, .2) 60%, rgba(70, 45, 20, .2) 61.5%, rgba(70, 45, 20, 0) 64%),
    linear-gradient(-14deg, rgba(255, 240, 210, 0) 20%, rgba(70, 45, 20, .14) 22%, rgba(255, 240, 210, .12) 23.5%, rgba(255, 240, 210, 0) 26%),
    radial-gradient(120% 80% at 30% 12%, rgba(255, 244, 214, .34), rgba(255, 244, 214, 0) 55%), ${KRAFT} 0 0 / 180px 180px, linear-gradient(160deg, #c9ab7a, #9b7c50 58%, #765b3a);
  box-shadow: inset 0 0 0 2px rgba(60, 40, 20, .35), inset 0 -18px 30px -18px rgba(40, 24, 10, .6), inset 0 18px 24px -20px rgba(255, 240, 210, .35); }
.ffd-page--library .lbc-pack-half.is-top { clip-path: inset(0 0 56% 0); transform-origin: 8% 44%; }
.ffd-page--library .lbc-pack-half.is-bot { clip-path: inset(44% 0 0 0); }
/* twine, twisted, with its shadow on the paper */
.ffd-page--library .lbc-pack-str { position: absolute; display: block; left: 0; right: 0; top: 44%; height: 4px; margin-top: -2px; border-radius: 2px; background: repeating-linear-gradient(118deg, #f6ecd2 0 1.6px, #cbb68a 1.6px 3px, #e8dab4 3px 4.4px); box-shadow: 0 2px 2px rgba(40, 24, 10, .42), 0 0 0 .5px rgba(90, 64, 30, .35); }
.ffd-page--library .lbc-pack-str.is-v { left: 46%; right: auto; top: 0; bottom: 0; width: 4px; height: auto; margin: 0 0 0 -2px; background: repeating-linear-gradient(28deg, #f6ecd2 0 1.6px, #cbb68a 1.6px 3px, #e8dab4 3px 4.4px); box-shadow: 2px 0 2px rgba(40, 24, 10, .42), 0 0 0 .5px rgba(90, 64, 30, .35); }
/* his wax: a raised, uneven blob with a drip, lit from the upper left, his mark pressed into it */
.ffd-page--library .lbc-pack-seal { position: absolute; display: block; left: 46%; top: 44%; --seal: clamp(28px, 16cqw, 62px); width: var(--seal); height: var(--seal); margin: calc(var(--seal) / -2) 0 0 calc(var(--seal) / -2); border-radius: 47% 53% 49% 51% / 52% 46% 54% 48%;
  background: ${SEAL} 50% 50% / 74% 74% no-repeat, radial-gradient(circle at 34% 28%, #f2846c 0, #cf4138 20%, #951d24 58%, #5c0c13 100%);
  box-shadow: 0 3px 6px rgba(0, 0, 0, .5), inset 0 0 0 2px rgba(74, 6, 12, .35), inset 0 -3px 5px rgba(40, 0, 6, .5), inset 0 2px 3px rgba(255, 176, 156, .4); }
.ffd-page--library .lbc-pack-seal::after { content: ''; position: absolute; right: -9%; bottom: -12%; display: block; width: 34%; height: 30%; border-radius: 46% 54% 50% 50%; background: radial-gradient(circle at 38% 30%, #c63a34, #6e1018 75%); box-shadow: 0 2px 3px rgba(0, 0, 0, .4); }
.ffd-page--library .lbc-pack:hover .lbc-pack-seal { box-shadow: 0 3px 6px rgba(0, 0, 0, .5), inset 0 0 0 2px rgba(74, 6, 12, .35), inset 0 -3px 5px rgba(40, 0, 6, .5), inset 0 2px 3px rgba(255, 176, 156, .4), 0 0 16px rgba(255, 150, 110, .5); }
.ffd-page--library .lbc-pack-face { position: absolute; display: block; left: 9%; right: 9%; bottom: 11%; font: italic 600 clamp(14px, 7.4cqw, 26px)/1.2 var(--f-aside); color: #3a2814; text-align: center; text-wrap: balance; }
.ffd-page--library .lbc-hint { margin: 0; max-width: 26em; font: italic 500 16px/1.35 var(--f-aside); color: #d9ccb0; text-align: center; text-wrap: balance; text-shadow: 0 1px 10px rgba(0, 0, 0, .7); }
.ffd-page--library .lbc-packcol > .lbc-acts { opacity: 1; transform: none; visibility: visible; transition: none; }
/* the album, when Yost asks for a portrait: his words over the pockets, and Ember’s pocket a little dimmer */
.ffd-page--library .lbc-toast { position: absolute; left: 50%; bottom: 14px; z-index: 3; width: min(330px, 88%); margin: 0; padding: 10px 14px; border-radius: 10px; border: 1px solid rgba(232, 198, 116, .42); background: rgba(14, 10, 7, .93); color: #f1e6cf;
  font: italic 500 16px/1.35 var(--f-aside); text-align: center; text-wrap: balance; box-shadow: 0 10px 30px rgba(0, 0, 0, .55); opacity: 0; transform: translate(-50%, 6px); transition: opacity .2s ease, transform .25s ease; pointer-events: none; }
.ffd-page--library .lbc-toast.is-in { opacity: 1; transform: translate(-50%, 0); }
.ffd-page--library .lbc-toast b { display: block; margin-bottom: 3px; font: 600 11.5px/1.2 var(--f-display); font-style: normal; letter-spacing: .18em; text-transform: uppercase; color: var(--gold-hi); }
.ffd-page--library .lbc-pocket.is-kept { opacity: .6; }
.ffd-page--library .lbc-pocket.is-no { animation: lbcNo .42s ease; }
@keyframes lbcNo { 0%, 100% { translate: 0; } 25% { translate: -4px 0; } 50% { translate: 4px 0; } 75% { translate: -2px 0; } }

/* ---- the album ---- */
.ffd-page--library .lbc-album { position: relative; z-index: 1; display: flex; flex-direction: column; align-items: center; gap: 10px; max-width: calc(100% - 12px); max-height: 100%; padding: 10px 0 calc(10px + env(safe-area-inset-bottom, 0px)); transform-origin: 50% 50%; }
.ffd-page--library .lbc-album > .lbc-acts { opacity: 1; transform: none; visibility: visible; transition: none; }
.ffd-page--library .lbc-binder { position: relative; display: flex; flex-direction: column; padding: 12px 14px 12px; border-radius: 14px;
  background: radial-gradient(120% 90% at 30% 0%, rgba(255, 220, 170, .07), rgba(255, 220, 170, 0) 55%), repeating-linear-gradient(115deg, rgba(0, 0, 0, .05) 0 2px, rgba(255, 255, 255, .012) 2px 4px), linear-gradient(160deg, #452818 0%, #2f1a0f 48%, #1f110a 100%);
  box-shadow: 0 26px 60px -20px rgba(0, 0, 0, .9), 0 0 0 1px rgba(0, 0, 0, .6), inset 0 1px 0 rgba(255, 220, 170, .12), inset 0 0 0 6px rgba(0, 0, 0, .14), inset 0 0 0 7px rgba(200, 164, 94, .34); }
.ffd-page--library .lbc-ahead { display: flex; align-items: center; gap: 8px 14px; flex-wrap: wrap; padding: 0 2px 10px; }
.ffd-page--library .lbc-atitle { margin: 0; font: 600 14px/1.25 var(--f-display); letter-spacing: .16em; text-transform: uppercase; color: var(--gold-hi); }
.ffd-page--library .lbc-atitle:focus { outline: none; }
.ffd-page--library .lbc-acount { margin: 0 auto 0 0; font: italic 500 15.5px/1.25 var(--f-aside); color: #e8d8b4; font-variant-numeric: tabular-nums; }
.ffd-page--library .lbc-quills { display: inline-flex; align-items: center; gap: 7px; margin: 0; font: italic 500 15px/1.25 var(--f-aside); color: #e9c979; font-variant-numeric: tabular-nums; white-space: nowrap; }
.ffd-page--library .lbc-quills::before { content: ''; flex: 0 0 auto; width: 10px; height: 13px; background: ${QUILL} center / 100% 100% no-repeat; image-rendering: pixelated; filter: drop-shadow(0 0 4px rgba(244, 214, 138, .55)); }
.ffd-page--library .lbc-quills[hidden] { display: none; }
.ffd-page--library .lbc-tabs { display: flex; gap: 6px; padding: 0; }
@media (max-width: 719px) {
  .ffd-page--library .lbc-acount { margin: 0 0 0 auto; }
  .ffd-page--library .lbc-tabs { flex: 1 0 100%; }
}
.ffd-page--library .lbc-tab { position: relative; min-height: 36px; padding: 6px 14px; border-radius: 999px; border: 1px solid rgba(200, 164, 94, .2); background: rgba(0, 0, 0, .18); color: #c9bea8; font: 500 14px/1.2 var(--f-body); cursor: pointer; transition: background-color .18s ease, border-color .18s ease, color .18s ease; }
.ffd-page--library .lbc-tab::after { content: ''; position: absolute; inset: -4px -2px; }
.ffd-page--library .lbc-tab:hover { color: #f1e6cf; border-color: rgba(232, 198, 116, .45); }
.ffd-page--library .lbc-tab[aria-selected="true"] { background: rgba(200, 164, 94, .16); border-color: rgba(232, 198, 116, .6); color: #f3dfa8; }
.ffd-page--library .lbc-tab[hidden], .ffd-page--library .lbc-tabs[hidden] { display: none; }
.ffd-page--library .lbc-side { position: relative; }
.ffd-page--library .lbc-side.is-swap { animation: lbcSide .22s ease both; }
@keyframes lbcSide { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }
.ffd-page--library .lbc-spread { position: relative; display: flex; justify-content: center; border-radius: 6px; background: #120e0a; box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .7), 0 1px 0 rgba(255, 220, 170, .06); touch-action: pan-y; }
.ffd-page--library .lbc-page { display: grid; grid-template-columns: repeat(3, var(--lbc-pw, 96px)); grid-auto-rows: var(--lbc-ph, 166px); gap: var(--lbc-gap, 8px); padding: var(--lbc-pp, 12px); border-radius: 6px;
  background: linear-gradient(180deg, rgba(255, 240, 210, .035), rgba(255, 240, 210, 0) 40%), radial-gradient(130% 100% at 50% 50%, #221a12, #17120c); }
.ffd-page--library .lbc-page.is-left { border-radius: 6px 2px 2px 6px; box-shadow: inset -16px 0 18px -16px rgba(0, 0, 0, .9); }
.ffd-page--library .lbc-page.is-right { border-radius: 2px 6px 6px 2px; box-shadow: inset 16px 0 18px -16px rgba(0, 0, 0, .9); }
.ffd-page--library .lbc-spine { flex: 0 0 22px; position: relative; background: linear-gradient(90deg, #0d0a07, #1d150e 50%, #0d0a07); }
.ffd-page--library .lbc-spine i { position: absolute; left: 50%; width: 12px; height: 26px; margin: -13px 0 0 -6px; border-radius: 6px; background: linear-gradient(90deg, #6d5a3a, #e9d39b 45%, #8d7447 70%, #4a3b22); box-shadow: 0 2px 4px rgba(0, 0, 0, .7); }
.ffd-page--library .lbc-spine i:nth-child(1) { top: 18%; } .ffd-page--library .lbc-spine i:nth-child(2) { top: 50%; } .ffd-page--library .lbc-spine i:nth-child(3) { top: 82%; }
.ffd-page--library .lbc-pages { display: flex; }
.ffd-page--library .lbc-pages.is-turn-l { animation: lbcTurnL .24s cubic-bezier(.2, .8, .2, 1) both; }
.ffd-page--library .lbc-pages.is-turn-r { animation: lbcTurnR .24s cubic-bezier(.2, .8, .2, 1) both; }
@keyframes lbcTurnL { from { opacity: 0; transform: translateX(-18px); } to { opacity: 1; transform: none; } }
@keyframes lbcTurnR { from { opacity: 0; transform: translateX(18px); } to { opacity: 1; transform: none; } }
.ffd-page--library .lbc-pocket { position: relative; display: block; width: var(--lbc-pw, 96px); height: var(--lbc-ph, 166px); margin: 0; padding: 3px; border: 0; border-radius: 6px; overflow: hidden; cursor: pointer; color: inherit;
  background: linear-gradient(140deg, rgba(255, 255, 255, .075), rgba(255, 255, 255, .02) 46%, rgba(255, 255, 255, .055)); box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .08), inset 0 -12px 18px -14px rgba(0, 0, 0, .7);
  transition: transform .18s ease, box-shadow .18s ease; }
.ffd-page--library .lbc-pocket::after { content: ''; position: absolute; inset: 0; border-radius: inherit; pointer-events: none; background: linear-gradient(118deg, rgba(255, 255, 255, 0) 32%, rgba(255, 255, 255, .09) 44%, rgba(255, 255, 255, 0) 56%); }
.ffd-page--library button.lbc-pocket:hover { transform: translateY(-2px); box-shadow: inset 0 0 0 1px rgba(232, 198, 116, .4), 0 8px 16px -10px rgba(0, 0, 0, .8); }
.ffd-page--library button.lbc-pocket:focus-visible { outline: 2px solid var(--gold); outline-offset: 2px; }
.ffd-page--library .lbc-pocket.is-empty { cursor: default; }
.ffd-page--library .lbc-pocket.is-empty::before { content: ''; position: absolute; left: 50%; top: 50%; width: 9px; height: 9px; margin: -4.5px 0 0 -4.5px; transform: rotate(45deg); border: 1px solid rgba(200, 164, 94, .22); }
.ffd-page--library .lbc-pocket .ffshop-cardbox { width: 100% !important; max-width: none !important; height: 100% !important; margin: 0 !important; pointer-events: none; }
.ffd-page--library .lbc-pocket .ffshop-tiltwrap { width: 380px; transform: scale(var(--lbc-pk, .24)) !important; transform-origin: top left !important; transition: none !important; will-change: auto !important; }
.ffd-page--library .lbc-pocket .ffshop-card { box-shadow: 0 4px 10px -4px rgba(0, 0, 0, .85); }
.ffd-page--library .lbc-pocket .lbc-pthumb { display: block; width: 100%; height: 100%; object-fit: cover; border-radius: 4px; opacity: .9; }
.ffd-page--library .lbc-pocket.is-new { animation: lbcNew 1.1s ease-out both; }
@keyframes lbcNew { 0% { box-shadow: inset 0 0 0 2px rgba(255, 220, 150, .95), 0 0 22px rgba(255, 196, 102, .6); } 100% { box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .08), 0 0 0 rgba(255, 196, 102, 0); } }
/* moving a card: a long press or a drag must never select, save or call up the picture */
.ffd-page--library .lbc-pocket, .ffd-page--library .lbc-pocket img { -webkit-user-select: none; user-select: none; -webkit-touch-callout: none; -webkit-user-drag: none; }
.ffd-page--library .lbc-album.is-dragging, .ffd-page--library .lbc-album.is-dragging * { cursor: grabbing !important; }
.ffd-page--library .lbc-album.is-dragging button.lbc-pocket:hover { transform: none; box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .08), inset 0 -12px 18px -14px rgba(0, 0, 0, .7); }
/* the pocket the lifted card left: an empty sleeve with a gold edge, where the card lands if it drops now */
.ffd-page--library .lbc-pocket.is-hole { background: rgba(255, 236, 200, .03); box-shadow: inset 0 0 0 1px rgba(232, 198, 116, .55), inset 0 0 16px rgba(232, 198, 116, .12); }
.ffd-page--library .lbc-pocket.is-hole > * { opacity: 0; }
/* the lifted card under the pointer */
.ffd-page--library .lbc-lift { position: absolute; left: 0; top: 0; z-index: 8; margin: 0; pointer-events: none; cursor: grabbing; will-change: transform; transition: opacity .16s ease;
  box-shadow: 0 22px 34px -12px rgba(0, 0, 0, .85), 0 0 0 1px rgba(232, 198, 116, .55), 0 0 18px rgba(255, 196, 102, .25); }
.ffd-page--library .lbc-lift.is-out { opacity: .55; }
/* holding the lifted card at the spread’s outer edge: the edge fills with light, and the page turns when it is full */
.ffd-page--library .lbc-spread::before, .ffd-page--library .lbc-spread::after { content: ''; position: absolute; top: 0; bottom: 0; z-index: 3; width: 44px; pointer-events: none; opacity: 0; transition: opacity .12s ease; }
.ffd-page--library .lbc-spread::before { left: 0; border-radius: 6px 0 0 6px; background: linear-gradient(90deg, rgba(255, 210, 130, .42), rgba(255, 210, 130, 0)); }
.ffd-page--library .lbc-spread::after { right: 0; border-radius: 0 6px 6px 0; background: linear-gradient(270deg, rgba(255, 210, 130, .42), rgba(255, 210, 130, 0)); }
.ffd-page--library .lbc-spread.is-edge-l::before, .ffd-page--library .lbc-spread.is-edge-r::after { opacity: 1; transition: opacity .6s linear; }
.ffd-page--library .lbc-empty { position: absolute; left: 50%; top: 50%; z-index: 2; width: min(300px, 86%); transform: translate(-50%, -50%); margin: 0; padding: 14px 16px; border-radius: 10px; border: 1px solid rgba(200, 164, 94, .26); background: rgba(12, 9, 6, .86); color: #ecdfc2; font: italic 500 16.5px/1.4 var(--f-aside); text-align: center; text-wrap: balance; box-shadow: 0 10px 30px rgba(0, 0, 0, .5); }
.ffd-page--library .lbc-turnrow { display: flex; align-items: center; justify-content: center; gap: 14px; padding-top: 8px; min-height: 44px; }
.ffd-page--library .lbc-turn { display: grid; place-items: center; width: 44px; height: 44px; padding: 0; border-radius: 50%; border: 1px solid rgba(200, 164, 94, .26); background: rgba(0, 0, 0, .2); color: var(--gold-hi); cursor: pointer; transition: background-color .18s ease, border-color .18s ease, opacity .18s ease; }
.ffd-page--library .lbc-turn svg { width: 20px; height: 20px; }
.ffd-page--library .lbc-turn:hover { border-color: rgba(232, 198, 116, .6); background: rgba(200, 164, 94, .1); }
.ffd-page--library .lbc-turn:disabled { opacity: .3; cursor: default; }
.ffd-page--library .lbc-pageno { min-width: 4.5em; text-align: center; font: italic 500 14.5px/1 var(--f-aside); color: #bfb39b; font-variant-numeric: tabular-nums; }
.ffd-page--library .lbc-books { list-style: none; margin: 0; padding: 8px; display: grid; align-content: start; gap: 6px; overflow-y: auto; overscroll-behavior: contain; border-radius: 6px; background: radial-gradient(130% 100% at 50% 50%, #221a12, #17120c); box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .7); scrollbar-width: thin; }
.ffd-page--library .lbc-book { display: flex; align-items: center; gap: 12px; width: 100%; min-height: 60px; margin: 0; padding: 6px 12px 6px 6px; border: 1px solid rgba(200, 164, 94, .16); border-radius: 8px; background: rgba(255, 236, 200, .03); color: #eadfc9; text-align: left; cursor: pointer; transition: border-color .18s ease, background-color .18s ease; }
.ffd-page--library .lbc-book:hover { border-color: rgba(232, 198, 116, .5); background: rgba(200, 164, 94, .07); }
.ffd-page--library .lbc-bcov { flex: 0 0 auto; width: 40px; height: 52px; border-radius: 3px; object-fit: cover; background: linear-gradient(90deg, rgba(0, 0, 0, .35), rgba(0, 0, 0, 0) 22%), var(--lbc-spine, #5a2b1c); box-shadow: inset 0 0 0 1px rgba(232, 198, 116, .3), 0 3px 8px rgba(0, 0, 0, .5); }
.ffd-page--library .lbc-btext { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.ffd-page--library .lbc-bt { font: 500 14.5px/1.3 var(--f-body); color: #efe4cc; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.ffd-page--library .lbc-books.is-empty { align-content: center; justify-items: center; }
.ffd-page--library .lbc-books-empty { position: static; transform: none; margin: 0; width: min(320px, 90%); }
/* the album on a short, wide frame (refitAlbum sets is-low): tighter padding, the head on one line, the page turner to
   the left and the way back to the right of the same row (while there is more than one page to turn) */
.ffd-page--library .lbc-album.is-low { gap: 0; padding: 6px 0 calc(6px + env(safe-area-inset-bottom, 0px)); }
.ffd-page--library .lbc-album.is-low .lbc-binder { padding: 8px 12px 6px; }
.ffd-page--library .lbc-album.is-low .lbc-ahead { gap: 4px 12px; padding: 0 2px 6px; }
.ffd-page--library .lbc-album.is-low .lbc-atitle { font-size: 12.5px; letter-spacing: .12em; }
.ffd-page--library .lbc-album.is-low .lbc-acount { margin: 0 auto 0 0; font-size: 14.5px; }
.ffd-page--library .lbc-album.is-low .lbc-tabs { flex: 0 0 auto; }
.ffd-page--library .lbc-album.is-low .lbc-tab { padding: 6px 12px; font-size: 13.5px; }
.ffd-page--library .lbc-album.is-low .lbc-turnrow { justify-content: flex-start; padding-top: 4px; }
.ffd-page--library .lbc-album.is-low.has-turn > .lbc-acts--album { position: absolute; right: 14px; bottom: calc(10px + env(safe-area-inset-bottom, 0px)); display: block; width: auto; }
.ffd-page--library .lbc-album.is-low.has-turn > .lbc-acts--album > .lbc-btn { width: auto; }
.ffd-page--library .lbc-album.is-low.has-turn .lbc-books { padding-bottom: 52px; }
.ffd-page--library .lbc-zoom { position: absolute; inset: 0; z-index: 5; display: grid; place-items: center; }
.ffd-page--library .lbc-zoom > .lbc-dim { background: rgba(6, 4, 3, .84); }
/* a card open over the album: the album's own way out steps back, so it never peeks round the card's button */
.ffd-page--library .lbc.is-zoomed .lbc-album > .lbc-acts { opacity: 0; visibility: hidden; transition: opacity .18s ease, visibility 0s linear .18s; }
.ffd-page--library .lbc.is-zoomed .lbc-spine i { opacity: .15; transition: opacity .18s ease; }
.ffd-page--library .lbc-zoom.is-in > .lbc-dim { opacity: 1; }
@media (prefers-reduced-motion: reduce) {
  .ffd-page--library .lbc-dim, .ffd-page--library .lbc-label, .ffd-page--library .lbc-by, .ffd-page--library .lbc-under, .ffd-page--library .lbc-acts { transform: none !important; transition-property: opacity, visibility; }
  .ffd-page--library .lbc-stage[data-glow]::after, .ffd-page--library .lbc-stage[data-glow].is-turning::after { animation: none; opacity: .75; }
  .ffd-page--library .lbc-stage.is-wait::before { animation: none; opacity: .7; }
  .ffd-page--library .lbc-btn.is-bump, .ffd-page--library .lbc-pages.is-turn-l, .ffd-page--library .lbc-pages.is-turn-r, .ffd-page--library .lbc-side.is-swap, .ffd-page--library .lbc-pocket.is-new { animation: none; }
  .ffd-page--library button.lbc-pocket:hover { transform: none; }
  .ffd-page--library .lbc-pack.is-idle, .ffd-page--library .lbc-pocket.is-no { animation: none; }
  .ffd-page--library .lbc-spread.is-edge-l::before, .ffd-page--library .lbc-spread.is-edge-r::after { transition: none; opacity: .8; }
  .ffd-page--library .lbc-pack, .ffd-page--library .lbc-pack:hover { transform: none; transition: none; }
  .ffd-page--library .lbc-toast { transform: translate(-50%, 0); transition: opacity .2s ease; }
}
`;
  function styleOnce() {
    if (document.getElementById('ffd-css-library-cards')) return;
    const st = document.createElement('style');
    st.id = 'ffd-css-library-cards'; st.textContent = CSS;
    document.head.appendChild(st);
  }

  /* ======================================================================================================== */
  (FFD.parts = FFD.parts || {})['library/cards'] = function makeCards(api) {
    api = api || {};
    const F = api.F || {};
    const SITE = api.SITE && typeof api.SITE === 'object' ? api.SITE : null;
    const h = api.h || FFD.h;
    const RM = () => { try { return api.RM ? !!api.RM() : matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } };
    const WIDE = () => { try { return api.WIDE ? !!api.WIDE() : matchMedia('(min-width: 720px)').matches; } catch (e) { return false; } };
    let dead = false;
    const alive = () => { if (dead) return false; try { return api.alive ? api.alive() !== false : true; } catch (e) { return true; } };
    const snd = (n) => { try { if (api.snd) api.snd(n); } catch (e) { /* a sound never breaks a card */ } };
    /* pack: Old Yost’s, on this file’s layer. daily: the daily pack’s screen (library/pack.js), made once when wanted */
    let touched = false, cur = null, album = null, layer = null, pack = null, uid = 0, daily = null, dailyOn = false, lastPark = null;
    styleOnce();
    repair();
    const tellRoom = () => { try { if (api.added) api.added(null); } catch (e) { /* the room’s binder catches up on its own */ } };
    /* the Hall binder (BINDER-04): this room hears when the account’s binder changes, and draws the books tab */
    TELL.add(() => { if (alive()) tellRoom(); });
    A.mount = { books: () => booksRead(), renderBooks: (el, o) => binderBooks(el, o) };
    acctSync();

    const warm = () => { touched = true; if (!S.kitP) ensureKit(SITE).catch(() => {}); };
    function ready() {
      return loadDeck(SITE).then((cs) => {
        /* the kit stays cold until the reader reaches for a card; after that, an idle moment warms it */
        const idle = window.requestIdleCallback ? (fn) => window.requestIdleCallback(fn, { timeout: 3000 }) : (fn) => setTimeout(fn, 1500);
        if (cs.length) idle(() => { if (alive() && touched) warm(); });
        return cs.length > 0;
      });
    }
    function order(cards) { return shuffle(cards.filter((c) => c.pick)).concat(shuffle(cards.filter((c) => !c.pick))); }
    async function next() {
      warm();
      const cards = await loadDeck(SITE);
      if (!cards.length) return null;
      if (!S.order || S.order.length !== cards.length) S.order = order(cards.slice());
      let fresh = S.order.filter((c) => !S.dealt.has(c.slug));
      if (!fresh.length) { S.dealt.clear(); fresh = S.order.slice(); }
      const missing = fresh.filter((c) => !has(c.slug));
      const c = (missing.length ? missing : fresh)[0];
      S.dealt.add(c.slug);
      try { if (FFD.tally) FFD.tally.add('library', 'cards'); } catch (e) { /* fine */ }
      return c;
    }
    const peek = () => {
      if (!S.order) return null;
      const fresh = S.order.filter((c) => !S.dealt.has(c.slug));
      return fresh.find((c) => !has(c.slug)) || fresh[0] || null;
    };
    async function find(slug) {
      const s = lc(slug);
      if (!s || DENY.includes(s)) return null;
      warm();
      await loadDeck(SITE);
      return (S.bySlug && S.bySlug.get(s)) || null;
    }
    function portrait(c) {
      if (!c) return null;
      const P = SITE && SITE.portraits && typeof SITE.portraits === 'object' ? SITE.portraits : null;
      const own = P && (P[c.demo] || P[c.slug]);
      return own || c.thumb || c.img || null;
    }
    function line(c) {
      if (!c) return '';
      const q = plainText(c.quote).replace(/^["“”'‘’]+|["“”'‘’]+$/g, '').trim();
      if (q && q.length <= 140 && cleanLine(q)) return q;
      const e = plainText(c.epithet);
      return e && cleanLine(e) ? e : '';
    }
    function story(c) {
      const s = plainText(c && c.legend);
      if (!s || s === GENERIC_LEGEND) return '';
      const parts = s.match(/[^.?!…]+(?:[.?!…]+["”’)]*|$)/g) || [];
      let out = '', n = 0;
      for (const raw of parts) {
        let t = raw.trim();
        if (!t) continue;
        if (!/[.?!…]["”’)]*$/.test(t)) t += '.';
        if (!cleanLine(t)) { if (out) break; continue; }
        if (out && (out + ' ' + t).length > 230) break;
        out = out ? out + ' ' + t : t;
        if (++n >= 2) break;
      }
      return out.length > 260 ? '' : out;
    }
    /* signed in (BINDER-04): held means held in the account’s binder, and the binder counts every card in it */
    const has = (slug) => {
      if (acctOn()) { const s = lc(slug); return acctHas((S.bySlug && S.bySlug.get(s)) || (S.yostBy && S.yostBy.get(s)) || null); }
      return held().includes(lc(slug));
    };
    function count() {
      if (acctOn()) return Math.max(0, +FB().state().cards || 0);
      const L = held(); return S.bySlug ? L.filter((s) => S.bySlug.has(s)).length : L.length;
    }
    const total = () => (S.deck ? S.deck.length : 0);
    const all = () => (S.deck ? S.deck.slice() : []);
    const heldCards = () => { const by = S.bySlug; return by ? held().map((s) => by.get(s)).filter(Boolean) : []; };
    const countAll = () => (acctOn() ? count() : count() + yostHeld().length);
    /* the binder’s order, both kinds: the reader’s own order first (only cards still held), then every held card it
       doesn’t name, Jan’s in the order they went in, then Yost’s in theirs */
    function orderedSlugs() {
      S.held = null;
      const jan = held(), yo = yostHeld(), have = new Set(jan.concat(yo));
      const mine = readOrder().filter((s) => have.has(s)), named = new Set(mine);
      return mine.concat(jan.filter((s) => !named.has(s)), yo.filter((s) => !named.has(s)));
    }
    /* every card the binder can show, in its order (a Yost card waits for his cart to be known) */
    function collection() {
      const by = S.bySlug, yb = S.yostBy, seen = new Set(), out = [];
      orderedSlugs().forEach((s) => { const c = (by && by.get(s)) || (yb && yb.get(s)) || null; if (c && !seen.has(c)) { seen.add(c); out.push(c); } });
      return out;
    }
    /* cards just got go on the end of the reader’s order, in the order they came */
    function noteGot(list) {
      const add = (list || []).map(lc).filter(Boolean);
      if (!add.length) return;
      const now = orderedSlugs().filter((s) => !add.includes(s));
      writeOrder(now.concat(add));
    }
    /* into the collection (both keys read fresh first): true when it wasn’t held before */
    function hold(c) {
      S.held = null;
      const L = held(), s = lc(c.slug);
      if (!s || L.includes(s)) return false;
      L.push(s); keepHeld();
      noteGot([s]);
      return true;
    }
    /* signed in (BINDER-04): a walker’s card into the account’s binder, once. { got, had }, or null without the binder */
    function acctGift(c) {
      const fb = FB();
      if (!fb || !c || !c.id) return Promise.resolve(null);
      if (acctHas(c)) return Promise.resolve({ got: false, had: true });
      return Promise.resolve(fb.library('gift', { hero: c.id })).then((j) => (j && j.ok === true ? { got: j.had === false, had: j.had === true } : { got: false, had: false }),
        () => ({ got: false, had: false }));
    }
    /* signed in: the Hall binder over the room (focused on ids when given), and the room waits until it closes */
    let binderOn = false;
    async function acctAlbum(ids) {
      const fb = FB();
      if (!fb || !alive()) return;
      if (album) shutAlbum(album, true);
      if (cur) endShow(cur, 'library', true);
      if (pack) dropPack(pack);
      if (layer) layerDown(layer);
      binderOn = true;
      try {
        snd('rustle');
        if (ids && ids.length) fb.open({ focusId: ids[ids.length - 1], landing: ids }); else fb.open();
        await fb.whenClosed();
      } finally { binderOn = false; }
    }
    /* signed in: the deck opens the binder’s waiting pack, today’s daily pack first, on the binder’s own pack screen; the
       cards go into the binder there (the binder opens on them), and the room waits until it all closes */
    async function acctPack() {
      const fb = FB(), list = fb && typeof fb.packs === 'function' ? fb.packs() : [];
      if (!list.length) return 'cancelled';
      const daily = list.filter((x) => x.source === 'daily'), pick = daily.length ? daily[daily.length - 1] : list[0];
      if (album) shutAlbum(album, true);
      if (cur) endShow(cur, 'library', true);
      if (pack) dropPack(pack);
      if (layer) layerDown(layer);
      binderOn = true;
      try {
        snd('whoosh');
        fb.openPack(pick.id);
        await fb.whenClosed();
        if (!fb.packs().some((x) => x.id === pick.id)) { for (let i = 0; i < 3; i++) { try { if (FFD.tally) FFD.tally.add('library', 'cards'); } catch (e) { /* fine */ } } }
      } finally { binderOn = false; }
      tellRoom();
      acctRefresh();
      return 'opened';
    }
    /* the books read, as a tab of the Hall binder (the album’s Books side, in the binder’s own look): a tap closes the
       binder and opens the book in the room */
    function binderBooks(el, o) {
      const list = booksRead();
      const wrap = h('div', { class: 'ffb-books' });
      let q = 0;
      try { const tr = api.trophies ? api.trophies() : null; q = tr ? Math.max(0, Math.floor(+tr.feathers || 0)) : 0; } catch (e) { q = 0; }
      if (q) wrap.append(h('p', { class: 'ffb-books-feathers', text: q === 1 ? '1 gold feather found in the library' : q + ' gold feathers found in the library' }));
      if (!list.length) wrap.append(h('p', { class: 'ffb-books-empty', text: 'Every book you finish waits here.' }));
      else {
        const SPINE = { character: '#5a2b1c', prices: '#2d4231', gifts: '#4a2741', table: '#283a52' };
        const ul = h('ul', { class: 'ffb-books-list' });
        list.forEach((bk) => {
          const cov = h('span', { class: 'ffb-book-cov', 'aria-hidden': 'true' });
          cov.style.setProperty('--ffb-spine', SPINE[bk.k] || '#5a2b1c');
          const setPic = (u) => { if (!u || !cov.isConnected) return; const im = h('img', { src: u, alt: '', decoding: 'async', loading: 'lazy' }); im.addEventListener('error', () => im.remove(), { once: true }); cov.append(im); };
          const b = h('button', { type: 'button', class: 'ffb-book-btn' }, cov, h('span', { class: 'ffb-book-t', text: bk.t }));
          b.addEventListener('click', () => {
            snd('tap');
            const fb = FB();
            if (o && typeof o.close === 'function') o.close();
            Promise.resolve(fb ? fb.whenClosed() : null).then(() => { try { if (alive() && api.openBook) api.openBook(bk); } catch (e) { console.error(e); } });
          });
          ul.append(h('li', null, b));
          if (typeof bk.c === 'string' && bk.c) setTimeout(() => setPic(sized(bk.c, 96)), 0);
          else if (api.cover) { try { Promise.resolve(api.cover(bk, 96)).then(setPic, () => {}); } catch (e) { /* fine */ } }
        });
        wrap.append(ul);
      }
      el.textContent = '';
      el.append(wrap);
    }
    /* what the cart can still deal this reader: never one held, never one of Jan’s (signed in: none the account holds) */
    function cartLeft() {
      if (acctOn()) return (S.yost || []).filter((c) => !acctHas(c));
      const have = new Set(readCk().yost);
      return (S.yost || []).filter((c) => !have.has(c.slug) && !(S.bySlug && S.bySlug.has(c.slug)));
    }
    /* the portraits Yost can take: this browser’s, or (signed in) the account’s spares, one held twice or more */
    const tradeCards = () => {
      if (!acctOn()) return heldCards();
      const m = deckById();
      return [...A.st.spares.entries()].filter((e) => e[1] >= 2).map((e) => m.get(e[0])).filter(Boolean);
    };
    /* Jan’s portraits that can buy a pack: least precious first (the lowest tier, and not one of Jan’s picks, first).
       Ember is in the list and answers with Yost’s refusal */
    const isEmber = (c) => !!c && (c.id === EMBER_ID || c.slug === 'ember' || c.demo === 'ember');
    function tradeList() {
      const L = tradeCards();
      return L.map((c, i) => ({ c, i })).sort((a, b) => (TIERS.indexOf(a.c.tier) - TIERS.indexOf(b.c.tier)) || ((a.c.pick ? 1 : 0) - (b.c.pick ? 1 : 0)) || ((isEmber(a.c) ? 1 : 0) - (isEmber(b.c) ? 1 : 0)) || (a.i - b.i)).map((x) => x.c);
    }
    const tradeable = () => tradeCards().filter((c) => !isEmber(c));

    /* ---------------- the layer over the room: one dim, one thing on it at a time ---------------- */
    function layerUp(label) {
      if (layer && !layer.closing) {
        clearTimeout(layer.parkT); layer.parked = false;
        /* the same dim, a new thing on it (the next card, or Yost’s album handing over to his pack): the last one’s keys go */
        layer.esc = null; layer.outside = null; layer.onArrow = null; layer.t0 = Date.now();
        layer.root.removeAttribute('aria-labelledby');
        layer.root.setAttribute('aria-label', label);
        return layer;
      }
      const root = h('div', { class: 'lbc', role: 'dialog', 'aria-modal': 'true', 'aria-label': label });
      /* the dim is a way out a touch screen reader can find (a tap on it goes back, as it does for everyone) */
      const dim = h('div', { class: 'lbc-dim', role: 'button', 'aria-label': 'Back to the library' });
      root.append(dim);
      (F.el || document.body).append(root);
      const L = { root, dim, esc: null, outside: null, parked: false, parkT: 0, closing: false, left: false, back: document.activeElement, t0: Date.now() };
      L.onKey = (e) => {
        if (layer !== L) return;
        if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopImmediatePropagation(); if (L.esc) L.esc(); else layerDown(L); return; }
        if (e.key === 'Tab') trap(e, L.root);
        else if (L.onArrow && /^Arrow(Left|Right|Up|Down)$/.test(e.key)) {
          const t = e.target && e.target.nodeType === 1 ? e.target : null;
          if (!(t && (/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) || t.getAttribute('role') === 'tab'))) L.onArrow(e);
        }
      };
      window.addEventListener('keydown', L.onKey, true);
      /* a tap on the dim around the card (or the album) goes back to the room, never in the layer’s first 350 ms */
      root.addEventListener('click', (e) => {
        if (Date.now() - L.t0 < 350) return;
        const t = e.target;
        if (t === root || t === dim || (t.classList && t.classList.contains('lbc-col') && t.parentNode === root)) { if (L.parked) { L.left = true; layerDown(L); } else if (L.outside) L.outside(); }
      });
      let rz = 0;
      L.onResize = () => { if (rz) return; rz = requestAnimationFrame(() => { rz = 0; if (cur && cur.L === L) fitView(cur); if (album && album.L === L) refitAlbum(album); if (pack && pack.L === L && pack.v) fitView(pack.v); }); };
      window.addEventListener('resize', L.onResize);
      L.watch = setInterval(() => { if (!alive()) close(); }, 700);
      layer = L;
      requestAnimationFrame(() => root.classList.add('is-in'));
      return L;
    }
    /* the dim waits a moment after Draw another, for the next card. A reader who closes it meanwhile (a tap on it,
       Escape) has gone back to the room: the next show() with o.cont opens nothing (L.left) */
    function park(L) {
      L.parked = true; L.left = false; lastPark = L;
      L.esc = () => { L.left = true; layerDown(L); }; L.outside = null;
      clearTimeout(L.parkT);
      L.parkT = setTimeout(() => { if (L.parked) layerDown(L); }, 2600);
    }
    function layerDown(L, now) {
      if (!L || L.closing) return;
      L.closing = true;
      clearTimeout(L.parkT); clearInterval(L.watch);
      window.removeEventListener('keydown', L.onKey, true);
      window.removeEventListener('resize', L.onResize);
      if (layer === L) layer = null;
      const back = L.back;
      /* focus goes back where it was (the deck’s hotspot, the binder’s) when it was inside the layer */
      const gone = () => {
        const had = L.root.contains(document.activeElement);
        L.root.remove();
        if ((had || document.activeElement === document.body) && back && back.isConnected && typeof back.focus === 'function') { try { back.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
      };
      if (now) { gone(); return; }
      L.root.classList.remove('is-in');
      setTimeout(gone, RM() ? 180 : 280);
    }
    function trap(e, root) {
      const list = [...root.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])')].filter((el) => {
        if (el.disabled || el.closest('[inert], [aria-hidden="true"]')) return false;
        if (!el.getClientRects().length) return false;
        const cs = getComputedStyle(el); return cs.visibility !== 'hidden';
      });
      const zoomed = root.querySelector('.lbc-zoom');
      const pool = zoomed ? list.filter((el) => zoomed.contains(el)) : list;
      if (!pool.length) { e.preventDefault(); return; }
      const i = pool.indexOf(document.activeElement);
      e.preventDefault();
      const n = e.shiftKey ? (i <= 0 ? pool.length - 1 : i - 1) : (i < 0 || i >= pool.length - 1 ? 0 : i + 1);
      try { pool[n].focus({ preventScroll: true }); } catch (x) { /* fine */ }
    }
    const btn = (text, cls) => h('button', { type: 'button', class: 'lbc-btn' + (cls ? ' ' + cls : ''), text });
    const bump = (el) => { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); };
    /* the line under a card’s title, set (made when the card had none), read out once */
    function byLine(v, text) {
      let el = v.col.querySelector('.lbc-by');
      if (!el) { el = h('p', { class: 'lbc-by' }); const lab = v.col.querySelector('.lbc-label'); v.col.insertBefore(el, lab ? lab.nextSibling : v.stage); }
      if (el.textContent === text) return;
      el.setAttribute('aria-live', 'polite');
      el.textContent = text;
      fitView(v);
    }
    function spotRect(id) {
      try {
        const r = F.spotCss ? F.spotCss(id) : null; if (!r || !F.art) return null;
        const a = F.art.getBoundingClientRect();
        return { left: a.left + r.x, top: a.top + r.y, width: Math.max(8, r.w), height: Math.max(8, r.h) };
      } catch (e) { return null; }
    }

    /* ---------------- one card on the stage (show, and a pocket opened in the album) ---------------- */
    function makeView(L, holder, c, o) {
      const v = { L, c, o, state: 'new', anims: [], lean: null, turning: false, art: null, img: null };
      v.col = h('div', { class: 'lbc-col' });
      if (o.label) v.col.append(h('p', { class: 'lbc-label', text: o.label }));
      if (o.by) v.col.append(h('p', { class: 'lbc-by', text: o.by }));
      /* hhp-cv-stage: hoh-shop.js’s own sign for a stage that is scaled and leaned from outside (see the CSS) */
      v.stage = h('div', { class: 'lbc-stage hhp-cv-stage is-wait is-arriving' });
      v.under = h('div', { class: 'lbc-under' });
      v.acts = h('div', { class: 'lbc-acts' });
      v.col.append(v.stage, v.under, v.acts);
      holder.append(v.col);
      /* the glow takes the card’s turn, whichever turn it is (the Hall’s on a mouse, this file’s on a phone) */
      const isTurn = (e) => e.animationName === 'ffshopInspTurn' && e.target && e.target.classList && e.target.classList.contains('ffshop-card');
      v.stage.addEventListener('animationstart', (e) => { if (isTurn(e)) { v.stage.classList.add('is-turning'); snd('flip'); } });
      const off = (e) => { if (isTurn(e)) v.stage.classList.remove('is-turning'); };
      v.stage.addEventListener('animationend', off); v.stage.addEventListener('animationcancel', off);
      fitView(v);
      return v;
    }
    function fitView(v) {
      if (!v || !v.col || !v.col.isConnected) return;
      const host = F.el || document.documentElement;
      const fw = host.clientWidth || window.innerWidth, fh = host.clientHeight || window.innerHeight;
      const natural = Math.max(650, (v.art && v.art.offsetHeight) || 650);
      /* everything in the column but the card: its rows, the gaps between them and its padding */
      let chrome = 0;
      try {
        const cs = getComputedStyle(v.col), kids = [...v.col.children].filter((x) => x !== v.stage && x.offsetHeight);
        chrome = kids.reduce((a, x) => a + x.offsetHeight, 0) + kids.length * (parseFloat(cs.rowGap) || 0) + (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
      } catch (e) { chrome = 160; }
      /* a wide frame: about 58 percent of its height; a short one (the store’s header leaves a laptop about 500 px) may
         go to 66 percent, so the card never shrinks to a stamp. A phone: about 72 percent of the width */
      const tall = Math.max(0.58 * fh, Math.min(0.66 * fh, 360));
      let k = WIDE() ? Math.min(tall / natural, (fw - 64) / 380, 1.15) : Math.min(0.72 * fw / 380, 0.66 * fh / natural, 1);
      k = Math.max(0.24, Math.min(k, (fh - chrome - 6) / natural));
      v.k = k;
      v.stage.style.setProperty('--lbc-k', k.toFixed(4));
      v.stage.style.width = Math.round(380 * k) + 'px';
      v.stage.style.height = Math.round(natural * k) + 'px';
    }
    function glow(v) {
      const g = GLOW[v.c.tier] || GLOW.uncommon;
      let col = '';
      try { col = getComputedStyle(v.art).getPropertyValue('--rar').trim(); } catch (e) { col = ''; }
      if (!col) return;
      v.stage.style.setProperty('--lbc-glow-col', col); v.stage.style.setProperty('--lbc-glow-size', g[0]);
      v.stage.style.setProperty('--lbc-glow-min', g[1]); v.stage.style.setProperty('--lbc-glow-dur', g[2]);
      v.stage.setAttribute('data-glow', v.c.tier);
    }
    function mountCard(v, d) {
      v.stage.classList.remove('is-wait');
      v.stage.textContent = '';
      v.stage.append(d.box);
      v.art = d.art; v.img = d.img;
      if (d.coll) v.under.append(d.coll);
      if (!v.o.front) v.art.classList.add('on');
      try { window.hohShopWireCard(d.box.querySelector('.ffshop-tiltwrap')); } catch (e) { /* the card still shows */ }
      syncFaces(v.art);
      glow(v);
      /* a phone: the Hall’s card stays still on a touch screen (R578); here a tap turns it the Hall’s way */
      v.art.addEventListener('click', (e) => {
        if (v.state !== 'open' || !coarse()) return;
        if (e.target.closest && e.target.closest('.ffshop-gem, .ffshop-ffm-wrap')) return;
        if (v.turning) return;
        v.turning = true;
        turnCard(v.art).then(() => { v.turning = false; });
      });
    }
    function failView(v, acts, text) {
      v.stage.classList.remove('is-wait', 'is-arriving');
      v.stage.textContent = '';
      v.stage.append(h('div', { class: 'lbc-fail', text: text || 'This card stuck to the deck. Try again in a moment.' }));
      v.acts.textContent = '';
      acts.forEach((b) => v.acts.append(b));
      /* one button on its own spans the row on a phone */
      if (acts.length === 1) acts[0].classList.add('is-wide');
      v.state = 'open';
      v.col.classList.add('is-titled', 'is-shown');
      setTimeout(() => { try { acts[0].focus({ preventScroll: true }); } catch (e) { /* fine */ } }, 60);
    }
    /* the kit, the picture and the fonts, then the real card on the stage (null when the kit can’t load) */
    async function prepare(v) {
      const c = v.c, src = c.thumb || c.img;
      let ok = true;
      try { await Promise.race([Promise.all([ensureKit(SITE), preload(src, 2600)]), sleep(12000).then(() => { throw new Error('slow'); })]); } catch (e) { ok = false; }
      if (v.state === 'gone' || !alive()) return null;
      const d = ok ? drawCard(c, { src, number: !!v.o.number }) : null;
      if (!d) return null;
      mountCard(v, d);
      v.stage.style.visibility = 'hidden';
      fitView(v);
      try { await Promise.race([document.fonts && document.fonts.ready, sleep(900)]); } catch (e) { /* fine */ }
      if (v.state === 'gone') return null;
      fitView(v);
      v.stage.style.visibility = '';
      return d;
    }
    /* back up from where it came, turned over on the way in (o.front: already face up, from a pocket) */
    async function arrive(v) {
      v.state = 'arriving';
      if (RM()) {
        if (!v.o.front) { v.art.classList.remove('on'); syncFaces(v.art); }
        v.col.classList.add('is-titled');
        const a = v.stage.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' });
        v.anims.push(a);
        await a.finished.catch(() => {});
        return;
      }
      const r = v.stage.getBoundingClientRect(), from = rectOf(v.o.from);
      const t0 = from ? fromTransform(r, from, v.o.front ? 0 : -9) : 'translate(0px, ' + Math.round(r.height * 0.16) + 'px) scale(.8)';
      snd('whoosh');
      const fly = v.stage.animate([{ transform: t0, opacity: 0 }, { opacity: 1, offset: 0.14 }, { transform: 'none', opacity: 1 }],
        { duration: v.o.front ? 320 : 470, easing: 'cubic-bezier(.22,.8,.24,1)' });
      v.anims.push(fly);
      if (v.o.front) { v.col.classList.add('is-titled'); await fly.finished.catch(() => {}); return; }
      await sleep(300);
      if (v.state !== 'arriving') return;
      v.col.classList.add('is-titled');
      v.turning = true;
      await turnCard(v.art);
      v.turning = false;
      if (v.state !== 'arriving') return;
      await fly.finished.catch(() => {});
    }
    function opened(v, focusEl) {
      v.state = 'open';
      v.stage.classList.remove('is-arriving');
      v.col.classList.add('is-titled', 'is-shown');
      if (typeof window.hohCardLean === 'function') { try { v.lean = window.hohCardLean(v.stage, { moteParent: v.L.root, moteClass: 'lbc-mote', hostClass: 'lbc-mote-host' }); } catch (e) { v.lean = null; } }
      if (focusEl) setTimeout(() => { if (v.state === 'open') { try { focusEl.focus({ preventScroll: true }); } catch (e) { /* fine */ } } }, 40);
      /* the full picture behind the thumb, quietly, when the reader isn’t saving data (the Hall’s card view does the same).
         A Yost hero’s picture sits on the Hall’s own storage at full size (it can’t be asked smaller), so a phone keeps
         the thumb */
      const c = v.c, im = v.img;
      if (im && c.img && c.img !== c.thumb && !saveData() && (c.ff !== false || WIDE())) preload(c.img).then((ok) => { if (ok && im.isConnected && im.style.display !== 'none') im.src = c.img; });
    }
    function release(v) {
      if (v.lean) { try { v.lean.release(); } catch (e) { /* fine */ } v.lean = null; }
      v.anims.forEach((a) => { try { a.cancel(); } catch (e) { /* fine */ } });
      v.anims = [];
    }
    /* the card goes back where it came from (or to `to`), or simply fades */
    async function flyOut(v, to) {
      release(v);
      v.col.classList.remove('is-shown', 'is-titled');
      v.acts.querySelectorAll('button').forEach((b) => { b.disabled = true; });
      if (RM() || !v.art) { await v.col.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160, fill: 'forwards' }).finished.catch(() => {}); return; }
      const r = v.stage.getBoundingClientRect(), dest = rectOf(to);
      const t1 = dest ? fromTransform(r, dest, -6) : 'translate(0px, ' + Math.round(r.height * 0.12) + 'px) scale(.86)';
      await v.stage.animate([{ transform: 'none', opacity: 1 }, { transform: t1, opacity: 0 }], { duration: dest ? 250 : 200, easing: 'cubic-bezier(.5,0,.75,.4)', fill: 'forwards' }).finished.catch(() => {});
    }

    /* ---------------- show: a card over the dimmed room ---------------- */
    /* the time to tomorrow’s pack, as the line shows it (5:12:09) and as a screen reader hears it, once, in words */
    const clock = (ms) => { const s = Math.max(0, Math.ceil(ms / 1000)), hh = Math.floor(s / 3600), mm = Math.floor(s / 60) % 60, ss = s % 60; return hh + ':' + String(mm).padStart(2, '0') + ':' + String(ss).padStart(2, '0'); };
    function inWords(ms) {
      const m = Math.max(0, Math.floor(ms / 60000)), hh = Math.floor(m / 60), mm = m % 60;
      if (!hh && !mm) return 'under a minute';
      const hs = hh === 1 ? '1 hour' : hh + ' hours', ns = mm === 1 ? '1 minute' : mm + ' minutes';
      return hh && mm ? hs + ' and ' + ns : hh ? hs : ns;
    }
    const PACK_WAITS = 'A new pack is waiting in the deck.';
    async function show(c, o) {
      o = Object.assign({}, o || {});
      /* the next draw after Draw another, and the reader closed the waiting dim meanwhile: they went back to the room */
      const parked = lastPark; lastPark = null;
      if (o.cont && parked && parked.left) return 'library';
      if (!c || !alive()) return 'library';
      warm();
      if (album) shutAlbum(album, true);
      if (cur) endShow(cur, 'library', true);
      if (pack) dropPack(pack);
      const label = o.label || LABEL;
      const L = layerUp(label);
      let done = null;
      const p = new Promise((r) => { done = r; });
      const v = makeView(L, L.root, c, { label, by: o.by || null, from: o.from, number: true, front: !!o.front });
      v.done = done; v.how = null;
      cur = v;
      /* one button. A deck draw goes on (Draw another), a pack card shown in turn goes to the next (o.next), a card
         opened from the pack’s screen goes back to it (o.zoom), anything else goes back to the room. Only a gift
         (o.free, the walker’s card) is kept */
      const gift = o.free === true, draw = !gift && o.draw === true && o.again !== false, step = !gift && !draw && o.next === true;
      const back = o.zoom ? 'Back to the pack' : 'Back to the library';
      let more = draw || step;
      const one = btn(draw ? 'Draw another' : step ? 'Next card' : back, 'is-main');
      const box = h('div', { class: 'lbc-one is-wide' }, one);
      L.dim.setAttribute('aria-label', back);
      /* under a deck draw: the time until tomorrow’s pack, ticking each second. A screen reader hears it once, in words
         (the label); the ticks are never announced */
      let timer = null;
      if (draw) {
        timer = h('p', { class: 'lbc-timer', role: 'timer', 'aria-live': 'off' });
        box.append(timer);
        /* the way back, in words (a tap on the dim or Escape does the same, but a phone shows neither) */
        const home = btn(back, 'is-quiet');
        home.addEventListener('click', () => { if (!(v.state === 'open' || v.state === 'arriving')) return; snd('tap'); leave(v, 'library'); });
        box.append(home);
        v.home = home;
        const t0 = todayNow();
        timer.setAttribute('aria-label', t0.pack ? PACK_WAITS : 'Tomorrow’s pack opens in ' + inWords(t0.nextAt - Date.now()));
        const tick = () => {
          v.tickT = 0;
          if (v.state === 'gone' || v.state === 'leaving') return;
          const t = todayNow(), left = t.nextAt - Date.now();
          if (t.pack || left <= 0) {
            /* midnight came while the card was up: the button opens today’s pack */
            timer.textContent = PACK_WAITS; timer.setAttribute('aria-label', PACK_WAITS);
            one.textContent = 'Open a pack';
            return;
          }
          timer.textContent = 'Tomorrow’s pack opens in ' + clock(left);
          v.tickT = setTimeout(tick, (left % 1000) + 30);
        };
        tick();
      }
      v.acts.append(box);
      fitView(v);
      one.addEventListener('click', () => {
        if (more ? v.state !== 'open' : !(v.state === 'open' || v.state === 'arriving')) return;
        snd('tap'); leave(v, more ? 'again' : 'library');
      });
      L.esc = () => leave(v, 'library');
      L.outside = () => { if (v.state === 'open') leave(v, 'library'); };
      /* signed in (BINDER-04): the walker’s card goes into the account’s binder, asked for while the card gets ready */
      const giftP = gift ? acctReady(3000).then((on) => (on ? acctGift(c) : null)) : null;
      const d = await prepare(v);
      const ag = giftP ? await giftP : null;
      if (ag && ag.got) { try { if (api.added) api.added(c); } catch (e) { /* the room’s binder catches up on its own */ } }
      /* closed while it was getting ready: leave() is already taking it away */
      if (v.state === 'gone' || v.state === 'leaving') return p;
      if (!d) { more = false; one.textContent = back; if (timer) { clearTimeout(v.tickT); timer.remove(); } if (v.home) v.home.remove(); failView(v, [one]); return p; }
      /* a gift is the reader’s from here, even if they close it while it flies in (signed in: once the account kept it) */
      const had = ag ? ag.had : has(c.slug);
      const got = ag ? ag.got : gift && !had && hold(c);
      if (got && !ag) { try { if (api.added) api.added(c); } catch (e) { /* the room’s binder catches up on its own */ } }
      if (gift && (o.by || had || got)) byLine(v, (o.by ? o.by + (had || got ? '. ' : '') : '') + (had ? 'Already in your collection.' : got ? 'Added to your collection.' : ''));
      else if (draw && !o.by) byLine(v, had ? 'Already in your collection.' : 'Just a look. Your binder fills from the daily pack.');
      await arrive(v);
      if (v.state !== 'arriving') return p;
      opened(v, one);
      if (got) { snd('gold'); stamp(v); }
      /* the next card’s picture, so the next turn is quick */
      if (draw) { const nx = peek(); if (nx) preload(nx.thumb || nx.img); }
      return p;
    }
    async function leave(v, how) {
      if (v.state === 'leaving' || v.state === 'gone') return;
      v.state = 'leaving';
      await flyOut(v, how === 'again' || how === 'library' ? v.o.from : null);
      endShow(v, how);
    }
    function endShow(v, how, now) {
      if (v.state === 'gone') return;
      clearTimeout(v.tickT);
      release(v);
      v.state = 'gone';
      if (cur === v) cur = null;
      v.col.remove();
      if (how === 'again' && !now) park(v.L);
      else if (how !== 'album') layerDown(v.L, now);
      if (how !== 'album' && v.done) { const d = v.done; v.done = null; d(how === 'again' ? 'again' : 'library'); }
    }
    /* a card going in: a ring of light on the card, and a small copy flies into the binder in the room */
    function stamp(v) {
      if (RM()) return;
      const ring = h('div', { class: 'lbc-ring' });
      v.stage.append(ring);
      ring.animate([{ opacity: 0, transform: 'scale(.97)' }, { opacity: 1, transform: 'scale(1)', offset: 0.25 }, { opacity: 0, transform: 'scale(1.05)' }], { duration: 640, easing: 'ease-out' }).finished.catch(() => {}).then(() => ring.remove());
      const tgt = spotRect('binder');
      const root = v.L.root.getBoundingClientRect(), sr = v.stage.getBoundingClientRect();
      const gim = h('img', { src: v.c.thumb || v.c.img || '', alt: '', decoding: 'async' });
      gim.setAttribute('style', frameStyle(v.c));
      const ghost = h('div', { class: 'lbc-ghost' }, gim);
      v.L.root.append(ghost);
      const gw = 40, gh = 68, x0 = sr.left - root.left + sr.width / 2 - gw / 2, y0 = sr.top - root.top + sr.height * 0.4 - gh / 2;
      let x1, y1, s1;
      if (tgt) { x1 = tgt.left - root.left + tgt.width / 2 - gw / 2; y1 = tgt.top - root.top + tgt.height / 2 - gh / 2; s1 = 0.45; }
      else { const ab = v.acts.getBoundingClientRect(); x1 = ab.left - root.left + ab.width / 2 - gw / 2; y1 = ab.top - root.top - gh / 2; s1 = 0.3; }
      const mx = (x0 + x1) / 2, my = Math.min(y0, y1) - Math.max(40, Math.abs(x1 - x0) * 0.25);
      const fly = ghost.animate([
        { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1.4) rotate(0deg)', opacity: 0 },
        { transform: 'translate(' + x0 + 'px,' + (y0 - 10) + 'px) scale(1.25) rotate(-4deg)', opacity: 1, offset: 0.16 },
        { transform: 'translate(' + mx + 'px,' + my + 'px) scale(.9) rotate(8deg)', opacity: 1, offset: 0.58 },
        { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(' + s1 + ') rotate(14deg)', opacity: 0.9 }
      ], { duration: 640, easing: 'cubic-bezier(.45,.05,.4,1)', fill: 'forwards' });
      fly.finished.catch(() => {}).then(() => {
        ghost.remove();
        if (!alive() || !tgt) return;
        try { if (FFD.fx && FFD.fx.sparks) FFD.fx.sparks(v.L.root, { x: tgt.left + tgt.width / 2, y: tgt.top + tgt.height / 2, n: 14, spread: 46 }); } catch (e) { /* fine */ }
        snd('land');
      });
    }
    /* ---------------- the album ---------------- */
    async function binder() {
      if (!alive()) return;
      if (album) return album.p;
      /* signed in (BINDER-04): the binder on the table is the Hall binder */
      if (binderOn) return;
      if (await acctReady(3000)) { if (alive()) await acctAlbum(null); return; }
      if (!alive()) return;
      if (album) return album.p;
      if (cur) endShow(cur, 'library', true);
      if (pack) dropPack(pack);
      return openAlbum(null);
    }
    /* the album’s sides: every card held, in one grid in the reader’s own order, and the books read. In trade mode (Yost
       asking for a portrait) only Jan’s, least precious first, with no tabs and no moving; the album then resolves with
       the card picked. While a card is lifted the grid shows the lifted order (A.drag.list) */
    const SIDES = ['cards', 'books'];
    const sideList = (A) => (A.drag ? A.drag.list : A.trade ? tradeList() : collection());
    async function openAlbum(fresh, oo) {
      oo = oo || {};
      const trade = !!oo.trade;
      const L = layerUp(trade ? 'Trade a portrait' : 'Your collection');
      L.dim.setAttribute('aria-label', trade ? 'Keep my cards' : 'Back to the library');
      const n = ++uid;
      const freshSet = fresh ? new Set([lc(fresh.slug)]) : Array.isArray(oo.fresh) && oo.fresh.length ? new Set(oo.fresh.map(lc)) : null;
      /* pk: each card’s pocket, kept while the album is open, so a moved card and its neighbours are moved, not redrawn */
      const A = { L, page: 0, per: 9, two: false, side: 'cards', zoom: null, state: 'opening', fresh: freshSet, trade, picked: null, pk: new Map(), drag: null, pend: null, dragEnd: 0 };
      A.p = new Promise((r) => { A.resolve = r; });
      album = A;
      const title = h('h2', { class: 'lbc-atitle', id: 'lbc-at-' + n, tabindex: '-1', text: trade ? 'Trade a portrait' : 'Your collection' });
      A.countEl = h('p', { class: 'lbc-acount', 'aria-live': 'polite' });
      A.quills = h('p', { class: 'lbc-quills', hidden: true });
      const tab = (side, text) => h('button', { type: 'button', class: 'lbc-tab', role: 'tab', id: 'lbc-t' + side.charAt(0) + '-' + n, 'aria-controls': (side === 'books' ? 'lbc-sb-' : 'lbc-sc-') + n },
        h('span', { class: 'lbc-tl', text }));
      A.tabs = { cards: tab('cards', 'Heroes'), books: tab('books', 'Books you’ve read') };
      A.tablist = h('div', { class: 'lbc-tabs', role: 'tablist', 'aria-label': 'Your collection' }, A.tabs.cards, A.tabs.books);
      /* for keyboard and screen reader users: how a card moves (read with each pocket), and where it went */
      A.hint = h('span', { class: 'lbc-sr', id: 'lbc-mv-' + n, text: 'Hold Shift and press an arrow key to move it.' });
      A.live = h('p', { class: 'lbc-sr', 'aria-live': 'polite' });
      A.pagesEl = h('div', { class: 'lbc-pages' });
      A.spread = h('div', { class: 'lbc-spread' }, A.pagesEl);
      A.prev = h('button', { type: 'button', class: 'lbc-turn', 'aria-label': 'Turn back a page', html: ICON_PREV });
      A.next = h('button', { type: 'button', class: 'lbc-turn', 'aria-label': 'Turn the page', html: ICON_NEXT });
      A.pageNo = h('span', { class: 'lbc-pageno', 'aria-live': 'polite' });
      A.turnRow = h('div', { class: 'lbc-turnrow' }, A.prev, A.pageNo, A.next);
      A.sideCards = h('div', { class: 'lbc-side', id: 'lbc-sc-' + n, role: 'tabpanel', 'aria-labelledby': A.tabs.cards.id }, A.spread, A.turnRow);
      A.booksEl = h('ul', { class: 'lbc-books' });
      A.sideBooks = h('div', { class: 'lbc-side', id: 'lbc-sb-' + n, role: 'tabpanel', 'aria-labelledby': A.tabs.books.id, hidden: true }, A.booksEl);
      A.binderEl = h('div', { class: 'lbc-binder' },
        h('div', { class: 'lbc-ahead' }, title, A.countEl, A.quills, A.tablist),
        A.sideCards, A.sideBooks, A.hint, A.live);
      const back = btn(trade ? 'Keep my cards' : 'Return to the library', 'is-quiet is-wide');
      A.el = h('div', { class: 'lbc-album', 'aria-labelledby': 'lbc-at-' + n }, A.binderEl, h('div', { class: 'lbc-acts lbc-acts--album' }, back));
      A.el.style.visibility = 'hidden';
      L.root.append(A.el);
      L.root.setAttribute('aria-labelledby', 'lbc-at-' + n);
      /* Escape puts a lifted card back first */
      L.esc = () => (A.drag ? dropDrag(A, false) : A.zoom ? zoomOut(A) : shutAlbum(A));
      L.outside = () => { if (!A.zoom && !A.drag) shutAlbum(A); };
      /* Left and Right turn the page; with Shift, every arrow moves the focused card (Up and Down by a row) */
      L.onArrow = (e) => {
        if (A.zoom || A.side === 'books' || A.drag) return;
        const pk = e.target && e.target.closest ? e.target.closest('button.lbc-pocket') : null;
        if (e.shiftKey && pk && !A.trade && pk.dataset.slug) { e.preventDefault(); moveBy(A, pk.dataset.slug, { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -3, ArrowDown: 3 }[e.key]); return; }
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault(); turnPage(A, e.key === 'ArrowLeft' ? -1 : 1);
      };
      /* a lifted card on a touch screen holds the page still (the hold itself never scrolls anything) */
      A.el.addEventListener('touchmove', (e) => { if (A.drag && e.cancelable) e.preventDefault(); }, { passive: false });
      back.addEventListener('click', () => { snd('tap'); shutAlbum(A); });
      SIDES.forEach((s) => {
        const t = A.tabs[s];
        t.addEventListener('click', () => sideTo(A, s));
        /* the arrow keys go round the tabs that show */
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault(); e.stopPropagation();
          const vis = SIDES.filter((x) => !A.tabs[x].hidden), i = Math.max(0, vis.indexOf(s));
          const to = vis[(i + (e.key === 'ArrowLeft' ? vis.length - 1 : 1)) % vis.length];
          A.tabs[to].focus(); sideTo(A, to);
        });
      });
      A.prev.addEventListener('click', () => turnPage(A, -1));
      A.next.addEventListener('click', () => turnPage(A, 1));
      /* a swipe turns the page on a phone */
      let sx = 0, sy = 0, sid = null;
      A.spread.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; sid = e.pointerId; sx = e.clientX; sy = e.clientY; });
      A.spread.addEventListener('pointerup', (e) => {
        if (e.pointerId !== sid) return; sid = null;
        /* the end of a card’s move is never a swipe */
        if (A.drag || Date.now() - A.dragEnd < 400) return;
        const dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) > 44 && Math.abs(dy) < 70) { A.swiped = Date.now(); turnPage(A, dx < 0 ? 1 : -1); }
      });
      A.spread.addEventListener('pointercancel', () => { sid = null; });
      snd('rustle');
      /* Yost’s cards need his cart to know their heroes (the album opens without it after 4 s and fills in after) */
      const wantYost = !trade && yostHeld().length > 0;
      await Promise.race([Promise.all([loadDeck(SITE), wantYost ? loadYost(SITE) : null]), sleep(4000)]);
      if (A.state === 'gone') return A.p;
      if (wantYost && !S.yost) loadYost(SITE).then(() => { if (album === A && A.state !== 'gone' && !A.drag) { renderPage(A, 0); paintCount(A); } });
      A.freshIdx = -1;
      if (A.fresh) A.freshIdx = sideList(A).findIndex((x) => A.fresh.has(x.slug));
      /* pockets show their portraits until the kit arrives, then their real cards */
      if (!S.kitOk && sideList(A).length) ensureKit(SITE).then(() => { if (A.state !== 'gone' && album === A && !A.drag) renderPage(A, 0); }).catch(() => {});
      renderAll(A);
      A.el.style.visibility = '';
      await albumIn(A);
      if (A.state === 'gone') return A.p;
      A.state = 'open';
      try {
        const first = trade ? A.pagesEl.querySelector('button.lbc-pocket') : null;
        (first || (!trade && sideList(A).length ? A.tabs[A.side] : title)).focus({ preventScroll: true });
      } catch (e) { /* fine */ }
      return A.p;
    }
    function renderAll(A) {
      /* trade mode shows no tabs */
      A.tablist.hidden = A.trade;
      paintCount(A);
      sideTo(A, A.side, true);
      refitAlbum(A, true);
    }
    function paintCount(A) {
      if (A.trade) A.countEl.textContent = 'Pick one for a pack of three';
      else if (A.side === 'books') { const b = booksRead().length; A.countEl.textContent = b === 1 ? '1 book read' : b + ' books read'; }
      else { const c = sideList(A).length; A.countEl.textContent = c === 1 ? '1 hero' : c + ' heroes'; }
      let q = 0;
      try { const tr = api.trophies && !A.trade ? api.trophies() : null; q = tr ? Math.max(0, Math.floor(+tr.feathers || 0)) : 0; } catch (e) { q = 0; }
      A.quills.hidden = !q;
      A.quills.textContent = q === 1 ? '1 gold feather' : q + ' gold feathers';
    }
    function booksRead() { try { const b = api.booksRead ? api.booksRead() : []; return Array.isArray(b) ? b.filter((x) => x && x.t) : []; } catch (e) { return []; } }
    function sideTo(A, side, quiet) {
      if (!A.tabs[side] || A.tabs[side].hidden) side = 'cards';
      if (A.drag) dropDrag(A, false);
      A.side = side;
      SIDES.forEach((s) => { const t = A.tabs[s]; t.setAttribute('aria-selected', s === side ? 'true' : 'false'); t.tabIndex = s === side ? 0 : -1; });
      const cardSide = side === 'cards';
      if (!cardSide) { sizeBooks(A); renderBooks(A); }
      A.sideCards.hidden = !cardSide; A.sideBooks.hidden = cardSide;
      if (!quiet) { snd('tap'); const s = cardSide ? A.sideCards : A.sideBooks; s.classList.remove('is-swap'); void s.offsetWidth; s.classList.add('is-swap'); }
      paintCount(A);
    }
    /* the pocket size: three even rows a page, two pages side by side on a wide frame, never past the frame */
    function refitAlbum(A, first) {
      if (!A || !A.el.isConnected) return;
      /* the pockets are about to move under a lifted card: it goes back where it was */
      if (A.drag) dropDrag(A, false);
      const host = F.el || document.documentElement;
      const fw = host.clientWidth || window.innerWidth, fh = host.clientHeight || window.innerHeight;
      /* a short, wide frame (a phone on its side) gets the two-page spread too, with the album's head on one line and its
         way back in the page-turn row (is-low), so two even rows of readable pockets fit its height */
      const low = fh < 500 && fw >= 560 && fw > fh * 1.3;
      const two = (WIDE() && fw >= 760) || low;
      A.el.classList.toggle('is-low', low);
      /* a short wide frame keeps its pockets readable with two even rows a page instead of three */
      const rows = two && fh < 640 ? 2 : 3;
      const changed = two !== A.two || rows !== A.rows;
      const firstShown = A.page * (A.per || 9);
      A.two = two; A.rows = rows; A.per = (two ? 2 : 1) * rows * 3;
      /* the page that holds the card just added, or the one that keeps the reader’s place when the layout changes */
      if (first && A.freshIdx >= 0) A.page = Math.floor(A.freshIdx / A.per);
      else if (changed) A.page = Math.floor(firstShown / A.per);
      A.el.classList.toggle('is-two', two);
      const gap = two ? 10 : 7, pp = two ? 14 : 10, pad = 6;
      A.el.style.setProperty('--lbc-gap', gap + 'px'); A.el.style.setProperty('--lbc-pp', pp + 'px');
      if (changed || first) renderPage(A, 0);
      /* everything but the pockets: the album’s padding and its last row, the binder’s padding, head and page turner */
      let chrome = 230;
      try {
        const px = (x) => parseFloat(x) || 0, ca = getComputedStyle(A.el), cb = getComputedStyle(A.binderEl);
        const acts = A.el.querySelector('.lbc-acts--album'), head = A.binderEl.querySelector('.lbc-ahead');
        const actsIn = !acts || getComputedStyle(acts).position !== 'absolute';
        chrome = px(ca.paddingTop) + px(ca.paddingBottom) + (actsIn ? px(ca.rowGap) + (acts ? acts.offsetHeight : 44) : 0) + px(cb.paddingTop) + px(cb.paddingBottom) +
          (head ? head.offsetHeight : 50) + (A.turnRow.hidden ? 0 : A.turnRow.offsetHeight || 52) + 8;
      } catch (e) { chrome = 230; }
      const shellW = Math.min(fw - 12, two ? 1180 : 600) - 28;
      const wFit = two ? ((shellW - 22) / 2 - pp * 2 - gap * 2) / 3 : (shellW - pp * 2 - gap * 2) / 3;
      const hFit = ((fh - chrome - pp * 2 - gap * (rows - 1)) / rows - pad) * 380 / 650 + pad;
      const pw = Math.max(52, Math.floor(Math.min(wFit, hFit, two ? 142 : 128)));
      const pk = (pw - pad) / 380, ph = Math.round(650 * pk + pad);
      A.el.style.setProperty('--lbc-pw', pw + 'px'); A.el.style.setProperty('--lbc-ph', ph + 'px'); A.el.style.setProperty('--lbc-pk', pk.toFixed(4));
      /* the grid’s numbers, for finding the pocket under a lifted card without asking moving pockets where they are */
      A.geo = { pw, ph, gap, pp };
      /* the pockets’ place, worked out from the same numbers (the books side borrows it) */
      const pageW = 3 * pw + 2 * gap + 2 * pp, pageH = rows * ph + (rows - 1) * gap + 2 * pp;
      A.size = [two ? pageW * 2 + 22 : pageW, pageH + (A.turnRow.hidden ? 0 : 52)];
      sizeBooks(A);
      if (A.zoom && A.zoom.v) fitView(A.zoom.v);
    }
    /* the books side takes the place the pockets had, so the album never changes size between its sides */
    function sizeBooks(A) {
      if (!A.size) return;
      A.booksEl.style.width = A.size[0] + 'px';
      A.booksEl.style.height = A.size[1] + 'px';
    }
    /* the spread for A.page. o.flip: the pockets glide from where they stood to their new places (a card being moved and
       the ones making room for it); the pocket a lifted card left never glides, so the card can land on it */
    function renderPage(A, dir, o) {
      o = o || {};
      const list = sideList(A), per = A.per, pages = Math.max(1, Math.ceil(list.length / per));
      A.page = Math.max(0, Math.min(A.page, pages - 1));
      const slice = list.slice(A.page * per, A.page * per + per);
      const perPage = (A.rows || 3) * 3;
      const before = o.flip && !RM() ? new Map([...A.pagesEl.querySelectorAll('button.lbc-pocket')].map((b) => [b, b.getBoundingClientRect()])) : null;
      const mk = (from) => {
        const page = h('div', { class: 'lbc-page' + (A.two ? (from ? ' is-right' : ' is-left') : '') });
        for (let i = 0; i < perPage; i++) {
          const c = slice[from + i];
          page.append(c ? pocketFor(A, c) : h('span', { class: 'lbc-pocket is-empty', 'aria-hidden': 'true' }));
        }
        return page;
      };
      A.pagesEl.textContent = '';
      A.pagesEl.append(mk(0));
      if (A.two) { A.pagesEl.append(h('div', { class: 'lbc-spine', 'aria-hidden': 'true' }, h('i'), h('i'), h('i'))); A.pagesEl.append(mk(perPage)); }
      const old = A.spread.querySelector('.lbc-empty'); if (old) old.remove();
      if (!list.length) A.spread.append(h('p', { class: 'lbc-empty', text: 'Tap the deck for today’s pack. Your heroes wait here.' }));
      A.prev.disabled = A.page <= 0; A.next.disabled = A.page >= pages - 1;
      A.turnRow.hidden = pages <= 1;
      A.el.classList.toggle('has-turn', pages > 1);
      A.pageNo.textContent = 'Page ' + (A.page + 1) + ' of ' + pages;
      if (dir && !RM()) { A.pagesEl.classList.remove('is-turn-l', 'is-turn-r'); void A.pagesEl.offsetWidth; A.pagesEl.classList.add(dir < 0 ? 'is-turn-l' : 'is-turn-r'); }
      if (before) {
        A.pagesEl.querySelectorAll('button.lbc-pocket').forEach((b) => {
          if (b.classList.contains('is-hole')) return;
          const r0 = before.get(b);
          if (!r0) { b.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' }); return; }
          const r1 = b.getBoundingClientRect(), dx = r0.left - r1.left, dy = r0.top - r1.top;
          if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
          b.animate([{ transform: 'translate(' + dx + 'px, ' + dy + 'px)' }, { transform: 'none' }], { duration: 200, easing: 'cubic-bezier(.2,.8,.2,1)' });
        });
      }
    }
    function turnPage(A, d) {
      if (A.drag) return;
      const pages = Math.max(1, Math.ceil(sideList(A).length / A.per));
      const to = A.page + d;
      if (to < 0 || to >= pages) return;
      A.page = to; A.fresh = null;
      snd('rustle');
      renderPage(A, d);
    }
    /* a card’s pocket, made once while the album is open (a picture-only pocket is made again once the kit is in) */
    function pocketFor(A, c) {
      let b = A.pk.get(c.slug);
      if (b && S.kitOk && b.classList.contains('is-photo')) b = null;
      if (!b) { b = pocket(A, c); A.pk.set(c.slug, b); }
      return b;
    }
    function pocket(A, c) {
      const b = h('button', { type: 'button', class: 'lbc-pocket', 'data-slug': c.slug, 'aria-label': c.name + (A.trade ? ', offer this card to Old Yost' : ', open the card') });
      if (!A.trade) b.setAttribute('aria-describedby', A.hint.id);
      if (S.kitOk && typeof window.hohShopCardHtml === 'function') {
        const d = drawCard(c, { src: c.thumb || c.img, number: false });
        if (d) {
          d.box.setAttribute('aria-hidden', 'true'); d.art.setAttribute('tabindex', '-1');
          b.append(d.box);
          requestAnimationFrame(() => { if (b.isConnected) { try { window.hohShopWireCard(d.box.querySelector('.ffshop-tiltwrap')); } catch (e) { /* fine */ } } });
        }
      }
      if (!b.firstChild) {
        b.classList.add('is-photo');
        const im = h('img', { class: 'lbc-pthumb', src: c.thumb || c.img, alt: '', decoding: 'async', draggable: 'false' });
        im.setAttribute('style', frameStyle(c));
        b.append(im);
      }
      /* a card just added glows once (a pocket put back on the page later doesn’t glow again) */
      if (A.fresh && A.fresh.has(c.slug)) { b.classList.add('is-new'); b.addEventListener('animationend', () => b.classList.remove('is-new'), { once: true }); }
      const keepsEmber = A.trade && isEmber(c);
      if (keepsEmber) b.classList.add('is-kept');
      b.addEventListener('click', () => {
        if (A.swiped && Date.now() - A.swiped < 400) return;
        /* the release at the end of a move is not a tap */
        if (A.drag || Date.now() - A.dragEnd < 400) return;
        if (keepsEmber) { refuse(A, b); return; }
        zoomIn(A, c, b);
      });
      if (!A.trade) wireDrag(A, b, c);
      return b;
    }

    /* ---------------- moving a card in the binder ---------------- */
    const HOLD_MS = 300, EDGE_MS = 600;
    /* a mouse lifts the card once it moves 6 px with the button down; a finger or a pen lifts it after holding still for
       HOLD_MS (moving 10 px first is a swipe or a scroll, and the card stays) */
    function wireDrag(A, b, c) {
      b.addEventListener('dragstart', (e) => e.preventDefault());
      b.addEventListener('contextmenu', (e) => { if (A.pend || A.drag) e.preventDefault(); });
      b.addEventListener('pointerdown', (e) => {
        if (A.state !== 'open' || A.zoom || A.drag || A.pend || A.side !== 'cards' || A.trade) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        const P = { id: e.pointerId, type: e.pointerType || 'mouse', x0: e.clientX, y0: e.clientY, x: e.clientX, y: e.clientY, b, c, t: 0 };
        const mv = (ev) => {
          if (ev.pointerId !== P.id) return;
          P.x = ev.clientX; P.y = ev.clientY;
          if (A.drag && A.drag.P === P) { dragMove(A, P.x, P.y); return; }
          const d = Math.hypot(P.x - P.x0, P.y - P.y0);
          if (P.type === 'mouse') { if (d > 6) lift(A, P); }
          else if (d > 10) P.off();
        };
        const up = (ev) => { if (ev.pointerId !== P.id) return; const lifted = A.drag && A.drag.P === P; P.off(); if (lifted) dropDrag(A, true); };
        const cancel = (ev) => { if (ev.pointerId !== P.id) return; const lifted = A.drag && A.drag.P === P; P.off(); if (lifted) dropDrag(A, false); };
        P.off = () => {
          window.removeEventListener('pointermove', mv, true); window.removeEventListener('pointerup', up, true); window.removeEventListener('pointercancel', cancel, true);
          clearTimeout(P.t);
          if (A.pend === P) A.pend = null;
        };
        A.pend = P;
        window.addEventListener('pointermove', mv, true); window.addEventListener('pointerup', up, true); window.addEventListener('pointercancel', cancel, true);
        if (P.type !== 'mouse') P.t = setTimeout(() => { if (A.pend === P && !A.drag) lift(A, P); }, HOLD_MS);
      });
    }
    /* the card comes up under the pointer and its pocket stays behind as an empty sleeve */
    function lift(A, P) {
      if (A.drag || A.state !== 'open' || A.zoom || !P.b.isConnected) return;
      const list = sideList(A).slice(), from = list.findIndex((x) => x.slug === P.c.slug);
      if (from < 0) return;
      const r = P.b.getBoundingClientRect(), root = A.L.root.getBoundingClientRect();
      const g = h('div', { class: 'lbc-pocket lbc-lift', 'aria-hidden': 'true' });
      [...P.b.childNodes].forEach((x) => g.append(x.cloneNode(true)));
      ['--lbc-pw', '--lbc-ph', '--lbc-pk'].forEach((k) => g.style.setProperty(k, A.el.style.getPropertyValue(k)));
      g.style.width = r.width + 'px'; g.style.height = r.height + 'px';
      A.L.root.append(g);
      const D = { P, c: P.c, list, orig: list.slice(), from, at: from, page0: A.page, g, ox: P.x - r.left, oy: P.y - r.top, rx: root.left, ry: root.top, x: P.x, y: P.y, edge: 0, edgeT: 0, out: false };
      A.drag = D;
      P.b.classList.add('is-hole');
      A.el.classList.add('is-dragging');
      snd('tap');
      if (P.type !== 'mouse') { try { if (FFD.buzz) FFD.buzz(12); } catch (e) { /* fine */ } }
      ghostAt(D, P.x, P.y);
    }
    function ghostAt(D, x, y) {
      D.g.style.transform = 'translate(' + Math.round(x - D.rx - D.ox) + 'px, ' + Math.round(y - D.ry - D.oy) + 'px)' + (RM() ? '' : ' rotate(-3deg) scale(1.06)');
    }
    /* the pocket under (x, y) on the spread, as an index into the whole list, or -1 over the spine or off the pages */
    function slotAt(A, x, y) {
      const g = A.geo; if (!g) return -1;
      const perPage = (A.rows || 3) * 3;
      let at = -1;
      [...A.pagesEl.querySelectorAll('.lbc-page')].forEach((pg, pi) => {
        const r = pg.getBoundingClientRect();
        if (x < r.left || x > r.right || y < r.top - 24 || y > r.bottom + 24) return;
        const col = Math.max(0, Math.min(2, Math.floor((x - r.left - g.pp + g.gap / 2) / (g.pw + g.gap))));
        const row = Math.max(0, Math.min((A.rows || 3) - 1, Math.floor((y - r.top - g.pp + g.gap / 2) / (g.ph + g.gap))));
        at = A.page * A.per + pi * perPage + row * 3 + col;
      });
      return at;
    }
    function dragMove(A, x, y) {
      const D = A.drag; if (!D) return;
      D.x = x; D.y = y;
      ghostAt(D, x, y);
      /* off the binder: the card would go back where it was, and the cards say so by going back now */
      const br = A.binderEl.getBoundingClientRect(), M = 28;
      if (x < br.left - M || x > br.right + M || y < br.top - M || y > br.bottom + M) {
        edgeOff(A);
        if (!D.out) {
          D.out = true; D.g.classList.add('is-out');
          if (D.at !== D.from) { D.list = D.orig.slice(); D.at = D.from; renderPage(A, 0, { flip: true }); }
        }
        return;
      }
      if (D.out) { D.out = false; D.g.classList.remove('is-out'); }
      /* the spread’s outer edge, held, turns the page */
      const sr = A.spread.getBoundingClientRect(), EW = Math.max(30, Math.min(56, sr.width * 0.08));
      const pages = Math.max(1, Math.ceil(D.list.length / A.per));
      const side = x < sr.left + EW ? -1 : x > sr.right - EW ? 1 : 0;
      const can = side < 0 ? A.page > 0 : side > 0 ? A.page < pages - 1 : false;
      if (!can) edgeOff(A); else if (D.edge !== side) edgeOn(A, side);
      const to = slotAt(A, x, y);
      if (to < 0) return;
      moveTo(A, Math.min(D.list.length - 1, to));
    }
    function moveTo(A, to) {
      const D = A.drag;
      if (!D || to === D.at) return;
      D.list.splice(D.at, 1); D.list.splice(to, 0, D.c); D.at = to;
      renderPage(A, 0, { flip: true });
    }
    function edgeOn(A, side) {
      const D = A.drag; if (!D) return;
      edgeOff(A);
      D.edge = side;
      A.spread.classList.toggle('is-edge-l', side < 0); A.spread.classList.toggle('is-edge-r', side > 0);
      D.edgeT = setTimeout(() => { if (A.drag === D && D.edge === side) edgeTurn(A, side); }, EDGE_MS);
    }
    function edgeOff(A) {
      const D = A.drag;
      if (D) { clearTimeout(D.edgeT); D.edge = 0; }
      A.spread.classList.remove('is-edge-l', 'is-edge-r');
    }
    /* the page turns with the card: it goes to the near edge of the new page (its first pocket going on, its last going
       back), and holding on at the edge turns the next one 0.6 s later */
    function edgeTurn(A, side) {
      const D = A.drag; if (!D) return;
      const pages = Math.max(1, Math.ceil(D.list.length / A.per)), np = A.page + side;
      edgeOff(A);
      if (np < 0 || np >= pages) return;
      A.page = np;
      const to = side > 0 ? np * A.per : Math.min(D.list.length - 1, np * A.per + A.per - 1);
      D.list.splice(D.at, 1); D.list.splice(to, 0, D.c); D.at = to;
      snd('rustle');
      renderPage(A, side);
      dragMove(A, D.x, D.y);
    }
    /* the card lands. commit: where it was dropped (off the binder, or Escape, puts it back where it was) */
    function dropDrag(A, commit) {
      const D = A.drag; if (!D) return;
      edgeOff(A);
      if (D.P && D.P.off) D.P.off();
      const keep = commit && !D.out && D.at !== D.from;
      if (!keep) { D.list = D.orig.slice(); D.at = D.from; if (!commit || D.out) A.page = D.page0; }
      A.drag = null;
      A.dragEnd = Date.now();
      if (keep) saveOrder(A, D.list);
      renderPage(A, 0, { flip: true });
      const b = A.pk.get(D.c.slug);
      const land = () => { D.g.remove(); if (b) b.classList.remove('is-hole'); A.el.classList.remove('is-dragging'); };
      if (b && b.isConnected && !RM()) {
        const r = b.getBoundingClientRect();
        D.g.animate([{ transform: D.g.style.transform }, { transform: 'translate(' + Math.round(r.left - D.rx) + 'px, ' + Math.round(r.top - D.ry) + 'px)' }], { duration: 180, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'forwards' }).finished.then(land, land);
      } else land();
      if (keep) { snd('tap'); A.live.textContent = D.c.name + ', pocket ' + (D.at + 1) + ' of ' + D.list.length + '.'; }
    }
    /* the order on the page, saved: the cards shown, then any held card the album can’t show yet (a Yost card whose cart
       hasn’t come), in the order they had */
    function saveOrder(A, list) {
      const shown = list.map((c) => c.slug), set = new Set(shown);
      writeOrder(shown.concat(orderedSlugs().filter((s) => !set.has(s))));
    }
    /* Shift and an arrow key: the focused card moves one pocket (Left, Right) or one row (Up, Down), turning the page
       when it crosses one, and keeps the focus */
    function moveBy(A, slug, d) {
      const list = sideList(A).slice(), i = list.findIndex((x) => x.slug === slug);
      if (i < 0 || !d) return;
      const j = Math.max(0, Math.min(list.length - 1, i + d));
      const c = list[i];
      if (j === i) { A.live.textContent = c.name + ' is already in pocket ' + (i + 1) + ' of ' + list.length + '.'; return; }
      list.splice(i, 1); list.splice(j, 0, c);
      saveOrder(A, list);
      const np = Math.floor(j / A.per), turned = np !== A.page;
      A.page = np;
      renderPage(A, turned ? (j > i ? 1 : -1) : 0, { flip: !turned });
      snd(turned ? 'rustle' : 'tap');
      const b = A.pk.get(slug);
      if (b) { try { b.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
      A.live.textContent = c.name + ', pocket ' + (j + 1) + ' of ' + list.length + '.';
    }
    /* Ember stays with the reader: the pocket shakes and Yost says so, over the pockets */
    function refuse(A, b) {
      snd('tap');
      if (!RM()) { b.classList.remove('is-no'); void b.offsetWidth; b.classList.add('is-no'); }
      let t = A.toast;
      if (!t) { t = A.toast = h('p', { class: 'lbc-toast', role: 'status' }); A.spread.append(t); }
      t.textContent = '';
      t.append(h('b', { text: 'Old Yost' }), document.createTextNode('Not that one. She’d come looking for it.'));
      requestAnimationFrame(() => t.classList.add('is-in'));
      clearTimeout(A.toastT);
      A.toastT = setTimeout(() => t.classList.remove('is-in'), 3000);
    }
    function renderBooks(A) {
      const list = booksRead();
      A.booksEl.textContent = '';
      A.booksEl.classList.toggle('is-empty', !list.length);
      if (!list.length) { A.booksEl.append(h('li', { class: 'lbc-empty lbc-books-empty', text: 'Every book you finish waits here.' })); return; }
      const SPINE = { character: '#5a2b1c', prices: '#2d4231', gifts: '#4a2741', table: '#283a52' };
      list.forEach((bk) => {
        const cov = h('span', { class: 'lbc-bcov', 'aria-hidden': 'true' });
        cov.style.setProperty('--lbc-spine', SPINE[bk.k] || '#5a2b1c');
        const setPic = (u) => { if (!u || !cov.isConnected) return; const im = h('img', { class: 'lbc-bcov', src: u, alt: '', decoding: 'async', loading: 'lazy' }); im.addEventListener('error', () => im.replaceWith(cov), { once: true }); cov.replaceWith(im); };
        const b = h('button', { type: 'button', class: 'lbc-book' }, cov, h('span', { class: 'lbc-btext' }, h('span', { class: 'lbc-bt', text: bk.t })));
        b.addEventListener('click', () => { snd('tap'); shutAlbum(A, () => { try { if (api.openBook) api.openBook(bk); } catch (e) { console.error(e); } }); });
        A.booksEl.append(h('li', null, b));
        if (typeof bk.c === 'string' && bk.c) setTimeout(() => setPic(sized(bk.c, 96)), 0);
        else if (api.cover) { try { Promise.resolve(api.cover(bk, 96)).then(setPic, () => {}); } catch (e) { /* fine */ } }
      });
    }
    async function albumIn(A) {
      if (RM()) { await A.el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' }).finished.catch(() => {}); return; }
      const r = A.el.getBoundingClientRect(), from = A.trade ? null : spotRect('binder');
      const t0 = from ? fromTransform(r, from, 0) : 'translateY(18px) scale(.94)';
      await A.el.animate([{ transform: t0, opacity: 0 }, { opacity: 1, offset: 0.3 }, { transform: 'none', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.22,.8,.24,1)' }).finished.catch(() => {});
    }
    /* shutAlbum(A), shutAlbum(A, true) at once, shutAlbum(A, then) and open a book after, or shutAlbum(A, { keep: true })
       leaving the dim up for what comes next (Yost’s pack) */
    async function shutAlbum(A, now, then) {
      let keep = false;
      if (now && typeof now === 'object') { keep = !!now.keep; now = false; }
      if (typeof now === 'function') { then = now; now = false; }
      if (!A || A.state === 'closing' || A.state === 'gone') return;
      /* a card mid-move goes back where it was before the album closes */
      if (A.drag) dropDrag(A, false);
      if (A.pend && A.pend.off) A.pend.off();
      A.state = 'closing';
      clearTimeout(A.toastT);
      if (A.zoom) dropZoom(A, A.zoom);
      if (keep) { A.L.esc = () => {}; A.L.outside = null; A.L.onArrow = null; }
      if (!now) {
        if (RM()) await A.el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160, fill: 'forwards' }).finished.catch(() => {});
        else {
          const r = A.el.getBoundingClientRect(), to = then || keep || A.trade ? null : spotRect('binder');
          const t1 = to ? fromTransform(r, to, 0) : 'translateY(14px) scale(.96)';
          await A.el.animate([{ transform: 'none', opacity: 1 }, { transform: t1, opacity: 0 }], { duration: 240, easing: 'cubic-bezier(.5,0,.75,.4)', fill: 'forwards' }).finished.catch(() => {});
        }
      }
      A.state = 'gone';
      if (album === A) album = null;
      A.el.remove();
      if (!keep) layerDown(A.L, now);
      A.resolve(A.picked || null);
      if (then) then();
    }
    /* a pocket opened: the card large, face up, and it turns. In trade mode it asks whether this is the one */
    async function zoomIn(A, c, pocketEl) {
      if (A.zoom || A.state !== 'open' || A.drag) return;
      snd('tap');
      const el = h('div', { class: 'lbc-zoom' }, h('div', { class: 'lbc-dim', role: 'button', 'aria-label': A.trade ? 'Keep my card' : 'Back to the album' }));
      A.L.root.append(el);
      A.L.root.classList.add('is-zoomed');
      const Z = { el, pocket: pocketEl, v: null };
      A.zoom = Z;
      const v = makeView(A.L, el, c, { label: null, by: null, from: pocketEl, front: true, number: c.ff !== false });
      Z.v = v;
      let acts;
      if (A.trade) {
        const yes = btn('Trade this one', 'is-main'), no = btn('Keep my card', 'is-quiet');
        acts = [yes, no];
        let sure = false;
        yes.addEventListener('click', () => {
          if (v.state !== 'open' || A.state !== 'open') return;
          /* a Mythic, or one Jan picked herself: one more step */
          if ((c.pick || c.tier === 'mythic') && !sure) {
            sure = true; snd('tap'); bump(yes); yes.textContent = 'Yes, trade it';
            byLine(v, c.pick ? 'Jan picked this one out herself. Trade it anyway?' : 'Cards like this one are hard to find. Trade it anyway?');
            return;
          }
          snd('tap');
          A.picked = c;
          shutAlbum(A, { keep: true });
        });
        no.addEventListener('click', () => { snd('tap'); zoomOut(A); });
      } else {
        const back = btn('Back to the album', 'is-main is-wide');
        acts = [back];
        back.addEventListener('click', () => { snd('tap'); zoomOut(A); });
      }
      acts.forEach((b) => v.acts.append(b));
      el.addEventListener('click', (e) => { e.stopPropagation(); if (e.target === el || e.target.classList.contains('lbc-dim') || e.target === v.col) zoomOut(A); });
      requestAnimationFrame(() => el.classList.add('is-in'));
      const d = await prepare(v);
      if (v.state === 'gone' || A.zoom !== Z) return;
      if (!d) { failView(v, acts); return; }
      await arrive(v);
      if (v.state !== 'arriving') return;
      opened(v, acts[0]);
    }
    async function zoomOut(A) {
      const Z = A.zoom; if (!Z || Z.out) return;
      Z.out = true;
      const v = Z.v;
      if (v && v.state !== 'gone') { v.state = 'leaving'; Z.el.classList.remove('is-in'); await flyOut(v, Z.pocket && Z.pocket.isConnected ? Z.pocket : null); }
      dropZoom(A, Z);
      if (Z.pocket && Z.pocket.isConnected) { try { Z.pocket.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
    }
    function dropZoom(A, Z) {
      if (Z.v) { release(Z.v); Z.v.state = 'gone'; }
      Z.el.remove();
      if (A.zoom === Z) { A.zoom = null; A.L.root.classList.remove('is-zoomed'); }
    }

    /* ---------------- Old Yost’s pack ---------------- */
    let yostOn = false, lastGot = [];
    /* three dealt in memory: slots one and two epic while the cart has one (else legendary), the third legendary while
       it has one (else epic), no hero twice, a hero with a stored thumb before one without, the best last */
    function dealPack() {
      const left = cartLeft(), out = [];
      const take = (tier) => {
        let c = left.filter((x) => x.tier === tier && !out.includes(x));
        if (!c.length) return null;
        const th = c.filter((x) => x.hasThumb); if (th.length) c = th;
        return c[rnd(c.length)];
      };
      for (let i = 0; i < 3; i++) {
        const want = i < 2 ? ['epic', 'legendary'] : ['legendary', 'epic'];
        const c = take(want[0]) || take(want[1]);
        if (!c) break;
        out.push(c);
      }
      return out.sort((a, b) => YOST_TIERS.indexOf(a.tier) - YOST_TIERS.indexOf(b.tier));
    }
    /* the tear: the three go in first, then the portrait leaves the binder (a cut between the two writes is finished on
       the next load). False when a second tab got there first (one of the three, the portrait or the free pack gone) */
    /* signed in (BINDER-04): Yost’s pack from the account, the free one (once an account) or a trade of a spare copy.
       The server deals his three by his rule and saves them before it answers; a retry of the same trade (its key)
       answers the same pack */
    let lastIds = [];
    async function acctYost(P) {
      const fb = FB();
      if (!fb || !A.st) return { ok: false };
      if (!P.key) P.key = 'y' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      let j = null;
      try { j = await (P.free ? fb.library('yost', {}) : fb.library('trade', { give: P.give.id, key: P.key })); } catch (e) { j = null; }
      if (!j || j.ok !== true) return { ok: false, reason: j && j.reason };
      if (P.free) A.st.yostFree = false;
      else if (!j.again && j.gave) { const k = String(j.gave), n = (A.st.spares.get(k) || 0) - 1; if (n >= 2) A.st.spares.set(k, n); else A.st.spares.delete(k); }
      /* the server’s own spares arrive while the pack tears (in time for Trade another) */
      acctRefresh();
      const ids = (Array.isArray(j.cards) ? j.cards : []).map(String);
      await loadYost(SITE).catch(() => []);
      let cards = ids.map((id) => yostById(id));
      const miss = ids.filter((id, i) => !cards[i]);
      if (miss.length) { const more = await yostRows(SITE, miss); cards = ids.map((id, i) => cards[i] || more.get(id) || null); }
      cards = cards.filter(Boolean);
      lastIds = ids; lastGot = cards.map((c) => c.slug);
      tellRoom();
      return cards.length ? { ok: true, cards } : { ok: false };
    }
    function commitPack(P) {
      const st = rollDay(readCk(), Date.now());
      if (P.free && st.gift) return false;
      if (P.deal.some((c) => st.yost.includes(c.slug))) return false;
      const gave = P.give ? lc(P.give.slug) : '';
      if (gave) { S.held = null; if (!held().includes(gave)) return false; }
      const got = P.deal.map((c) => c.slug);
      st.yost = slugs(st.yost.concat(got), 400);
      if (P.free) st.gift = 1;
      st.log.push([Date.now(), gave, got, gave ? 0 : 1]); st.log = st.log.slice(-40);
      writeCk(st);
      noteGot(got);
      if (gave) {
        S.held = null;
        const L = held(), i = L.indexOf(gave);
        if (i >= 0) { L.splice(i, 1); keepHeld(); }
        st.log[st.log.length - 1][3] = 1; writeCk(st);
      }
      lastGot = got;
      return true;
    }
    const closeLayer = () => { if (layer && !layer.closing && !album && !cur && !pack) layerDown(layer); };
    const BY3 = ['One of three', 'Two of three', 'He saved the best for last.'], BY2 = ['One of two', 'The last one in his cart.'];
    /* one pack: shut on the dim until the reader tears it (nothing written before), then the cards one at a time.
       'cancelled' | 'empty' | 'again' (trade another) | 'album' | 'library'. The dim stays up; the caller takes it down */
    async function runPack(o) {
      /* signed in (BINDER-04): the server deals his three when the pack tears; until then the cart only tells how many */
      const acct = acctOn();
      let deal = acct ? cartLeft().slice(0, 3) : dealPack();
      if (!deal.length) return 'empty';
      const give = o.give || null, free = !!o.free;
      const L = layerUp('Old Yost’s pack');
      const P = { L, state: 'shut', deal, give, free, v: null, col: null, answer: null, res: null };
      pack = P;
      const ready = (d) => ({ stories: yostStories(SITE, d).catch(() => {}), pics: Promise.all([ensureKit(SITE).catch(() => false)].concat(d.map((c) => preload(c.thumb || c.img, 8000)))) });
      P.prep = ready(acct ? [] : deal);
      const packBtn = h('button', { type: 'button', class: 'lbc-pack' + (RM() ? '' : ' is-idle'), 'aria-label': 'Tear the pack open' },
        h('span', { class: 'lbc-pack-half is-top' }), h('span', { class: 'lbc-pack-half is-bot' }), h('span', { class: 'lbc-pack-str' }), h('span', { class: 'lbc-pack-str is-v' }), h('span', { class: 'lbc-pack-seal' }),
        h('span', { class: 'lbc-pack-face', text: ['', 'One hero', 'Two heroes', 'Three heroes'][deal.length] + ' from the Hall' }));
      const not = btn('Not now', 'is-quiet is-wide');
      const col = h('div', { class: 'lbc-col lbc-packcol' },
        h('p', { class: 'lbc-label', text: 'Old Yost’s pack' }),
        h('p', { class: 'lbc-by', text: free ? 'The first one is on Yost.' : 'For your ' + give.name + ' card' }),
        packBtn,
        h('p', { class: 'lbc-hint', text: free ? 'Heroes other players brought to the Hall. Tap the pack to tear it open.' : 'Nothing changes hands until you tear it open.' }),
        h('div', { class: 'lbc-acts' }, not));
      L.root.append(col);
      P.col = col;
      requestAnimationFrame(() => col.classList.add('is-titled', 'is-shown'));
      if (!RM()) {
        const r = packBtn.getBoundingClientRect(), f = rectOf(o.from);
        packBtn.animate([{ transform: f ? fromTransform(r, f, -8) : 'translateY(40px) scale(.92)', opacity: 0 }, { opacity: 1, offset: 0.2 }, { transform: 'none', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.22,.8,.24,1)' });
        snd('whoosh');
      }
      setTimeout(() => { if (P.state === 'shut') { try { packBtn.focus({ preventScroll: true }); } catch (e) { /* fine */ } } }, 60);
      const choice = await new Promise((res) => {
        P.answer = res;
        packBtn.addEventListener('click', () => { if (P.state === 'shut') res('tear'); });
        not.addEventListener('click', () => { if (P.state === 'shut') { snd('tap'); res('cancel'); } });
        L.esc = () => { if (P.state === 'shut') res('cancel'); };
        L.outside = () => { if (P.state === 'shut') res('cancel'); };
      });
      P.answer = null;
      if (choice !== 'tear' || pack !== P || !alive()) {
        /* stepped back before the tear: nothing was written */
        if (pack === P) {
          P.state = 'gone'; pack = null;
          if (!RM()) await col.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(14px) scale(.96)' }], { duration: 220, easing: 'ease-in', fill: 'forwards' }).finished.catch(() => {});
          col.remove();
        }
        return 'cancelled';
      }
      P.state = 'tearing';
      packBtn.disabled = true; not.disabled = true;
      packBtn.classList.remove('is-idle');
      if (acct) {
        /* the account’s pack: dealt and saved by the server before it answers (a trade gives one spare copy) */
        const r = await acctYost(P);
        if (!r.ok || pack !== P || !alive()) { P.state = 'gone'; if (pack === P) pack = null; col.remove(); return r.ok ? 'library' : r.reason === 'empty' ? 'empty' : 'cancelled'; }
        P.deal = deal = r.cards;
        P.prep = ready(deal);
      } else if (!commitPack(P)) {
        /* a second tab dealt one of these: deal again, once */
        P.deal = deal = dealPack();
        if (!deal.length || !commitPack(P)) { P.state = 'gone'; if (pack === P) pack = null; col.remove(); return deal.length ? 'cancelled' : 'empty'; }
        P.prep = ready(deal);
      }
      tellRoom();
      snd('rip');
      try { if (FFD.buzz) FFD.buzz(14); } catch (e) { /* fine */ }
      await tearPack(P, packBtn);
      col.remove(); P.col = null;
      if (pack !== P) return 'library';
      /* the Hall’s echo guard needs the stories before a card is drawn: one that can’t be asked in time is shown with the
         Hall’s neutral line, and remembered so */
      const slow = await Promise.race([P.prep.stories.then(() => false), sleep(5000).then(() => true)]);
      if (slow) deal.forEach((c) => { if (c.legend && c.edited !== true && c.story === undefined) { c.unsure = true; c.row = null; } });
      markEcho(deal.filter((c) => c.unsure).map((c) => c.slug));
      P.state = 'reveal';
      for (let i = 0; i < deal.length; i++) {
        if (pack !== P || !alive()) return 'library';
        const c = deal[i], last = i === deal.length - 1;
        const by = (deal.length === 3 ? BY3 : deal.length === 2 ? BY2 : ['The last one in his cart.'])[i];
        let answer = null;
        const ans = new Promise((r) => { answer = r; });
        P.res = answer;
        L.esc = () => answer('library');
        const v = makeView(L, L.root, c, { label: 'From Old Yost’s pack', by, from: null, number: false });
        P.v = v;
        let acts;
        if (!last) acts = [btn('Next card', 'is-main is-wide')];
        else {
          const more = tradeable().length > 0 && cartLeft().length > 0;
          acts = more ? [btn('Trade another', 'is-main'), btn('Open your collection'), btn('Back to the library', 'is-quiet is-wide')] : [btn('Open your collection', 'is-main'), btn('Back to the library', 'is-quiet')];
          acts.forEach((b, k) => { b.dataset.how = more ? ['again', 'album', 'library'][k] : ['album', 'library'][k]; });
        }
        if (!last) acts[0].dataset.how = 'next';
        acts.forEach((b) => { v.acts.append(b); b.addEventListener('click', () => { if (v.state === 'open') { snd('tap'); answer(b.dataset.how); } }); });
        fitView(v);
        const d = await prepare(v);
        if (pack !== P || v.state === 'gone') return 'library';
        if (!d) failView(v, acts, 'This one stuck in the pack. It’s in your collection all the same.');
        else {
          await arrive(v);
          if (pack !== P || v.state === 'gone') return 'library';
          opened(v, acts[0]);
          if (last && deal.length > 1) {
            snd('crit');
            try { if (FFD.buzz) FFD.buzz(24); } catch (e) { /* fine */ }
            if (!RM()) { try { const r = v.stage.getBoundingClientRect(); if (FFD.fx && FFD.fx.sparks) FFD.fx.sparks(L.root, { x: r.left + r.width / 2, y: r.top + r.height * 0.42, n: 22, spread: Math.max(80, r.width * 0.7) }); } catch (e) { /* fine */ } }
          }
        }
        const how = await ans;
        P.res = null;
        if (pack !== P) return 'library';
        v.state = 'leaving';
        await flyOut(v, how === 'album' ? spotRect('binder') : null);
        release(v); v.state = 'gone'; v.col.remove(); P.v = null;
        if (how === 'next') continue;
        P.state = 'gone'; if (pack === P) pack = null;
        return how;
      }
      P.state = 'gone'; if (pack === P) pack = null;
      return 'library';
    }
    /* the seal pops, the top of the pack folds back and away, the string falls */
    async function tearPack(P, b) {
      if (RM()) { await P.col.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, fill: 'forwards' }).finished.catch(() => {}); return; }
      const q = (s) => b.querySelector(s), r = b.getBoundingClientRect();
      try { if (FFD.fx && FFD.fx.sparks) FFD.fx.sparks(P.L.root, { x: r.left + r.width * 0.46, y: r.top + r.height * 0.44, n: 18, spread: 70 }); } catch (e) { /* fine */ }
      const as = [
        q('.lbc-pack-seal').animate([{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(1.7)', opacity: 0 }], { duration: 240, easing: 'ease-out', fill: 'forwards' }),
        q('.lbc-pack-half.is-top').animate([{ transform: 'none', opacity: 1 }, { transform: 'translate(-4%, -6%) rotate(-10deg)', opacity: 1, offset: 0.35 }, { transform: 'translate(-10%, -40%) rotate(-28deg)', opacity: 0 }], { duration: 520, easing: 'cubic-bezier(.3,.7,.3,1)', fill: 'forwards' }),
        q('.lbc-pack-half.is-bot').animate([{ transform: 'none', opacity: 1 }, { transform: 'translateY(12%) scale(.95)', opacity: 0 }], { duration: 460, delay: 160, easing: 'ease-in', fill: 'forwards' }),
        q('.lbc-pack-face').animate([{ opacity: 1 }, { opacity: 0 }], { duration: 300, delay: 120, fill: 'forwards' })
      ];
      b.querySelectorAll('.lbc-pack-str').forEach((s) => as.push(s.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(14px)' }], { duration: 260, easing: 'ease-in', fill: 'forwards' })));
      [...P.col.children].filter((x) => x !== b).forEach((x) => as.push(x.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 240, fill: 'forwards' })));
      await Promise.all(as.map((a) => a.finished.catch(() => {})));
    }
    /* the pack taken away at once (the room closing, or another card called up) */
    function dropPack(P) {
      if (!P || P.state === 'gone') return;
      P.state = 'gone';
      if (pack === P) pack = null;
      if (P.v) { release(P.v); P.v.state = 'gone'; if (P.v.col) P.v.col.remove(); P.v = null; }
      if (P.col) { P.col.remove(); P.col = null; }
      if (P.answer) P.answer('gone');
      if (P.res) P.res('library');
    }
    /* the album in trade mode: the portrait picked, or null */
    const pickToTrade = () => openAlbum(null, { trade: true }).then((c) => c || null);
    /* a free pack or a trade, and every pack after it until the reader goes back to the room */
    async function yostSession(first) {
      let opened = false, next = first;
      for (;;) {
        const r = await runPack(next);
        if (r === 'cancelled' || r === 'empty') { closeLayer(); return opened ? 'opened' : r; }
        opened = true;
        /* signed in: the Hall binder, open on his three */
        if (r === 'album' && alive() && acctOn()) { closeLayer(); await acctAlbum(lastIds); return 'opened'; }
        if (r === 'album' && alive()) { await openAlbum(null, { fresh: lastGot }); closeLayer(); return 'opened'; }
        if (r !== 'again' || !alive()) { closeLayer(); return 'opened'; }
        const c = await pickToTrade();
        if (!c) { closeLayer(); return 'opened'; }
        next = { give: c };
      }
    }
    function yostLoad() {
      return loadYost(SITE).then((list) => {
        /* the card kit, warmed while the cart rolls in (never on Save-Data) */
        if (list.length && alive() && !saveData()) { touched = true; ensureKit(SITE).catch(() => {}); }
        return cartLeft().length;
      }, () => 0);
    }
    async function yostOpen(o) {
      o = o || {};
      if (!o.free) return yostTrade(o);
      if (!alive() || yostOn) return 'cancelled';
      yostOn = true;
      try {
        /* signed in (BINDER-04): the free pack is once an account */
        const acct = await acctReady(3000);
        if (!alive() || (acct ? !A.st.yostFree : readCk().gift)) return 'cancelled';
        if (cur) endShow(cur, 'library', true);
        if (album) shutAlbum(album, true);
        warm();
        await loadYost(SITE);
        if (!alive()) return 'cancelled';
        if (!cartLeft().length) return 'empty';
        return await yostSession({ free: true, from: o.from });
      } finally { yostOn = false; }
    }
    async function yostTrade(o) {
      o = o || {};
      if (!alive() || yostOn) return 'cancelled';
      yostOn = true;
      try {
        /* signed in (BINDER-04): he takes a spare copy only ('spare' when the account holds none) */
        const acct = await acctReady(3000);
        if (!alive()) return 'cancelled';
        if (cur) endShow(cur, 'library', true);
        if (album) shutAlbum(album, true);
        warm();
        await Promise.all([loadDeck(SITE), loadYost(SITE)]);
        if (!alive()) return 'cancelled';
        if (!tradeable().length) return acct ? 'spare' : 'none';
        if (!cartLeft().length) return 'empty';
        const c = await pickToTrade();
        if (!c) return 'cancelled';
        return await yostSession({ give: c, from: o.from });
      } finally { yostOn = false; }
    }

    /* ---------------- today’s pack ---------------- */
    /* up to three different heroes from Jan’s portraits, each hero weighted by its tier (PACK_W): a tier with many heroes
       comes up often and a lone hero in a tier stays rare (choosing the tier first made the deck's one Uncommon turn up
       in three packs of four). With the store's mix a Mythic is about one pack in eighteen. Heroes the reader doesn’t
       hold first; never a second Mythic; lowest tier first, so the best turns last */
    function dealDaily(deck) {
      const out = [];
      for (let i = 0; i < PACK_N; i++) {
        const mythicIn = out.some((x) => x.tier === 'mythic');
        const ok = (x) => !out.includes(x) && !(mythicIn && x.tier === 'mythic');
        let pool = deck.filter((x) => ok(x) && !has(x.slug));
        if (!pool.length) pool = deck.filter(ok);
        if (!pool.length) break;
        const w = (x) => PACK_W[x.tier] || PACK_W.rare;
        const sum = pool.reduce((a, x) => a + w(x), 0);
        let roll = Math.random() * sum, pick = pool[pool.length - 1];
        for (const x of pool) { roll -= w(x); if (roll < 0) { pick = x; break; } }
        out.push(pick);
      }
      return out.map((c, i) => ({ c, i })).sort((a, b) => (TIERS.indexOf(a.c.tier) - TIERS.indexOf(b.c.tier)) || (a.i - b.i)).map((x) => x.c);
    }
    /* Zhaunil on a Mythic: never the same line twice running */
    let lastMythic = -1;
    function mythicLine() {
      let i = rnd(MYTHIC.length);
      if (MYTHIC.length > 1 && i === lastMythic) i = (i + 1) % MYTHIC.length;
      lastMythic = i;
      return MYTHIC[i];
    }
    /* the card’s Hall face drawn into el (the pack’s face box, the card’s own size): the same kit and look as the card
       view, scaled to el’s width (or the overlay’s --lbc-k while el has no size yet). Resolves once it is in */
    const faceAt = new Map();
    function face(c, el) {
      if (!c || !el) return Promise.reject(new Error('face'));
      warm();
      faceAt.set(c.slug, el);
      const src = c.thumb || c.img;
      return Promise.all([ensureKit(SITE), preload(src, 4000)]).then(() => {
        if (!alive()) throw new Error('gone');
        const d = drawCard(c, { src, number: false });
        if (!d) throw new Error('face');
        d.box.setAttribute('aria-hidden', 'true'); d.art.setAttribute('tabindex', '-1');
        el.classList.add('lbc-face');
        el.replaceChildren(d.box);
        const fit = () => { const w = el.clientWidth; if (w > 0) el.style.setProperty('--lbc-fk', (w / 380).toFixed(4)); };
        fit();
        if (typeof ResizeObserver === 'function') { try { const ro = new ResizeObserver(() => { if (!el.isConnected) { ro.disconnect(); return; } fit(); }); ro.observe(el); } catch (e) { /* the overlay’s --lbc-k stands in */ } }
        requestAnimationFrame(() => { fit(); try { window.hohShopWireCard(d.box.querySelector('.ffshop-tiltwrap')); } catch (e) { /* the face still shows */ } });
        return true;
      });
    }
    /* a face-up card on the pack’s screen, opened large, look only; settles when it closes */
    function zoom(c) {
      if (!c || !alive()) return Promise.resolve();
      const at = faceAt.get(c.slug), r = at && at.isConnected ? at.getBoundingClientRect() : null;
      return show(c, { zoom: true, front: true, from: r && r.width > 0 ? r : null, label: 'From today’s pack' }).then(() => {}, () => {});
    }
    function dailyPart() {
      if (daily) return daily;
      const make = FFD.parts && FFD.parts['library/pack'];
      if (typeof make !== 'function') return null;
      try {
        daily = make({
          F, h, RM, zh: api.zh || null, face, zoom, mythicLine,
          snd: (n, o) => { try { if (api.snd) api.snd(n, o); } catch (e) { /* silent */ } },
          buzz: (ms) => { try { if (FFD.buzz) FFD.buzz(ms); } catch (e) { /* silent */ } }
        }) || null;
      } catch (e) { console.error('library/pack', e); daily = null; }
      return daily;
    }
    const SUB = ['', 'A hero for your binder.', 'Two heroes for your binder.', 'Three heroes for your binder.'];
    const DONE = ['', 'It’s in your binder now.', 'Both are in your binder now.', 'All three are in your binder now.'];
    const OF = ['One of three', 'Two of three', 'Three of three'], OF2 = ['One of two', 'Two of two'];
    async function openPack(o) {
      o = o || {};
      const parked = lastPark; lastPark = null;
      if (o.cont && parked && parked.left) return 'cancelled';
      if (!alive() || dailyOn || binderOn) return 'cancelled';
      /* signed in (BINDER-04): the binder’s own waiting pack, never this browser’s */
      if (hallSigned()) {
        dailyOn = true;
        let acct = false;
        try { acct = await acctReady(4000); } finally { dailyOn = false; }
        if (acct) return alive() ? acctPack() : 'cancelled';
        if (!alive()) return 'cancelled';
      }
      dailyOn = true;
      try {
        warm();
        const deck = await loadDeck(SITE);
        if (!alive()) return 'cancelled';
        if (!deck.length) return 'empty';
        if (!todayNow().pack) return 'cancelled';
        const deal = dealDaily(deck);
        if (!deal.length) return 'empty';
        /* saved before anything shows: the binder holds the three and today is marked, so a reload, a closed tab or a
           second tab can never deal today’s pack twice (another tab that got there first wins) */
        if (!markPack()) return 'cancelled';
        const got = deal.filter((c) => hold(c));
        deal.forEach((c) => { S.dealt.add(c.slug); try { if (FFD.tally) FFD.tally.add('library', 'cards'); } catch (e) { /* fine */ } });
        tellRoom();
        if (album) shutAlbum(album, true);
        if (cur) endShow(cur, 'library', true);
        if (pack) dropPack(pack);
        /* the dim a deck draw left waiting fades as the pack’s comes up */
        if (layer) layerDown(layer);
        const from = rectOf(o.from);
        const P = dailyPart();
        if (P && typeof P.open === 'function') {
          try {
            await P.open(deal, { from, title: 'Today’s pack', sub: SUB[deal.length], button: 'Open a pack', back: 'Back to the library', done: DONE[deal.length] });
          } catch (e) { console.error(e); }
          return 'opened';
        }
        /* no pack screen: the three show one after another, each already in the binder */
        for (let i = 0; i < deal.length; i++) {
          if (!alive()) break;
          const c = deal[i], last = i === deal.length - 1;
          const by = c.tier === 'mythic' ? mythicLine() : (deal.length === 3 ? OF[i] : deal.length === 2 ? OF2[i] : 'A hero for your binder') + (got.includes(c) ? '. Added to your collection.' : '. Already in your collection.');
          const r = await show(c, { from: i ? null : o.from, label: 'Today’s pack', by, next: !last });
          if (r !== 'again') break;
        }
        return 'opened';
      } finally { dailyOn = false; }
    }

    function close() {
      if (cur) endShow(cur, 'library', true);
      if (album) shutAlbum(album, true);
      if (pack) dropPack(pack);
      if (daily && typeof daily.close === 'function') { try { daily.close(true); } catch (e) { /* fine */ } }
      if (layer) layerDown(layer, true);
      /* the Hall binder this room opened goes with it */
      if (binderOn) { try { const fb = FB(); if (fb) fb.close(); } catch (e) { /* fine */ } }
    }
    const dailyBusy = () => { try { return dailyOn || !!(daily && typeof daily.busy === 'function' && daily.busy()); } catch (e) { return dailyOn; } };
    /* a card, the album, the daily pack or Yost’s pack is up (the room holds its song change and its walkers meanwhile) */
    const busy = () => !!(cur || album || pack || layer || yostOn || binderOn || dailyBusy());

    return {
      ready, next, find, portrait, line, story, show, binder, has, count, countAll, total, all, close, busy, today: todayNow, openPack,
      yost: { load: yostLoad, freeLeft: () => (acctOn() ? !!A.st.yostFree : !readCk().gift), open: yostOpen, trade: yostTrade }
    };
  };
})();

/* ===== src/scene-pages/pages/library/favorites.js ===== */
/* Heroes worth meeting: Jan's favorite portraits, hung on a candlelit gallery wall (Jan, 2026-10-28: "heroes worth
   meeting should be designed way better and more interactive"). The reader walks the wall (swipe, the arrows, the
   keys, or a tap on a neighbouring painting), rolls Soryndel's d20 to land on a hero at random, taps the lit painting
   to look closer, and reads the story beside it. The rows are read from the public Hall only when the wall opens.
   Selection: hoh-section-core.js hohIsJanFeatured / quest_meta.jan_featured, restricted to approved, visible
   FramedFantasy portraits. Fit: the Hall's own square framing (image_offset_x/y and image_zoom, where the Hall's valid
   device override wins, as in library/cards.js framing()).

   FFD.parts['library/favorites']({ F, RM, snd, hold, SITE, onEasel?, heroHref?(slug), fixtureData? })
     -> { open(): Promise<void>, close(), busy(), available(): Promise<boolean>, destroy() }
   open resolves on close. fixtureData is an explicit raw public-row fixture for review; there are no invented heroes
   and no portrait or story caches. */
(() => {
  'use strict';
  const FFD = window.FFD;
  if (!FFD) return;
  FFD.parts = FFD.parts || {};
  const STYLE = 'ffd-css-library-favorites', P = '.ffd-page--library .lbh';
  const COLS = 'id,slug,name,race,character_class,story,image_url,image_thumb_url,image_offset_x,image_offset_y,image_zoom,is_ff_portrait,approved,is_hidden,jan_featured:quest_meta->jan_featured';
  const QUERY = 'select=' + COLS + '&approved=eq.true&or=(is_hidden.is.null,is_hidden.eq.false)&is_ff_portrait=eq.true&quest_meta->>jan_featured=eq.true&image_url=not.is.null&order=created_at.desc&limit=24';
  const CSS = `
${P}{position:fixed;inset:0;z-index:90;display:flex;flex-direction:column;overflow:hidden auto;overscroll-behavior:contain;box-sizing:border-box;padding:max(14px,env(safe-area-inset-top)) 0 max(18px,env(safe-area-inset-bottom));color:#efe2c6;font-family:var(--f-body,'Spectral',Georgia,serif);background:radial-gradient(ellipse 70% 55% at 34% 30%,#3a2a1c,transparent 70%),repeating-linear-gradient(90deg,#0000 0 46px,#ffffff04 46px 47px),linear-gradient(180deg,#1c1612,#120e0c 70%,#0c0a09);opacity:0;transition:opacity .26s ease-out;scrollbar-width:thin;scrollbar-color:#8f7344 #120e0c}
${P}.is-in{opacity:1}
${P} *,${P} *::before,${P} *::after{box-sizing:border-box}
${P} button{font:inherit;cursor:pointer;-webkit-tap-highlight-color:transparent}
${P} button:focus-visible,${P} a:focus-visible{outline:2px solid #ffe2a0;outline-offset:3px}
${P} .lbh-head{flex:none;display:flex;align-items:flex-start;justify-content:space-between;gap:16px;width:min(1120px,100%);margin:0 auto;padding:6px 20px 0}
${P} .lbh-title{margin:0;color:#f3e3bf;font:600 clamp(21px,2.4vw,27px)/1.2 var(--f-display,'Cinzel',Georgia,serif)}
${P} .lbh-sub{margin:6px 0 0;color:#b9a88a;font:italic 400 15px/1.45 var(--f-body,'Spectral',Georgia,serif)}
${P} .lbh-x{flex:none;width:44px;height:44px;display:grid;place-items:center;border:1px solid #8f734466;border-radius:50%;background:#0f0c09a0;color:#eadfc7;font:22px/1 Georgia,serif;transition:background .18s,border-color .18s}
${P} .lbh-x:hover{background:#2a2016;border-color:#c9a35d}
${P} .lbh-main{--s:min(54vh,40vw,500px);flex:1 0 auto;display:grid;grid-template-columns:minmax(0,1.25fr) minmax(300px,.9fr);align-items:center;gap:clamp(18px,3vw,44px);width:min(1120px,100%);margin:0 auto;padding:10px 20px 4px;opacity:0;transform:translateY(10px);transition:opacity .32s .08s ease-out,transform .32s .08s ease-out}
${P}.is-in .lbh-main{opacity:1;transform:none}
${P} .lbh-wall{position:relative;min-width:0}
${P} .lbh-view{position:relative;height:calc(var(--s) + 44px);overflow:hidden;touch-action:pan-y;cursor:grab;-webkit-mask:linear-gradient(90deg,#0000,#000 9%,#000 91%,#0000);mask:linear-gradient(90deg,#0000,#000 9%,#000 91%,#0000)}
${P} .lbh-view.is-drag{cursor:grabbing}
${P} .lbh-light{position:absolute;left:50%;top:-10px;width:calc(var(--s) * 1.5);height:calc(var(--s) + 70px);transform:translateX(-50%);background:radial-gradient(ellipse 50% 46% at 50% 52%,#ffd99a26,transparent 72%);pointer-events:none;transition:opacity .4s}
${P} .lbh-track{position:absolute;left:50%;top:22px;height:var(--s);display:flex;align-items:center;transition:transform .38s cubic-bezier(.22,.8,.24,1);will-change:transform}
${P} .lbh-track.is-quick{transition-duration:.11s;transition-timing-function:linear}
${P} .lbh-track.is-still{transition:none}
${P} .lbh-frame{position:relative;flex:none;width:var(--s);height:var(--s);margin:0 calc(var(--s) * -.07);padding:calc(var(--s) * .035);border:0;background:linear-gradient(135deg,#d8b26a,#8a6532 30%,#c79b55 52%,#6f4f27 78%,#b38a4c);box-shadow:0 0 0 1px #2a1b0c,0 18px 40px #000b,inset 0 0 0 1px #f3d8a066;transform:scale(.7);filter:brightness(.42) saturate(.8);transition:transform .38s cubic-bezier(.22,.8,.24,1),filter .38s ease-out,opacity .3s ease-out}
${P} .lbh-frame::before{content:'';position:absolute;left:50%;top:calc(var(--s) * -.07);width:7px;height:7px;margin-left:-3.5px;border-radius:50%;background:#c9a35d;box-shadow:0 1px 2px #000}
${P} .lbh-frame.is-on{z-index:1;transform:scale(1);filter:none;cursor:zoom-in}
${P} .lbh-frame.is-near{filter:brightness(.55) saturate(.85)}
${P} .lbh-mat{position:relative;width:100%;height:100%;padding:calc(var(--s) * .028);background:#1d1712;box-shadow:inset 0 0 0 1px #000,inset 0 2px 8px #000a}
${P} .lbh-ap{position:relative;width:100%;height:100%;overflow:hidden;background:#15131c}
${P} .lbh-ap img{display:block;width:100%;height:100%;object-fit:cover;pointer-events:none;-webkit-user-drag:none;user-select:none;opacity:0;transition:opacity .35s ease-out}
${P} .lbh-ap img.is-on{opacity:1}
${P} .lbh-glint{position:absolute;inset:0;pointer-events:none;background:linear-gradient(110deg,transparent 38%,#fff3d044 49%,#ffe6a888 50%,#fff3d044 51%,transparent 62%);transform:translateX(-120%)}
${P} .lbh-frame.is-landed .lbh-glint{animation:lbh-glint 1s cubic-bezier(.3,.6,.3,1) both}
${P}.is-close .lbh-view{overflow:visible;-webkit-mask:none;mask:none;z-index:2}
${P}.is-close .lbh-frame.is-on{transform:scale(1.18);cursor:zoom-out}
${P}.is-close .lbh-frame:not(.is-on),${P}.is-close .lbh-frame::before{opacity:0}
${P}.is-close .lbh-plate,${P}.is-close .lbh-ctl,${P}.is-close .lbh-count,${P}.is-close .lbh-card{opacity:.2}
${P} .lbh-card,${P} .lbh-count{transition:opacity .3s}
${P} .lbh-plate{position:relative;width:min(calc(var(--s) * .78),340px);margin:2px auto 0;padding:9px 16px 10px;text-align:center;border:1px solid #c9a35d88;border-radius:2px;background:linear-gradient(180deg,#2c2218,#1a140f);box-shadow:0 1px 0 #f3d8a022 inset,0 6px 14px #0009;color:#f0d79f;transition:opacity .3s}
${P} .lbh-name{margin:0;font:700 17px/1.2 var(--f-display,'Cinzel',Georgia,serif);overflow-wrap:anywhere;text-wrap:balance}
${P} .lbh-kind{margin:3px 0 0;font:500 13px/1.3 var(--f-body,'Spectral',Georgia,serif);color:#b9a88a}
${P} .lbh-ctl{display:flex;align-items:center;justify-content:center;gap:12px;margin:14px 0 0;transition:opacity .3s}
${P} .lbh-arrow{width:44px;height:44px;display:grid;place-items:center;border:1px solid #c9a35d55;border-radius:50%;background:#0f0c09a0;color:#e8d3a6;transition:background .18s,border-color .18s,transform .18s}
${P} .lbh-arrow:hover{background:#2a2016;border-color:#c9a35d}
${P} .lbh-arrow:active{transform:scale(.94)}
${P} .lbh-arrow svg{width:16px;height:16px}
${P} .lbh-roll{display:flex;align-items:center;gap:9px;min-height:44px;padding:6px 14px 6px 8px;border:1px solid #c9a35d55;border-radius:22px;background:#0f0c09a0;color:#e8d3a6;font:500 14px/1 var(--f-body,'Spectral',Georgia,serif);transition:background .18s,border-color .18s}
${P} .lbh-roll:hover{background:#2a2016;border-color:#c9a35d}
${P} .lbh-roll svg{width:30px;height:30px;flex:none;transition:transform .5s cubic-bezier(.3,1.4,.5,1)}
${P} .lbh-roll.is-rolling svg{transform:rotate(540deg)}
${P} .lbh-count{min-width:54px;text-align:center;color:#a8977a;font:500 13px/1 var(--f-display,'Cinzel',Georgia,serif);letter-spacing:.06em}
${P} .lbh-card{position:relative;min-width:0;align-self:center;max-height:min(calc(var(--s) + 140px),72vh);display:flex;flex-direction:column;padding:24px 26px 22px;border:1px solid #8f734466;border-radius:3px;background:linear-gradient(180deg,#1b1511f0,#140f0cf0);box-shadow:0 20px 50px #0008}
${P} .lbh-story{min-height:0;overflow-y:auto;overscroll-behavior:contain;padding-right:6px;scrollbar-width:thin;scrollbar-color:#8f7344 #1b1511}
${P} .lbh-story p{margin:0 0 14px;color:#e6d8bb;font:400 15.5px/1.66 var(--f-body,'Spectral',Georgia,serif);overflow-wrap:anywhere}
${P} .lbh-story p:first-child::first-letter{float:left;margin:4px 8px 0 0;color:#e9c87a;font:600 44px/.82 var(--f-display,'Cinzel',Georgia,serif)}
${P} .lbh-story .lbh-quiet{color:#b9a88a;font-style:italic}
${P} .lbh-story.is-more{-webkit-mask:linear-gradient(#000 82%,#0000);mask:linear-gradient(#000 82%,#0000)}
${P} .lbh-swap{animation:lbh-in .3s ease-out both}
${P} .lbh-acts{flex:none;display:flex;flex-direction:column;align-items:center;gap:6px;margin-top:16px;padding-top:16px;border-top:1px solid #8f734440}
${P} .lbh-meet{display:inline-flex;align-items:center;justify-content:center;min-height:46px;width:100%;padding:10px 16px;border:1px solid #c9a35d;border-radius:3px;background:#e9c87a1f;color:#f6e3b4;font:600 14.5px/1.25 var(--f-display,'Cinzel',Georgia,serif);text-align:center;text-decoration:none;transition:background .18s}
${P} .lbh-meet:hover{background:#e9c87a38}
${P} .lbh-ask{min-height:44px;padding:8px 6px;border:0;background:none;color:#d6bf91;font:400 14.5px/1.3 var(--f-body,'Spectral',Georgia,serif);text-decoration:underline;text-underline-offset:4px;text-decoration-color:#d6bf9166}
${P} .lbh-ask:hover{color:#f3dfb2}
${P} .lbh-wait{display:grid;place-items:center;min-height:50vh;color:#b9a88a;font:italic 400 16px/1.5 var(--f-body,'Spectral',Georgia,serif);text-align:center;padding:0 24px}
${P} .lbh-wait a{color:#f0d79f}
${P} .lbh-spark{position:absolute;z-index:3;left:var(--x);top:var(--y);width:3px;height:3px;background:#ffe3a0;box-shadow:0 0 6px #ffd27a;pointer-events:none;animation:lbh-spark 1s ease-out both}
@keyframes lbh-in{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}
@keyframes lbh-glint{to{transform:translateX(120%)}}
@keyframes lbh-spark{0%{opacity:0;transform:none}20%{opacity:1}100%{opacity:0;transform:translate(var(--dx),var(--dy))}}
@media(max-width:860px){
  ${P} .lbh-main{--s:min(72vw,46vh,420px);grid-template-columns:minmax(0,1fr);align-items:start;gap:18px;padding:12px 0 4px}
  ${P} .lbh-card{max-height:none;margin:0 16px;padding:20px 18px 18px}
  ${P} .lbh-story{overflow:visible;padding-right:0}
  ${P} .lbh-story.is-short{max-height:12.5em;overflow:hidden;-webkit-mask:linear-gradient(#000 70%,#0000);mask:linear-gradient(#000 70%,#0000)}
  ${P} .lbh-head{padding:4px 70px 0 16px}
  ${P} .lbh-x{position:fixed;z-index:5;top:max(12px,env(safe-area-inset-top));right:14px;background:#0f0c09e6;box-shadow:0 4px 14px #000a}
  ${P} .lbh-sub{font-size:14px}
}
${P} .lbh-more{align-self:flex-start;min-height:44px;margin:2px 0 0;padding:6px 0;border:0;background:none;color:#e9c87a;font:600 14px/1.2 var(--f-display,'Cinzel',Georgia,serif)}
@media(min-width:861px){${P} .lbh-more{display:none}}
@media(max-height:520px) and (min-width:600px){${P} .lbh-main{--s:min(50vh,36vw);grid-template-columns:minmax(0,1fr) minmax(280px,.9fr)}${P} .lbh-card{max-height:78vh}${P} .lbh-sub{display:none}}
@media(prefers-reduced-motion:reduce){${P},${P} .lbh-main,${P} .lbh-track,${P} .lbh-frame,${P} .lbh-ap img,${P} .lbh-roll svg{transition:none}${P} .lbh-glint,${P} .lbh-spark{display:none}${P} .lbh-swap{animation:none}}
`;
  const ARROW = (d) => '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="' + (d < 0 ? 'M10 3 5 8l5 5' : 'M6 3l5 5-5 5') + '"/></svg>';
  const D20 = '<svg viewBox="0 0 44 44" aria-hidden="true"><path d="M22 2 40 12.5v19L22 42 4 31.5v-19z" fill="#2b2117" stroke="#c9a35d" stroke-width="1.6"/><path d="M22 2 13 17h18zM13 17 4 12.5M31 17l9-4.5M13 17l-4 15M31 17l4 15M9 32h26M13 17l9 25 9-25" fill="none" stroke="#c9a35d" stroke-width="1" opacity=".6"/><text x="22" y="28" text-anchor="middle" fill="#f3e3bf" font-size="11" font-family="Cinzel,Georgia,serif" font-weight="700">20</text></svg>';
  function styles() {
    if (document.getElementById(STYLE)) return;
    const el = document.createElement('style'); el.id = STYLE; el.textContent = CSS; document.head.appendChild(el);
  }
  const text = (v) => typeof v === 'string' ? v.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').trim() : '';
  function url(v) {
    if (typeof v !== 'string' || !v || v.length > 1500) return '';
    try { const u = new URL(v, window.location.href); return u.protocol === 'https:' || (u.protocol === 'http:' && /^(localhost|127\.0\.0\.1)$/.test(u.hostname)) ? u.href : ''; } catch (_) { return ''; }
  }
  function heroes(rows) {
    return (Array.isArray(rows) ? rows : []).filter((r) => r && r.jan_featured === true && r.is_ff_portrait === true && r.approved === true && r.is_hidden !== true && text(r.name) && url(r.image_url)).map((r) => Object.assign({}, r, { name: text(r.name), story: text(r.story), image_url: url(r.image_url), image_thumb_url: url(r.image_thumb_url) }));
  }
  function framing(row, map) {
    const ok = (v, lo, hi) => typeof v === 'number' && isFinite(v) && v >= lo && v <= hi;
    const m = map && typeof map === 'object' && !Array.isArray(map) ? map : {}, k = String(row.id || '') + ':primary';
    const pick = (a, b, lo, hi, d) => ok(a, lo, hi) ? a : ok(b, lo, hi) ? b : d;
    const x = pick(m[k + ':x'], row.image_offset_x, 0, 100, 50), y = pick(m[k], row.image_offset_y, 0, 100, 50), z = pick(m[k + ':zoom'], row.image_zoom, 100, 200, 100);
    const pos = x + '% ' + y + '%';
    return 'object-position:' + pos + ';transform-origin:' + pos + ';scale:' + (Math.round(z) / 100) + ';';
  }
  function node(tag, cls, value) {
    const el = document.createElement(tag); if (cls) el.className = cls; if (value != null) el.textContent = value; return el;
  }
  const make = function (api) {
    api = api || {};
    const SITE = api.SITE || window.FFD_SITE || null, hall = (SITE && SITE.hall) || window.FFD_HALL || null;
    const hallHref = url(SITE && SITE.routes && SITE.routes.hall) || 'https://framedfantasy.com/pages/hall-of-heroes';
    const RM = () => { try { return !!(api.RM && api.RM()); } catch (_) { return false; } };
    let rows = null, request = null, controller = null, cur = null, disposed = false, at = 0;
    const hold = (on) => { try { if (api.hold) api.hold(on); } catch (_) { /* room still usable */ } };
    const sound = (n) => { try { if (api.snd) api.snd(n); } catch (_) { /* quiet is fine */ } };
    function fit(row) {
      let map = {}; try { map = JSON.parse(window.localStorage.getItem('hoh-img-offsets-v1') || '{}'); } catch (_) { /* server fit */ }
      return framing(row, map);
    }
    function load() {
      if (rows) return Promise.resolve(rows);
      if (request) return request;
      if (Array.isArray(api.fixtureData)) { rows = heroes(api.fixtureData); return Promise.resolve(rows); }
      if (disposed || !hall || !url(hall.url) || typeof hall.key !== 'string' || !hall.key || typeof window.fetch !== 'function') return Promise.resolve([]);
      request = (async () => {
        controller = typeof AbortController === 'function' ? new AbortController() : null;
        const timer = setTimeout(() => { if (controller) controller.abort(); }, 10000);
        try {
          const res = await window.fetch(url(hall.url).replace(/\/+$/, '') + '/rest/v1/characters?' + QUERY, { method: 'GET', headers: { apikey: hall.key }, credentials: 'omit', referrerPolicy: 'no-referrer', signal: controller ? controller.signal : undefined });
          if (!res.ok) return [];
          const got = heroes(await res.json()); if (!disposed) rows = got; return got;
        } catch (_) { return []; }
        finally { clearTimeout(timer); controller = null; request = null; }
      })();
      return request;
    }
    function heroLink(row) {
      const slug = text(row.slug) || String(row.id);
      if (typeof api.heroHref === 'function') { const h = url(api.heroHref(slug)); if (h) return h; }
      const u = new URL(hallHref); u.searchParams.set('hero', slug); return u.href;
    }
    function close() {
      const s = cur; if (!s) return;
      cur = null; s.gone = true; clearTimeout(s.rollT);
      document.removeEventListener('keydown', s.key, true);
      s.root.classList.remove('is-in');
      const done = () => { s.root.remove(); hold(false); if (s.back && s.back.isConnected && typeof s.back.focus === 'function') s.back.focus({ preventScroll: true }); s.resolve(); };
      if (RM()) done(); else setTimeout(done, 240);
    }

    /* ---- the wall: every painting on one track; the lit one in the middle, its neighbours dim at the sides ---- */
    function build(s, list) {
      const n = list.length;
      s.list = list;
      const wall = node('div', 'lbh-wall'), view = node('div', 'lbh-view'), track = node('div', 'lbh-track is-still');
      view.append(node('i', 'lbh-light'), track);
      s.frames = list.map((row, i) => {
        const f = node('button', 'lbh-frame'); f.type = 'button'; f.dataset.i = String(i);
        f.setAttribute('aria-label', row.name);
        const mat = node('div', 'lbh-mat'), ap = node('div', 'lbh-ap');
        mat.append(ap); f.append(mat, node('i', 'lbh-glint'));
        f.addEventListener('click', () => { if (s.dragged) return; if (i === at) look(s); else go(s, i - at); });
        track.append(f);
        return f;
      });
      const plate = node('div', 'lbh-plate'); plate.setAttribute('aria-live', 'polite');
      s.name = node('h3', 'lbh-name'); s.kind = node('p', 'lbh-kind');
      plate.append(s.name, s.kind);
      const ctl = node('div', 'lbh-ctl');
      const prev = node('button', 'lbh-arrow'); prev.type = 'button'; prev.innerHTML = ARROW(-1); prev.setAttribute('aria-label', 'Previous hero');
      const next = node('button', 'lbh-arrow'); next.type = 'button'; next.innerHTML = ARROW(1); next.setAttribute('aria-label', 'Next hero');
      const roll = node('button', 'lbh-roll'); roll.type = 'button'; roll.innerHTML = D20; roll.append('Roll for a hero');
      s.count = node('span', 'lbh-count');
      prev.addEventListener('click', () => go(s, -1));
      next.addEventListener('click', () => go(s, 1));
      roll.addEventListener('click', () => rollFor(s, roll));
      if (n > 1) ctl.append(prev, roll, next); else ctl.append(s.count);
      wall.append(view, plate, ctl);
      if (n > 1) { const c = node('p', 'lbh-count'); c.style.marginTop = '10px'; s.countWrap = c; wall.append(c); s.count = c; }
      const card = node('section', 'lbh-card'); card.setAttribute('aria-label', 'Their story');
      s.story = node('div', 'lbh-story');
      s.story.addEventListener('scroll', () => more(s), { passive: true });
      s.more = node('button', 'lbh-more', 'Read the whole story'); s.more.type = 'button';
      s.more.addEventListener('click', () => { s.story.classList.remove('is-short'); s.more.hidden = true; more(s); });
      const acts = node('div', 'lbh-acts');
      s.meet = node('a', 'lbh-meet');
      acts.append(s.meet);
      if (typeof api.onEasel === 'function') {
        const ask = node('button', 'lbh-ask', 'Ask Jan about a portrait of your hero'); ask.type = 'button';
        ask.addEventListener('click', () => { const fn = api.onEasel; close(); fn(); });
        acts.append(ask);
      }
      card.append(s.story, s.more, acts);
      s.main.replaceChildren(wall, card);
      s.view = view; s.track = track;
      drag(s);
      place(s, false);
      requestAnimationFrame(() => { if (!s.gone) track.classList.remove('is-still'); });
    }
    /* only the paintings near the lit one load their pictures (a small copy for the far ones) */
    function pictures(s) {
      const n = s.list.length;
      s.frames.forEach((f, i) => {
        const d = Math.min(Math.abs(i - at), n - Math.abs(i - at));
        if (d > 2) return;
        const row = s.list[i], ap = f.querySelector('.lbh-ap'), want = d <= 1 ? row.image_url : (row.image_thumb_url || row.image_url);
        let img = ap.querySelector('img');
        if (img && (img.dataset.src === want || img.dataset.src === row.image_url)) return;
        if (!img) {
          img = node('img'); img.alt = ''; img.decoding = 'async'; img.draggable = false;
          img.addEventListener('load', () => img.classList.add('is-on'));
          img.addEventListener('error', () => { if (img.dataset.src !== row.image_url) { img.dataset.src = row.image_url; img.src = row.image_url; } });
          ap.append(img);
        }
        img.setAttribute('style', fit(row)); img.dataset.src = want; img.src = want;
      });
    }
    function place(s, swapText) {
      /* the step from one painting to the next is read from the laid-out track (the frames overlap a little, so the
         dim neighbours peek in at both sides of the lit one) */
      const n = s.list.length, f0 = s.frames[0], f1 = s.frames[1], w = f0 ? f0.offsetWidth : 0, step = f1 ? f1.offsetLeft - f0.offsetLeft : w;
      s.track.style.transform = 'translateX(' + (-((f0 ? f0.offsetLeft : 0) + at * step + w / 2) + (s.dx || 0)) + 'px)';
      s.frames.forEach((f, i) => { f.classList.toggle('is-on', i === at); f.classList.toggle('is-near', Math.abs(i - at) === 1); f.tabIndex = Math.abs(i - at) <= 1 ? 0 : -1; f.setAttribute('aria-current', i === at ? 'true' : 'false'); });
      pictures(s);
      const row = s.list[at];
      s.name.textContent = row.name;
      const kind = [text(row.race), text(row.character_class)].filter(Boolean).join(' · ');
      s.kind.textContent = kind; s.kind.hidden = !kind;
      if (s.count) s.count.textContent = (at + 1) + ' of ' + n;
      if (swapText === false && s.storyFor === at) return;
      s.storyFor = at;
      const paras = (row.story || '').split(/\n+/).map((p) => p.trim()).filter(Boolean);
      const body = node('div', 'lbh-swap');
      if (paras.length) paras.forEach((p) => body.append(node('p', '', p)));
      else body.append(node('p', 'lbh-quiet', row.name + ' hasn’t shared a written story in the Hall yet. The portrait says plenty.'));
      s.story.replaceChildren(body); s.story.scrollTop = 0;
      const short = window.matchMedia && window.matchMedia('(max-width:860px)').matches && (row.story || '').length > 420;
      s.story.classList.toggle('is-short', short); s.more.hidden = !short; more(s);
      s.meet.textContent = 'Meet ' + row.name + ' in the Hall'; s.meet.href = heroLink(row);
    }
    function go(s, step, quiet) {
      const n = s.list.length; if (n < 2 || !step) return;
      s.root.classList.remove('is-close');
      at = (at + step + n) % n;
      if (!quiet) sound('flip');
      place(s);
    }
    /* a story that scrolls in its card fades at the foot until its last line is in view */
    function more(s) { const st = s.story; st.classList.toggle('is-more', !st.classList.contains('is-short') && st.scrollHeight - st.scrollTop - st.clientHeight > 4); }
    /* a tap on the lit painting: a closer look, and back */
    function look(s) { s.root.classList.toggle('is-close'); sound('tap'); }
    /* Soryndel's d20: the wall runs past a few heroes, slows, and lands on one with a glint */
    function rollFor(s, btn) {
      const n = s.list.length; if (n < 2 || s.rolling) return;
      s.root.classList.remove('is-close');
      let target = Math.floor(Math.random() * (n - 1)); if (target >= at) target++;
      sound('dice'); btn.classList.add('is-rolling');
      const land = () => {
        s.rolling = false; s.track.classList.remove('is-quick'); btn.classList.remove('is-rolling');
        at = target; place(s);
        const f = s.frames[at]; f.classList.remove('is-landed'); void f.offsetWidth; f.classList.add('is-landed');
        sparks(f); sound('chime');
      };
      if (RM()) { at = target; place(s); btn.classList.remove('is-rolling'); return; }
      s.rolling = true;
      let steps = ((target - at + n) % n) || n, delay = 70;
      /* a short run: at most about ten paintings pass, the rest jump while the wall is quick */
      if (steps > 10) { at = (target - 10 + n) % n; steps = 10; }
      s.track.classList.add('is-quick');
      const tick = () => {
        if (s.gone) return;
        if (steps <= 1) { land(); return; }
        steps--; at = (at + 1) % n; place(s, false);
        if (steps < 4) { s.track.classList.remove('is-quick'); delay += 90; } else delay += 14;
        s.rollT = setTimeout(tick, delay);
      };
      tick();
    }
    function sparks(f) {
      if (RM()) return;
      for (let i = 0; i < 10; i++) {
        const m = node('i', 'lbh-spark'), a = Math.random() * Math.PI * 2, r = 30 + Math.random() * 50;
        m.style.cssText = '--x:' + (10 + Math.random() * 80) + '%;--y:' + (10 + Math.random() * 80) + '%;--dx:' + Math.round(Math.cos(a) * r) + 'px;--dy:' + Math.round(Math.sin(a) * r - 20) + 'px;animation-delay:' + (Math.random() * 0.25).toFixed(2) + 's';
        f.append(m); setTimeout(() => m.remove(), 1400);
      }
    }
    /* swipe or drag the wall: past a third of a painting it walks one; a fast flick walks too */
    function drag(s) {
      let x0 = 0, t0 = 0, id = null;
      s.view.addEventListener('pointerdown', (e) => {
        if (s.rolling || s.list.length < 2 || (e.pointerType === 'mouse' && e.button !== 0)) return;
        id = e.pointerId; x0 = e.clientX; t0 = Date.now(); s.dx = 0; s.dragged = false;
      });
      s.view.addEventListener('pointermove', (e) => {
        if (id !== e.pointerId) return;
        const dx = e.clientX - x0;
        if (!s.dragged && Math.abs(dx) < 8) return;
        if (!s.dragged) { s.dragged = true; s.track.classList.add('is-still'); s.view.classList.add('is-drag'); try { s.view.setPointerCapture(id); } catch (_) { /* fine */ } }
        s.dx = dx; place(s, false);
      });
      const end = (e) => {
        if (id !== e.pointerId) return;
        id = null;
        const dx = s.dx || 0, w = s.frames[0] ? s.frames[0].offsetWidth : 300, fast = Math.abs(dx) > 30 && Date.now() - t0 < 260;
        s.dx = 0; s.track.classList.remove('is-still'); s.view.classList.remove('is-drag');
        if (s.dragged && (Math.abs(dx) > w / 3 || fast)) go(s, dx < 0 ? 1 : -1); else place(s, false);
        setTimeout(() => { s.dragged = false; }, 0);
      };
      s.view.addEventListener('pointerup', end);
      s.view.addEventListener('pointercancel', end);
    }
    function open() {
      if (disposed) return Promise.resolve();
      if (cur) return cur.promise;
      styles();
      const s = { root: node('div', 'lbh'), main: node('div', 'lbh-main'), back: document.activeElement, gone: false, resolve: null, key: null };
      s.promise = new Promise((resolve) => { s.resolve = resolve; }); cur = s;
      s.root.setAttribute('role', 'dialog'); s.root.setAttribute('aria-modal', 'true'); s.root.setAttribute('aria-labelledby', 'lbh-title');
      const head = node('header', 'lbh-head'), words = node('div');
      const title = node('h2', 'lbh-title', 'Heroes worth meeting'); title.id = 'lbh-title';
      words.append(title, node('p', 'lbh-sub', 'A few of Jan’s favorite portraits, and the stories their players wrote.'));
      const exit = node('button', 'lbh-x', '×'); exit.type = 'button'; exit.setAttribute('aria-label', 'Back to the library'); exit.addEventListener('click', close);
      head.append(words, exit);
      s.main.append(node('p', 'lbh-wait', 'Soryndel is fetching the portraits from the Hall…'));
      s.root.append(head, s.main);
      s.key = (e) => {
        if (cur !== s) return;
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); if (s.root.classList.contains('is-close')) s.root.classList.remove('is-close'); else close(); return; }
        if (s.list && (e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !(document.activeElement && document.activeElement.closest && document.activeElement.closest('.lbh-story'))) { e.preventDefault(); e.stopPropagation(); go(s, e.key === 'ArrowLeft' ? -1 : 1); return; }
        if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
        if (e.key !== 'Tab') return;
        const focusable = Array.from(s.root.querySelectorAll('button:not([disabled]):not([tabindex="-1"]),a[href]')).filter((el) => el.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1]; if (!first) return;
        if (e.shiftKey && (document.activeElement === first || !s.root.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !s.root.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
      };
      s.root.addEventListener('pointerdown', (e) => e.stopPropagation());
      const host = api.F && api.F.el || document.querySelector('.ffd-page--library') || document.body; host.append(s.root); hold(true); document.addEventListener('keydown', s.key, true);
      requestAnimationFrame(() => { if (!s.gone) s.root.classList.add('is-in'); });
      exit.focus({ preventScroll: true });
      sound('whoosh');
      load().then((list) => {
        if (cur !== s || s.gone || disposed) return;
        if (!list.length) {
          const wait = node('p', 'lbh-wait'), a = node('a', '', 'Visit the Hall of Heroes'); a.href = hallHref;
          wait.append('The portraits couldn’t be reached just now. ', a, '.'); s.main.replaceChildren(wait); return;
        }
        at = at % list.length;
        build(s, list);
      });
      return s.promise;
    }
    const repaint = () => { if (!cur || !cur.list) return; cur.frames.forEach((f, i) => { const im = f.querySelector('.lbh-ap img'); if (im) im.setAttribute('style', fit(cur.list[i])); }); };
    const storage = (e) => { if (e.key === 'hoh-img-offsets-v1') repaint(); };
    const resize = () => { if (cur && cur.list) { place(cur, false); more(cur); } };
    document.addEventListener('hoh:image-offset-changed', repaint); window.addEventListener('storage', storage); window.addEventListener('resize', resize);
    return { open, close, busy: () => !!cur, available: () => load().then((list) => list.length > 0), destroy() { disposed = true; close(); if (controller) controller.abort(); document.removeEventListener('hoh:image-offset-changed', repaint); window.removeEventListener('storage', storage); window.removeEventListener('resize', resize); } };
  };
  make.QUERY = QUERY; make.COLS = COLS; make.framing = framing; make.heroes = heroes;
  FFD.parts['library/favorites'] = make;
})();

/* ===== src/scene-pages/pages/library/fight.js ===== */
/* library/fight.js: the Iron Matron, face to face, when she walks into the library on Ash in the Alehouse (a part of the
   library page).
   Jan (2026-10-07, after the pitch): the fight is two-sided. You have 30 health and so does she, and either of you can
   fall. Jan (2026-10-07, the second pass): raise the whole screen and make it bigger, animate every blow on both sides
   (hers land on you), open with her casting the tavern over the library, roll the Shield's heal, and offer the hand only
   when you're nearly down.
   The rules (the session's fight-sim.cjs mirrors them, 200,000 fights each: careful play, which is always pressing the
   gold card, wins about 62%, with all three room bonuses about 83%, always pressing the first button about 47%, Strike
   alone without the hand about 32%):
     Roll to stand   one d20 before the first blow: 15 or more is a clean rise (+2 to hit for this fight), under 10 she
                     moves first. Until it's rolled the view lies tipped over, as if on the floor
     Strike          d20 + to hit against 11, then 2d6 (a natural 20 rolls 4d6, a natural 1 slips)
     Trick           d20 + to hit against 10, then 1d6. Her next swing rolls twice and keeps the lower, or, after "Her
                     hands move.", the spell breaks instead (it doesn't do both)
     Shield          as the Shield spell has it: a flat +5 guard against her next attack (no roll), and her spell is halved
                     (rounded up). Then 1d6 of health back, rolled on a gold die (the Quest's dice have no d4)
     her turn        d20 + 2 against your guard 12: a natural 1 misses, a natural 20 hits and adds 1d6. A hit is 1d6 + 2,
                     rolled on her obsidian dice. After her second swing her hands move (the telegraph: a sphere of frost
                     gathers in them), and on her third turn she throws it, 2d6 + 3 (was 2d6 + 2: the telegraph matters
                     more)
     the hand        once a fight, only while your health is 8 or less: it takes Strike's place as the first choice, with
                     Trick and Shield beside it, and Strike comes back once it's spent. Jan's unseen save, the Quest's own:
                     Jan's recorded "Catch" (Quest One's clip, inline below), her bolt, and two mythic d6 of 4 to 6 each
     room bonuses    Road scar +1 to hit, You saw it coming +2 guard, What you remembered +2 Strike damage, read from
                     api.bonus() at the start of every fight (a rematch reads them again)
     the gold card   the recommended choice: Strike (or the hand while it's offered); on a charged turn Trick, or Shield
                     under 14 health. While the hand is offered and her spell is charged with her above 12, Shield (the
                     hand can't finish her, the spell could finish you, and Shield halves it)
   The opening (the first fight only; Face her again starts at Roll to stand): the overlay opens see-through over the
   library with the room still playing. The shape you tapped is her in the dark (Jan, 2026-10-08: "the black siloutte
   and red eyes is just her in the dark once shes up close its still the old lady"): her figure in the room goes into
   shadow as the same dark shape, red eyes and a rim of cold light, comes out of it toward you in three strides (a
   footfall at each), growing until she stands at the front (darkOf below). A breath with her eyes on you, then a
   candle catches and the light finds her: the dark lifts off her from the hands up, her face last, and she is only the
   old woman. Then she lifts her hands and casts while the music dips (“Remember this place, love? I can bring it
   anywhere.”). Her cast is a ring
   of runes in pixel art at her art's own scale and in her spell's own colours (runePainter below): it writes itself
   round from the top, turns while a light runs round it, and spins up when the spell surges. The library comes apart
   from her hands outward in a pixel dither, 1.5 s, with the tavern-cold scene behind it, the floor tips you over, and
   she slides her cup across (“Neat trick, isn’t it? Would you like a drink before we start?”). Then Roll to stand.
   A tap anywhere but Leave, or a key, skips to the end of it. Reduced motion: her in the dark at the front, a plain
   crossfade as the light finds her, the lines, and a plain crossfade to the tavern.
   Every blow travels and lands: your Strike is a pale crescent across her (her flinch, a white flash, the number over
   her), a Trick is a feint (dust, her wobble, the "next swing is wild" chip), Shield raises a gold barrier on your side,
   a shallow dome rising from below her counter with a light sweeping over it, while your guard badge (labelled Guard)
   climbs. Her swing lunges at you and comes the other way, in iron and blood red: the iron cup's arc from her hand, her
   cold hand's three frost rakes or the frost from her cup (picked by her line; the two frost blows are pixel art on her
   art's grid, like her spell), coming at you and landing just above your bar on every screen (in the right-hand
   column on a phone on its side): a shake, a red edge, a crack where it hit, your bar flinching and draining and a
   full-size number rising beside the line above your bar (on the side of it with room, else above it), so the line
   stays readable. A miss glances off in a guard spark near your bar (on the dome when you're shielded). Her spell is
   pixel art at her art's own scale (orbPainter below): a ball of frost lit from the upper left with a small crystal at
   its heart that gathers between her cupped hands and fills them, swells in the surge (her hands hold it up until she
   throws it), and dims and sputters in her hands when a Trick breaks it, popping as they drop on her turn. Thrown, the
   same ball comes at you on one canvas over the screen whose cells are her art's pixels, growing to about a third of a
   phone's width as it nears, with frost streaks and motes behind it, and bursts there in pixels (a white flash and a
   bloom, a ring of frost across the floor and your bar, ice slivers flung off and frost growing out like ferns on a
   window pane, below the line and her art) with a heavier shake. The blows are sized to the fight's
   own column (the window's short side, at most 560 px), so on a desktop they stay near you instead of sweeping across
   her counter. The rest is CSS and the Web Animations API on transforms and opacity (the rune ring and her spell are
   small canvases), drawn from a private random stream so a stubbed Math.random (scripted tests) moves only the
   rules.
   The words follow the dice: her swing's line says only what she tries (“Her cold hand reaches for you.”), and the
   line after the roll says what it did, in that swing's own words. The sum under the dice shows one beat at a time
   (her two wild d20s and which one counts, then the roll against your guard, then the damage). The Shield's heal is
   the big green number and one short line. Her lines carry the room's curly quotes.
   The hand's first offer in a fight gets its own moment: its card rises a beat after the others with a glow, a light
   sweeps across it and a soft chime plays (reduced motion: the chime alone). Keyboard focus stays in the fight while a
   round plays (on the row of choices) and moves to the gold card when the next choice appears. The room's bonus chips
   leave once the fight is decided.
   Pacing: a round runs about 7 s from your pick to the next choice (it was about 9). A tap anywhere but Leave while it plays (or Enter or
   Space) answers with a ripple and hurries the rest of the round: every hold still to come runs at half its time and
   the next roll is quicker, but every beat still lands in order. It resets at the next choice. When a choice appears,
   the last round's dice and sum fade after a moment, and they clear as her hands start to move, so her spell or the
   cards are the one thing to read.
   The win: she slumps and shatters, and only her figure goes. Her counter stays (a copy of her art's own pixels with
   her cut out, the tankard, coins and the snuffed candle kept), and a cluster of ice, drawn at the art's own pixel size,
   rises on the counter where she stood. Leave hides once the fight is decided (Back to the library and Face her again
   are the ways on).
   Painting: two painters would run during the fight, the library room under the overlay and her tavern. Once the
   tavern covers the room, the room's scroller (.lb-pan, or the .ffs-art on its own) is moved off screen with the CSS
   translate property and hidden: the room painter's own IntersectionObserver stops its loop. translate leaves the
   layout, the scroll position and the room's ResizeObserver alone (a resize still rebuilds the room once), and both are
   put back the moment the fight ends, before the overlay fades.
   The art is the Quest's own: QOArt.mountMatron (her states, menace, the cast, the cup, the stun and the smite), the
   tavern-cold backdrop on its own painter canvas (FFNoteScenes keeps that scene for this page,
   src/scene-pages/build/library.json), and QODice for every roll. Her words are Quest One's fixed lines (MATRON_LINES in
   assets/quest-one-v2.js) and the two opening lines above; her locked description in the Quest's prompts is never used
   or quoted here.
   The interface (library.js creates it once and closes it on teardown):
     FFD.parts['library/fight'](api) -> fight
       fight.open() -> Promise<'won' | 'lost' | 'left'>   the fight over the whole screen until it ends ('left' is the
                                                         Leave button, Escape, or close() while it is open, but once
                                                         she has fallen every way out is 'won', and once you have
                                                         fallen it is 'lost'; a fault inside the fight ends it the
                                                         same way rather than leaving the overlay stuck)
       fight.busy() -> true while the fight is open      fight.close()  take it away at once
       fight.state() -> a copy of the fight's numbers (QA), or null when no fight is open
   The room gives: F (the overlay is appended to F.el; F.art and F.spotCss('jb-matron') place the shadow over her figure
   when they're there), RM(), snd(name, opts), bonus() -> { road, saw, mem }, music ({ lpTo(hz, sec), duck(on) }, both
   optional). The room's own words (who she is, "Have you met her before?") come before open(); inside the fight only the
   fight speaks. Your bar carries your Quest character's name (FFD.char, else FFD.quest.hero())
   or "You".
   Reduced motion: no tumbling dice, travel, shake, flash, crack, shards or particles, and no waits between beats. Each
   round's beats land at once and stay on screen together until the next choice: the lines one after another, and the
   damage beside each health number instead of over it.
   Nothing is stored and nothing is sent. */
(() => {
  'use strict';
  const FFD = window.FFD = window.FFD || {};
  const CSS_ID = 'ffd-css-library-fight';
  const CDN = 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/';

  /* ---------- the numbers, named ---------- */
  const FIGHT = {
    you: 30, her: 30,
    toHit: 11, trickAt: 10,                 /* your d20 + to hit must reach these */
    guard: 12, herHit: 2,                   /* her d20 + 2 against your guard */
    blow: 6, blowB: 2, spellB: 3,           /* her blow 1d6 + 2 (a natural 20 adds 1d6), her spell 2d6 + 3 */
    shield: 5, heal: 6,                     /* Shield: +5 guard for her next attack, then 1d6 health */
    handYou: 8,                             /* the hand is offered while your health is at or under 8 */
    rise: 15, stand: 10,                    /* Roll to stand: a clean rise, or on your feet first */
    clean: 2, road: 1, saw: 2, mem: 2       /* the clean rise and the room's three bonuses */
  };
  /* her words: Quest One's fixed lines (assets/quest-one-v2.js, MATRON_LINES), then the opening's two, in the room's
     curly quotes */
  const MATRON_LINES = ['“Everyone gets up once.”', '“Six weeks of travelers, and not one of them was different.”', '“Sit down, love. It is easier.”'];
  const OPEN_LINES = ['“Remember this place, love? I can bring it anywhere.”', '“Neat trick, isn’t it? Would you like a drink before we start?”'];
  /* her three swings: what she tries (said before the roll, so it never says whether it lands), then what the roll made
     of it: a hit, a miss, a miss on her wild swing (after your Trick), and a miss off your Shield */
  const SWINGS = [
    { go: 'She swings the iron cup.', hit: 'It catches you hard.', miss: 'You duck under it.', wild: 'Her swing goes wide.', ward: 'It rings off your guard.' },
    { go: 'Her cold hand reaches for you.', hit: 'It closes on your arm.', miss: 'You pull away in time.', wild: 'Her hand closes on nothing.', ward: 'It slides off your guard.' },
    { go: 'She throws the frost from her cup.', hit: 'It bites into you.', miss: 'It hisses past you.', wild: 'It flies wide of you.', ward: 'It freezes on your guard.' }
  ];

  /* ---------- Jan's recorded sounds, as Quest One plays them (assets/quest-one-v2-audio.js FILES and FILE_VOL). They play
     on FFSound's own audio context (the one the jukebox plays through), decoded once, so the bolt lands on the art's
     impact frame. Catch is the Quest's inline AAC (its Files original is Ogg, which older iPhones can't play); the bolt
     and the shatter are Shopify Files, fetched only when the hand is first offered and when she is nearly down. Muted
     means silent; a clip that isn't ready gives way to an FFSound sound. ---------- */
  const CLIPS = { catch: { vol: 0.75 }, bolt: { src: CDN + 'attack.wav?v=1791264246', vol: 0.8 }, shatter: { src: CDN + 'shatter.MP3?v=1778071284', vol: 0.55 } };
  const CLIP_BUF = {}, CLIP_LOAD = {};
  const audioCtx = () => { try { return window.FFSound && typeof FFSound.wake === 'function' ? FFSound.wake() : null; } catch (e) { return null; } };
  function warmClip(k) {
    if (CLIP_LOAD[k]) return CLIP_LOAD[k];
    const ac = audioCtx(), c = CLIPS[k];
    if (!ac || !c || typeof ac.decodeAudioData !== 'function') return null;
    CLIP_LOAD[k] = (async () => {
      let bytes;
      if (k === 'catch') {
        const b = atob(catchAac()), u = new Uint8Array(b.length);
        for (let i = 0; i < b.length; i++) u[i] = b.charCodeAt(i);
        bytes = u.buffer;
      } else {
        const r = await fetch(c.src, { mode: 'cors', credentials: 'omit' });
        if (!r.ok) throw new Error('clip ' + r.status);
        bytes = await r.arrayBuffer();
      }
      /* the callback form too: Safari before 14.1 has no promise from decodeAudioData */
      CLIP_BUF[k] = await new Promise((res, rej) => { try { const p = ac.decodeAudioData(bytes, res, rej); if (p && typeof p.then === 'function') p.then(res, rej); } catch (e) { rej(e); } });
    })().catch(() => { CLIP_BUF[k] = null; });
    return CLIP_LOAD[k];
  }

  /* ---------- the effects' own random stream (mulberry32), so scripted tests that stub Math.random steer only the rules */
  let vSeed = (Date.now() ^ 0x5bd1e995) | 0;
  const vr = () => { vSeed = (vSeed + 0x6D2B79F5) | 0; let t = Math.imul(vSeed ^ (vSeed >>> 15), 1 | vSeed); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };

  /* ---------- small line icons (stroke only, currentColor) ---------- */
  const SVG = (d, cls) => '<svg viewBox="0 0 24 24" aria-hidden="true"' + (cls ? ' class="' + cls + '"' : '') + '><path d="' + d + '"/></svg>';
  const ICON = {
    strike: SVG('M19.5 4.5l-10 10M15.5 4.5h4v4M6.5 12.5l5 5M9 15l-4.5 4.5'),
    trick: SVG('M4.5 17.5c1.6-6.4 6.2-10 13-10M14.5 4.5l3.5 3-3.5 3M4.5 10.5c1-1.6 2.4-2.9 4-3.8'),
    shield: SVG('M12 3.5l7 2.6v5.4c0 4.4-2.9 7.6-7 9-4.1-1.4-7-4.6-7-9V6.1z'),
    hand: SVG('M8 12.5V6.8a1.4 1.4 0 012.8 0V11M10.8 10.5V5.4a1.4 1.4 0 012.8 0v5.1M13.6 10.5V6.6a1.4 1.4 0 012.8 0V14c0 3.9-2.6 6.5-6.2 6.5-2.5 0-4.2-1.3-5.3-3.4L3.6 14a1.3 1.3 0 012.2-1.4L8 15'),
    d20: SVG('M12 3l7.8 4.5v9L12 21l-7.8-4.5v-9zM12 3L6.6 13h10.8zM4.2 7.5L6.6 13M19.8 7.5L17.4 13M6.6 13L12 21l5.4-8'),
    again: SVG('M5 12a7 7 0 1 0 2.1-5M5 4.5V8h3.5'),
    back: SVG('M10 6l-6 6 6 6M4.5 12H20')
  };
  const GUARD_SVG = '<svg viewBox="0 0 40 44" aria-hidden="true"><path d="M20 2.5l15 5.5v11.2c0 9.6-6.4 16.6-15 19.8C11.4 35.8 5 28.8 5 19.2V8z"/></svg>';
  /* her cast's rune ring, as pixel art on her art's own grid: 85 x 84 of its pixels (art x 54 to 139, y 40 to 124, so
     its centre is her centre line, x 96.5, at y 82, between her lifted hands) in her spell's colours (m2 to m5 in
     assets/quest-one-v2-art.js, and the ice's white). From the outside in: a dashed ring turning one way, a band of
     runes between two rings turning the other, and a six-point star turning slowly inside. The runes are 5 x 5 bitmaps
     made of rings, dots, hooks and bars (a moon and a star, a sun, an eye, three stars over a bar, a maze, a key, two
     waves, a starred triangle, a ring on a stand, broken and whole bars), none of them a letter, laid round the band
     with their tops outward and moved a whole pixel at a time, so they stay crisp as they turn. In the surge, lit
     pixels crackle with a sparse dithered halo, as her orb's light does. o: { a, b, c } the three turns (radians),
     lvl 1 (gathering: a light runs round the band at angle hl) or 2 (the surge: everything lit), u 0 to 1 how far
     round it has written itself (from the top, clockwise, with a bright pen point at the front) */
  const RUNE_W = 85, RUNE_H = 84, RUNE_CX = 42.5, RUNE_CY = 42;
  const RUNE_GLYPHS = [
    ['.##..', '##...', '##.#.', '##...', '.##..'],
    ['.###.', '#...#', '#.#.#', '#...#', '.###.'],
    ['.....', '.###.', '#.#.#', '.###.', '.....'],
    ['#.#.#', '.....', '#####', '.....', '..#..'],
    ['#####', '....#', '.##.#', '.#..#', '.####'],
    ['..#..', '.###.', '..#..', '.#.#.', '..#..'],
    ['.#.#.', '#.#.#', '.....', '.#.#.', '#.#.#'],
    ['..#..', '.#.#.', '.#.#.', '#.#.#', '#####'],
    ['.###.', '.#.#.', '.###.', '..#..', '.###.'],
    ['##.##', '.....', '#####', '.....', '##.##']
  ].map((g) => g.map((row) => [...row].map((c) => c === '#')));
  const RUNE_ORDER = [0, 4, 1, 7, 3, 9, 5, 2, 8, 6, 1, 4, 0, 9, 7, 2, 5, 3];   /* 18 runes round the band, no two alike side by side */
  /* ABGR, as a Uint32Array sees canvas pixels on a little-endian machine */
  const RUNE_PAL = { h: 0xb894735d, h2: 0xccd9b79f, d: 0xff94735d, m: 0xffd9b79f, b: 0xfff5e4d6, w: 0xfffffbf4 };
  const RUNE_BAY = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
  function runePainter(cv) {
    const g = cv && cv.getContext && cv.getContext('2d');
    if (!g) return null;
    const W = RUNE_W, H = RUNE_H, N = W * H, R = new Float32Array(N), A = new Float32Array(N), TAU = Math.PI * 2;
    for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
      const dx = x + 0.5 - RUNE_CX, dy = y + 0.5 - RUNE_CY, i = y * W + x;
      R[i] = Math.sqrt(dx * dx + dy * dy); A[i] = (Math.atan2(dx, -dy) + TAU) % TAU;   /* 0 at the top, clockwise */
    }
    const im = g.createImageData(W, H), px = new Uint32Array(im.data.buffer), lit = new Uint8Array(N), star = new Uint8Array(N);
    const MID = 33.5, SLOT = TAU * MID / RUNE_ORDER.length;
    const line = (x0, y0, x1, y1) => {
      const n = Math.ceil(Math.max(Math.abs(x1 - x0), Math.abs(y1 - y0)) * 1.4);
      for (let k = 0; k <= n; k++) { const x = Math.floor(x0 + (x1 - x0) * k / n), y = Math.floor(y0 + (y1 - y0) * k / n); if (x >= 0 && y >= 0 && x < W && y < H) star[y * W + x] = 1; }
    };
    return (o) => {
      const lvl = o.lvl || 1, u = o.u == null ? 1 : o.u, surge = lvl >= 2;
      /* the band moves a whole pixel at a time along its middle, so a rune keeps its shape as it turns */
      const a = Math.round(o.a * MID) / MID, b = o.b, hl = o.hl || 0;
      star.fill(0);
      const pts = [];
      for (let k = 0; k < 6; k++) { const t = o.c + k * Math.PI / 3; pts.push([RUNE_CX + Math.sin(t) * 27.6, RUNE_CY - Math.cos(t) * 27.6]); }
      [[0, 2], [2, 4], [4, 0], [1, 3], [3, 5], [5, 1]].forEach((e) => line(pts[e[0]][0], pts[e[0]][1], pts[e[1]][0], pts[e[1]][1]));
      for (let i = 0; i < N; i++) {
        const r = R[i], th = A[i];
        let c = 0;
        if (u < 1 && th / TAU > u) { px[i] = 0; lit[i] = 0; continue; }
        if (Math.abs(r - 40.5) < 0.5) {
          const s = ((th - b) % TAU + TAU) % TAU * 40.5;
          if (Math.floor(s / 3) % 2 === 0) c = surge ? RUNE_PAL.m : RUNE_PAL.d;
        } else if (Math.abs(r - 37.5) < 0.5 || Math.abs(r - 29.5) < 0.5) c = surge ? RUNE_PAL.b : RUNE_PAL.m;
        else if (r >= 31 && r < 36) {
          const s = ((th - a) % TAU + TAU) % TAU * MID, slot = Math.floor(s / SLOT), loc = s - slot * SLOT;
          const col = Math.floor(loc - (SLOT - 5) / 2), row = Math.floor(36 - r);
          if (col >= 0 && col < 5) {
            if (RUNE_GLYPHS[RUNE_ORDER[slot % RUNE_ORDER.length]][row][col]) {
              const off = Math.abs(((th - hl) % TAU + TAU + Math.PI) % TAU - Math.PI);
              c = surge ? (off < 0.9 ? RUNE_PAL.w : RUNE_PAL.b) : off < 0.42 ? RUNE_PAL.w : off < 0.9 ? RUNE_PAL.b : RUNE_PAL.m;
            }
          } else if (Math.floor(loc) === 0 && row === 2) c = RUNE_PAL.d;
        } else if (r < 28.9 && star[i]) c = surge ? RUNE_PAL.m : RUNE_PAL.d;
        /* the pen point: the newest sliver of the ring burns white while it writes itself */
        if (c && u < 1 && u - th / TAU < 0.035) c = RUNE_PAL.w;
        px[i] = c; lit[i] = c ? 1 : 0;
      }
      /* the star's points */
      pts.forEach((p) => { const x = Math.floor(p[0]), y = Math.floor(p[1]), i = y * W + x; if (x >= 0 && y >= 0 && x < W && y < H && (u >= 1 || A[i] / TAU <= u)) { px[i] = RUNE_PAL.b; lit[i] = 1; } });
      /* in the surge, a sparse dithered crackle round everything lit, as her orb's light falls off (while it gathers,
         the canvas's own soft glow is the light, so the runes stay clean) */
      if (surge) for (let y = 1; y < H - 1; y++) for (let x = 1; x < W - 1; x++) {
        const i = y * W + x;
        if (lit[i] || !(lit[i - 1] + lit[i + 1] + lit[i - W] + lit[i + W])) continue;
        const d = RUNE_BAY[(y & 3) * 4 + (x & 3)] / 16;
        if (d < 0.2) px[i] = RUNE_PAL.h2; else if (d < 0.34) px[i] = RUNE_PAL.h;
      }
      g.putImageData(im, 0, 0);
    };
  }
  let fxN = 0;

  /* the ice where she stood, as pixel art at her art's own scale: a 72 x 46 cluster (art x 60 to 132, y 72 to 118) of
     back shards, a frost mound over the counter where her hands lay, and short front shards. Lit from the upper left like
     the art: a pale left face, a mid right face, a dark edge, a white ridge near the tip. Returns the tallest tip */
  const ICE_W = 72, ICE_H = 46;
  function paintIce(cv) {
    const g = cv && cv.getContext && cv.getContext('2d');
    if (!g) return null;
    const C = { O: '#14273f', D: '#3d6a9a', M: '#7eb0dc', L: '#c4e4fa', W: '#f4fbff', F: '#a8d4f2' };
    const px = (x, y, c) => { if (x >= 0 && y >= 0 && x < ICE_W && y < ICE_H) { g.fillStyle = C[c]; g.fillRect(x, y, 1, 1); } };
    g.clearRect(0, 0, ICE_W, ICE_H);
    const shard = (bx, w, h, lean, by) => {
      const ty = by - h, tx = bx + lean;
      px(Math.round(tx), ty - 1, 'O');
      for (let y = ty; y <= by; y++) {
        const t = (y - ty) / h, cx = tx + (bx - tx) * t, hw = w * t, a = Math.round(cx - hw), b = Math.max(a, Math.round(cx + hw)), r = Math.round(cx);
        px(a - 1, y, 'O'); px(b + 1, y, 'O');
        for (let x = a; x <= b; x++) {
          const deep = t > 0.82;
          px(x, y, x === r ? (t < 0.7 ? 'W' : 'L') : x < r ? (deep ? 'M' : x === a && t < 0.5 ? 'W' : 'L') : x === b ? 'D' : deep ? 'D' : 'M');
        }
      }
    };
    [[36, 6, 41, 0, 42], [26, 5, 29, 0, 41], [47, 5, 31, 2, 41], [16, 4, 20, -2, 41], [57, 4, 22, 2, 41]].forEach((s) => shard(...s));
    /* the frost mound: rows 36 to 45 across the counter, tapering down at its ends, outlined wherever it is exposed */
    const tops = [];
    for (let x = 0; x < ICE_W; x++) {
      const u = (x - 2) / (ICE_W - 5);
      tops.push(x < 2 || x > ICE_W - 3 ? ICE_H : Math.min(ICE_H - 2, 36 + Math.round(7 * Math.pow(Math.abs(u - 0.5) * 2, 4)) + ((x * 7) % 5 === 0 ? 1 : 0)));
    }
    for (let x = 2; x < ICE_W - 2; x++) {
      const top = tops[x];
      for (let y = top; y < ICE_H; y++) px(x, y, y === top || tops[x - 1] > y || tops[x + 1] > y ? 'O' : y === top + 1 ? 'W' : y >= ICE_H - 1 ? 'D' : (x + y) % 2 ? 'F' : 'L');
    }
    [[31, 4, 15, -1, 43], [42, 4, 13, 1, 43], [9, 3, 11, -2, 44], [63, 3, 12, 2, 44], [20, 3, 8, 0, 44], [52, 3, 9, 0, 44]].forEach((s) => shard(...s));
    /* a few glints in the frost */
    [[14, 39], [33, 38], [48, 39], [60, 38]].forEach((p) => px(p[0], p[1], 'W'));
    return { x: 36, y: 1 };
  }

  /* her spell, as pixel art on her art's own grid. The art's own cast lifts and cups her hands, lights them cold and puts
     a small dithered core between them (art x 96.7, y 75.7, bright out to radius 6, her lit fingers at 9 to 11); this
     is that spell grown into a sphere of frost on a canvas of 65 x 66 of the art's pixels (x 64 to 128, y 43 to 108)
     centred on it (art y 76). Its colours are the art's moonlight (m1 to m5 in assets/quest-one-v2-art.js) and the ice's
     white, with the ice of her end (paintIce's pale cyan and blues) for its shards. A ball lit from the upper left
     (R 8.5 at rest, so its rim meets her lit fingers and it covers the art's core), a small frost crystal at its heart
     with a light running round its arms, short hairline cracks of light that flicker across it a step at a time in the
     surge (dark ones when it is weak) and three ice slivers tumbling round it close in on tilted orbits (behind it on
     the far side). The art's own glow, lit hands and motes are its light while it charges.
     o.mode: 'on' gathers from motes into the sphere (o.g 0 to 1), then breathes; 'surge' swells two pixels, brightens
     and cracks all over, its slivers spinning three times as fast with four snow motes round it, and pushes one ring of
     light out as it swells; 'weak' (Tricked apart, still in her hands) shrinks a little and sinks a pixel, stutters,
     goes dim and gappy (its gaps dark, never the art's core), and sheds its slivers to fall and fizzle. 'pop' (her
     hands drop on her turn) collapses and scatters what is left. A frame is a pure function of o.t (ms in this
     state) and o.T (ms since it was lit), through a hash, so a still frame (o.still, reduced motion) is always the same
     and a stubbed Math.random moves nothing here. frostSphere and sliver also draw the thrown spell (throwOrb) */
  const ORB_W = 65, ORB_H = 66, ORB_X0 = 64, ORB_Y0 = 43, ORB_CX = 32.5, ORB_CY = 33, TAU = Math.PI * 2;
  /* ABGR: m1, m2, m3, m4, m5 and the ice's white, then the ice's pale cyan, mid, deep and its outline */
  const FP = { k: 0xff281a13, n: 0xff4a3023, d: 0xff94735d, m: 0xffd9b79f, b: 0xfff5e4d6, w: 0xfffffbf4, L: 0xfffae4c4, M: 0xffdcb07e, D: 0xff9a6a3d, O: 0xff3f2714 };
  const bayr = (x, y) => (RUNE_BAY[((y & 3) << 2) | (x & 3)] + 0.5) / 16;
  const hsh = (a, b, c) => {
    let h = (Math.imul(a | 0, 0x27d4eb2d) ^ Math.imul((b | 0) + 0x165667b1, 0x85ebca6b) ^ Math.imul((c | 0) + 0x61c88647, 0xc2b2ae35)) | 0;
    h = Math.imul(h ^ (h >>> 15), 0x2c1b3c6d); h = Math.imul(h ^ (h >>> 12), 0x297a2d39);
    return ((h ^ (h >>> 15)) >>> 0) / 4294967296;
  };
  const eo = (v) => 1 - Math.pow(1 - Math.min(1, Math.max(0, v)), 3);
  /* the sphere at (cx, cy), radius R, shaded as a ball lit from the upper left: a pale lit side, a mid body and a
     shadowed crescent low on the right, inside a selective outline (pale where the light falls on its edge, navy in
     its shadow, never black); a glint on its glass up and to the left, and in it a small frost crystal of six arms
     (it stays a small heart in a big sphere; two twigs on each arm only at its in-hand sizes) in its palest colours,
     the inner half of every arm always lit and the lit arm (o.arm) lit to its tip (paler when it is dimmed).
     o: { lvl (brighter +, dimmer -), rot (the crystal's turn), arm (the one arm lit white, or -1 for all of them),
     broken (arms left out, 0 to 1), holes (0 to 1: pixels gone dark, scattered by a hash and more of them toward the
     rim so it crumbles from its edge, never a regular mesh; dark, so whatever is under the sphere never shows
     through) } */
  function frostSphere(put, cx, cy, R, o) {
    if (R < 0.8) return;
    const lvl = o.lvl || 0, holes = o.holes || 0, rot = o.rot == null ? -Math.PI / 2 : o.rot, arm = o.arm == null ? -1 : o.arm, dz = 0.1;
    const gap = (x, y, nd) => holes > 0 && hsh(x, y, 91) < holes * (0.4 + 1.2 * nd);
    const set = (x, y, c) => { const dx = x + 0.5 - cx, dy = y + 0.5 - cy, dd = dx * dx + dy * dy; if (dd <= (R - 1) * (R - 1) && !gap(x, y, Math.sqrt(dd) / R)) put(x, y, c); };
    for (let y = Math.floor(cy - R - 1); y <= cy + R + 1; y++) for (let x = Math.floor(cx - R - 1); x <= cx + R + 1; x++) {
      const dx = x + 0.5 - cx, dy = y + 0.5 - cy, d = Math.sqrt(dx * dx + dy * dy);
      if (d > R) continue;
      const b = bayr(x, y);
      if (gap(x, y, d / R)) { put(x, y, FP.n); continue; }
      if (d > R - 1) { put(x, y, dx + dy > R * 0.5 ? FP.n : dx + dy > -R * 0.3 ? FP.d : FP.m); continue; }
      const nd = d / R, nx = dx / R, ny = dy / R, nz = Math.sqrt(Math.max(0, 1 - nx * nx - ny * ny)), lam = Math.max(0, -0.6 * nx - 0.66 * ny + 0.45 * nz);
      const v = 0.08 + 0.55 * lam + 0.12 * (1 - nd) + lvl + (b - 0.5) * dz;
      put(x, y, v < 0.12 ? FP.n : v < 0.36 ? FP.d : v < 0.6 ? FP.m : v < 0.84 ? FP.L : FP.w);
    }
    if (R >= 3.5) {
      const L = Math.min(R * 0.72, 6.5), hi = lvl < -0.1 ? FP.L : FP.w, lo = lvl < -0.1 ? FP.m : FP.L;
      for (let k = 0; k < 6; k++) {
        if (o.broken && hsh(k, Math.floor(R * 4), 61) < o.broken) continue;
        const a = rot + k * Math.PI / 3, c = Math.cos(a), s = Math.sin(a), hot = arm < 0 || k === arm;
        for (let r = 0.5; r <= L; r += 0.5) set(Math.floor(cx + c * r), Math.floor(cy + s * r), hot || r <= L * 0.5 ? hi : lo);
        if (R >= 9.5 && R <= 14) [0.48, 0.74].forEach((f, j) => {
          const r0 = L * f, tl = R * (j ? 0.14 : 0.2);
          [-1, 1].forEach((sd) => { const a2 = a + sd * Math.PI / 3; for (let q = 0.5; q <= tl; q += 0.5) set(Math.floor(cx + c * r0 + Math.cos(a2) * q), Math.floor(cy + s * r0 + Math.sin(a2) * q), hot ? FP.L : FP.m); });
        });
      }
      set(Math.floor(cx), Math.floor(cy), hi);
      if (R > 10) {
        const gx = Math.floor(cx - R * 0.5), gy = Math.floor(cy - R * 0.48);
        set(gx, gy, FP.w); set(gx + 1, gy, FP.w); set(gx, gy + 1, FP.w); set(gx + 1, gy + 1, FP.w); set(gx + 2, gy + 2, FP.b);
      } else set(Math.floor(cx - R * 0.52), Math.floor(cy - R * 0.5), FP.w);
    }
  }
  /* hairline cracks of light: n of them for this step, each a short jagged walk in from near the rim (a branch now and
     then), kept a pixel inside it and never longer than maxL when it is given (on a big sphere they stay short) */
  function frostCracks(put, cx, cy, R, step, n, col, salt, maxL) {
    for (let k = 0; k < n; k++) {
      const h = (j) => hsh(step, k * 16 + j, salt);
      const a0 = h(0) * TAU, r0 = R * (0.5 + 0.38 * h(1)), len = Math.min(maxL || Infinity, Math.max(2, R * (0.45 + 0.4 * h(2))));
      let x = cx + Math.cos(a0) * r0, y = cy + Math.sin(a0) * r0, a = a0 + Math.PI * (0.62 + 0.76 * h(3));
      const jit = 1.1 * Math.min(1, 5 / len);   /* a long crack (a big sphere) kinks less per pixel, so it never curls */
      const walk = (x1, y1, a1, l, j0) => {
        for (let i = 0; i < l; i++) {
          a1 += (h(j0 + i) - 0.5) * jit; x1 += Math.cos(a1); y1 += Math.sin(a1);
          const dx = x1 - cx, dy = y1 - cy;
          if (dx * dx + dy * dy > (R - 1.4) * (R - 1.4)) break;
          put(Math.floor(x1), Math.floor(y1), col);
        }
        return [x1, y1, a1];
      };
      const mid = walk(x, y, a, Math.ceil(len * 0.55), 4);
      walk(mid[0], mid[1], mid[2], Math.ceil(len * 0.45), 9);
      if (h(14) < 0.5) walk(mid[0], mid[1], mid[2] + (h(15) < 0.5 ? -1 : 1) * 1.1, Math.ceil(len * 0.3), 11);
    }
  }
  /* a tumbling ice sliver at (x, y) turned to angle a, as the ice of her end is lit: a white tip, its pale face, a mid
     blue tail and a deep blue edge down one side (longer when big, every pixel z x z when z is given); far ones two dim
     pixels */
  function sliver(put, x, y, a, near, big, z) {
    const c = Math.cos(a), s = Math.sin(a), q = z || 1;
    const P = (k, w, col) => { const X = Math.floor(x + (c * k - s * w) * q), Y = Math.floor(y + (s * k + c * w) * q); for (let j = 0; j < q; j++) for (let i = 0; i < q; i++) put(X + i, Y + j, col); };
    if (!near) { P(0.6, 0, FP.M); P(-0.6, 0, FP.D); return; }
    if (big) { P(2, 0, FP.w); P(1, 0, FP.L); P(0, 0, FP.L); P(-1, 0, FP.M); P(1, 1, FP.M); P(0, 1, FP.D); P(-1, 1, FP.D); return; }
    P(1.5, 0, FP.w); P(0.5, 0, FP.L); P(-0.5, 0, FP.M); P(0.5, 1, FP.D);
  }
  /* three tilted orbits (how far out past the sphere's rim, tilt, way round; each is flattened to a third as tall as it
     is wide, so the slivers hug the sphere inside her cupped hands) and a sliver on each (orbit, phase) */
  const ORB_RINGS = [[3.5, -0.3, 1], [4.5, 0.42, -0.8], [3, 0.06, 1.25]];
  const ORB_SHARDS = [[0, 0], [1, 0.33], [2, 0.66]];
  function orbPainter(cv) {
    const g = cv && cv.getContext && cv.getContext('2d');
    if (!g) return null;
    const W = ORB_W, H = ORB_H, im = g.createImageData(W, H), px = new Uint32Array(im.data.buffer);
    const put = (x, y, c) => { if (x >= 0 && y >= 0 && x < W && y < H) px[y * W + x] = c; };
    /* a ring of light at radius rr, thinned by the Bayer under 'thin' (0: solid) */
    const ring = (cx, cy, rr, thin, col) => {
      const n = Math.ceil(TAU * rr * 1.5);
      for (let i = 0; i < n; i++) { const a = i / n * TAU, x = Math.floor(cx + Math.cos(a) * rr), y = Math.floor(cy + Math.sin(a) * rr); if (bayr(x, y) >= thin) put(x, y, col); }
    };
    return (o) => {
      px.fill(0);
      if (!o || !o.mode) { g.putImageData(im, 0, 0); return; }
      const mode = o.mode, t = o.t || 0, T = o.T || 0, still = !!o.still, gth = mode === 'on' && o.g != null ? o.g : 1;
      let R = 8.5, cx = ORB_CX, cy = ORB_CY, lvl = 0, spinV = 1, crk = 0, crkStep = 110, halo = 0, holes = 0, scl = 1 + 1.5 * (1 - eo(gth)), grow = 0, body = true;
      /* the crystal: still, with a light running round its arms (one every 160 ms) while it charges; every arm lit and
         ticking round a twelfth of a turn every 70 ms in the surge; dim and losing arms when it is weak. At rest the
         sphere (R 8.5) fills her cupped hands, its rim meeting her lit fingers, and it is never darker than the art's own
         bright core under it */
      let rot = -Math.PI / 2, arm = still ? -1 : Math.floor(T / 160) % 6, broken = 0;
      if (mode === 'on') {
        R = gth < 0.12 ? 0 : 1 + 7.5 * eo((gth - 0.12) / 0.88);
        if (gth >= 1 && !still) R += 0.4 * Math.sin(T / 1400 * TAU);
        lvl = 0.1;
      } else if (mode === 'surge') {
        const su = still ? 1 : eo(t / 260);
        R = 8.5 + 2 * su + (still ? 0 : 0.5 * Math.sin(T / 320 * TAU)); lvl = 0.1 + 0.06 * su; spinV = 3.2; crkStep = 60; halo = su > 0.3 ? 1 : 0; scl = 1; grow = 2 * su;
        crk = still ? 1 : 1 + (hsh(Math.floor(T / crkStep), 2, 7) < 0.5 ? 1 : 0);
        arm = -1; rot += still ? 0 : Math.floor(T / 70) * Math.PI / 12;
        if (!still && t > 260 && hsh(Math.floor(T / 70), 3, 7) < 0.16) cx += hsh(Math.floor(T / 70), 4, 7) < 0.5 ? -1 : 1;
      } else if (mode === 'weak') {
        /* it stays big enough (R 7 at least) to cover the art's bright core, so it dies in her hands, dim, gappy and
           stuttering between its dim body and an all-dark frame */
        const wk = still ? 1 : eo(t / 450);
        R = 8.5 - 1.5 * wk; cy += still ? 1 : eo(t / 800); lvl = -0.24 * wk; holes = 0.16 * wk; spinV = 0.4;
        arm = 6; broken = 0.45 * wk;
        const st = Math.floor(t / 85);
        if (!still && t > 320) {
          const hs = hsh(st, 11, 7);
          if (hs < 0.12) lvl = -0.5; else if (hs < 0.32) holes += 0.18;
          if (hsh(st, 12, 7) < 0.25) cx += hsh(st, 13, 7) < 0.5 ? -1 : 1;
        }
        crk = still ? 1 : hsh(st, 14, 7) < 0.45 ? 1 : 0; crkStep = 85;
      } else if (mode === 'pop') {
        const u = Math.min(1, t / 170); R = 7 * (1 - u * u); cy += 1; lvl = 0.4 * u; body = t < 170; arm = 6; broken = 0.5;
      }
      const ice = R > 0 && body;
      /* in the surge, its light round the rim: a solid ring a pixel wide (while it charges the art's own glow and its
         lit hands are its light) */
      if (ice && halo > 0) for (let y = Math.floor(cy - R - halo - 1); y <= cy + R + halo + 1; y++) for (let x = Math.floor(cx - R - halo - 1); x <= cx + R + halo + 1; x++) {
        const dx = x + 0.5 - cx, dy = y + 0.5 - cy, d = Math.sqrt(dx * dx + dy * dy);
        if (d <= R || d > R + halo) continue;
        put(x, y, FP.d);
      }
      /* the slivers' places this frame (far ones now, near ones after the sphere) */
      const shards = [];
      if (mode !== 'pop') ORB_SHARDS.forEach((s, i) => {
        const rg = ORB_RINGS[s[0]], per = 2600 / spinV, rx = (Math.max(R, 1) + rg[0] + grow) * scl, ry = rx * 0.32;
        let a = (s[1] + (still ? 0 : T / per * rg[2])) * TAU, fall = null;
        if (mode === 'weak') {
          const ti = 60 + i * 120, tau = (still ? (i < 2 ? 200 : 900) : t) - ti;
          if (tau > 0) { if (tau > 600) return; a = (s[1] + (still ? 0 : (T - tau) / per * rg[2])) * TAU; fall = tau; }
        }
        const ex = Math.cos(a) * rx, ey = Math.sin(a) * ry, c = Math.cos(rg[1]), sn = Math.sin(rg[1]);
        let x = cx + ex * c - ey * sn, y = cy + ex * sn + ey * c;
        const near = Math.sin(a) >= 0;
        if (fall != null) {
          x += (x - cx) * 0.0016 * fall; y += 0.00011 * fall * fall;
          if (fall > 380 && bayr(Math.floor(x), Math.floor(y)) < (fall - 380) / 220) return;
        }
        if (mode === 'on' && gth < 1 && hsh(i, 5, 7) * 0.6 > gth) return;
        shards.push({ x, y, near: near || fall != null, rot: a * 2 + i * 1.7 + (fall || 0) * 0.02, big: i % 3 === 0 });
      });
      const inSphere = (x, y) => { const dx = Math.floor(x) + 0.5 - cx, dy = Math.floor(y) + 0.5 - cy; return dx * dx + dy * dy <= (R + 0.5) * (R + 0.5); };
      shards.forEach((s) => { if (!s.near && !(ice && inSphere(s.x, s.y))) sliver(put, s.x, s.y, s.rot, false); });
      /* in the surge, four snow motes drifting down close round it (while it charges, the art's own motes circle it) */
      if (mode === 'surge') for (let i = 0; i < 4; i++) {
        const span = 30, fall = ((still ? 0.3 : T / 1000 * (2.2 + hsh(i, 21, 7) * 2)) + hsh(i, 22, 7) * span) % span;
        const r = R + 2 + hsh(i, 23, 7) * 3, a = hsh(i, 24, 7) * TAU + (still ? 0 : T / 4200);
        const x = cx + Math.cos(a) * r, y = cy - span / 2 + fall + Math.sin(a) * 2;
        if (ice && inSphere(x, y)) continue;
        put(Math.floor(x), Math.floor(y), i % 3 ? FP.b : FP.L);
      }
      /* the gather: motes of frost spiralling in from round her hands into the sphere, each with a short tail */
      if (mode === 'on' && gth < 1) for (let i = 0; i < 18; i++) {
        const dl = hsh(i, 31, 7) * 0.4, p = Math.min(1, Math.max(0, (gth - dl) / 0.6));
        if (p >= 1) continue;
        const r0 = 14 + hsh(i, 32, 7) * 8, R0 = Math.max(R, 1), at = (q) => { const rr = R0 + (r0 - R0) * (1 - eo(q)), a = i / 18 * TAU + hsh(i, 33, 7) + (1 - q) * 1.7; return [cx + Math.cos(a) * rr, cy + Math.sin(a) * rr * 0.86]; };
        const h0 = at(p), h1 = at(Math.max(0, p - 0.06)), h2 = at(Math.max(0, p - 0.12));
        put(Math.floor(h2[0]), Math.floor(h2[1]), FP.d); put(Math.floor(h1[0]), Math.floor(h1[1]), p < 0.4 ? FP.d : FP.m);
        put(Math.floor(h0[0]), Math.floor(h0[1]), p < 0.3 ? FP.m : p < 0.7 ? FP.L : FP.w);
      }
      if (ice) {
        frostSphere(put, cx, cy, R, { lvl, holes, rot, arm, broken });
        if (crk && R > 3) frostCracks(put, cx, cy, R, still ? 0 : Math.floor(T / crkStep), crk, mode === 'weak' ? FP.n : FP.w, mode === 'surge' ? 3 : 5, 5);
      }
      shards.forEach((s) => { if (s.near) sliver(put, s.x, s.y, s.rot, true, s.big); });
      /* the surge: one ring of light pushed out as it swells, solid, fading a colour at a time */
      if (mode === 'surge' && !still && t < 340) ring(cx, cy, R + 1.5 + eo(t / 340) * 10, 0, t < 115 ? FP.b : t < 230 ? FP.m : FP.d);
      /* weak: now and then a spark sputters off and drops */
      if (mode === 'weak' && !still && t > 700) {
        const st = Math.floor(t / 380), tau = t - st * 380, a = hsh(st, 41, 7) * TAU;
        if (tau < 300) { const x = cx + Math.cos(a) * (R + 1 + tau * 0.006), y = cy + Math.sin(a) * (R + 1) + tau * tau * 0.00005; if (bayr(Math.floor(x), Math.floor(y)) >= tau / 300) put(Math.floor(x), Math.floor(y), tau < 120 ? FP.b : FP.d); }
      }
      /* the pop: a white cross where it collapsed, then slivers and motes thrown out, falling and fizzling */
      if (mode === 'pop') {
        if (t >= 150 && t < 230) { [[0, 0], [1, 0], [-1, 0], [0, 1], [0, -1], [2, 0], [-2, 0], [0, 2], [0, -2]].forEach((q, j) => put(Math.floor(cx) + q[0], Math.floor(cy) + q[1], j < 5 ? FP.w : FP.b)); }
        const tau = t - 150;
        if (tau > 0) for (let i = 0; i < 14; i++) {
          const a = i / 14 * TAU + hsh(i, 51, 7) * 0.5, v = 0.02 + hsh(i, 52, 7) * 0.025, dd = v * tau * (1 - tau / 1500);
          const x = cx + Math.cos(a) * dd, y = cy + Math.sin(a) * dd * 0.8 + 0.00007 * tau * tau;
          if (tau > 300 && bayr(Math.floor(x), Math.floor(y)) < (tau - 300) / 260) continue;
          if (i % 2) sliver(put, x, y, a + tau * 0.02, true, false); else put(Math.floor(x), Math.floor(y), tau < 200 ? FP.b : FP.m);
        }
      }
      g.putImageData(im, 0, 0);
    };
  }

  const CSS = `
.ffd-page--library .lbf { position: fixed; left: 0; top: 0; z-index: 30; display: block; width: 100%; height: 100vh; height: 100svh; overflow: hidden; background-color: transparent; color: #f3e6c8; opacity: 0; transition: opacity .32s ease-out; -webkit-tap-highlight-color: transparent; user-select: none; -webkit-user-select: none; touch-action: manipulation; outline: none; }
.ffd-page--library .lbf.is-in { opacity: 1; }
.ffd-page--library .lbf.is-tav { background-color: #05070a; }
.ffd-page--library .lbf::after { content: ''; position: absolute; inset: 0; z-index: 5; pointer-events: none; box-shadow: inset 0 0 0 rgba(0, 0, 0, 0); transition: box-shadow .5s ease; }
.ffd-page--library .lbf.is-low::after { box-shadow: inset 0 0 80px rgba(239, 68, 68, .42); }
.ffd-page--library .lbf.is-myth::after { box-shadow: inset 0 0 90px rgba(200, 120, 255, .55), inset 0 0 40px rgba(120, 240, 230, .5); }
.ffd-page--library .lbf.is-down::after { box-shadow: inset 0 0 180px rgba(120, 0, 0, .9); }
.ffd-page--library .lbf-cam { position: absolute; inset: 0; display: block; }
.ffd-page--library .lbf.is-shake .lbf-cam { animation: lbf-shake .32s ease-out; }
.ffd-page--library .lbf.is-quake .lbf-cam { animation: lbf-quake .6s ease-out; }
.ffd-page--library .lbf-world { position: absolute; inset: 0; display: block; transform-origin: 50% 62%; transition: transform .42s cubic-bezier(.3, .7, .3, 1), filter .6s ease; }
.ffd-page--library .lbf.is-floor .lbf-world { transform: rotate(-3.2deg) translateY(3.5%) scale(1.13); }
.ffd-page--library .lbf.is-down .lbf-world { filter: brightness(.6) saturate(.7); }
.ffd-page--library .lbf-dim { position: absolute; inset: 0; display: block; background: radial-gradient(ellipse at 50% 46%, rgba(4, 6, 10, .3) 0, rgba(4, 6, 10, .78) 72%); opacity: 0; transition: opacity .45s ease-out; }
.ffd-page--library .lbf.is-in.is-intro .lbf-dim { opacity: 1; }
.ffd-page--library .lbf.is-tav .lbf-dim { opacity: 0; transition: none; }
.ffd-page--library .lbf-mist { position: absolute; display: block; border-radius: 50%; background: radial-gradient(closest-side, rgba(3, 4, 8, .99) 0, rgba(3, 4, 8, .97) 55%, rgba(3, 4, 8, 0) 100%); opacity: 0; transition: opacity .4s ease-out; pointer-events: none; }
.ffd-page--library .lbf-mist.is-on { opacity: 1; }
.ffd-page--library .lbf-bg { position: absolute; inset: 0; display: block; background: radial-gradient(ellipse at 50% 30%, #1c2735 0%, #0c121b 58%, #05070a 100%); opacity: 0; }
.ffd-page--library .lbf.is-tav .lbf-bg { opacity: 1; }
.ffd-page--library .lbf-rv { position: absolute; display: block; pointer-events: none; }
.ffd-page--library .lbf-wave { position: absolute; display: block; border-radius: 50%; pointer-events: none; border: 2px solid rgba(200, 232, 255, .75); box-shadow: 0 0 30px rgba(160, 210, 255, .65), inset 0 0 30px rgba(160, 210, 255, .45); }
.ffd-page--library .lbf-shade { position: absolute; inset: 0; display: block; pointer-events: none; background: radial-gradient(ellipse 120% 85% at 50% 48%, rgba(5, 7, 10, 0) 40%, rgba(5, 7, 10, .55) 100%), linear-gradient(to bottom, rgba(5, 7, 10, .7) 0, rgba(5, 7, 10, 0) 16%); }
.ffd-page--library .lbf-frost { position: absolute; inset: 0; display: block; pointer-events: none; opacity: 0; background: radial-gradient(ellipse 95% 80% at 50% 50%, rgba(200, 232, 255, 0) 52%, rgba(200, 232, 255, .2) 78%, rgba(235, 247, 255, .5) 100%); transition: opacity 1.6s ease-out; }
.ffd-page--library .lbf.is-won .lbf-frost { opacity: 1; }
.ffd-page--library .lbf-in { position: absolute; inset: 0; z-index: 3; display: flex; flex-direction: column; align-items: center; overflow-x: hidden; overflow-y: auto; overscroll-behavior: contain; scrollbar-width: none; padding: max(12px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right)) max(28px, calc(env(safe-area-inset-bottom) + 20px)) max(16px, env(safe-area-inset-left)); }
.ffd-page--library .lbf-top { flex: 0 0 auto; width: min(100%, 720px); display: grid; grid-template-columns: auto minmax(0, 1fr); column-gap: 14px; align-items: start; }
.ffd-page--library .lbf-leave { min-height: 44px; min-width: 44px; margin: 0; padding: 6px 16px; border-radius: 999px; border: 1px solid rgba(255, 255, 255, .22); background: rgba(0, 0, 0, .5); color: #c9bea8; font: 600 14px/1.2 var(--f-body, 'Spectral', Georgia, serif); cursor: pointer; -webkit-appearance: none; appearance: none; transition: color .18s ease, border-color .18s ease, opacity .2s ease-out; }
.ffd-page--library .lbf-leave:hover { color: #f3e6c8; border-color: rgba(255, 255, 255, .4); }
.ffd-page--library .lbf.is-won .lbf-leave, .ffd-page--library .lbf.is-down .lbf-leave { opacity: 0; visibility: hidden; pointer-events: none; transition: opacity .2s ease-out, visibility 0s linear .2s; }
.ffd-page--library .lbf-hp { display: grid; grid-template-columns: minmax(0, 1fr) auto; align-items: baseline; row-gap: 6px; column-gap: 10px; width: 100%; color: #fff3d6; }
.ffd-page--library .lbf-her { padding-top: 2px; grid-template-areas: 'n v' 'b b' 'i i'; transition: opacity .3s ease-out, transform .3s ease-out; }
.ffd-page--library .lbf-n { grid-area: n; font: 600 13px/1.2 var(--f-display, 'Cinzel', Georgia, serif); letter-spacing: .14em; text-transform: uppercase; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-shadow: 0 1px 6px #000; }
.ffd-page--library .lbf-hp em { grid-area: v; font: 700 16px/1.2 var(--f-body, 'Spectral', Georgia, serif); font-style: normal; font-variant-numeric: tabular-nums; text-shadow: 0 1px 6px #000; white-space: nowrap; }
.ffd-page--library .lbf-dl { color: #ff9a8f; }
.ffd-page--library .lbf-dl.is-heal { color: #9fe2b8; }
.ffd-page--library .lbf-tr { grid-area: b; position: relative; display: block; height: 14px; border-radius: 7px; background: rgba(255, 255, 255, .12); box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .5), 0 2px 10px rgba(0, 0, 0, .45); overflow: hidden; }
.ffd-page--library .lbf-tr > span { position: absolute; left: 0; top: 0; bottom: 0; display: block; width: 100%; border-radius: 7px; }
.ffd-page--library .lbf-tr::after { content: ''; position: absolute; left: 0; right: 0; top: 0; height: 45%; border-radius: 7px 7px 0 0; background: rgba(255, 255, 255, .18); pointer-events: none; }
.ffd-page--library .lbf-g { background: rgba(255, 236, 200, .6); transition: width .55s ease .38s; }
.ffd-page--library .lbf-f { transition: width .26s ease-out; }
.ffd-page--library .lbf-her .lbf-f { background: linear-gradient(90deg, #c2282f, #ef4444 45%, #f5a45e); }
.ffd-page--library .lbf-you .lbf-f { background: linear-gradient(90deg, #4fb47e, #7fd0a0 45%, #e8c674); }
.ffd-page--library .lbf.is-low .lbf-you .lbf-f { background: linear-gradient(90deg, #c2282f, #ef4444 50%, #f59e5e); }
.ffd-page--library .lbf.is-low .lbf-you .lbf-tr { animation: lbf-lowbeat 1.1s ease-in-out infinite; }
.ffd-page--library .lbf-int { grid-area: i; justify-self: start; display: inline-flex; align-items: center; gap: 8px; min-height: 28px; padding: 3px 12px 3px 10px; border-radius: 999px; background: rgba(0, 0, 0, .55); border: 1px solid rgba(201, 212, 226, .25); font: italic 600 15px/1.15 var(--f-aside, 'Cormorant Garamond', Georgia, serif); color: #d6dfea; transition: opacity .2s ease-out; }
.ffd-page--library .lbf-int:empty, .ffd-page--library .lbf-int.is-none { opacity: 0; }
.ffd-page--library .lbf-int i { display: block; width: 8px; height: 8px; border-radius: 50%; background: #f5a45e; box-shadow: 0 0 8px #f5a45e; }
.ffd-page--library .lbf-int.is-spell { color: #d8ebff; border-color: rgba(150, 200, 255, .6); box-shadow: 0 0 16px rgba(120, 170, 255, .45); }
.ffd-page--library .lbf-int.is-spell i { background: #bfe2ff; box-shadow: 0 0 10px #8fc6ff; animation: lbf-pulse 1s ease-in-out infinite; }
.ffd-page--library .lbf-int.is-wild { color: #f1dcff; border-color: rgba(220, 170, 255, .5); }
.ffd-page--library .lbf-int.is-wild i { background: #e3b8ff; box-shadow: 0 0 8px #c890ff; }
.ffd-page--library .lbf-int.is-pop { animation: lbf-chip .36s ease-out; }
.ffd-page--library .lbf-main { flex: 1 1 auto; min-height: 0; width: 100%; display: flex; flex-direction: column; align-items: center; }
.ffd-page--library .lbf-main::before { content: ''; flex: 1 1 0; min-height: 4px; max-height: 40px; }
.ffd-page--library .lbf-main::after { content: ''; flex: 2 1 0; min-height: 0; }
.ffd-page--library .lbf-stage { position: relative; flex: 0 1 47svh; min-height: 150px; max-height: 540px; width: 100%; display: flex; justify-content: center; align-items: flex-end; container-type: size; transform-origin: 50% 85%; transition: transform .42s cubic-bezier(.3, .7, .3, 1); }
.ffd-page--library .lbf.is-floor .lbf-stage { transform: rotate(-3.2deg) translateY(5%); }
.ffd-page--library .lbf-pos { position: relative; flex: 0 0 auto; display: block; height: 100%; height: min(100cqh, 110cqw); aspect-ratio: 4 / 3; transform-origin: 50% 88%; transition: transform .24s ease-out, opacity 1.2s ease .2s; }
.ffd-page--library .lbf-pos.is-lunge { transform: translateY(2.5%) scale(1.07); }
.ffd-page--library .lbf-pos.is-near { transform: translateY(3%) scale(1.12); transition-duration: .6s; }
/* the win: only her figure goes; her counter stays as a copy of the art's own pixels (.lbf-cnt) */
.ffd-page--library .lbf-pos.is-gone .lbf-m { opacity: 0; transition: opacity .6s ease-out .05s; }
.ffd-page--library .lbf-pos.is-gone .lbf-candle { animation: none; opacity: 0; }
/* her in the dark (darkOf): laid over her art until the light finds her; her candle isn't lit until then */
.ffd-page--library .lbf-dark { position: absolute; left: 0; top: 0; z-index: 1; display: block; width: 100%; height: 100%; pointer-events: none; image-rendering: crisp-edges; image-rendering: pixelated; }
.ffd-page--library .lbf.is-dark .lbf-candle { animation: none; opacity: 0; }
.ffd-page--library .lbf.is-dark .lbf-stage { overflow: visible; -webkit-mask-image: none; mask-image: none; }
.ffd-page--library .lbf-cnt { position: absolute; left: 0; top: 0; z-index: 0; display: block; width: 100%; height: 100%; pointer-events: none; image-rendering: crisp-edges; image-rendering: pixelated; }
.ffd-page--library .lbf-m { position: absolute; inset: 0; display: block; filter: drop-shadow(0 0 30px rgba(0, 0, 0, .6)); transform-origin: 50% 100%; animation: lbf-breathe 4.6s ease-in-out infinite; }
.ffd-page--library .lbf.is-down .lbf-m { filter: drop-shadow(0 0 30px rgba(0, 0, 0, .6)) brightness(.85); }
.ffd-page--library .lbf-candle { position: absolute; left: 80%; top: 67%; z-index: 1; display: block; width: 18%; aspect-ratio: 1; border-radius: 50%; transform: translate(-50%, -50%); background: radial-gradient(closest-side, rgba(214, 232, 255, .34), rgba(150, 190, 255, .12) 55%, rgba(150, 190, 255, 0)); mix-blend-mode: screen; pointer-events: none; animation: lbf-flick 2.3s linear infinite; }
/* her cast: the rune ring's canvas on her art's own pixel grid (85 x 84 of its 192 x 144 pixels, from x 54 and y 40) */
.ffd-page--library .lbf-cast { position: absolute; left: 28.125%; top: 27.778%; z-index: 2; display: block; width: 44.271%; height: 58.333%; transform: scale(.4); opacity: 0; pointer-events: none; transition: opacity .5s ease-out, transform .9s cubic-bezier(.2, .8, .3, 1); }
.ffd-page--library .lbf-cast.is-on { opacity: 1; transform: none; }
.ffd-page--library .lbf-cast.is-surge { transform: scale(1.35); transition-duration: .5s; }
.ffd-page--library .lbf-glow { position: absolute; inset: 8%; display: block; border-radius: 50%; background: radial-gradient(closest-side, rgba(255, 255, 255, .9), rgba(170, 214, 255, .55) 30%, rgba(90, 150, 255, .2) 62%, rgba(90, 150, 255, 0)); animation: lbf-pulse 1.4s ease-in-out infinite; mix-blend-mode: screen; }
.ffd-page--library .lbf-cast canvas { position: absolute; left: 0; top: 0; display: block; width: 100%; height: 100%; image-rendering: crisp-edges; image-rendering: pixelated; filter: drop-shadow(0 0 4px rgba(150, 205, 255, .7)); }
/* her spell: its canvas on her art's own pixel grid (65 x 66 of its 192 x 144 pixels, from x 64 and y 43; orbPainter) */
.ffd-page--library .lbf-orb { position: absolute; left: 33.3333%; top: 29.8611%; z-index: 3; display: block; width: 33.8542%; height: 45.8333%; pointer-events: none; image-rendering: crisp-edges; image-rendering: pixelated; }
/* your Shield: a shallow gold dome rising from below her counter, on your side of it (its top sits just above the
   counter in every layout: the sizes follow her art box, which is min(100cqh, 110cqw) tall in the stage) */
.ffd-page--library .lbf-ward { position: absolute; left: 50%; bottom: -30%; z-index: 3; display: block; width: 160%; aspect-ratio: 5 / 2; overflow: hidden; pointer-events: none; opacity: 0; transform: translateX(-50%) scaleY(.3); transform-origin: 50% 100%; border-radius: 50% 50% 0 0 / 100% 100% 0 0; border-top: 3px solid #ffe4a8; background: radial-gradient(ellipse 60% 90% at 50% 100%, rgba(255, 228, 168, .2), rgba(255, 228, 168, .05) 62%, rgba(255, 228, 168, 0) 80%), repeating-linear-gradient(60deg, rgba(255, 236, 190, .08) 0 1px, rgba(255, 236, 190, 0) 1px 16px), repeating-linear-gradient(-60deg, rgba(255, 236, 190, .08) 0 1px, rgba(255, 236, 190, 0) 1px 16px); box-shadow: 0 -10px 40px rgba(255, 214, 140, .35), inset 0 12px 28px rgba(255, 228, 168, .25); transition: opacity .3s ease-out, transform .32s cubic-bezier(.2, .9, .3, 1.15), border-color .12s ease, box-shadow .12s ease; }
@supports (height: 1cqh) {
  .ffd-page--library .lbf-ward { --ah: min(100cqh, 110cqw); width: max(110%, calc(var(--ah) * 2.2)); height: calc(var(--ah) * .62); aspect-ratio: auto; bottom: calc(var(--ah) * -.36); }
}
.ffd-page--library .lbf-ward i { position: absolute; left: 0; top: 0; bottom: 0; display: block; width: 30%; background: linear-gradient(100deg, rgba(255, 244, 214, 0), rgba(255, 244, 214, .45) 50%, rgba(255, 244, 214, 0)); transform: translateX(-120%); }
.ffd-page--library .lbf-ward.is-on { opacity: 1; transform: translateX(-50%); }
.ffd-page--library .lbf-ward.is-on i { animation: lbf-sweep .8s ease-out .12s both; }
.ffd-page--library .lbf-ward.is-flare { border-top-color: #fff6dc; box-shadow: 0 -12px 60px rgba(255, 228, 168, .75), inset 0 14px 34px rgba(255, 236, 190, .5); transform: translateX(-50%) scale(1.03); transition-duration: .12s; }
.ffd-page--library .lbf-ward.is-break { opacity: 0; transform: translateX(-50%) translateY(-3%) scale(1.06); transition: opacity .38s ease-out, transform .38s ease-out; }
/* the ice where she stood: pixel art at the art's own scale (72 x 46 art pixels), seated on her counter (art y 72 to 118).
   It rises row by row; the negative insets leave room for its glow */
.ffd-page--library .lbf-ice { position: absolute; left: 31.25%; top: 50%; z-index: 2; display: block; width: 37.5%; height: 31.944%; pointer-events: none; opacity: 0; -webkit-clip-path: inset(100% -40px -40px -40px); clip-path: inset(100% -40px -40px -40px); filter: drop-shadow(0 0 10px rgba(170, 215, 255, .55)); transition: -webkit-clip-path .9s steps(12, end) .45s, clip-path .9s steps(12, end) .45s, opacity .15s ease-out .45s; }
.ffd-page--library .lbf.is-won .lbf-ice { opacity: 1; -webkit-clip-path: inset(-40px -40px -40px -40px); clip-path: inset(-40px -40px -40px -40px); }
.ffd-page--library .lbf-ice canvas { display: block; width: 100%; height: 100%; image-rendering: crisp-edges; image-rendering: pixelated; }
.ffd-page--library .lbf-ice i { position: absolute; left: var(--gx, 50%); top: var(--gy, 4%); display: block; width: 26%; aspect-ratio: 1; transform: translate(-50%, -50%); background: radial-gradient(closest-side, #fff, rgba(255, 255, 255, .6) 20%, rgba(200, 230, 255, 0)), linear-gradient(90deg, rgba(255,255,255,0) 46%, #fff 50%, rgba(255,255,255,0) 54%), linear-gradient(0deg, rgba(255,255,255,0) 46%, #fff 50%, rgba(255,255,255,0) 54%); opacity: 0; animation: lbf-glint 2.2s ease-in-out 1.3s infinite; }
.ffd-page--library .lbf-dice { position: absolute; left: 50%; bottom: 30px; z-index: 4; display: block; width: min(94vw, 440px); height: clamp(58px, 11svh, 104px); transform: translateX(-50%); pointer-events: none; }
.ffd-page--library .lbf-dice { transition: opacity .2s ease-out; }
.ffd-page--library .lbf-dice.is-idle { opacity: 0; }
.ffd-page--library .lbf-dice.is-text { display: grid; place-items: center; font: 700 34px/1 var(--f-display, 'Cinzel', Georgia, serif); color: #fff3d6; }
.ffd-page--library .lbf-sum { position: absolute; left: 50%; bottom: 0; z-index: 4; margin: 0; width: max-content; max-width: calc(100vw - 32px); padding: 4px 14px; border-radius: 999px; transform: translateX(-50%); background: rgba(5, 7, 10, .78); border: 1px solid rgba(255, 255, 255, .16); font: 600 14px/1.3 var(--f-body, 'Spectral', Georgia, serif); color: #d7dee8; font-variant-numeric: tabular-nums; text-align: center; text-wrap: balance; transition: opacity .18s ease-out; }
.ffd-page--library .lbf-sum:empty { opacity: 0; }
.ffd-page--library .lbf-sum.is-ok { border-color: rgba(127, 208, 160, .6); color: #dcf6e6; }
.ffd-page--library .lbf-sum.is-no { border-color: rgba(239, 120, 110, .6); color: #ffe0dc; }
.ffd-page--library .lbf-sum.is-pop { animation: lbf-sumpop .32s ease-out; }
.ffd-page--library .lbf-panel { position: relative; z-index: 4; flex: 0 0 auto; width: min(100%, 680px); display: flex; flex-direction: column; align-items: center; gap: 12px; margin-top: 12px; }
.ffd-page--library .lbf-panel::before { content: ''; position: absolute; left: -14%; right: -14%; top: -26%; bottom: -34%; z-index: -1; pointer-events: none; background: radial-gradient(closest-side, rgba(5, 7, 10, .8), rgba(5, 7, 10, .56) 62%, rgba(5, 7, 10, 0)); }
.ffd-page--library .lbf-line { margin: 0; width: min(100%, 34em); min-height: 2.6em; text-align: center; font: italic 600 clamp(19px, calc(1.1vw + 15px), 26px)/1.3 var(--f-aside, 'Cormorant Garamond', Georgia, serif); color: #fff3d6; text-shadow: 0 2px 12px #000, 0 0 2px #000; text-wrap: balance; overflow-wrap: break-word; }
.ffd-page--library .lbf-line.is-in { animation: lbf-up .3s ease-out both; }
.ffd-page--library .lbf-sr { position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; overflow: hidden; clip: rect(0 0 0 0); clip-path: inset(50%); white-space: nowrap; border: 0; }
.ffd-page--library .lbf-you { grid-template-columns: auto minmax(0, 1fr) auto; grid-template-areas: 'g n v' 'g b b'; row-gap: 6px; align-items: center; }
.ffd-page--library .lbf-you .lbf-tr { height: 16px; border-radius: 8px; }
/* your guard: the number her d20 + 2 must reach, on a small shield with its name under it */
.ffd-page--library .lbf-guard { grid-area: g; position: relative; display: flex; flex-direction: column; align-items: center; gap: 3px; min-width: 42px; }
.ffd-page--library .lbf-gs { position: relative; display: grid; place-items: center; width: 38px; height: 42px; }
.ffd-page--library .lbf-guard svg { position: absolute; inset: 0; width: 100%; height: 100%; fill: rgba(16, 20, 28, .9); stroke: #c9b07a; stroke-width: 2; transition: stroke .2s ease, filter .2s ease; }
.ffd-page--library .lbf-guard b { position: relative; margin-top: -2px; font: 700 16px/1 var(--f-display, 'Cinzel', Georgia, serif); color: #f4e2b8; font-variant-numeric: tabular-nums; }
.ffd-page--library .lbf-guard small { display: block; font: 600 10.5px/1 var(--f-display, 'Cinzel', Georgia, serif); letter-spacing: .1em; text-transform: uppercase; color: #d9c38c; text-shadow: 0 1px 4px #000; white-space: nowrap; transition: color .2s ease; }
.ffd-page--library .lbf-guard.is-up svg { stroke: #ffe4a8; filter: drop-shadow(0 0 7px rgba(255, 214, 140, .95)); }
.ffd-page--library .lbf-guard.is-up b, .ffd-page--library .lbf-guard.is-up small { color: #fff4d6; }
.ffd-page--library .lbf-guard.is-up .lbf-gs::after { content: ''; position: absolute; inset: -6px; border-radius: 50%; background: conic-gradient(from 0deg, rgba(255, 228, 168, 0), rgba(255, 228, 168, .55), rgba(255, 228, 168, 0) 35%); animation: lbf-spin 1.4s linear infinite; z-index: -1; }
.ffd-page--library .lbf-bonus { display: flex; flex-wrap: wrap; justify-content: center; gap: 6px; width: 100%; }
.ffd-page--library .lbf-bonus:empty, .ffd-page--library .lbf-bonus.is-off { display: none; }
.ffd-page--library .lbf-act:focus { outline: none; }
.ffd-page--library .lbf-bonus span { font: 600 12px/1.2 var(--f-body, 'Spectral', Georgia, serif); letter-spacing: .03em; padding: 5px 11px; border-radius: 999px; border: 1px solid rgba(231, 201, 127, .42); color: #f4d68a; background: rgba(0, 0, 0, .55); }
.ffd-page--library .lbf-bonus span.is-new { animation: lbf-chip .4s ease-out; }
.ffd-page--library .lbf-act { display: flex; flex-wrap: nowrap; justify-content: center; gap: 10px; width: 100%; min-height: 68px; }
.ffd-page--library .lbf-b { position: relative; flex: 1 1 0; min-width: 0; max-width: 220px; min-height: 66px; margin: 0; display: grid; justify-items: center; align-content: center; gap: 3px; padding: 8px 10px; border-radius: 16px; border: 1px solid rgba(231, 201, 127, .55); background: linear-gradient(180deg, rgba(40, 30, 18, .92), rgba(16, 11, 6, .92)); box-shadow: 0 6px 18px rgba(0, 0, 0, .45), inset 0 1px 0 rgba(255, 236, 190, .12); color: #f3e6c8; cursor: pointer; -webkit-appearance: none; appearance: none; animation: lbf-bin .26s ease-out both; transition: background .18s ease, border-color .18s ease, transform .12s ease, box-shadow .18s ease, opacity .18s ease; }
.ffd-page--library .lbf-bl { display: inline-flex; align-items: center; gap: 7px; font: 700 18px/1.15 var(--f-body, 'Spectral', Georgia, serif); }
.ffd-page--library .lbf-bl svg { flex: 0 0 auto; width: 19px; height: 19px; fill: none; stroke: currentColor; stroke-width: 1.9; stroke-linecap: round; stroke-linejoin: round; opacity: .9; }
.ffd-page--library .lbf-b small { font: 500 12.5px/1.25 var(--f-body, 'Spectral', Georgia, serif); color: #c9bea8; text-wrap: balance; }
.ffd-page--library .lbf-b:hover { border-color: #e7c97f; box-shadow: 0 8px 22px rgba(0, 0, 0, .5), 0 0 0 1px rgba(231, 201, 127, .35); }
.ffd-page--library .lbf-b:active { transform: scale(.97); }
.ffd-page--library .lbf-b.is-main { background: linear-gradient(180deg, rgba(118, 90, 40, .95), rgba(52, 36, 14, .95)); border-color: #e7c97f; color: #fff6dc; box-shadow: 0 6px 22px rgba(0, 0, 0, .45), 0 0 18px rgba(231, 201, 127, .28), inset 0 1px 0 rgba(255, 236, 190, .3); }
.ffd-page--library .lbf-b.is-main small { color: #ecdcb4; }
.ffd-page--library .lbf-b.is-solo { flex: 0 1 320px; max-width: 320px; }
/* two or three cards side by side with a small line under each title: each title sits on the same line, whatever wraps
   under it (btn() marks such a row has-sub, and a row of plain labels, such as the loss screen's, keeps them centred) */
.ffd-page--library .lbf-act.has-sub > .lbf-b:not(.is-solo) { align-content: start; padding-top: 11px; }
.ffd-page--library .lbf-b.is-hand { flex-grow: 1.45; border-color: rgba(179, 245, 238, .8); background: linear-gradient(135deg, rgba(150, 70, 190, .7), rgba(40, 110, 120, .55)), rgba(20, 10, 30, .9); color: #fbeaff; box-shadow: 0 0 22px rgba(239, 148, 255, .45), inset 0 1px 0 rgba(255, 255, 255, .2); }
.ffd-page--library .lbf-b.is-hand small { color: #d9f7f3; }
/* the hand's first offer: its card rises a beat after the others with a glow round it, and a light sweeps across it */
.ffd-page--library .lbf-b.is-arrive { animation: lbf-handin .85s cubic-bezier(.2, .85, .3, 1) .3s both; }
.ffd-page--library .lbf-b.is-arrive::before { content: ''; position: absolute; inset: 0; border-radius: inherit; pointer-events: none; box-shadow: 0 0 34px 8px rgba(239, 148, 255, .75), 0 0 12px 2px rgba(179, 245, 238, .7); opacity: 0; animation: lbf-handglow 1.6s ease-out .3s both; }
.ffd-page--library .lbf-sweep { position: absolute; inset: 0; display: block; border-radius: inherit; overflow: hidden; pointer-events: none; }
.ffd-page--library .lbf-sweep::after { content: ''; position: absolute; left: 0; top: -20%; bottom: -20%; width: 42%; background: linear-gradient(100deg, rgba(255, 246, 255, 0), rgba(255, 246, 255, .6) 50%, rgba(255, 246, 255, 0)); transform: translateX(-140%) skewX(-14deg); animation: lbf-handsweep .8s ease-in-out .85s both; }
.ffd-page--library .lbf-b.is-picked { animation: lbf-pick .28s ease-out both; }
.ffd-page--library .lbf-b.is-out { opacity: 0; transform: scale(.96); pointer-events: none; }
.ffd-page--library .lbf-b:focus-visible, .ffd-page--library .lbf-leave:focus-visible { outline: 2px solid #e7c97f; outline-offset: 3px; }
.ffd-page--library .lbf.is-intro .lbf-her, .ffd-page--library .lbf.is-intro .lbf-you, .ffd-page--library .lbf.is-intro .lbf-bonus { opacity: 0; transform: translateY(10px); }
.ffd-page--library .lbf.is-intro .lbf-her { transform: translateY(-10px); }
.ffd-page--library .lbf-you { transition: opacity .3s ease-out .08s, transform .3s ease-out .08s; }
.ffd-page--library .lbf-bonus { transition: opacity .3s ease-out .16s, transform .3s ease-out .16s; }
.ffd-page--library .lbf-fxl { position: absolute; inset: 0; z-index: 4; display: block; pointer-events: none; overflow: hidden; }
.ffd-page--library .lbf-fxl > span { position: absolute; display: block; pointer-events: none; }
.ffd-page--library .lbf-fxl svg { display: block; width: 100%; height: 100%; overflow: visible; }
.ffd-page--library .lbf-edge { position: absolute; inset: 0; z-index: 6; display: block; pointer-events: none; opacity: 0; box-shadow: inset 0 0 0 3px rgba(255, 96, 86, .6), inset 0 0 150px 46px rgba(220, 30, 30, .62); }
.ffd-page--library .lbf-edge.is-on { animation: lbf-edge .62s ease-out both; }
.ffd-page--library .lbf-fx { position: absolute; inset: 0; z-index: 7; display: block; pointer-events: none; opacity: 0; }
.ffd-page--library .lbf-fx.is-on { animation: lbf-fx 600ms ease-out both; }
.ffd-page--library .lbf-num { z-index: 8; left: 0; top: 0; font: 700 clamp(54px, 15vw, 96px)/1 var(--f-display, 'Cinzel', Georgia, serif); color: #fff; white-space: nowrap; text-shadow: 0 0 22px #ef4444, 0 5px 0 #8c1a22, 0 0 2px #000; animation: lbf-num 1.3s cubic-bezier(.2, .9, .3, 1) both; }
.ffd-page--library .lbf-num.is-big { color: #f2d8ff; text-shadow: 0 0 24px #c878ff, 0 5px 0 #3a1460, 0 0 2px #000; font-size: clamp(64px, 18vw, 116px); }
.ffd-page--library .lbf-num.is-you { color: #ffe1dd; text-shadow: 0 0 26px #ff2a2a, 0 5px 0 #5a0f14, 0 0 2px #000; }
.ffd-page--library .lbf-num.is-spell { color: #e6f3ff; text-shadow: 0 0 26px #6fb2ff, 0 5px 0 #17305e, 0 0 2px #000; }
.ffd-page--library .lbf-num.is-heal { color: #e2ffef; text-shadow: 0 0 22px #3fb87a, 0 5px 0 #0f3a22, 0 0 2px #000; font-size: clamp(44px, 12vw, 76px); }
.ffd-page--library .lbf-slash { filter: drop-shadow(0 0 10px rgba(200, 230, 255, .95)); transform-origin: 50% 50%; }
.ffd-page--library .lbf-arc { filter: drop-shadow(0 0 14px rgba(255, 80, 70, .85)); transform-origin: 50% 50%; }
.ffd-page--library .lbf-tapr { width: 64px; height: 64px; margin: -32px 0 0 -32px; border-radius: 50%; border: 2px solid rgba(255, 236, 190, .85); box-shadow: 0 0 16px rgba(255, 214, 140, .5), inset 0 0 12px rgba(255, 214, 140, .35); animation: lbf-tapr .38s ease-out both; }
/* her spell's flight and burst: one canvas over the screen whose cells are her art's pixels (fight.js places it) */
.ffd-page--library .lbf-fxl > canvas.lbf-pix { position: absolute; display: block; pointer-events: none; image-rendering: crisp-edges; image-rendering: pixelated; }
.ffd-page--library .lbf-burst { border-radius: 50%; background: radial-gradient(circle, rgba(255, 255, 255, .95) 0, var(--c, rgba(255, 120, 110, .8)) 28%, rgba(0, 0, 0, 0) 68%); animation: lbf-burst .55s ease-out both; }
.ffd-page--library .lbf-ringw { border-radius: 50%; border: 3px solid var(--c, #bfe2ff); box-shadow: 0 0 26px var(--c, #bfe2ff), inset 0 0 26px var(--c, #bfe2ff); animation: lbf-ringw .75s cubic-bezier(.2, .7, .3, 1) both; }
.ffd-page--library .lbf-crack { animation: lbf-crack 1s ease-out both; }
.ffd-page--library .lbf-crack path { fill: none; stroke-linecap: round; stroke-linejoin: round; }
.ffd-page--library .lbf-spark { width: 0; height: 0; }
.ffd-page--library .lbf-spark i { position: absolute; left: -2px; top: 0; display: block; width: 5px; height: 46px; border-radius: 3px; background: linear-gradient(#fff, #ffd98a 50%, rgba(255, 200, 120, 0)); transform-origin: 50% 0; transform: rotate(var(--a)) translateY(12px); animation: lbf-spark .5s ease-out both; }
.ffd-page--library .lbf-dust { width: var(--s, 18px); height: var(--s, 18px); border-radius: 50%; background: radial-gradient(closest-side, rgba(226, 208, 176, .78), rgba(200, 180, 150, .35) 55%, rgba(200, 180, 150, 0)); animation: lbf-dust .95s ease-out both; }
.ffd-page--library .lbf-shards { width: 0; height: 0; }
.ffd-page--library .lbf-shards i { position: absolute; display: block; width: 7px; height: 11px; background: linear-gradient(#f2fbff, #9fd8f0); clip-path: polygon(50% 0, 100% 60%, 40% 100%, 0 40%); animation: lbf-shard 1.5s cubic-bezier(.1, .7, .3, 1) both; }
.ffd-page--library .lbf-mote { width: 4px; height: 4px; border-radius: 50%; background: #e8f6ff; box-shadow: 0 0 8px #bfe2ff; animation: lbf-mote var(--d, 5s) linear var(--w, 0s) infinite; }
@keyframes lbf-up { from { opacity: 0; transform: translateY(6px); } }
@keyframes lbf-fx { 0% { opacity: 1; } 100% { opacity: 0; } }
@keyframes lbf-edge { 0% { opacity: 0; } 10% { opacity: 1; } 100% { opacity: 0; } }
@keyframes lbf-shake { 0% { transform: scale(1.03); } 18% { transform: translate(-9px, 3px) scale(1.03); } 36% { transform: translate(8px, -3px) scale(1.03); } 56% { transform: translate(-5px, 2px) scale(1.03); } 78% { transform: translate(3px, 0) scale(1.02); } 100% { transform: none; } }
@keyframes lbf-quake { 0% { transform: scale(1.05); } 10% { transform: translate(-16px, 6px) scale(1.05); } 22% { transform: translate(14px, -7px) scale(1.05); } 36% { transform: translate(-11px, 5px) scale(1.04); } 52% { transform: translate(8px, -3px) scale(1.03); } 70% { transform: translate(-4px, 2px) scale(1.02); } 100% { transform: none; } }
@keyframes lbf-breathe { 0%, 100% { transform: none; } 50% { transform: translateY(-.3%) scale(1.004, 1.012); } }
@keyframes lbf-flick { 0% { opacity: .78; } 9% { opacity: .96; } 17% { opacity: .62; } 31% { opacity: .9; } 44% { opacity: .7; } 58% { opacity: 1; } 71% { opacity: .66; } 86% { opacity: .88; } 100% { opacity: .78; } }
@keyframes lbf-spin { to { transform: rotate(360deg); } }
@keyframes lbf-pulse { 0%, 100% { opacity: .82; transform: scale(1); } 50% { opacity: 1; transform: scale(1.08); } }
@keyframes lbf-chip { 0% { transform: scale(.7); opacity: 0; } 60% { transform: scale(1.08); opacity: 1; } 100% { transform: none; } }
@keyframes lbf-sumpop { 0% { transform: translateX(-50%) scale(.7); opacity: 0; } 60% { transform: translateX(-50%) scale(1.06); opacity: 1; } 100% { transform: translateX(-50%); } }
@keyframes lbf-glint { 0%, 55%, 100% { opacity: 0; transform: translate(-50%, -50%) scale(.4) rotate(0deg); } 70% { opacity: 1; transform: translate(-50%, -50%) scale(1) rotate(45deg); } 85% { opacity: 0; transform: translate(-50%, -50%) scale(.6) rotate(90deg); } }
@keyframes lbf-lowbeat { 0%, 100% { box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .5), 0 0 0 rgba(239, 68, 68, 0); } 50% { box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .5), 0 0 14px rgba(239, 68, 68, .7); } }
@keyframes lbf-bin { from { opacity: 0; transform: translateY(8px) scale(.98); } }
@keyframes lbf-pick { 0% { transform: none; } 45% { transform: scale(1.05); box-shadow: 0 0 26px rgba(255, 228, 168, .6); } 100% { transform: scale(1); opacity: 0; } }
@keyframes lbf-num { 0% { opacity: 0; transform: translate(-50%, -40%) scale(.4); } 12% { opacity: 1; transform: translate(-50%, -55%) scale(1.25); } 24% { transform: translate(-50%, -55%) scale(1); } 74% { opacity: 1; transform: translate(-50%, -78%) scale(1); } 100% { opacity: 0; transform: translate(-50%, -105%) scale(.96); } }
@keyframes lbf-burst { from { transform: scale(.2); opacity: 1; } to { transform: scale(1.6); opacity: 0; } }
@keyframes lbf-ringw { from { transform: scale(.08); opacity: 1; } to { transform: scale(1); opacity: 0; } }
@keyframes lbf-crack { 0% { opacity: 0; transform: scale(.55); } 8% { opacity: 1; transform: scale(1); } 62% { opacity: .9; } 100% { opacity: 0; transform: scale(1.02); } }
@keyframes lbf-spark { to { transform: rotate(var(--a)) translateY(120px) scaleY(.35); opacity: 0; } }
@keyframes lbf-dust { from { transform: translate(-50%, -50%) scale(.4); opacity: .9; } to { transform: translate(calc(-50% + var(--dx)), calc(-50% + var(--dy))) scale(2.4); opacity: 0; } }
@keyframes lbf-shard { to { transform: translate(var(--x), var(--y)) rotate(var(--r)); opacity: 0; } }
@keyframes lbf-mote { 0% { transform: translate(0, 0); opacity: 0; } 15% { opacity: .9; } 80% { opacity: .6; } 100% { transform: translate(var(--dx, 0px), var(--rise, -40svh)); opacity: 0; } }
@keyframes lbf-sweep { from { transform: translateX(-120%); } to { transform: translateX(440%); } }
@keyframes lbf-tapr { from { transform: scale(.3); opacity: 1; } to { transform: scale(1.25); opacity: 0; } }
@keyframes lbf-handin { 0% { opacity: 0; transform: translateY(30px) scale(.94); } 60% { opacity: 1; transform: translateY(-4px) scale(1.03); } }
@keyframes lbf-handglow { 0% { opacity: 0; } 30% { opacity: 1; } 100% { opacity: 0; } }
@keyframes lbf-handsweep { from { transform: translateX(-140%) skewX(-14deg); } to { transform: translateX(340%) skewX(-14deg); } }
/* a phone on its side: she stands on the left, the fight runs down the right */
@media (orientation: landscape) and (max-height: 540px) {
  .ffd-page--library .lbf-in { display: grid; grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr); grid-template-rows: auto minmax(0, 1fr); grid-template-areas: 'stage top' 'stage panel'; column-gap: 18px; row-gap: 6px; padding: max(10px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right)) max(12px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left)); }
  .ffd-page--library .lbf-top { grid-area: top; width: 100%; }
  .ffd-page--library .lbf-main { display: contents; }
  .ffd-page--library .lbf-main::before, .ffd-page--library .lbf-main::after { display: none; }
  .ffd-page--library .lbf-stage { grid-area: stage; height: 100%; max-height: none; min-height: 0; overflow: hidden; align-items: center; -webkit-mask-image: linear-gradient(90deg, #000 0, #000 80%, transparent 100%); mask-image: linear-gradient(90deg, #000 0, #000 80%, transparent 100%); }
  .ffd-page--library .lbf-pos { height: min(100cqh, 80cqw); }
  @supports (height: 1cqh) {
    /* her art box is centred in the stage here, so the dome's foot moves up with it */
    .ffd-page--library .lbf-ward { --ah: min(100cqh, 80cqw); bottom: calc((100cqh - var(--ah)) / 2 - var(--ah) * .36); }
  }
  .ffd-page--library .lbf-panel { grid-area: panel; align-self: center; width: 100%; margin: 0; gap: 8px; }
  .ffd-page--library .lbf-panel::before { left: -6%; right: -6%; top: -10%; bottom: -10%; }
  .ffd-page--library .lbf-line { font-size: 18.5px; min-height: 2.5em; }
  .ffd-page--library .lbf-b { min-height: 56px; padding: 6px 8px; }
  .ffd-page--library .lbf-act.has-sub > .lbf-b:not(.is-solo) { padding-top: 8px; }
  .ffd-page--library .lbf-bl { gap: 6px; font-size: 16.5px; }
  .ffd-page--library .lbf-bl svg { width: 17px; height: 17px; }
  .ffd-page--library .lbf-b small { font-size: 11.5px; }
  .ffd-page--library .lbf-act { min-height: 56px; }
  .ffd-page--library .lbf-dice { height: clamp(48px, 15svh, 74px); bottom: 26px; }
  .ffd-page--library .lbf-int { min-height: 24px; font-size: 14px; }
  /* her name whole beside her number, even on a small phone on its side */
  .ffd-page--library .lbf-n { font-size: 12px; letter-spacing: .09em; }
}
/* a short phone held upright (an SE with its toolbars): tighter gaps and lines so she keeps her size */
@media (orientation: portrait) and (max-height: 640px) {
  .ffd-page--library .lbf-panel { gap: 8px; margin-top: 8px; }
  .ffd-page--library .lbf-bonus span { font-size: 11px; padding: 3px 8px; }
  .ffd-page--library .lbf-line { min-height: 0; font-size: 18px; }
  .ffd-page--library .lbf-b { min-height: 58px; }
}
/* a narrow phone: tighter cards in the row, and they stack only when the screen is tall enough to hold them */
@media (max-width: 349px) {
  .ffd-page--library .lbf-n { font-size: 11.5px; letter-spacing: .08em; }
  .ffd-page--library .lbf-act { gap: 6px; }
  .ffd-page--library .lbf-b { padding: 6px 4px; }
  .ffd-page--library .lbf-bl { font-size: 16px; }
  .ffd-page--library .lbf-bl svg { display: none; }
  .ffd-page--library .lbf-b small { font-size: 11px; }
}
@media (max-width: 349px) and (min-height: 700px) {
  .ffd-page--library .lbf-act { flex-direction: column; align-items: stretch; }
  .ffd-page--library .lbf-b, .ffd-page--library .lbf-b.is-solo { max-width: none; flex: 0 0 auto; min-height: 52px; }
  .ffd-page--library .lbf-bl svg { display: block; }
}
/* a screen wider than her counter (a tablet, a desktop): the art box's sides and foot fade into the tavern, so she never
   arrives as a hard-edged rectangle (a phone on its side keeps its own stage fade above) */
@media (min-width: 700px) and (min-height: 541px) {
  .ffd-page--library .lbf-pos { -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 10%, #000 90%, transparent 100%), linear-gradient(to bottom, #000 85%, transparent 100%); -webkit-mask-composite: source-in; mask-image: linear-gradient(90deg, transparent 0, #000 10%, #000 90%, transparent 100%), linear-gradient(to bottom, #000 85%, transparent 100%); mask-composite: intersect; }
}
/* a wide screen: bigger words and bars, and a bigger Matron */
@media (min-width: 900px) and (min-height: 600px) {
  .ffd-page--library .lbf-n { font-size: 15px; }
  .ffd-page--library .lbf-hp em { font-size: 18px; }
  .ffd-page--library .lbf-her .lbf-tr { height: 16px; }
  .ffd-page--library .lbf-you .lbf-tr { height: 18px; }
  .ffd-page--library .lbf-int { font-size: 16.5px; }
  .ffd-page--library .lbf-stage { flex-basis: 56svh; max-height: 620px; }
  .ffd-page--library .lbf-b { min-height: 72px; }
  .ffd-page--library .lbf-bl { font-size: 19px; }
  .ffd-page--library .lbf-b small { font-size: 13.5px; }
  .ffd-page--library .lbf-sum { font-size: 15.5px; }
}
/* a desktop: the chips, the labels and the small words grow with the screen instead of staying phone-sized */
@media (min-width: 1024px) and (min-height: 541px) {
  .ffd-page--library .lbf-leave { padding: 8px 20px; font-size: 16px; }
  .ffd-page--library .lbf-n { font-size: 16.5px; }
  .ffd-page--library .lbf-hp em { font-size: 20px; }
  .ffd-page--library .lbf-int { min-height: 34px; padding: 4px 15px 4px 13px; gap: 10px; font-size: 19px; }
  .ffd-page--library .lbf-int i { width: 9px; height: 9px; }
  .ffd-page--library .lbf-sum { padding: 5px 18px; font-size: 17px; }
  .ffd-page--library .lbf-bonus { gap: 8px; }
  .ffd-page--library .lbf-bonus span { padding: 6px 14px; font-size: 14.5px; }
  .ffd-page--library .lbf-gs { width: 44px; height: 48px; }
  .ffd-page--library .lbf-guard b { font-size: 19px; }
  .ffd-page--library .lbf-guard small { font-size: 12.5px; }
  .ffd-page--library .lbf-b { max-width: 240px; min-height: 76px; gap: 4px; }
  .ffd-page--library .lbf-bl { gap: 8px; font-size: 21px; }
  .ffd-page--library .lbf-bl svg { width: 21px; height: 21px; }
  .ffd-page--library .lbf-b small { font-size: 15px; }
  .ffd-page--library .lbf-b.is-solo { flex-basis: 340px; max-width: 340px; }
}
@media (prefers-reduced-motion: reduce) {
  .ffd-page--library .lbf *, .ffd-page--library .lbf::after { animation: none !important; transition: none !important; }
  .ffd-page--library .lbf { transition: opacity .3s linear, background-color .45s linear !important; }
  .ffd-page--library .lbf .lbf-bg { transition: opacity .45s linear !important; }
}
.ffd-page--library .lbf.is-rm *, .ffd-page--library .lbf.is-rm::after { animation: none !important; transition: none !important; }
.ffd-page--library .lbf.is-rm { transition: opacity .3s linear, background-color .45s linear !important; }
.ffd-page--library .lbf.is-rm .lbf-bg { transition: opacity .45s linear !important; }
.ffd-page--library .lbf.is-rm.is-floor .lbf-world, .ffd-page--library .lbf.is-rm.is-floor .lbf-stage, .ffd-page--library .lbf.is-rm .lbf-pos.is-near { transform: none; }
@media (prefers-reduced-motion: reduce) { .ffd-page--library .lbf.is-floor .lbf-world, .ffd-page--library .lbf.is-floor .lbf-stage, .ffd-page--library .lbf .lbf-pos.is-near { transform: none; } }
`;

  (FFD.parts = FFD.parts || {})['library/fight'] = function (api) {
    api = api || {};
    const RM = () => { try { return api.RM ? !!api.RM() : !!(FFD.RM && FFD.RM()); } catch (e) { return false; } };
    const T = (ms) => (RM() ? 0 : ms);
    const snd = (n, op) => { try { if (typeof api.snd === 'function') api.snd(n, op); else if (window.FFSound && typeof FFSound[n] === 'function') FFSound[n](op || {}); } catch (e) { /* quiet */ } };
    const buzz = (p) => { try { if (typeof FFD.buzz === 'function') FFD.buzz(p); else if (navigator.vibrate) navigator.vibrate(p); } catch (e) { /* no motor */ } };
    const music = (fn, ...a) => { try { const m = api.music; if (m && typeof m[fn] === 'function') m[fn](...a); } catch (e) { /* fine */ } };
    const bonus = () => { try { const b = (api.bonus && api.bonus()) || {}; return { road: !!b.road, saw: !!b.saw, mem: !!b.mem }; } catch (e) { return { road: false, saw: false, mem: false }; } };
    const rnd = (n) => 1 + Math.floor(Math.random() * n);
    /* your Quest character's name for your bar (read only), else "You" */
    const youName = () => {
      let n = '';
      try { const c = FFD.char; if (c && typeof c.name === 'string') n = c.name; } catch (e) { /* fine */ }
      /* the identity the room knows (FFD.quest), never the Quest's raw run: an unfinished run or a hero someone set aside
         with "Not you?" must not name the bar */
      if (!n) { try { const q = window.FFD && FFD.quest && FFD.quest.v === 1 ? FFD.quest.hero() : null; if (q && typeof q.name === 'string') n = q.name; } catch (e) { /* fine */ } }
      n = String(n).replace(/\s+/g, ' ').trim().slice(0, 24);
      return n || 'You';
    };
    /* one of Jan's clips now, or the FFSound stand-in while it isn't decoded yet */
    const clip = (k, stand) => {
      if (window.FFSound && FFSound.muted) return;
      const ac = audioCtx(), b = CLIP_BUF[k];
      if (!ac || !b) { if (stand) snd(stand); return; }
      try { const s = ac.createBufferSource(), g = ac.createGain(); s.buffer = b; g.gain.value = CLIPS[k].vol * 0.8; s.connect(g); g.connect(ac.destination); s.start(); } catch (e) { if (stand) snd(stand); }
    };
    /* the hand's soft chime: four quiet bell partials rising (B5, E6, B6, E7), on FFSound's own audio context like the
       clips above; FFSound's chime if there is no context. Muted means silent */
    const handChime = () => {
      if (window.FFSound && FFSound.muted) return;
      const ac = audioCtx();
      if (!ac || typeof ac.createOscillator !== 'function') { snd('chime'); return; }
      try {
        const t0 = ac.currentTime + 0.02;
        [[987.8, 0, 0.045], [1318.5, 0.09, 0.04], [1975.5, 0.18, 0.03], [2637, 0.3, 0.02]].forEach((p, i) => {
          const os = ac.createOscillator(), g = ac.createGain(), t = t0 + p[1];
          os.type = i === 3 ? 'triangle' : 'sine'; os.frequency.value = p[0];
          g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(p[2], t + 0.025); g.gain.exponentialRampToValueAtTime(0.0001, t + 1.5);
          os.connect(g); g.connect(ac.destination); os.start(t); os.stop(t + 1.6);
        });
      } catch (e) { snd('chime'); }
    };
    if (!document.getElementById(CSS_ID)) { const st = document.createElement('style'); st.id = CSS_ID; st.textContent = CSS; document.head.append(st); }

    let cur = null;   /* the open fight: { p, end(result, now), state() } */

    function open() {
      if (cur) return cur.p;
      const F = api.F || {};
      const host = F.el || document.querySelector('.ffd-page--library .ffs') || document.body;
      const back = document.activeElement;
      let res = null;
      const p = new Promise((r) => { res = r; });

      const o = document.createElement('div');
      o.className = 'lbf is-intro' + (RM() ? ' is-rm' : '');
      o.tabIndex = -1;
      o.setAttribute('role', 'dialog'); o.setAttribute('aria-modal', 'true'); o.setAttribute('aria-label', 'The fight with the Iron Matron');
      o.innerHTML = '<div class="lbf-cam"><div class="lbf-world" aria-hidden="true"><div class="lbf-dim"></div><div class="lbf-bg"></div><div class="lbf-shade"></div><div class="lbf-frost"></div></div>' +
        '<div class="lbf-in"><div class="lbf-top"><button type="button" class="lbf-leave">Leave</button>' +
          '<div class="lbf-hp lbf-her"><span class="lbf-n">The Iron Matron</span><em></em><span class="lbf-tr" aria-hidden="true"><span class="lbf-g"></span><span class="lbf-f"></span></span><span class="lbf-int is-none"><i></i><span></span></span></div></div>' +
          '<div class="lbf-main"><div class="lbf-stage"><div class="lbf-pos"><div class="lbf-m"></div><span class="lbf-candle" aria-hidden="true"></span>' +
            '<div class="lbf-cast" aria-hidden="true"><span class="lbf-glow"></span><canvas class="lbf-runes" width="' + RUNE_W + '" height="' + RUNE_H + '"></canvas></div><canvas class="lbf-orb" width="' + ORB_W + '" height="' + ORB_H + '" aria-hidden="true"></canvas>' +
            '<div class="lbf-ice" aria-hidden="true"><canvas width="' + ICE_W + '" height="' + ICE_H + '"></canvas><i></i></div></div>' +
            '<div class="lbf-ward" aria-hidden="true"><i></i></div><div class="lbf-dice" aria-hidden="true"></div><p class="lbf-sum" aria-hidden="true"></p></div>' +
          '<div class="lbf-panel"><p class="lbf-line" aria-hidden="true"></p><p class="lbf-sr" aria-live="polite"></p>' +
            '<div class="lbf-hp lbf-you"><span class="lbf-guard"><span class="lbf-gs">' + GUARD_SVG + '<b></b></span><small aria-hidden="true">Guard</small></span><span class="lbf-n"></span><em></em><span class="lbf-tr" aria-hidden="true"><span class="lbf-g"></span><span class="lbf-f"></span></span></div>' +
            '<div class="lbf-bonus"></div><div class="lbf-act"></div></div></div></div>' +
        '<div class="lbf-fxl" aria-hidden="true"></div></div><div class="lbf-edge" aria-hidden="true"></div><div class="lbf-fx" aria-hidden="true"></div>';
      const $ = (s) => o.querySelector(s);
      const world = $('.lbf-world'), bgEl = $('.lbf-bg'), stage = $('.lbf-stage'), posEl = $('.lbf-pos'), mEl = $('.lbf-m'), dEl = $('.lbf-dice'), sumEl = $('.lbf-sum'), ln = $('.lbf-line'), srEl = $('.lbf-sr');
      const bon = $('.lbf-bonus'), act = $('.lbf-act'), fx = $('.lbf-fx'), edge = $('.lbf-edge'), fxl = $('.lbf-fxl'), intEl = $('.lbf-int'), intTx = intEl.querySelector('span');
      act.tabIndex = -1;   /* the keyboard focus waits here while a round plays (btn()) */
      const castEl = $('.lbf-cast'), orbEl = $('.lbf-orb'), wardEl = $('.lbf-ward'), guardEl = $('.lbf-guard'), guardTx = guardEl.querySelector('b'), iceEl = $('.lbf-ice');
      try {
        const tip = paintIce(iceEl.querySelector('canvas'));
        if (tip) { iceEl.style.setProperty('--gx', ((tip.x + 0.5) / ICE_W * 100).toFixed(1) + '%'); iceEl.style.setProperty('--gy', ((tip.y + 0.5) / ICE_H * 100).toFixed(1) + '%'); }
      } catch (e) { /* the ice is a nicety */ }
      const bar = (sel) => { const el = $(sel); return { el, tr: el.querySelector('.lbf-tr'), f: el.querySelector('.lbf-f'), g: el.querySelector('.lbf-g'), t: el.querySelector('em'), v: 0, max: 1, dl: [] }; };
      const herBar = bar('.lbf-her'), youBar = bar('.lbf-you');
      const myName = youName();
      youBar.el.querySelector('.lbf-n').textContent = myName;
      if (myName !== 'You') youBar.el.setAttribute('aria-label', myName + ', your health');
      /* the fight's own taps and keys stay the fight's: the room under it never sees them */
      ['pointerdown', 'mousedown', 'touchstart', 'click', 'wheel'].forEach((t) => o.addEventListener(t, (e) => e.stopPropagation(), { passive: t === 'touchstart' || t === 'wheel' }));
      host.append(o);

      let over = false, S = null, B = bonus(), scene = null, M = null, redEyes = false, phase = 'open', main = 0, firstFocus = true, diceBox = '';
      let blowAt = null, introDone = false, skipIntro = null, skipAt = 0, dis = null, slept = null, guardNow = FIGHT.guard, guardAnim = 0, motes = null, handSeen = false;
      /* the rune ring: painted on its own small canvas only while her cast shows (see castFx) */
      let runes = null, runeRaf = 0, runeLvl = 0, runeLast = 0, runeT0 = 0;
      const runeTurn = { a: 0, b: 0, c: 0, hl: 0 };
      try { runes = runePainter(castEl.querySelector('canvas')); } catch (e) { runes = null; }
      /* her spell in her hands: painted on its own small canvas only while it shows (see orb()) */
      let orbPaint = null, orbMode = null, orbRaf = 0, orbLast = 0, orbT0 = 0, orbLit = 0, orbR = 7;
      try { orbPaint = orbPainter(orbEl); } catch (e) { orbPaint = null; }
      /* her spell's flight and burst: the screen canvas on her art's grid, while anything is drawn on it (see pixAdd) */
      let pix = null;
      const timers = new Set();
      /* wait: an exact pause (an effect's own timing, so a number lands when its blow does) */
      const wait = (ms) => new Promise((r) => { if (!ms) { r(); return; } const id = setTimeout(() => { timers.delete(id); r(); }, ms); timers.add(id); });
      /* beat: the hold between two beats of a round (none under reduced motion). A tap hurries every hold still running
         and still to come to half its time, until the next choice */
      let hurry = false;
      const holds = new Set();
      const beat = (ms) => new Promise((r) => {
        ms = T(ms); if (hurry) ms = Math.round(ms / 2);
        if (!ms || over) { r(); return; }
        const h = { end: performance.now() + ms, id: 0, go: null };
        h.go = () => { timers.delete(h.id); holds.delete(h); r(); };
        h.id = setTimeout(h.go, ms); timers.add(h.id); holds.add(h);
      });
      const later = (fn, ms) => { const id = setTimeout(() => { timers.delete(id); if (!over) fn(); }, ms); timers.add(id); };
      const m = (f) => { try { if (M) f(M); } catch (e) { /* the art is a nicety */ } };

      /* her backdrop: Quest One's tavern-cold, painted by the library's own art bundle (hidden until her spell brings it);
         a cold gradient without it */
      try { const NS = window.FFNoteScenes; if (NS && typeof NS.mount === 'function' && (!NS.keys || NS.keys().indexOf('tavern-cold') >= 0)) scene = NS.mount(bgEl, 'tavern-cold', { reduced: RM() }); } catch (e) { scene = null; }
      try { if (window.QOArt && typeof QOArt.mountMatron === 'function') M = QOArt.mountMatron(mEl, { state: 'matron', reduced: RM() }); } catch (e) { M = null; }
      const eyes = (mode) => { try { const NS = window.FFNoteScenes; if (scene && NS && typeof NS.eyes === 'function' && (mode || redEyes)) { NS.eyes(mode); redEyes = !!mode; } } catch (e) { /* fine */ } };
      const tavCanvas = () => { const cs = bgEl.querySelectorAll('canvas'); return cs.length ? cs[cs.length - 1] : null; };

      /* ---- the room under the fight: asleep while the tavern covers it (see the header) ---- */
      const roomEl = () => { try { return host.querySelector('.lb-pan') || host.querySelector('.ffs-art'); } catch (e) { return null; } };
      function roomSleep(on) {
        try {
          if (on) {
            if (slept || over) return;
            const el = roomEl(); if (!el) return;
            slept = { el, tr: el.style.translate || '', vis: el.style.visibility || '' };
            el.style.translate = '-400vw 0'; el.style.visibility = 'hidden';
          } else if (slept) {
            const s = slept; slept = null;
            s.el.style.translate = s.tr; s.el.style.visibility = s.vis;
          }
        } catch (e) { slept = null; }
      }

      requestAnimationFrame(() => { if (!over) o.classList.add('is-in'); });

      /* ---- what the reader sees ---- */
      let log = [];
      const newRound = () => { log = []; sum(''); dEl.classList.add('is-idle'); if (herBar.dl.length || youBar.dl.length) { herBar.dl = []; youBar.dl = []; num(herBar); num(youBar); } };
      /* a beat's words: in motion they replace each other. Under reduced motion the round's beats stay together. What she
         says aloud arrives word by word at the room's own pace (FFD.arrive, the box's arrival, when the page has it), and
         a tap shows it whole; the fight's own beats land at once, as blows do. A screen reader hears each line once, whole,
         from the hidden twin */
      const arriving = () => { try { return ln.__ffdArrive || null; } catch (e) { return null; } };
      const say = (t) => {
        if (RM()) { log.push(t); ln.textContent = log.join(' '); srEl.textContent = ln.textContent; return; }
        srEl.textContent = t;
        const was = arriving(); if (was) { try { was.stop(); } catch (e) { /* fine */ } }
        if (/^“/.test(t) && typeof FFD.arrive === 'function') {
          ln.classList.remove('is-in');
          try { FFD.arrive(ln, t); return; } catch (e) { /* the plain way below */ }
        }
        ln.textContent = t; ln.classList.remove('is-in'); void ln.offsetWidth; ln.classList.add('is-in');
      };
      const sum = (t, tone) => {
        sumEl.textContent = t || '';
        sumEl.classList.toggle('is-ok', tone === 'ok'); sumEl.classList.toggle('is-no', tone === 'no');
        if (t && !RM()) { sumEl.classList.remove('is-pop'); void sumEl.offsetWidth; sumEl.classList.add('is-pop'); }
      };
      /* the number, and under reduced motion the round's changes beside it (in motion they fly off the art instead) */
      const num = (b) => {
        b.t.textContent = b.v + ' / ' + b.max;
        b.dl.forEach((d) => { const s = document.createElement('span'); s.className = 'lbf-dl' + (d[0] === '+' ? ' is-heal' : ''); s.textContent = d; b.t.append(' ', s); });
      };
      const paint = (b, v, max) => { const pc = Math.max(0, Math.min(max, v)) / max * 100; b.f.style.width = pc + '%'; b.g.style.width = pc + '%'; b.v = v; b.max = max; num(b); };
      const setHer = (v) => { S.her = Math.max(0, v); paint(herBar, S.her, FIGHT.her); };
      const setYou = (v) => { S.you = Math.max(0, Math.min(FIGHT.you, v)); paint(youBar, S.you, FIGHT.you); o.classList.toggle('is-low', S.you > 0 && S.you <= FIGHT.handYou); };
      const baseGuard = () => FIGHT.guard + (B.saw ? FIGHT.saw : 0);
      const curGuard = () => baseGuard() + (S && S.shield ? FIGHT.shield : 0);
      /* your guard, shown as a number on the badge; it climbs and falls back with a count */
      const showGuard = (to, up) => {
        guardEl.classList.toggle('is-up', !!up);
        guardEl.setAttribute('aria-label', 'Your guard ' + to);
        cancelAnimationFrame(guardAnim);
        const from = guardNow; guardNow = to;
        if (RM() || from === to) { guardTx.textContent = String(to); return; }
        const t0 = performance.now(), dur = 420;
        const stepG = (t) => { const u = Math.min(1, (t - t0) / dur); guardTx.textContent = String(Math.round(from + (to - from) * (1 - Math.pow(1 - u, 3)))); if (u < 1 && !over) guardAnim = requestAnimationFrame(stepG); };
        guardAnim = requestAnimationFrame(stepG);
      };
      const chips = (fresh) => {
        const c = [];
        if (S.clean) c.push(['A clean rise, +2 to hit', fresh === 'clean']);
        if (B.road) c.push(['Road scar, +1 to hit']);
        if (B.saw) c.push(['You saw it coming, +2 to your guard']);
        if (B.mem) c.push(['What you remembered, +2 damage']);
        bon.textContent = '';
        c.forEach((t) => { const s = document.createElement('span'); s.textContent = t[0]; if (t[1]) s.className = 'is-new'; bon.append(s); });
      };
      /* what she does next, always in view while you choose */
      const intent = (pop) => {
        let t = '', k = '';
        if (S && S.you > 0 && S.her > 0 && phase !== 'stand' && phase !== 'intro') {
          if (S.charge >= 2) { t = S.broken ? 'Her spell is coming apart' : 'She casts next'; k = S.broken ? 'wild' : 'spell'; }
          else if (S.tricked) { t = 'Her next swing is wild'; k = 'wild'; }
          else t = 'She swings next';
        }
        const was = intTx.textContent;
        intTx.textContent = t;
        intEl.classList.toggle('is-none', !t); intEl.classList.toggle('is-spell', k === 'spell'); intEl.classList.toggle('is-wild', k === 'wild');
        if (t && (pop || t !== was) && !RM()) { intEl.classList.remove('is-pop'); void intEl.offsetWidth; intEl.classList.add('is-pop'); }
      };
      const shake = (big) => { if (RM()) return; o.classList.remove('is-shake', 'is-quake'); void o.offsetWidth; o.classList.add(big ? 'is-quake' : 'is-shake'); };
      const flash = (c, ms) => { if (RM()) return; fx.style.background = c; fx.style.animationDuration = (ms || 600) + 'ms'; fx.classList.remove('is-on'); void fx.offsetWidth; fx.classList.add('is-on'); };

      /* ---- the effects layer: every blow travels and lands ---- */
      const box = (el) => { const r = el.getBoundingClientRect(); return { l: r.left, t: r.top, w: r.width, h: r.height, cx: r.left + r.width / 2, cy: r.top + r.height / 2 }; };
      const vw = () => window.innerWidth || document.documentElement.clientWidth || 390;
      const vh = () => window.innerHeight || document.documentElement.clientHeight || 844;
      const put = (cls, x, y, w, h, html) => {
        const s = document.createElement('span'); s.className = cls;
        s.style.left = Math.round(x) + 'px'; s.style.top = Math.round(y) + 'px';
        if (w != null) s.style.width = Math.round(w) + 'px';
        if (h != null) s.style.height = Math.round(h) + 'px';
        if (html) s.innerHTML = html;
        fxl.append(s); return s;
      };
      const drop = (el, ms) => { setTimeout(() => { try { el.remove(); } catch (e) { /* gone */ } }, ms); };
      const anim = (el, kf, op) => { if (RM() || !el || typeof el.animate !== 'function') return null; try { return el.animate(kf, op); } catch (e) { return null; } };
      const an = (el, kf, op) => { const a = anim(el, kf, op); return a ? a.finished.then(() => {}, () => {}) : Promise.resolve(); };
      /* the size her blows are drawn at: the window's short side, but never more than 560 px, so on a desktop they stay
         the size of the fight's own column instead of sweeping across the room */
      const fxK = () => Math.min(vw(), vh(), 560);
      /* where her blows land: just above your bar, over the middle of its track, on every screen (on a phone on its side
         that is the right-hand column, so her blows cross from her to you) */
      const impactPt = () => {
        const tr = box(youBar.tr), yb = box(youBar.el), w = vw(), h = vh();
        return { x: Math.min(w - 40, Math.max(40, tr.cx)), y: Math.min(h - 60, Math.max(60, yb.t - 6)) };
      };
      /* where a miss goes: wide of the middle, toward one end of your bar, and a little higher */
      const missPt = (P) => { const tr = box(youBar.tr), d = Math.min(tr.w * 0.42, fxK() * 0.38); return { x: Math.min(vw() - 30, Math.max(30, P.x + (vr() < 0.5 ? -1 : 1) * d)), y: P.y - fxK() * 0.06 }; };
      /* the top of your Shield's dome, where a blow it stops glances off */
      const wardPt = () => { const b = box(wardEl), s = box(stage); return b.h > 4 && b.w > 4 ? { x: Math.min(vw() - 40, Math.max(40, s.cx)), y: Math.max(60, b.t + 4) } : impactPt(); };
      /* her figure, and her hands, inside the art box (192 x 144: her hands meet at the middle, about 57% down when lifted) */
      const herPt = (fx0, fy0) => { const b = box(posEl); return { x: b.l + b.w * fx0, y: b.t + b.h * fy0, w: b.w, h: b.h }; };
      /* your number's spot: it rises from just above your bar beside the line above it, in the middle of whichever side
         of the line's words has room for it, and from above the line when neither side does, so the line stays
         readable (its anchor is the number's centre line, set high enough that its foot clears your bar and the line
         even at the 1.25x pop of lbf-num) */
      const youNumAt = (s) => {
        const yb = box(youBar.el), tr = box(youBar.tr), w = s.offsetWidth || 60, h = s.offsetHeight || 60;
        let x = tr.cx, y = yb.t - 4 - h * 0.6, L = Infinity, R = -Infinity, T = Infinity;
        if (ln.textContent) {
          try {
            const rg = document.createRange(); rg.selectNodeContents(ln);
            [...rg.getClientRects()].forEach((b) => { if (b.width > 0 && b.height > 0) { L = Math.min(L, b.left); R = Math.max(R, b.right); T = Math.min(T, b.top); } });
          } catch (e) { /* no words to step round */ }
        }
        if (R > L) {
          const right = tr.l + tr.w - R, left = L - tr.l, need = w + 16;
          if (right >= need || left >= need) x = right >= left ? R + right / 2 : L - left / 2;
          else y = T - h * 0.62;
        }
        return { x: Math.min(vw() - w / 2 - 6, Math.max(w / 2 + 6, x)), y: Math.max(h, y) };
      };
      const pop = (who, text, cls) => {
        const b = who === 'her' ? herBar : youBar;
        if (RM()) { b.dl.push(text); num(b); return; }
        const q = who === 'her' ? herPt(0.5, 0.4) : null;
        const s = put('lbf-num' + (cls ? ' ' + cls : ''), q ? q.x : 0, q ? q.y : 0, null, null);
        s.textContent = text;
        if (!q) { const p = youNumAt(s); s.style.left = Math.round(p.x) + 'px'; s.style.top = Math.round(p.y) + 'px'; }
        drop(s, 1350);
      };
      const crack = (P, k) => {
        if (RM()) return;
        const R = Math.round(fxK() * 0.65 * (k || 1)), n = 7 + Math.floor(vr() * 3);
        let d = '';
        for (let i = 0; i < n; i++) {
          let a = i / n * Math.PI * 2 + (vr() - 0.5) * 0.55, x = 0, y = 0;
          const len = R * (0.4 + vr() * 0.6), seg = 4 + Math.floor(vr() * 3);
          d += 'M0 0';
          for (let j = 0; j < seg; j++) {
            a += (vr() - 0.5) * 0.7; x += Math.cos(a) * len / seg; y += Math.sin(a) * len / seg;
            d += 'L' + x.toFixed(1) + ' ' + y.toFixed(1);
            if (j > 0 && vr() < 0.3) { const b2 = a + (vr() < 0.5 ? -1 : 1) * (0.5 + vr() * 0.5), bl = len / seg * (0.6 + vr()); d += 'L' + (x + Math.cos(b2) * bl).toFixed(1) + ' ' + (y + Math.sin(b2) * bl).toFixed(1) + 'M' + x.toFixed(1) + ' ' + y.toFixed(1); }
          }
        }
        const ring = 'M' + (R * 0.07) + ' 0A' + (R * 0.07) + ' ' + (R * 0.07) + ' 0 1 1 ' + (R * 0.07 - 0.1) + ' -0.5';
        const s = put('lbf-crack', P.x - R, P.y - R, R * 2, R * 2, '<svg viewBox="' + -R + ' ' + -R + ' ' + R * 2 + ' ' + R * 2 + '"><path d="' + d + ring + '" stroke="rgba(0,0,0,.55)" stroke-width="5"/><path d="' + d + ring + '" stroke="rgba(255,255,255,.85)" stroke-width="1.6"/></svg>');
        drop(s, 1050);
      };
      const burst = (P, size, col) => { if (RM()) return; const s = put('lbf-burst', P.x - size / 2, P.y - size / 2, size, size); s.style.setProperty('--c', col); drop(s, 620); };
      const ringWave = (P, size, col) => { if (RM()) return; const s = put('lbf-ringw', P.x - size / 2, P.y - size / 2, size, size); s.style.setProperty('--c', col); drop(s, 820); };
      const spark = (P) => {
        if (RM()) return;
        const s = put('lbf-spark', P.x, P.y, null, null);
        for (let i = 0; i < 12; i++) { const e = document.createElement('i'); e.style.setProperty('--a', Math.round(i * 30 + vr() * 20) + 'deg'); e.style.animationDelay = Math.round(vr() * 40) + 'ms'; s.append(e); }
        drop(s, 560);
      };
      const edgeFlash = () => { if (RM()) return; edge.classList.remove('is-on'); void edge.offsetWidth; edge.classList.add('is-on'); };
      /* a tap while a round plays: a ripple where it landed, and every hold of the round (running or still to come) at
         half its time; the next roll is quicker too. Every beat still lands, in order */
      const hurryAt = ['busy', 'her', 'fight', 'stand', 'won', 'lost'];
      const hurryUp = (x, y) => {
        if (over || hurryAt.indexOf(phase) < 0) return;
        if (!RM()) { const s = put('lbf-tapr', x, y, null, null); drop(s, 420); }
        const a = arriving(); if (a) { try { a.finish(); } catch (e) { /* fine */ } }
        if (hurry) return;
        hurry = true; buzz(6);
        const now = performance.now();
        holds.forEach((h) => { const ms = Math.round(Math.max(0, h.end - now) / 2); clearTimeout(h.id); timers.delete(h.id); h.end = now + ms; h.id = setTimeout(h.go, ms); timers.add(h.id); });
      };
      /* a bar takes the hit: it jolts, and its fill flashes white before it drains */
      const barHit = (b, big) => {
        an(b.el, [{ transform: 'none' }, { transform: 'translateX(' + (big ? 9 : 6) + 'px)', offset: 0.15 }, { transform: 'translateX(-6px)', offset: 0.4 }, { transform: 'translateX(3px)', offset: 0.65 }, { transform: 'none' }], { duration: 360, easing: 'ease-out' });
        an(b.f, [{ filter: 'brightness(1)' }, { filter: 'brightness(2.6)', offset: 0.18 }, { filter: 'brightness(1)' }], { duration: 300 });
      };
      /* your blade across her: a bright crescent that sweeps over her (or past her) */
      const slashSvg = () => { const id = 'lbfS' + (++fxN); return '<svg viewBox="0 0 200 200"><defs><linearGradient id="' + id + '" x1="0" y1="1" x2="1" y2="0"><stop offset="0" stop-color="#fff" stop-opacity="0"/><stop offset=".5" stop-color="#fff"/><stop offset="1" stop-color="#cfe9ff" stop-opacity="0"/></linearGradient></defs><path d="M12 152Q94 22 190 50Q100 44 12 152Z" fill="url(#' + id + ')"/></svg>'; };
      const slashHer = (big, miss) => {
        if (RM()) return Promise.resolve();
        const q = herPt(miss ? 0.86 : 0.5, 0.42), w = q.w * (big ? 0.72 : 0.56);
        const s = put('lbf-slash', q.x - w / 2, q.y - w / 2, w, w, slashSvg());
        const r0 = big ? -30 : -16;
        an(s, [{ opacity: 0, transform: 'rotate(' + (r0 - 26) + 'deg) scale(.7)', clipPath: 'inset(0 100% 0 0)' }, { opacity: 1, transform: 'rotate(' + r0 + 'deg) scale(1)', clipPath: 'inset(0 0 0 0)', offset: 0.55 }, { opacity: 0, transform: 'rotate(' + (r0 + 8) + 'deg) scale(1.08)', clipPath: 'inset(0 0 0 0)' }], { duration: big ? 360 : 300, easing: 'ease-out' });
        drop(s, 420);
        snd('whoosh', { g: 0.1, d: 0.22 });
        return wait(170);
      };
      /* her flinch, a white flash on her, and her bar's jolt */
      const flinchHer = (big) => {
        an(posEl, [{ transform: 'none' }, { transform: 'translate(' + (big ? 16 : 10) + 'px, -2px) rotate(' + (big ? 1.8 : 1.1) + 'deg)', offset: 0.18 }, { transform: 'translate(-6px, 0) rotate(-.6deg)', offset: 0.45 }, { transform: 'translate(3px, 0)', offset: 0.7 }, { transform: 'none' }], { duration: big ? 480 : 360, easing: 'ease-out' });
        an(mEl, [{ filter: 'drop-shadow(0 0 30px rgba(0,0,0,.6)) brightness(1)' }, { filter: 'drop-shadow(0 0 30px rgba(0,0,0,.6)) brightness(2.5) saturate(.5)', offset: 0.15 }, { filter: 'drop-shadow(0 0 30px rgba(0,0,0,.6)) brightness(1)' }], { duration: 280 });
        barHit(herBar, big);
      };
      const dodge = () => an(posEl, [{ transform: 'none' }, { transform: 'translateX(-5%) rotate(-1.5deg)', offset: 0.35 }, { transform: 'none' }], { duration: 460, easing: 'ease-in-out' });
      /* the feint: dust off the bar and her wobble */
      const feint = () => {
        if (RM()) return Promise.resolve();
        const b = box(posEl);
        for (let i = 0; i < 14; i++) {
          const s = put('lbf-dust', b.l + b.w * (0.3 + vr() * 0.4), b.t + b.h * (0.66 + vr() * 0.06), null, null);
          s.style.setProperty('--dx', Math.round((vr() - 0.5) * b.w * 0.5) + 'px'); s.style.setProperty('--dy', Math.round(-10 - vr() * b.h * 0.18) + 'px');
          s.style.setProperty('--s', Math.round(16 + vr() * b.w * 0.08) + 'px'); s.style.animationDelay = Math.round(vr() * 120) + 'ms';
          drop(s, 1150);
        }
        snd('rustle');
        an(posEl, [{ transform: 'none' }, { transform: 'rotate(-3.4deg) translateX(-2%)', offset: 0.22 }, { transform: 'rotate(2.6deg) translateX(1.5%)', offset: 0.5 }, { transform: 'rotate(-1.2deg)', offset: 0.75 }, { transform: 'none' }], { duration: 760, easing: 'ease-in-out' });
        return wait(260);
      };
      /* the cast: her hands lift and the runes and the cold gather (0 off, 1 on, 2 the surge before the spell lands). The
         ring writes itself round from the top over 0.7 s, then turns (the band once in 9 s, the outer dashes the other
         way, the star slowly), and in the surge it spins up and every rune lights. Under reduced motion it is one still
         frame. The loop runs only while the cast shows */
      const runeStop = () => { cancelAnimationFrame(runeRaf); runeRaf = 0; };
      const runeTick = (now) => {
        runeRaf = 0;
        if (over || !runes || !runeLvl) return;
        const dt = Math.min(64, now - (runeLast || now)) / 1000, sp = runeLvl >= 2 ? 5.6 : 1;
        runeLast = now;
        runeTurn.a += dt * sp * Math.PI * 2 / 9; runeTurn.b -= dt * sp * Math.PI * 2 / 14; runeTurn.c -= dt * sp * Math.PI * 2 / 24;
        runeTurn.hl = (runeTurn.hl + dt * Math.PI * 2 / 1.5) % (Math.PI * 2);
        try { runes(Object.assign({ lvl: runeLvl, u: Math.min(1, (now - runeT0) / 700) }, runeTurn)); } catch (e) { runes = null; return; }
        runeRaf = requestAnimationFrame(runeTick);
      };
      const castFx = (lvl) => {
        castEl.classList.toggle('is-on', lvl >= 1); castEl.classList.toggle('is-surge', lvl >= 2);
        const was = runeLvl; runeLvl = lvl;
        if (!runes) return;
        if (!lvl) { runeStop(); return; }
        if (RM()) { try { runes(Object.assign({ lvl, u: 1 }, runeTurn)); } catch (e) { /* the ring is a nicety */ } return; }
        if (!was) { runeT0 = performance.now(); runeLast = 0; }
        if (!runeRaf) runeRaf = requestAnimationFrame(runeTick);
      };
      /* the spell in her hands (orbPainter): 'on' (it gathers, then charges), 'surge' (about to fly), 'weak' (Tricked
         apart), 'pop' (its end, orbFizzle), or off at once. About 30 frames a second while it shows; under reduced
         motion one still frame of each state */
      const orbDraw = (now) => {
        if (!orbPaint) return;
        const rm = RM(), o = rm ? { mode: orbMode, t: 2000, T: 0, g: 1, still: true } : { mode: orbMode, t: now - orbT0, T: now - orbLit, g: Math.min(1, (now - orbLit) / 900) };
        try { orbPaint(o); } catch (e) { orbPaint = null; }
      };
      const orbTick = (now) => {
        orbRaf = 0;
        if (over || !orbPaint || !orbMode) return;
        if (now - orbLast >= 32) { orbLast = now; orbDraw(now); }
        orbRaf = requestAnimationFrame(orbTick);
      };
      const orb = (mode) => {
        const now = performance.now();
        if (!mode) { orbMode = null; orbLit = 0; cancelAnimationFrame(orbRaf); orbRaf = 0; try { if (orbPaint) orbPaint(null); } catch (e) { orbPaint = null; } return; }
        if (!orbLit) orbLit = mode === 'on' ? now : now - 2000;
        orbMode = mode; orbT0 = now; orbR = mode === 'surge' ? 10.5 : mode === 'weak' ? 7 : 8.5;
        orbDraw(now);
        if (!RM() && !orbRaf) { orbLast = now; orbRaf = requestAnimationFrame(orbTick); }
      };
      /* the Tricked spell's end: it collapses, flashes and scatters its last slivers (none under reduced motion) */
      const orbFizzle = () => {
        if (RM() || !orbPaint || orbMode !== 'weak') { orb(null); return; }
        orb('pop'); later(() => { if (orbMode === 'pop') orb(null); }, 760);
      };
      /* the middle of her spell on the screen (where it sits on her art's grid), and the size of one of the art's pixels */
      const orbAt = () => { const b = box(posEl), k = b.w / 192; return { x: b.l + (ORB_X0 + ORB_CX) * k, y: b.t + (ORB_Y0 + ORB_CY) * k, k }; };
      /* ---- the screen canvas for her spell's flight and burst: its cells are her art's pixels, lined up with them, so the
         thrown spell stays pixel art as it comes at you. Each effect is a function (now, p) drawn every frame until it
         returns false; the canvas goes when the last one has ---- */
      const pixOff = () => { if (!pix) return; cancelAnimationFrame(pix.raf); try { pix.cv.remove(); } catch (e) { /* gone */ } pix = null; };
      const pixOn = () => {
        if (pix) return pix;
        const b = box(posEl), cell = Math.max(1.5, b.w / 192);
        const ox = b.l - Math.ceil(b.l / cell) * cell, oy = b.t - Math.ceil(b.t / cell) * cell;
        const W = Math.ceil((vw() - ox) / cell) + 1, H = Math.ceil((vh() - oy) / cell) + 1;
        const cv = document.createElement('canvas'), g = cv.getContext && cv.getContext('2d');
        if (!g) return null;
        cv.className = 'lbf-pix'; cv.width = W; cv.height = H; cv.setAttribute('aria-hidden', 'true');
        cv.style.left = ox + 'px'; cv.style.top = oy + 'px'; cv.style.width = (W * cell) + 'px'; cv.style.height = (H * cell) + 'px';
        fxl.append(cv);
        const im = g.createImageData(W, H);
        pix = { cv, g, im, px: new Uint32Array(im.data.buffer), W, H, cell, ox, oy, list: [], raf: 0 };
        pix.put = (x, y, c) => { x = Math.floor(x); y = Math.floor(y); if (x >= 0 && y >= 0 && x < W && y < H) pix.px[y * W + x] = c; };
        return pix;
      };
      const pixTick = (now) => {
        const p = pix; if (!p) return;
        p.raf = 0;
        if (over) { pixOff(); return; }
        p.px.fill(0);
        p.list = p.list.filter((f) => { try { return f(now, p) !== false; } catch (e) { return false; } });
        p.g.putImageData(p.im, 0, 0);
        if (p.list.length) p.raf = requestAnimationFrame(pixTick); else pixOff();
      };
      const pixAdd = (f) => { const p = pixOn(); if (!p) return null; p.list.push(f); if (!p.raf) p.raf = requestAnimationFrame(pixTick); return p; };
      /* a ring of pixels at radius rr round (cx, cy) in cells, thinned by the Bayer under 'thin', left out above row ymin
         when it is given */
      const pixRing = (p, cx, cy, rr, thin, col, ymin) => {
        const n = Math.ceil(TAU * rr * 1.4);
        for (let i = 0; i < n; i++) { const a = i / n * TAU, x = Math.floor(cx + Math.cos(a) * rr), y = Math.floor(cy + Math.sin(a) * rr); if (ymin != null && y < ymin) continue; if (bayr(x, y) >= thin) p.put(x, y, col); }
      };
      /* her spell bursting on you, in pixels: the white of it, a star of light shrinking, a ring of frost pushed out
         across the floor and your bar (never up over her), ice slivers flung off, frost growing out from it like ferns on
         a window pane (down and to the sides only, so it stays below the line and her art) and a cold light that swells
         and collapses, solid but for a narrow dithered edge (it takes the place of the other blows' crack, burst, ring
         and flash). About a third of a phone's width at its widest */
      const frostBurst = (P) => {
        if (RM()) return;
        const p0 = pixOn(); if (!p0) return;
        const cell = p0.cell, cx = (P.x - p0.ox) / cell, cy = (P.y - p0.oy) / cell, r = Math.max(6, fxK() * 0.16 / cell);
        const Rmax = fxK() * 0.5 / cell, Rc = fxK() * 0.3 / cell, t0 = performance.now();
        /* the row just under the line's words (when they sit above the burst): the frost, slivers, ring and star stay
           below it, so the line stays readable */
        let yTop = -1e9;
        try { const rg = document.createRange(); rg.selectNodeContents(ln); const tb = rg.getBoundingClientRect(); if (tb.height > 0 && tb.bottom < P.y) yTop = (tb.bottom - p0.oy) / cell + 1; } catch (e) { /* no line to keep clear */ }
        const below = (put) => (x, y, c) => { if (y >= yTop) put(x, y, c); };
        /* the slivers, flung down and to the sides at her art's own pixel size */
        const shards = Array.from({ length: 26 }, (_, i) => ({ a: -0.35 + (Math.PI + 0.7) * (i + 0.5) / 26 + (vr() - 0.5) * 0.3, v: (0.35 + vr() * 0.65) * Rmax / 900, s: vr() * TAU, sp: (vr() - 0.5) * 0.03, big: vr() < 0.7 }));
        /* the frost: 7 to 9 runs fanned out from the middle across its lower half (barely rising at the sides), each
           bending only gently, with a pair of fern twigs every third pixel, longer near the middle (the ones pointing up
           half as long), as pixels with how far along each is; it keeps clear of the line on its own, so the line's
           edge never cuts it flat */
        const cr = [], nc = 7 + Math.floor(vr() * 3);
        for (let i = 0; i < nc; i++) {
          let a = -0.15 + (Math.PI + 0.3) * (i + 0.5) / nc + (vr() - 0.5) * 0.3, x = cx, y = cy, run = 0;
          const len = Rc * (0.4 + vr() * 0.6), seg = 3;
          for (let j = 0; j < seg; j++) {
            a = Math.min(Math.PI + 0.2, Math.max(-0.2, a + (vr() - 0.5) * 0.25));
            const sl = len / seg, nx = x + Math.cos(a) * sl, ny = y + Math.sin(a) * sl, steps = Math.ceil(sl);
            for (let k = 1; k <= steps; k++) {
              const fx0 = x + (nx - x) * k / steps, fy0 = y + (ny - y) * k / steps, al = (run + sl * k / steps) / Rc;
              cr.push([fx0, fy0, al]);
              if (k % 3 === 0) {
                const fl = Math.max(1, Math.round((1 - al) * 4));
                [-1, 1].forEach((sd) => { const fa2 = a + sd * Math.PI / 3, n2 = Math.sin(fa2) < -0.3 ? Math.ceil(fl / 2) : fl; for (let q = 1; q <= n2; q++) cr.push([fx0 + Math.cos(fa2) * q, fy0 + Math.sin(fa2) * q, al + q / Rc]); });
              }
            }
            x = nx; y = ny; run += sl;
          }
        }
        pixAdd((now, p) => {
          const t = now - t0;
          if (t > 1050) return false;
          const put = below(p.put);
          /* the cold light: a bloom round the burst that swells for 90 ms and collapses by 200, solid but for a narrow
             dithered edge (so it never thins into a screen of dots) */
          if (t < 200) {
            const Rf = r * (1.05 + 0.65 * eo(t / 90)) * (1 - Math.max(0, t - 90) / 110), y0 = Math.max(0, Math.floor(cy - Rf)), y1 = Math.min(p.H - 1, Math.ceil(cy + Rf)), x0 = Math.max(0, Math.floor(cx - Rf)), x1 = Math.min(p.W - 1, Math.ceil(cx + Rf));
            if (Rf > 1) for (let y = y0; y <= y1; y++) for (let x = x0; x <= x1; x++) {
              const dx = x + 0.5 - cx, dy = y + 0.5 - cy, d = Math.sqrt(dx * dx + dy * dy) / Rf;
              if (d >= 1 || bayr(x, y) >= (1 - d) * 6) continue;
              p.px[y * p.W + x] = d < 0.3 ? FP.w : d < 0.55 ? FP.b : d < 0.78 ? FP.m : FP.d;
            }
          }
          /* the frost: it grows out in the first 140 ms, holds, and thins away after 650; white at its heart, pale,
             then blue at its tips */
          const reach = eo(t / 140);
          cr.forEach((q) => {
            if (q[2] > reach) return;
            const x = Math.floor(q[0]), y = Math.floor(q[1]);
            if (t > 650 && bayr(x, y) < (t - 650) / 350) return;
            put(x, y, q[2] < 0.15 ? FP.w : q[2] < 0.55 ? FP.L : FP.M);
          });
          /* the ring of frost pushed out across the floor and your bar, solid, fading by colour */
          if (t < 420) { const u = t / 420, rr = r + (Rmax - r) * eo(u), col = t < 105 ? FP.w : t < 210 ? FP.b : t < 315 ? FP.m : FP.d; pixRing(p, cx, cy, rr, 0, col, Math.max(cy - Rmax * 0.35, yTop)); }
          /* the slivers flung off it */
          shards.forEach((s) => {
            const dd = r * 0.7 + s.v * t * (1 - t / 2200), x = cx + Math.cos(s.a) * dd, y = cy + Math.sin(s.a) * dd + 0.00004 * t * t;
            if (t > 600 && bayr(Math.floor(x), Math.floor(y)) < (t - 600) / 420) return;
            sliver(put, x, y, s.s + s.sp * t, true, s.big);
          });
          /* the white of it, then a star of light shrinking away round a white core */
          if (t < 70) {
            const rw = r * 0.6;
            for (let y = Math.floor(cy - rw); y <= cy + rw; y++) for (let x = Math.floor(cx - rw); x <= cx + rw; x++) { const dx = x + 0.5 - cx, dy = y + 0.5 - cy; if (dx * dx + dy * dy <= rw * rw) p.put(x, y, FP.w); }
          } else if (t < 280) {
            const u = (t - 70) / 210, L = r * 1.7 * (1 - eo(u)), cr0 = Math.max(1, r * 0.5 * (1 - u));
            for (let k = -L; k <= L; k++) { const c = Math.abs(k) < L * 0.5 ? FP.w : FP.b; put(cx + k, cy, c); put(cx, cy + k, c); if (Math.abs(k) < L * 0.5) { put(cx + k * 0.7, cy + k * 0.7, FP.b); put(cx + k * 0.7, cy - k * 0.7, FP.b); } }
            for (let y = -cr0; y <= cr0; y++) for (let x = -cr0; x <= cr0; x++) if (x * x + y * y <= cr0 * cr0) p.put(cx + x, cy + y, FP.w);
          }
          return true;
        });
      };
      /* your Shield: a gold dome rising on your side of her counter, a light sweeping over it as it comes up; it flares
         when a blow glances off it and breaks (with gold sparks off its top) when one gets through */
      const ward = (mode) => {
        wardEl.classList.remove('is-flare', 'is-break');
        if (mode === 'on') { wardEl.classList.add('is-on'); snd('chime'); return; }
        if (!wardEl.classList.contains('is-on')) return;
        if (mode === 'flare') { wardEl.classList.add('is-flare'); later(() => { wardEl.classList.remove('is-flare', 'is-on'); }, RM() ? 0 : 260); return; }
        if (mode === 'break') {
          if (!RM()) { const P = wardPt(); spark(P); burst(P, fxK() * 0.35, 'rgba(255,214,140,.65)'); }
          wardEl.classList.add('is-break'); wardEl.classList.remove('is-on'); later(() => wardEl.classList.remove('is-break'), RM() ? 0 : 420); return;
        }
        wardEl.classList.remove('is-on');
      };
      /* her blow on its way to you: the iron cup's arc, her cold hand's three frost streaks, or the frost from her cup. Her
         arc is iron going to blood red, a crescent the other way round from your Strike's, and it starts small at her
         hand and grows as it comes down at you. A miss goes wide of the middle, or (at) glances off your Shield's dome.
         Resolves at the moment it lands */
      const arcSvg = () => { const id = 'lbfA' + (++fxN); return '<svg viewBox="0 0 200 200"><defs><linearGradient id="' + id + '" x1="1" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#3a3f48" stop-opacity="0"/><stop offset=".4" stop-color="#7a6f70"/><stop offset=".72" stop-color="#ff6a5a"/><stop offset="1" stop-color="#ff6a5a" stop-opacity="0"/></linearGradient></defs><g transform="matrix(-1 0 0 1 200 0)"><path d="M8 120Q60 10 192 40Q74 34 8 120Z" fill="url(#' + id + ')"/><path d="M30 128Q80 46 186 58" fill="none" stroke="rgba(255,190,170,.55)" stroke-width="2"/></g></svg>'; };
      /* frosty streaks off the back edge of a flying sphere c ({ x, y, r } in cells) along the way it came (ux, uy), pale
         then blue, thinning toward their ends and longer as it speeds up (dl: the cells it moved in the last 16 ms); n of
         them */
      const frostTrail = (put, c, ux, uy, dl, n) => {
        const sp = Math.min(3, dl / Math.max(1, c.r) * 1.6) + 0.4;
        for (let i = 0; i < n; i++) {
          const off = (i / (n - 1) - 0.5) * 1.5 * c.r, bk = Math.sqrt(Math.max(0, c.r * c.r - off * off)), L = c.r * sp * (0.45 + 0.55 * hsh(i, 71, 7));
          const x0 = c.x - uy * off - ux * bk, y0 = c.y + ux * off - uy * bk;
          for (let k = 0; k < L; k += 0.7) {
            const f = k / L, x = Math.floor(x0 - ux * k), y = Math.floor(y0 - uy * k);
            if (bayr(x, y) < f * 0.9) continue;
            put(x, y, f < 0.3 ? FP.L : f < 0.65 ? FP.m : FP.d);
          }
        }
      };
      const herBlow = (kind, hit, at) => {
        if (RM()) return Promise.resolve();
        const P = impactPt(), tgt = at || (hit ? P : missPt(P));
        blowAt = tgt;
        const from = kind === 0 ? herPt(0.32, 0.62) : herPt(kind === 2 ? 0.6 : 0.5, kind === 2 ? 0.6 : 0.5);
        const S0 = fxK();
        if (kind === 0) {
          const w = S0 * 1.05, s = put('lbf-arc', tgt.x - w / 2, tgt.y - w / 2, w, w, arcSvg());
          an(s, [{ opacity: 0, transform: 'translate(' + (from.x - tgt.x) + 'px,' + (from.y - tgt.y) + 'px) scale(.22) rotate(48deg)' }, { opacity: 1, transform: 'translate(0,0) scale(.9) rotate(4deg)', offset: 0.72 }, { opacity: 0, transform: 'translate(0,0) scale(1.15) rotate(-8deg)' }], { duration: 400, easing: 'cubic-bezier(.5,0,.75,1)' });
          drop(s, 430); snd('whoosh', { g: 0.16, d: 0.32 });
          return wait(290);
        }
        if (kind === 1) {
          /* her cold hand: three frost rakes torn across you on her art's grid, two pixels wide (one at their ends), each
             drawn head first in 170 ms (45 ms apart) with a white head, a pale body and a blue tail, then fading a colour
             at a time over 350 ms */
          const w = S0 * 0.9, t0 = performance.now();
          const rakes = [[40, 30, 96, 92, 150, 170], [70, 22, 122, 84, 172, 150], [18, 56, 70, 112, 122, 182]].map((q, i) => {
            const pt = (u) => { const a = (1 - u) * (1 - u), b = 2 * (1 - u) * u, c = u * u; return [tgt.x - w / 2 + (a * q[0] + b * q[2] + c * q[4]) / 200 * w, tgt.y - w / 2 + (a * q[1] + b * q[3] + c * q[5]) / 200 * w]; };
            return { pt, d0: i * 45 };
          });
          pixAdd((now, p) => {
            const t = now - t0;
            if (t > 620) return false;
            rakes.forEach((k) => {
              const tt = t - k.d0;
              if (tt <= 0) return;
              const rev = Math.min(1, Math.pow(tt / 170, 2)), f = (tt - 170) / 350;
              if (f >= 1) return;
              const fade = f < 0 ? -1 : f < 1 / 3 ? 0 : f < 2 / 3 ? 1 : 2;
              const a0 = k.pt(0), a1 = k.pt(1), n = Math.ceil(Math.hypot(a1[0] - a0[0], a1[1] - a0[1]) / p.cell * 1.6);
              for (let j = 0; j <= n * rev; j++) {
                const u = j / n, q = k.pt(u), x = (q[0] - p.ox) / p.cell, y = (q[1] - p.oy) / p.cell, back = rev - u;
                const col = fade >= 0 ? [FP.L, FP.M, FP.D][fade] : back < 0.06 ? FP.w : back < 0.5 ? FP.L : FP.M;
                p.put(x, y, col);
                if (u > 0.15 && u < 0.85) { p.put(x + 1, y, col); }
              }
            });
            return true;
          });
          snd('rip');
          return wait(230);
        }
        /* the frost from her cup: a small sphere of the same frost flung at you on the screen canvas, growing as it comes,
           with three streaks behind it; it lands at 330 ms (as the promise resolves) and on a hit bursts small, a white
           flash and then six slivers flung off (a miss is marked by its own spark where it lands) */
        const t0 = performance.now(), DL = Math.hypot(tgt.x - from.x, tgt.y - from.y) || 1, UX = (tgt.x - from.x) / DL, UY = (tgt.y - from.y) / DL;
        const bits = Array.from({ length: 6 }, (_, i) => ({ a: i / 6 * TAU + (vr() - 0.5) * 0.6, v: 0.9 + vr() * 0.9, s: vr() * TAU, sp: (vr() - 0.5) * 0.03 }));
        pixAdd((now, p) => {
          const t = now - t0, put = p.put, r1 = Math.max(3, S0 * 0.08 / p.cell);
          const at = (tt) => { const u = easeThrow(Math.min(1, Math.max(0, tt / 330))); return { x: (from.x + (tgt.x - from.x) * u - p.ox) / p.cell, y: (from.y + (tgt.y - from.y) * u - p.oy) / p.cell, r: 1.5 + (r1 - 1.5) * u }; };
          if (t < 330) {
            const c = at(t), q0 = at(t - 16);
            frostTrail(put, c, UX, UY, Math.hypot(c.x - q0.x, c.y - q0.y), 3);
            frostSphere(put, c.x, c.y, c.r, { lvl: 0.12, arm: -1, rot: -Math.PI / 2 + Math.floor(t / 50) * Math.PI / 12 });
            return true;
          }
          if (!hit) return false;
          const tb = t - 330, c = at(330);
          if (tb > 400) return false;
          if (tb < 50) { const rw = c.r * 0.6; for (let y = Math.floor(c.y - rw); y <= c.y + rw; y++) for (let x = Math.floor(c.x - rw); x <= c.x + rw; x++) { const dx = x + 0.5 - c.x, dy = y + 0.5 - c.y; if (dx * dx + dy * dy <= rw * rw) put(x, y, FP.w); } }
          bits.forEach((s) => {
            const dd = c.r * (0.5 + s.v * eo(tb / 400)), x = c.x + Math.cos(s.a) * dd, y = c.y + Math.sin(s.a) * dd + 0.00004 * tb * tb;
            if (tb > 220 && bayr(Math.floor(x), Math.floor(y)) < (tb - 220) / 180) return;
            sliver(put, x, y, s.s + s.sp * tb, true, false, 1);
          });
          return true;
        });
        snd('whoosh', { g: 0.12, d: 0.36 });
        return wait(330);
      };
      /* her spell, thrown at you: it leaves her hands (they drop, and the art's own snuff flashes between them) and the
         same sphere comes at you on the screen canvas, growing on her art's grid as it nears (to a radius of 0.16 of the
         fight's column, about a third of a phone's width across), with frost streaks and a trail of frost motes behind
         it, accelerating all the way; it lands at 515 ms, as the promise
         resolves (frostBurst takes it from there) */
      const easeThrow = (x) => {   /* cubic-bezier(.6, 0, .9, .55), the old flight's curve */
        if (x <= 0) return 0; if (x >= 1) return 1;
        let lo = 0, hi = 1, s = x;
        for (let i = 0; i < 18; i++) { s = (lo + hi) / 2; const bx = 3 * (1 - s) * (1 - s) * s * 0.6 + 3 * (1 - s) * s * s * 0.9 + s * s * s; if (bx < x) lo = s; else hi = s; }
        return 3 * (1 - s) * s * s * 0.55 + s * s * s;
      };
      const throwOrb = () => {
        const S0 = orbAt(), r0 = orbR;
        m((x) => x.cast(false));
        orb(null);
        if (RM()) return Promise.resolve();
        const P = impactPt(), t0 = performance.now(), motes = [], DL = Math.hypot(P.x - S0.x, P.y - S0.y) || 1, UX = (P.x - S0.x) / DL, UY = (P.y - S0.y) / DL;
        let spawned = 0;
        pixAdd((now, p) => {
          const t = now - t0, put = p.put, r1 = Math.max(r0 + 2, fxK() * 0.16 / p.cell);
          const at = (tt) => { const u = easeThrow(Math.min(1, Math.max(0, tt / 515))); return { x: (S0.x + (P.x - S0.x) * u - p.ox) / p.cell, y: (S0.y + (P.y - S0.y) * u - p.oy) / p.cell, r: r0 + (r1 - r0) * u }; };
          const c = at(t), q0 = at(t - 16), dl = Math.hypot(c.x - q0.x, c.y - q0.y), ux = UX, uy = UY;
          if (t < 515) {
            /* frost motes shed off its back, about one every 9 ms */
            for (; spawned < t / 9; spawned++) {
              const side = (vr() - 0.5) * 1.6 * c.r, back = c.r * (0.4 + vr() * 0.5);
              motes.push({ x: c.x - ux * back - uy * side, y: c.y - uy * back + ux * side, vx: -uy * (vr() - 0.5) * 0.02 - ux * 0.004, vy: ux * (vr() - 0.5) * 0.02 - uy * 0.004 + 0.003, b: now, life: 260 + vr() * 200, big: c.r > 16 && vr() < 0.5 });
            }
          }
          /* the motes: white, then pale, then blue, then thinning away */
          for (let i = motes.length - 1; i >= 0; i--) {
            const q = motes[i], a = (now - q.b) / q.life;
            if (a >= 1) { motes.splice(i, 1); continue; }
            const x = q.x + q.vx * (now - q.b), y = q.y + q.vy * (now - q.b);
            if (a > 0.55 && bayr(Math.floor(x), Math.floor(y)) < (a - 0.55) / 0.45) continue;
            const col = a < 0.2 ? FP.w : a < 0.45 ? FP.b : a < 0.7 ? FP.m : FP.d;
            put(x, y, col); if (q.big) { put(x + 1, y, col); put(x, y + 1, col); put(x + 1, y + 1, a < 0.45 ? FP.m : FP.d); }
          }
          if (t < 515) {
            frostTrail(put, c, ux, uy, dl, 7);
            frostSphere(put, c.x, c.y, c.r, { lvl: 0.06, arm: -1, rot: -Math.PI / 2 + Math.floor(t / 50) * Math.PI / 12 });
            if (c.r > 3) frostCracks(put, c.x, c.y, c.r, Math.floor(t / 60), 2, FP.w, 9, 6);
          }
          return t < 515 || motes.length > 0;
        });
        snd('whoosh', { g: 0.2, d: 0.6 });
        return wait(515);
      };

      const shatter = () => {
        if (RM()) return;
        const q = herPt(0.5, 0.45);
        const s = put('lbf-shards', q.x, q.y, null, null);
        for (let i = 0; i < 70; i++) {
          const e = document.createElement('i'), a = vr() * Math.PI * 2, d = 60 + vr() * Math.max(260, q.w * 0.7);
          e.style.setProperty('--x', Math.round(Math.cos(a) * d) + 'px'); e.style.setProperty('--y', Math.round(Math.sin(a) * d) + 'px'); e.style.setProperty('--r', Math.round(vr() * 720 - 360) + 'deg');
          e.style.animationDelay = Math.round(vr() * 80) + 'ms'; s.append(e);
        }
        drop(s, 1800);
      };
      /* the frost left in the air: motes rise off her counter through her stage only, so they never drift across a bar,
         a line or a button */
      const moteRise = () => {
        if (RM() || motes) return;
        motes = [];
        const sb = box(stage), w = sb.w || vw(), h = sb.h || vh() * 0.5, l = sb.w ? sb.l : 0, t = sb.h ? sb.t : vh() * 0.2;
        for (let i = 0; i < 22; i++) {
          const s = put('lbf-mote', l + w * (0.06 + vr() * 0.88), t + h * (0.78 + vr() * 0.2), null, null);
          s.style.setProperty('--d', (4 + vr() * 4).toFixed(2) + 's'); s.style.setProperty('--w', (vr() * 4).toFixed(2) + 's'); s.style.setProperty('--dx', Math.round((vr() - 0.5) * 60) + 'px');
          s.style.setProperty('--rise', -Math.round(h * (0.62 + vr() * 0.3)) + 'px');
          motes.push(s);
        }
      };
      const motesOff = () => { if (motes) { motes.forEach((s) => s.remove()); motes = null; } };
      /* the win: a copy of her art's own pixels with her cut out (art x 56 to 136, above the counter top at y 109), laid
         over the art so only her figure fades. The shelf's ends, the tankard, the coins and the snuffed candle stay. Her
         slumped hands (art x 66 to 89 and 111 to 132, rows 109 to 128, fingers hooked over the front lip) are painted
         over with the counter itself: the front planks repeat every 16 pixels, so rows 117 on come from 32 pixels to the
         side (clear of the tankard, the coins and the candle); the counter top's rows (mostly under the ice) take the
         grain of one clean column beside them */
      const counterOnly = () => {
        try {
          const c = mEl.querySelector('canvas.qoart-matron') || mEl.querySelector('canvas');
          if (!c || !c.width || !c.height || posEl.querySelector('.lbf-cnt')) return;
          const k = c.width / 192, W = c.width, H = c.height, s = document.createElement('canvas');
          s.width = W; s.height = H; s.className = 'lbf-cnt'; s.setAttribute('aria-hidden', 'true');
          const g = s.getContext('2d'); if (!g) return;
          g.drawImage(c, 0, 0);
          if (Number.isInteger(k) && k >= 1) {
            const im = g.getImageData(0, 0, W, H), d = new Uint32Array(im.data.buffer), o0 = d.slice();
            const cp = (sx, sy, x, y) => { for (let j = 0; j < k; j++) for (let i = 0; i < k; i++) d[(y * k + j) * W + x * k + i] = o0[(sy * k + j) * W + sx * k + i]; };
            for (let y = 109; y < 129; y++) {
              for (let x = 66; x < 90; x++) cp(y >= 117 ? x - 32 : 64, y, x, y);
              for (let x = 111; x < 133; x++) cp(y >= 117 ? x + 32 : 134, y, x, y);
            }
            g.putImageData(im, 0, 0);
          }
          g.clearRect(Math.round(56 * k), 0, Math.round(80 * k), Math.round(109 * k));
          mEl.after(s);
        } catch (e) { /* the art is a nicety */ }
      };

      /* ---- damage, both ways ---- */
      /* a charged spell stays lit in her hands until it is cast or broken (a blow puts the art's glow out) */
      const relight = () => { if (S.charge >= 2 && !S.broken && S.her > 0) m((x) => x.cast(true)); };
      const hurtHer = (n, big, light) => {
        if (light) { barHit(herBar, false); pop('her', '-' + n, 'is-her'); }
        else { m((x) => x.hit()); flinchHer(big); shake(big); pop('her', '-' + n, big ? 'is-big' : 'is-her'); }
        setHer(S.her - n); if (S.her > 0) later(relight, T(380));
      };
      /* a blow lands on you: kind 'blow', 'crit' or 'spell' */
      const hurtYou = (n, kind) => {
        const P = impactPt(), sp = kind === 'spell';
        edgeFlash();
        /* her spell bursts in pixels on her art's grid (its own cracks, ring, slivers and light); her blows crack and flash */
        if (sp) frostBurst(P);
        else { crack(P, kind === 'crit' ? 1.15 : 1); burst(P, fxK() * 0.55, 'rgba(255,110,100,.7)'); flash('rgba(239,68,68,.3)', 480); }
        shake(sp || kind === 'crit');
        barHit(youBar, sp || kind === 'crit');
        pop('you', '-' + n, sp ? 'is-you is-spell' : 'is-you');
        setYou(S.you - n);
        buzz(sp ? [30, 40, 60] : kind === 'crit' ? [24, 30, 40] : 28);
        snd('hammer'); snd('fumble'); if (sp) snd('heart');
      };

      /* the real dice, the caller's numbers (QODice shows what the rules already rolled) */
      const roll = async (vals, skin, keep) => {
        if (over) return;
        if (!keep) sum('');
        dEl.classList.remove('is-idle');
        snd('dice');
        if (window.QODice && typeof QODice.rollMany === 'function') {
          dEl.classList.remove('is-text');
          /* QODice sizes a set of dice once; a box that changed since (a turned phone, a longer line) gets new ones */
          const bx = dEl.clientWidth + 'x' + dEl.clientHeight;
          if (bx !== diceBox) { diceBox = bx; try { if (QODice.clear) QODice.clear(dEl); } catch (e) { /* fine */ } }
          try { await QODice.rollMany(dEl, vals.map((v) => ({ sides: v[0], result: v[1] })), { skin, reduced: RM(), duration: hurry ? 600 : 1050 }); } catch (e) { /* the numbers still count */ }
        } else { dEl.classList.add('is-text'); dEl.textContent = vals.map((v) => v[1]).join(' + '); await beat(600); }
      };
      const check = (r, add, need) => (r === 20 ? 'A natural 20' : r === 1 ? 'A natural 1' : (add ? r + ' + ' + add + ' = ' + (r + add) : String(r)) + ', needs ' + need);
      /* the choices: cards in a row, the recommended one gold, the first keyboard focus on it. A pick lights up and the
         others fade (a tap within a moment of skipping the opening is the skip's own second tap, so it waits) */
      const btn = (list, mainAt) => new Promise((r) => {
        act.textContent = '';
        /* titles line up at the top only when a card in the row has a small line under its title (the CSS above) */
        act.classList.toggle('has-sub', list.some((x) => !!x.sub));
        phase = 'choose:' + list.map((x) => x.label).join('|'); main = mainAt || 0; hurry = false;
        /* a real choice: the last round's dice and sum fade after a moment, so the cards are the thing to read (under
           reduced motion the round's beats stay together until the pick, as the header says) */
        if (list.length > 1 && !RM()) later(() => { if (phase.indexOf('choose') === 0) { dEl.classList.add('is-idle'); sum(''); } }, 700);
        let picked = false;
        const bs = list.map((it, k) => {
          const b = document.createElement('button'); b.type = 'button';
          b.className = 'lbf-b' + (k === (mainAt || 0) ? ' is-main' : '') + (list.length === 1 ? ' is-solo' : '') + (it.cls ? ' ' + it.cls : '') + (it.arrive && !RM() ? ' is-arrive' : '');
          if (!(it.arrive && !RM())) b.style.animationDelay = (k * 50) + 'ms';
          const t = document.createElement('span'); t.className = 'lbf-bl';
          if (it.icon && ICON[it.icon]) t.innerHTML = ICON[it.icon];
          t.append(document.createTextNode(it.label)); b.append(t);
          if (it.sub) { const s = document.createElement('small'); s.textContent = it.sub; b.append(s); }
          /* its first offer: the card rises a beat after the others (CSS), a light sweeps across it, and a soft chime
             plays as it comes up (reduced motion: the chime alone, at once) */
          if (it.arrive) {
            if (!RM()) { const sw = document.createElement('i'); sw.className = 'lbf-sweep'; sw.setAttribute('aria-hidden', 'true'); b.append(sw); }
            later(handChime, T(320) || 1);
          }
          b.addEventListener('click', () => {
            if (over || picked || !act.contains(b)) return;
            if (Date.now() - skipAt < 350) return;
            picked = true;
            try { if (window.FFSound && FFSound.wake) FFSound.wake(); } catch (e) { /* fine */ }
            snd('tap'); buzz(8); phase = 'busy';
            /* the keyboard focus waits on the row of choices while the round plays (never on the page behind), and moves
               to the next choice's gold card when it appears */
            try { if (!document.activeElement || document.activeElement === document.body || o.contains(document.activeElement)) act.focus({ preventScroll: true }); } catch (e) { /* fine */ }
            if (RM()) act.textContent = '';
            else { b.style.animationDelay = '0ms'; bs.forEach((x) => x.classList.add(x === b ? 'is-picked' : 'is-out')); later(() => { if (act.contains(b)) act.textContent = ''; }, 280); }
            r(k);
          });
          act.append(b); return b;
        });
        /* the first choice takes the focus from whatever opened the fight; later ones keep it inside the fight */
        const f = bs[mainAt || 0] || bs[0], ae = document.activeElement;
        if (f && (firstFocus || !ae || ae === document.body || o.contains(ae))) { firstFocus = false; try { f.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
      });

      /* ---- the opening: she casts the tavern over the library ---- */
      /* the reveal: the tavern's own canvas, copied each frame through a dither mask that opens from her hands outward,
         with a pale front where the library is coming apart; the room stays live under it until it's gone */
      const BAY = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
      const tavIn = () => { o.classList.add('is-tav'); };
      const dissolve = (ox, oy, dur) => new Promise((done) => {
        const tav = tavCanvas();
        let g = null;
        try { g = tav && tav.width > 4 && !RM() ? document.createElement('canvas').getContext('2d') : null; } catch (e) { g = null; }
        if (!g || over) { tavIn(); done(); return; }
        const W = tav.width, H = tav.height, rv = document.createElement('canvas'), mk = document.createElement('canvas'), fr = document.createElement('canvas');
        rv.className = 'lbf-rv'; rv.width = mk.width = fr.width = W; rv.height = mk.height = fr.height = H;
        ['left', 'top', 'width', 'height', 'imageRendering'].forEach((k) => { try { rv.style[k] = tav.style[k]; } catch (e) { /* fine */ } });
        const rg = rv.getContext('2d'), mg = mk.getContext('2d'), fg = fr.getContext('2d');
        if (!rg || !mg || !fg) { tavIn(); done(); return; }
        const mI = mg.createImageData(W, H), fI = fg.createImageData(W, H), m32 = new Uint32Array(mI.data.buffer), f32 = new Uint32Array(fI.data.buffer);
        const r = tav.getBoundingClientRect(), gx = (ox - r.left) / Math.max(1, r.width) * W, gy = (oy - r.top) / Math.max(1, r.height) * H;
        const th = new Float32Array(W * H);
        let mx = 1;
        for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) { const dx = x - gx, dy = y - gy, dd = Math.sqrt(dx * dx + dy * dy); th[y * W + x] = dd; if (dd > mx) mx = dd; }
        for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
          const i = y * W + x, hsh = (((x >> 1) * 73856093) ^ ((y >> 1) * 19349663)) >>> 0;
          th[i] = th[i] / mx * 0.82 + BAY[(y & 3) * 4 + (x & 3)] / 16 * 0.12 + (hsh % 997) / 997 * 0.06;
        }
        const ICE = 0x9cffe6c4, CORE = 0xf0ffffff;          /* ABGR: a pale ice front with a white edge */
        const wave = document.createElement('span'); wave.className = 'lbf-wave';
        const reach = Math.hypot(Math.max(ox, vw() - ox), Math.max(oy, vh() - oy)) * 2;
        wave.style.left = (ox - reach / 2) + 'px'; wave.style.top = (oy - reach / 2) + 'px'; wave.style.width = wave.style.height = reach + 'px'; wave.style.transform = 'scale(0)';
        bgEl.after(rv); rv.after(wave);
        const t0 = performance.now();
        const finish = () => {
          if (!dis) return;
          cancelAnimationFrame(dis.raf); dis = null;
          tavIn(); rv.remove(); wave.remove(); done();
        };
        const step = (now) => {
          if (!dis) return;
          if (over || tav.width !== W || tav.height !== H || !tav.isConnected) { finish(); return; }
          const u = Math.min(1, (now - t0) / dur), e = u < 0.5 ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2, pr = e * 1.1 - 0.02;
          for (let i = 0, n = W * H; i < n; i++) {
            const v = th[i];
            if (v < pr - 0.034) { m32[i] = 0xff000000; f32[i] = 0; } else if (v < pr) { m32[i] = 0xff000000; f32[i] = v > pr - 0.01 ? CORE : ICE; } else { m32[i] = 0; f32[i] = 0; }
          }
          mg.putImageData(mI, 0, 0); fg.putImageData(fI, 0, 0);
          rg.globalCompositeOperation = 'copy'; rg.drawImage(tav, 0, 0);
          rg.globalCompositeOperation = 'destination-in'; rg.drawImage(mk, 0, 0);
          rg.globalCompositeOperation = 'source-over'; rg.drawImage(fr, 0, 0);
          wave.style.transform = 'scale(' + Math.max(0, pr * 0.62).toFixed(3) + ')'; wave.style.opacity = String(Math.max(0, 1 - u * 0.9).toFixed(2));
          if (u >= 1) { finish(); return; }
          dis.raf = requestAnimationFrame(step);
        };
        dis = { raf: requestAnimationFrame(step), finish };
      });
      /* the floor tips you over before each Roll to stand, and the view rises with the roll */
      const floor = (on) => { o.classList.toggle('is-floor', !!on); };
      /* ---- her in the dark. Jan (2026-10-08): "when the encounter opens, it needs to start with this black with red eyes
         silhouette you clicked on, then turn into the old lady, then she does this cool spell thing, so it makes sense you
         are fighting the same thing you clicked on", then "basically the black siloutte and red eyes is just her in the
         dark once shes up close its still the old lady". So nothing magic happens to her: the shape in the room is her
         with no light on her, and she walks out of the dark into the light.
         The dark is her own live pixels in her figure's box (art x 52 to 141, down to the counter top at y 109), each one
         black, a broken rim of the room's cold light round her edge (brighter on the left, the door's side, as the room
         draws her), the dark she stands in pooling below her, and only her eyes catching the light, red (her art's menace
         look, read off its pixels) with a dark red bloom round them. Redrawn every frame from the art, so it breathes with
         her. light(ms) lifts the dark off her in a dither: her hands and body first, her face last and her eyes very
         last, while her art (and her counter) comes up underneath. Her eyes are held as they were when the light reached
         her, so they fade with the dark instead of going out when the art's menace look ends ---- */
      function darkOf() {
        const c = mEl.querySelector('canvas.qoart-matron') || mEl.querySelector('canvas');
        if (!c || !c.width || !c.height) return null;
        const W = 192, H = 144, X0 = 52, X1 = 141, CUT = 109, EYE_Y = 64;
        const s = document.createElement('canvas'); s.width = W; s.height = H; s.className = 'lbf-dark'; s.setAttribute('aria-hidden', 'true');
        const t = document.createElement('canvas'); t.width = W; t.height = H;
        const g = s.getContext('2d'), tg = t.getContext('2d', { willReadFrequently: true });
        if (!g || !tg) return null;
        tg.imageSmoothingEnabled = false;
        const out = g.createImageData(W, H), o32 = new Uint32Array(out.data.buffer);
        const BAY = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
        const bay = (x, y) => (BAY[(y & 3) * 4 + (x & 3)] + 0.5) / 16;
        const hsh = (x, y) => { let h = (x * 374761393 + y * 668265263) | 0; h = Math.imul(h ^ (h >>> 13), 1274126177); return ((h ^ (h >>> 16)) >>> 0) / 4294967296; };
        const px = (r, gg, b) => ((255 << 24) | (b << 16) | (gg << 8) | r) >>> 0;   /* little-endian ABGR */
        const INK = px(4, 5, 9), INK2 = px(10, 11, 17), RIM_L = px(160, 178, 202), RIM_R = px(104, 122, 148);
        const EYE = px(255, 52, 40), EYE_HOT = px(255, 172, 152), BLOOM = px(74, 10, 9);
        let lit = 0, alive = true, raf = 0, held = null, odd = false, drawn = false;
        function draw() {
          raf = 0; if (!alive) return;
          /* the fight ended under it (Leave, Escape, a fault): stop drawing */
          if (over) { stop(); return; }
          /* in the dark nothing changes faster than her art does (it repaints every 80 ms or so): every other frame */
          if (!lit && drawn && (odd = !odd)) { raf = requestAnimationFrame(draw); return; }
          drawn = true;
          tg.clearRect(0, 0, W, H); tg.drawImage(c, 0, 0, W, H);
          let src;
          try { src = new Uint32Array(tg.getImageData(0, 0, W, H).data.buffer); } catch (e) { stop(); return; }
          o32.fill(0);
          const on = (x, y) => x >= X0 && x < X1 && y >= 0 && y < CUT && (src[y * W + x] >>> 24) > 40;
          /* the crown of her head, so the light reaches her face last whatever her pose */
          let top = CUT;
          for (let y = 0; y < CUT && top === CUT; y++) for (let x = X0; x < X1; x++) if (on(x, y)) { top = y; break; }
          const span = Math.max(20, CUT - top), rimTo = top + span * 0.6;
          /* a pixel stays dark while its share of the dark is above the light: low on her goes first, her face last */
          const dark = (x, y, extra) => (y - top < 0 ? 1 : 1 - (y - top) / span) * 0.55 + bay(x, y) * 0.45 + (extra || 0) > lit * 1.25;
          const red = [];
          for (let y = 0; y < H; y++) {
            for (let x = X0; x < X1; x++) {
              const i = y * W + x;
              if (!on(x, y)) {
                /* the dark she stands in, pooling below her waist and thinning as the light comes */
                if (y >= 92) {
                  const ex = (x + 0.5 - 96.5) / 46, ey = (y + 0.5 - 104) / 22;
                  const a = Math.max(0, 1 - ex * ex - ey * ey) * (y < CUT ? 1 : Math.max(0, 1 - (y - CUT) / 18)) * (1 - lit);
                  if (a > bay(x, y) * 0.9) o32[i] = a > 0.55 ? INK : INK2;
                }
                continue;
              }
              const p = src[i], r = p & 255, gg = (p >>> 8) & 255, b = (p >>> 16) & 255;
              if (!held && y < EYE_Y && r > 165 && gg < 120 && b < 120 && r - gg > 80) red.push([x, y, r + gg]);
              if (lit > 0 && !dark(x, y)) continue;
              /* the rim catches her head and shoulders; lower down she goes into the dark she stands in */
              const edge = !on(x - 1, y) || !on(x + 1, y) || !on(x, y - 1);
              o32[i] = edge && y > top + 1 && y < rimTo && hsh(x, y) > 0.2 + Math.max(0, (y - rimTo + 12) / 12) * 0.7 ? (x < 96 ? RIM_L : RIM_R) : INK;
            }
          }
          /* her two eyes catching what light there is: each side's hottest red point (her art's menace look blooms over
             several pixels; the room shows two small eyes), two pixels across with the hot one inward, a dark red
             round them. Held from the moment the light reaches her, and gone as it reaches her face: lit, they are
             only her eyes */
          const eyes = held || [0, 1].map((side) => {
            const pts = red.filter((q) => (q[0] < 96.5) === (side === 0));
            if (!pts.length) return null;
            const hot = Math.max(...pts.map((q) => q[2])), core = pts.filter((q) => q[2] >= hot - 30);
            const cx = core.reduce((a, q) => a + q[0], 0) / core.length, cy = core.reduce((a, q) => a + q[1], 0) / core.length;
            return [Math.round(cx - 0.5), Math.round(cy), side];
          }).filter(Boolean);
          /* both go out together (one dither cell each would leave one eye staring a moment), just before her face */
          const eyeY = eyes.length ? eyes.reduce((a, e) => a + e[1], 0) / eyes.length : 0;
          const eyesOut = lit > 0 && !((eyeY - top < 0 ? 1 : 1 - (eyeY - top) / span) * 0.55 + 0.225 - 0.12 > lit * 1.25);
          if (!eyesOut) eyes.forEach(([x, y, side]) => {
            for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 2; dx++) {
              const j = (y + dy) * W + x + dx; if (y + dy >= 0 && o32[j] === INK) o32[j] = BLOOM;
            }
            o32[y * W + x] = side === 0 ? EYE : EYE_HOT; o32[y * W + x + 1] = side === 0 ? EYE_HOT : EYE;
          });
          if (!held && lit > 0) held = eyes;
          g.putImageData(out, 0, 0);
          raf = requestAnimationFrame(draw);
        }
        function stop() { alive = false; if (raf) cancelAnimationFrame(raf); raf = 0; }
        mEl.appendChild(s);
        c.style.opacity = '0';
        draw();
        return {
          el: s, art: c,
          /* the eyes she has in the dark, read now (before the art's menace look is taken off) */
          hold() { if (!held && alive) { if (raf) cancelAnimationFrame(raf); lit = 0.0001; draw(); } },
          light(ms) {
            return new Promise((r) => {
              if (!alive) { r(); return; }
              const t0 = performance.now();
              const tick = () => {
                if (!alive || over) { stop(); r(); return; }
                const u = Math.min(1, (performance.now() - t0) / ms);
                lit = Math.max(lit, u); c.style.opacity = String(Math.min(1, u * 1.7).toFixed(2));
                if (u >= 1) { r(); return; }
                requestAnimationFrame(tick);
              };
              requestAnimationFrame(tick);
            });
          },
          remove() { stop(); c.style.opacity = ''; s.remove(); }
        };
      }
      async function intro() {
        phase = 'intro';
        let skipped = false;
        const pend = new Set();
        const iw = (ms) => new Promise((r) => { if (skipped || over || !ms) { r(); return; } pend.add(r); const id = setTimeout(() => { timers.delete(id); pend.delete(r); r(); }, ms); timers.add(id); });
        let mist = null, stepIn = null, dk = null;
        const darkOff = () => { o.classList.remove('is-dark'); if (dk) { dk.remove(); dk = null; } };
        skipIntro = () => { if (skipped || over || introDone) return; skipped = true; skipAt = Date.now(); pend.forEach((r) => r()); pend.clear(); if (dis) dis.finish(); darkOff(); };
        const fin = () => {
          if (introDone) return;
          introDone = true; skipIntro = null;
          darkOff(); m((x) => x.menace(false));
          tavIn();
          /* under reduced motion the tavern crossfades in over the room first */
          if (RM()) later(() => roomSleep(true), 520); else roomSleep(true);
          if (skipped) flash('rgba(190,225,255,.3)', 320);
          if (mist) { const ms = mist; mist = null; if (RM()) later(() => ms.remove(), 520); else ms.remove(); }
          if (stepIn) { try { stepIn.finish(); } catch (e) { /* fine */ } stepIn = null; }
          castFx(0); m((x) => x.cast(false));
          music('lpTo', 2200, 0.8);
          floor(true);
          o.classList.remove('is-intro');
          m((x) => x.setCup('served'));
          say(OPEN_LINES[1]);
        };
        /* she is in the dark at first (her art's menace look gives her the red eyes the dark keeps) */
        m((x) => x.menace(true));
        try { dk = darkOf(); } catch (e) { dk = null; }
        if (dk) o.classList.add('is-dark');
        /* the shape in the room is her: the same frame she appears at its place, it goes under the mist, so there is never
           two of her; then three strides from where she stood to the front, growing as she comes. Only when her place is
           on screen (a phone's room pans): otherwise she simply comes up at the front */
        let from = null;
        try {
          const sp = F.spotCss && F.spotCss('jb-matron'), art = F.art || host.querySelector('.ffs-art');
          if (sp && art) {
            const a = art.getBoundingClientRect(), rx = a.left + sp.cx, rc = a.top + sp.cy;
            if (rx >= 0 && rx <= (window.innerWidth || 0) && rc >= 0 && rc <= (window.innerHeight || 0)) {
              const w = Math.max(sp.w * 3, 80), h = Math.max(sp.h * 1.85, 130);
              mist = document.createElement('span'); mist.className = 'lbf-mist is-on'; mist.style.transition = 'none';
              mist.style.left = Math.round(rx - w / 2) + 'px'; mist.style.top = Math.round(rc - h / 2) + 'px'; mist.style.width = Math.round(w) + 'px'; mist.style.height = Math.round(h) + 'px';
              world.querySelector('.lbf-dim').after(mist);
              /* lined up by her eyes: the room's shape has them 7.4 of its 42 units below its top (moods.js matronFig), her
                 art at row 28 of 144; the front shows her to the counter top (rows 8 to 109), the top 56% of her in the room */
              const b = posEl.getBoundingClientRect();
              if (!RM() && b.width > 0 && b.height > 0) {
                const ry = a.top + sp.cy - sp.h / 2 + sp.h * (7.4 / 42), hx = b.left + b.width * (96.5 / 192), hy = b.top + b.height * (28 / 144);
                from = { dx: rx - hx, dy: ry - hy, sc: Math.min(1, Math.max(0.04, (sp.h * 0.56) / (b.height * (101 / 144)))) };
              }
            }
          }
        } catch (e) { if (mist) mist.remove(); mist = null; from = null; }
        if (RM()) {
          /* reduced motion: her in the dark at the front, a plain crossfade as the light finds her, and only then the
             tavern (fin), so her dark is only ever seen over the library */
          say(OPEN_LINES[0]);
          if (!dk) { fin(); return; }
          const d = dk; dk = null; d.hold(); m((x) => x.menace(false));
          await iw(650); if (over) return;
          o.classList.remove('is-dark'); d.el.style.transition = 'opacity .45s ease'; d.el.style.opacity = '0'; d.art.style.transition = 'opacity .45s ease'; d.art.style.opacity = '1';
          await iw(500); d.art.style.transition = ''; d.remove(); if (over) return;
          fin(); return;
        }
        if (from) {
          const org = (96.5 / 192 * 100).toFixed(2) + '% ' + (28 / 144 * 100).toFixed(2) + '%';
          const tf = (u) => 'translate(' + (from.dx * (1 - u)).toFixed(1) + 'px, ' + (from.dy * (1 - u)).toFixed(1) + 'px) scale(' + Math.pow(from.sc, 1 - u).toFixed(4) + ')';
          const stride = 'cubic-bezier(.45, 0, .3, 1)';
          stepIn = anim(posEl, [
            { offset: 0, opacity: 1, transform: tf(0), transformOrigin: org, easing: 'ease-out' },
            { offset: 0.1, opacity: 1, transform: tf(0.02), transformOrigin: org, easing: stride },
            { offset: 0.4, opacity: 1, transform: tf(0.26), transformOrigin: org, easing: stride },
            { offset: 0.7, opacity: 1, transform: tf(0.6), transformOrigin: org, easing: stride },
            { offset: 1, opacity: 1, transform: 'none', transformOrigin: org }
          ], { duration: 1700, delay: 150, fill: 'backwards' });
        } else {
          stepIn = anim(posEl, [{ opacity: 0, transform: 'translateY(4%) scale(.9)' }, { opacity: 1, transform: 'none' }], { duration: 900, delay: 200, easing: 'cubic-bezier(.2,.8,.3,1)', fill: 'backwards' });
        }
        await iw(150); if (over) return; if (skipped) { fin(); return; }
        snd('whoosh', { g: 0.05, d: 1.6 }); music('lpTo', 900, 1.2);
        /* her footfalls on the boards, one at the end of each stride */
        if (from) { later(() => { if (!introDone) snd('land'); }, 170 + 380); later(() => { if (!introDone) snd('land'); }, 170 + 900); later(() => { if (!introDone) snd('land'); }, 170 + 1400); }
        await iw(from ? 1700 : 900); if (over) return; if (skipped) { fin(); return; }
        /* up close, still in the dark: her eyes on you a breath */
        snd('heart'); buzz(10); music('lpTo', 650, 0.8);
        await iw(750); if (over) return; if (skipped) { fin(); return; }
        /* the light finds her: the old woman, nothing more (her eyes are her own again) */
        if (dk) { dk.hold(); m((x) => x.menace(false)); o.classList.remove('is-dark'); snd('candle', { warm: true }); await dk.light(950); darkOff(); }
        else m((x) => x.menace(false));
        if (over) return; if (skipped) { fin(); return; }
        await iw(380); if (over) return; if (skipped) { fin(); return; }
        m((x) => x.cast(true)); castFx(1); snd('ring'); music('lpTo', 650, 1.4);
        await iw(320); if (over) return; if (skipped) { fin(); return; }
        say(OPEN_LINES[0]);
        await iw(2600); if (over) return; if (skipped) { fin(); return; }
        castFx(2); snd('chime'); snd('whoosh', { g: 0.18, d: 1.6 }); flash('rgba(190,225,255,.32)', 420); buzz(14);
        const P = herPt(0.5, 0.57);
        await dissolve(P.x, P.y, 1500); if (over) return;
        fin();
        if (!skipped) { shake(true); snd('hammer'); snd('heart'); buzz([20, 30, 40]); }
      }

      /* ---- her turn ---- */
      async function herTurn() {
        if (over || S.her <= 0 || S.you <= 0) return;
        phase = 'her';
        await beat(500); if (over) return;
        if (S.charge >= 2) {
          /* her hands hold the spell up through the surge and drop as she throws it (throwOrb) */
          S.charge = 0;
          if (S.broken) { m((x) => x.cast(false)); S.broken = false; sum(''); dEl.classList.add('is-idle'); orbFizzle(); say('The spell comes apart in her hands.'); snd('miss'); intent(); await beat(1100); return; }
          say('The spell is ready.'); m((x) => x.menace(true)); orb('surge'); posEl.classList.add('is-lunge'); snd('heart'); await beat(700); if (over) return;
          const a = rnd(6), b = rnd(6); await roll([[6, a], [6, b]], 'obsidian'); if (over) return;
          const raw = a + b + FIGHT.spellB, dm = S.shield ? Math.ceil(raw / 2) : raw;
          sum(a + ' + ' + b + ' + ' + FIGHT.spellB + ' = ' + raw + (S.shield ? ', halved to ' + dm : '') + ' damage', 'no');
          await throwOrb(); if (over) return;
          if (S.shield) ward('break');
          say(S.shield ? 'Cold slams into your guard. Half of it gets through.' : 'Cold pours through you.'); hurtYou(dm, 'spell');
          m((x) => x.menace(false)); posEl.classList.remove('is-lunge'); S.shield = false; showGuard(curGuard(), false); intent(); await beat(1100); return;
        }
        const kind = Math.floor(vr() * SWINGS.length), sw = SWINGS[kind];
        say(sw.go); m((x) => x.menace(true)); if (!RM()) posEl.classList.add('is-lunge');
        const r1 = rnd(20), r2 = S.tricked ? rnd(20) : null;
        await roll(r2 != null ? [[20, r1], [20, r2]] : [[20, r1]], 'obsidian'); if (over) return;
        const r = r2 != null ? Math.min(r1, r2) : r1, wild = r2 != null; S.tricked = false;
        const guard = curGuard(), hit = r === 20 || (r !== 1 && r + FIGHT.herHit >= guard);
        /* the sum, a beat at a time: her two wild dice and which one counts, then the roll against your guard */
        if (wild && r1 !== r2) { sum(r1 + ' and ' + r2 + ', the lower counts', 'ok'); await beat(650); if (over) return; }
        sum((r === 20 ? 'A natural 20' : r === 1 ? 'A natural 1' : r + ' + ' + FIGHT.herHit + ' = ' + (r + FIGHT.herHit)) + ', your guard ' + guard, hit ? 'no' : 'ok');
        if (hit) {
          await beat(200); if (over) return;
          const a = rnd(FIGHT.blow), c = r === 20 ? rnd(FIGHT.blow) : 0;
          await roll(c ? [[6, a], [6, c]] : [[6, a]], 'obsidian', true); if (over) return;
          const dm = a + c + FIGHT.blowB;
          sum(a + (c ? ' + ' + c : '') + ' + ' + FIGHT.blowB + ' = ' + dm + ' damage', 'no');
          await herBlow(kind, true); if (over) return;
          if (S.shield) ward('break');
          say(r === 20 ? 'She finds the gap in your guard.' : sw.hit); hurtYou(dm, r === 20 ? 'crit' : 'blow');
        } else {
          const onWard = S.shield && wardEl.classList.contains('is-on');
          await herBlow(kind, false, onWard && !RM() ? wardPt() : null); if (over) return;
          if (S.shield) ward('flare');
          const sp = blowAt || impactPt(); spark(sp); burst(sp, fxK() * 0.3, 'rgba(255,214,140,.7)'); blowAt = null; snd('latch'); snd('miss');
          say(S.shield ? sw.ward : wild ? sw.wild : sw.miss);
        }
        m((x) => x.menace(false)); posEl.classList.remove('is-lunge');
        S.shield = false; showGuard(curGuard(), false); S.charge++; intent();
        if (S.charge === 2 && S.you > 0) {
          await beat(800); if (over) return;
          /* the telegraph: her spell is the one thing to read, so last swing's dice and sum go */
          if (!RM()) { sum(''); dEl.classList.add('is-idle'); }
          say('Her hands move.'); m((x) => x.cast(true)); orb('on'); snd('ring'); intent(true);
        }
        await beat(700);
      }

      /* ---- your turn ---- */
      async function yourTurn() {
        if (over) return;
        const canHand = !S.hand && S.you <= FIGHT.handYou;
        if (canHand) { warmClip('catch'); warmClip('bolt'); }
        if (S.her <= 14) warmClip('shatter');
        const charged = S.charge >= 2 && !S.broken;
        const list = [
          canHand ? { k: 'hand', label: 'Roll with the hand', sub: 'Only once', cls: 'is-hand', icon: 'hand', arrive: !handSeen } : { k: 'strike', label: 'Strike', sub: '2d6' + (B.mem ? ' + 2' : '') + ' damage', icon: 'strike' },
          { k: 'trick', label: 'Trick', sub: charged ? 'Breaks her spell' : 'Throws her off', icon: 'trick' },
          { k: 'shield', label: 'Shield', sub: (charged ? 'Halves her spell' : '+5 guard') + ', heal 1d6', icon: 'shield' }
        ];
        if (canHand) handSeen = true;   /* only its first offer in a fight gets the entrance (btn() below) */
        /* the gold card (the header's "careful play"): while the hand is offered and her spell is charged with her above
           12, Shield, since the hand (8 to 12) can't finish her and the spell (5 to 15) could finish you */
        main = canHand ? (charged && S.her > 12 ? 2 : 0) : charged ? (S.you < 14 ? 2 : 1) : 0;
        const pick = await btn(list, main); if (over) return;
        const k = list[pick].k;
        newRound();
        if (k === 'strike') {
          say('You go for her.'); const r = rnd(20); await roll([[20, r]], 'gold'); if (over) return;
          const hitSum = check(r, S.hit, FIGHT.toHit), ok = r === 20 || (r !== 1 && r + S.hit >= FIGHT.toHit);
          sum(hitSum, ok ? 'ok' : 'no');
          if (r === 1) {
            say('Your boot slips on the wet boards.'); snd('fumble');
            an(stage, [{ transform: 'none' }, { transform: 'translateY(4%) rotate(1.5deg)', offset: 0.3 }, { transform: 'none' }], { duration: 520, easing: 'ease-out' });
          } else if (ok) {
            /* the d20's face stays a beat, and its sum stays up while the damage dice roll */
            await beat(220); if (over) return;
            const vs = Array.from({ length: r === 20 ? 4 : 2 }, () => rnd(6));
            await roll(vs.map((v) => [6, v]), 'gold', true); if (over) return;
            const dm = vs.reduce((a, b) => a + b, 0) + (B.mem ? FIGHT.mem : 0);
            sum(vs.join(' + ') + (B.mem ? ' + ' + FIGHT.mem : '') + ' = ' + dm + ' damage', 'ok');
            await slashHer(r === 20, false); if (over) return;
            say(r === 20 ? 'A clean hit, with everything behind it.' : 'It lands.'); snd(r === 20 ? 'crit' : 'hammer'); buzz(r === 20 ? [18, 40, 26] : 18); hurtHer(dm, r === 20);
            if (r === 20) flash('rgba(255,244,214,.4)', 420);
          } else { await slashHer(false, true); if (over) return; dodge(); say('She turns it aside.'); snd('miss'); }
        } else if (k === 'trick') {
          say('You feint, then go low.'); const r = rnd(20); await roll([[20, r]], 'gold'); if (over) return;
          const ok = r === 20 || (r !== 1 && r + S.hit >= FIGHT.trickAt);
          sum(check(r, S.hit, FIGHT.trickAt), ok ? 'ok' : 'no');
          if (ok) {
            await beat(200); if (over) return;
            const v = rnd(6); await roll([[6, v]], 'gold', true); if (over) return;
            sum(v + ' damage', 'ok');
            await feint(); if (over) return;
            hurtHer(v, false, true); snd('land');
            /* her hands stay round the dying spell until her turn, when they drop with its end (herTurn) */
            if (S.charge >= 2) { S.broken = true; orb('weak'); say('You catch her wrists. The spell slips.'); }
            else { S.tricked = true; say('She stumbles. Her next swing will be wild.'); }
            intent(true);
          } else { say('She doesn’t fall for it.'); snd('miss'); m((x) => x.menace(true)); later(() => { if (phase !== 'her') m((x) => x.menace(false)); }, T(700) || 1); }
        } else if (k === 'shield') {
          /* the Shield spell's way: a flat +5 to your guard for her next attack, then a rolled heal */
          S.shield = true; say('You raise your guard.'); ward('on'); showGuard(curGuard(), true); buzz(10);
          await beat(650); if (over) return;
          /* the die shows its roll; the big green number shows only what you actually get back (none at full), and one
             short line says it (the badge already shows the guard) */
          const v = rnd(FIGHT.heal); await roll([[6, v]], 'gold'); if (over) return;
          const got = Math.min(FIGHT.you, S.you + v) - S.you;
          sum('');
          setYou(S.you + got);
          say(got === v ? 'You catch your breath.' : got > 0 ? 'You catch your breath, back to full.' : 'You’re already at full health.');
          if (got > 0) { pop('you', '+' + got, 'is-heal'); an(youBar.f, [{ filter: 'brightness(1)' }, { filter: 'brightness(1.8) hue-rotate(-20deg)', offset: 0.3 }, { filter: 'brightness(1)' }], { duration: 520 }); }
          snd('pass');
        } else {
          /* the hand: Jan's save, timed as the Quest times it (her Catch, the bolt 300 ms on, landing with the impact) */
          S.hand = true; say('A hand you cannot see lands on your shoulder.'); await beat(1000); if (over) return;
          say('“Catch.”'); o.classList.add('is-myth'); clip('catch', 'ring'); music('duck', true); later(() => music('duck', false), 1800); buzz(15);
          await wait(T(300)); if (over) return;
          let landed = false;
          const land = () => { if (landed || over) return; landed = true; clip('bolt', 'hammer'); };
          let flight = Promise.resolve();
          try { if (M && typeof M.smite === 'function') flight = M.smite() || flight; } catch (e) { /* fine */ }
          if (!RM()) later(land, 380);
          await flight; if (over) return;
          land(); m((x) => x.stun(true)); shake(true); flash('rgba(239,148,255,.32)', 520); buzz([20, 40, 60]);
          if (!RM()) { const q = herPt(0.42, 0.3); burst({ x: q.x, y: q.y }, q.w * 0.5, 'rgba(239,148,255,.7)'); ringWave({ x: q.x, y: q.y }, q.w * 1.2, '#b3f5ee'); }
          const a = 3 + rnd(3), b = 3 + rnd(3); await roll([[6, a], [6, b]], 'mythic'); if (over) return;
          sum(a + ' + ' + b + ' = ' + (a + b) + ' damage', 'ok');
          snd('crit'); buzz(30); hurtHer(a + b, true); await beat(700); if (over) return;
          m((x) => x.stun(false)); o.classList.remove('is-myth'); relight();
        }
        await beat(700);
      }

      /* ---- one fight, start to end (Face her again runs it once more) ---- */
      async function fight(again) {
        B = bonus();
        S = { you: FIGHT.you, her: FIGHT.her, charge: 0, shield: false, tricked: false, broken: false, hand: false, hit: B.road ? FIGHT.road : 0, clean: false };
        phase = introDone ? 'stand' : 'intro';
        setHer(FIGHT.her); setYou(FIGHT.you); handSeen = false; bon.classList.remove('is-off'); chips(); intent(); newRound(); sum(''); showGuard(baseGuard(), false);
        o.classList.remove('is-down', 'is-low', 'is-myth', 'is-won'); posEl.classList.remove('is-gone', 'is-near', 'is-lunge'); eyes(null); orb(null); ward(null); motesOff();
        posEl.querySelectorAll('.lbf-cnt').forEach((c) => c.remove());
        m((x) => { x.setState('matron'); x.menace(false); x.cast(false); x.stun(false); });
        if (!introDone) { await intro(); if (over) return; }
        else { floor(true); m((x) => x.setCup('served')); say(again ? MATRON_LINES[1] : OPEN_LINES[1]); }
        phase = 'stand';
        await beat(skipAt && Date.now() - skipAt < 1000 ? 0 : 1200); if (over) return;
        await btn([{ label: 'Roll to stand', sub: '15 or more rises clean', icon: 'd20' }]); if (over) return;
        newRound(); phase = 'stand';
        m((x) => x.setCup('held'));
        const r = rnd(20); await roll([[20, r]], 'gold'); if (over) return;
        floor(false);
        sum(r + (r >= FIGHT.rise ? ', a clean rise' : r >= FIGHT.stand ? ', on your feet' : ', needs ' + FIGHT.stand), r >= FIGHT.stand ? 'ok' : 'no');
        let herFirst = false;
        if (r >= FIGHT.rise) { S.hit += FIGHT.clean; S.clean = true; chips('clean'); say('A clean rise. +2 to hit.'); snd('pass'); flash('rgba(244,214,138,.35)', 600); }
        else if (r >= FIGHT.stand) { say('You’re on your feet first.'); snd('land'); }
        else { say('Not enough to stand. She moves first.'); snd('miss'); herFirst = true; }
        phase = 'fight'; intent(true);
        await beat(1000); if (over) return;
        if (!herFirst && !again) { say(MATRON_LINES[0]); await beat(1300); if (over) return; }
        if (herFirst) await herTurn();
        while (!over && S.you > 0 && S.her > 0) { await yourTurn(); if (over || S.her <= 0) break; await herTurn(); }
        if (over) return;
        phase = S.her <= 0 ? 'won' : 'lost'; intent();
        orb(null); ward(null); posEl.classList.remove('is-lunge');
        if (S.her <= 0) {
          m((x) => { x.stun(false); x.cast(false); x.menace(false); x.setState('fallen'); });
          await beat(1000); if (over) return;
          counterOnly();
          /* the end screens carry no bonus chips: they go under the white flash (and as you fall, below), where the
             panel closing up is never seen */
          flash('rgba(255,255,255,.95)', 900); shatter(); clip('shatter', 'pop'); buzz([20, 40, 60]); say('She breaks like ice.'); posEl.classList.add('is-gone'); bon.classList.add('is-off');
          sum(''); dEl.classList.add('is-idle'); o.classList.remove('is-low'); o.classList.add('is-won'); music('lpTo', 18000, 2.5); moteRise();
          await beat(1400); if (over) return;
          snd('lights');
          sum('You won with ' + S.you + ' health left', 'ok');
          await btn([{ label: 'Back to the library', icon: 'back' }]); end('won');
        } else {
          sum(''); dEl.classList.add('is-idle'); o.classList.add('is-down'); floor(true); bon.classList.add('is-off'); say('You fall.'); snd('heart'); buzz([30, 120, 30]); m((x) => { x.cast(false); x.menace(true); }); eyes('red');
          await beat(1300); if (over) return;
          posEl.classList.add('is-near'); snd('heart');
          say(MATRON_LINES[2]);
          const k = await btn([{ label: 'Face her again', icon: 'again' }, { label: 'Back to the library', icon: 'back' }]); if (over) return;
          if (k === 0) fight(true).catch(fault); else end('lost');
        }
      }

      /* ---- the way out: a result, then the overlay fades (or goes at once for close()) ---- */
      function end(result, now) {
        if (over) return;
        /* once the fight is decided, every way out carries the result (Leave, Escape, close(), a fault) */
        if (result === 'left' && S) { if (S.her <= 0) result = 'won'; else if (S.you <= 0) result = 'lost'; }
        over = true; phase = 'done';
        timers.forEach((id) => clearTimeout(id)); timers.clear();
        if (dis) { try { dis.finish(); } catch (e) { /* fine */ } }
        cancelAnimationFrame(guardAnim); runeStop(); cancelAnimationFrame(orbRaf); orbRaf = 0; pixOff();
        window.removeEventListener('keydown', onKey, true);
        roomSleep(false);
        eyes(null);
        music('lpTo', 18000, 1); music('duck', false);
        const gone = () => {
          try { if (M) M.destroy(); } catch (e) { /* fine */ }
          try { if (scene && scene.destroy) scene.destroy(); } catch (e) { /* fine */ }
          try { if (window.QODice && QODice.clear) QODice.clear(dEl); } catch (e) { /* fine */ }
          o.remove();
        };
        if (now || RM()) gone(); else { o.classList.remove('is-in'); setTimeout(gone, 340); }
        if (cur && cur.p === p) cur = null;
        try { if (back && back.isConnected && typeof back.focus === 'function') back.focus({ preventScroll: true }); } catch (e) { /* fine */ }
        res(result);
      }
      /* a fault inside the fight never leaves the overlay stuck: it ends the fight (as the win or the loss once decided) */
      const fault = () => { try { end('left'); } catch (e) { /* already gone */ } };
      $('.lbf-leave').addEventListener('click', () => { snd('tap'); end('left'); });
      /* a tap during the opening skips to its end (Leave still leaves); a tap while a round plays hurries it */
      o.addEventListener('click', (e) => {
        const t = e.target && e.target.closest ? e.target : null;
        if (t && t.closest('.lbf-leave')) return;
        if (phase === 'intro' && skipIntro) { skipIntro(); return; }
        if (!(t && t.closest('.lbf-b'))) hurryUp(e.clientX, e.clientY);
      });
      /* keys: Escape leaves; Tab stays inside the fight; during the opening any other key skips it; while a round plays,
         Enter or Space hurries it; Enter and Space press the fight's own buttons (the room's continue key is held back
         while the fight has the focus) */
      function onKey(e) {
        if (over) return;
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); end('left'); return; }
        if (e.key === 'Tab') {
          const fs = [...o.querySelectorAll('button')].filter((b) => b.offsetParent !== null && getComputedStyle(b).visibility !== 'hidden');
          if (!fs.length) return;
          const i = fs.indexOf(document.activeElement);
          if (i < 0 || (e.shiftKey && i === 0) || (!e.shiftKey && i === fs.length - 1)) { e.preventDefault(); fs[e.shiftKey ? (i <= 0 ? fs.length - 1 : i - 1) : (i < 0 || i === fs.length - 1 ? 0 : i + 1)].focus({ preventScroll: true }); }
          return;
        }
        if (phase === 'intro' && skipIntro && !e.metaKey && !e.ctrlKey && !e.altKey) {
          const onLeave = document.activeElement && document.activeElement.classList && document.activeElement.classList.contains('lbf-leave');
          if (!(onLeave && (e.key === 'Enter' || e.key === ' '))) { e.preventDefault(); e.stopPropagation(); skipIntro(); return; }
        }
        const ae = document.activeElement;
        if ((e.key === 'Enter' || e.key === ' ') && hurryAt.indexOf(phase) >= 0 && !(ae && ae.tagName === 'BUTTON' && o.contains(ae) && ae.isConnected)) {
          e.preventDefault(); e.stopPropagation();
          const b = box(stage); hurryUp(b.cx, b.t + b.h * 0.5); return;
        }
        if ((e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowRight') && o.contains(ae)) e.stopPropagation();
      }
      window.addEventListener('keydown', onKey, true);
      try { o.focus({ preventScroll: true }); } catch (e) { /* fine */ }

      cur = {
        p, end,
        state: () => (S ? {
          phase, you: S.you, her: S.her, charge: S.charge, shield: S.shield, tricked: S.tricked, broken: S.broken, hand: S.hand, hit: S.hit, clean: S.clean,
          bonus: Object.assign({}, B), main, guard: curGuard(), intro: phase === 'intro', room: slept ? 'asleep' : 'awake', name: myName,
          labels: [...act.querySelectorAll('.lbf-b .lbf-bl')].map((x) => x.textContent)
        } : { phase })
      };
      fight(false).catch(fault);
      return p;
    }

    function close() { if (cur) cur.end('left', true); }
    return { open, busy: () => !!cur, close, state: () => (cur ? cur.state() : null) };
  };

  /* Quest One's "Catch" (assets/quest-one-v2-audio.js FILES.catch, the same bytes): Jan's voice from the dark, AAC in MP4,
     0.64 s */
  function catchAac() {
    return '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';
  }
})();

/* ===== src/scene-pages/pages/library/gallery.js ===== */
/* library/gallery.js: the gallery's locked paintings (a part of the library page, id library). Jan (2026-10-07): only
   readers who took the Character Quest open the extra scenes, one more on each day they come back.

   The locks are a game inside the room, never access control. Every scene page, the Guide's "Scenes to play" band,
   direct links and the room's hidden list of links keep working. Nothing here is sent anywhere: the state lives in this
   browser only, in localStorage 'ffd-library-gallery' (its own key, because 'ffd-library' keep() would wipe new fields):
     { v: 1, open: [ids in the order they opened], fresh: [opened, not yet walked through], keys: [opened, its lock still
       hanging until the moment plays], last: 'YYYY-MM-DD' the day the last painting opened, hi: the hang's rotation (one
       step on each new visit day), quest: { at, via } when the Quest was first recognised here, stamped: the WANTED poster
       crossed out, nudge: Zhaunil's rung on the lock ladder, locksTapped: taps on any lock }
   The order, and why (the plan's): coin (Old Yost's cart, open to everyone from the first visit), parcel (a parcel with
   the hero's name, right after Zhaunil learns it), bounty, death, inn, sign (the first with Hall heroes), mystery,
   adventures, jobs, heroes (the door to the Hall), then the sellsword and any scene published later, at the end. Only the
   scenes this room was given count (api.scenes()), so an unpublished one is never locked or opened in its place.
   Old Yost's cart is the first painting and the first one open (Jan 2026-10-08: "the first unlock for the paintings is
   the first one not the second one"). The moment the Quest is recognised the gallery is the reader's (questOpen
   records it; nothing more opens that day), then one more painting opens on each new calendar day the library is
   opened (roll), the parcel first. Missed days don't pile up, and a clock set back gives nothing: the day is FFD.day(),
   cards.js's rollDay guard, and a new day must be later than the last one.

   FFD.parts['library/gallery'](api: { scenes() -> [ids], took() -> bool, day() -> 'YYYY-MM-DD', info?() -> { at, via },
                                       ls? (a Storage, for tests) })
     order()            the scenes in opening order          next()   the next one to open, or null
     state(id)          'open' | 'fresh' (open, not walked through yet) | 'next' (a taker's next lock) | 'locked'
     keyed(id)          its lock still hangs (the opening moment hasn't played)    keys()  those ids, oldest first
     questOpen()        the first recognition: records the Quest and the day (no painting opens until the next day) -> null
     roll()             once per arrival: a new day for a taker opens the next painting -> its id or null
     unkey(id)          the lock came off on screen          walked(id)  the reader stepped through it
     stamp() stamped()  the WANTED poster's moment           nudge() -> the ladder's rung (1, 2, 3, then more)
     tapped() -> taps   any lock tap                         locksTapped()
     hang(backFrom, cap) the thumbs: the painting the reader came back through, Yost's cart, fresh ones newest first,
                        the other open ones newest first (rotating each visit day once they outgrow the wall), the
                        next lock, the other locks. The painter cuts the list to the wall (about 5, at most 6)
     locks(hung)        a NEW { id: kind } for the hung frames that wear a lock. The kind goes by the painting's place in
                        the order (the parcel always wears the bow); a stack or a big lock never hangs in the middle frame
                        or two, over the window, because they hang low enough to cover the window's arch there
     nextLock(hung) glint(hung) offWall(cap) open()   snapshot()   reset() (tests) */
(() => {
  'use strict';
  const FFD = window.FFD = window.FFD || {};
  FFD.parts = FFD.parts || {};
  const SK = 'ffd-library-gallery';
  const ORDER = ['coin', 'parcel', 'bounty', 'death', 'inn', 'sign', 'mystery', 'adventures', 'jobs', 'heroes', 'sellsword'];
  const FREE = 'coin';
  /* the kinds after the parcel, by place in ORDER: bounty planks, death bat, inn big, sign stack, mystery plain, and round
     again (adventures planks, jobs bat, heroes big, sellsword stack). A stranger's first wall (the cart, then parcel to
     sign) shows the two that hang low, big and stack, away from the middle frames over the window */
  const KINDS = ['planks', 'bat', 'big', 'stack', 'plain'];
  /* these hang below their frame, onto the window's arch when they're in the middle: plain there instead */
  const LOW = ['big', 'stack'];
  const ID_RE = /^[a-z0-9-]{1,24}$/;
  const isDay = (v) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v);
  const ids = (v) => (Array.isArray(v) ? [...new Set(v.filter((x) => typeof x === 'string' && ID_RE.test(x)))] : []);
  const int = (v) => (typeof v === 'number' && isFinite(v) && v >= 0 ? Math.floor(v) : 0);
  const localDay = () => { const d = new Date(); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); };
  const VIAS = ['run', 'lead', 'hall', 'email'];

  function make(api) {
    api = api || {};
    let ls = null;
    if (api.ls !== undefined) ls = api.ls; else { try { ls = window.localStorage; } catch (e) { ls = null; } }
    const call = (fn, d) => { try { return typeof fn === 'function' ? fn() : d; } catch (e) { return d; } };
    const took = () => !!call(api.took, false);
    const today = () => { const d = call(api.day, ''); return isDay(d) ? d : localDay(); };
    /* this page's own copy stands in when the browser keeps nothing (a private window) */
    let mem = null;
    function blank() { return { v: 1, open: [], fresh: [], keys: [], last: '', hi: 0, quest: null, stamped: false, nudge: 0, locksTapped: 0 }; }
    function clean(v) {
      const o = blank();
      if (!v || typeof v !== 'object') return o;
      o.open = ids(v.open);
      o.fresh = ids(v.fresh).filter((x) => o.open.includes(x));
      o.keys = ids(v.keys).filter((x) => o.open.includes(x));
      o.last = isDay(v.last) ? v.last : '';
      o.hi = int(v.hi);
      if (v.quest && typeof v.quest === 'object') o.quest = { at: int(v.quest.at), via: VIAS.includes(v.quest.via) ? v.quest.via : '' };
      o.stamped = v.stamped === true;
      o.nudge = Math.min(999, int(v.nudge));
      o.locksTapped = Math.min(9999, int(v.locksTapped));
      return o;
    }
    function load() {
      let raw = null, ok = true;
      try { raw = ls ? ls.getItem(SK) : null; } catch (e) { ok = false; }
      if (!ls) ok = false;
      if (ok && raw != null) { try { return clean(JSON.parse(raw)); } catch (e) { return clean(null); } }
      return clean(mem);
    }
    function save(st) {
      mem = JSON.parse(JSON.stringify(st));
      try { if (ls) ls.setItem(SK, JSON.stringify(st)); } catch (e) { /* full or blocked: this page keeps its copy */ }
      return st;
    }

    /* the scenes here, in opening order; a scene this list doesn't know joins at the end */
    function order() {
      const here = ids(call(api.scenes, ORDER.slice()));
      return ORDER.filter((id) => here.includes(id)).concat(here.filter((id) => !ORDER.includes(id)));
    }
    const freeId = (ord) => (ord.includes(FREE) ? FREE : ord[0] || null);
    /* every read: the free painting is always open */
    function st0() {
      const st = load(), ord = order(), f = freeId(ord);
      if (f && !st.open.includes(f)) { st.open.unshift(f); save(st); }
      return st;
    }
    const openHere = (st, ord) => st.open.filter((id) => ord.includes(id));
    function nextOf(st, ord) { return ord.find((id) => !st.open.includes(id)) || null; }
    function openOne(st, ord) {
      const id = nextOf(st, ord);
      if (!id) return null;
      st.open.push(id); st.fresh.push(id); st.keys.push(id);
      return id;
    }

    const G = {
      order,
      next: () => nextOf(st0(), order()),
      open: () => openHere(st0(), order()),
      state(id) {
        const st = st0(), ord = order();
        if (st.open.includes(id)) return st.fresh.includes(id) ? 'fresh' : 'open';
        if (took() && id === nextOf(st, ord)) return 'next';
        return 'locked';
      },
      keyed: (id) => { const st = st0(); return st.keys.includes(id) && st.open.includes(id); },
      keys: () => { const st = st0(), ord = order(); return st.keys.filter((id) => ord.includes(id)); },
      questOpen() {
        if (!took()) return null;
        const st = st0();
        if (st.quest) return null;
        const inf = call(api.info, null) || {};
        st.quest = { at: int(inf.at) || Date.now(), via: VIAS.includes(inf.via) ? inf.via : '' };
        st.last = today();
        save(st);
        return null;
      },
      roll() {
        if (!took()) return null;
        const st = st0();
        if (!st.quest) return null;
        const d = today();
        if (!(d > st.last)) return null;
        st.last = d; st.hi += 1;
        const id = openOne(st, order());
        save(st);
        return id;
      },
      unkey(id) { const st = st0(); if (!st.keys.includes(id)) return; st.keys = st.keys.filter((x) => x !== id); save(st); },
      walked(id) { const st = st0(); if (!st.fresh.includes(id) && !st.keys.includes(id)) return; st.fresh = st.fresh.filter((x) => x !== id); st.keys = st.keys.filter((x) => x !== id); save(st); },
      stamp() { const st = st0(); if (st.stamped) return; st.stamped = true; save(st); },
      stamped: () => st0().stamped,
      quest: () => { const q = st0().quest; return q ? { at: q.at, via: q.via } : null; },
      nudge() { const st = st0(); st.nudge += 1; save(st); return st.nudge; },
      rung: () => st0().nudge,
      tapped() { const st = st0(); st.locksTapped += 1; save(st); return st.locksTapped; },
      locksTapped: () => st0().locksTapped,
      hang(backFrom, cap) {
        cap = Math.max(1, Math.min(6, int(cap) || 6));
        const st = st0(), ord = order(), op = openHere(st, ord), out = [];
        const add = (id) => { if (id && ord.includes(id) && !out.includes(id)) out.push(id); };
        if (backFrom && op.includes(backFrom)) add(backFrom);
        add(freeId(ord));
        const newest = op.slice().reverse();
        newest.filter((id) => st.fresh.includes(id)).forEach(add);
        let rest = newest.filter((id) => !out.includes(id));
        const slots = Math.max(0, cap - out.length);
        if (rest.length > slots && rest.length > 1) { const k = st.hi % rest.length; rest = rest.slice(k).concat(rest.slice(0, k)); }
        rest.forEach(add);
        if (took()) add(nextOf(st, ord));
        ord.filter((id) => !st.open.includes(id)).forEach(add);
        return out;
      },
      locks(hung) {
        const st = st0(), list = ids(hung), n = list.length, out = {};
        const mid = n % 2 ? [(n - 1) / 2] : [n / 2 - 1, n / 2];
        list.forEach((id, slot) => {
          if (st.open.includes(id) && !st.keys.includes(id)) return;
          let k = kindOf(id);
          if (LOW.includes(k) && mid.includes(slot)) k = 'plain';
          out[id] = k;
        });
        return out;
      },
      nextLock(hung) { if (!took()) return null; const st = st0(), id = nextOf(st, order()); return id && ids(hung).includes(id) ? id : null; },
      glint(hung) { const st = st0(), list = ids(hung); return st.fresh.filter((id) => list.includes(id) && !st.keys.includes(id)); },
      offWall(cap) { const hung = G.hang(null, cap).slice(0, Math.max(1, Math.min(6, int(cap) || 6))); return G.open().filter((id) => !hung.includes(id)); },
      snapshot: () => JSON.parse(JSON.stringify(st0())),
      reset() { mem = null; try { if (ls) ls.removeItem(SK); } catch (e) { /* fine */ } }
    };
    return G;
  }
  /* a lock's kind, by the painting's place in the whole order (so it never moves when another scene is unpublished) */
  function kindOf(id) {
    if (id === 'parcel') return 'bow';
    const i = ORDER.indexOf(id);
    if (i === 0) return 'plain';
    if (i > 1) return KINDS[(i - 2) % KINDS.length];
    let x = 0; for (let j = 0; j < id.length; j++) x = (x * 31 + id.charCodeAt(j)) >>> 0;
    return KINDS[x % KINDS.length];
  }
  FFD.parts['library/gallery'] = make;
  FFD.parts['library/gallery'].ORDER = ORDER;
  FFD.parts['library/gallery'].kindOf = kindOf;
  FFD.parts['library/gallery'].KEY = SK;
})();

/* ===== src/scene-pages/pages/library/games.js ===== */
/* library/games.js: the curios and small games in Zhaunil's library (a part of the library page, id library).
   Jan (2026-10-05): "make random objects in the library interactable right now on the shelves theres like 8 globes and
   the shelf in general just doesnt make any sense, add some mini games or something ... things that can be interacted
   with that are just easter eggs that dont neccessaary serve a function other than to delight and enteratin and be fun
   ... i like what you did with the coin like have it flip into the cup like that". The spec:
   docs/scene-pages/demo2/research/LIBRARY-V2-SPEC.md, section 7 and "The curios and small games (games.js)".

   The painter (src/scene-pages/scenes/library.js) draws every curio and answers the events named below; this part owns
   the words and the rules. Unlike the book and the cards, the games speak, but only through the room (api.talk and
   api.ask), so every word lands in the one box at the bottom with the right portrait.

   The interface (the room calls the factory once inside render, after the frame, the book and the cards exist):
     FFD.parts['library/games'](api) -> games
       games.hots() -> { id: { label, tap, sound: false } }   the curios' hotspot handlers (always the same objects; a
                                    label can change as the reader meets a curio, so the room keeps them by reference)
       games.busy() -> boolean      a game is running (the feather hunt, the journal, the mimic's card): start nothing else
       games.close()                stop every timer, listener and overlay (also done when api.alive() turns false)
       games.trophies() -> { feathers, wishes }   this reader's gold feathers and wishes, for the binder if it wants them
       games.wantsEveryTap(id) -> boolean   this curio answers every tap, even while its own words wait in the box (the
                                    skull, unless his bridge is being told): the room skips its repeat-tap poke for it
     The room may give api.rec() and api.calm() (the playing record, as the borders get them, or else the jukebox
     on the frame's check handle is read), and api.has(key) (a border found, or else the borders' own handle).
     Lasting egg state is FFD.egg('library') (core's egg kit): bart.puns, bart.cls, bart.page (memories.js marks it when
     Bartholomew's page shows), bart.day, bart.tried, bart.crown, bart.jaw, bart.jawOn, mimic.liked, stars.n. A
     read-only handle for checks: F.el.__lbGames.
     The room may give api.note(what, d): the moments Jan's hidden token borders wait on (library/borders.js), namely
     'mimic-gave', 'mimic-sulk', 'pun' { n }, 'bubble' { n }, 'dark', 'light', 'hunt-win' and 'wish' { n } (a wish
     on the shooting star, which the borders turn into Fighter Goldspire on a calm record).

   The curios, tap by tap:
     globe        'spin', then 'spun': it lands with a clack, the place shows as a caption over the art (F.result) and
                  Zhaunil reads the rumour he heard there. 24 hooks a DM can steal, in one shuffled order per browser,
                  no repeat until all 24 are told. A second tap inside 0.6 s spins it hard ('globe-hard', 'globecaught')
                  and Zhaunil catches it. While a road record plays (regal, bog, tinker, tavern, flood, ash) its first
                  spin of the visit stops on that road ('spin { at }') with that road's own rumour.
     hourglass    'flip-glass', then the feather hunt: "Soryndel dropped three feathers somewhere in this room." Three
                  the first time and one more after every win, up to ten (Jan, 2026-10-07); that many free grid points
                  go to 'feathers', never on the jukebox or a record guest (the painter keeps them clear, and a feather's
                  button sits above every other), and the sand ('sand', 0 to 1) runs 15 s plus 3 s for each feather past
                  three (25 s plus 4 s under reduced motion, paused while the tab is hidden). A feather tapped flies to
                  the owl ('feather-take { i }', 'took'). All of them: 'hunt-win', a gold feather flies from the owl into
                  the binder, shared tally 'feathers', and Zhaunil says how many she drops next time.
                  Out of sand: 'hunt-lose', and "The sand won this one."
     mimic        'snap { n: 1 }' snaps, 'snap { n: 2 }' growls, 'snap { n: 3 }' spits a card ('spat'): cards.next(),
                  then cards.show(card, { from, label: 'The mimic spat out a card', again: false }), a card to look at
                  (Jan, 2026-10-07: the deck's daily pack is the only way into the binder, the walker's gift aside).
                  One card a visit; after that the third tap gets a sulk. From the third day the reader comes, its first
                  tap of a visit opens wide instead ('mimic-tongue', 'tongued'): it likes them. That tap counts as the
                  first of the three, so the card still comes on the third.
     skull        Bartholomew: every tap answers. 'clack { n }' from the taps in this burst (FFD.burst 'skull', 3 s): his
                  clack, a chatter, then a hop that lands him facing the other way. His words move on with every tap
                  (the newest wins): one terrible D&D pun per joke, 16 of them, the joke always on him; once the reader's
                  character is known, a line for their class (each class's once); once a visit a line for the record
                  playing, or for midnight; in the dark, his dark line and on the third tap a ghost story; within 3 s
                  of the potions' smoke he coughs with Soryndel ('clack { mode: cough }'). Five taps inside 3 s, once a
                  visit and only once Deathrend is found, knock his jaw off ('jaw-off'): the spot 'skull-jaw' clicks it
                  back on ('jaw-on'), and after 20 s with no touch at all Zhaunil puts it back himself (so the window's
                  15 s stillness find always comes first). After eight jokes, or once his page in the memory book has
                  shown, a fresh tap on a calm record asks to tell the bridge: three lines, then the reader rolls a real
                  d20 (F.roll) at DC 15. 15 or more and it held: a paper crown ('crown', kept), and his greeting changes.
                  A natural 20 laughs (the clack's laugh mode), a natural 1 rattles. A miss asks again another day.
     potions      'bubble { n }', n 1 to 5: they bubble and change colour; the fifth smokes and Soryndel coughs.
     cat          Footnote: 'cat { n: 1 }' stretches, 'cat { n: 2 }' bats a book down ('bookfell'), and Zhaunil offers
                  it (api.pickUnread()): Read it opens it in the Guide book (api.openBook), Leave it leaves it.
     candle-<i>   'candle { i, on }' and the candles' value (CANDLES below): snuff and relight. All out darkens the room
                  and 'reveal-journal' lights a book on a shelf; journal opens one page of Zhaunil's own (written from
                  his public Hall card and story, never a secret or weakness field), and the candles relight after.
                  Once the reader's character is known, a note at the page's foot says a reader of their class reads
                  here now. Put out left to right (once the journal has been found, once a visit), three stars cross
                  the window instead ('candle-stars', 'candlestarred') and the room stays dark until a candle is lit.
     window       the moon. A shooting star crosses now and then ('star', 'starshown'); a tap while it crosses: "Make a
                  wish." Shared tally 'wishes'. The second tap tells the reader about the stars, and one comes soon after.
   Every tap answers at once (the frame's ripple, the painter's motion and a sound), variations cycle, and nothing
   repeats too soon. Every wait on the painter has a timeout (F.once), so a missing emit never holds anything up. Words
   wait for a free box (no choice open, no tap to continue pending, no book or card over the art) and give up quietly
   rather than talk over the room. While the hunt runs the other curios still move, but nobody speaks.
   Per reader, in this browser only (localStorage 'ffd-library-games', wrapped in try/catch): which rumours and puns
   have been told, gold feathers, wishes, and which curios have been met; the eggs above in 'ffd-eggs-library'. The
   reader's character is read from FFD.char when it is used (its class key and name only, and the name only ever as
   the frame's escaped {Name}), never from the Quest's or the Hall's own storage. Nothing typed is kept or sent. */
(() => {
  'use strict';
  const FFD = window.FFD;
  if (!FFD) return;
  const CSS_ID = 'ffd-css-library-games';
  const STORE = 'ffd-library-games';
  /* the candles' value in the painter, for the candles in the wall sconces (its header names it: 'lit' is already the bays' glow) */
  const CANDLES = 'candles';
  const MAX_CANDLES = 12;

  /* ---------- the words ---------- */
  /* where the globe stopped (a caption over the art), and the rumour Zhaunil heard there */
  const RUMOURS = [
    ['A fishing town on a grey coast', 'The nets come up full of old keys, and nobody in town owns a single lock.'],
    ['A mountain toll bridge', 'It hasn’t had a keeper in years. Travellers still find a receipt for the toll in their pockets.'],
    ['A desert caravan road', 'A caravan came in a week late with one more camel than it left with. The camel knows the way better than the guide does.'],
    ['A city of a hundred bridges', 'They count the bridges every morning. This week there’s one more than there was.'],
    ['A village in the far north', 'The thaw gave back a knight who went through the ice a century ago. He’d like to finish his quest, and he’s asking for directions.'],
    ['A swamp at the edge of the map', 'A witch there sells weather in jars. Someone bought a whole thunderstorm last spring and hasn’t opened it yet.'],
    ['A crowded capital', 'The royal mapmaker has vanished, and every map she drew now shows a street nobody can find.'],
    ['A chain of warm islands', 'A captain is hiring a crew of exactly seven. Her last crew came home rich and won’t say a word about where they went.'],
    ['A dwarven hold', 'The miners broke through into a hall with the table still set. The bread on it is warm.'],
    ['A town under a volcano', 'A dragon’s egg has gone missing from the crater. The dragon has started asking questions in town, very politely.'],
    ['A busy port', 'A ship sailed in with every sail set and nobody aboard. Its log stops halfway through a sentence about the lighthouse.'],
    ['A city of wizards’ towers', 'A spellbook came back to the library forty years late. Inside is a note to the librarian, signed by someone not yet born.'],
    ['Ruins deep in the jungle', 'An explorer came back from the ruins forty years younger. She wants to go back, and she’s hiring.'],
    ['A fort on a disputed border', 'Two kingdoms both claim the fort, so it pays its taxes twice. The soldiers have quietly declared a third kingdom.'],
    ['A college of magic', 'A student summoned something small for a class. It has since enrolled, and its marks are better than hers.'],
    ['The sewers of a great city', 'The rats have stopped eating the grain. They’re guarding it now, and nobody can say from what.'],
    ['A mountain lake', 'The lake froze in midsummer around one small boat. The fisherman in it swears he only made a wish.'],
    ['A crossroads inn', 'The innkeeper hasn’t aged in sixty years. Neither have her regulars, and they’d rather you didn’t ask.'],
    ['A temple above a market', 'The temple bell rings by itself whenever someone nearby tells a lie. Trade in the market has slowed to a crawl.'],
    ['A city of merchants', 'A trader is selling maps to a treasure he swears doesn’t exist. They keep selling out.'],
    ['The open sea', 'A whale surfaced with a door on its back. Someone knocked from the inside.'],
    ['A royal court', 'A noblewoman traded her name to a fey lord for one dance. Now nobody at court remembers who she is, not even her.'],
    ['A halfling village', 'Someone has been stealing second breakfasts all over the village. The only clues are very small, very polite thank you notes.'],
    ['A goblin market', 'The goblins are selling a crown they swear they found. Three kings have sent people to buy it back, and the price keeps going up.']
  ];
  /* Bartholomew's puns: the joke is always on him */
  const PUNS = [
    'I volunteered to scout ahead. Ahead is all that came back.',
    'Never split the party. I’m what happens when you do.',
    'I rolled a natural 20 on Stealth once. They never found the rest of me.',
    'I never fought the dragon. I didn’t have the guts.',
    'I’d cast Mage Hand, but I’m a little short-handed.',
    'I’d tell you my alignment, but I’ve lost my spine.',
    'The bard asked me to join the band. I had to tell him I have no organs.',
    'My last DM said I had a great sense of humerus. Nobody ever found it.',
    'The rogue promised to watch my back. She took it with her.',
    'I asked the cleric to raise me. She put me on a higher shelf.',
    'Ask me anything about traps. I tested every one of them personally.',
    'They keep me on this shelf as a bookend. I’m told it’s a supporting role.',
    'I’d shrug, but you need shoulders for that.',
    'I’m all head these days. Brilliant at Intelligence checks, hopeless at stairs.',
    'I have a wonderful poker face. It’s all I have left.',
    'Nobody ever casts Speak with Dead on me. I have so much to say.'
  ];
  /* Bartholomew, once he knows the reader's class (FFD.char's class key): the word he uses for it, and that class's own
     line, each told once in this browser. 'other' (any class the Quest doesn't list) gets the last line and no opener */
  const CLASS_WORD = { barbarian: 'barbarian', bard: 'bard', cleric: 'cleric', druid: 'druid', fighter: 'fighter', monk: 'monk', paladin: 'paladin',
    ranger: 'ranger', rogue: 'rogue', sorcerer: 'sorcerer', warlock: 'warlock', wizard: 'wizard', artificer: 'artificer', bloodhunter: 'blood hunter' };
  const CLASS_PUN = {
    barbarian: 'A barbarian used me as a tankard once. Best night I’ve had since the bridge.',
    bard: 'A bard wrote a song about me. It’s short, like the rest of me.',
    cleric: 'Clerics keep offering to raise me. Raise me where? I’m a head.',
    druid: 'A druid turned into a squirrel and buried me for the winter. Zhaunil found me in the spring.',
    fighter: 'A fighter used me as a shield once. I was a very bad shield.',
    monk: 'A monk taught me to empty my mind. Easy enough. It’s all I’ve got.',
    paladin: 'A paladin swore she’d carry me home. She kept most of the promise.',
    ranger: 'A ranger tracked me for three days. I was on this shelf the whole time.',
    rogue: 'A rogue picked my pocket once. Lucky her, I still had pockets.',
    sorcerer: 'Sorcerers say the magic’s in the blood. I’d have to borrow some.',
    warlock: 'A warlock offered me a body for my soul. The fine print said some assembly required.',
    wizard: 'A wizard asked me what being dead is like. I told him it’s mostly shelf work.',
    artificer: 'An artificer offered to build me a body. She ran out of parts at the neck.',
    bloodhunter: 'A blood hunter asked where I keep my blood. I’ve lost track.',
    other: 'Whatever you are, there’s more of you than there is of me.'
  };
  /* his line for the record playing (two each, one a visit per record), and for the midnight hour */
  const SKULL_REC = {
    ash: ['I’d hide, but I can’t get off the shelf.', 'That song again. I’d run, if I had anything to run with.'],
    flood: ['Heads float. Finally, a talent.', 'If the water gets any higher, I’m a buoy.'],
    regal: ['I’d salute. You need an arm for that.', 'I marched once. Mostly I remember the blisters. I miss the blisters.'],
    bog: ['The frog asked if I was a rock. I said yes. It’s easier.', 'A frog sat on me for an hour. I didn’t have the heart to move.'],
    tinker: ['Yost tried to sell me twice. Nobody bid.', 'Yost keeps measuring me for a box. I hope it’s a hat box.'],
    tavern: ['Everyone’s staring. I can’t even blink back.', 'Buy me a drink? It goes straight through.']
  };
  /* while a road record plays, the globe's first spin of the visit stops on that road: where it stops (a share of a
     turn, the same face every time), the caption, and the rumour. Marrow's End knows whether the reader went after her */
  const ROAD = {
    regal: [0.08, 'The King’s Road', 'The watch found a new milestone on the King’s Road. It counts down, and nobody knows to what.'],
    bog: [0.25, 'The Blackfen', 'The lights in the Blackfen have started leading travellers home. Nobody trusts it.'],
    tinker: [0.42, 'Yost’s back road', 'Yost’s back road only shows up for people Yost owes money. I see it from this window every night.'],
    tavern: [0.58, 'The Hollow Stump', 'The regulars at the Hollow Stump have sat at the same tables for forty years. Nobody has ever seen them order.'],
    flood: [0.75, 'A drowned town under Blackwater', 'The drowned town under Blackwater still keeps its market day. The fishermen come home with change in their nets.'],
    ash: [0.92, 'Marrow’s End', 'Marrow’s End bolts its doors at dusk. The Reeve’s posting is still up.', 'Marrow’s End leaves its doors open at night again. You had something to do with that.']
  };
  const L = {
    globeFirst: 'Every place on this globe has a rumour. I collect them.',
    globeAll: 'That’s every rumour I have. Soryndel is out gathering more, so here’s an old one.',
    globeAside: ['Take that one for your table if you like. Rumours are meant to travel.', 'If your players ever go there, I’d love to hear what they find.', 'Soryndel brought that one home. I didn’t ask how.'],
    hunt: ['Soryndel dropped {n} feathers somewhere in this room.', 'Find them before the sand runs out.'],
    huntNone: 'Soryndel won’t drop anything while the room is this crowded. Try the glass again in a moment.',
    win: ['All {n}, with sand to spare. Soryndel is unbearably proud of you.', 'All {n}. Soryndel hasn’t looked this pleased since the moth.', '{N} for {n}. Soryndel will be insufferable about this for a week.'],
    /* each win drops one more next time, up to ten (Jan, 2026-10-07) */
    harder: 'Next time she drops {n}. She’s taking this personally now.',
    hardest: 'Ten. Soryndel has nothing left to drop, and she knows it.',
    gold1: 'A gold feather for your binder. Soryndel doesn’t give those to just anyone.',
    goldN: 'That’s {n} gold feathers in your binder. Soryndel is running low.',
    goldAll: '{n} gold feathers given away so far. Soryndel is running low.',
    lose: 'The sand won this one.',
    loseAfter: ['Turn the glass again whenever you like. Soryndel is moulting anyway.', 'Soryndel will happily drop them again. It’s the owl’s favourite game.', 'They’ll turn up. Lost feathers always end up in my tea.'],
    mimicFirst: 'Ah. That one isn’t a book.',
    mimicBy: 'A little damp, but in one piece.',
    mimicAfter: ['It only spits out cards for people it likes. Everyone else, it bites.', 'I feed it my worst first drafts. It seems to prefer cards.', 'Don’t tell it I said so, but that was its favourite card.', 'It swallowed that one again. Mimics never share.'],
    mimicSulk: ['It’s sulking. One card a visit, and it showed you its favourite.', 'Nothing left in there but a bookmark and a grudge.', 'It showed you its only card. Now it wants a nap.'],
    mimicNone: 'It coughed up a bookmark. The cards are all out with the deck tonight.',
    skullHi: 'Oh, a visitor. Bartholomew, at your service.',
    skullAll: 'That’s all sixteen. I’ll start again from the top. You’ll laugh this time.',
    skullDark: ['Ah, the dark. Finally, my good side.', 'Lights out. Now nobody can tell I’m only a head.'],
    skullLose: ['I could have found them. If I had legs.', 'I saw where all three went. Nobody ever asks the skull.'],
    skullPotion: 'Don’t drink the green one. That’s how I ended up like this.',
    skullAside: ['Bartholomew came with the library. I’ve stopped apologising for him.', 'He has a thousand of these. Soryndel has heard every one twice.', 'Please don’t encourage him. He’s been at it for two hundred years.'],
    /* the opener once he knows the reader's class ({a} the article, {c} the class word) */
    skullClass: '{A} {c}. I knew {a} {c} once. Most of one, anyway.',
    skullHop: ['Thank you. That’s my good side.', 'Oh, that’s much better. I’ve been staring at that wall for a century.'],
    skullMid: ['Midnight. This is when I’d haunt something. The shelf will do.', 'Midnight. Soryndel’s hour. I sit very still and pretend to be a bookend.'],
    skullGhost: ['Once, a skull sat in a dark library.', 'That’s the whole story. It’s terrifying if you’re me.'],
    skullCough: ['Two hundred years without lungs, and I still cough.', 'That smoke went straight to my head. All of me, then.'],
    crownHi: 'Bartholomew, at your service. The bridge held, you know.',
    mmf: ['Mmf.', 'Mmmf mf.', 'Mf mmf mmmf mf.', 'Mmmmmf.'],
    jawOff: ['Mmf. Mmmf mf mmf.', 'You knocked his jaw off. It goes back on with a click.'],
    jawOn: ['Thank you. The last time I lost it, I was on a bridge.', 'Thank you. I’d nod, but look where that got us.', 'Much obliged. It’s been loose since the bridge.'],
    jawAuto: ['I’ll do it. Again.', 'Back on it goes. Soryndel, stop laughing.'],
    /* the bridge: why he asks, the reader's choice, the story (a later try goes straight to the roll), the roll's ends */
    bridgePage: 'You read my page.',
    bridgePuns: 'Eight jokes, and you’re still here.',
    bridgeAgain: 'About that bridge. I’ve been thinking about it all day.',
    bridgeYes: 'Tell me about the bridge',
    bridgeNo: 'Another joke',
    bridgeStory: ['Three of us on a rope bridge over a gorge. I’d checked it, so I went last.', 'It held for them.', 'Roll for me. Fifteen or more, and this time it holds.'],
    bridgeHeld: 'It held. Two hundred years, and it finally held.',
    bridge20: 'A natural 20. Two hundred years, and it finally held.',
    bridgeFell: 'It fell. Same as last time. Thanks for rolling for me.',
    bridge1: 'Even the dice know.',
    crownZh: 'Soryndel folded him a crown. Nobody tell him it’s paper.',
    globeHard: ['Gently. It’s the only world I’ve got.', 'Easy. Soryndel gets dizzy just watching.', 'Careful. The last time it spun like that, a kingdom fell off.'],
    mimicLikes: ['It likes you. It’s never done that for me.', 'It still likes you. It bit me this morning.', 'There it goes again. You must smell like old paper.'],
    stars: ['In order. Soryndel does it that way too.', 'Left to right, like reading. The stars liked that.'],
    /* the foot of the journal page once the reader is known ({A} {c} as above) */
    journalMe: '{A} {c} called {Name} reads here now. Keep an eye on {them}.',
    potion: ['Soryndel has asked me, very politely, to stop mixing those.', 'That one was meant to turn lead into gold. It turned Soryndel grey for a week.', 'I’ll tell Soryndel it was the cat.'],
    catHi: 'That’s Footnote. She sleeps up there and judges my shelving.',
    catOffer: 'Footnote has chosen your next book.',
    catAsk: 'Read it?',
    catFrom: 'Footnote chose this one',
    catLeave: ['Footnote will knock down another one later. It’s how she reviews books.', 'Leave it, then. Footnote will sit on it until you change your mind.'],
    catNone: 'That’s one of my old ledgers. Nothing you’d want to read, though Footnote disagrees.',
    journal1: 'You found my journal. I’d ask you to keep it between us, but Soryndel already told the cat.',
    journal2: 'Still only the one page. I write slowly, and I cross out a great deal.',
    window: ['Soryndel hunts by that moon. Books, mostly.', 'Stars fall past this window now and then. Catch one and you get a wish.', 'The moon keeps better hours than I do.'],
    wish: 'Make a wish.',
    wish1: 'I never ask what they were. It’s the one thing I don’t write down.',
    wishN: 'That’s {n} wishes from you at this window. I still won’t ask.',
    wishAll: '{n} wishes made at this window so far. I’ve never asked about a single one.'
  };
  /* one page of Zhaunil's journal, from his public Hall card (title The Open Sky, epithet The Patient Question, his
     legend and quote) and the public story in data/heroes.json: the Weave, the failed divinations, Soryndel */
  const JOURNAL = {
    kicker: 'From the journal of Zhaunil Maerabban',
    title: 'The Open Sky',
    paras: [
      'In Sshamath the wizards rule, and they decide which questions are worth asking. Mine were about the surface, its open sky and its gods. I wrote every one of them down. That was my mistake, and I would make it again.',
      'I left with my journals, a darkwood staff and an owl I never asked for. Soryndel was waiting on the city gate the night I ran, and has known the way ever since, down paths I never walked and names I never taught. My old masters would have dissected an owl like that to see how it works. I would rather ask.',
      'My divinations keep failing in the same place, as if the Weave itself has a wound. So I travel, and I read, and I write down every vision as a guess. Then I wait, politely, to be wrong.'
    ],
    quote: 'Every vision is a hypothesis. Every prayer, a person.',
    sign: 'Z.',
    close: 'Close the journal'
  };

  /* ---------- the look: the journal page and the gold feather (every rule under the library page) ---------- */
  const svgUrl = (s) => 'url("data:image/svg+xml,' + encodeURIComponent(s) + '")';
  const GRAIN = svgUrl("<svg xmlns='http://www.w3.org/2000/svg' width='180' height='180'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='3' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 .32  0 0 0 0 .22  0 0 0 0 .1  0 0 0 .55 0'/></filter><rect width='100%' height='100%' filter='url(#n)' opacity='.32'/></svg>");
  /* a small gold quill feather in pixels (L light, G gold, M mid, D the shaft), drawn once to a tiny picture and shown at
     the room's own pixel scale, pixelated, so it stays crisp in flight */
  const FEATHER_ROWS = ['.......LLLL....', '....LLGGG.GGL..', '..LGGGGGG.GGGM.', 'DDDDDDDDDDDDDDL', '..MGGGGGGGGGMM.', '....MMGGGGMM...', '.......MMM.....'];
  const FEATHER_COL = { L: '#fff3cc', G: '#f4d68a', M: '#d6ae55', D: '#8a6a1f' };
  let featherSrc = null;
  function featherPng() {
    if (featherSrc != null) return featherSrc;
    featherSrc = '';
    try {
      const cv = document.createElement('canvas');
      cv.width = FEATHER_ROWS[0].length; cv.height = FEATHER_ROWS.length;
      const g = cv.getContext('2d');
      FEATHER_ROWS.forEach((row, y) => row.split('').forEach((c, x) => { if (FEATHER_COL[c]) { g.fillStyle = FEATHER_COL[c]; g.fillRect(x, y, 1, 1); } }));
      featherSrc = cv.toDataURL('image/png');
    } catch (e) { featherSrc = ''; }
    return featherSrc;
  }
  const P = '.ffd-page--library';
  const CSS = `
${P} .ffs-hot[data-hot^="feather-"] { z-index: 2; }
${P} .lbg-jr { position: absolute; inset: 0; z-index: 6; display: grid; place-items: center; box-sizing: border-box; padding: 16px; background: radial-gradient(120% 90% at 50% 40%, rgba(16, 20, 40, .4), rgba(4, 4, 10, .82)); opacity: 0; transition: opacity .26s ease; }
${P} .lbg-jr.is-in { opacity: 1; }
${P} .lbg-jr.is-out { opacity: 0; transition-duration: .2s; }
${P} .lbg-jp { position: relative; box-sizing: border-box; width: min(500px, 100%); max-height: min(100%, 92svh); overflow-y: auto; overscroll-behavior: contain; margin: 0; padding: 28px 30px 20px; border-radius: 3px; color: #2a2016;
  background: ${GRAIN}, radial-gradient(130% 100% at 50% 35%, #f4e9d0 0%, #efe3c8 55%, #d9c6a0 100%);
  box-shadow: 0 24px 70px rgba(0, 0, 0, .55), 0 0 0 1px rgba(138, 106, 31, .35), inset 0 0 50px rgba(110, 76, 34, .3), 0 0 90px rgba(168, 196, 255, .16);
  font: italic 500 19px/1.5 var(--f-aside, 'Cormorant Garamond', Georgia, serif); transform: translateY(16px) rotate(-1deg); transition: transform .34s cubic-bezier(.2, .8, .2, 1); scrollbar-width: thin; }
${P} .lbg-jr.is-in .lbg-jp { transform: rotate(-.5deg); }
${P} .lbg-jp .lbg-jk { margin: 0; text-align: center; font: 600 11.5px/1.35 var(--f-body, 'Spectral', Georgia, serif); letter-spacing: .14em; text-transform: uppercase; color: #8a6a1f; }
${P} .lbg-jp .lbg-jt { margin: 6px 0 16px; text-align: center; font: 600 24px/1.2 var(--f-display, 'Cinzel', Georgia, serif); color: #2a2016; }
${P} .lbg-jp .lbg-jt::after { content: ''; display: block; width: 72px; height: 1px; margin: 12px auto 0; background: linear-gradient(90deg, rgba(138, 106, 31, 0), #8a6a1f, rgba(138, 106, 31, 0)); }
${P} .lbg-jp p { margin: 0 0 .7em; text-wrap: pretty; }
${P} .lbg-jp .lbg-jq { margin: 1.1em 0 .2em; text-align: center; font-weight: 600; color: #5a4420; text-wrap: balance; }
${P} .lbg-jp .lbg-jn { margin: 0; text-align: right; font: italic 600 21px/1.2 var(--f-aside, 'Cormorant Garamond', Georgia, serif); color: #8a6a1f; }
/* the note added at the foot once the reader is known: a later hand, smaller and a little crooked */
${P} .lbg-jp .lbg-jx { margin: .8em 0 0; padding-top: .5em; border-top: 1px dashed rgba(138, 106, 31, .38); font: italic 500 .84em/1.4 var(--f-aside, 'Cormorant Garamond', Georgia, serif); color: #6a5230; transform: rotate(-.6deg); transform-origin: left center; }
${P} .lbg-jc { display: block; box-sizing: border-box; min-height: 44px; margin: 12px auto 0; padding: 0 22px; border: 1px solid rgba(138, 106, 31, .55); border-radius: 999px; background: rgba(255, 250, 235, .4); color: #4a3818; font: 600 15px/1 var(--f-body, 'Spectral', Georgia, serif); cursor: pointer; transition: background .18s ease, transform .18s ease; -webkit-tap-highlight-color: transparent; }
${P} .lbg-jc:hover { background: rgba(138, 106, 31, .14); }
${P} .lbg-jc:active { transform: scale(.97); }
${P} .lbg-jc:focus-visible { outline: 2px solid #8a6a1f; outline-offset: 3px; }
${P} .lbg-gold { position: absolute; z-index: 5; display: block; pointer-events: none; transform: translate(-50%, -50%); filter: drop-shadow(0 0 6px rgba(244, 214, 138, .85)); will-change: transform, opacity; }
${P} .lbg-gold img { display: block; width: 100%; height: 100%; image-rendering: pixelated; }
/* Bartholomew's portrait in the box is his own pixels from the room: kept crisp */
${P} .ffs-who-img[src$="#lbg-px"] { image-rendering: pixelated; }
@media (max-width: 719px) {
  ${P} .lbg-jp { padding: 24px 20px 16px; font-size: 18.5px; }
  ${P} .lbg-jp .lbg-jt { font-size: 21px; }
}
/* a short room (the store's frame under its header, a small phone): the whole page and its close button still fit.
   The room's own height decides, not the window's (the store's header takes 117 px of a phone) */
${P} .lbg-jr { container-type: size; }
@container (max-width: 719px) and (max-height: 780px) {
  ${P} .lbg-jp { padding: 18px 18px 12px; font-size: 16.5px; line-height: 1.42; }
  ${P} .lbg-jp .lbg-jt { margin: 4px 0 10px; font-size: 19px; }
  ${P} .lbg-jp .lbg-jt::after { margin-top: 8px; }
  ${P} .lbg-jp p { margin-bottom: .55em; }
  ${P} .lbg-jp .lbg-jq { margin-top: .7em; }
  ${P} .lbg-jc { margin-top: 8px; }
}
/* with the note at its foot, a phone's page tightens a little so its close button still shows without scrolling */
@container (max-width: 719px) and (min-height: 781px) and (max-height: 900px) {
  ${P} .lbg-jp.has-note { padding: 22px 20px 14px; font-size: 17.5px; line-height: 1.42; }
  ${P} .lbg-jp.has-note .lbg-jt { margin: 4px 0 12px; }
  ${P} .lbg-jp.has-note p { margin-bottom: .55em; }
  ${P} .lbg-jp.has-note .lbg-jq { margin-top: .8em; }
  ${P} .lbg-jp.has-note .lbg-jx { margin-top: .5em; padding-top: .4em; }
  ${P} .lbg-jp.has-note .lbg-jc { margin-top: 8px; }
}
@container (max-width: 719px) and (max-height: 650px) {
  ${P} .lbg-jp { padding: 14px 16px 10px; font-size: 15.5px; line-height: 1.38; }
  ${P} .lbg-jp .lbg-jt { font-size: 18px; }
}
/* a very short room (a small phone under the store's header, or a wide screen under its tall header): wider and tighter */
@container (max-height: 560px) {
  ${P} .lbg-jp { width: min(660px, 100%); padding: 12px 18px 8px; font-size: 15px; line-height: 1.32; }
  ${P} .lbg-jp .lbg-jk { font-size: 10.5px; letter-spacing: .1em; }
  ${P} .lbg-jp .lbg-jt { margin: 2px 0 8px; font-size: 18px; }
  ${P} .lbg-jp .lbg-jt::after { margin-top: 6px; }
  ${P} .lbg-jp p { margin-bottom: .4em; }
  ${P} .lbg-jp .lbg-jq { margin: .5em 0 0; }
  ${P} .lbg-jp .lbg-jn { margin-top: -4px; font-size: 18px; }
  ${P} .lbg-jp .lbg-jx { margin-top: .3em; padding-top: .3em; }
  ${P} .lbg-jc { margin-top: 4px; }
}
/* a sideways phone with the note: a little tighter again, so the close button stays on the page */
@container (max-height: 560px) {
  ${P} .lbg-jp.has-note { padding-top: 10px; padding-bottom: 6px; line-height: 1.26; }
  ${P} .lbg-jp.has-note .lbg-jt { margin: 0 0 6px; }
  ${P} .lbg-jp.has-note p { margin-bottom: .3em; }
  ${P} .lbg-jp.has-note .lbg-jx { margin-top: .15em; padding-top: .2em; }
}
@container (min-width: 720px) and (max-height: 560px) {
  ${P} .lbg-jp { width: min(700px, 100%); font-size: 16.5px; line-height: 1.4; }
}
@media (prefers-reduced-motion: reduce) {
  ${P} .lbg-jr, ${P} .lbg-jp, ${P} .lbg-jc { transition: none; }
  ${P} .lbg-jp, ${P} .lbg-jr.is-in .lbg-jp, ${P} .lbg-jp .lbg-jx { transform: none; }
}
`;

  /* ---------- small helpers ---------- */
  const q = (t) => ({ text: '“' + t + '”', cls: 'say' });
  const rnd = (n) => Math.floor(Math.random() * n);
  const load = () => { try { const v = JSON.parse(localStorage.getItem(STORE) || 'null'); return v && typeof v === 'object' && !Array.isArray(v) ? v : {}; } catch (e) { return {}; } };
  const keep = (st) => { try { localStorage.setItem(STORE, JSON.stringify(st)); } catch (e) { /* this browser only, and only when it can */ } };
  function shuffled(n, notFirst) {
    const a = [];
    for (let i = 0; i < n; i++) a.push(i);
    for (let i = n - 1; i > 0; i--) { const j = rnd(i + 1); const t = a[i]; a[i] = a[j]; a[j] = t; }
    if (notFirst != null && n > 1 && a[0] === notFirst) { const j = 1 + rnd(n - 1); a[0] = a[j]; a[j] = notFirst; }
    return a;
  }
  const isPerm = (a, n) => Array.isArray(a) && a.length === n && new Set(a).size === n && a.every((x) => Number.isInteger(x) && x >= 0 && x < n);
  /* the next of n in this browser's own order: no repeat until all n have come, and the new round never opens with the
     one just told. The order survives visits (st[k] = { o: order, i: next }) */
  function deal(st, k, n) {
    let d = st[k], wrapped = false;
    if (!d || !isPerm(d.o, n) || !Number.isInteger(d.i) || d.i < 0) d = st[k] = { o: shuffled(n), i: 0 };
    if (d.i >= n) { d = st[k] = { o: shuffled(n, d.o[n - 1]), i: 0 }; wrapped = true; }
    const v = d.o[d.i];
    d.i++;
    return { v, wrapped };
  }
  const race = (p, ms, dflt) => Promise.race([Promise.resolve(p).catch(() => dflt), new Promise((res) => setTimeout(() => res(dflt), ms))]);
  /* a class key's word and its article, filled into {A} {a} {c}. Only these fixed words ever go in: what the reader
     typed (a name, a class of their own) reaches a line only as the frame's {Name}, which it escapes */
  const clsKey = (c) => (c && typeof c.cls === 'string' && CLASS_PUN[c.cls] ? c.cls : 'other');
  const clsWord = (k) => CLASS_WORD[k] || 'adventurer';
  function withCls(t, k) {
    const w = clsWord(k), a = /^[aeiou]/.test(w) ? 'an' : 'a';
    return t.replace(/\{A\}/g, a.charAt(0).toUpperCase() + a.slice(1)).replace(/\{a\}/g, a).replace(/\{c\}/g, w);
  }
  const CALM_RECS = ['quiet', 'hearth', 'after'];

  (FFD.parts = FFD.parts || {})['library/games'] = function makeGames(api) {
    api = api || {};
    const F = api.F;
    const h = api.h || FFD.h;
    const RM = () => { try { return api.RM ? !!api.RM() : !!(FFD.RM && FFD.RM()); } catch (e) { return false; } };
    const WIDE = () => { try { return api.WIDE ? !!api.WIDE() : matchMedia('(min-width: 720px)').matches; } catch (e) { return false; } };
    const alive = () => { try { return !api.alive || api.alive() !== false; } catch (e) { return false; } };
    const snd = (n) => { try { if (api.snd) api.snd(n); } catch (e) { /* a sound never breaks a game */ } };
    const ZH = api.ZH || { name: 'Zhaunil' };
    let closed = false;
    const live = () => !closed && alive();
    const defs = {};
    const games = { hots: () => defs, busy: () => false, close: () => {}, trophies: () => ({ feathers: 0, wishes: 0 }), wantsEveryTap: () => false };
    if (!F || !F.el || !h) return games;
    if (!document.getElementById(CSS_ID)) document.head.append(h('style', { id: CSS_ID, text: CSS }));
    const st = load();
    const save = () => keep(st);

    /* ---- timers, intervals and listeners: close() stops every one ---- */
    const timers = new Set(), offs = [];
    const later = (fn, ms) => { const t = setTimeout(() => { timers.delete(t); if (live()) fn(); }, Math.max(0, ms || 0)); timers.add(t); return t; };
    const pause = (ms) => new Promise((res) => later(res, ms));
    const listen = (type, fn) => { if (F.on) offs.push(F.on(type, (d) => { if (live()) fn(d || {}); })); };
    /* an emit from the painter, or { timeout: true } when it doesn't come (F.once trims the wait under reduced motion) */
    const emitted = (type, ms) => (F.once ? F.once(type, ms) : new Promise((res) => setTimeout(() => res({ timeout: true }), RM() ? 0 : ms)));
    const act = (type, v) => { try { F.act(type, v); } catch (e) { /* the art answers when it can */ } };
    const setV = (n, v) => { try { F.set(n, v); } catch (e) { /* fine */ } };
    const getV = (n) => { try { return F.get(n); } catch (e) { return undefined; } };
    const rectOf = (id) => { try { return F.spotCss ? F.spotCss(id) : null; } catch (e) { return null; } };
    const hotMap = () => { try { return F.api && F.api.hot ? F.api.hot(F.key) : null; } catch (e) { return null; } };
    const beacon = (ids, on) => { try { if (F.beacon) F.beacon(ids, on); } catch (e) { /* fine */ } };
    /* a moment the token borders wait on (the room passes it on to library/borders.js) */
    const note = (what, d) => { try { if (api.note) api.note(what, d || {}); } catch (e) { /* fine */ } };
    const cyc = {};
    const next = (k, list) => { if (cyc[k] == null) cyc[k] = rnd(list.length) - 1; cyc[k] = (cyc[k] + 1) % list.length; return list[cyc[k]]; };
    /* the room held busy while a game runs: a count, so two holds never release each other */
    let holds = 0;
    const hold = () => { holds++; if (holds === 1) { try { if (api.busy) api.busy(true); } catch (e) { /* fine */ } } };
    const release = () => { if (!holds) return; holds--; if (!holds) { try { if (api.busy) api.busy(false); } catch (e) { /* fine */ } } };
    function relabel(id, label) {
      if (!defs[id] || defs[id].label === label) return;
      defs[id].label = label;
      try { if (F.relayout) F.relayout(); } catch (e) { /* the name updates on the next layout */ }
    }

    /* ---- the egg kit (core.js: FFD.egg, FFD.burst, FFD.day, FFD.when, FFD.visitDays, FFD.now), each with a plain
       stand-in so an older core still plays the curios ---- */
    const EGG = (() => {
      try { if (typeof FFD.egg === 'function') return FFD.egg('library'); } catch (e) { /* the stand-in below */ }
      const m = {};
      return { get: (k, d) => (Object.prototype.hasOwnProperty.call(m, k) ? m[k] : d), set: (k, v) => { m[k] = v; return true; }, inc: (k, n) => (m[k] = (+m[k] || 0) + (n || 1)), once: () => true, daily: () => true };
    })();
    const eget = (k, d) => { try { return EGG.get(k, d); } catch (e) { return d; } };
    const eset = (k, v) => { try { EGG.set(k, v); } catch (e) { /* this browser only, when it can */ } };
    const nowMs = () => { try { return typeof FFD.now === 'function' ? FFD.now() : Date.now(); } catch (e) { return Date.now(); } };
    const ownBursts = {};
    function burst(k, ms) {
      try { if (typeof FFD.burst === 'function') return FFD.burst(k, ms); } catch (e) { /* the stand-in below */ }
      const t = Date.now(), a = (ownBursts[k] || []).filter((x) => t - x <= ms);
      a.push(t); ownBursts[k] = a;
      return a.length;
    }
    function today() {
      try { if (typeof FFD.day === 'function') return FFD.day(); } catch (e) { /* the stand-in below */ }
      const d = new Date(nowMs());
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }
    function when() {
      try { if (typeof FFD.when === 'function') return FFD.when(); } catch (e) { /* the stand-in below */ }
      const hh = new Date(nowMs()).getHours();
      return { h: hh, late: hh >= 23 || hh < 4, midnight: hh === 0 };
    }
    const visitDays = () => { try { return typeof FFD.visitDays === 'function' ? +FFD.visitDays('library') || 0 : 0; } catch (e) { return 0; } };
    /* the reader's character, read when it's used (never a copy from when the room began) */
    const me = () => { try { const c = FFD.char; return c && typeof c === 'object' && c.name ? c : null; } catch (e) { return null; } };
    const tookQuest = () => { try { return !!(FFD.quest && FFD.quest.v === 1 && FFD.quest.took()); } catch (e) { return false; } };
    /* the record playing: the room's own api.rec when it gives one, else the jukebox on the frame's check handle */
    function rec() {
      try {
        if (typeof api.rec === 'function') return String(api.rec() || 'quiet');
        const j = F.el.__lbJuke;
        if (j && j.jukebox && typeof j.jukebox.rec === 'function') return String(j.jukebox.rec() || 'quiet');
      } catch (e) { /* quiet */ }
      return 'quiet';
    }
    const calmRec = () => { try { if (typeof api.calm === 'function') return !!api.calm(); } catch (e) { /* by the id */ } return CALM_RECS.indexOf(rec()) >= 0; };
    /* a border found (library/borders.js): api.has when the room gives it, else the borders' own check handle */
    function has(k) {
      try {
        if (typeof api.has === 'function') return !!api.has(k);
        const b = F.el.__lbBorders;
        if (b && typeof b.has === 'function') return !!b.has(k);
      } catch (e) { /* not found */ }
      return false;
    }
    /* the reader's last touch anywhere, for the eggs that wait on nobody touching anything */
    let lastTouch = Date.now();
    const touched = () => { lastTouch = Date.now(); };
    window.addEventListener('pointerdown', touched, true);
    window.addEventListener('keydown', touched, true);

    /* ---- the art's pixel scale and where things are, in the art's CSS px ---- */
    function pxScale() {
      try { const hs = hotMap(); if (!hs || !hs.W) return 3; const a = F.toCss(0, 0), b = F.toCss(hs.W, 0); return Math.max(1.5, (b.x - a.x) / hs.W); } catch (e) { return 3; }
    }
    /* a small shake of the whole room (none under reduced motion) */
    const rumble = (px) => { try { if (FFD.fx && F.art) FFD.fx.shake(F.art, px); } catch (e) { /* fine */ } };
    function sparkAt(id, o) {
      const r = rectOf(id);
      if (!r || RM() || !FFD.fx || !F.art) return;
      const ar = F.art.getBoundingClientRect();
      FFD.fx.sparks(F.art, Object.assign({ x: ar.left + r.cx, y: ar.top + r.cy, n: 14, spread: 60 }, o || {}));
    }

    /* ---- speaking through the room: one at a time, only into a free box ---- */
    function covered() {
      try {
        const r = F.art.getBoundingClientRect(), vh = window.innerHeight || 0, vw = window.innerWidth || 0;
        if (!r.width || !r.height || r.bottom <= 0 || r.top >= vh) return false;
        /* the middle of the part of the art on screen (an upright phone's room pans, wider than the window) */
        const x = vw ? (Math.max(r.left, 0) + Math.min(r.right, vw)) / 2 : r.left + r.width / 2;
        const e = document.elementFromPoint(x, Math.max(r.top + 4, Math.min(vh - 4, r.top + r.height * 0.4)));
        /* something of the frame's own over the middle of the art that isn't the art or the box: the book, a card,
           the album or the journal */
        return !!(e && F.el.contains(e) && !F.art.contains(e) && !(F.box && F.box.contains(e)));
      } catch (e) { return false; }
    }
    function boxBusy() {
      const c = F.el.classList;
      if (c.contains('is-gate') || c.contains('has-sheet')) return true;
      if (F.acts && [...F.acts.children].some((x) => !x.hidden && !x.classList.contains('is-out'))) return true;
      return covered();
    }
    async function boxFree(max) {
      const t0 = Date.now();
      while (boxBusy()) {
        if (Date.now() - t0 > max) return false;
        await pause(160);
        if (!live()) return false;
      }
      return live();
    }
    let chain = Promise.resolve(true), waiting = 0;
    /* says the lines (who defaults to Zhaunil; a line object may name its own speaker, { who }) when the box is free;
       resolves true once the reader has tapped on, false when it gave up (the box stayed busy, a hunt is running, or
       the room went away). waiting counts the words still to come or still in the box */
    function speak(lines, who, o) {
      o = o || {};
      waiting++;
      const run = async () => {
        if (!live() || hunt) return false;
        if (!(await boxFree(o.wait != null ? o.wait : 6000)) || hunt) return false;
        try { await api.talk(lines, who); } catch (e) { return false; }
        return live();
      };
      const p = chain.then(run, run);
      chain = p.catch(() => false);
      p.then(() => { waiting--; }, () => { waiting--; });
      return p;
    }
    const qb = (t) => Object.assign(q(t), { who: bart() });
    const qz = (t) => Object.assign(q(t), { who: ZH });

    /* ================= the globe ================= */
    let globeBusy = false, rumoursTold = 0;
    /* the rumours sit round the globe in order (rumour i at i / 24 of a turn): Zhaunil reads the untold one nearest to
       where it stopped ('spun' { at }), and none comes twice until all 24 are told (st.told, this round's). A new round
       never opens with the one just told (st.lastR) */
    function rumourAt(at) {
      const n = RUMOURS.length;
      let told = Array.isArray(st.told) ? st.told.filter((x, k, a) => Number.isInteger(x) && x >= 0 && x < n && a.indexOf(x) === k) : [], wrapped = false;
      if (told.length >= n) { told = []; wrapped = true; }
      let free = [];
      for (let i = 0; i < n; i++) if (told.indexOf(i) < 0 && !(wrapped && i === st.lastR)) free.push(i);
      if (!free.length) free = [0];
      let pick = free[rnd(free.length)];
      if (typeof at === 'number' && isFinite(at)) {
        const a = ((at % 1) + 1) % 1;
        let best = 2;
        free.forEach((i) => { const d = Math.abs(i / n - a), dd = Math.min(d, 1 - d); if (dd < best) { best = dd; pick = i; } });
      }
      told.push(pick);
      st.told = told; st.lastR = pick;
      delete st.rumours;
      return { v: pick, wrapped };
    }
    /* a second tap inside 0.6 s of a spin starting spins it hard, and Zhaunil catches it (once a spin) */
    let globeAt = -1e9, globeHard = false, globeSaid = false;
    const roadDone = {};
    async function tapGlobe() {
      if (globeBusy) {
        if (!globeHard && Date.now() - globeAt < 600) {
          globeHard = true; act('globe-hard');
          /* under reduced motion the rumour may already be on its way: the catch comes after it */
          if (globeSaid) speak([q(next('globeHard', L.globeHard))]);
          return;
        }
        snd('tap'); return;
      }
      globeBusy = true; globeHard = false; globeSaid = false; globeAt = Date.now();
      /* a road record playing: the first spin this visit stops on that road */
      const rd = rec(), road = ROAD[rd] && !roadDone[rd] && !hunt ? rd : null;
      act('spin', road ? { at: ROAD[road][0] } : undefined);   /* the painter whirs it ('spin') and clacks it to a stop */
      const d = await Promise.race([emitted('spun', 3600), emitted('globecaught', 3600).then((x) => (x && !x.timeout ? Object.assign({ hard: true }, x) : new Promise(() => {})))]);
      if (!live()) return;
      sparkAt('globe', { n: 8, spread: 34 });
      if (hunt) { globeBusy = false; return; }
      if (globeHard || (d && d.hard)) {
        rumble(2);
        await speak([q(next('globeHard', L.globeHard))], undefined, { wait: 4000 });
        globeBusy = false;
        return;
      }
      const first = !st.globe;
      st.globe = 1; save();
      const lines = [];
      let R;
      if (road) {
        roadDone[road] = true;
        const W = ROAD[road];
        R = [W[1], road === 'ash' && tookQuest() ? W[3] : W[2]];
        if (first) lines.push(q(L.globeFirst));
      } else {
        const r = rumourAt(d && d.at);
        R = RUMOURS[r.v];
        if (first) lines.push(q(L.globeFirst));
        else if (r.wrapped) lines.push(q(L.globeAll));
      }
      rumoursTold++;
      lines.push(q(R[1]));
      try { F.result(R[0]); } catch (e) { /* the words still come */ }
      globeSaid = true;
      await speak(lines, undefined, { wait: 5000 });
      globeSaid = false;
      try { F.hideResult(); } catch (e) { /* fine */ }
      if (live() && (rumoursTold === 2 || (rumoursTold > 2 && rumoursTold % 5 === 2))) await speak([q(next('globeAside', L.globeAside))]);
      globeBusy = false;
    }

    /* ================= the hourglass and the feather hunt ================= */
    let hunt = null, glassBusy = false, drainT = 0;
    /* three feathers the first time, one more after each win, up to ten (Jan, 2026-10-07: "each time they beat it it
       gets +1 feather harder"); the sand gets three more seconds for each feather past three */
    const WORDS = ['no', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
    const featherN = () => Math.max(3, Math.min(10, 3 + (st.gold || 0)));
    const nWord = (t, n) => t.replace(/\{N\}/g, WORDS[n].charAt(0).toUpperCase() + WORDS[n].slice(1)).replace(/\{n\}/g, WORDS[n]);
    const featherIds = (n) => Array.from({ length: n }, (_, i) => 'feather-' + i);
    async function tapGlass() {
      if (hunt || glassBusy) { snd('tap'); return; }
      glassBusy = true;
      clearInterval(drainT);
      setV('sand', 0);
      act('flip-glass');
      await pause(RM() ? 0 : 620);
      /* the room is mid-conversation (a choice open, a book or a card out): the glass just turns */
      if (boxBusy()) { glassBusy = false; return; }
      hold();
      const ok = await speak([q(nWord(L.hunt[0], featherN())), q(L.hunt[1])], undefined, { wait: 2500 });
      if (!live()) return;
      if (!ok) { glassBusy = false; release(); return; }
      if (!(await startHunt())) { if (!live()) return; glassBusy = false; await speak([q(L.huntNone)]); release(); return; }
      glassBusy = false;
    }
    /* after a win the glass keeps running, as glasses do, and stops when the sand is all down */
    function drainSand(p, ms) {
      clearInterval(drainT);
      if (RM()) { setV('sand', 1); return; }
      let cur = p, last = performance.now();
      drainT = setInterval(() => {
        if (!live()) { clearInterval(drainT); return; }
        const now = performance.now();
        cur = Math.min(1, cur + (now - last) / ms); last = now;
        setV('sand', cur);
        if (cur >= 1) clearInterval(drainT);
      }, 120);
    }
    /* the feathers' grid points, three in all: the ones the painter hid in its own places (have), and the rest found
       here. Each feather's 44 px button stays clear of every other button and the corner tools, out of where the box
       speaks (the bottom 35% on a phone, the bottom 30% of the middle 70% on a wide screen), spread over different parts
       of the room and at least 56 px apart. When a rule leaves no good set, the next level relaxes it: level 1 lets a
       feather lie where the box would speak (it stays shut while the sand runs), level 2 lets buttons touch, never
       overlap */
    function featherSpots(have, n) {
      n = n || 3;
      have = (have || []).slice(0, n);
      const need = n - have.length;
      if (need <= 0) return have;
      const hs = hotMap();
      if (!hs || !hs.W || !hs.H || !F.art) return null;
      const W = hs.W, H = hs.H, aw = F.art.clientWidth, ah = F.art.clientHeight, k = pxScale(), wide = WIDE();
      const box = (cx, cy, w, hh) => ({ l: cx - w / 2, t: cy - hh / 2, r: cx + w / 2, b: cy + hh / 2 });
      /* every other spot's button as the frame lays it: its rect in CSS px, grown to at least 44 px round its centre.
         The shelves, the window, the ladder and the gallery's row are left out. They're the room's backdrop, a feather
         may lie on them, and the painter trims their buttons round a feather's */
      const btns = Object.keys(hs.spots).filter((id) => !/^(feather-|bay-)/.test(id) && !/^(window|ladder|gallery)$/.test(id)).map((id) => {
        const s = hs.spots[id], a = F.toCss(s.x, s.y), b = F.toCss(s.x + s.w, s.y + s.h);
        return box((a.x + b.x) / 2, (a.y + b.y) / 2, Math.max(44, b.x - a.x), Math.max(44, b.y - a.y));
      });
      have.forEach((p) => { const c = F.toCss(p.x, p.y); btns.push(box(c.x, c.y, 44, 44)); });
      /* and the corner's tools and name, wherever this screen puts them */
      try {
        const ar = F.art.getBoundingClientRect();
        F.el.querySelectorAll('.ffs-top .ffs-tool, .ffs-top .ffs-name').forEach((n) => {
          if (!n.offsetWidth || n.hidden) return;
          const r = n.getBoundingClientRect();
          btns.push({ l: r.left - ar.left - 6, t: r.top - ar.top - 6, r: r.right - ar.left + 6, b: r.bottom - ar.top + 6 });
        });
      } catch (e) { /* fine */ }
      const okAt = (lv) => (gx, gy) => {
        const c = F.toCss(gx, gy), m = lv >= 2 ? 0 : 8;
        if (c.x < 30 || c.x > aw - 30 || c.y < 40 || c.y > ah - 36) return false;
        if (lv < 1 && !wide && c.y > ah * 0.65) return false;
        if (lv < 1 && wide && c.y > ah * 0.7 && c.x > aw * 0.15 && c.x < aw * 0.85) return false;
        const l = c.x - 22 - m, t = c.y - 22 - m, r = c.x + 22 + m, b = c.y + 22 + m;
        for (const o of btns) if (l < o.r && r > o.l && t < o.b && b > o.t) return false;
        return true;
      };
      const step = Math.max(2, Math.round(Math.min(W, H) / 30));
      const dist = (a, b) => Math.hypot((a.x - b.x) * k, (a.y - b.y) * k);
      const want = Math.min(aw, ah) * 0.26;
      /* the room in a 3 x 3 grid: each new feather from a different part when it can */
      const zone = (p) => { const c = F.toCss(p.x, p.y); return Math.min(2, Math.floor(c.x / aw * 3)) + 3 * Math.min(2, Math.floor(c.y / ah * 3)); };
      for (let lv = 0; lv < 3; lv++) {
        const ok = okAt(lv), cand = [];
        for (let gy = step; gy < H - step; gy += step) for (let gx = step; gx < W - step; gx += step) if (ok(gx, gy)) cand.push({ x: gx, y: gy });
        if (cand.length < need) continue;
        const byZone = {};
        cand.forEach((p) => { (byZone[zone(p)] = byZone[zone(p)] || []).push(p); });
        const zones = Object.keys(byZone);
        let best = null, bestD = -1;
        for (let t = 0; t < 240; t++) {
          let pick;
          if (zones.length >= need && t < 160) pick = shuffled(zones.length).slice(0, need).map((i) => { const l = byZone[zones[i]]; return l[rnd(l.length)]; });
          else { pick = []; for (let q = 0; q < need; q++) pick.push(cand[rnd(cand.length)]); }
          const all = have.concat(pick);
          let d = Infinity;
          for (let i = 0; i < all.length; i++) for (let j = i + 1; j < all.length; j++) d = Math.min(d, dist(all[i], all[j]));
          if (d > bestD) { bestD = d; best = all; }
          if (d >= want) break;
        }
        if (best && bestD >= (n > 6 ? 46 : 56)) return best.map((p) => ({ x: Math.round(p.x), y: Math.round(p.y) }));
      }
      return null;
    }
    /* the feathers the painter has laid, as grid points (a feather's spot sits round the point it was given) */
    const painterFeathers = () => {
      const hs = hotMap();
      if (!hs || !hs.spots) return [];
      return Object.keys(hs.spots).filter((id) => /^feather-\d+$/.test(id)).map((id) => { const s = hs.spots[id]; return { x: Math.round(s.x + (s.w - 1) / 2), y: Math.round(s.y + s.h - 1) }; });
    };
    /* the painter hides three in its own places (on shelves, cornices and the boards, clear of every other spot; 3 asks
       for them); when the room only has space for fewer, the ones it hid stay and free spots found here make three */
    async function placeFeathers(n) {
      setV('feathers', n);
      const t0 = Date.now();
      let got = [];
      while (Date.now() - t0 < 700) {
        await pause(60);
        if (!live()) return false;
        got = painterFeathers();
        if (got.length >= n) return true;
        if (got.length && Date.now() - t0 > 300) break;
      }
      const pts = featherSpots(got, n);
      if (!pts) { setV('feathers', null); return false; }
      setV('feathers', pts);
      return true;
    }
    async function startHunt() {
      const n = featherN();
      if (!(await placeFeathers(n)) || !live()) return false;
      hunt = { n, got: Array(n).fill(false), left: n, dur: (RM() ? 25000 : 15000) + (n - 3) * (RM() ? 4000 : 3000), used: 0, last: performance.now(), p: 0, tick: 0, nudge: false, over: false, ticks: 3 };
      setV('sand', 0);
      snd('wings');
      act('hot', 'owl');   /* Soryndel ruffles as the feathers come down */
      hunt.tick = setInterval(huntTick, 100);
      return true;
    }
    /* the sand only runs while the reader can see the room: not in a hidden tab, not with the frame scrolled away */
    function inView() {
      if (document.hidden) return false;
      try { const r = F.art.getBoundingClientRect(), vh = window.innerHeight || 0; return r.height > 0 && (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height > 0.5; } catch (e) { return true; }
    }
    function huntTick() {
      const H = hunt;
      if (!H || H.over) return;
      if (!live()) { clearInterval(H.tick); return; }
      const now = performance.now(), dt = Math.min(250, now - H.last);
      H.last = now;
      if (inView()) H.used += dt;
      const p = Math.min(1, H.used / H.dur);
      if (p - H.p >= 0.005 || p >= 1) { H.p = p; setV('sand', p); }
      /* the last three seconds tick */
      const left = H.dur - H.used;
      if (H.ticks > 0 && left <= H.ticks * 1000 && left > 0) { H.ticks--; snd('tap'); }
      /* halfway and nothing found yet: one soft ring on a feather */
      if (!H.nudge && p >= 0.5 && H.left === H.n) { H.nudge = true; beacon('feather-' + H.got.indexOf(false)); }
      if (p >= 1) endHunt(false);
    }
    function takeFeather(i) {
      const H = hunt;
      if (!H || H.over || H.got[i]) return;
      H.got[i] = true; H.left--;
      const btn = F.el.querySelector('.ffs-hot[data-hot="feather-' + i + '"]');
      act('feather-take', { i });
      snd(H.left ? 'chime' : 'pass');
      beacon(featherIds(H.n), false);
      if (btn && FFD.fx && FFD.fx.pop) FFD.fx.pop(btn, (H.n - H.left) + ' of ' + H.n);
      if (!H.left) endHunt(true);
    }
    function goldLine() {
      const n = st.gold || 1;
      try { if (FFD.tally && FFD.tally.shared) { const t = FFD.tally.total('library', 'feathers'); if (t > n) return L.goldAll.replace('{n}', t.toLocaleString('en-US')); } } catch (e) { /* fine */ }
      return n === 1 ? L.gold1 : L.goldN.replace('{n}', String(n));
    }
    async function endHunt(win) {
      const H = hunt;
      if (!H || H.over) return;
      H.over = true;
      clearInterval(H.tick);
      beacon(featherIds(H.n), false);
      if (win) {
        await emitted('took', 1000);
        if (!live()) return;
        act('hunt-win');
        snd('crit');
        drainSand(H.p, Math.max(600, H.dur - H.used));
        st.gold = (st.gold || 0) + 1; save();
        try { if (api.tally) api.tally('feathers', 1); } catch (e) { /* fine */ }
        await pause(RM() ? 0 : 650);
        await goldFeather();
        if (!live()) return;
        setV('feathers', null);
        hunt = null;
        note('hunt-win');
        const nx = featherN();
        await speak([q(nWord(next('win', L.win), H.n)), q(goldLine()), q(H.n >= 10 ? L.hardest : nWord(L.harder, nx))], undefined, { wait: 4000 });
      } else {
        act('hunt-lose');
        setV('sand', 1);
        await pause(RM() ? 0 : 450);
        if (!live()) return;
        setV('feathers', null);
        hunt = null;
        const ok = await speak([q(L.lose), q(next('lose', L.loseAfter))], undefined, { wait: 4000 });
        /* Bartholomew, once met, has opinions about the hunt */
        if (ok && live() && st.skull && rnd(2)) await speak([q(next('skullLose', L.skullLose))], bart());
      }
      release();
    }
    /* the gold feather lifts off the owl and drops into the binder */
    const flyers = new Set();
    function goldFeather() {
      return new Promise((res) => {
        const a = rectOf('owl'), b = rectOf('binder');
        if (!a || RM() || !F.art || typeof F.art.animate !== 'function') { if (b) sparkAt('binder', { n: 10 }); res(); return; }
        const src = featherPng();
        if (!src) { if (b) sparkAt('binder', { n: 10 }); res(); return; }
        const k = Math.max(2, Math.round(pxScale() * 1.25)), w = FEATHER_ROWS[0].length * k, hh = FEATHER_ROWS.length * k;
        const el = h('i', { class: 'lbg-gold', 'aria-hidden': 'true', style: 'left:' + a.cx + 'px;top:' + a.cy + 'px;width:' + w + 'px;height:' + hh + 'px' }, h('img', { src, alt: '' }));
        F.art.append(el); flyers.add(el);
        /* a few gold sparks fall off it on the way */
        [380, 700, 1000].forEach((ms) => later(() => {
          if (!el.isConnected || !FFD.fx) return;
          const r = el.getBoundingClientRect();
          FFD.fx.sparks(F.art, { x: r.left + r.width / 2, y: r.top + r.height / 2, n: 5, spread: 26 });
        }, ms));
        const to = b ? { x: b.cx, y: b.cy } : { x: a.cx, y: a.cy - 90 };
        const dx = to.x - a.cx, dy = to.y - a.cy, apex = Math.min(0, dy) - Math.max(56, Math.abs(dx) * 0.22);
        const T = (x, y, s, r) => 'translate(calc(-50% + ' + Math.round(x) + 'px), calc(-50% + ' + Math.round(y) + 'px)) scale(' + s + ') rotate(' + r + 'deg)';
        const anim = el.animate([
          { transform: T(0, 0, 0.4, -20), opacity: 0 },
          { transform: T(dx * 0.08, -46, 1.35, 12), opacity: 1, offset: 0.24 },
          { transform: T(dx * 0.55, apex, 1.2, -8), opacity: 1, offset: 0.62 },
          { transform: T(dx, dy, 0.45, 24), opacity: 0.15 }
        ], { duration: 1300, easing: 'cubic-bezier(.45, .05, .4, 1)', fill: 'forwards' });
        let done = false;
        const fin = () => {
          if (done) return; done = true;
          el.remove(); flyers.delete(el);
          if (live()) { sparkAt(b ? 'binder' : 'owl', { n: 16, spread: 70 }); snd('chime'); }
          res();
        };
        anim.onfinish = fin; anim.oncancel = fin;
        setTimeout(fin, 1800);
      });
    }

    /* ================= the mimic ================= */
    let mimicN = 0, mimicGave = false, mimicBusy = false, mimicLiked = false;
    /* from the third day the reader comes, its first tap of a visit: it opens wide, tongue out, and doesn't bite. It
       counts as the first of its three taps, so the card comes when it always did */
    function mimicLikes() {
      if (mimicLiked || mimicN !== 0 || mimicGave || hunt || visitDays() < 3) return false;
      mimicLiked = true; mimicN = 1;
      act('mimic-tongue');
      relabel('mimic', 'The mimic');
      if (!st.mimic) { st.mimic = 1; save(); }
      const n = +eget('mimic.liked', 0) || 0, at = mimicTaps;
      eset('mimic.liked', n + 1);
      /* the words after the wag, unless the reader has tapped it again by then (its growl answers instead) */
      emitted('tongued', 1600).then(() => { if (live() && !hunt && mimicTaps === at) speak([q(n === 0 ? L.mimicLikes[0] : L.mimicLikes[1 + ((n - 1) % (L.mimicLikes.length - 1))])]); });
      return true;
    }
    let mimicTaps = 0;
    function spatFrom(d) {
      try {
        const ar = F.art.getBoundingClientRect();
        let x, y;
        if (d && typeof d.x === 'number' && typeof d.y === 'number') { const c = F.toCss(d.x, d.y); x = c.x; y = c.y; }
        else { const r = rectOf('mimic'); if (!r) return null; x = r.cx; y = r.cy; }
        const w = 28, hh = 40, l0 = ar.left + x - w / 2, t0 = ar.top + y - hh / 2;
        return typeof DOMRect === 'function' ? new DOMRect(l0, t0, w, hh) : { left: l0, top: t0, width: w, height: hh, right: l0 + w, bottom: t0 + hh, x: l0, y: t0 };
      } catch (e) { return null; }
    }
    async function tapMimic() {
      if (mimicBusy) { snd('tap'); return; }
      mimicTaps++;
      if (mimicLikes()) return;
      mimicN++;
      if (mimicN === 1) {
        act('snap', { n: 1 });
        relabel('mimic', 'The mimic');
        if (!st.mimic && !hunt) { st.mimic = 1; save(); speak([q(L.mimicFirst)]); }
        return;
      }
      if (mimicN === 2) { act('snap', { n: 2 }); rumble(3); return; }
      mimicN = 0;
      if (mimicGave || hunt) { act('snap', { n: 2 }); rumble(2); if (!hunt) { speak([q(next('mimicSulk', L.mimicSulk))]); if (mimicGave) note('mimic-sulk'); } return; }
      mimicBusy = true; mimicGave = true;
      hold();
      act('snap', { n: 3 }); rumble(4);
      const cards = api.cards;
      const [d, card] = await Promise.all([
        emitted('spat', 1400),
        cards && typeof cards.next === 'function' ? race((cards.ready ? race(cards.ready(), 4000, false) : Promise.resolve(true)).then(() => cards.next()), 6000, null) : Promise.resolve(null)
      ]);
      if (!live()) return;
      if (card && typeof cards.show === 'function') {
        try { await cards.show(card, { from: spatFrom(d), label: 'The mimic spat out a card', by: L.mimicBy, again: false }); } catch (e) { /* the cards keep their own troubles */ }
        if (!live()) return;
        mimicBusy = false; release();
        note('mimic-gave');
        speak([q(next('mimicAfter', L.mimicAfter))]);
      } else {
        mimicBusy = false; release();
        speak([q(L.mimicNone)]);
      }
    }

    /* ================= the skull: Bartholomew ================= */
    let puns = 0, face = null, darkPun = false;
    /* his portrait in the box is his own pixels, cut from the room's canvas round his spot */
    function skullFace() {
      if (face) return face;
      try {
        const hs = hotMap(), sp = hs && hs.spots && hs.spots.skull;
        const cvs = F.art.querySelectorAll('canvas.qo-scenes__cv'), cv = cvs.length ? cvs[cvs.length - 1] : null;
        if (!sp || !cv || !cv.width || !hs.W) return null;
        const s = cv.width / hs.W, side = Math.max(8, Math.min(18, Math.min(sp.w, sp.h))) + 2;
        const cx = sp.x + sp.w / 2, cy = sp.y + sp.h / 2, sz = Math.max(1, Math.round(side * s));
        const x0 = Math.max(0, Math.min(cv.width - sz, Math.round((cx - side / 2) * s))), y0 = Math.max(0, Math.min(cv.height - sz, Math.round((cy - side / 2) * s)));
        const out = document.createElement('canvas');
        /* a whole number of picture pixels per room pixel, marked so it shows pixelated in the box (the CSS above) */
        const side2 = sz * Math.max(1, Math.ceil(64 / sz));
        out.width = out.height = side2;
        const g = out.getContext('2d');
        g.imageSmoothingEnabled = false;
        g.drawImage(cv, x0, y0, sz, sz, 0, 0, side2, side2);
        face = out.toDataURL('image/png') + '#lbg-px';
      } catch (e) { face = null; }
      return face || null;
    }
    const bart = () => ({ name: 'Bartholomew', img: skullFace() });
    /* every tap answers at once in the art, and his words move on with it: the newest tap's words are the ones said
       (a tap while his line waits fades it, as the room gives way, and the next one comes). Words are made only when
       they're about to be said, so a joke skipped by a quick tap is never used up */
    let skullTaps = 0, skullWant = null, skullLoop = false;
    let hopSaid = false, coughSaid = false, ghostSaid = false, midSaid = false, darkTaps = 0, smokeAt = -1e9;
    const recSaid = {};
    function skullSay(make) {
      skullWant = make;
      if (skullLoop) return;
      skullLoop = true;
      (async () => {
        while (skullWant && live()) {
          const mk = skullWant;
          skullWant = null;
          let r = null;
          try { r = mk(); } catch (e) { r = null; }
          if (!r || !r.lines || !r.lines.length) continue;
          const ok = await speak(r.lines, bart(), { wait: 5000 });
          if (ok && live() && !skullWant && r.after) { try { await r.after(); } catch (e) { /* fine */ } }
        }
        skullLoop = false;
      })();
    }
    /* the next of his sixteen puns (all sixteen before any again, the order kept across visits) */
    function pun(lines) {
      const r = deal(st, 'puns', PUNS.length);
      if (r.wrapped) lines.push(qb(L.skullAll));
      lines.push(qb(PUNS[r.v]));
    }
    /* his class line: the reader's class, told once in this browser. With a greeting already said, no opener */
    function classLines(lines, greeted) {
      const c = me();
      if (!c) return false;
      const k = clsKey(c), told = eget('bart.cls', []);
      const list = Array.isArray(told) ? told.filter((x) => typeof x === 'string' && CLASS_PUN[x]) : [];
      if (list.indexOf(k) >= 0) return false;
      eset('bart.cls', list.concat(k));
      if (!greeted && CLASS_WORD[k]) lines.push(qb(withCls(L.skullClass, k)));
      lines.push(qb(CLASS_PUN[k]));
      return true;
    }
    /* his line for the record playing, once a visit for each record, or for the midnight hour, once a visit */
    function recordLine(lines) {
      if (when().midnight && !midSaid) { midSaid = true; lines.push(qb(next('skullMid', L.skullMid))); return true; }
      const r = rec(), list = SKULL_REC[r];
      if (!list || recSaid[r]) return false;
      recSaid[r] = true;
      lines.push(qb(next('rec-' + r, list)));
      return true;
    }
    /* what he says for this tap: a greeting when one is due, then one joke */
    function skullLines(o) {
      const lines = [];
      let greeted = false;
      if (!st.skull) { st.skull = 1; relabel('skull', 'Bartholomew'); lines.push(qb(eget('bart.crown') ? L.crownHi : L.skullHi)); greeted = true; }
      else if (o.tapN === 1 && eget('bart.crown')) { lines.push(qb(L.crownHi)); greeted = true; }
      if (o.smoke && !coughSaid) { coughSaid = true; lines.push(qb(next('skullCough', L.skullCough))); }
      else if (revealed) {
        /* the dark: his line for it first, and on the third tap his ghost story (once a visit) */
        darkTaps++;
        if (darkPun) { darkPun = false; lines.push(qb(next('skullDark', L.skullDark))); }
        else if (darkTaps >= 3 && !ghostSaid) { ghostSaid = true; L.skullGhost.forEach((t) => lines.push(qb(t))); }
        else pun(lines);
      }
      else if (o.n === 3 && !hopSaid) { hopSaid = true; lines.push(qb(next('skullHop', L.skullHop))); }
      /* the reader's class the first time he knows it, else the record's line once a visit, else a pun */
      else if (!classLines(lines, greeted) && !recordLine(lines)) pun(lines);
      save();
      puns++;
      note('pun', { n: puns });
      eset('bart.puns', Math.min(9999, (+eget('bart.puns', 0) || 0) + 1));
      /* every other one, Soryndel turns away */
      if (puns % 2 === 0) later(() => act('hot', 'owl'), RM() ? 0 : 900);
      const n = puns;
      return { lines, after: () => (n === 3 || (n > 3 && n % 5 === 3) ? speak([q(next('skullAside', L.skullAside))]) : null) };
    }
    let skullLit = false;
    function tapSkull() {
      if (skullLit) { skullLit = false; beacon('skull', false); }
      /* while he tells the bridge, a tap only clacks (the story waits for the reader) */
      if (bridge) { act('clack', { n: 1 }); return; }
      const n = burst('skull', 3000);
      skullTaps++;
      /* five taps inside 3 s knock his jaw off: once a visit, once Deathrend is found, never during the hunt */
      if (!jaw && !jawDone && n >= 5 && !hunt && has('necromancer-deathrend')) { knockJaw(); return; }
      if (jaw) { act('clack', { n: 1 }); if (!hunt) skullSay(() => ({ lines: [qb(next('mmf', L.mmf))] })); return; }
      const smoke = Date.now() - smokeAt < 3000;
      act('clack', smoke ? { mode: 'cough' } : { n: n >= 4 ? (n % 2 ? 3 : 2) : n });
      if (hunt) return;
      const tapN = skullTaps;
      /* a fresh tap on a calm record, when he's ready: the bridge */
      if (n === 1 && bridgeReady()) { openBridge(); return; }
      skullSay(() => skullLines({ n, smoke, tapN }));
    }

    /* ---- his jaw: off at five quick taps, back on with a tap on it (the spot 'skull-jaw'), or by Zhaunil once nobody
       has touched anything for 20 s (a stillness border's 15 s always comes first, so this never resets it) ---- */
    let jaw = null, jawDone = false;
    function knockJaw() {
      jaw = { at: Date.now() }; jawDone = true;
      act('jaw-off');
      eset('bart.jaw', (+eget('bart.jaw', 0) || 0) + 1);
      /* each speaker in their own beat, so the box names who said what */
      skullSay(() => ({ lines: [qb(L.jawOff[0])], after: () => (jaw ? speak([qz(L.jawOff[1])]) : null) }));
      jawWatch();
    }
    function jawBack(auto) {
      if (!jaw) return;
      jaw = null;
      act('jaw-on');
      if (auto) { speak([qz(next('jawAuto', L.jawAuto))]); return; }
      const n = +eget('bart.jawOn', 0) || 0;
      eset('bart.jawOn', n + 1);
      skullSay(() => ({ lines: [qb(n === 0 ? L.jawOn[0] : L.jawOn[1 + ((n - 1) % (L.jawOn.length - 1))])] }));
    }
    function jawWatch() {
      later(() => {
        if (!jaw) return;
        /* nothing on the way into the box, no hunt, nothing over the art, and 20 s since anyone touched anything */
        if (!hunt && !waiting && !skullLoop && !boxBusy() && Date.now() - Math.max(jaw.at, lastTouch) >= 20000) { jawBack(true); return; }
        jawWatch();
      }, 500);
    }
    const tapJaw = () => { if (jaw) jawBack(false); };

    /* ---- the bridge: after eight jokes in all, or once his page in the memory book has shown (memories.js marks
       bart.page). A fresh tap on a calm record asks, once a visit; a no, or a miss, asks again another day ---- */
    let bridge = null, bridgeAsked = false;
    function bridgeReady() {
      if (bridge || bridgeAsked || !st.skull || eget('bart.crown') || revealed || hunt || jaw || !calmRec()) return false;
      if (!eget('bart.page') && (+eget('bart.puns', 0) || 0) < 8) return false;
      const d = eget('bart.day', '');
      return !(typeof d === 'string' && d && d >= today());
    }
    async function openBridge() {
      bridge = 'ask'; bridgeAsked = true;
      const again = !!eget('bart.tried');
      const why = again ? L.bridgeAgain : eget('bart.page') ? L.bridgePage : L.bridgePuns;
      try {
        if (!(await boxFree(4000)) || hunt || typeof api.ask !== 'function') return;
        let pick = null;
        try { pick = await api.ask([{ label: L.bridgeYes, value: 'bridge' }, { label: L.bridgeNo, value: 'joke' }], { cols: 2, who: bart(), lines: [qb(why)] }); } catch (e) { pick = null; }
        if (!live() || !pick) return;
        if (pick.value !== 'bridge' && pick.index !== 0) {
          eset('bart.day', today());
          bridge = null;
          skullSay(() => skullLines({ n: 1, smoke: false, tapN: 2 }));
          return;
        }
        bridge = 'story';
        if (!(await speak((again ? L.bridgeStory.slice(-1) : L.bridgeStory).map(qb), null, { wait: 3000 })) || !live()) return;
        /* the reader opted in: the room holds for the roll */
        bridge = 'roll';
        hold();
        let r = null;
        try { r = await F.roll({ dice: [{ sides: 20 }], now: true, hot: 'skull', dc: 15 }); } catch (e) { r = null; }
        release();
        if (!live() || !r) return;
        eset('bart.tried', 1);
        bridge = 'end';
        const nat = r.nat != null ? r.nat : r.total;
        if (nat >= 15) {
          act('clack', nat === 20 ? { mode: 'laugh' } : { n: 2 });
          eset('bart.crown', 1);
          setV('crown', true);
          sparkAt('skull', { n: 18, spread: 50 });
          if (await speak([qb(nat === 20 ? L.bridge20 : L.bridgeHeld)], null, { wait: 4000 })) await speak([qz(L.crownZh)]);
        } else {
          eset('bart.day', today());
          if (nat === 1) { act('clack', { mode: 'rattle' }); rumble(3); await speak([qb(L.bridge1)], null, { wait: 4000 }); }
          else await speak([qb(L.bridgeFell)], null, { wait: 4000 });
        }
      } finally { if (bridge) bridge = null; }
    }
    /* the crown he earned stays on him */
    if (eget('bart.crown')) setV('crown', true);
    /* his page in the memory book (memories.js): once the book closes and the room is quiet, he catches the reader's eye */
    function onEgg(e) {
      const d = e && e.detail;
      if (!d || d.page !== 'library' || d.what !== 'bartpage' || !live() || eget('bart.crown')) return;
      let tries = 0;
      (function look() {
        later(() => {
          if (++tries > 240 || eget('bart.crown')) return;
          if (covered() || boxBusy() || hunt || !bridgeReady()) { look(); return; }
          skullLit = true; beacon('skull');
          later(() => { if (skullLit) { skullLit = false; beacon('skull', false); } }, 6000);
        }, 500);
      })();
    }
    document.addEventListener('ffd:egg', onEgg);

    /* ================= the potions ================= */
    let potN = 0, smokes = 0;
    function tapPotions() {
      potN = potN % 5 + 1;
      act('bubble', { n: potN });
      note('bubble', { n: potN });
      if (potN < 5) return;
      /* Bartholomew tapped within 3 s of this coughs along with Soryndel */
      smokeAt = Date.now();
      /* a puff of smoke over the room */
      try { if (FFD.fx && !RM()) FFD.fx.flash('rgba(176, 196, 164, .26)', F.el); } catch (e) { /* fine */ }
      later(() => snd('pat'), RM() ? 0 : 520);
      later(() => snd('pat'), RM() ? 0 : 660);
      /* Zhaunil apologises for the smoke; every other time Bartholomew (once met) warns the reader off instead */
      smokes++;
      later(() => {
        if (hunt) return;
        if (st.skull && smokes % 2 === 0) speak([q(L.skullPotion)], bart());
        else speak([q(next('potion', L.potion))]);
      }, RM() ? 0 : 950);
    }

    /* ================= the cat: Footnote ================= */
    let catN = 0, catBusy = false;
    async function tapCat() {
      if (catBusy) { snd('tap'); return; }
      catN = catN % 2 + 1;
      if (catN === 1 || hunt) {
        catN = 1;
        act('cat', { n: 1 });
        if (!st.cat && !hunt) { st.cat = 1; save(); relabel('cat', 'Footnote'); speak([q(L.catHi)]); }
        return;
      }
      catBusy = true;
      act('cat', { n: 2 });
      await emitted('bookfell', 1600);
      if (!live()) return;
      rumble(2);
      let b = null;
      try { b = typeof api.pickUnread === 'function' ? api.pickUnread() : null; } catch (e) { b = null; }
      if (!b || !b.t) { await speak([q(L.catNone)]); catBusy = false; return; }
      if (!(await boxFree(4000)) || hunt || typeof api.ask !== 'function') { catBusy = false; return; }
      let pick = null;
      try {
        pick = await api.ask([{ label: 'Read it', value: 'read' }, { label: 'Leave it', value: 'leave' }],
          { cols: 2, who: ZH, prompt: L.catAsk, lines: [q(L.catOffer), { text: String(b.t).split(/\s+[|]\s+/)[0], cls: 'gold' }, q(L.catAsk)] });
      } catch (e) { pick = null; }
      catBusy = false;
      if (!live() || !pick) return;
      if (pick.value === 'read' || pick.index === 0) { try { if (api.openBook) api.openBook(b, L.catFrom); } catch (e) { /* the room shows its own fallback */ } return; }
      speak([q(next('catLeave', L.catLeave))]);
    }

    /* ================= the candles and Zhaunil's journal ================= */
    let revealed = false, journalOpen = false, relighting = false, jr = null, lastFocus = null;
    const candleIds = () => { const hs = hotMap(); return hs && hs.spots ? Object.keys(hs.spots).filter((id) => /^candle-\d+$/.test(id)).map((id) => +id.slice(7)) : []; };
    function candleCount() {
      const v = getV(CANDLES), ids = candleIds();
      return Math.min(MAX_CANDLES, Math.max(Array.isArray(v) ? v.length : 0, ids.length ? Math.max.apply(null, ids) + 1 : 0)) || 4;
    }
    function litNow(n) {
      const v = getV(CANDLES), a = [];
      for (let k = 0; k < n; k++) a.push(Array.isArray(v) && typeof v[k] === 'boolean' ? v[k] : true);
      return a;
    }
    function tapCandle(i) {
      if (journalOpen || relighting) { snd('tap'); return; }
      const n = candleCount();
      if (i >= n) return;
      const lit = litNow(n), allLit = lit.every((v) => v);
      lit[i] = !lit[i];
      /* a candle the reader can't reach (no spot on this screen) goes out with the last one they can */
      const reach = candleIds();
      if (!lit[i] && reach.length && reach.every((k) => k >= n || !lit[k])) for (let k = 0; k < n; k++) lit[k] = false;
      setV(CANDLES, lit);
      act('candle', { i, on: lit[i] });   /* the painter snuffs or lights it, with its own sound */
      /* the order they go out in, since the last one was lit */
      if (lit[i] || allLit) outSeq = [];
      if (!lit[i] && outSeq.indexOf(i) < 0) outSeq.push(i);
      if (lit.every((v) => !v)) { if (inOrder(reach) && st.journal && !starsDone) stars(); else reveal(); note('dark'); }
      else if (revealed) { revealed = false; beacon('journal', false); note('light'); }
    }
    /* put out left to right: every candle the reader can reach, each tapped out in turn by where it stands */
    let outSeq = [], starsDone = false;
    function inOrder(reach) {
      const hs = hotMap();
      if (!hs || !hs.spots || !reach || reach.length < 2) return false;
      const x = (k) => { const s = hs.spots['candle-' + k]; return s ? s.x + s.w / 2 : Infinity; };
      const want = reach.slice().sort((a, b) => x(a) - x(b) || a - b);
      const got = outSeq.filter((k) => reach.indexOf(k) >= 0);
      return got.length === want.length && got.every((k, j) => k === want[j]);
    }
    /* three stars cross the window instead of the journal lighting (once a visit, once the journal has been found).
       The room stays dark until a candle is lit, so whatever waits in the dark still does */
    function stars() {
      revealed = true; darkPun = true; starsDone = true;
      act('candle-stars');
      const n = +eget('stars.n', 0) || 0;
      eset('stars.n', n + 1);
      emitted('candlestarred', 2400).then(() => { if (live() && !hunt && revealed) speak([q(L.stars[n % L.stars.length])]); });
    }
    /* the room goes dark; a moment later the painter lights the journal by itself (with its chime). The event follows in
       case it didn't, and a soft ring finds the journal for a reader who hasn't spotted it */
    function reveal() {
      revealed = true;
      darkPun = true;
      later(() => { if (revealed && !journalOpen) act('reveal-journal'); }, RM() ? 0 : 1900);
      later(() => { if (revealed && !journalOpen) beacon('journal'); }, RM() ? 2500 : 5200);
    }
    /* once the reader's character is known, a note at the foot of the page, in a hand added later (text, never HTML) */
    function journalMe() {
      const c = me();
      if (!c) return null;
      let t = withCls(L.journalMe, clsKey(c));
      try { t = FFD.fmt ? FFD.fmt(t) : t.replace(/\{Name\}/g, String(c.name)).replace(/\{them\}/g, 'them'); } catch (e) { return null; }
      return h('p', { class: 'lbg-jx', text: t });
    }
    function buildJournal() {
      const me0 = journalMe();
      const page = h('article', { class: 'lbg-jp' + (me0 ? ' has-note' : '') },
        h('p', { class: 'lbg-jk', text: JOURNAL.kicker }),
        h('h2', { class: 'lbg-jt', id: 'lbg-jt', text: JOURNAL.title }),
        JOURNAL.paras.map((t) => h('p', { text: t })),
        h('p', { class: 'lbg-jq', text: JOURNAL.quote }),
        h('p', { class: 'lbg-jn', text: JOURNAL.sign }),
        me0);
      const btn = h('button', { type: 'button', class: 'lbg-jc', text: JOURNAL.close });
      btn.addEventListener('click', (e) => { e.stopPropagation(); closeJournal(); });
      page.append(btn);
      const ov = h('div', { class: 'lbg-jr', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'lbg-jt' }, page);
      ov.addEventListener('click', (e) => { e.stopPropagation(); if (!page.contains(e.target)) closeJournal(); });
      return ov;
    }
    function openJournal() {
      if (!revealed || journalOpen || relighting) return;
      journalOpen = true;
      hold();
      beacon('journal', false);
      snd('flip');
      lastFocus = document.activeElement;
      jr = buildJournal();
      F.el.append(jr);
      requestAnimationFrame(() => { if (jr) jr.classList.add('is-in'); });
      later(() => { const b = jr && jr.querySelector('.lbg-jc'); if (b) b.focus({ preventScroll: true }); }, RM() ? 0 : 280);
      relabel('journal', 'Zhaunil’s journal');
    }
    async function closeJournal() {
      if (!journalOpen || !jr) return;
      const ov = jr;
      jr = null; journalOpen = false; revealed = false; relighting = true;
      note('light');
      ov.classList.remove('is-in'); ov.classList.add('is-out');
      setTimeout(() => ov.remove(), RM() ? 0 : 240);
      try { if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true }); } catch (e) { /* fine */ }
      snd('flip');
      await pause(RM() ? 0 : 320);
      const n = candleCount();
      for (let k = 0; k < n; k++) {
        if (!live()) return;
        const lit = litNow(n);
        lit[k] = true;
        setV(CANDLES, lit);
        act('candle', { i: k, on: true });
        await pause(RM() ? 0 : 170);
      }
      if (!live()) return;
      relighting = false;
      const first = !st.journal;
      st.journal = 1; save();
      release();
      speak([q(first ? L.journal1 : L.journal2)]);
    }
    const onKey = (e) => {
      if (!live()) { document.removeEventListener('keydown', onKey, true); return; }
      if (!journalOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeJournal(); return; }
      /* the page holds the keyboard while it's open: its one button keeps the focus */
      if (e.key === 'Tab') { const b = jr && jr.querySelector('.lbg-jc'); if (b) { e.preventDefault(); b.focus({ preventScroll: true }); } }
    };
    document.addEventListener('keydown', onKey, true);

    /* ================= the window and the shooting star ================= */
    let starAt = -1e9, starMs = 900, lastStar = Date.now(), winN = 0, wishing = false;
    /* 'starshown' { dur } comes as a star starts across; a tap counts while it crosses, and a breath after */
    listen('starshown', (d) => { starAt = lastStar = Date.now(); starMs = Math.max(600, Math.min(4000, (+d.dur || 0.9) * 1000)); });
    const starLive = () => Date.now() - starAt < starMs + (RM() ? 1800 : 700);
    /* a star soon, unless one is crossing now (Zhaunil has just promised one, so a star that crossed a while ago
       doesn't count) */
    let starPending = false;
    function starSoon(ms) {
      if (starPending || Date.now() - starAt < 4000) return;
      starPending = true;
      lastStar = Date.now();
      later(() => { starPending = false; if (!hunt) act('star'); }, ms);
    }
    /* the painter sends its own stars about every 40 s; if none has crossed for a minute, one is asked for */
    (function watch() {
      later(() => {
        if (!RM() && !document.hidden && !hunt && Date.now() - lastStar > 62000) { lastStar = Date.now(); act('star'); }
        watch();
      }, 6000);
    })();
    function wishLine() {
      const n = st.wishes || 1;
      try { if (FFD.tally && FFD.tally.shared) { const t = FFD.tally.total('library', 'wishes'); if (t > n) return L.wishAll.replace('{n}', t.toLocaleString('en-US')); } } catch (e) { /* fine */ }
      return n === 1 ? L.wish1 : L.wishN.replace('{n}', String(n));
    }
    async function wish() {
      wishing = true;
      act('hot', 'window');
      snd('lights');
      sparkAt('window', { n: 22, spread: 80, colors: ['#fff6dc', '#dfe9ff', '#f4d68a', '#bcd0ff'] });
      st.wishes = (st.wishes || 0) + 1; save();
      try { if (api.tally) api.tally('wishes', 1); } catch (e) { /* fine */ }
      note('wish', { n: st.wishes });
      await pause(RM() ? 0 : 380);
      const ok = await speak([q(L.wish)], undefined, { wait: 2500 });
      if (ok && live()) await speak([q(wishLine())]);
      wishing = false;
    }
    function tapWindow() {
      if (wishing) { snd('tap'); return; }
      if (starLive() && !hunt) { wish(); return; }
      act('hot', 'window');
      snd('tap');
      if (hunt) return;
      winN++;
      if (winN === 1) { speak([q(L.window[0])]); return; }
      /* the second tap tells the reader about the stars, and one comes soon after the words go */
      if (winN === 2) { speak([q(L.window[1])]).then((ok) => { if (ok) starSoon(RM() ? 400 : 1300 + rnd(1300)); }); return; }
      if (winN % 6 === 0) { speak([q(L.window[2])]); return; }
      if (winN % 3 === 0) starSoon(RM() ? 300 : 700 + rnd(900));
    }

    /* ================= the hotspots ================= */
    const add = (id, label, fn) => {
      defs[id] = {
        label, sound: false,
        tap: () => {
          if (!live()) return;
          try { const r = fn(); if (r && typeof r.catch === 'function') r.catch((e) => console.error(e)); } catch (e) { console.error(e); }
        }
      };
    };
    add('globe', 'The globe', tapGlobe);
    add('hourglass', 'The hourglass', tapGlass);
    add('mimic', st.mimic ? 'The mimic' : 'An old book', tapMimic);
    add('skull', st.skull ? 'Bartholomew' : 'A skull', tapSkull);
    /* the painter has this spot only while his jaw lies off */
    add('skull-jaw', 'Bartholomew’s jaw', tapJaw);
    add('potions', 'Three bottles', tapPotions);
    add('cat', st.cat ? 'Footnote' : 'The cat', tapCat);
    for (let i = 0; i < MAX_CANDLES; i++) add('candle-' + i, 'A candle', () => tapCandle(i));
    add('journal', st.journal ? 'Zhaunil’s journal' : 'A glowing book', openJournal);
    for (let i = 0; i < 10; i++) add('feather-' + i, 'A white feather', () => takeFeather(i));
    add('window', 'The window', tapWindow);

    /* ================= the interface ================= */
    games.busy = () => !!(hunt || glassBusy || journalOpen || relighting || mimicBusy || bridge === 'roll');
    games.trophies = () => ({ feathers: st.gold || 0, wishes: st.wishes || 0 });
    /* the skull answers every tap, so the room's repeat-tap poke skips him (never while he tells the bridge) */
    games.wantsEveryTap = (id) => id === 'skull' && !bridge;
    /* read-only, for checks (as the borders keep F.el.__lbBorders) */
    try {
      Object.defineProperty(F.el, '__lbGames', { configurable: true, value: {
        state: () => ({ puns, skullTaps, jaw: !!jaw, jawDone, bridge, bridgeAsked, starsDone, outSeq: outSeq.slice(), mimicLiked, mimicN, hunt: !!hunt, waiting, revealed, rec: rec(), calm: calmRec() }),
        wantsEveryTap: games.wantsEveryTap, bridgeReady
      } });
    } catch (e) { /* fine */ }
    games.close = () => {
      if (closed) return;
      const wasHunt = !!hunt, wasDark = revealed || journalOpen || relighting;
      closed = true;
      timers.forEach((t) => clearTimeout(t)); timers.clear();
      if (hunt) { clearInterval(hunt.tick); hunt = null; }
      offs.splice(0).forEach((off) => { try { off(); } catch (e) { /* fine */ } });
      document.removeEventListener('keydown', onKey, true);
      document.removeEventListener('ffd:egg', onEgg);
      window.removeEventListener('pointerdown', touched, true);
      window.removeEventListener('keydown', touched, true);
      try { delete F.el.__lbGames; } catch (e) { /* fine */ }
      if (jr) { jr.remove(); jr = null; }
      flyers.forEach((el) => el.remove()); flyers.clear();
      journalOpen = false; relighting = false; glassBusy = false; mimicBusy = false;
      if (alive()) {
        if (wasHunt) { setV('feathers', null); beacon(featherIds(10), false); }
        if (wasDark) setV(CANDLES, litNow(candleCount()).map(() => true));
        if (holds) { holds = 0; try { if (api.busy) api.busy(false); } catch (e) { /* fine */ } }
      }
    };
    return games;
  };
})();

/* ===== src/scene-pages/pages/library/jukebox.js ===== */
/* library/jukebox.js: the jukebox's director (a part of the library page). Jan (2026-10-07): a jukebox where readers
   "can change the songs but they cant control it", and the room changes with each record; the plan and Jan's fixes are
   docs/scene-pages/jukebox/README.md, the playable pitch docs/scene-pages/jukebox/pitch/.

   It decides which record plays and when the room may change, and runs every guest's flow. The pictures are the moods
   part's (library/moods.js, drawn inside the painter), the sound the music part's (library/music.js), the gifts the
   borders part's (give/has), Yost's packs the cards part's, the book the memories part's, the fight the fight part's.
     one tap, one change: the jukebox jolts, its disc window flicks through other records and lands; the reader never picks
     calm and road records take turns: calm cycles quiet, hearth, after; road records come in the Quest's order the
       first time (regal, bog, tinker, tavern, flood, ash), then shuffle with any record still holding a gift first
     a road record plays until the jukebox is tapped again; beating the Iron Matron is the one time it changes by itself
     three quick taps while it turns skip the needle: one more spin of the disc window, the same record (the needle skip)
     "Have you met her before?" is asked only of a reader FFD.quest doesn't know (src/scene-pages/quest-id.js); the
       jukebox never reads the Quest's own run
     while a card, the book, a pack, the binder or the fight is open the jukebox waits (the room's own give-way rules)
   Per reader, in this browser only (localStorage 'ffd-library-jukebox'): the bag's place, records heard, the stops whose
   gift was taken (the lamps turn gold), the keepsakes on the jukebox, the Hollow Stump's toast, whether the reader was
   asked about the Iron Matron, and which first lines Zhaunil has said.

   FFD.parts['library/jukebox'](api) -> jukebox
     jukebox.enter(o)   after the Enter gate: the first record, the jukebox wakes (o.first: first visit)
     jukebox.rec() -> record id        jukebox.calm() -> bool        jukebox.busy() -> a change is turning
     jukebox.owlTap() -> true when the After Hours owl took the tap      jukebox.jukeLines() -> Zhaunil's words on it
     jukebox.resume()   the music again after the browser's back/forward cache (on the reader's next touch)
     jukebox.close()
   The room gives: F, h, RM, snd(name, o), buzz(ms), ZH, talk(lines, who), ask(prompt, options, o, who), aside(t, who),
   tapTo(id, name, fn, ro), step(tok, p), NOGIVE, leaveAsk(o) (a way out, asked once), leaveNow(o) (a way out the reader's
   choice already named, straight to the fade), hots(map), lookAt(gx, o), music, moods, borders, cards, memories, fight,
   live(text), plate(name, col), ink(hex), free() */
(() => {
  'use strict';
  const FFD = window.FFD = window.FFD || {};
  FFD.parts = FFD.parts || {};

  const REC = {
    quiet: { name: 'Quiet Alehouse', col: '#e8a85a', ink: '#16110a', home: true },
    hearth: { name: 'Hearthside Echoes', col: '#ff8a3d', ink: '#1a1009', home: true },
    after: { name: 'After Hours', col: '#f0c070', ink: '#1c130b', home: true },
    regal: { name: 'Regal Wayfarer', col: '#6f8cff', ink: '#13101d' },
    bog: { name: 'Murmurs in the Bog', col: '#8fe07a', ink: '#0b140e' },
    tinker: { name: 'Tinker’s Evening Route', col: '#e09a4a', ink: '#1b1208' },
    tavern: { name: 'Shadows in the Tankard', col: '#d0603a', ink: '#170d07' },
    flood: { name: 'Blackwater Pressure', col: '#3fb8b0', ink: '#050c10' },
    ash: { name: 'Ash in the Alehouse', col: '#ff3b30', ink: '#07080c' }
  };
  const HOME = ['quiet', 'hearth', 'after'], FIRST = ['regal', 'bog', 'tinker', 'tavern', 'flood', 'ash'], ORDER = HOME.concat(FIRST);
  /* where the camera looks for each record, as a share of the room's width (the phone's room pans) */
  const LOOK = { quiet: 0.13, hearth: 0.13, after: 0.13, regal: 0.82, bog: 0.13, tinker: 0.8, tavern: 0.6, flood: 0.5, ash: 0.78 };
  /* each road record's gift, for the shuffle (a record still holding something comes first) and the gold lamps */
  const GIFTS = {
    regal: ['paladin-regal', 'paladin-imperial', 'fighter-steelveil'], bog: ['sorcerer-verdictus', 'druid-verdant', 'necromancer-gravebloom'],
    tinker: ['fighter-ironhide', 'barbarian-marbleborn'], tavern: ['rogue-nightshade'], flood: ['sorcerer-umbral', 'monk-blue-and-gray'],
    ash: ['necromancer-lichspire', 'rogue-thorncloak']
  };
  const SK = 'ffd-library-jukebox';

  /* Zhaunil, once per browser when each record first plays */
  const FIRSTLINE = {
    regal: ['The King’s Road. They always wipe their boots, at least.'],
    bog: ['The Blackfen. Mind your step. The floor thinks it’s a swamp now.'],
    tinker: ['Yost. You still owe me a book.'],
    tavern: ['The Hollow Stump. Don’t stare back. It only encourages them.'],
    flood: ['That book only floats up when the water comes in.'],
    ash: ['Stay near the crystal. Something heard that song.']
  };
  const HOMELINE = { quiet: 'Quiet again. Good.', hearth: 'Someone lit the hearth. It wasn’t me.', after: 'Rain. Nobody leaves early on a night like this.' };
  /* the frog's keepsake is a small brass frog on the crown, never the live one (moods.js; Jan, 2026-10-11: "the frog
     seems to spawn when its not the frog scene"). Zhaunil names it once, the first time the bog leaves with it there, and
     the live frog, tapped through again by a reader who already has her green, keeps it */
  const FROG_BRASS = 'I had her cast in brass. The real one never sits still.';
  const FROG_AGAIN = 'She gave you hers already. Now she just likes the company.';
  const YOST = { name: 'Old Yost', img: null }, MAREN = { name: 'Sergeant Maren Vos', img: null }, PATRON = { name: 'A patron', img: null }, MATRON = { name: 'The Iron Matron', img: null };

  FFD.parts['library/jukebox'] = function (api) {
    const { F, RM, snd } = api;
    const buzz = (ms) => { try { if (api.buzz) api.buzz(ms); } catch (e) { /* fine */ } };
    const moods = api.moods, music = api.music, borders = api.borders, cards = api.cards;
    let closed = false, cur = 'quiet', lock = 0, turning = false, toldLock = false, salutes = 0, saluteAt = -1e9, prefetchT = 0, resumeOnTouch = false;
    const offs = [], timers = new Set();
    const later = (ms, fn) => { const t = setTimeout(() => { timers.delete(t); if (!closed) fn(); }, ms); timers.add(t); return t; };
    const now = () => performance.now();
    const has = (k) => { try { return !!(borders && borders.has && borders.has(k)); } catch (e) { return false; } };
    const give = (k, o) => { try { return borders && borders.give ? Promise.resolve(borders.give(k, o || {})) : Promise.resolve(); } catch (e) { return Promise.resolve(); } };
    const mood = (fn) => { try { if (moods) fn(moods); } catch (e) { console.error(e); } };

    /* ---- the reader's jukebox, kept in this browser ---- */
    const st = (() => {
      const d = { bagAt: 0, last: null, homeAt: 0, heard: {}, gold: {}, keep: [], saw: false, met: null, said: {} };
      try {
        const v = JSON.parse(localStorage.getItem(SK) || 'null');
        if (v && typeof v === 'object') {
          if (isFinite(+v.bagAt)) d.bagAt = Math.max(0, Math.min(FIRST.length, +v.bagAt));
          if (FIRST.includes(v.last)) d.last = v.last;
          if (isFinite(+v.homeAt)) d.homeAt = Math.max(0, +v.homeAt) % 3;
          ['heard', 'gold', 'said'].forEach((k) => { if (v[k] && typeof v[k] === 'object') Object.keys(v[k]).forEach((x) => { if (ORDER.includes(x) || k === 'said') d[k][x] = true; }); });
          if (Array.isArray(v.keep)) d.keep = v.keep.filter((x) => ['frog', 'tankard', 'cup'].includes(x));
          d.saw = v.saw === true; d.met = v.met === 'quest' || v.met === 'never' ? v.met : null;
        }
      } catch (e) { /* fine */ }
      return d;
    })();
    const save = () => { try { localStorage.setItem(SK, JSON.stringify(st)); } catch (e) { /* fine */ } };
    const lamps = () => mood((m) => { m.juke('lamps', { heard: st.heard, gold: st.gold }); m.juke('keep', { items: st.keep.slice() }); });
    const keepsake = (k) => { if (!st.keep.includes(k)) { st.keep.push(k); save(); lamps(); } };
    const goldOf = (rec) => { if (!st.gold[rec]) { st.gold[rec] = true; save(); lamps(); } };
    const said = (k) => { if (st.said[k]) return true; st.said[k] = true; save(); return false; };

    /* ---- the next record: the reader never picks ---- */
    function nextRecord() {
      if (REC[cur].home) {
        let id;
        if (st.bagAt < FIRST.length) id = FIRST[st.bagAt++];
        else {
          const waiting = FIRST.filter((r) => r !== st.last && (GIFTS[r] || []).some((k) => !has(k)));
          const pool = (waiting.length ? waiting : FIRST.filter((r) => r !== st.last));
          id = pool[Math.floor(Math.random() * pool.length)];
        }
        st.last = id; save();
        return id;
      }
      st.homeAt = (st.homeAt + 1) % 3; save();
      return HOME[st.homeAt];
    }
    const roadHeard = () => FIRST.slice(0, 3).some((k) => st.heard[k]);

    /* ---- a change: the jolt, the roulette, the needle, the landing, then the room ---- */
    async function change(id, o) {
      o = o || {};
      if (closed || !REC[id]) return;
      const from = cur, toHome = !!REC[id].home;
      turning = true;
      lock = now() + (o.quick ? 600 : toHome ? 3200 : 3600);
      snd('latch'); buzz(12);
      mood((m) => m.juke('jolt'));
      try { music.needle(); } catch (e) { /* fine */ }
      if (!o.quick && !RM()) {
        const others = ORDER.filter((x) => x !== id && x !== from).sort(() => Math.random() - 0.5).slice(0, 4);
        mood((m) => m.juke('roulette', { cols: others.map((x) => REC[x].col) }));
        [0, 100, 230, 400].forEach((t) => later(t, () => snd('tap')));
      }
      later(o.quick ? 0 : 150, () => { try { music.play(id, toHome ? 3 : 2.4); } catch (e) { /* fine */ } });
      await new Promise((r) => later(o.quick || RM() ? 60 : 600, r));
      if (closed) return;
      snd('land');
      cur = id;
      st.heard[id] = true; save();
      mood((m) => { m.juke('land', { id }); m.record(id, { from, quick: !!o.quick }); });
      api.ink(REC[id].ink);
      api.plate(REC[id].name, REC[id].col);
      api.live('Now playing ' + REC[id].name + '.');
      lamps();
      api.lookAt(LOOK[id], { share: true, dur: 1000 });
      if (id === 'tinker' && cards && cards.yost) { try { cards.yost.load(); } catch (e) { /* fine */ } }
      clearTimeout(prefetchT);
      if (toHome) prefetchT = later(20000, () => { try { music.prefetch(st.bagAt < FIRST.length ? FIRST[st.bagAt] : FIRST[0]); } catch (e) { /* fine */ } });
      turning = false;
      /* the bog leaving with the frog's keepsake on the crown: the brass frog comes up in her place, and Zhaunil names it
         once (in place of the record's home line, which waits for another time) */
      if (!o.quiet && from === 'bog' && id !== 'bog' && st.keep.includes('frog') && !st.said['frog-brass']) {
        later(3000, () => { if (cur === id && api.free() && !said('frog-brass')) api.aside(FROG_BRASS); });
      } else if (!o.quiet && toHome && from !== id && !REC[from].home && !said('home-' + id)) later(3000, () => { if (api.free()) api.aside(HOMELINE[id]); });
    }
    /* the study's records (library/study.js): a calm record with no jolt, roulette, needle, plate or line, because the
       room is covered; the room's mood follows quietly, so standing up finds the record that's playing. Keyed off the
       player, so a record already playing never restarts */
    function calmTo(id) {
      if (closed || !REC[id] || !REC[id].home) return;
      if (music.id !== id) { try { music.play(id, 4); } catch (e) { /* fine */ } }
      if (id === cur) return;
      const from = cur;
      cur = id; st.heard[id] = true; const hi = HOME.indexOf(id); if (hi >= 0) st.homeAt = hi; save();
      mood((m) => m.record(id, { from, quick: true }));
      api.ink(REC[id].ink); lamps();
    }
    /* the one time the jukebox changes by itself: the Iron Matron has fallen */
    function selfChange() {
      later(400, () => {
        st.homeAt = (st.homeAt + 1) % 3; save();
        change(HOME[st.homeAt], { quiet: true }).then(() => later(3600, () => { if (api.free()) api.aside('She’ll be back behind her bar by morning. She always is.'); }));
      });
    }

    /* ---- the jukebox's own tap ---- */
    const taps = () => { try { return FFD.burst ? FFD.burst('jb-juke', 2000) : 1; } catch (e) { return 1; } };
    /* the needle skip: three quick taps while it turns. The needle jumps, the disc window spins one more round and lands
       on the same record (the reader still never picks one). The first time ever, Zhaunil has a word about Yost */
    function needleSkip() {
      try { if (FFD.burst && FFD.burst.clear) FFD.burst.clear('jb-juke'); } catch (e) { /* fine */ }
      snd('latch'); buzz(16);
      try { music.needle(); } catch (e) { /* fine */ }
      mood((m) => m.juke('jolt'));
      if (!RM()) {
        const others = ORDER.filter((x) => x !== cur).sort(() => Math.random() - 0.5).slice(0, 4);
        mood((m) => m.juke('roulette', { cols: others.map((x) => REC[x].col) }));
        [0, 100, 230, 400].forEach((t) => later(t, () => snd('tap')));
      }
      later(RM() ? 60 : 600, () => { snd('land'); mood((m) => m.juke('land', { id: cur })); });
      lock = Math.max(lock, now() + 1400);
      if (!said('needle')) later(RM() ? 120 : 800, () => { if (api.free()) api.aside('Yost kicked it too. It never helped.'); });
    }
    const tapJuke = api.tapTo('jb-juke', 'juke', async () => {
      const n = taps();
      if (now() < lock) {
        if (n >= 3) { needleSkip(); return; }
        mood((m) => m.juke('locked')); snd('tap');
        if (!toldLock) { toldLock = true; api.aside('Let it finish turning.'); }
        return;
      }
      await change(nextRecord());
    });

    /* ---- the cues the moods give: lines, the heartbeat, the knocks ---- */
    if (moods && moods.on) {
      const on = (cue, fn) => { try { const off = moods.on(cue, fn); if (typeof off === 'function') offs.push(off); } catch (e) { /* fine */ } };
      on('settled', (d) => {
        const rec = d && d.rec;
        if (!rec || rec !== cur || REC[rec].home) return;
        if (FIRSTLINE[rec] && !said('first-' + rec)) later(rec === 'flood' ? 2200 : 600, () => { if (cur === rec && api.free()) api.aside(FIRSTLINE[rec][0]); });
      });
      on('stare-on', () => { snd('heart'); buzz(18); try { music.duck(true); } catch (e) { /* fine */ } });
      on('stare-off', () => { try { music.duck(false); } catch (e) { /* fine */ } });
      on('salute', () => { saluteAt = now(); snd('land'); });
      on('guards-in', () => { snd('land'); buzz(18); });
      on('frog-landed', () => { snd('pop'); api.lookAt(LOOK.bog, { share: true }); });
      on('cart-stopped', () => snd('latch'));
      on('knock', () => { snd('hammer'); buzz(12); if (!said('knock-' + Math.floor(Date.now() / 6e5))) later(1500, () => { if (cur === 'ash' && api.free()) api.aside('Don’t answer that.'); }); });
      on('door-open', () => { api.lookAt(0.88, { share: true, dur: 1200 }); });
      on('matron-posted', () => api.lookAt(0.68, { share: true, dur: 1600 }));
      on('book-up', () => { snd('chime'); api.lookAt(LOOK.flood, { share: true }); });
    }

    /* ---- the guests ----
       a guest tapped again and again (Pike, the frog, the mule, the boots, a coin) answers with an aside, so the flow ends
       at once and every tap counts; only a question or a gift holds the room. Yost's and the Matron's questions give way
       to the jukebox like any other; their pack and their fight never do (tok.can goes false before either opens).
       A question the reader turns down is answered with one short line in passing (declined below, an aside in place of
       the question, so the box crossfades and never keeps a question with no choices under it) */
    const H = {};
    const declined = (t, who) => api.aside(t, who);
    const flow = (id, name, fn, ro) => { H[id] = { label: '', tap: api.tapTo(id, name, fn, ro) }; return H[id]; };
    const NOGIVE = api.NOGIVE;
    /* the King's Road watch */
    flow('jb-maren', 'maren', async (tok) => {
      if (now() - saluteAt < 3500 && !has('fighter-steelveil')) return returnSalute(tok);
      const r = await api.step(tok, api.ask(['Sergeant Maren Vos, King’s Road watch. We go wherever the march plays.'], [{ label: 'Salute', value: 's' }, { label: 'Ask about the road', value: 'r' }, { label: 'Let them stand', value: 'x' }], { cols: 1 }, MAREN));
      if (!r || r.cancelled) return;
      if (r.value === 'x') { declined('They’d stand there all night anyway.'); return; }
      F.clear();
      if (r.value === 's') {
        mood((m) => { m.act('salute'); m.act('maren-give'); }); snd('land');
        tok.can = false;
        await new Promise((res) => later(450, res));
        await give('paladin-regal', { line: 'Wear them on the road. The watch will know you.', who: MAREN.name });
        goldOf('regal');
      } else if (r.value === 'r') {
        await api.step(tok, api.talk(['Rain on the road tonight. The bridge checkpoint wants a name from everyone.', 'Every hero on that road started with a posting. Zhaunil keeps one on his wall.'], MAREN));
        try { F.beacon(['poster'], true); later(4000, () => F.beacon(['poster'], false)); } catch (e) { /* fine */ }
      }
    }).label = 'Sergeant Maren Vos';
    let pikeN = 0;
    flow('jb-pike', 'pike', async (tok) => {
      if (now() - saluteAt < 3500 && !has('fighter-steelveil')) return returnSalute(tok);
      pikeN++;
      mood((m) => m.act('pike', { n: pikeN }));
      if (pikeN === 2) api.aside('Pike doesn’t talk on duty.', MAREN);
      else if (pikeN === 5) {
        snd('pop'); buzz(20); tok.can = false;
        await api.step(tok, api.talk(['Bless you. Eyes front.'], MAREN));
        await give('paladin-imperial', { line: 'Pike says nothing. He holds out a folded cloth and looks straight ahead.', who: 'Pike' });
      } else snd('ring');
    }).label = 'Pike, on guard';
    async function returnSalute(tok) {
      tok.can = false;
      mood((m) => m.act('salute')); snd('land');
      await api.step(tok, api.talk(['You return the salute. Both spears come down together.'], { name: '', img: null }));
      await give('fighter-steelveil', { line: 'Maren tucks a cloth into your hand without breaking the salute.', who: MAREN.name });
    }
    /* the Blackfen */
    let frogN = 0, flies = 0, wispN = 0;
    flow('jb-frog', 'frog', async (tok) => {
      frogN++;
      mood((m) => m.act('frog-croak')); snd('pop');
      if (frogN === 1) mood((m) => m.act('frog-hop', { to: 1 }));
      else if (frogN === 2) { mood((m) => m.act('frog-hop', { to: 2 })); await new Promise((r) => later(700, r)); api.aside('Not on the book.'); }
      else if (frogN === 3) {
        /* a reader who already has her green (a visit before this one): she hops home to the crown and keeps it, and
           nothing is handed over twice */
        if (has('sorcerer-verdictus')) {
          mood((m) => m.act('frog-give'));
          await new Promise((r) => later(600, r));
          api.aside(FROG_AGAIN);
          keepsake('frog'); goldOf('bog');
          return;
        }
        tok.can = false;
        mood((m) => m.act('frog-give'));
        await new Promise((r) => later(500, r));
        await give('sorcerer-verdictus', { line: 'The bog keeps a sorcerer’s green. The frog was holding it for you.', who: 'Zhaunil' });
        keepsake('frog'); goldOf('bog');
      } else if (frogN > 3) api.aside('It knows you now.');
    }).label = 'The frog';
    [0, 1, 2].forEach((i) => {
      flow('jb-fly-' + i, 'fly', async (tok) => {
        mood((m) => m.act('fly-catch', { i })); snd('chime');
        flies++;
        if (flies === 3) { tok.can = false; await give('druid-verdant', { line: 'Three fireflies in a cupped hand. The bog lets you keep its green.', who: 'Zhaunil' }); }
      }).label = 'A firefly';
    });
    flow('jb-wisp', 'wisp', async (tok) => {
      wispN++;
      mood((m) => m.act('wisp', { n: wispN })); snd('whoosh', { g: 0.05, d: 0.5 });
      if (wispN === 3) { tok.can = false; await give('necromancer-gravebloom', { line: 'The wisp settles on a grave flower in the reeds and goes out.', who: 'Zhaunil' }); }
    }).label = 'A wandering wisp';
    /* Yost's cart */
    let muleN = 0, bootsN = 0;
    flow('jb-cart', 'yost', async (tok) => {
      const y = cards && cards.yost;
      if (!y) { await api.step(tok, api.talk(['The canvas stays shut tonight.'], YOST)); return; }
      let free = false;
      try { free = y.freeLeft(); } catch (e) { free = false; }
      if (free) {
        const r = await api.step(tok, api.ask(['Evening. The canvas stays shut. Don’t ask.', 'I deal in faces from the Hall. Other people’s heroes, the rare ones.', 'One of Jan’s portraits buys a pack of three. First pack’s on me.'], [{ label: 'Open the free pack', value: 'o' }, { label: 'Just looking', value: 'x' }], { cols: 1 }, YOST));
        if (!r || r.cancelled) return;
        if (r.value !== 'o') { declined('Suit yourself. The first pack keeps.', YOST); return; }
        F.clear(); tok.can = false;
        mood((m) => m.act('yost-hand'));
        const res = await y.open({ free: true });
        if (res === 'opened') { mood((m) => m.act('pack-done')); goldOf('tinker'); await api.talk(['Come back when the road does.'], YOST); }
        else if (res === 'empty') await api.talk(['You’ve emptied the cart. New faces reach me as the Hall grows.'], YOST);
      } else {
        const r = await api.step(tok, api.ask(['One of Jan’s portraits buys a pack of three.'], [{ label: 'Trade a portrait', value: 't' }, { label: 'Just looking', value: 'x' }], { cols: 1 }, YOST));
        if (!r || r.cancelled) return;
        if (r.value !== 't') { declined('Looking’s free. Touching isn’t.', YOST); return; }
        F.clear(); tok.can = false;
        const res = await y.trade();
        if (res === 'opened') { mood((m) => m.act('pack-done')); goldOf('tinker'); await api.talk(['Pleasure doing business.'], YOST); }
        else if (res === 'none') await api.talk(['Nothing to trade yet. Zhaunil’s deck gives a pack of Jan’s portraits each day.'], YOST);
        /* a reader signed in to the Hall (BINDER-04): he takes only a portrait they hold twice */
        else if (res === 'spare') await api.talk(['Nothing to spare yet. I only take a portrait you hold twice.'], YOST);
        else if (res === 'empty') await api.talk(['You’ve emptied the cart. New faces reach me as the Hall grows.'], YOST);
      }
    }).label = 'Old Yost’s cart';
    flow('jb-mule', 'mule', async (tok) => {
      muleN++;
      mood((m) => m.act('mule', { n: muleN })); snd('rustle');
      if (muleN === 1) api.aside('She bites. Mostly readers.', YOST);
      else if (muleN === 3) { tok.can = false; await api.step(tok, api.talk(['What’s she chewing? Give it here.'], YOST)); await give('fighter-ironhide', { line: 'Found that in a sack of oats. Don’t ask whose.', who: YOST.name }); }
    }).label = 'The mule';
    flow('jb-boots', 'boots', async (tok) => {
      bootsN++;
      mood((m) => m.act('boots', { n: bootsN })); snd('tap');
      if (bootsN === 1) api.aside('Those are my boots. Leave them be.', YOST);
      else if (bootsN === 3) {
        tok.can = false; snd('coin');
        await api.step(tok, api.talk(['Fine. Heads, you get something. Tails, you leave my boots alone.', 'Heads. Took this off a barbarian who owed me.'], YOST));
        await give('barbarian-marbleborn', { line: 'Yost’s gloved hand pushes it out from under the canvas.', who: YOST.name });
      }
    }).label = 'A pair of boots';
    /* the Hollow Stump */
    let coins = [false, false, false];
    [0, 1, 2].forEach((i) => {
      flow('jb-coin-' + i, 'coin', async (tok) => {
        let staring = false;
        try { staring = !!moods.state().stare; } catch (e) { /* fine */ }
        if (staring) {
          coins = [false, false, false];
          mood((m) => { m.act('eyes-red'); m.act('coins-reset'); }); snd('heart'); snd('miss'); buzz(30);
          api.aside('All of it. Back on the table.', PATRON);
          return;
        }
        coins[i] = true; mood((m) => m.act('coin', { i })); snd('coin');
        if (coins.every(Boolean)) {
          tok.can = false;
          await api.step(tok, api.talk(['Quick hands. Take this and don’t come back.'], PATRON));
          await give('rogue-nightshade', { line: 'A hooded patron slides it across the table without looking up.', who: PATRON.name });
        }
      }).label = 'A coin on the table';
    });
    /* any regular, tapped, turns and looks at the reader for 5 s on their own (Jan, 2026-10-07); no words, no gift, so
       the room never waits on it, and one regular looking catches no coin */
    [0, 1, 2, 3, 4, 5].forEach((i) => {
      flow('jb-patron-' + i, 'patron', async () => {
        mood((m) => m.act('patron-look', { i })); snd('murmur', { d: 0.5 });
      }).label = 'A patron';
    });
    flow('jb-table', 'toast', async (tok) => {
      const r = await api.step(tok, api.ask(['They’re watching the door. And you.'], [{ label: 'Raise a glass', value: 'g' }, { label: 'Leave them be', value: 'x' }], { cols: 2 }));
      if (!r || r.cancelled) return;
      if (r.value !== 'g') { declined('Wise. Let them watch the door.'); return; }
      F.clear();
      mood((m) => m.act('toast')); snd('ring');
      st.saw = true; save(); keepsake('tankard'); goldOf('tavern');
      await api.step(tok, api.talk(['The table drinks to you. Nobody smiles.'], PATRON));
    }).label = 'The back table';
    /* the flood */
    let driftN = 0;
    flow('jb-book', 'memories', async (tok) => {
      tok.can = false;
      mood((m) => m.act('book-open')); snd('flip');
      goldOf('flood');
      if (api.memories && api.memories.open) await api.memories.open();
    }, NOGIVE).label = 'The floating book';
    flow('jb-drift', 'drift', async (tok) => {
      driftN++;
      mood((m) => m.act('drift', { n: driftN })); snd('flip');
      if (driftN === 3) { tok.can = false; await give('sorcerer-umbral', { line: 'The drowned book falls open on something it was keeping dry.', who: 'Zhaunil' }); }
    }).label = 'A drifting book';
    /* the cold, and the Iron Matron. Whether the reader met her comes from FFD.quest (src/scene-pages/quest-id.js): a
       finished Quest only, never the Quest's own run read here */
    const questTook = () => { try { return !!(FFD.quest && FFD.quest.v === 1 && FFD.quest.took()); } catch (e) { return false; } };
    /* the store always has FFD.questHref; the fallback keeps the same tags, so the Quest still shows the way back here */
    const QUEST_MATRON = '/pages/dnd-character-quest?utm_source=scene-page&utm_medium=matron&utm_campaign=library';
    flow('jb-matron', 'matron', async (tok) => {
      mood((m) => m.act('face')); snd('heart');
      const r = await api.step(tok, api.ask(['That’s the Iron Matron. She came for whoever played that song.'], [{ label: 'Face her', value: 'f' }, { label: 'Stay in the light', value: 'x' }], { cols: 2 }));
      if (!r || r.cancelled) return;
      if (r.value !== 'f') { declined('Good. Keep to the crystal’s light.'); return; }
      F.clear();
      if (!st.met && !questTook()) {
        const r2 = await api.step(tok, api.ask(['Have you met her before?'], [{ label: 'In the Character Quest', value: 'quest' }, { label: 'Never', value: 'never' }], { cols: 2 }));
        if (!r2 || r2.cancelled) return;
        st.met = r2.value === 'never' ? 'never' : 'quest'; save();
        F.clear();
        if (st.met === 'never') {
          const r3 = await api.step(tok, api.ask(['Then she’s waiting at the end of the Character Quest. Don’t spoil it here.'], [{ label: 'Go after her in the Quest', value: 'q' }, { label: 'Fight her anyway', value: 'f' }], { cols: 1 }));
          if (!r3 || r3.cancelled) return;
          F.clear();
          /* "Go after her in the Quest" already names the way out: it leaves at once, with the fade, and asks nothing
             more (Jan, 2026-10-11, of the same thing at the easel: "it says the same thing again then you click it again") */
          if (r3.value === 'q') { const go = api.leaveNow || api.leaveAsk; await go({ line: 'The Character Quest starts with her WANTED posting.', yes: 'Go after the Iron Matron', href: FFD.questHref ? FFD.questHref('library', 'matron') : QUEST_MATRON, tok }); return; }
        }
      }
      tok.can = false;
      if (!api.fight || !api.fight.open) return;
      const res = await api.fight.open();
      if (closed) return;
      if (res === 'won') {
        mood((m) => m.act('gone'));
        keepsake('cup'); goldOf('ash');
        await give('necromancer-lichspire', { line: 'Something glints in the ice where she stood.', who: 'Zhaunil' });
        selfChange();
      }
    }).label = 'The shape in the shadows';
    flow('jb-thorn', 'thorn', async (tok) => {
      tok.can = false;
      mood((m) => m.act('thorn-taken')); snd('coin');
      await give('rogue-thorncloak', { line: 'You took it while she wasn’t looking. A thief’s cloak, for a thief.', who: 'Zhaunil' });
    }).label = 'Something glinting at her feet';
    /* the calm records' small things */
    let cinders = 0, owlWakes = 0;
    [0, 1, 2].forEach((i) => {
      flow('jb-cinder-' + i, 'cinder', async () => {
        mood((m) => m.act('cinder', { i })); snd('chime');
        cinders++;
        try { borders && borders.note && borders.note('cinders', { n: cinders }); } catch (e) { /* fine */ }
      }).label = 'A rising ember';
    });
    flow('jb-cup', 'cup', async () => { mood((m) => m.act('cup')); api.aside('Mint and honey. The owl stole the honey.'); }).label = 'A steaming cup';
    H['jb-juke'] = { label: 'The jukebox', tap: tapJuke };
    api.hots(H);

    return {
      async enter(o) {
        o = o || {};
        cur = 'quiet';
        st.heard.quiet = true; save();
        try { music.start('quiet'); } catch (e) { /* fine */ }
        mood((m) => { m.start(); m.record('quiet', { quick: true }); m.juke('wake'); });
        lamps();
        api.ink(REC.quiet.ink);
        lock = now() + 3600;
        api.lookAt(LOOK.quiet, { share: true, instant: true });
      },
      rec: () => cur,
      calmTo,
      calm: () => !!REC[cur].home,
      busy: () => turning,
      bonus: () => ({ road: roadHeard(), saw: !!st.saw, mem: !!(api.memories && api.memories.wrote && api.memories.wrote()) }),
      /* After Hours: the dozing owl wakes with a start (three wakes and she drops something in a huff) */
      owlTap() {
        if (cur !== 'after' || has('druid-wintershade')) return false;
        owlWakes++;
        mood((m) => m.act('owl-wake')); snd('wings');
        try { borders && borders.note && borders.note('owl-wake', { n: owlWakes }); } catch (e) { /* fine */ }
        return true;
      },
      jukeLines: () => ['Yost left that jukebox instead of paying for a book. Every record in it was played on the road to the Hollow Stump.', 'It plays what it likes. Tap it and see who it brings.'],
      resume() { resumeOnTouch = true; },
      touched() { if (resumeOnTouch) { resumeOnTouch = false; try { music.wake(); } catch (e) { /* fine */ } } },
      close() {
        if (closed) return;
        closed = true;
        timers.forEach((t) => clearTimeout(t)); timers.clear();
        offs.splice(0).forEach((off) => { try { off(); } catch (e) { /* fine */ } });
      }
    };
  };
})();

/* ===== src/scene-pages/pages/library/ledger.js ===== */
/* library/ledger.js: Zhaunil’s ledger, the Hall sign-in inside the library (a part of the library page, id library).
   The second way the library knows a reader’s hero, after this browser’s own Quest run (src/scene-pages/quest-id.js,
   FFD.quest). Two doors, the email one first:
     THE EMAIL DOOR (Jan, 2026-10-07: "if they type an email and it matches they can do the experience with that
       email"). The reader types the email they used in the Character Quest. It is trimmed and lowercased, and an
       address the Hall’s filter syntax could misread is refused before anything is sent. Two GETs go out together,
       with no PIN:
         a. the same characters read as the PIN door (SELECT below), keeping only the Quest’s rows (from_quest 'true'
            or quest_source 'iron-matron'). Every other row is dropped at once;
         b. quiz_leads with QL_SELECT only: character_name, race, character_class, gender_pronouns, created_at, and
            single blueprint_json paths for the archetype title, skin, hair, build and age, face, features and the
            Quest’s approach. Never email, phone, player name, the memory, likeness, reference pictures or a token.
            It gives the pronouns and looks the Hall has no column for, and finds a Quest hero whose Hall row was
            never saved. When the read is refused, the pronouns are asked as before.
       Newest Quest hero first, up to 6 to pick from (one is taken at once). The pick goes to FFD.quest.set(hero,
       'email', { heroes, took: true }), so it fills the identity like this browser’s own run does. No match gets
       Zhaunil’s warm line about the posting, counts toward the throttle and, when the sheet closes, lights the
       poster. The email goes only in those two requests to the Hall’s own API. It is never printed or logged, and
       never put in a page URL, an event, a tally or storage (the email door writes no hoh-* key and keeps no email in
       'ffd-ledger-fails').
     THE PIN DOOR, for Hall readers and never required ("I have a Hall PIN"): the Hall of Heroes' own sign-in, an
       email and the 4-digit Hall PIN, below.
   Only the library carries this file, and no other scene page reads the Hall token.

   THE SESSION this browser may already hold is the Hall’s own: localStorage 'hoh-your-hall-token' { email, pin,
   savedAt, phone }, read as assets/hoh-stamps.js session() does (an email and a 4-digit PIN, or a Google session: 'g1.' and
   64 hex, which assets/hoh-google-signin.js keeps where the PIN goes and verify_pin takes, HALL-GOOGLE-01) with the Quest’s 365-day
   savedAt check (quest-one-v2.js hallToken). A sign-in here writes it in exactly HHD.saveToken’s shape
   (assets/hoh-hero-data.js: { email, pin, savedAt, phone kept from the old token } plus 'hoh-your-hall-email') and
   fires 'hoh:signed-in' with { source: 'library' }, so the Hall, the hero pages and the Quest open signed in.

   THE DOORS, with the Hall’s publishable key (api.hall, else window.FFD_HALL, else FFD_SITE.hall), no cookies, no
   referrer, 8 s each, and only on the store (FFD.live):
     1. POST rpc/verify_pin { user_email, user_pin } in the body: a count. 0 is a wrong PIN and an unknown email alike,
        so both get the same words and the page never says whether an account exists.
     2. GET characters with public columns only (SELECT below: no email, auth_email, phone, PIN hash, player name,
        secret, story, PDF or quest_meta but its two ->> fields), filtered by or=(auth_email.eq.X,and(auth_email.is.null,
        email.eq.X)), newest first, 24 at most. Hidden quest rows come back whatever their PIN hash. The email goes only
        in this request to the Hall’s own API (the Hall’s own scan makes the same one): never in a page URL, a log, an
        event, a tally or the library’s copy. Quest taken means from_quest 'true' or quest_source 'iron-matron', the
        Hall’s own test (hoh-section-core.js).
   It never calls set_pin, email_has_pin or get_my_characters, reads quiz_leads only through QL_SELECT, and never
   uses a lead token. Readers with no PIN take the email door, or the Hall’s own add-and-claim flow
   (FFD_SITE.routes.hall). A client throttle copies the hero page’s and covers both doors: 5 fails (a wrong PIN, or
   an email with no Quest hero) mean 5 minutes, kept in localStorage 'ffd-ledger-fails' { n, at } (no email kept).
   Every Hall string is put on the page as text, never as HTML, and a hero name said through the room’s talk (F.say
   reads HTML) is escaped first.

   The interface (the room calls the factory once, after its frame exists):
     FFD.parts['library/ledger'](api: { h, esc, F, RM(), snd(name), SITE, live, talk(lines, who), ask, hall?, hold?(on),
                                        who? (Zhaunil’s speaker { name, img }), poster?() })
       -> { open(o) -> Promise<{ took, hero, fresh } | null>, refresh() -> Promise<{ took, fresh } | null>, busy(),
            close() }
     open(o)    the sheet over the room (o.line replaces Zhaunil’s first line). It opens on the email door. A Hall
                session already here (and not someone else’s, as refresh() below says) goes straight to the reader’s
                heroes, and a stale one opens the email door with its email filled in. In a list that mixes them,
                Quest heroes come first, labelled 'From the Quest'. A hidden hero shows its class icon, never its picture. Pronouns are asked once when neither this browser
                nor the Quest’s lead knows them. The pick goes to FFD.quest.set(hero, 'email') or set(hero, 'hall').
                Resolves null for "Not now". When it closes after an email with no Quest hero, the room’s api.poster()
                runs, or the poster’s beacon breathes for 4 s. A Hall member with no quest hero hears "{Name} is in the
                Hall. The Reeve’s posting is still up, though." and took stays false; a quest hero is left for the
                room’s own recognition (fresh says it’s new on this device)
     refresh()  at most once a day (FFD.quest.info().checkedDay), only with a Hall session, and never when that session
                may be someone else’s: after "Not you?" (forgot, or noHall on a hero that came after it) or for an
                email-door reader (via 'email'). Then no request is made. Otherwise verify_pin, then the public read.
                A count of 0 is a stale session: nothing more today. When this browser has a hero, the heroes list is
                taken only from an account that holds it (linked to its Hall row, by id, or by name, class and race);
                an account without it only stamps the day. With no hero here, it adopts the newest quest hero
                (silent: never over a character the reader typed or picked). The same rule keeps open() from going
                straight to a session’s heroes, and its email from being filled in
   The adapter is also on the factory as .Hall (with .SELECT, .QL_SELECT, .normEmail, .emailHero, .keepList, and the
   words as .L) for harness/scene-identity.test.cjs. */
(() => {
  'use strict';
  const FFD = window.FFD = window.FFD || {};
  FFD.parts = FFD.parts || {};
  const CSS_ID = 'ffd-css-library-ledger';
  const TOKEN = 'hoh-your-hall-token', EMAIL = 'hoh-your-hall-email', FAILS = 'ffd-ledger-fails';
  const YEAR = 365 * 864e5, DAY = 864e5, LOCK_N = 5, LOCK_MS = 5 * 60e3, WAIT_MS = 8000, LIMIT = 24, KEEP = 6;
  const SELECT = 'id,slug,name,race,character_class,level,image_url,image_thumb_url,image_offset_x,image_offset_y,image_zoom,approved,is_hidden,created_at,from_quest:quest_meta->>from_quest,quest_source:quest_meta->>source';
  /* the Quest’s lead row, as Quest One v2 writes it (assets/quest-one-v2-live.js leadRow, its blueprint_json being
     toBlueprint() plus the claim’s fields): the hero’s own words only, each JSON value as one path */
  const QL_SELECT = 'character_name,race,character_class,gender_pronouns,created_at,title:blueprint_json->>archetypeTitle,skin:blueprint_json->>skinDesc,hair:blueprint_json->>hairDesc,build_age:blueprint_json->>buildAge,face:blueprint_json->>facialFeatures,feats:blueprint_json->>appendages,approach:blueprint_json->quest->>approach';
  const QL_LIMIT = 12;
  /* no quote, comma, bracket, colon or backslash, and dot-separated domain labels: an address the Hall’s filter syntax
     could misread is refused before sending */
  const EMAIL_RE = /^[^\s@"'(),\\<>;:]+@(?:[^\s@"'(),\\<>;:.]+\.)+[^\s@"'(),\\<>;:.]{2,}$/;
  /* the reader’s typed email, trimmed and lowercased (zero-width marks a paste brings along dropped), or '' */
  const normEmail = (v) => { const s = String(v == null ? '' : v).replace(/[​-‍⁠﻿]/g, '').trim().toLowerCase(); return s && s.length <= 254 && EMAIL_RE.test(s) ? s : ''; };
  /* the Quest’s feature labels as FFD.quest’s keys (quest-id.js FEATS; toBlueprint writes "None" when only "None of these" was picked) */
  const FEAT_OF = { 'horns': 'horns', 'a tail': 'tail', 'wings': 'wings', 'pointed ears': 'pointedears', 'tusks': 'tusks', 'scales': 'scales', 'fur': 'fur', 'none of these': 'none', 'none': 'none' };

  /* every word a reader sees */
  const L = {
    title: 'Zhaunil’s ledger',
    lineEmail: 'Which email did you use for the Character Quest? I’ll find your hero.',
    find: 'Find my hero',
    noMatch: 'That email isn’t in my ledger yet. The Iron Matron’s posting is still up on my wall.',
    usePin: 'I have a Hall PIN', useEmail: 'Use my Quest email',
    line: 'Sign with your Hall email and PIN, and I’ll find your hero.',
    email: 'Email', pin: 'Hall PIN',
    sign: 'Sign the ledger', reading: 'Reading the ledger…', not: 'Not now',
    bad: 'That isn’t in my ledger. The email and four numbers have to match the Hall’s.',
    wait: 'Soryndel is sitting on the ledger. Try again in a few minutes.',
    noPin: 'No numbers yet? Add your hero to the Hall, then sign here.',
    badEmail: 'Check the email address.',
    badPin: 'The PIN is four numbers.',
    offline: 'The ledger won’t open right now. Try again in a moment.',
    none: 'You’re in the ledger, but no heroes yet. Add one in the Hall.',
    pick: 'Which hero walked in tonight?',
    fromQuest: 'From the Quest',
    prAsk: 'How should I write about {Name}?',
    he: 'He', she: 'She', they: 'They',
    inHall: '{Name} is in the Hall. The Reeve’s posting is still up, though.',
    closed: 'My ledger opens on the store.'
  };

  /* ================================================================ the Hall adapter ================================================================ */
  const num = (v, lo, hi, d) => { const n = typeof v === 'number' ? v : typeof v === 'string' && v.trim() ? Number(v) : NaN; return isFinite(n) && n >= lo && n <= hi ? n : d; };
  const pic = (v) => (typeof v === 'string' && v.length <= 600 && (/^https:\/\/[^\s\x22\x27<>]+$/.test(v) || /^\/(?!\/)[^\s\x22\x27<>]*$/.test(v)) ? v : '');
  const txt = (v, n) => (typeof v === 'string' ? v.replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, n) : '');
  const keyOf = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const clsOf = (label) => { try { if (FFD.quest && FFD.quest.norm) return FFD.quest.norm.cls(label); } catch (e) { /* fall through */ } return keyOf(label) || 'other'; };
  /* pronoun words as FFD.quest keeps them (quest-id.js prOf, copied for a page without FFD.quest) */
  const prOf = (v) => {
    try { if (FFD.quest && FFD.quest.norm) return FFD.quest.norm.pr(v); } catch (e) { /* fall through */ }
    const t = txt(v, 24), k = t.toLowerCase().replace(/\s+/g, '');
    if (!t) return { pr: 'they', prText: '' };
    if (k === 'he/him' || k === 'he') return { pr: 'he', prText: '' };
    if (k === 'she/her' || k === 'she') return { pr: 'she', prText: '' };
    if (k === 'they/them' || k === 'they') return { pr: 'they', prText: '' };
    return { pr: 'x', prText: t.slice(0, 12) };
  };
  const bodyOf = (pr) => (pr === 'he' ? 'm' : pr === 'she' ? 'f' : 'n');
  const parts = (v, n) => txt(v, n).split(/\s*,\s*/).filter(Boolean);
  const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '');
  /* one quiz_leads row (QL_SELECT) as what FFD.quest keeps. The looks are read back from toBlueprint()'s words
     ("Crimson skin", "Black, braided", "Tall and lean, Seasoned", "A beard", "Horns, A tail"). quest-id.js keeps only
     the Quest’s own labels, so a free word falls away there */
  function leadOf(r) {
    if (!r || typeof r !== 'object') return null;
    const name = txt(r.character_name, 40); if (!name) return null;
    const clsLabel = txt(r.character_class, 48), said = txt(r.gender_pronouns, 24), p = prOf(said);
    const hair = parts(r.hair, 80), ba = parts(r.build_age, 80);
    const feats = [...new Set(parts(r.feats, 200).map((f) => FEAT_OF[f.toLowerCase()]).filter(Boolean))];
    return { name, race: txt(r.race, 48), cls: clsOf(clsLabel), clsLabel: clsLabel || 'Adventurer', known: !!said, pr: p.pr, prText: p.prText || '',
      look: { skin: txt(r.skin, 60).replace(/\s+skin$/i, ''), hair: hair[0] || '', hairStyle: hair[0] === 'No hair' ? '' : cap(hair[1] || ''), build: ba[0] || '', age: ba.length > 1 ? ba[1] : ba[0] || '',
        beard: parts(r.face, 120).some((m) => m.toLowerCase() === 'a beard'), feats },
      title: txt(r.title, 60), approach: typeof r.approach === 'string' && /^[a-z0-9-]{1,24}$/.test(r.approach) ? r.approach : '', created: Date.parse(r.created_at) || 0 };
  }
  /* o: { hall: { url, key }, live, fetch, ls (a localStorage), now(), doc (for the signed-in event) } */
  function Hall(o) {
    o = o || {};
    const ls = o.ls || null, net = typeof o.fetch === 'function' ? o.fetch : null, now = o.now || (() => Date.now()), doc = o.doc || null;
    const cfg = o.hall && typeof o.hall.url === 'string' && o.hall.url && typeof o.hall.key === 'string' && o.hall.key ? { url: o.hall.url.replace(/\/+$/, ''), key: o.hall.key } : null;
    const get = (k) => { try { return ls ? ls.getItem(k) : null; } catch (e) { return null; } };
    const put = (k, v) => { try { if (ls) ls.setItem(k, v); return !!ls; } catch (e) { return false; } };
    const del = (k) => { try { if (ls) ls.removeItem(k); } catch (e) { /* fine */ } };
    const readJSON = (k) => { const s = get(k); if (!s) return null; try { return JSON.parse(s); } catch (e) { return null; } };
    const on = !!(cfg && net && o.live === true);
    /* the Hall’s session on this browser: an email, a 4-digit PIN or a Google session, saved within the year */
    function session() {
      const t = readJSON(TOKEN);
      if (!t || typeof t !== 'object' || !t.email || !/^(?:\d{4}|g1\.[0-9a-f]{64})$/.test(String(t.pin || '')) || !(now() - (+t.savedAt || 0) < YEAR)) return null;
      /* the same rule as a typed email: a stored address that wouldn't pass the form never reaches a request */
      const em = normEmail(t.email);
      return em ? { email: em, pin: String(t.pin) } : null;
    }
    /* HHD.storedEmail’s rule: the token’s email, else the Hall’s remembered email. A hint for the form only */
    function prefill() {
      const t = readJSON(TOKEN);
      if (t && typeof t === 'object' && typeof t.email === 'string' && t.email.trim()) return t.email.trim().toLowerCase();
      const e = get(EMAIL); return typeof e === 'string' ? e.trim().toLowerCase() : '';
    }
    /* the hero page’s throttle, kept for this browser: after 5 fails, 5 minutes from the last one */
    function lockLeft() { const r = readJSON(FAILS); if (!r || typeof r !== 'object' || (r.n | 0) < LOCK_N) return 0; return Math.max(0, (+r.at || 0) + LOCK_MS - now()); }
    function failed() { const r = readJSON(FAILS) || {}; put(FAILS, JSON.stringify({ n: ((r && r.n) | 0) + 1, at: now() })); return lockLeft(); }
    function cleared() { del(FAILS); }
    async function req(path, init) {
      if (!on) return { off: true };
      const opt = { method: init.method || 'GET', credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store',
        headers: Object.assign({ apikey: cfg.key, Authorization: 'Bearer ' + cfg.key, Accept: 'application/json' }, init.headers || {}) };
      if (init.body != null) opt.body = init.body;
      let ac = null, timer = 0, r;
      try { if (typeof AbortController === 'function') { ac = new AbortController(); opt.signal = ac.signal; timer = setTimeout(() => { try { ac.abort(); } catch (e) { /* fine */ } }, WAIT_MS); } } catch (e) { ac = null; }
      try { r = await net(cfg.url + '/rest/v1/' + path, opt); } catch (e) { return { network: true }; } finally { if (timer) clearTimeout(timer); }
      let data = null;
      try { data = await r.json(); } catch (e) { data = null; }
      return { ok: !!r.ok, status: r.status, data };
    }
    /* { ok, n } (n > 0 is a match), or { network } / { ok: false } when the Hall didn’t answer plainly */
    async function verify(email, pin) {
      const r = await req('rpc/verify_pin', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ user_email: email, user_pin: pin }) });
      if (r.off || r.network) return { network: true };
      if (!r.ok) return { ok: false, status: r.status };
      const n = typeof r.data === 'number' ? r.data : Array.isArray(r.data) && typeof r.data[0] === 'number' ? r.data[0] : 0;
      return { ok: true, n };
    }
    async function list(email) {
      const or = '(auth_email.eq.' + email + ',and(auth_email.is.null,email.eq.' + email + '))';
      const r = await req('characters?select=' + encodeURIComponent(SELECT) + '&or=' + encodeURIComponent(or) + '&order=created_at.desc&limit=' + LIMIT, { method: 'GET' });
      if (r.off || r.network) return { network: true };
      if (!r.ok || !Array.isArray(r.data)) return { ok: false, status: r.status };
      return { ok: true, rows: r.data.slice(0, LIMIT) };
    }
    /* the Quest’s lead rows for this email, the hero’s own words only (QL_SELECT), newest first */
    async function leads(email) {
      const r = await req('quiz_leads?select=' + encodeURIComponent(QL_SELECT) + '&email=eq.' + encodeURIComponent(email) + '&order=created_at.desc&limit=' + QL_LIMIT, { method: 'GET' });
      if (r.off || r.network) return { network: true };
      if (!r.ok || !Array.isArray(r.data)) return { ok: false, status: r.status };
      return { ok: true, rows: r.data.slice(0, QL_LIMIT) };
    }
    /* the Quest heroes under one email: the Hall’s Quest rows (every other row dropped here), each with its newest lead
       by name for pronouns and looks, plus a lead whose Hall row was never saved. Newest first, 6 at most */
    function questMatches(rows, leadRows) {
      const seen = new Set(), out = [];
      heroes(rows).filter((e) => e.fromQuest).sort((a, b) => b.created - a.created || a.i - b.i)
        .forEach((e) => { const k = keyOf(e.name); if (!k || seen.has(k)) return; seen.add(k); out.push(e); });
      const ls = (Array.isArray(leadRows) ? leadRows : []).map(leadOf).filter(Boolean).sort((a, b) => b.created - a.created);
      const lead = new Map();
      ls.forEach((l) => { const k = keyOf(l.name); if (k && !lead.has(k)) lead.set(k, l); });
      out.forEach((e) => { const l = lead.get(keyOf(e.name)); if (l) e.lead = l; });
      lead.forEach((l, k) => { if (seen.has(k)) return; seen.add(k); out.push({ id: '', slug: '', name: l.name, race: l.race, cls: l.cls, clsLabel: l.clsLabel, level: null, public: false, fromQuest: true, created: l.created, i: 1e6, lead: l }); });
      out.sort((a, b) => b.created - a.created || a.i - b.i);
      return out.slice(0, KEEP);
    }
    /* the email door: { ok, heroes } (none is no match), { bad } for an address that can’t be sent, or { network } */
    async function match(email) {
      const em = normEmail(email);
      if (!em) return { bad: true };
      const [c, l] = await Promise.all([list(em), leads(em)]);
      /* without the Hall’s own read the answer would be a guess: no match is said only when that read answered */
      if (!c.ok) return c.network ? { network: true } : { ok: false, status: c.status };
      return { ok: true, heroes: questMatches(c.rows, l.ok ? l.rows : []), leads: !!l.ok };
    }
    /* HHD.saveToken, field for field */
    function saveToken(email, pin) {
      let old = {};
      try { old = JSON.parse(get(TOKEN) || '{}') || {}; } catch (e) { old = {}; }
      const ok = put(TOKEN, JSON.stringify({ email, pin, savedAt: now(), phone: !!old.phone })) && put(EMAIL, email);
      try { if (doc) doc.dispatchEvent(new CustomEvent('hoh:signed-in', { detail: { source: 'library' } })); } catch (e) { /* fine */ }
      return ok;
    }
    /* the session slides, as Your Hall’s own read does: a stamp more than a day old is renewed, nothing else changes */
    function touch() {
      const t = readJSON(TOKEN);
      if (!t || typeof t !== 'object' || now() - (+t.savedAt || 0) < DAY) return;
      put(TOKEN, JSON.stringify(Object.assign({}, t, { savedAt: now() })));
    }
    /* the rows as heroes: public fields only, quest heroes first, then newest first */
    function heroes(rows) {
      const out = [];
      (Array.isArray(rows) ? rows : []).forEach((r, i) => {
        if (!r || typeof r !== 'object') return;
        const name = txt(r.name, 40); if (!name) return;
        const pub = r.approved === true && r.is_hidden !== true;
        const clsLabel = txt(r.character_class, 48);
        const e = { id: typeof r.id === 'string' || typeof r.id === 'number' ? String(r.id) : '', slug: typeof r.slug === 'string' ? r.slug : '', name, race: txt(r.race, 48),
          cls: clsOf(clsLabel), clsLabel: clsLabel || 'Adventurer', level: num(r.level, 1, 20, null), public: pub,
          fromQuest: r.from_quest === 'true' || r.from_quest === true || r.quest_source === 'iron-matron', created: Date.parse(r.created_at) || 0, i };
        if (pub) {
          const t = pic(r.image_thumb_url) || pic(r.image_url);
          if (t) { e.thumb = t; e.frame = { x: num(r.image_offset_x, 0, 100, 50), y: num(r.image_offset_y, 0, 100, 50), zoom: num(r.image_zoom, 100, 200, 100) }; }
        }
        out.push(e);
      });
      out.sort((a, b) => (a.fromQuest !== b.fromQuest ? (a.fromQuest ? -1 : 1) : b.created - a.created || a.i - b.i));
      return out;
    }
    return { on, session, prefill, lockLeft, failed, cleared, verify, list, leads, match, questMatches, saveToken, touch, heroes };
  }
  /* the six the library keeps (the pick always among them), as FFD.quest stores them */
  function keepList(list, hero) {
    const first = list.slice(0, KEEP);
    if (hero && hero.heroId && !first.some((e) => e.id === hero.heroId)) { const m = list.find((e) => e.id === hero.heroId); if (m) { first.pop(); first.push(m); } }
    return first.map((e) => ({ id: e.id, slug: e.slug, name: e.name, race: e.race, cls: e.cls, clsLabel: e.clsLabel, public: e.public, fromQuest: e.fromQuest, thumb: e.thumb, frame: e.frame }));
  }
  /* a Hall hero as FFD.quest’s hero; the run’s own looks, title and choices stay when it is the same hero */
  function asHero(e, base, pr) {
    const same = !!(base && ((base.heroId && base.heroId === e.id) || (!base.heroId && keyOf(base.name) === keyOf(e.name) && base.cls === e.cls && keyOf(base.race) === keyOf(e.race))));
    const o = Object.assign({}, same ? base : {}, {
      name: same ? base.name : e.name, cls: same ? base.cls : e.cls, clsLabel: same ? base.clsLabel : e.clsLabel, race: same ? base.race : e.race,
      level: same && base.level ? base.level : e.level, heroId: e.id, slug: e.slug, public: e.public, thumb: e.thumb, frame: e.frame, fromQuest: e.fromQuest
    });
    if (pr) { o.pr = pr.pr; o.prText = pr.prText || ''; o.body = pr.pr === 'he' ? 'm' : pr.pr === 'she' ? 'f' : 'n'; }
    else if (!same) { o.pr = 'they'; o.prText = ''; o.body = 'n'; }
    return { hero: o, same };
  }
  /* a Quest hero found by email as FFD.quest’s hero: the Hall row’s name, class and race, the lead’s pronouns, looks,
     title and approach. This browser’s own run hero, when it is the same one, keeps everything it knows */
  function emailHero(e, base) {
    const same = !!(base && base.name && (base.heroId && e.id ? base.heroId === e.id : keyOf(base.name) === keyOf(e.name) && base.cls === e.cls && keyOf(base.race) === keyOf(e.race)));
    const l = e.lead || null;
    const o = same ? Object.assign({}, base) : { name: e.name, cls: e.cls, clsLabel: e.clsLabel, race: e.race, level: e.level,
      look: l ? l.look : null, title: l ? l.title : '', quest: { approach: l ? l.approach : '', coinCall: '', coinWon: false } };
    if (same && l && !o.title) o.title = l.title;
    Object.assign(o, { heroId: e.id || (same && base.heroId) || '', slug: e.slug || (same && base.slug) || '', public: e.public === true, thumb: e.thumb, frame: e.frame, fromQuest: true });
    if (!o.level && e.level) o.level = e.level;
    let known = !!(same && base.pr);
    if (!known && l && l.known) { o.pr = l.pr; o.prText = l.prText; o.body = bodyOf(l.pr); known = true; }
    else if (!known) { o.pr = 'they'; o.prText = ''; o.body = 'n'; }
    return { hero: o, same, known };
  }
  const withPr = (hero, pr) => Object.assign({}, hero, { pr: pr.pr, prText: pr.prText || '', body: bodyOf(pr.pr) });
  const localDay = () => { const d = new Date(); const p = (n) => String(n).padStart(2, '0'); return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()); };
  const today = () => { try { if (typeof FFD.day === 'function') { const d = FFD.day(); if (/^\d{4}-\d{2}-\d{2}$/.test(d)) return d; } } catch (e) { /* fall through */ } return localDay(); };

  /* ---------- the look: a centered card over the room, scoped to the library (core.css’s sheet rules come later in the
     document, so every rule here carries .ffd.ffd-page--library to outrank them) ---------- */
  const P = '.ffd.ffd-page--library';
  const CSS = `
/* an empty div: Dawn’s div:empty { display: none } would hide it on the store, so it says its display */
${P} .lb-lg-scrim { display: block; position: absolute; inset: 0; z-index: 8; background: rgba(6, 4, 2, .58); opacity: 0; transition: opacity .26s ease; }
${P} .lb-lg-scrim.is-in { opacity: 1; }
${P} .ffs-sheet.lb-lg { top: 50%; bottom: auto; left: 50%; right: auto; z-index: 9; width: min(440px, calc(100% - 32px)); max-height: calc(100% - 32px);
  overflow: auto; overscroll-behavior: contain; padding: 22px 20px 20px; border-radius: 16px; border: 1px solid rgba(231, 201, 127, .3);
  background: linear-gradient(90deg, rgba(231, 201, 127, 0), rgba(231, 201, 127, .6), rgba(231, 201, 127, 0)) 50% 0 / 62% 1px no-repeat, radial-gradient(70% 34% at 50% 0, rgba(232, 168, 90, .13), rgba(232, 168, 90, 0) 75%), linear-gradient(180deg, #1f170e, #120d08 72%);
  box-shadow: 0 26px 70px rgba(0, 0, 0, .66), 0 0 0 1px rgba(231, 201, 127, .06) inset; text-align: center;
  transform: translate(-50%, calc(-50% + 16px)); opacity: 0; transition: transform .3s cubic-bezier(.2, .8, .2, 1), opacity .24s ease; }
@supports (height: 100svh) { ${P} .ffs-sheet.lb-lg { max-height: min(calc(100% - 32px), calc(100svh - 32px)); } }
${P} .ffs-sheet.lb-lg.is-in { transform: translate(-50%, -50%); opacity: 1; }
${P} .ffs-sheet.lb-lg.is-out { transform: translate(-50%, calc(-50% + 16px)); opacity: 0; transition-duration: .22s; }
${P} .ffs-sheet.lb-lg.is-kb, ${P} .ffs-sheet.lb-lg.is-kb.is-in { top: var(--lblg-top, 8px); max-height: var(--lblg-h, calc(100% - 16px)); transform: translate(-50%, 0); transition: opacity .24s ease; }
${P} .lb-lg-h { display: grid; justify-items: center; gap: 6px; margin: 0 0 16px; }
${P} .lb-lg-h img { display: block; width: 58px; height: 58px; border-radius: 50%; object-fit: cover; object-position: 50% 24%; border: 1px solid rgba(231, 201, 127, .55); box-shadow: 0 0 0 3px rgba(231, 201, 127, .08); }
${P} .lb-lg-h b { display: block; font: 600 14px/1.2 var(--f-display); letter-spacing: .08em; color: var(--gold-hi); }
${P} .lb-lg-h p { margin: 0; font: italic 500 18px/1.35 var(--f-aside); color: var(--fg); max-width: 22em; text-wrap: balance; }
${P} .lb-lg-step { display: grid; gap: 12px; transition: opacity .2s ease, transform .2s ease; }
${P} .lb-lg-step.is-swap { opacity: 0; transform: translateY(6px); }
${P} .lb-lg-form { display: grid; gap: 12px; margin: 0; text-align: left; }
${P} .lb-lg-f { display: grid; gap: 6px; min-width: 0; }
${P} .lb-lg-f label { font: 600 13.5px/1.2 var(--f-body); letter-spacing: .01em; color: var(--fg-2); }
${P} .lb-lg-f input { width: 100%; min-height: 48px; margin: 0; padding: 10px 12px; border-radius: 10px; border: 1px solid rgba(231, 201, 127, .3);
  background: #0e0a06; color: var(--fg); font: 500 16px/1.2 var(--f-body); box-shadow: none; -webkit-appearance: none; appearance: none; }
${P} .lb-lg-f input.lb-lg-pin { letter-spacing: .5em; font-variant-numeric: tabular-nums; max-width: 11em; }
${P} .lb-lg-f input:focus { outline: none; border-color: var(--gold); box-shadow: 0 0 0 3px rgba(200, 164, 94, .2); }
${P} .lb-lg-f input[aria-invalid="true"] { border-color: #e0806e; box-shadow: 0 0 0 3px rgba(224, 128, 110, .16); }
${P} .lb-lg-f input::placeholder { color: rgba(201, 190, 168, .42); }
${P} .lb-lg-msg { margin: 0; font: 14.5px/1.4 var(--f-body); text-align: center; color: var(--fg-2); }
${P} .lb-lg-msg:empty { display: none; }
${P} .lb-lg-msg.is-bad { color: #ffa493; }
/* the buttons span the field's width. Under the heroes (six of them on a short screen can scroll) "Not now" stays
   pinned to the card's foot, so it can always be reached */
${P} .lb-lg-btns { display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; margin-top: 4px; }
${P} .lb-lg-btns .ffd-btn { flex: 1 1 auto; min-height: 48px; padding-inline: 22px; border-color: rgba(231, 201, 127, .28); background: transparent; color: var(--fg-2); }
${P} .lb-lg-heroes + .lb-lg-btns { position: sticky; bottom: -20px; z-index: 1; margin: 2px -20px -20px; padding: 10px 20px 20px; background: linear-gradient(180deg, rgba(18, 13, 8, 0), #120d08 12px); }
${P} .lb-lg-heroes + .lb-lg-btns .ffd-btn { flex: 0 1 220px; }
${P} .lb-lg-btns .ffd-btn--solid { border-color: var(--gold-hi); background: linear-gradient(180deg, rgba(231, 201, 127, .24), rgba(231, 201, 127, .1)); color: #fff6dc; }
${P} .lb-lg-btns .ffd-btn:hover { border-color: var(--gold); color: #fff1cc; background: rgba(200, 164, 94, .12); }
${P} .lb-lg-btns .ffd-btn:disabled { opacity: .7; cursor: default; }
${P} .lb-lg-small { display: grid; gap: 2px; margin: 2px 0 0; text-align: center; }
${P} .lb-lg-small a, ${P} .lb-lg-small p { display: flex; align-items: center; justify-content: center; margin: 0; padding: 4px 6px; font: 13.5px/1.4 var(--f-body); color: #b9ad97; text-wrap: balance; }
/* the link takes a 44 px tap; the plain line beside it is not a target */
${P} .lb-lg-small a { min-height: 44px; padding-block: 0; }
${P} .lb-lg-small a { color: var(--gold-hi); text-decoration: underline; text-underline-offset: 3px; text-decoration-color: rgba(231, 201, 127, .5); }
/* the other door ("I have a Hall PIN", "Use my Quest email"): a link’s look on a 44 px button */
${P} .lb-lg-small .lb-lg-alt { display: flex; align-items: center; justify-content: center; justify-self: center; min-height: 44px; margin: 0; padding: 0 12px; border: 0; border-radius: 8px;
  background: none; box-shadow: none; font: 13.5px/1.4 var(--f-body); letter-spacing: normal; text-transform: none; color: var(--gold-hi); cursor: pointer;
  text-decoration: underline; text-underline-offset: 3px; text-decoration-color: rgba(231, 201, 127, .5); transition: color .18s ease, background .18s ease; }
${P} .lb-lg-small .lb-lg-alt:hover { color: #fff1cc; background: rgba(200, 164, 94, .08); }
${P} .lb-lg-small .lb-lg-alt:focus-visible { outline: 2px solid var(--gold); outline-offset: 2px; }
${P} .lb-lg-heroes { display: grid; gap: 8px; margin: 0; padding: 0; text-align: left; }
${P} .lb-lg-hero { display: grid; grid-template-columns: 52px 1fr; align-items: center; gap: 12px; width: 100%; min-height: 64px; margin: 0; padding: 8px 12px 8px 8px; border-radius: 12px;
  border: 1px solid rgba(231, 201, 127, .22); background: rgba(14, 10, 6, .6); color: var(--fg); font: inherit; text-align: left; cursor: pointer; transition: border-color .18s ease, background .18s ease, transform .18s ease; }
${P} .lb-lg-hero:hover, ${P} .lb-lg-hero:focus-visible { border-color: var(--gold); background: rgba(60, 44, 20, .55); outline: none; }
${P} .lb-lg-hero:active { transform: scale(.985); }
${P} .lb-lg-pic { display: block; position: relative; width: 52px; height: 52px; overflow: hidden; border-radius: 10px; background: #0b0805; border: 1px solid rgba(231, 201, 127, .25); }
${P} .lb-lg-pic img { display: block; width: 100%; height: 100%; object-fit: cover; }
${P} .lb-lg-pic.is-icon img { object-fit: contain; padding: 7px; box-sizing: border-box; image-rendering: pixelated; }
${P} .lb-lg-who { display: grid; gap: 2px; min-width: 0; }
${P} .lb-lg-who b { font: 600 16px/1.2 var(--f-body); color: var(--fg); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
${P} .lb-lg-who span { font: 13.5px/1.3 var(--f-body); color: var(--fg-2); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
${P} .lb-lg-who em { justify-self: start; margin-top: 2px; padding: 1px 8px; border-radius: 999px; border: 1px solid rgba(231, 201, 127, .4); font: italic 600 12px/1.5 var(--f-body); color: var(--gold-hi); }
${P} .lb-lg-prs { display: flex; justify-content: center; gap: 10px; flex-wrap: wrap; }
${P} .lb-lg-prs .ffd-btn { min-width: 88px; min-height: 48px; }
@media (max-height: 640px) {
  ${P} .ffs-sheet.lb-lg { padding: 14px 16px 14px; max-height: calc(100% - 16px); }
  ${P} .lb-lg-h { grid-template-columns: auto 1fr; justify-items: start; align-items: center; column-gap: 12px; margin-bottom: 10px; text-align: left; }
  ${P} .lb-lg-h img { width: 44px; height: 44px; grid-row: span 2; }
  ${P} .lb-lg-h p { font-size: 16px; }
  ${P} .lb-lg-form, ${P} .lb-lg-step { gap: 8px; }
  ${P} .lb-lg-f input { min-height: 44px; padding-block: 8px; }
  ${P} .lb-lg-btns .ffd-btn { min-height: 46px; }
  ${P} .lb-lg-heroes + .lb-lg-btns { bottom: -14px; margin: 0 -16px -14px; padding: 8px 16px 14px; }
}
/* a landscape phone: each label sits beside its field, so the whole form fits without scrolling */
@media (max-height: 480px) {
  ${P} .lb-lg-f { grid-template-columns: 76px minmax(0, 1fr); align-items: center; column-gap: 10px; }
  ${P} .lb-lg-f label { white-space: nowrap; }
  ${P} .lb-lg-small { grid-template-columns: 1fr 1fr; align-items: center; gap: 4px 10px; }
  ${P} .lb-lg-small.is-one { grid-template-columns: 1fr; }
}
/* a landscape phone: a wider card, and six heroes in two columns, so the picker fits without scrolling */
@media (max-height: 480px) and (min-width: 600px) {
  ${P} .ffs-sheet.lb-lg { width: min(600px, calc(100% - 32px)); }
  ${P} .lb-lg-heroes { grid-template-columns: 1fr 1fr; }
}
@media (prefers-reduced-motion: reduce) {
  ${P} .ffs-sheet.lb-lg, ${P} .lb-lg-scrim, ${P} .lb-lg-step, ${P} .lb-lg-hero, ${P} .lb-lg-small .lb-lg-alt { transition: none; }
  ${P} .lb-lg-step.is-swap { transform: none; }
}`;

  FFD.parts['library/ledger'] = function (api) {
    api = api || {};
    const F = api.F || null;
    const el = (tag, a, ...kids) => {   /* text only: an 'html' attribute is refused here */
      if (a && a.html != null) throw new Error('the ledger writes text only');
      return (api.h || FFD.h)(tag, a, ...kids);
    };
    const esc = api.esc || FFD.esc || ((v) => String(v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])));
    const RM = typeof api.RM === 'function' ? api.RM : () => false;
    const snd = (n) => { try { if (typeof api.snd === 'function') api.snd(n); } catch (e) { /* fine */ } };
    const SITE = api.SITE || window.FFD_SITE || null;
    const live = api.live === true || (api.live == null && FFD.live === true);
    let ls = null; try { ls = window.localStorage; } catch (e) { ls = null; }
    const hall = Hall({ hall: api.hall || window.FFD_HALL || (SITE && SITE.hall) || null, live, fetch: typeof window.fetch === 'function' ? window.fetch.bind(window) : null, ls, doc: document });
    const ZH = api.who || { name: 'Zhaunil', img: (SITE && SITE.portraits && SITE.portraits.zhaunil) || null };
    const hallHref = (SITE && SITE.routes && typeof SITE.routes.hall === 'string' && SITE.routes.hall) || null;
    const Q = () => (FFD.quest && FFD.quest.v === 1 ? FFD.quest : null);
    /* the Hall session on this browser may be someone else’s: after "Not you?" (forgot, then noHall on every hero that
       follows it), or for a reader who came in by the email door. Then it is never used: no shortcut to its heroes, no
       prefilled email, no silent refresh. Signing the ledger with a PIN makes it the reader’s own again */
    const forgotten = () => { try { const q = Q(); const i = q ? q.info() : null; return !!(i && (i.forgot || i.noHall || i.via === 'email')); } catch (e) { return false; } };
    /* a Hall name said through the room’s talk: F.say reads HTML and fills {tokens}, so both are made inert */
    const said = (tpl, name) => tpl.replace('{Name}', () => esc(String(name || '')).replace(/\{/g, '&#123;').replace(/\}/g, '&#125;'));
    const say = async (lines) => { try { if (typeof api.talk === 'function') await api.talk(lines, ZH); } catch (e) { /* the room moved on */ } };
    let running = false, refreshing = null, shut = null, closed = false, n = 0, lastMiss = false;
    /* "point at the poster": the room’s own way when it gives one, else the poster’s beacon breathes for 4 s */
    function poster() {
      try {
        if (typeof api.poster === 'function') { api.poster(); return; }
        if (F && typeof F.beacon === 'function') { F.beacon(['poster'], true); setTimeout(() => { try { if (!closed) F.beacon(['poster'], false); } catch (e) { /* fine */ } }, 4000); }
      } catch (e) { /* the room moved on */ }
    }

    function css() { if (!document.getElementById(CSS_ID)) document.head.append(el('style', { id: CSS_ID, text: CSS })); }

    /* ---------- the sheet: sign, then the heroes, then pronouns when this browser doesn’t know them ---------- */
    function sheet(o) {
      css();
      const k = ++n, id = (s) => 'lblg-' + k + '-' + s;
      const scrim = el('div', { class: 'lb-lg-scrim', 'aria-hidden': 'true' });
      F.el.append(scrim);
      requestAnimationFrame(() => scrim.classList.add('is-in'));
      let sh = null, isOpen = true, inerted = [], offs = [];
      const done = F.sheet((body, close) => {
        sh = body.parentNode;
        sh.setAttribute('aria-modal', 'true'); sh.setAttribute('aria-label', L.title); sh.setAttribute('aria-describedby', id('line'));
        const img = ZH && ZH.img ? el('img', { src: ZH.img, alt: '', width: '58', height: '58', decoding: 'async' }) : null;
        /* the room’s own first line (o.line) stays for the first step; Zhaunil’s line is a live region, so each new
           prompt, and his answer to an email he can’t find, is read out */
        const first = (o && typeof o.line === 'string' && o.line) || '';
        const line = el('p', { id: id('line'), 'aria-live': 'polite', text: first || L.lineEmail });
        lastMiss = false;
        const coarse = () => !!(window.matchMedia && matchMedia('(pointer: coarse)').matches);
        const step = el('div', { class: 'lb-lg-step' });
        body.append(el('div', { class: 'lb-lg-h' }, img, el('div', null, el('b', { text: (ZH && ZH.name) || 'Zhaunil' }), line)), step);
        const finish = (v) => { if (!isOpen) return; isOpen = false; close(v); };
        shut = () => finish(null);
        /* one step at a time, crossfading (about 200 ms, at once under reduced motion) */
        let swapN = 0;
        const swap = (words, build) => new Promise((res) => {
          const my = ++swapN;
          const fill = () => {
            if (my !== swapN || !isOpen) return res(false);
            line.textContent = words;
            step.replaceChildren(...build());
            requestAnimationFrame(() => { step.classList.remove('is-swap'); res(true); });
            const first = step.querySelector('input, button, a');
            if (first && !(window.matchMedia && matchMedia('(pointer: coarse)').matches)) setTimeout(() => { try { first.focus({ preventScroll: true }); } catch (e) { /* fine */ } }, 60);
          };
          if (!step.children.length || RM()) return fill();
          step.classList.add('is-swap');
          setTimeout(fill, 200);
        });
        const notBtn = () => { const b = el('button', { type: 'button', class: 'ffd-btn', text: L.not }); b.addEventListener('click', () => { snd('tap'); finish(null); }); return b; };

        /* the form */
        function signStep(msgText, bad, email) {
          const fEmail = el('input', { id: id('email'), name: 'email', type: 'email', autocomplete: 'email', inputmode: 'email', maxlength: '254', enterkeyhint: 'next', spellcheck: 'false', autocapitalize: 'off' });
          const fPin = el('input', { id: id('pin'), name: 'pin', class: 'lb-lg-pin', type: 'password', autocomplete: 'off', inputmode: 'numeric', pattern: '[0-9]*', maxlength: '4', enterkeyhint: 'go' });
          fEmail.value = email != null ? email : forgotten() ? '' : hall.prefill();
          const msg = el('p', { class: 'lb-lg-msg', id: id('msg'), role: 'status', 'aria-live': 'polite' });
          const go = el('button', { type: 'submit', class: 'ffd-btn ffd-btn--solid', text: L.sign });
          const form = el('form', { class: 'lb-lg-form', novalidate: true, 'aria-labelledby': id('line') },
            el('div', { class: 'lb-lg-f' }, el('label', { for: id('email'), text: L.email }), fEmail),
            el('div', { class: 'lb-lg-f' }, el('label', { for: id('pin'), text: L.pin }), fPin),
            msg, el('div', { class: 'lb-lg-btns' }, go, notBtn()));
          const back = el('button', { type: 'button', class: 'lb-lg-alt', text: L.useEmail });
          back.addEventListener('click', () => { snd('tap'); const v = String(fEmail.value || '').trim().toLowerCase(); swap(L.lineEmail, () => emailStep('', false, v)); });
          const small = el('div', { class: 'lb-lg-small' }, hallHref ? el('a', { href: hallHref, text: L.noPin }) : el('p', { text: L.noPin }), back);
          const show = (text, isBad, field) => {
            msg.textContent = text || '';
            msg.className = 'lb-lg-msg' + (isBad ? ' is-bad' : '');
            msg.setAttribute('role', isBad ? 'alert' : 'status');
            [fEmail, fPin].forEach((f) => { f.removeAttribute('aria-invalid'); f.removeAttribute('aria-describedby'); });
            const f = field === 'email' ? fEmail : field === 'pin' ? fPin : null;
            if (f && isBad) { f.setAttribute('aria-invalid', 'true'); f.setAttribute('aria-describedby', id('msg')); }
            if (text) requestAnimationFrame(() => reveal(msg));
          };
          if (msgText) show(msgText, bad);
          fPin.addEventListener('input', () => { const v = fPin.value.replace(/\D/g, '').slice(0, 4); if (v !== fPin.value) fPin.value = v; if (fPin.getAttribute('aria-invalid') === 'true') show(''); });
          fEmail.addEventListener('input', () => { if (fEmail.getAttribute('aria-invalid') === 'true') show(''); });
          fEmail.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.isComposing) { e.preventDefault(); fPin.focus({ preventScroll: true }); } });
          let sending = false;
          const busyOn = (on) => { go.disabled = on; go.textContent = on ? L.reading : L.sign; if (on) form.setAttribute('aria-busy', 'true'); else form.removeAttribute('aria-busy'); };
          form.addEventListener('submit', async (e) => {
            e.preventDefault();
            if (sending || !isOpen) return;
            snd('tap');
            const em = normEmail(fEmail.value), pin = String(fPin.value || '').trim();
            if (hall.lockLeft() > 0) { show(L.wait, true); return; }
            if (!em) { show(L.badEmail, true, 'email'); fEmail.focus({ preventScroll: true }); return; }
            if (!/^\d{4}$/.test(pin)) { show(L.badPin, true, 'pin'); fPin.focus({ preventScroll: true }); return; }
            show(''); sending = true; busyOn(true);
            try {
              const v = await hall.verify(em, pin);
              if (!isOpen) return;
              if (v.network || !v.ok) { show(L.offline, true); return; }
              if (!(v.n > 0)) { fPin.value = ''; show(hall.failed() > 0 ? L.wait : L.bad, true); fPin.focus({ preventScroll: true }); return; }
              hall.cleared();
              hall.saveToken(em, pin);
              fPin.value = '';
              const l = await hall.list(em);
              if (!isOpen) return;
              if (!l.ok) { show(L.offline, true); return; }
              choose(hall.heroes(l.rows));
            } finally { sending = false; if (go.isConnected) busyOn(false); }
          });
          return [form, small];
        }
        const readingStep = () => [el('p', { class: 'lb-lg-msg', role: 'status', text: L.reading }), el('div', { class: 'lb-lg-btns' }, notBtn())];

        /* the email door: the email from the Character Quest, and no PIN */
        function emailStep(msgText, bad, email) {
          const fEmail = el('input', { id: id('qemail'), name: 'email', type: 'email', autocomplete: 'email', inputmode: 'email', maxlength: '254', enterkeyhint: 'go', spellcheck: 'false', autocapitalize: 'off' });
          fEmail.value = email != null ? email : forgotten() ? '' : hall.prefill();
          const msg = el('p', { class: 'lb-lg-msg', id: id('qmsg'), role: 'status', 'aria-live': 'polite' });
          const go = el('button', { type: 'submit', class: 'ffd-btn ffd-btn--solid', text: L.find });
          const form = el('form', { class: 'lb-lg-form', novalidate: true, 'aria-labelledby': id('line') },
            el('div', { class: 'lb-lg-f' }, el('label', { for: id('qemail'), text: L.email }), fEmail),
            msg, el('div', { class: 'lb-lg-btns' }, go, notBtn()));
          const alt = el('button', { type: 'button', class: 'lb-lg-alt', text: L.usePin });
          alt.addEventListener('click', () => { snd('tap'); const v = String(fEmail.value || '').trim().toLowerCase(); swap(L.line, () => signStep('', false, v)); });
          const small = el('div', { class: 'lb-lg-small is-one' }, alt);
          const show = (text, isBad) => {
            msg.textContent = text || '';
            msg.className = 'lb-lg-msg' + (isBad ? ' is-bad' : '');
            msg.setAttribute('role', isBad ? 'alert' : 'status');
            fEmail.removeAttribute('aria-invalid'); fEmail.removeAttribute('aria-describedby');
            if (isBad && text === L.badEmail) { fEmail.setAttribute('aria-invalid', 'true'); fEmail.setAttribute('aria-describedby', id('qmsg')); }
            if (text) requestAnimationFrame(() => reveal(msg));
          };
          if (msgText) show(msgText, bad);
          fEmail.addEventListener('input', () => { if (fEmail.getAttribute('aria-invalid') === 'true') show(''); });
          let sending = false;
          const busyOn = (on) => { go.disabled = on; go.textContent = on ? L.reading : L.find; if (on) form.setAttribute('aria-busy', 'true'); else form.removeAttribute('aria-busy'); };
          form.addEventListener('submit', async (e) => {
            e.preventDefault();
            if (sending || !isOpen) return;
            snd('tap');
            if (hall.lockLeft() > 0) { show(L.wait, true); return; }
            const em = normEmail(fEmail.value);
            if (!em) { show(L.badEmail, true); fEmail.focus({ preventScroll: true }); return; }
            if (fEmail.value !== em) fEmail.value = em;
            show(''); sending = true; busyOn(true);
            try {
              const m = await hall.match(em);
              if (!isOpen) return;
              if (m.network || !m.ok) { show(L.offline, true); return; }
              if (!m.heroes.length) {
                /* no Quest hero under it: Zhaunil’s own words, never an error, and the address stays to be fixed */
                lastMiss = true;
                if (hall.failed() > 0) { show(L.wait, true); return; }
                line.textContent = L.noMatch; show('');
                if (!coarse()) fEmail.focus({ preventScroll: true });
                return;
              }
              lastMiss = false;
              hall.cleared();
              chooseEmail(m.heroes);
            } finally { sending = false; if (go.isConnected) busyOn(false); }
          });
          return [form, small];
        }

        /* the heroes: quest heroes first; a hidden hero shows its class icon, never its picture */
        function heroBtn(e, pickIt, tag) {
          const box = el('span', { class: 'lb-lg-pic' + (e.thumb ? '' : ' is-icon') });
          const im = el('img', { src: e.thumb || (FFD.icon ? FFD.icon(e.cls || 'other', 64) : ''), alt: '', width: '52', height: '52', decoding: 'async', loading: 'lazy' });
          if (e.thumb && e.frame) {
            im.style.objectPosition = e.frame.x + '% ' + e.frame.y + '%';
            if (e.frame.zoom > 100) { im.style.transform = 'scale(' + e.frame.zoom / 100 + ')'; im.style.transformOrigin = e.frame.x + '% ' + e.frame.y + '%'; }
          }
          box.append(im);
          const sub = [e.race, e.clsLabel].filter(Boolean).join(' ');
          const b = el('button', { type: 'button', class: 'lb-lg-hero' + (e.fromQuest ? ' is-quest' : '') }, box,
            el('span', { class: 'lb-lg-who' }, el('b', { text: e.name }), sub ? el('span', { text: sub }) : null, e.fromQuest && tag ? el('em', { text: L.fromQuest }) : null));
          b.addEventListener('click', () => { snd('tap'); pickIt(e); });
          return b;
        }
        /* 'From the Quest' only tells a list apart when it mixes Quest and Hall heroes */
        function pickStep(list) {
          const tag = list.some((e) => !e.fromQuest);
          return new Promise((res) => {
            swap(L.pick, () => [el('div', { class: 'lb-lg-heroes' }, list.map((e) => heroBtn(e, res, tag))), el('div', { class: 'lb-lg-btns' }, notBtn())]);
          });
        }
        function prStep(name) {
          return new Promise((res) => {
            const b = (k, label) => { const x = el('button', { type: 'button', class: 'ffd-btn', text: label }); x.addEventListener('click', () => { snd('tap'); res({ pr: k, prText: '' }); }); return x; };
            swap(L.prAsk.replace('{Name}', () => name), () => [el('div', { class: 'lb-lg-prs' }, b('he', L.he), b('she', L.she), b('they', L.they))]);
          });
        }
        async function choose(list) {
          if (!isOpen) return;
          if (!list.length) { await swap(L.line, () => signStep(L.none, false)); return; }
          const pick = list.length === 1 ? list[0] : await pickStep(list);
          if (!pick || !isOpen) return;
          const q = Q(), base = q ? q.hero() : null;
          let { hero, same } = asHero(pick, base, null);
          if (!same || !base || !base.pr) { const pr = await prStep(hero.name); if (!isOpen) return; hero = asHero(pick, base, pr).hero; }
          finish({ hero, keep: keepList(list, hero), took: list.some((e) => e.fromQuest), via: 'hall' });
        }
        /* the email door’s heroes: one is taken at once, several are picked from (newest first); pronouns are asked
           only when neither this browser nor the Quest’s lead knows them */
        async function chooseEmail(list) {
          if (!isOpen) return;
          const pick = list.length === 1 ? list[0] : await pickStep(list);
          if (!pick || !isOpen) return;
          const q = Q(), base = q ? q.hero() : null;
          let { hero, known } = emailHero(pick, base);
          if (!known) { const pr = await prStep(hero.name); if (!isOpen) return; hero = withPr(hero, pr); }
          finish({ hero, keep: keepList(list, hero), took: true, via: 'email' });
        }
        /* a Hall session already here (and not "Not you?"): straight to the heroes. Otherwise the email door, with a
           stale session’s email filled in */
        const emailDoor = (msgText, bad, email) => swap(first || L.lineEmail, () => emailStep(msgText, bad, email));
        (async () => {
          const s = forgotten() ? null : hall.session();
          if (!s) { emailDoor('', false); return; }
          await swap(first || L.pick, readingStep);
          const v = await hall.verify(s.email, s.pin);
          if (!isOpen) return;
          if (v.network || !v.ok) { emailDoor(L.offline, true); return; }
          if (!(v.n > 0)) { emailDoor('', false, s.email); return; }
          hall.touch();
          const l = await hall.list(s.email);
          if (!isOpen) return;
          if (!l.ok) { emailDoor(L.offline, true); return; }
          choose(hall.heroes(l.rows));
        })().catch(() => { if (isOpen) emailDoor(L.offline, true); });
      }, { cls: 'lb-lg' });

      /* modal while it’s open: the rest of the frame steps back (no taps, no Tab stops), Escape is "Not now" */
      [...F.el.children].forEach((c) => { if (c !== sh && c !== scrim && !c.inert) { c.inert = true; inerted.push(c); } });
      const onKey = (e) => { if ((e.key === 'Escape' || e.key === 'Esc') && sh && sh.isConnected) { e.preventDefault(); if (shut) shut(); } };
      document.addEventListener('keydown', onKey, true);
      offs.push(() => document.removeEventListener('keydown', onKey, true));
      /* the phone’s keyboard: the card sits at the top of what’s left of the screen */
      const vv = window.visualViewport;
      const fitKb = () => {
        if (!sh || !sh.isConnected || !vv) return;
        const kb = window.innerHeight - vv.height > 120;
        sh.classList.toggle('is-kb', kb);
        if (kb) { const r = F.el.getBoundingClientRect(); sh.style.setProperty('--lblg-top', Math.max(8, vv.offsetTop - r.top + 8) + 'px'); sh.style.setProperty('--lblg-h', Math.max(200, vv.height - 16) + 'px'); }
      };
      if (vv) { vv.addEventListener('resize', fitKb); vv.addEventListener('scroll', fitKb); offs.push(() => { vv.removeEventListener('resize', fitKb); vv.removeEventListener('scroll', fitKb); }); }
      const onFocus = (e) => { const t = e.target; if (t && t.tagName === 'INPUT') setTimeout(() => { fitKb(); reveal(t); }, 320); };
      if (sh) sh.addEventListener('focusin', onFocus);
      function reveal(t) {
        /* scroll the card itself, never the frame round it */
        if (!sh || !sh.isConnected || !t || !t.isConnected) return;
        const a = sh.getBoundingClientRect(), b = t.getBoundingClientRect();
        if (b.bottom > a.bottom - 12) sh.scrollTop += b.bottom - a.bottom + 12;
        else if (b.top < a.top + 12) sh.scrollTop -= a.top + 12 - b.top;
      }
      return done.then((v) => {
        isOpen = false; shut = null;
        offs.splice(0).forEach((f) => { try { f(); } catch (e) { /* fine */ } });
        inerted.forEach((c) => { c.inert = false; }); inerted = [];
        scrim.classList.remove('is-in');
        setTimeout(() => scrim.remove(), RM() ? 0 : 260);
        return v || null;
      });
    }

    async function open(o) {
      if (running || closed || !F || typeof F.sheet !== 'function' || !F.el) return null;
      running = true;
      let held = false;
      try {
        if (!hall.on) { await say([L.closed]); return null; }
        if (hall.lockLeft() > 0) { await say([L.wait]); return null; }
        if (typeof api.hold === 'function') { api.hold(true); held = true; }
        const v = await sheet(o || {}).catch(() => null);
        if (closed) return null;
        if (!v) { if (lastMiss) poster(); return null; }
        const q = Q();
        /* the email door proves the Quest and stores nothing but the hero copy: no Hall session, no day stamp */
        const r = !q ? { took: !!v.took, hero: v.hero, fresh: true }
          : v.via === 'email' ? q.set(v.hero, 'email', { heroes: v.keep, took: true })
            : q.set(v.hero, 'hall', { heroes: v.keep, checkedDay: today() });
        snd('pen');
        if (!r.took) await say([said(L.inHall, (r.hero && r.hero.name) || v.hero.name)]);
        return { took: !!r.took, hero: r.hero || null, fresh: !!r.fresh };
      } finally {
        if (held) api.hold(false);
        running = false;
      }
    }

    function refresh() {
      if (refreshing) return refreshing;
      const q = Q();
      if (!hall.on || !q || closed) return Promise.resolve(null);
      let info; try { info = q.info(); } catch (e) { return Promise.resolve(null); }
      const day = today();
      /* never with a session that may be someone else’s: no stored PIN of theirs is sent for an email-door reader */
      if (info.forgot || info.noHall || info.via === 'email' || info.checkedDay === day) return Promise.resolve(null);
      const s = hall.session();
      if (!s) return Promise.resolve(null);
      refreshing = (async () => {
        const v = await hall.verify(s.email, s.pin);
        if (v.network || !v.ok) return null;
        if (!(v.n > 0)) { q.set(null, null, { checkedDay: day }); return null; }
        hall.touch();
        const l = await hall.list(s.email);
        if (!l.ok) return null;
        const list = hall.heroes(l.rows), cur = q.hero();
        let hero = null, via = null;
        if (cur) {
          /* the hero this browser already knows, linked to its Hall row (by id, or by name, class and race) */
          const m = list.find((e) => cur.heroId ? e.id === cur.heroId : keyOf(e.name) === keyOf(cur.name) && e.cls === cur.cls && keyOf(e.race) === keyOf(cur.race));
          /* an account without this browser’s hero is someone else’s, so its heroes stay out of this reader’s switch
             sheet (only the day is stamped) */
          if (!m) { q.set(null, null, { checkedDay: day }); return { took: q.took(), fresh: false }; }
          hero = asHero(m, cur, null).hero;
        } else {
          const qh = list.find((e) => e.fromQuest);
          if (qh) { hero = asHero(qh, null, null).hero; via = 'hall'; }
        }
        const r = q.set(hero, via, { heroes: keepList(list, hero), checkedDay: day, silent: true });
        return { took: !!r.took, fresh: !!r.fresh };
      })().catch(() => null).finally(() => { refreshing = null; });
      return refreshing;
    }

    return {
      open, refresh,
      busy: () => running || !!refreshing,
      /* the room is going: the sheet goes with it */
      close() { if (closed) return; closed = true; if (shut) shut(); }
    };
  };
  FFD.parts['library/ledger'].Hall = Hall;
  FFD.parts['library/ledger'].L = L;
  FFD.parts['library/ledger'].SELECT = SELECT;
  FFD.parts['library/ledger'].QL_SELECT = QL_SELECT;
  FFD.parts['library/ledger'].normEmail = normEmail;
  FFD.parts['library/ledger'].emailHero = emailHero;
  FFD.parts['library/ledger'].keepList = keepList;
})();

/* ===== src/scene-pages/pages/library/memories.js ===== */
/* library/memories.js: the darkest-memory book in Zhaunil's library (a part of the library page, id library).
   Jan (2026-10-07): "the room floods like the Quest memory, a journal for the character's darkest memory, shared across
   devices", and after the pitch: "The book reads like a book: a two-page spread on laptops that turns when the pointer
   reaches a page's outer edge (corner curl as it nears), one page on upright phones turned by swipe or edge tap, arrow
   keys too, no page buttons, and no 'Jan reads every page' note (approval stays, silently). After leaving a page it
   reads 'Your page is in the book.'" The plan is docs/scene-pages/jukebox/README.md, the playable pitch's openNotebook
   (docs/scene-pages/jukebox/pitch/js/pitch.js) is the look and the turning, and sql/SCENE-MEMORY-01-DARKEST-BOOK.sql is
   the shared book.
   Jan (2026-10-07, later): "this book should only flip the page if they press the edges when it flips up, not
   automatically, and fill it with some more pages of regrets make some of them darker for dnd players, write them in
   different ways", and the room behind it should show a little more. So a page never turns by itself: with a mouse,
   nearing a page's outer edge lifts its corner and shows a pointer, and a click there turns it; on touch a tap on the
   edge (a small corner rests there) or a swipe turns it; the arrow keys still do.

   The book opens over the room. Its first page is the reader's own: a short form (their character's name and class,
   what kind of memory, the memory itself), or, once they have left one, their page as written. Then the pages Jan kept
   in the Data Hub, newest first, then thirty story pages (Bartholomew and twenty-nine strangers, light and dark in turn,
   so the book is never empty and reads as full), then "That's the last page." The story pages live only here: the SQL
   never stores, counts or serves them. A reader's own page shows at once and stays in their browser; everyone else sees it only
   after Jan keeps it, and the book never says so. The form keeps what was typed across turns, a close and a reopen.
   It never reads or fills in the Quest's own memory text: only the name and class of the scene pages' saved character
   (localStorage 'ffd-char') fill the form.

   The Hall adapter (Store below) talks only to the three page doors of SCENE-MEMORY-01, with the Hall's public key, no
   cookies and no referrer, and only on the store (FFD.live === true with a Hall address and key). Before that SQL runs
   the first call answers 404: the adapter writes 'ffd-book-none' and asks nothing more for six hours, and every page
   stays in the browser as owed, with nothing shown to the reader. Once the SQL is in, the next visit sends what is owed,
   once each. A refusal (22023) comes back with its hint ('link', 'contact', 'word', 'short', 'long', 'field'), which the
   form says in plain words; 'same' counts as written. A 429 or no network keeps the page owed for a later visit.
   The browser keeps: 'ffd-book-token' (one random id, only ever sent to the add and mine doors, stored by the Hall as a
   hash), 'ffd-book-pages' (its own pages, newest twelve) and 'ffd-book-none' (the nap).

   The interface (the room calls the factory once, after its frame exists):
     FFD.parts['library/memories'](api: { F, RM(), snd(name), SITE, live, hall: { url, key }, talk, hold(on) })
       -> { open() -> Promise (resolves when the book closes), wrote() -> boolean (a page was left, this visit or
            before), busy() -> boolean, prefetch() -> Promise (the Hall read, ahead of opening), close() }
   When Bartholomew's story page shows, the book marks it for the skull's bridge (FFD.egg('library') bart.page, and
   the document event 'ffd:egg' { page: 'library', what: 'bartpage' }); nothing else of the book is shared.
   The book draws itself inside api.F.el (one overlay the size of the frame), styles itself with one style element (id
   ffd-css-library-memories, every rule under .ffd-page--library), holds the room (api.hold) while open, and cleans up
   on close(). The adapter is also on the factory as .Store (and the lists as .CLASSES and .KINDS) for
   harness/scene-memory.test.cjs. */
(() => {
  'use strict';
  const FFD = window.FFD;
  if (!FFD) return;
  const CSS_ID = 'ffd-css-library-memories';
  const P = '.ffd-page--library';

  /* the lists the SQL checks, in Quest One's order (assets/quest-one-v2-art.js CLASSES) */
  const CLASSES = [['barbarian', 'Barbarian'], ['bard', 'Bard'], ['cleric', 'Cleric'], ['druid', 'Druid'], ['fighter', 'Fighter'], ['monk', 'Monk'],
    ['paladin', 'Paladin'], ['ranger', 'Ranger'], ['rogue', 'Rogue'], ['sorcerer', 'Sorcerer'], ['warlock', 'Warlock'], ['wizard', 'Wizard'],
    ['artificer', 'Artificer'], ['bloodhunter', 'Blood Hunter'], ['other', 'Adventurer']];
  const KINDS = [['loss', 'A loss'], ['mistake', 'A mistake'], ['promise', 'A broken promise'], ['betrayal', 'A betrayal'], ['fear', 'A fear'], ['rival', 'A rival']];
  const label = (list, k) => { const x = list.find((c) => c[0] === k); return x ? x[1] : ''; };
  /* the story pages: they come after every kept page, so the book is never empty. Five, by five different hands
     (Jan 2026-10-08: "make it sound more like different people wrote them, and only fill like the first 5 pages"):
     Bartholomew's dry line (the skull's bridge egg reads SEED[0]), a paladin's formal oath, a druid's breathless run-on,
     a ranger's tally, a rogue's lowercase note. Each carries its hand (ink, letters and slant in the CSS below), stays
     within a reader's 20 to 360 characters, and keeps to the book's own class and kind lists. A line break is a new line. */
  const story = (who, c, k, text, hand) => ({ who, cls: label(CLASSES, c), kind: label(KINDS, k), text, hand });
  const SEED = [
    { who: 'Bartholomew', cls: 'Skull, retired', kind: 'A mistake', hand: 'dry', text: 'I told the party the bridge would hold. I was the one who checked it. I still had a body then.' },
    story('Ser Halvard Ostry', 'paladin', 'promise', 'Let it be written here that I, Halvard Ostry, swore upon the dawn to spare any foe who yielded. At Greyfen a bandit knelt and yielded. He had drowned the ferryman not an hour before, and I was weary, and no one was watching. I did not spare him. The dawn rises for me still. It no longer warms me.', 'oath'),
    story('Marigold Fenwick', 'druid', 'mistake', 'So I turned into a bear to impress a boy at the harvest dance, which I had never done before, not once, and then I couldn’t remember how to stop being a bear, and he married the girl who pulled me out of the punch bowl, and they named their first daughter Marigold, so I suppose we’re even.', 'rush'),
    story('Hollis Fenn', 'ranger', 'loss', 'Nights I’ve made camp alone since the barrow at Kesh\n||||\u2003||||\u2003||||\u2003||||\u2003||||\u2003||||\u2003||||\u2003||||\u2003||\nI still cut wood for five. I leave the four best places by the fire empty.', 'tally'),
    story('Linnet Moss', 'rogue', 'mistake', 'never told the others the crown was a fake.\nthey were so happy.', 'note')
  ];
  /* what the form says when the Hall refuses a page (the add door's hints) */
  const SAYS = {
    field: 'Give your character a name first.',
    short: 'A few more words. Where did it happen?',
    long: 'That runs past one page. Trim it a little.',
    link: 'Leave links out. The book keeps only the memory.',
    contact: 'Leave out emails, handles and phone numbers.',
    word: 'The book won’t take some of those words. Say it another way.'
  };
  const PROMPTS = ['Start with where it happened.', 'Keep going. What happened?', 'Good. What did it cost them?', 'That’s the page.'];

  /* ================================================================ the Hall adapter ================================================================ */
  const K_NAP = 'ffd-book-none', K_TOKEN = 'ffd-book-token', K_OWN = 'ffd-book-pages';
  const NAP_MS = 6 * 3600 * 1000, KEEP = 12, BATCH = 12, WAIT_MS = 9000;
  function uuid() {
    const C = (typeof crypto !== 'undefined' && crypto) || null;
    try { if (C && typeof C.randomUUID === 'function') return C.randomUUID(); } catch (e) { /* fall through */ }
    const b = new Uint8Array(16);
    try { if (C && C.getRandomValues) C.getRandomValues(b); else throw new Error('none'); } catch (e) { for (let i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256); }
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    const x = [...b].map((v) => v.toString(16).padStart(2, '0')).join('');
    return x.slice(0, 8) + '-' + x.slice(8, 12) + '-' + x.slice(12, 16) + '-' + x.slice(16, 20) + '-' + x.slice(20);
  }
  const okPage = (p) => !!(p && typeof p.n === 'string' && p.n && typeof p.b === 'string' && p.b && CLASSES.some((c) => c[0] === p.c) && KINDS.some((k) => k[0] === p.k));
  /* o: { hall: { url, key }, live, ls (a localStorage), fetch, now() } */
  function Store(o) {
    o = o || {};
    const ls = o.ls || null, net = o.fetch || null, now = o.now || (() => Date.now());
    const hall = o.hall && o.hall.url && o.hall.key ? { url: String(o.hall.url).replace(/\/$/, ''), key: String(o.hall.key) } : null;
    const get = (k) => { try { return ls ? ls.getItem(k) : null; } catch (e) { return null; } };
    const put = (k, v) => { try { if (ls) ls.setItem(k, v); } catch (e) { /* fine: the page still shows this visit */ } };
    /* this browser's pages, newest first: { n name, c class, k kind, b words, at, s 'owed' | 'ok' | 'same' | 'no', p page number once kept } */
    let own = [];
    try { const v = JSON.parse(get(K_OWN) || '[]'); if (Array.isArray(v)) own = v.filter(okPage).slice(0, KEEP); } catch (e) { own = []; }
    const save = () => put(K_OWN, JSON.stringify(own.slice(0, KEEP)));
    const napping = () => { const t = Number(get(K_NAP)); return t > 0 && now() - t < NAP_MS; };
    /* off: nothing is ever sent (not the store, no Hall printed, no fetch, or napping). held: writes wait for a later visit */
    let off = !(o.live === true && hall && typeof net === 'function') || napping(), held = false, shared = false;
    let kept = [], more = false, last = null, reading = null, readOnce = false, synced = null, flight = 0;
    const token = () => { let t = get(K_TOKEN); if (!/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(t || '')) { t = uuid(); put(K_TOKEN, t); } return t; };
    async function call(fn, body, write) {
      if (off) return { off: true };
      const init = { method: 'POST', headers: { apikey: hall.key, Authorization: 'Bearer ' + hall.key, 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit', referrerPolicy: 'no-referrer' };
      if (write) init.keepalive = true; else init.cache = 'no-store';
      let ac = null, timer = 0, r;
      try { if (typeof AbortController === 'function') { ac = new AbortController(); init.signal = ac.signal; timer = setTimeout(() => ac.abort(), WAIT_MS); } } catch (e) { ac = null; }
      flight++;
      try { r = await net(hall.url + '/rest/v1/rpc/' + fn, init); } catch (e) { return { offline: true }; } finally { flight--; if (timer) clearTimeout(timer); }
      /* not installed (404), or a key the Hall refuses: quiet for six hours, nothing shown */
      if (r.status === 404 || r.status === 401 || r.status === 403) { off = true; put(K_NAP, String(now())); return { gone: true, status: r.status }; }
      let j = null;
      try { j = await r.json(); } catch (e) { j = null; }
      if (r.ok) { shared = true; return { ok: true, data: j }; }
      return { status: r.status, code: j && j.code, hint: j && j.hint };
    }
    /* one page to the Hall. The answer: 'ok' | 'same' | a refusal hint | 'later' */
    async function send(pg) {
      if (off || held) return 'later';
      const r = await call('scene_memory_add', { p_token: token(), p_name: pg.n, p_cls: pg.c, p_kind: pg.k, p_body: pg.b }, true);
      if (r.ok) return 'ok';
      if (r.status === 400 && r.code === '22023') return r.hint === 'same' ? 'same' : (SAYS[r.hint] ? r.hint : 'word');
      held = true;   /* a 429, a server error or no network: the rest waits for a later visit */
      return 'later';
    }
    /* once a visit: what earlier visits owe goes first, oldest first, once each; then the newest kept pages; then the
       page numbers of this browser's kept pages */
    async function sync() {
      for (const pg of own.slice().reverse()) {
        if (pg.s !== 'owed') continue;
        const a = await send(pg);
        if (a === 'later') break;
        pg.s = a === 'ok' ? 'ok' : a === 'same' ? 'same' : 'no';
        save();
      }
      await readMore();
      await mine();
    }
    function ready() { if (!synced) synced = sync().catch(() => {}); return synced; }
    function readMore() {
      if (off || reading) return reading || Promise.resolve();
      if (readOnce && !more) return Promise.resolve();
      reading = (async () => {
        const r = await call('scene_memory_read', last == null ? { p_limit: BATCH } : { p_before: last, p_limit: BATCH }, false);
        readOnce = true;
        if (r.ok && r.data && Array.isArray(r.data.rows)) {
          const seen = new Set(kept.map((x) => x.page));
          r.data.rows.forEach((x) => { if (x && Number.isInteger(x.page) && !seen.has(x.page) && typeof x.body === 'string' && typeof x.name === 'string') { kept.push({ page: x.page, name: x.name, cls: x.cls, kind: x.kind, body: x.body }); seen.add(x.page); } });
          kept.sort((a, b) => b.page - a.page);
          more = !!r.data.more && r.data.rows.length > 0;
          if (kept.length) last = kept[kept.length - 1].page;
        } else more = false;
      })().finally(() => { reading = null; });
      return reading;
    }
    /* the Hall's own list of this browser's pages, newest first, lines up with this browser's sent pages, newest first */
    async function mine() {
      const sent = own.filter((pg) => pg.s === 'ok');
      if (off || !sent.length || !sent.some((pg) => pg.p == null) || !get(K_TOKEN)) return;
      const r = await call('scene_memory_mine', { p_token: token() }, false);
      if (!r.ok || !Array.isArray(r.data)) return;
      sent.forEach((pg, i) => { const x = r.data[i]; if (x && Number.isInteger(x.page)) pg.p = x.page; });
      save();
    }
    /* a new page: kept in the browser first (so a closed tab loses nothing), then sent. { ok: true } or { ok: false, hint } */
    async function add(page) {
      const pg = { n: String(page.name || '').trim().slice(0, 40), c: page.cls, k: page.kind, b: String(page.body || '').trim().slice(0, 360), at: now(), s: 'owed', p: null };
      if (!okPage(pg)) return { ok: false, hint: 'field' };
      if (synced) await synced;
      own.unshift(pg); own = own.slice(0, KEEP); save();
      const a = await send(pg);
      if (a === 'later') return { ok: true, later: true };
      if (a !== 'ok' && a !== 'same') { own = own.filter((x) => x !== pg); save(); return { ok: false, hint: a }; }
      pg.s = a; save();
      return { ok: true };
    }
    return {
      ready, readMore, add,
      kept: () => kept.slice(), more: () => more && !off,
      own: () => own.map((pg) => ({ name: pg.n, cls: pg.c, kind: pg.k, body: pg.b, at: pg.at, page: pg.p, sent: pg.s })),
      wrote: () => own.length > 0, shared: () => shared, busy: () => flight > 0
    };
  }

  /* ================================================================ the book ================================================================ */
  const CSS = `
${P} .lbm { position: absolute; inset: 0; z-index: 12; display: block; opacity: 0; transition: opacity .26s ease; -webkit-tap-highlight-color: transparent; letter-spacing: normal; text-align: left; }
${P} .lbm.is-in { opacity: 1; }
${P} .lbm.is-out { opacity: 0; transition-duration: .22s; }
/* the flooded room stays in sight behind the book (Jan, 2026-10-07: "lower the opacity for the water scene so we can see
   a bit more of the library"); the edges stay darker so the hint and Close still read */
${P} .lbm-dim { position: absolute; inset: 0; display: block; background: radial-gradient(ellipse at 50% 45%, rgba(10, 34, 40, .5), rgba(2, 7, 9, .72) 72%); touch-action: none; }
${P} .lbm-stage { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; box-sizing: border-box;
  padding: calc(env(safe-area-inset-top, 0px) + 62px) 16px calc(env(safe-area-inset-bottom, 0px) + 14px); container-type: size; touch-action: none; }
${P} .lbm-bk { position: relative; display: grid; grid-template-columns: 1fr 1fr; flex: none; aspect-ratio: 1.45; perspective: 2200px; filter: drop-shadow(0 26px 40px rgba(0, 0, 0, .65)); touch-action: none;
  width: min(860px, calc(100vw - 32px), calc((100svh - 130px) * 1.45)); width: min(860px, 100cqw, calc((100cqh - 40px) * 1.45)); }
/* a sideways phone: the stage gives up its top band (the Close button sits clear of the spread at the side) and the
   spread takes the width beside it, so each page is half again as tall and wide as a book-shaped spread would be */
@media (max-height: 500px) and (min-width: 700px) {
  ${P} .lbm-stage { gap: 6px; padding-top: calc(env(safe-area-inset-top, 0px) + 10px); padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 8px); }
  ${P} .lbm-bk:not(.is-single) { aspect-ratio: auto; height: calc(100cqh - 30px); width: min(860px, calc(100cqw - 192px), calc((100cqh - 30px) * 2.1)); }
}
${P} .lbm-bk.is-single { grid-template-columns: 1fr; aspect-ratio: .68; width: min(440px, calc(100vw - 32px), calc((100svh - 130px) * .68)); width: min(440px, 100cqw, calc((100cqh - 40px) * .68)); }
${P} .lbm-bk:focus { outline: none; }
${P} .lbm-l, ${P} .lbm-r { position: relative; display: block; min-width: 0; }
${P} .lbm-pg { position: absolute; inset: 0; display: block; overflow: hidden; color: #1f2a30; background: linear-gradient(to top, rgba(54, 96, 106, .30), transparent 16%), radial-gradient(ellipse at 50% 38%, #e6edf0, #d2dce1 66%, #bccad1); }
${P} .lbm-l .lbm-pg, ${P} .lbm-lf-b .lbm-pg { border-radius: 8px 2px 2px 8px; box-shadow: inset -22px 0 26px -16px rgba(20, 44, 52, .5); }
${P} .lbm-r .lbm-pg, ${P} .lbm-lf-f .lbm-pg { border-radius: 2px 8px 8px 2px; box-shadow: inset 22px 0 26px -16px rgba(20, 44, 52, .5); }
${P} .lbm-bk.is-single .lbm-pg { border-radius: 3px 8px 8px 3px; box-shadow: inset 16px 0 22px -14px rgba(20, 44, 52, .5); }
${P} .lbm-pg.is-blank { background: radial-gradient(ellipse at 50% 38%, #dfe7eb, #c9d4da); }
${P} .lbm-in { position: absolute; inset: 0; display: grid; gap: 7px; align-content: start; padding: 8% 9% 11%; overflow-y: auto; overscroll-behavior: contain; scrollbar-width: none; touch-action: pan-y; container-type: inline-size; }
${P} .lbm-in::-webkit-scrollbar { display: none; }
${P} .lbm-in.is-end { align-content: center; text-align: center; }
${P} .lbm-in.is-ink { animation: lbm-ink .32s ease; }
@keyframes lbm-ink { 50% { opacity: .35; filter: blur(1px); } }
${P} .lbm-n { position: absolute; bottom: 4%; display: block; font: 12px var(--f-body, 'Spectral', Georgia, serif); color: #5a6d76; }
${P} .lbm-l .lbm-n, ${P} .lbm-lf-b .lbm-n { left: 8%; }
${P} .lbm-r .lbm-n, ${P} .lbm-lf-f .lbm-n, ${P} .lbm-bk.is-single .lbm-n { right: 8%; left: auto; }
${P} .lbm-leaf { position: absolute; top: 0; bottom: 0; left: 50%; z-index: 3; display: block; width: 50%; transform-style: preserve-3d; pointer-events: none; visibility: hidden; }
${P} .lbm-bk.is-single .lbm-leaf { left: 0; width: 100%; }
${P} .lbm-leaf.is-fwd { visibility: visible; transform-origin: left center; transform: rotateY(0deg); }
${P} .lbm-leaf.is-back { visibility: visible; left: 0; transform-origin: right center; transform: rotateY(0deg); }
${P} .lbm-bk.is-single .lbm-leaf.is-back { transform-origin: left center; transform: rotateY(-180deg); }
${P} .lbm-leaf.is-go { transition: transform .72s cubic-bezier(.45, .05, .25, 1); }
${P} .lbm-leaf.is-fwd.is-go { transform: rotateY(-180deg); }
${P} .lbm-leaf.is-back.is-go { transform: rotateY(180deg); }
${P} .lbm-bk.is-single .lbm-leaf.is-back.is-go { transform: rotateY(0deg); }
${P} .lbm-lf { position: absolute; inset: 0; display: block; backface-visibility: hidden; -webkit-backface-visibility: hidden; }
${P} .lbm-lf-b { transform: rotateY(180deg); }
${P} .lbm-leaf.is-go .lbm-lf::after { content: ''; position: absolute; inset: 0; pointer-events: none; background: linear-gradient(to right, rgba(10, 30, 36, .28), transparent 60%); animation: lbm-shade .72s ease both; }
@keyframes lbm-shade { 0%, 100% { opacity: 0; } 50% { opacity: 1; } }
${P} .lbm-curl { position: absolute; bottom: 0; z-index: 4; display: block; width: 0; height: 0; pointer-events: none; transition: width .25s ease, height .25s ease; }
${P} .lbm-curl.is-r { right: 0; border-top-left-radius: 6px; background: linear-gradient(135deg, transparent 50%, #b7c6cd 50%, #e3eaee 76%, #cbd6dc); box-shadow: -3px -3px 8px rgba(10, 30, 36, .25); }
${P} .lbm-curl.is-l { left: 0; border-top-right-radius: 6px; background: linear-gradient(225deg, transparent 50%, #b7c6cd 50%, #e3eaee 76%, #cbd6dc); box-shadow: 3px -3px 8px rgba(10, 30, 36, .25); }
/* the corner lifts where a press would turn: under a mouse at the edge (with a pointer), under a finger as it presses,
   and on touch screens a small corner rests wherever there's a page to turn to */
@media (hover: none) { ${P} .lbm-bk.can-r .lbm-curl.is-r, ${P} .lbm-bk.can-l .lbm-curl.is-l { width: 20px; height: 20px; } }
${P} .lbm-bk.is-near-r .lbm-curl.is-r, ${P} .lbm-bk.is-near-l .lbm-curl.is-l { width: 34px; height: 34px; }
${P} .lbm-bk.is-near-r, ${P} .lbm-bk.is-near-l { cursor: pointer; }
${P} .lbm-bk.is-stop { animation: lbm-stop .3s ease; }
@keyframes lbm-stop { 30% { transform: translateX(-4px); } 60% { transform: translateX(3px); } }
${P} .lbm-hint { margin: 0; min-height: 1.4em; font: italic 500 15px/1.35 var(--f-aside, 'Cormorant Garamond', Georgia, serif); color: rgba(220, 238, 240, .72); text-align: center; transition: opacity .5s ease; }
${P} .lbm-hint.is-gone { opacity: 0; }
${P} .lbm-x { position: absolute; z-index: 6; top: calc(env(safe-area-inset-top, 0px) + 10px); right: 12px; min-width: 44px; min-height: 44px; padding: 6px 16px; border-radius: 999px;
  border: 1px solid rgba(220, 238, 240, .4); background: rgb(8, 20, 24); color: #e6f2f4; cursor: pointer; font: 600 13px var(--f-body, 'Spectral', Georgia, serif); }
${P} .lbm-x:hover { border-color: rgba(220, 238, 240, .75); }
${P} .lbm-x:focus-visible, ${P} .lbm button:focus-visible, ${P} .lbm input:focus-visible, ${P} .lbm select:focus-visible, ${P} .lbm textarea:focus-visible { outline: 2px solid #7fd0dc; outline-offset: 2px; }
${P} .lbm-sr { position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; border: 0; }
${P} .lbm-k { margin: 0; font: 600 11px var(--f-body, 'Spectral', Georgia, serif); letter-spacing: .16em; text-transform: uppercase; color: #3d5560; }
${P} .lbm label { display: grid; gap: 3px; margin: 0; font: 600 12px var(--f-body, 'Spectral', Georgia, serif); color: #2d3c44; }
${P} .lbm input, ${P} .lbm select, ${P} .lbm textarea { box-sizing: border-box; width: 100%; min-height: 40px; margin: 0; padding: 6px 8px; border: 1px solid #9fb1ba; border-radius: 6px;
  background: rgba(255, 255, 255, .5); color: #1f2a30; font: 16px/1.35 var(--f-body, 'Spectral', Georgia, serif); color-scheme: light; }
${P} .lbm textarea { min-height: 0; resize: none; font-family: var(--f-aside, 'Cormorant Garamond', Georgia, serif); font-size: 18px; font-style: italic; }
${P} .lbm-row { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
/* a narrow page (a sideways phone's spread) stacks the two pickers, so neither is cut short */
@container (max-width: 280px) { ${P} .lbm-row { grid-template-columns: 1fr; } }
${P} .lbm-ct { display: block; font: 12px var(--f-body, 'Spectral', Georgia, serif); color: #5a6d76; text-align: right; }
${P} .lbm-say { margin: 0; min-height: 1.2em; font: italic 500 15px/1.3 var(--f-aside, 'Cormorant Garamond', Georgia, serif); color: #7a2f22; }
${P} .lbm-say:empty { display: none; }
${P} .lbm-go, ${P} .lbm-again { display: inline-flex; align-items: center; justify-content: center; justify-self: start; min-height: 44px; padding: 6px 18px; border-radius: 999px; cursor: pointer;
  font: 600 15px/1.2 var(--f-body, 'Spectral', Georgia, serif); }
${P} .lbm-go { border: 1px solid #24414b; background: #24414b; color: #eef6f8; }
${P} .lbm-go:disabled { opacity: .7; cursor: default; }
${P} .lbm-again { border: 1px solid #6f8a96; background: rgba(255, 255, 255, .5); color: #1f2a30; }
${P} .lbm-who { display: grid; margin: 0; font: 600 19px/1.25 var(--f-display, 'Cinzel', Georgia, serif); color: #1d343c; overflow-wrap: anywhere; }
${P} .lbm-who small { font: italic 500 15px var(--f-aside, 'Cormorant Garamond', Georgia, serif); color: #4d636c; }
${P} .lbm-tx { margin: 0; font: italic 500 18px/1.48 var(--f-aside, 'Cormorant Garamond', Georgia, serif); font-size: clamp(17px, 5.8cqw, 21px); color: #1f2a30; overflow-wrap: anywhere; }
${P} .lbm-tx.is-lines { white-space: pre-line; }
/* five hands for the five story pages, from the page's own fonts: a skull's tidy upright, a knight's clerkly capitals,
   a druid's hurried slanting brown ink, a ranger's plain notches, a thief's small red-brown note */
${P} .lbm-tx.is-hand-dry { font-style: normal; letter-spacing: .01em; color: #263238; }
${P} .lbm-tx.is-hand-oath { font: 500 15px/1.62 var(--f-display, 'Cinzel', Georgia, serif); font-size: clamp(13.5px, 4.3cqw, 16px); letter-spacing: .02em; color: #1c2a33; }
${P} .lbm-tx.is-hand-rush { font-size: clamp(18px, 6.2cqw, 22.5px); line-height: 1.36; color: #4a3122; transform: rotate(-1.1deg); transform-origin: 0 0; word-spacing: .05em; }
${P} .lbm-tx.is-hand-tally { font: 400 16px/1.55 var(--f-body, 'Spectral', Georgia, serif); font-size: clamp(15px, 5cqw, 17.5px); color: #34302a; }
${P} .lbm-tx.is-hand-note { font-size: clamp(16px, 5.2cqw, 19px); color: #6a2b2f; margin-top: .8em; transform: rotate(.7deg); transform-origin: 0 0; }
${P} .lbm-note { margin: 0; font: italic 500 15px var(--f-aside, 'Cormorant Garamond', Georgia, serif); color: #3d5560; }
@media (prefers-reduced-motion: reduce) {
  ${P} .lbm, ${P} .lbm-hint, ${P} .lbm-curl { transition: none; }
  ${P} .lbm-leaf.is-go { transition: none; }
  ${P} .lbm-in.is-ink, ${P} .lbm-bk.is-stop, ${P} .lbm-leaf.is-go .lbm-lf::after { animation: none; }
}`;

  function factory(api) {
    api = api || {};
    const F = api.F;
    const RM = () => { try { return typeof api.RM === 'function' ? !!api.RM() : !!(FFD.RM && FFD.RM()); } catch (e) { return false; } };
    const snd = (n) => { try { if (api.snd) api.snd(n); } catch (e) { /* a sound never breaks the book */ } };
    const hold = (on) => { try { if (typeof api.hold === 'function') api.hold(!!on); } catch (e) { /* fine */ } };
    let ls = null;
    try { ls = window.localStorage; } catch (e) { ls = null; }
    const hall = api.hall || window.FFD_HALL || (api.SITE && api.SITE.hall) || null;
    const store = Store({ hall, live: api.live === true || (api.live === undefined && FFD.live === true), ls, fetch: typeof fetch === 'function' ? fetch.bind(window) : null });

    /* the reader's page: one form for the whole visit, so whatever they typed survives every turn, a close and a reopen */
    let writeEl = null, writing = false, sending = false, sayEl = null;
    const esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    const written = (s, note, kicker) => (kicker ? '<p class="lbm-k">' + esc(kicker) + '</p>' : '') +
      '<p class="lbm-who">' + esc(s.who) + '<small>' + esc(s.cls) + ' \u00b7 ' + esc(s.kind) + '</small></p><p class="lbm-tx' + (s.lines ? ' is-lines' : '') + (s.hand ? ' is-hand-' + s.hand : '') + '">' + esc(s.text) + '</p>' + (note ? '<p class="lbm-note">' + esc(note) + '</p>' : '');
    const ownView = (pg) => ({ who: pg.name, cls: label(CLASSES, pg.cls), kind: label(KINDS, pg.kind), text: pg.body });
    function buildForm() {
      const ch = FFD.char || null;
      const pick = ch && CLASSES.some((c) => c[0] === ch.cls) ? ch.cls : 'fighter';
      const el = document.createElement('div');
      el.className = 'lbm-in';
      el.innerHTML = '<p class="lbm-k">Your page</p>' +
        '<label>Your character’s name<input type="text" maxlength="40" autocomplete="off" placeholder="Name" data-f="name"></label>' +
        '<div class="lbm-row"><label>Class<select data-f="cls">' + CLASSES.map((c) => '<option value="' + c[0] + '"' + (c[0] === pick ? ' selected' : '') + '>' + esc(c[1]) + '</option>').join('') + '</select></label>' +
        '<label>What kind of memory<select data-f="kind">' + KINDS.map((k) => '<option value="' + k[0] + '">' + esc(k[1]) + '</option>').join('') + '</select></label></div>' +
        '<label>The memory<textarea maxlength="360" rows="6" placeholder="' + PROMPTS[0] + '" data-f="body"></textarea></label>' +
        '<span class="lbm-ct" aria-hidden="true"><span>0</span> of 360</span><p class="lbm-say" aria-live="polite"></p>' +
        '<button type="button" class="lbm-go">Leave it in the book</button>';
      const name = el.querySelector('[data-f="name"]'), ta = el.querySelector('textarea'), ct = el.querySelector('.lbm-ct span'), go = el.querySelector('.lbm-go');
      sayEl = el.querySelector('.lbm-say');
      if (ch && typeof ch.name === 'string') name.value = ch.name.slice(0, 40);
      const count = () => { const n = ta.value.length; ct.textContent = n; ta.placeholder = PROMPTS[Math.min(3, Math.floor(n / 90))]; };
      ta.addEventListener('input', () => { count(); if (sayEl.textContent) sayEl.textContent = ''; });
      name.addEventListener('input', () => { if (sayEl.textContent) sayEl.textContent = ''; });
      go.addEventListener('click', async () => {
        if (sending) return;
        const page = { name: name.value.trim(), cls: el.querySelector('[data-f="cls"]').value, kind: el.querySelector('[data-f="kind"]').value, body: ta.value.trim() };
        if (!page.name) { sayEl.textContent = SAYS.field; name.focus(); return; }
        if (page.body.length < 20) { sayEl.textContent = SAYS.short; ta.placeholder = 'A few more words. Where did it happen?'; ta.focus(); return; }
        sending = true; go.disabled = true;
        let r;
        try { r = await store.add(page); } catch (e) { r = { ok: true }; } finally { sending = false; go.disabled = false; }
        if (!r.ok) { sayEl.textContent = SAYS[r.hint] || SAYS.word; ta.focus(); return; }
        snd('pen');
        ta.value = ''; count();
        writing = false;
        const host = el.parentNode, show = () => { if (book) book.redraw(); };
        if (!RM() && host) { el.classList.add('is-ink'); setTimeout(() => { el.classList.remove('is-ink'); show(); }, 320); } else show();
      });
      return el;
    }
    /* the first page: the form, or the reader's newest page as written */
    function firstPage() {
      const own = store.own();
      if (writing || !own.length) {
        if (!writeEl) writeEl = buildForm();
        return writeEl;
      }
      const el = document.createElement('div');
      el.className = 'lbm-in';
      el.innerHTML = written(ownView(own[0]), 'Your page is in the book.') + '<button type="button" class="lbm-again">Write another page</button>';
      el.querySelector('.lbm-again').addEventListener('click', () => { writing = true; snd('rustle'); if (book) book.redraw(); });
      return el;
    }

    let book = null, ended = null, endRes = null;
    function css() {
      if (document.getElementById(CSS_ID)) return;
      const st = document.createElement('style'); st.id = CSS_ID; st.textContent = CSS; document.head.appendChild(st);
    }
    function open() {
      if (book) return ended;
      if (!F || !F.el) return Promise.resolve();
      css();
      ended = new Promise((r) => { endRes = r; });
      hold(true);
      book = makeBook();
      store.ready().then(() => { if (book) book.redraw(); });
      return ended;
    }

    function makeBook() {
      const prev = document.activeElement;
      const o = document.createElement('div');
      o.className = 'lbm';
      o.setAttribute('role', 'dialog'); o.setAttribute('aria-modal', 'true'); o.setAttribute('aria-label', 'The book of darkest memories');
      o.innerHTML = '<div class="lbm-dim"></div><div class="lbm-stage"><div class="lbm-bk" tabindex="-1"><div class="lbm-l"></div><div class="lbm-r"></div>' +
        '<div class="lbm-leaf"><div class="lbm-lf lbm-lf-f"></div><div class="lbm-lf lbm-lf-b"></div></div><span class="lbm-curl is-r" aria-hidden="true"></span><span class="lbm-curl is-l" aria-hidden="true"></span></div>' +
        '<p class="lbm-hint"></p><p class="lbm-sr" aria-live="polite"></p></div><button type="button" class="lbm-x" aria-label="Close the book">Close</button>';
      F.el.appendChild(o);
      const bk = o.querySelector('.lbm-bk'), L = o.querySelector('.lbm-l'), R = o.querySelector('.lbm-r'), leaf = o.querySelector('.lbm-leaf'),
        lf = o.querySelector('.lbm-lf-f'), lb = o.querySelector('.lbm-lf-b'), hint = o.querySelector('.lbm-hint'), sr = o.querySelector('.lbm-sr');
      const offs = [];
      const on = (t, ev, fn, opt) => { t.addEventListener(ev, fn, opt); offs.push(() => t.removeEventListener(ev, fn, opt)); };
      let single = false, page = 0, busy = false, turned = false, timer = 0;
      /* kept pages join the book only while the reader is still before them, so what they are looking at never moves */
      let shown = store.kept();
      const mineNos = () => new Set(store.own().map((pg) => pg.page).filter((n) => Number.isInteger(n)));
      const N = () => 1 + shown.length + SEED.length + 1;
      const isSingle = () => { const w = F.el.clientWidth || window.innerWidth || 0; return w < 700; };
      function pageNode(i) {
        const el = document.createElement('div');
        el.className = 'lbm-pg';
        if (i === 0) el.append(firstPage());
        else if (i <= shown.length) { const k = shown[i - 1], mine = mineNos().has(k.page); el.innerHTML = '<div class="lbm-in">' + written({ who: k.name, cls: label(CLASSES, k.cls) || 'Adventurer', kind: label(KINDS, k.kind), text: k.body }, '', mine ? 'Your page' : '') + '</div>'; }
        else if (i <= shown.length + SEED.length) el.innerHTML = '<div class="lbm-in">' + written(Object.assign({ lines: true }, SEED[i - 1 - shown.length])) + '</div>';
        else el.innerHTML = '<div class="lbm-in is-end"><p class="lbm-tx">That’s the last page.</p></div>';
        if (i > 0) { const n = document.createElement('span'); n.className = 'lbm-n'; n.textContent = String(i); el.append(n); }
        return el;
      }
      const blank = () => { const e = document.createElement('div'); e.className = 'lbm-pg is-blank'; return e; };
      /* Bartholomew's page (SEED[0]) in view: the skull in the room remembers it (library/games.js, his bridge). It
         marks bart.page in the egg kit and sends the note 'bartpage' as the document event 'ffd:egg', once a book */
      let bartSeen = false;
      function bartShown() {
        const at = 1 + shown.length;
        if (bartSeen || (page !== at && (single || page + 1 !== at))) return;
        bartSeen = true;
        try { if (typeof FFD.egg === 'function') FFD.egg('library').set('bart.page', 1); } catch (e) { /* this browser only, when it can */ }
        try { document.dispatchEvent(new CustomEvent('ffd:egg', { detail: { page: 'library', what: 'bartpage' } })); } catch (e) { /* fine */ }
      }
      const fill = (slot, i) => slot.replaceChildren(i >= 0 && i < N() ? pageNode(i) : blank());
      const step = () => (single ? 1 : 2);
      const say = () => { const a = page + 1, b = single ? a : Math.min(N(), page + 2); sr.textContent = (a === b ? 'Page ' + a : 'Pages ' + a + ' and ' + b) + ' of ' + N(); };
      /* newer batches are older pages, so they only ever join after the ones shown: merging is safe while every page in
         view is before them (and at the very start, when the first kept pages arrive) */
      function merge() {
        const fresh = store.kept();
        if (fresh.length !== shown.length && (page === 0 || page + (single ? 0 : 1) <= shown.length)) shown = fresh;
      }
      function show() {
        merge();
        fill(L, page); if (!single) fill(R, page + 1);
        bartShown();
        say();
        bk.classList.toggle('can-r', page + step() < N()); bk.classList.toggle('can-l', page > 0);
        reNear();
        if (store.more() && page + step() * 2 >= shown.length) store.readMore().then(() => { if (book) book.redraw(); });
      }
      function layout() {
        single = isSingle();
        bk.classList.toggle('is-single', single);
        if (!single && page % 2) page -= 1;
        R.style.display = single ? 'none' : '';
        /* the hint follows the hand, not the layout: a mouse presses, a finger taps or swipes */
        let fine = false;
        try { fine = matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) { fine = false; }
        hint.textContent = fine ? 'Press the edge of a page to turn it.' : 'Tap the edge of a page, or swipe, to turn it.';
        show();
      }
      /* redraw after kept pages arrive or a page is written (never in the middle of a turn) */
      function redraw() {
        if (busy) { setTimeout(() => { if (book) book.redraw(); }, 760); return; }
        show();
      }
      function turn(dir) {
        if (busy) return;
        const next = page + dir * step();
        if (next < 0 || next >= N()) { bk.classList.remove('is-stop'); void bk.offsetWidth; bk.classList.add('is-stop'); return; }
        busy = true; near(0); snd('flip');
        if (!turned) { turned = true; hint.classList.add('is-gone'); }
        if (RM()) { page = next; busy = false; show(); return; }
        leaf.className = 'lbm-leaf ' + (dir > 0 ? 'is-fwd' : 'is-back');
        if (single) {
          if (dir > 0) { fill(lf, page); lb.replaceChildren(); fill(L, next); } else { fill(lf, next); lb.replaceChildren(); }
        } else if (dir > 0) { fill(lf, page + 1); fill(lb, next); fill(R, next + 1); } else { fill(lf, page); fill(lb, next + 1); fill(L, next); }
        void leaf.offsetWidth;
        leaf.classList.add('is-go');
        timer = setTimeout(() => { timer = 0; page = next; leaf.className = 'lbm-leaf'; lf.replaceChildren(); lb.replaceChildren(); busy = false; show(); }, 720);
      }
      /* a page turns only when the reader presses its outer edge, never by itself. The edge is a strip along each page's
         outer side (a sixth of the page under a mouse, a little more under a finger, never under 44px), live only where
         there is a page to turn to. A mouse nearing it lifts the corner and shows a pointer; a click there turns. A
         finger's tap there turns (the corner lifts while it presses), and a swipe turns either way. A press that starts on
         the form (a field, a label, a button) never turns, and neither does a drag (choosing words to copy, say). */
      let hov = null, down = null;
      function edgeAt(cx, fine) {
        const r = bk.getBoundingClientRect();
        if (!r.width) return 0;
        const z = Math.max(44, (r.width / (single ? 1 : 2)) * (fine ? 0.16 : 0.22)), x = cx - r.left;
        if (x >= r.width - z && x <= r.width && page + step() < N()) return 1;
        if (x <= z && x >= 0 && page > 0) return -1;
        return 0;
      }
      function near(d) { bk.classList.toggle('is-near-r', d > 0); bk.classList.toggle('is-near-l', d < 0); }
      function reNear() { if (!down) near(hov && !busy && !hov.f ? edgeAt(hov.x, true) : 0); }
      on(bk, 'pointermove', (e) => {
        if (e.pointerType !== 'mouse') return;
        hov = { x: e.clientX, f: field(e.target) };
        reNear();
      });
      on(bk, 'pointerleave', (e) => { if (e.pointerType !== 'mouse') return; hov = null; reNear(); });
      const field = (t) => !!(t && t.closest && t.closest('input, textarea, select, button, label, a'));
      on(bk, 'pointerdown', (e) => {
        down = null;
        if ((e.pointerType === 'mouse' && e.button !== 0) || field(e.target)) return;
        const fine = e.pointerType === 'mouse';
        down = { x: e.clientX, y: e.clientY, id: e.pointerId, fine, d: busy ? 0 : edgeAt(e.clientX, fine) };
        if (!fine && down.d) near(down.d);
      });
      on(bk, 'pointercancel', () => { down = null; reNear(); });
      on(bk, 'pointerup', (e) => {
        const d0 = down;
        down = null;
        if (!d0 || e.pointerId !== d0.id) { reNear(); return; }
        const dx = e.clientX - d0.x, dy = e.clientY - d0.y;
        if (!d0.fine) near(0);
        if (!d0.fine && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) { turn(dx < 0 ? 1 : -1); return; }
        if (Math.abs(dx) > 12 || Math.abs(dy) > 12) { reNear(); return; }
        const sel = (() => { try { const g = window.getSelection(); return !!(g && !g.isCollapsed && String(g).trim()); } catch (err) { return false; } })();
        if (d0.d && !sel && edgeAt(e.clientX, d0.fine) === d0.d) turn(d0.d); else reNear();
      });
      /* keys: arrows turn (never while typing), Escape closes; the room's own keys never see them while the book is open */
      on(window, 'keydown', (e) => {
        if (!o.isConnected) return;
        const t = e.target, typing = !!(t && t.closest && t.closest('input, textarea, select'));
        if (e.key === 'Escape') { if (t && t.closest && t.closest('select')) return; e.preventDefault(); e.stopPropagation(); close(true); return; }
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.stopPropagation(); if (typing) return; e.preventDefault(); turn(e.key === 'ArrowRight' ? 1 : -1); return; }
        /* Enter and Space keep their own meaning inside the book (a button presses, the memory gets a new line), and
           the room never takes them as "continue"; Enter in the name moves on to the memory */
        if (e.key === 'Enter' || e.key === ' ') {
          if (!(o.contains(t) || t === document.body)) return;
          e.stopPropagation();
          if (e.key === 'Enter' && t && t.matches && t.matches('[data-f="name"]')) { e.preventDefault(); const ta = o.querySelector('textarea'); if (ta) ta.focus(); }
          return;
        }
        if (e.key === 'Tab') {
          const f = [...o.querySelectorAll('button, input, select, textarea')].filter((x) => !x.disabled && x.offsetParent !== null && !x.closest('.lbm-leaf'));
          if (!f.length) return;
          const i = f.indexOf(document.activeElement);
          if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
        }
      }, true);
      on(o.querySelector('.lbm-x'), 'click', () => close(true));
      /* a tap off the book closes it (Jan 2026-10-08); the reader's own page keeps its words until they come back */
      const openedAt = Date.now();
      on(o, 'click', (e) => {
        const t = e.target;
        if (Date.now() - openedAt < 350 || !t || !t.classList) return;
        if (t === o || t.classList.contains('lbm-dim') || t.classList.contains('lbm-stage')) close(true);
      });
      let ro = null;
      const resized = () => { if (isSingle() !== single && !busy) layout(); };
      try { ro = new ResizeObserver(resized); ro.observe(F.el); } catch (e) { on(window, 'resize', resized); }
      layout();
      snd('rustle');
      requestAnimationFrame(() => { o.classList.add('is-in'); try { bk.focus({ preventScroll: true }); } catch (e) { /* fine */ } });
      return {
        redraw,
        teardown(soft) {
          offs.forEach((f) => f()); if (ro) ro.disconnect(); if (timer) clearTimeout(timer);
          /* the form is kept for the next opening; only its place in this book goes */
          if (writeEl && writeEl.parentNode) writeEl.parentNode.removeChild(writeEl);
          const gone = () => { o.remove(); try { if (prev && prev.focus && prev.isConnected) prev.focus({ preventScroll: true }); } catch (e) { /* fine */ } };
          if (soft && !RM()) { o.classList.remove('is-in'); o.classList.add('is-out'); setTimeout(gone, 230); } else gone();
        }
      };
    }
    function close(soft) {
      if (!book) return;
      if (soft) snd('pat');
      const b = book; book = null;
      b.teardown(!!soft);
      hold(false);
      const r = endRes; endRes = null; ended = null;
      if (r) r();
    }
    return {
      open,
      wrote: () => store.wrote(),
      busy: () => !!book || sending || store.busy(),
      prefetch: () => store.ready(),
      close: () => close(false)
    };
  }
  factory.Store = Store;
  factory.CLASSES = CLASSES.map((c) => c[0]);
  factory.KINDS = KINDS.map((k) => k[0]);
  (FFD.parts = FFD.parts || {})['library/memories'] = factory;
})();

/* ===== src/scene-pages/pages/library/moods.js ===== */
/* library/moods.js: the room's moods, one for each record on Zhaunil's jukebox (a part of the library page). Jan
   (2026-10-07): a jukebox, and "the room changes with each song". The plan and Jan's fixes after the pitch are
   docs/scene-pages/jukebox/README.md; the renderer here is the playable pitch's (docs/scene-pages/jukebox/pitch/js/pitch.js),
   moved into the real room.

   Everything is drawn INSIDE the library painter's one draw: src/scene-pages/scenes/library.js calls V.lbMood(phase, R)
   at fixed points of it, and this part paints straight into its pixels at its own grid. So the moods sit at the right
   depth (the guests behind Zhaunil, the near tables in front of him, the flames over the record's colour, the hover
   rings over everything), the wings beside a wide window read the mooded room, and a resize rebuilds them with the
   room. Every position comes from the room's own measurements (F.get('lbLay'), published on every build), so each
   screen size works; sprite units scale with the room's height over 200. The tall room (an upright phone frame that
   is not panned) gets no jukebox and no moods.
   The points, in the painter's order: 'back' (over the walls and the floor), 'behind' (just before the easel's brush
   and the things on the tables; a painter without it is fine, the back guests then go in at 'mid'), 'mid' (just
   before Zhaunil), 'front', 'grade' (before the dark), 'light' (after it), 'over', 'spots'. A guest at the back of the
   room (the Iron Matron, the back table, the flood's kelp) is drawn only where the painter's depth R.z is a wall or
   the floor (ZBACK), so the easel and the furniture baked into the room stand in front of it, and what still shows
   of it is checked again at 'grade' (seen), so its rim, its eyes or its colour after the dark never land on whatever
   was drawn in front of it later. The Ash record's cloud follows the painter's live moon, F.get('lbMoon') [x, y, r],
   when it publishes one; each record sets the room window's weather, 'vistaWx' (After Hours rain, Hearthside snow).

   The candles a record puts out (Ash, Blackwater) go through their own channel, V.lbMoodCand (false: out for the mood),
   never the candle game's (the journal, the borders' dark and the game's own candles answer to the game alone).

   FFD.parts['library/moods'](api) -> moods. api = { F, RM, snd(name, o), level() (the music, 0..1), time() (seconds
   into the record), has(borderKey), paused() (an overlay is open or the tab is hidden: timed beats freeze), reduced }
     moods.start(o)         hands the painter the draw; the room then waits dark until juke('wake') (o.awake: lit now)
     moods.record(id, o)    the room turns to record id: the old one leaves, the new one comes in. o.quick lands it at
                            its settled state with no entrance (a restore, a screen change); reduced motion always does
     moods.juke(action, v)  'wake' (the Enter light-up), 'jolt', 'roulette' { cols }, 'land' { id },
                            'lamps' { heard, gold }, 'keep' { items }, 'locked'
     moods.act(name, v)     a guest answers a tap (the names are in ACT at the bottom)
     moods.spots()          [{ id, x, y, w, h, label }] in grid px, ids 'jb-...': what a reader can touch right now
     moods.state()          { rec, settled, stare, blink (the Matron's eyes shut), glint (the thorn behind her can be
                            taken), posted, frogAt, coins, looks (the patrons looking on their own) }
     moods.on(cue, fn)      -> off. Cues: settled { rec }, guards-in, salute, frog-landed, cart-stopped, tables-in,
                            stare-on, stare-off, vanished { rec }, knock { n }, door-open, matron-posted, flooded,
                            book-up, drained, lit. The page speaks and plays its sounds on these; the moods play only the
                            sounds no cue carries (a cart's wheels, a murmur, a candle going out)
     moods.ink(id)          the page's ink for a record (theme-color)
     moods.qa()             what one frame of the moods costs (ms), for checks; qa().seek(ms) puts the playing record's
                            own clock at ms (the beats it passes run quietly), for frame sequences
     moods.close() */
(() => {
  'use strict';
  const FFD = window.FFD = window.FFD || {};
  FFD.parts = FFD.parts || {};

  /* ---------------- small maths ---------------- */
  const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
  const lerp = (a, b, t) => a + (b - a) * t;
  const sat = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
  const eio = (t) => { t = sat(t); return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; };
  const eout = (t) => { t = sat(t); return 1 - Math.pow(1 - t, 3); };
  const eback = (t) => { t = sat(t); const c1 = 1.70158, c3 = c1 + 1; return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); };
  const hex = (h) => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
  const BAYM = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5].map((v) => (v + 0.5) / 16);
  const bay = (x, y) => BAYM[(y & 3) * 4 + (x & 3)];
  const hsh = (a, b) => { let h = (a * 374761393 + b * 668265263) | 0; h = (h ^ (h >>> 13)) * 1274126177; return ((h ^ (h >>> 16)) >>> 0) / 4294967295; };
  const now = () => (window.performance && performance.now ? performance.now() : Date.now());

  /* ---------------- the records ---------------- */
  const REC = {
    quiet: { col: '#e8a85a', ink: '#16110a', home: true },
    hearth: { col: '#ff8a3d', ink: '#1a1009', home: true },
    after: { col: '#f0c070', ink: '#1c130b', home: true },
    regal: { col: '#6f8cff', ink: '#13101d' },
    bog: { col: '#8fe07a', ink: '#0b140e' },
    tinker: { col: '#e09a4a', ink: '#1b1208' },
    tavern: { col: '#d0603a', ink: '#170d07' },
    flood: { col: '#3fb8b0', ink: '#050c10' },
    ash: { col: '#ff3b30', ink: '#07080c' }
  };
  Object.keys(REC).forEach((k) => { REC[k].rgb = hex(REC[k].col); });
  /* the six road stops, in the order of the lamps along the jukebox's base */
  const FIRST = ['regal', 'bog', 'tinker', 'tavern', 'flood', 'ash'];
  /* the room window's weather for each record (the study's own table, library/study.js WX): the painter's 'vistaWx',
     set with the record (docs/scene-pages/jukebox/VISTAS.md), so After Hours rains outside the glass it streaks, and
     Hearthside snows; every other record is a clear night */
  const WXR = { quiet: 'clear', hearth: 'snow', after: 'rain' };
  /* each record's colour on the room, a multiply, a lift and a saturation. The bog creeps up from the floor, the King's
     Road sweeps in from the jukebox's side */
  const GR = {
    hearth: { m: [1.06, 0.97, 0.88], a: [8, 3, 0], s: 1 },
    after: { m: [1.1, 0.96, 0.84], a: [12, 5, 0], s: 1.02 },
    regal: { m: [1.08, 0.98, 0.86], a: [10, 4, 10], s: 1.12, dir: 'x' },
    bog: { m: [0.62, 0.86, 0.58], a: [6, 16, 8], s: 0.72, dir: '-y' },
    tinker: { m: [1.1, 0.94, 0.8], a: [12, 4, 8], s: 0.95 },
    tavern: { m: [1.12, 0.92, 0.7], a: [14, 6, 0], s: 1 },
    /* Jan (2026-10-07): "lower the opacity for the water scene so we can see a bit more of the library", so the flood's
       grade is about half what it was ({ m: [0.8, 0.86, 0.9], a: [0, 0, 4], s: 0.9 }) */
    flood: { m: [0.89, 0.923, 0.945], a: [0, 0, 2], s: 0.945 },
    ash: { m: [0.62, 0.7, 0.92], a: [0, 2, 10], s: 0.45 }
  };
  /* the grades as channel tables, so a whole frame costs table look-ups: at full strength a channel is
     (L[c][r] + L[c][g] + L[c][b]) >> 8, the multiply, the lift and the saturation folded into one 3x3; the pass blends
     toward that by the mood's amount */
  const GLUT = {};
  Object.keys(GR).forEach((id) => {
    const g = GR[id], s = g.s, w = [0.3, 0.59, 0.11], L = new Int32Array(9 * 256);
    for (let c = 0; c < 3; c++) for (let j = 0; j < 3; j++) {
      const m = (c === j ? s : 0) + (1 - s) * w[j];
      for (let v = 0; v < 256; v++) L[(c * 3 + j) * 256 + v] = Math.round(256 * m * (v * g.m[j] + g.a[j]));
    }
    GLUT[id] = L;
  });
  /* how long a record's colour takes to come in and to go (ms), and how long a leaving record is still drawn */
  const DUR = { quiet: [0, 0], hearth: [1600, 900], after: [1600, 900], regal: [1200, 1400], bog: [1400, 1600], tinker: [1000, 1400], tavern: [1000, 1400], flood: [600, 2600], ash: [3000, 1600] };
  const EXIT = { quiet: 600, hearth: 900, after: 900, regal: 2600, bog: 2600, tinker: 2800, tavern: 2200, flood: 3600, ash: 2400 };
  /* when a record has settled (its guests are in, its light has fallen; the page's first words wait for this), and
     where a quick landing puts its clock */
  const SET = { quiet: 0, hearth: 1600, after: 2000, regal: 4500, bog: 3500, tinker: 3800, tavern: 2200, flood: 4600, ash: 4000 };
  const QUICK = { quiet: 1000, hearth: 4000, after: 4000, regal: 9000, bog: 9000, tinker: 9000, tavern: SET.tavern, flood: 9000, ash: 40000 };
  const C = {
    ol: [26, 18, 16], k1: [43, 29, 24], wd1: [64, 41, 30], wd2: [92, 59, 39], wd3: [127, 84, 54], wd4: [168, 116, 76],
    br1: [90, 62, 20], br2: [142, 106, 36], br3: [201, 168, 76], br4: [232, 198, 116], br5: [244, 214, 138], hw: [255, 246, 220],
    gl: [12, 10, 14], pa: [232, 224, 208], red: [255, 59, 48], cold: [159, 183, 217], teal: [110, 200, 195]
  };
  /* the flood's ramp, from the deep to the shallows, by brightness 0..255 (its deep end lifted, Jan 2026-10-07; it was
     '#050c10', '#0a1a20', '#102d35', '#1c4a52', '#3b7a7e', '#8bc3bb') */
  const RAMP = new Uint8Array(256 * 3);
  /* how much of the room's dark (every candle out under the water) the flood gives back, 0..1 */
  const FLOOD_LIFT = 0.45;
  (function () {
    const tr = ['#08141a', '#11262d', '#1a3c45', '#285b63', '#4a8a8d', '#96cbc3'].map(hex);
    for (let v = 0; v < 256; v++) {
      const k = Math.min(4.999, v / 255 * 5), k0 = Math.floor(k), f = k - k0, c0 = tr[k0], c1 = tr[Math.min(5, k0 + 1)];
      for (let c = 0; c < 3; c++) RAMP[v * 3 + c] = Math.round(lerp(c0[c], c1[c], f));
    }
  })();
  const FROG = [['..gg..gg..', '.gygggygg.', 'gggggggggg', 'ggbbbbbbgg', '.gbbbbbbg.', 'gg.g..g.gg'],
    ['..gg..gg..', '.gygggygg.', 'gggggggggg', 'ggBBBBBBgg', 'gBBBBBBBBg', 'gg.g..g.gg']];
  const FROGPAL = { g: [111, 143, 58], y: [232, 200, 74], b: [215, 217, 160], B: [235, 238, 190] };
  /* the frog's keepsake on the jukebox's crown: the frog cast in brass (her own shape: the eye bumps, the round belly,
     the feet; its eyes dark dots in the metal), lit on its left, on a little plinth of dark wood with a brass rim */
  const FIGURE = ['..LL..Lm..', '.LdmmmdmL.', 'Lmmmmmmmmd', 'mmLLLLLLmd', '.mLLLLLmd.', 'mm.m..m.dd', 'rrrrrrrrrr', 'PPPPPPPPPP', '.pppppppp.'];
  const FIGPAL = { L: [240, 204, 112], m: [188, 140, 58], d: [112, 78, 34], r: [168, 124, 56], P: [62, 42, 30], p: [36, 24, 18] };
  const SK = 'ffd-library-moods';
  const CSS_ID = 'ffd-css-library-moods';
  /* the jukebox's guests win over the room's own buttons while they are there (the frame lays both in one layer); in
     the Hollow Stump a coin wins over the back table's board, and the board over the regulars, whose padded 44 px
     buttons reach into both on a small screen; the thorn at the Iron Matron's feet wins over her own button */
  const CSS = '.ffd-page--library .ffs-hot[data-hot^="jb-"]{z-index:1}.ffd-page--library .ffs-hot[data-hot="jb-table"]{z-index:2}.ffd-page--library .ffs-hot[data-hot^="jb-coin-"],.ffd-page--library .ffs-hot[data-hot="jb-thorn"]{z-index:3}';
  /* the depth the painter's base gives each pixel (R.z): 1 the walls and the door, 2 the floor, 3 and up what is baked
     into the room in front of them (the easel, the tables, the chair). A guest at the back of the room is drawn only
     where the depth is ZBACK or less, so the easel and the furniture stand in front of her (Jan, 2026-10-09: "make
     sure when she moves over she moves BEHIND the easle") */
  const ZBACK = 2;
  /* the Iron Matron's eyes, once she has taken her post: open MAT_OPEN ms of every MAT_P. They close where they are (a dim
     red slit stays) and while they are shut a thorn glints behind her, a body's width to her side at the foot of the
     bookcase: it fades in GL_IN ms after they shut (over GL_FADE) and is gone GL_END ms before they open (over GL_OUT),
     so it never comes or goes with her eyes and never where they were (Jan, 2026-10-09: "her eyes randomly fall on the
     floor when it turns white") */
  const MAT_P = 10000, MAT_OPEN = 6400, GL_IN = 1000, GL_FADE = 450, GL_OUT = 400, GL_END = 300;
  /* her shape, from her feet up in units: the skirt's A-line, the apron's waist, the chest, the sloping shoulders down
     to the neck ([height, half width]); the head and the knot of hair are ellipses on top */
  const MAT_BODY = [[0, 6.2], [3, 6], [9, 5.3], [15, 4.6], [19, 3.8], [21, 3.4], [23, 3.9], [26, 4.4], [27.4, 4.9], [28.8, 5], [29.8, 4.4], [30.5, 3], [30.9, 1.5], [31, 1.2], [32.2, 1.2]];
  const MAT_BLK = [10, 11, 15], MAT_APR = [15, 17, 23];
  /* the flood's kelp: the stalk, a leaf, a pale tip */
  const KELP = [[40, 90, 60], [54, 112, 70], [86, 146, 92]];

  FFD.parts['library/moods'] = function (api) {
    const F = api.F;
    const RM = typeof api.RM === 'function' ? api.RM : () => !!api.reduced;
    const snd = (n, o) => { try { if (api.snd) api.snd(n, o || {}); } catch (e) { /* fine */ } };
    const level = () => { try { const v = api.level ? +api.level() : 0.4; return isFinite(v) ? sat(v) : 0.4; } catch (e) { return 0.4; } };
    const mtime = () => { try { const v = api.time ? +api.time() : 0; return isFinite(v) ? v : 0; } catch (e) { return 0; } };
    const paused = () => { try { return !!(api.paused && api.paused()); } catch (e) { return false; } };
    const hasC = {};
    const has = (k) => {
      const c = hasC[k], n = now(); if (c && n - c.t < 500) return c.v;
      let v = false; try { v = !!(api.has && api.has(k)); } catch (e) { /* fine */ }
      hasC[k] = { v, t: n }; return v;
    };
    const fset = (n, v) => { try { F.set(n, v); } catch (e) { /* fine */ } };
    const door = () => { try { F.act('open-door'); } catch (e) { /* fine */ } };
    if (typeof document !== 'undefined' && !document.getElementById(CSS_ID)) {
      try { const s = document.createElement('style'); s.id = CSS_ID; s.textContent = CSS; document.head.append(s); } catch (e) { /* fine */ }
    }

    /* ---------------- what this reader has done, kept in this browser ---------------- */
    const kept = (() => { try { const v = JSON.parse(localStorage.getItem(SK) || 'null'); return v && typeof v === 'object' ? v : {}; } catch (e) { return {}; } })();
    const keep = (k) => { kept[k] = true; try { localStorage.setItem(SK, JSON.stringify({ pack: !!kept.pack, book: !!kept.book })); } catch (e) { /* fine */ } };

    /* ---------------- state ---------------- */
    const st = {
      rec: 'quiet', insts: [], awake: false, wake0: -1e9, started: false,
      mc: [false, false, false, false], mcSent: '',
      wave: null, thread: null, flights: [],
      jolt: -1e9, lockT: -1e9, roul: null, jukeRec: 'quiet', disc: 0, crown: 0.12,
      heard: {}, gold: {}, keep: new Set(),
      doze: false, owlWake: -1e9
    };
    let closed = false, T = now(), lastU = 0, lastDraw = -1e9, rm = !!RM(), timer = 0, pokeN = 0;
    let D = null, U32 = null, W = 0, H = 0, G = null, lastBuf = null, lastLay = null, frameT0 = 0, frameMs = 0;
    /* Z the painter's depth for each pixel (null when it gives none: then nothing is hidden); ZT on while a guest at the
       back of the room is drawn (px skips what stands in front); fno counts the painter's draws, bhd the last one that
       had a 'behind' point (a painter without one draws the back guests at 'mid') */
    let Z = null, ZT = false, fno = 0, bhd = -1;
    const cost = { n: 0, sum: 0, max: 0, last: 0 };
    const timers = new Set();
    const later = (ms, fn) => { const id = setTimeout(() => { timers.delete(id); if (!closed) { try { fn(); } catch (e) { /* fine */ } } }, ms); timers.add(id); return id; };
    const live = (id) => st.insts.find((I) => I.id === id && I.tx == null) || null;
    const isLive = (I) => st.insts.indexOf(I) >= 0 && I.tx == null;

    /* ---------------- cues: told after the draw, never inside it ---------------- */
    const fns = {}, cq = [];
    let cqT = 0;
    function cue(name, d) {
      cq.push([name, d || {}]);
      if (!cqT) cqT = setTimeout(() => {
        cqT = 0;
        cq.splice(0).forEach(([n, dd]) => (fns[n] || []).slice().forEach((fn) => { try { fn(dd); } catch (e) { console.error(e); } }));
      }, 0);
    }
    /* values for the painter, sent after the draw: a value set from inside the painter's draw would, under reduced
       motion, draw a whole frame inside that one (the frame draws on every poke there) */
    const pend = {};
    let pendQ = false;
    function send(n, v) {
      pend[n] = v;
      if (!pendQ) { pendQ = true; Promise.resolve().then(() => { pendQ = false; if (closed) return; Object.keys(pend).forEach((k) => { const x = pend[k]; delete pend[k]; fset(k, x); }); }); }
    }
    /* under reduced motion the painter draws only when poked: poke it whenever what shows has changed */
    function poke() { if (rm && !closed) send('lbMoodV', (pokeN = (pokeN + 1) % 1e6)); }

    /* ---------------- the moods' candles ---------------- */
    function setCand(i, on, quiet) {
      if (i < 0 || i >= st.mc.length || st.mc[i] === on) return;
      st.mc[i] = on;
      if (!quiet && !rm) snd('candle', on ? {} : { warm: false });
      poke();
    }
    function sendCand() {
      const sig = st.mc.map((b) => (b ? 1 : 0)).join('');
      if (sig !== st.mcSent) { st.mcSent = sig; send('lbMoodCand', st.mc.slice()); }
    }
    const darkRec = () => { const I = live('ash') || live('flood'); return !!I; };
    /* the candles from one side: nearest to x first */
    function candOrder(x) { const L = G && G.cand; if (!L) return st.mc.map((_, i) => i); return L.map((c, i) => [i, Math.abs(c[0] - x)]).sort((a, b) => a[1] - b[1]).map((a) => a[0]); }
    function relightAll(gap, quiet) {
      if (!st.awake || darkRec()) return;
      const ord = candOrder(G && G.J ? G.J.x : 0);
      if (!gap || rm || quiet) { ord.forEach((i) => setCand(i, true, true)); return; }
      ord.forEach((i, n) => later(n * gap, () => { if (st.awake && !darkRec()) setCand(i, true, false); }));
    }

    /* ---------------- the room's measurements, as this part uses them ---------------- */
    function geo(L) {
      if (!L || !L.W || !L.H) return null;
      const k = L.H / 200, fl = L.floorY, fd = L.H - fl, Wl = L.W, Hl = L.H;
      const g = { W: Wl, H: Hl, k, wide: !!L.wide && !!L.juke, fl, fd, cor: L.corT };
      if (!g.wide) return g;
      g.J = { x: L.juke[0], y: L.juke[1], w: L.juke[2], h: L.juke[3] };
      g.D = { cx: L.door[0], half: L.door[1], top: L.door[2], x0: L.door[0] - L.door[1], x1: L.door[0] + L.door[1] };
      g.win = { x0: L.win[0], T: L.win[1], x1: L.win[2], B: L.win[3], w: L.win[2] - L.win[0], h: L.win[3] - L.win[1], cx: (L.win[0] + L.win[2]) / 2 };
      g.moon = L.moon;
      g.cand = L.cand.map((c) => [c[0], c[1], c[2]]);
      g.lcand = L.lcand || [L.lect[0] - 20 * k, L.lect[1] - 12 * k];
      g.bays = L.bays.map((b) => ({ x0: b[0], x1: b[1], cx: (b[0] + b[1]) / 2 }));
      g.posts = Array.from(new Set(L.bays.reduce((a, b) => a.concat([b[0], b[1]]), []))).sort((a, b) => a - b);
      g.easel = { cx: L.easel[0], w: L.easel[1], f: L.easel[2] };
      g.lect = { x: L.lect[0], top: L.lect[1], bot: L.lect[2], w: L.lw || Math.round(13 * k) };
      g.book = L.book || [L.lect[0], L.lect[1] + 4];
      g.seat = L.seat || g.win.B + 6;
      g.tb = { x0: L.tb[0], x1: L.tb[1], top: L.tb[2], bot: L.tb[3] };
      /* the King's Road watch: Pike before the door, the sergeant at its side */
      g.pike = [g.D.cx, fl + 1.5 * k];
      g.maren = [Math.max(g.D.x0 - 10 * k, g.easel.cx + g.easel.w / 2 + 10.5 * 1.15 * k + 1), fl + 2.5 * k];
      g.pennants = g.bays.map((b) => [Math.round(b.cx - 2), g.cor + 1, Math.round(22 * k)]);
      g.torches = [[Math.round(g.D.x0 - 5 * k), Math.round(g.D.top + 10 * k)], [Math.min(Wl - 2, Math.round(g.D.x1 + 5 * k)), Math.round(g.D.top + 10 * k)]];
      /* the Blackfen: three puddles, reeds at the posts' feet and in the near corners, the frog's three seats (the
         jukebox's crown, the puddle by the easel, the book on the lectern) */
      g.puddles = [[0.83 * Wl, fl + 0.58 * fd, 10 * k], [0.67 * Wl, fl + 0.77 * fd, 12 * k], [0.19 * Wl, fl + 0.69 * fd, 9 * k]];
      const pp = g.posts.filter((p, i) => i === 0 || i === 1 || i === g.posts.length - 2 || i === g.posts.length - 1);
      g.reeds = [];
      pp.forEach((p, i) => { g.reeds.push([p - 4, fl + 1]); if (i % 2 === 0) g.reeds.push([p + 2, fl + 2]); });
      g.reedsNear = [[Math.round(4 * k), Hl - 4], [Math.round(12 * k), Hl - 3], [Wl - Math.round(16 * k), Hl - 4], [Wl - Math.round(6 * k), Hl - 3]];
      g.frog = [[g.J.x + g.J.w / 2, g.J.y + 1], [g.puddles[0][0] - 2, g.puddles[0][1] - 1], [g.book[0], g.book[1] - 1]];
      g.flyBase = [[g.bays[0].cx, fl - 45 * k], [g.win.cx + 2, g.win.T + 0.55 * g.win.h], [g.bays[g.bays.length - 1].cx, fl - 30 * k]];
      const c0 = g.cand.slice().sort((a, b) => Math.abs(a[0] - g.win.cx) - Math.abs(b[0] - g.win.cx)).find((c) => c[0] < g.win.cx) || g.cand[0];
      g.wisp = [[c0[0] + 7 * k, c0[1] + 12 * k], [g.win.x0 - 9 * k, fl - 28 * k], [g.D.x0 - 18 * k, g.D.top + 6 * k], [g.J.x + g.J.w / 2, g.J.y + 4]];
      g.wispFrom = [c0[0], c0[1] - 3];
      /* Old Yost's cart stops where the easel stands; the mule waits in the doorway (drawMule) */
      g.cart = { w: Math.round(56 * k), h: Math.round(40 * k), cx: g.easel.cx - 3 * k, fy: Math.round(fl + 10 * k) };
      /* the Hollow Stump's three tables, one at the back between the lectern and the easel, two near, their regulars'
         backs to us */
      const bx1 = Math.min(0.6375 * Wl + 40 * k, g.easel.cx - g.easel.w / 2 - 2), bx0 = Math.max(g.lect.x + g.lect.w + 2, bx1 - 40 * k);
      g.tables = [
        { x: bx0, y: Math.round(fl - 8 * k), w: Math.round(bx1 - bx0), from: 1, pats: [{ dx: 8 * k, s: 1.3 * k, hood: 1 }, { dx: 30 * k * (bx1 - bx0) / (40 * k), s: 1.3 * k, hood: 0 }], coin: [bx0 + 18 * k, Math.round(fl - 8 * k) - 1] },
        { x: 0.1125 * Wl, y: Math.round(fl + 0.718 * fd), w: Math.round(60 * k), from: -1, pats: [{ dx: 12 * k, s: 2.0 * k, hood: 1, back: 1 }, { dx: 44 * k, s: 1.9 * k, hood: 0, back: 1 }], coin: [0.1125 * Wl + 30 * k, Math.round(fl + 0.718 * fd) - 1] },
        { x: 0.82 * Wl, y: Math.round(fl + 0.385 * fd), w: Math.round(62 * k), from: 1, pats: [{ dx: 16 * k, s: 2.2 * k, hood: 0, back: 1 }, { dx: 46 * k, s: 2.3 * k, hood: 1, back: 1 }], coin: [0.82 * Wl + 28 * k, Math.round(fl + 0.385 * fd) - 1] }
      ];
      /* Blackwater: the water stops at the cornice; the notebook hangs in the moon's light; the books drift */
      g.waterTop = g.cor + 1;
      g.notebook = [Math.round(g.win.cx - 11 * k), Math.round(g.win.T + 0.4 * g.win.h), Math.round(22 * k), Math.round(18 * k)];
      g.books = [[0.27 * Wl, 0.47 * Hl], [0.52 * Wl, 0.56 * Hl], [0.76 * Wl, 0.42 * Hl]];
      g.shafts = Math.max(4, Math.round(Wl / 40)); g.bubN = Math.max(8, Math.round(Wl / 18)); g.flies = Math.max(16, Math.round(Wl / 8)); g.ashN = Math.max(16, Math.round(Wl / 9));
      /* the Iron Matron's place in the shadows between the lectern and the easel */
      g.matron = [0.68 * Wl, fl + 2 * k];
      g.matU = 1.51 * k;
      /* Hearthside's three slow embers. After Hours' cup on the window seat */
      g.cinders = [0.08, 0.18, 0.3].map((f) => f * Wl);
      g.cup = [Math.round(g.win.x1 - 7 * k), g.seat];
      /* the cold's vignette, worked out once: how far into the dark each pixel lies (0..255) */
      g.vig = new Uint8Array(Wl * Hl);
      const vcx = Wl / 2, vcy = Hl * 0.45, R0 = Math.hypot(Wl / 2, Hl / 2), ky = (Wl / Hl) * 0.6;
      for (let y = 0; y < Hl; y++) for (let x = 0; x < Wl; x++) { const dd = Math.hypot(x - vcx, (y - vcy) * ky) / R0; g.vig[y * Wl + x] = dd < 0.35 ? 0 : Math.round(255 * sat((dd - 0.35) / 0.65)); }
      /* scratch rows for the passes */
      g.row = new Uint32Array(Wl);
      g.fa = new Float32Array(Wl); g.fb = new Float32Array(Wl); g.fc = new Float32Array(Wl); g.fd2 = new Float32Array(Wl);
      g.gx = new Int16Array(Wl); g.gy = new Int16Array(Hl);
      return g;
    }

    /* the room's moon as it is drawn now, the painter's live lbMoon [x, y, r] in grid px when it gives one (the moon
       crossing the window with the reader's night), else where the room was built with it */
    function moonNow() {
      let m = null; try { m = F.get('lbMoon'); } catch (e) { m = null; }
      return Array.isArray(m) && m.length >= 3 && isFinite(m[0]) && isFinite(m[1]) && isFinite(m[2]) ? m : G.moon;
    }

    /* ================================================================ pixels ================================================================ */
    function px(x, y, c, a) {
      x = Math.round(x); y = Math.round(y);
      if (x < 0 || y < 0 || x >= W || y >= H) return;
      if (ZT && Z && Z[y * W + x] > ZBACK) return;
      const i = (y * W + x) << 2;
      if (a === undefined || a >= 1) { D[i] = c[0]; D[i + 1] = c[1]; D[i + 2] = c[2]; return; }
      if (!(a > 0)) return;
      D[i] += (c[0] - D[i]) * a; D[i + 1] += (c[1] - D[i + 1]) * a; D[i + 2] += (c[2] - D[i + 2]) * a;
    }
    function add(x, y, c, a) {
      x = Math.round(x); y = Math.round(y);
      if (x < 0 || y < 0 || x >= W || y >= H || !(a > 0)) return;
      const i = (y * W + x) << 2;
      D[i] += c[0] * a; D[i + 1] += c[1] * a; D[i + 2] += c[2] * a;
    }
    function rect(x, y, w, h, c, a, dz) {
      const X0 = Math.max(0, Math.round(x)), Y0 = Math.max(0, Math.round(y)), X1 = Math.min(W, Math.round(x + w)), Y1 = Math.min(H, Math.round(y + h));
      for (let yy = Y0; yy < Y1; yy++) for (let xx = X0; xx < X1; xx++) { if (dz != null && bay(xx, yy) > dz) continue; px(xx, yy, c, a); }
    }
    function glow(cx, cy, r, c, a) {
      if (!(a > 0) || !(r > 0)) return;
      const x0 = Math.max(0, Math.floor(cx - r)), x1 = Math.min(W - 1, Math.ceil(cx + r)), y0 = Math.max(0, Math.floor(cy - r)), y1 = Math.min(H - 1, Math.ceil(cy + r)), r2 = r * r, ir = 1 / r;
      for (let y = y0; y <= y1; y++) {
        const dy = y + 0.5 - cy;
        for (let x = x0; x <= x1; x++) {
          const dx = x + 0.5 - cx, d2 = dx * dx + dy * dy; if (d2 >= r2) continue;
          const f = 1 - Math.sqrt(d2) * ir, k = a * f * f, i = (y * W + x) << 2;
          D[i] += c[0] * k; D[i + 1] += c[1] * k; D[i + 2] += c[2] * k;
        }
      }
    }
    function darkDisc(cx, cy, r, k) {
      const x0 = Math.max(0, Math.floor(cx - r)), x1 = Math.min(W - 1, Math.ceil(cx + r)), y0 = Math.max(0, Math.floor(cy - r)), y1 = Math.min(H - 1, Math.ceil(cy + r));
      for (let y = y0; y <= y1; y++) for (let x = x0; x <= x1; x++) {
        const d = Math.hypot(x + 0.5 - cx, y + 0.5 - cy) / r; if (d >= 1) continue;
        const m = 1 - (1 - k) * (1 - d * d), i = (y * W + x) << 2; D[i] *= m; D[i + 1] *= m; D[i + 2] *= m;
      }
    }
    function ell(cx, cy, rx, ry, c, a, dz) {
      if (!(rx > 0) || !(ry > 0)) return;
      for (let y = Math.floor(cy - ry); y <= Math.ceil(cy + ry); y++) for (let x = Math.floor(cx - rx); x <= Math.ceil(cx + rx); x++) {
        const d = ((x + 0.5 - cx) / rx) ** 2 + ((y + 0.5 - cy) / ry) ** 2; if (d > 1) continue; if (dz != null && bay(x, y) > dz) continue; px(x, y, c, a);
      }
    }
    function line(x0, y0, x1, y1, c, a) { const n = Math.max(Math.abs(x1 - x0), Math.abs(y1 - y0), 1); for (let i = 0; i <= n; i++) px(lerp(x0, x1, i / n), lerp(y0, y1, i / n), c, a); }
    function spr(rows, x, y, pal, o) {
      o = o || {};
      x = Math.round(x); y = Math.round(y);
      for (let j = 0; j < rows.length; j++) { const r = rows[j]; for (let i = 0; i < r.length; i++) {
        const ch = r[o.flip ? r.length - 1 - i : i]; if (ch === '.' || ch === ' ') continue; const c = pal[ch]; if (!c) continue;
        if (o.dz != null && bay(x + i, y + j) > o.dz) continue; px(x + i, y + j, c, o.a);
      } }
    }
    /* ---------- a guest as a mask ----------
       A figure is built as a mask in a scratch box (row spans and ellipses, each with a value that picks its colour),
       then painted (fillShape: through the depth test while ZT is on, and the dissolve) and lit along its own outer edge
       pixels (rimShape), so a rim never stands outside the figure or over what is in front of it */
    let FB = new Uint8Array(4096);
    function shape(x0, y0, w, h) {
      x0 = Math.floor(x0); y0 = Math.floor(y0); w = Math.max(1, Math.ceil(w)); h = Math.max(1, Math.ceil(h));
      const n = w * h; if (FB.length < n) FB = new Uint8Array(n * 2);
      const m = FB; m.fill(0, 0, n);
      const sh = {
        x0, y0, w, h, m,
        span(y, xa, xb, v) { const j = Math.round(y) - y0; if (j < 0 || j >= h) return; let a = Math.round(xa) - x0, b = Math.round(xb) - x0; if (a < 0) a = 0; if (b > w) b = w; for (let i = a; i < b; i++) m[j * w + i] = v || 1; },
        ell(cx, cy, rx, ry, v) {
          if (!(rx > 0) || !(ry > 0)) return;
          for (let y = Math.floor(cy - ry); y <= Math.ceil(cy + ry); y++) { const t = (y + 0.5 - cy) / ry; if (t <= -1 || t >= 1) continue; const hw = rx * Math.sqrt(1 - t * t); sh.span(y, cx - hw, cx + hw, v); }
        }
      };
      return sh;
    }
    /* paint a mask: pal[value] is each part's colour; o.vis (when given, at least w*h long) notes the value of every
       pixel that was drawn */
    function fillShape(sh, pal, o) {
      const { x0, y0, w, h, m } = sh, vis = o.vis, cw = o.cw, dz = o.dz, a = o.a;
      for (let j = 0; j < h; j++) {
        const y = y0 + j; if (y < 0 || y >= H) continue;
        for (let i = 0; i < w; i++) {
          const v = m[j * w + i]; if (!v) continue;
          const x = x0 + i; if (x < 0 || x >= W) continue;
          if (ZT && Z && Z[y * W + x] > ZBACK) continue;
          if (dz != null && bay(x, y) > dz) continue;
          px(x, y, pal[v] || pal[1], a);
          if (vis) vis[j * w + i] = v;
          if (cw) cw[j * w + i] = U32[y * W + x];
        }
      }
    }
    /* light a mask's outer edge pixels: o.r on those facing right, o.l facing left, and on those facing up o.t on the
       o.tSide half (1 right, -1 left of o.cx) and o.t2 on the other ([colour, alpha] each, or null); seen (when given)
       keeps it to the pixels that show; nothing below o.yMax */
    function rimShape(sh, o, seen) {
      const { x0, y0, w, h, m } = sh;
      for (let j = 0; j < h; j++) {
        const y = y0 + j; if (y < 0 || y >= H || (o.yMax != null && y > o.yMax)) continue;
        for (let i = 0; i < w; i++) {
          const q = j * w + i; if (!m[q] || (seen && !seen[q])) continue;
          const x = x0 + i; if (x < 0 || x >= W) continue;
          if (o.r && (i + 1 >= w || !m[q + 1])) px(x, y, o.r[0], o.r[1]);
          else if (o.l && (i === 0 || !m[q - 1])) px(x, y, o.l[0], o.l[1]);
          else if (j === 0 || !m[q - w]) { const t = (x + 0.5 >= o.cx) === (o.tSide > 0) ? o.t : o.t2; if (t) px(x, y, t[0], t[1]); }
        }
      }
    }
    const pk = (c) => (c[2] << 16) | (c[1] << 8) | c[0];
    /* a small icy four-point sparkle: a white core, arms that breathe (never blink), a cold glow (the ice where she stood) */
    const ICE = [170, 214, 255];
    function sparkle(x, y, a) {
      if (!(a > 0)) return;
      const k = G.k, L = Math.max(2, Math.round(2.2 * k)), tw = rm ? 1 : 0.84 + 0.16 * Math.sin(T / 430);
      glow(x + 0.5, y + 0.5, 5 * k, [120, 176, 255], 0.3 * a * tw);
      add(x, y, [236, 248, 255], a);
      for (let n = 1; n <= L + 1; n++) {
        const f = a * tw * (n === 1 ? 0.85 : n === 2 ? 0.5 : 0.26);
        add(x, y - n, ICE, f); add(x, y + n, ICE, f);
        if (n <= L) { add(x + n, y, ICE, f * 0.9); add(x - n, y, ICE, f * 0.9); }
      }
    }
    /* the thorn she let fall: a short dark green sprig lying on the floor, two small thorns on it, and a cold sheen that
       slides slowly along its top edge (never a star, never a point that could be taken for an eye), a soft cold glow
       breathing round it. Reduced motion: the sheen rests in its middle */
    function thorn(x, y, a) {
      if (!(a > 0)) return;
      const k = G.k, n = Math.max(5, Math.round(6.4 * k)), x0 = x - (n >> 1), tw = rm ? 1 : 0.82 + 0.18 * Math.sin(T / 520);
      glow(x + 0.5, y + 0.5, 4.6 * k, [110, 160, 230], 0.2 * a * tw);
      for (let q = 0; q < n; q++) {
        const yy = y - Math.floor(q * 1.6 / n);
        px(x0 + q, yy, [26, 46, 36], a); px(x0 + q, yy - 1, q === 0 || q === n - 1 ? [26, 46, 36] : [52, 86, 62], a * (q === 0 ? 0.5 : 1));
        if (q === (n / 3 | 0) || q === (2 * n / 3 | 0)) px(x0 + q - 1, yy - 2, [40, 68, 50], a);
      }
      const sp = rm ? 0.5 : ((T / 2600) % 1), sq = Math.round(1 + sp * (n - 3)), sy = y - 1 - Math.floor(sq * 1.6 / n), sa = a * (rm ? 0.8 : 0.35 + 0.65 * Math.sin(sp * Math.PI));
      add(x0 + sq, sy, [200, 228, 255], sa); add(x0 + sq - 1, sy, ICE, sa * 0.45); add(x0 + sq + 1, sy, ICE, sa * 0.45);
    }
    /* faint sparkles drifting up off a guest who holds a gift; they stop once it has been given */
    function tapMe(x, y, col, seed) {
      if (rm) { add(x, y - 6, col, 0.5); return; }
      for (let k = 0; k < 3; k++) {
        const per = 2300 + k * 260, ph = ((T + k * 760 + (seed || 0) * 97) % per) / per;
        const sx = x + Math.sin(ph * 5 + k * 2.1 + (seed || 0)) * 3.2, sy = y - 2 - ph * 11, a = Math.sin(ph * Math.PI) * 0.75;
        const tw = 0.6 + 0.4 * Math.sin(T / 140 + k * 1.7);
        add(sx, sy, col, a * tw);
        if (tw > 0.85) { add(sx - 1, sy, col, a * 0.35); add(sx + 1, sy, col, a * 0.35); add(sx, sy - 1, col, a * 0.35); add(sx, sy + 1, col, a * 0.35); }
      }
    }
    /* how far a mood is in (0..1): d0..d0+d1 on its own clock coming in, x0..x0+x1 ms after it began to leave */
    function amt(I, d0, d1, x0, x1) {
      let a = sat((I.clk - d0) / Math.max(1, d1));
      if (I.tx != null) a *= 1 - sat((T - I.tx - (x0 || 0)) / Math.max(1, x1 || 1));
      return eio(a);
    }
    /* the Hall door's arch, as the painter cuts it */
    function inDoor(x, y) {
      const Dd = G.D; if (y < Dd.top || y > G.fl - 1) return false;
      const cy = Dd.top + Dd.half, dx = x + 0.5 - Dd.cx;
      if (y + 0.5 >= cy) return Math.abs(dx) <= Dd.half;
      const dy = cy - (y + 0.5); return dx * dx + dy * dy <= Dd.half * Dd.half;
    }

    /* ================================================================ the jukebox ================================================================ */
    function jukeCol() {
      const R = st.roul;
      if (R) { const e = T - R.t0, n = [0, 100, 230, 400].filter((t) => e >= t).length - 1; if (e < 700 && R.cols[n]) return R.cols[n]; st.roul = null; }
      return (REC[st.jukeRec] || REC[st.rec] || REC.quiet).rgb;
    }
    function crownNow() {
      let c = st.awake ? sat((T - st.wake0) / 650) : 0.12 + (rm ? 0 : 0.05 * Math.sin(T / 500));
      if (st.awake && c < 0.12) c = 0.12;
      const A = st.insts.find((I) => I.id === 'ash');
      if (A) { const dim = A.tx == null ? sat((A.clk - 200) / 1200) : 1 - sat((T - A.tx) / 1200); c = lerp(c, Math.min(c, 0.35), dim); }
      return c;
    }
    function drawJuke() {
      const J = G.J, x0 = J.x, y = J.y, w = J.w, h = J.h, col = jukeCol();
      const jolt = (T - st.jolt < 120 ? 1 : 0), rattle = T - st.lockT < 360 && !rm ? (Math.floor((T - st.lockT) / 60) % 2 ? 1 : -1) : 0;
      const x = x0 + rattle, ch = Math.round(w / 2), plH = Math.max(3, Math.round(4 * G.k)), bodyY = y + ch + jolt, bodyH = h - ch - plH, yy = y + jolt;
      /* its shadow on the boards */
      ell(x0 + w / 2 + 1, y + h, w * 0.62, Math.max(1.5, 2 * G.k), C.k1, 0.55);
      /* plinth, body, its brass edges */
      rect(x, y + h - plH, w, plH, C.k1); rect(x, y + h - plH, w, 1, C.wd2);
      rect(x + 1, bodyY, w - 2, bodyH, C.wd2); rect(x + 1, bodyY, 1, bodyH, C.wd1); rect(x + w - 2, bodyY, 1, bodyH, C.wd1);
      rect(x + 1, bodyY, w - 2, 1, C.br3); rect(x + 1, bodyY + bodyH - 1, w - 2, 1, C.br2);
      /* the bubble tubes, dark until the light comes */
      const tw = w >= 20 ? 2 : 1;
      for (const tx of [x + 2, x + w - 2 - tw]) rect(tx, bodyY + 2, tw, bodyH - 4, [col[0] * 0.22, col[1] * 0.22, col[2] * 0.22]);
      /* the window and its turning disc */
      const dip = st.roul && T - st.roul.t0 < 500 && !rm ? 1 : 0;
      const r = Math.max(3, Math.floor(w * 0.27)), dcx = x + w / 2, dcy = bodyY + r + 2 + dip;
      ell(dcx, dcy, r + 1, r + 1, C.br2); ell(dcx, dcy, r, r, C.gl);
      for (let k = 1; k < r; k += 2) for (let a = 0; a < 24; a++) { const an = a / 24 * Math.PI * 2; px(dcx + Math.cos(an) * k - 0.5, dcy + Math.sin(an) * k - 0.5, [34, 30, 34]); }
      ell(dcx, dcy, Math.max(1.2, r * 0.42), Math.max(1.2, r * 0.42), col);
      const an = st.disc; px(dcx + Math.cos(an) * (r - 1) - 0.5, dcy + Math.sin(an) * (r - 1) - 0.5, [120, 112, 108]); px(dcx + Math.cos(an) * (r - 2) - 0.5, dcy + Math.sin(an) * (r - 2) - 0.5, [90, 84, 80]);
      /* the grille */
      const gy = dcy + r + 3, gh = bodyY + bodyH - 2 - gy;
      for (let k = 0; k < gh; k++) rect(x + 3 + tw, gy + k, w - 6 - tw * 2, 1, k % 2 ? C.br1 : C.k1);
      /* the crown's arch, dark glass until the light comes (lit after the dark, in light()) */
      for (let j = 0; j < ch; j++) {
        const t = 1 - j / ch, half = Math.sqrt(Math.max(0, 1 - t * t)) * (w / 2), xa = Math.round(x + w / 2 - half), xb = Math.round(x + w / 2 + half);
        for (let xx = xa; xx < xb; xx++) px(xx, yy + j, xx === xa || xx === xb - 1 || j === ch - 1 ? C.wd1 : C.ol);
      }
      /* the keepsakes sit on the crown's arch: the frog on its top (where she sits herself in the bog), the Hollow
         Stump's tankard to its left, the Matron's cup to its right. The frog's keepsake is an ornament, never the live
         frog (Jan, 2026-10-11: "the frog seems to spawn when its not the frog scene"): a small brass frog on a dark
         plinth, still, a glint now and then on its back. In the bog the live frog has the crown to herself; as the bog
         leaves and she hops away, the brass one comes up in her place */
      const seat = (sx, sw) => { let top = 1e9; for (let xx = Math.round(sx); xx < Math.round(sx) + sw; xx++) { const dxx = Math.abs(xx + 0.5 - (x + w / 2)) / (w / 2); top = Math.min(top, dxx >= 1 ? 1e9 : yy + Math.ceil(ch * (1 - Math.sqrt(1 - dxx * dxx)))); } return top > 1e8 ? yy + ch : top; };
      const mid = x + w / 2;
      if (st.keep.has('frog')) {
        const B = st.insts.find((I) => I.id === 'bog'), fa = !B ? 1 : B.tx == null ? 0 : sat((T - B.tx - 150) / 600);
        if (fa > 0) {
          const fx = Math.round(mid - 5), fy = seat(fx, 10) - FIGURE.length;
          spr(FIGURE, fx, fy, FIGPAL, { a: fa < 1 ? fa : undefined });
          if (fa >= 1) add(fx + 2, fy + 3, [255, 236, 170], rm ? 0.3 : 0.15 + 0.3 * Math.max(0, Math.sin(T / 900)));
        }
      }
      if (st.keep.has('tankard')) { const tx = Math.round(mid - 6 - 3); spr(['bbb', 'wwk', 'wwk', 'ww.'], tx, seat(tx, 3) - 4, { b: [242, 234, 216], w: [185, 160, 122], k: [120, 95, 60] }); }
      if (st.keep.has('cup')) { const cx2 = Math.round(mid + 6); spr(['wwww', 'wwww', '.ww.'], cx2, seat(cx2, 4) - 3, { w: [110, 80, 50] }); }
      st.jg = { x, y: yy, w, h, ch, bodyY, bodyH, tw, dcx, dcy, r };
    }
    /* the jukebox's light, drawn after the dark so it stays bright */
    function lightJuke() {
      const Jg = st.jg; if (!Jg) return;
      const { x, y, w, h, ch, tw } = Jg, ashI = st.insts.find((I) => I.id === 'ash' && I.tx == null);
      const col = ashI && !st.roul ? [150, 30, 24] : jukeCol();
      const lev = level(), crown = st.crown, cr = crown * (0.72 + 0.4 * lev), cx = x + w / 2, by = y + ch;
      /* stained glass: rays from the arch's foot, one leaded ring, a dark frame with a brass edge */
      for (let j = 0; j < ch; j++) {
        const t = 1 - j / ch, half = Math.sqrt(Math.max(0, 1 - t * t)) * (w / 2), xa = Math.round(cx - half), xb = Math.round(cx + half);
        for (let xx = xa; xx < xb; xx++) {
          const dx = xx + 0.5 - cx, dy = by - (y + j + 0.5), rr = Math.hypot(dx, dy) / (w / 2), a = Math.atan2(dy, dx);
          let c;
          if (xx === xa || xx === xb - 1 || j === 0) c = C.wd1;
          else if (xx === xa + 1 || xx === xb - 2 || j === 1) c = C.br2;
          else {
            const step = Math.PI / 5, seg = Math.floor(a / step), hy = Math.hypot(dx, dy), near = Math.round(a / step) * step;
            const lead = (hy > 1.2 && hy * Math.abs(a - near) < 0.5) || Math.abs(hy - 0.52 * (w / 2)) < 0.5 || j === ch - 1;
            if (lead) c = [34, 26, 20];
            else { const kk = cr * (seg % 2 ? 0.85 : 1.08) * (0.75 + 0.35 * (1 - rr)) * (0.92 + 0.12 * hsh(xx, j)); c = [Math.min(255, col[0] * kk + 40 * kk * (1 - rr)), Math.min(255, col[1] * kk + 30 * kk * (1 - rr)), Math.min(255, col[2] * kk + 18 * kk * (1 - rr))]; }
          }
          px(xx, y + j, c);
        }
      }
      glow(cx, y + ch * 0.55, w * 1.1, col, 0.3 * cr);
      glow(cx, y + h, w * 0.8, col, 0.12 * cr);
      /* the glass tubes and their bubbles */
      for (const tx of [x + 2, x + w - 2 - tw]) for (let yy = Jg.bodyY + 2; yy < Jg.bodyY + Jg.bodyH - 2; yy++) for (let q = 0; q < tw; q++) px(tx + q, yy, [col[0] * 0.35 * crown + 20, col[1] * 0.35 * crown + 16, col[2] * 0.35 * crown + 14]);
      if (crown > 0.2) for (const [n, tx] of [[0, x + 2], [1, x + w - 2 - tw]]) for (let b = 0; b < 4; b++) {
        const per = 2200 + b * 300, ph = rm ? (b + 0.5) / 4 : ((T + n * 700 + b * 530) % per) / per, bby = Jg.bodyY + Jg.bodyH - 3 - ph * (Jg.bodyH - 5);
        px(tx + (b % tw), bby, [col[0] * 0.9 + 25, col[1] * 0.9 + 25, col[2] * 0.9 + 25], 0.5 + 0.5 * crown);
      }
      /* six lamps along the base, one for each stop on the road: dark, heard, gold once its gift is taken */
      const ly = y + h - 2;
      for (let i = 0; i < 6; i++) {
        const lx = x + 1 + Math.round((i + 0.5) * (w - 2) / 6) - 1, id = FIRST[i];
        if (st.gold[id]) { px(lx, ly, C.br5); add(lx, ly - 1, C.br4, 0.25); } else if (st.heard[id]) px(lx, ly, REC[id].rgb); else px(lx, ly, [96, 70, 44]);
      }
      /* notes rising off it while it plays (never in the cold) */
      if (crown > 0.5 && !rm && !ashI) for (let n = 0; n < 3; n++) { const per = 3600, ph = ((T + n * 1200) % per) / per; px(cx + Math.sin(ph * 6 + n) * 3, y - 2 - ph * 14, col, 0.7 * (1 - ph)); }
    }

    /* ---------- the warm wave home: light leaves the jukebox and relights every candle it passes ---------- */
    function startWave(delay, o) { st.wave = { t0: T + (delay || 0), dur: 1400 * (o && o.slow ? 1.4 : 1), relit: {}, said: false }; }
    function waveX(Wv) {
      const p = (T - Wv.t0) / Wv.dur, J = G.J, x0 = J.x + J.w / 2, span = W - x0 + W * 0.25;
      return { p, bx: x0 + span * eout(p) - W * 0.1, bw: W * 0.2 };
    }
    function waveTick() {
      const Wv = st.wave; if (!Wv) return;
      /* no room to cross (the tall room, reduced motion, or no frame yet after a while): the candles are simply lit */
      if ((G && !G.wide) || rm || (!G && T - Wv.t0 > 3000)) { st.mc.forEach((_, i) => { if (!darkRec()) setCand(i, true, true); }); st.wave = null; cue('lit'); poke(); return; }
      if (!G || T < Wv.t0) return;
      const q = waveX(Wv);
      G.cand.forEach((c, i) => { if (!Wv.relit[i] && c[0] < q.bx) { Wv.relit[i] = 1; if (!darkRec()) setCand(i, true, false); } });
      if (q.p > 1.4) { st.wave = null; cue('lit'); }
    }
    function drawWave() {
      const Wv = st.wave; if (!Wv || T < Wv.t0) return;
      const { p, bx, bw } = waveX(Wv), fade = p > 1 ? 1 - (p - 1) / 0.4 : 1;
      if (fade <= 0) return;
      const xa = Math.max(0, Math.floor(bx - bw)), xb = Math.min(W, Math.ceil(bx + bw * 0.3)), wf = G.fa;
      for (let x = xa; x < xb; x++) { const d = (bx - x) / bw; wf[x] = d < 0 || d > 1 ? 0 : Math.sin(d * Math.PI) * 0.16 * fade; }
      for (let y = 0; y < H; y++) for (let x = xa, i = (y * W + xa) << 2; x < xb; x++, i += 4) { const f = wf[x]; if (f <= 0) continue; D[i] += 255 * f; D[i + 1] += 196 * f; D[i + 2] += 120 * f; }
      for (let m = 0; m < 26; m++) { const my = hsh(m, 3) * H, mx = bx - hsh(m, 7) * bw * 0.6; px(mx, my - (((T - Wv.t0) / 20) % 6), C.br5, 0.6 * fade); }
    }
    /* ---------- a thread of the record's colour from the jukebox to where the place comes in ---------- */
    function startThread(id) {
      if (!G || !G.wide || id === 'ash' || rm) return;
      const J = G.J, to = id === 'bog' || id === 'flood' ? [J.x + J.w + 6, G.fl + 4] : id === 'tavern' ? [W * 0.5, G.cor] : [G.D.cx, G.D.top + (G.fl - G.D.top) * 0.5];
      st.thread = { t0: T, from: [J.x + J.w / 2, J.y + 3], to, col: REC[id].rgb };
    }
    function drawThread() {
      const Th = st.thread; if (!Th) return;
      const p = (T - Th.t0) / 650; if (p > 1.6) { st.thread = null; return; }
      const [x0, y0] = Th.from, [x1, y1] = Th.to, mx = (x0 + x1) / 2, my = Math.min(y0, y1) - H * 0.18;
      for (let k = 0; k < 40; k++) {
        const t = eout(Math.min(1, p)) - k * 0.012; if (t < 0) break;
        const u = 1 - t, xx = u * u * x0 + 2 * u * t * mx + t * t * x1, yy = u * u * y0 + 2 * u * t * my + t * t * y1;
        const a = (1 - k / 40) * (p > 1 ? 1 - (p - 1) / 0.6 : 1);
        add(xx, yy, Th.col, a); if (k < 6) glow(xx, yy, 3, Th.col, 0.25 * a);
      }
    }
    /* ---------- something caught, flying into the jukebox ---------- */
    function fly(x, y, col) { st.flights.push({ t0: T, x, y, col }); }
    function drawFlights() {
      st.flights = st.flights.filter((f) => T - f.t0 < 700);
      if (!G.J) return;
      const to = [G.J.x + G.J.w / 2, G.J.y + 3];
      for (const f of st.flights) {
        const p = eio((T - f.t0) / 600), mx = (f.x + to[0]) / 2, my = Math.min(f.y, to[1]) - 20 * G.k, u = 1 - p;
        const xx = u * u * f.x + 2 * u * p * mx + p * p * to[0], yy = u * u * f.y + 2 * u * p * my + p * p * to[1];
        add(xx, yy, f.col, 1); glow(xx, yy, 4 * G.k, f.col, 0.35 * (1 - p * 0.5));
        if (p >= 0.98) glow(to[0], to[1], 8 * G.k, f.col, 0.4);
      }
    }

    /* ================================================================ figures ================================================================ */
    /* a King's Road guard, facing the room (both of them, in and out): a tabard over mail, a plumed helm; Pike with a
       beard and the helm's nose guard, Maren bare-faced with a shield. Rows count up from the feet, in units u */
    function guard(cx, fy, u, o) {
      const pal = o.kind === 'pike' ? { tab: [64, 36, 112], tabD: [40, 22, 72] } : { tab: [86, 50, 136], tabD: [52, 30, 88] };
      const boot = [43, 29, 24], leg = [58, 52, 68], gold = [231, 184, 74], mail = [150, 158, 172], mailD = [98, 104, 116], skin = [214, 164, 120], skinD = [170, 120, 84], helm = [196, 202, 210], helmD = [120, 126, 138], plume = [190, 58, 58], plumeD = [130, 36, 40];
      const a = o.a, dz = o.dz, w = o.walk, parts = [];
      const Q = (x0, y0, x1, y1, c, dx) => parts.push([x0, y0, x1, y1, c, dx || 0]);
      const st1 = w >= 0 ? Math.floor(w * 2) % 2 : -1, sw = st1 >= 0 ? (st1 ? 1 : -1) * 0.5 : 0, hd = o.head || 0;
      if (st1 === 0) { Q(-3, 1, -1, 2, boot); Q(1, 0, 3, 1, boot); Q(-3, 3, -1, 10, leg); Q(1, 2, 3, 10, leg); }
      else if (st1 === 1) { Q(-3, 0, -1, 1, boot); Q(1, 1, 3, 2, boot); Q(-3, 2, -1, 10, leg); Q(1, 3, 3, 10, leg); }
      else { Q(-3, 0, -1, 1, boot); Q(1, 0, 3, 1, boot); Q(-3, 2, -1, 10, leg); Q(1, 2, 3, 10, leg); }
      Q(-5, 9, 5, 25, mail, sw);
      Q(-4, 8, 4, 24, pal.tab, sw); Q(-4, 8, -4, 24, pal.tabD, sw); Q(4, 8, 4, 24, pal.tabD, sw); Q(-4, 8, 4, 8, pal.tabD, sw);
      Q(-4, 14, 4, 14, [92, 59, 39]); Q(0, 14, 0, 14, gold);
      Q(-1, 17, 1, 21, gold); Q(0, 18, 0, 20, [150, 100, 30]); Q(-2, 19, 2, 19, gold);
      const sal = o.salute || 0;
      Q(-7, 14, -6, 24, mailD); Q(-7, 13, -6, 13, skin);
      if (sal > 0.5) { Q(6, 22, 7, 31, mailD); Q(5, 31, 6, 32, skin); }
      else if (o.give) { Q(6, 19, 7, 24, mailD); Q(3, 18, 7, 19, mailD); Q(2, 18, 3, 19, skin); Q(-1, 19, 2, 21, [86, 50, 136]); Q(-1, 21, 2, 21, gold); }
      else { Q(6, 14, 7, 24, mailD); Q(6, 13, 7, 13, skin); }
      Q(-6, 23, 6, 25, mail); Q(-6, 25, 6, 25, mailD);
      Q(-1, 26 - hd, 1, 26 - hd, skinD);
      Q(-2, 27 - hd, 2, 30 - hd, skin); Q(2, 27 - hd, 2, 30 - hd, skinD);
      const lk = o.look || 0;
      if (o.kind === 'pike') { Q(-2, 27 - hd, 2, 27 - hd, [92, 59, 39]); Q(-1, 28 - hd, 1, 28 - hd, [92, 59, 39]); Q(-2, 30 - hd, 2, 30 - hd, skinD); }
      Q(-1 - lk, 29 - hd, -1 - lk, 29 - hd, C.ol); Q(1 - lk, 29 - hd, 1 - lk, 29 - hd, C.ol);
      if (o.kind === 'pike') Q(0, 29 - hd, 0, 31 - hd, helmD);
      Q(-4, 31 - hd, 4, 31 - hd, helmD); Q(-3, 32 - hd, 3, 34 - hd, helm); Q(-3, 32 - hd, -2, 34 - hd, [232, 236, 240]); Q(-3, 35 - hd, 2, 35 - hd, helmD);
      Q(0, 36 - hd, 1, 37 - hd, plume); Q(1, 38 - hd, 3, 38 - hd, plume); Q(2, 37 - hd, 3, 37 - hd, plumeD);
      const spx = sal > 0.5 ? 5 : 8;
      Q(spx, 0, spx, 41, [127, 84, 54]); Q(spx, 42, spx, 45, [205, 210, 216]); Q(spx - 1, 42, spx + 1, 42, [205, 210, 216]);
      if (o.kind !== 'pike') { Q(-10, 12, -7, 22, [40, 70, 140]); Q(-10, 12, -10, 22, gold); Q(-7, 12, -7, 22, gold); Q(-9, 21, -8, 22, gold); Q(-9, 16, -8, 18, gold); }
      /* the Hall's dark outline first, then the figure */
      const box = (pt) => [Math.round(cx + pt[5] + pt[0] * u), Math.round(fy - (pt[3] + 1) * u), Math.round(cx + pt[5] + (pt[2] + 1) * u), Math.round(fy - pt[1] * u)];
      for (const pt of parts) { const [X0, Y0, X1, Y1] = box(pt); for (let y = Y0 - 1; y <= Y1; y++) for (let x = X0 - 1; x <= X1; x++) { if (dz != null && bay(x, y) > dz) continue; px(x, y, C.ol, a); } }
      for (const pt of parts) { const [X0, Y0, X1, Y1] = box(pt); for (let y = Y0; y < Y1; y++) for (let x = X0; x < X1; x++) { if (dz != null && bay(x, y) > dz) continue; px(x, y, pt[4], a); } }
      if (o.glint) add(Math.round(cx + spx * u), Math.round(fy - 44 * u), C.hw, 0.9);
      return { hx: cx, hy: Math.round(fy - (29 - hd) * u) };
    }
    /* the Iron Matron, only her shape: a long skirt and an apron a shade paler, the towel over her shoulder, the cup in
       her hand, the knot of hair. Built as a mask and drawn only where nothing baked into the room stands in front of
       her, so she passes behind the easel. m.vis notes what shows; seenMatron checks it again just before the grade, so
       anything drawn over her afterwards (Zhaunil, the owl, a near table) hides her rim and her eyes as well */
    function matronFig(cx, fy, u, o) {
      const sw = o.sway || 0, hu = (v) => fy - v * u;
      const sh = shape(cx - 9 * u - 2, hu(41) - 2, 18 * u + 5, 41 * u + 4);
      const hwAt = (t) => {
        const B = MAT_BODY; if (t <= B[0][0]) return B[0][1];
        for (let n = 1; n < B.length; n++) if (t <= B[n][0]) return lerp(B[n - 1][1], B[n][1], (t - B[n - 1][0]) / (B[n][0] - B[n - 1][0]));
        return 0;
      };
      for (let y = Math.round(hu(32.2)); y < Math.round(fy); y++) { const t = (fy - (y + 0.5)) / u, hw = hwAt(t), off = t < 16 ? sw : 0; sh.span(y, cx + off - hw * u, cx + off + hw * u); }
      /* the apron, from the waist to below the knee */
      for (let y = Math.round(hu(20.6)); y < Math.round(hu(6.5)); y++) { const t = (fy - (y + 0.5)) / u, off = t < 16 ? sw : 0, hw = Math.min(hwAt(t) - 1, 2.3 + (20.6 - t) * 0.07); if (hw > 0.5) sh.span(y, cx + off - hw * u, cx + off + hw * u, 2); }
      /* the head, and the knot of hair on its crown, a little to the back */
      sh.ell(cx, hu(34.9), 2.7 * u, 3.1 * u);
      sh.ell(cx + 0.9 * u, hu(38.1), 1.9 * u, 1.5 * u);
      /* the towel over her right shoulder, hanging down her front and rounding off at its end */
      for (let y = Math.round(hu(30.7)); y < Math.round(hu(24.6)); y++) { const t = (fy - (y + 0.5)) / u, r = t > 28 ? lerp(6.6, 6, (t - 28) / 2.7) : t > 25.8 ? 6.6 : 6.6 - Math.pow((25.8 - t) / 1.2, 2) * 1.6; sh.span(y, cx + 3.7 * u, cx + r * u); }
      /* her arms down her sides (overlapping her body, so no sliver of the room shows between); the left hand holds the
         cup a little forward */
      for (let y = Math.round(hu(28.4)); y < Math.round(hu(17.2)); y++) {
        const p = ((fy - (y + 0.5)) / u - 28.4) / -11.2;
        sh.span(y, cx - lerp(5.1, 6.1, p) * u, cx - 3 * u);
        sh.span(y, cx + 3 * u, cx + lerp(5.1, 5.9, p) * u);
      }
      sh.ell(cx - 6.9 * u, hu(18.1), 1.5 * u, 1.25 * u);
      const n = sh.w * sh.h, vis = o.vis && o.vis.length >= n ? o.vis : new Uint8Array(n * 2), cw = o.cw && o.cw.length >= n ? o.cw : new Uint32Array(n * 2);
      vis.fill(0, 0, n);
      ZT = true;
      fillShape(sh, { 1: MAT_BLK, 2: MAT_APR }, { vis, cw, a: o.a == null ? undefined : o.a });
      ZT = false;
      return { cx, ex: cx + 0.5, ey: Math.round(hu(34.6)), fy, a: o.a == null ? 1 : o.a, sh: { x0: sh.x0, y0: sh.y0, w: sh.w, h: sh.h, m: sh.m.slice(0, n) }, vis, cw };
    }
    function seenMatron(m) {
      const { x0, y0, w, h } = m.sh, vis = m.vis, cw = m.cw;
      for (let j = 0; j < h; j++) {
        const y = y0 + j;
        for (let i = 0; i < w; i++) {
          const q = j * w + i, v = vis[q]; if (!v) continue;
          const x = x0 + i;
          if (x < 0 || y < 0 || x >= W || y >= H || (U32[y * W + x] & 0xffffff) !== (cw[q] & 0xffffff)) vis[q] = 0;
        }
      }
    }
    const seenAt = (m, x, y) => { const i = Math.round(x) - m.sh.x0, j = Math.round(y) - m.sh.y0; return i >= 0 && j >= 0 && i < m.sh.w && j < m.sh.h && !!m.vis[j * m.sh.w + i]; };
    /* her rim of cold light, drawn after the dark so the shape still reads in a room with no candles: the door's cold
       down her right edge and along the tops of her shoulder, her head and the knot on that side; on the left only a
       breath of the crystal's blue, from the shoulder up. Only on her own edge pixels that show */
    function rimMatron(m) {
      if (!m || !m.sh) return;
      const a = m.a, u = (m.fy - m.ey) / 34.6;
      rimShape(m.sh, { cx: m.cx + 0.6 * u, tSide: 1, yMax: m.fy - 2, r: [C.cold, 0.5 * a], t: [C.cold, 0.34 * a] }, m.vis);
      rimShape(m.sh, { cx: m.cx, tSide: -1, yMax: Math.round(m.fy - 27 * u), l: [[110, 140, 210], 0.14 * a] }, m.vis);
    }
    /* a seated regular, from the table top (sy) up: rounded shoulders, a hood or a hat, a warm rim on one side. ht turns
       the head a pixel toward the room (the stare) */
    function patron(cx, sy, s, o) {
      const PAL = { 1: [22, 16, 14], 2: [34, 25, 21], 3: [28, 20, 17] }, rim = [205, 104, 52], side = o.side < 0 ? -1 : 1, ht = o.turn || 0;
      const top = sy - 10 * s, hx = cx + ht;
      const sh = shape(cx - 6.6 * s - 2, top - 6.6 * s - 2, 13.2 * s + 5, 16.6 * s + 3);
      /* the back and the shoulders: broad at the table, the top corners rounded off; the lower back a shade warmer
         (the table's candle under it), a fold or two down a big cloak */
      for (let y = Math.round(top); y < Math.round(sy); y++) {
        const t = (sy - (y + 0.5)) / s;
        let hw = 5 - t * 0.06;
        if (t > 7.2) hw *= Math.cbrt(Math.max(0, 1 - Math.pow((t - 7.2) / 2.8, 3)));
        sh.span(y, cx - hw * s, cx + hw * s, t < 4.4 ? 2 : 1);
        if (s >= 1.8 && t < 8) { sh.span(y, cx - 1.6 * s, cx - 1.6 * s + 1, 3); if (t < 5.5) sh.span(y, cx + 2.2 * s, cx + 2.2 * s + 1, 3); }
      }
      /* elbows out on the table */
      sh.ell(cx - 5.1 * s, sy - 1.1 * s, 1.5 * s, 1.15 * s, 2); sh.ell(cx + 5.1 * s, sy - 1.1 * s, 1.5 * s, 1.15 * s, 2);
      let y0;
      if (o.hood) {
        /* a hood over the head, falling onto the shoulders, its soft peak tipped back */
        sh.ell(cx + ht * 0.7, top - 1.5 * s, 3.1 * s, 3.4 * s);
        sh.ell(cx + ht * 0.5 - 0.5 * s * side, top - 4.4 * s, 1.35 * s, 1.5 * s);
        for (let y = Math.round(top - 1 * s); y < Math.round(top + 1.6 * s); y++) sh.span(y, cx - 4.1 * s, cx + 4.1 * s);
        y0 = Math.round(top - 5.9 * s);
      } else {
        /* a head, and a wide-brimmed hat on it */
        sh.ell(hx, top - 1.7 * s, 2.3 * s, 2.6 * s);
        sh.ell(hx, top - 4.6 * s, 2.1 * s, 1.9 * s);
        sh.ell(hx, top - 3.4 * s, 4.5 * s, 0.75 * s);
        y0 = Math.round(top - 6.5 * s);
      }
      fillShape(sh, PAL, { dz: o.dz, a: o.a });
      /* a warm rim on the side toward the room's candles, along the edge, the shoulder and the head's top on that side,
         with a softer second pixel on a big figure */
      const big = s >= 1.8, rk = [rim[0] * 0.8, rim[1] * 0.8, rim[2] * 0.8];
      for (let j = 0; j < sh.h; j++) for (let i = 0; i < sh.w; i++) {
        const q = j * sh.w + i; if (!sh.m[q]) continue;
        const x = sh.x0 + i, y = sh.y0 + j; if (y >= sy - 1 || (o.dz != null && bay(x, y) > o.dz)) continue;
        const out = side > 0 ? (i + 1 >= sh.w || !sh.m[q + 1]) : (i === 0 || !sh.m[q - 1]);
        if (out) { px(x, y, y < top - 0.5 * s ? rk : rim, (o.a == null ? 1 : o.a) * 0.9); if (big) px(x - side, y, rim, 0.22); continue; }
        if ((j === 0 || !sh.m[q - sh.w]) && (x + 0.5 - cx) * side > s * 0.5) px(x, y, rk, 0.55);
      }
      return { ex: hx - 0.5, ey: Math.round(top - 1.8 * s), box: [Math.round(cx - 6.6 * s), y0, Math.round(cx + 6.6 * s), sy] };
    }
    function tableAt(x, y, w, s, dz) {
      const top = [122, 85, 48], dk = [70, 46, 28];
      rect(x, y, w, Math.max(2, Math.round(2 * s)), dk, undefined, dz); rect(x, y, w, 1, top, undefined, dz);
      rect(x + 2, y + 2, Math.max(1, Math.round(s)), Math.round(9 * s), dk, undefined, dz); rect(x + w - 3, y + 2, Math.max(1, Math.round(s)), Math.round(9 * s), dk, undefined, dz);
    }
    function mug(x, y, lift) { y -= lift || 0; rect(x, y - 3, 2, 3, [185, 160, 122]); px(x, y - 4, [242, 234, 216]); px(x + 1, y - 4, [242, 234, 216]); px(x + 2, y - 2, [140, 112, 80]); }
    /* Yost's mule, face on, standing just outside the door on the road and looking in: long ears, a long face lit warm
       by the room, a pale muzzle that chews, the chest and the front legs; a rim of cool moonlight along her top
       edges. Clipped to the doorway; o.oa dissolves her in with the doorway. Returns her head's box and her mouth */
    function drawMule(cx, gy, k, o) {
      const U = (v) => gy - v * k, X = (v) => cx + v * k;
      const sh = shape(X(-7.5), U(40), 15 * k + 3, 40 * k + 2);
      /* legs and hooves, the chest, the neck */
      for (let y = Math.round(U(10)); y < Math.round(gy); y++) { const v = y >= Math.round(gy) - Math.max(1, Math.round(k)) ? 6 : 2; sh.span(y, X(-3.7), X(-1.5), v); sh.span(y, X(1.5), X(3.7), v); }
      sh.ell(cx, U(13.2), 5.2 * k, 5 * k);
      for (let y = Math.round(U(23.5)); y < Math.round(U(15)); y++) { const p = (U(15) - y) / (8.5 * k); const hw = lerp(4, 2.7, p); sh.span(y, X(-hw), X(hw)); }
      /* the long face: the poll, the broad brow, the cheeks narrowing to the muzzle */
      const FACE = [[31.6, 2], [30.6, 2.7], [28.6, 3], [26.4, 2.9], [24, 2.4], [21.6, 2.2], [19.6, 2], [18.6, 1.4]];
      for (let y = Math.round(U(31.6)); y < Math.round(U(18.6)); y++) {
        const v = (gy - (y + 0.5)) / k; let hw = 0;
        for (let n = 1; n < FACE.length; n++) if (v <= FACE[n - 1][0] && v >= FACE[n][0]) { hw = lerp(FACE[n - 1][1], FACE[n][1], (FACE[n - 1][0] - v) / (FACE[n - 1][0] - FACE[n][0])); break; }
        if (hw > 0) sh.span(y + (v < 20.4 ? o.chew : 0), X(-hw), X(hw), v < 22.4 ? 4 : 3);
      }
      /* the ears, long, broad as leaves and set in a V; a tap flicks the right one out */
      const earQ = (bx, tx, ty) => {
        const y0 = Math.round(U(ty)), y1 = Math.round(U(30.2));
        for (let y = y0; y < y1; y++) {
          const p = (y - y0) / Math.max(1, y1 - y0), xc = lerp(X(tx), X(bx), p), hw = (0.45 + 1.15 * Math.sin(p * Math.PI * 0.85)) * k;
          sh.span(y, xc - hw, xc + hw); if (p > 0.18 && p < 0.92 && hw > 0.9 * k) sh.span(y, xc - hw * 0.42, xc + hw * 0.42, 5);
        }
      };
      earQ(-1.9, -4.8, 38.4);
      if (o.ear) earQ(1.9, 6.2, 35.6); else earQ(1.9, 4.8, 38.4);
      /* the forelock, the eyes on the sides of the face, the nostrils and the mouth */
      sh.ell(cx, U(31), 1.3 * k, 1.1 * k, 6);
      const dot = (x, y, v) => sh.span(y, x, x + Math.max(1, Math.round(k)), v);
      dot(X(-2.6), U(26.9), 7); dot(X(1.6), U(26.9), 7);
      dot(X(-1.3), U(20.6) + o.chew, 8); dot(X(0.5), U(20.6) + o.chew, 8);
      sh.span(U(19.2) + o.chew, X(-0.9), X(0.9), 8);
      const MP = { 1: [92, 74, 62], 2: [70, 56, 48], 3: [126, 102, 84], 4: [184, 160, 136], 5: [74, 54, 52], 6: [44, 32, 28], 7: [20, 13, 11], 8: [62, 42, 36] };
      for (let j = 0; j < sh.h; j++) for (let i = 0; i < sh.w; i++) {
        const v = sh.m[j * sh.w + i]; if (!v) continue;
        const x = sh.x0 + i, y = sh.y0 + j; if (!inDoor(x, y)) continue;
        px(x, y, MP[v], o.oa);
        /* the moon's cool light on her top edges, and a little down her sides */
        const up = j === 0 || !sh.m[q0(sh, i, j - 1)], sd = i === 0 || i + 1 >= sh.w || !sh.m[q0(sh, i - 1, j)] || !sh.m[q0(sh, i + 1, j)];
        if (v !== 7 && v !== 8 && (up || (sd && y < U(26)))) px(x, y, [150, 162, 212], (up ? 0.5 : 0.28) * o.oa);
      }
      /* a warm catch-light in each eye, from the room */
      if (inDoor(Math.round(X(-2.6)), Math.round(U(27.4)))) { add(X(-2.6), U(26.9) - 1, [255, 200, 140], 0.35 * o.oa); add(X(1.6) + Math.max(1, Math.round(k)) - 1, U(26.9) - 1, [255, 200, 140], 0.35 * o.oa); }
      return { box: [X(-5), U(39), 10 * k, 20.5 * k], mouth: [X(0.9), U(19.6)] };
    }
    const q0 = (sh, i, j) => (i < 0 || j < 0 || i >= sh.w || j >= sh.h ? -1 : j * sh.w + i);
    /* Old Yost's cart: the canvas hood lit from inside over its hoops, the box, the wheels, the lantern pole at the front;
       his boots out of the back flap; the goods board down on its side once it's open */
    function cart(cx, fy, w, h, o) {
      const k = G.k, wheelR = Math.round(h * 0.2), boxH = Math.round(h * 0.24), boxY = fy - wheelR - boxH, x0 = Math.round(cx - w / 2);
      const hoodH = h - boxH - wheelR, hx0 = x0 + 2, hw = w - 4, hcx = hx0 + hw / 2;
      for (let j = 0; j < hoodH; j++) {
        const t = j / hoodH, half = Math.sqrt(Math.max(0, 1 - (1 - t) * (1 - t))) * (hw / 2), X0 = Math.round(hcx - half), X1 = Math.round(hcx + half);
        for (let xx = X0; xx < X1; xx++) {
          const edge = xx === X0 || xx === X1 - 1 || j === 0, hoop = ((xx - hx0) % Math.max(5, Math.round(hw / 5))) === 0, lit = 0.72 + 0.28 * t;
          px(xx, boxY - hoodH + j, edge ? [74, 56, 38] : hoop ? [150, 124, 88] : [201 * lit, 180 * lit, 138 * lit]);
        }
      }
      rect(x0 - 1, boxY - 1, w + 2, boxH + 2, C.ol); rect(x0, boxY, w, boxH, [110, 72, 46]); rect(x0, boxY, w, 1, [150, 104, 66]);
      /* the deep shade under the box, between the wheels (what stands behind the cart sinks into it) */
      rect(x0 + 1, boxY + boxH + 1, w - 2, fy - boxY - boxH - 1, [20, 14, 12], 0.66);
      for (let q = 5; q < w; q += 7) rect(x0 + q, boxY + 1, 1, boxH - 1, [74, 48, 32]);
      for (const wx of [x0 + wheelR + 3, x0 + w - wheelR - 4]) {
        ell(wx, fy - wheelR, wheelR + 1, wheelR + 1, C.ol); ell(wx, fy - wheelR, wheelR, wheelR, [90, 62, 40]); ell(wx, fy - wheelR, wheelR - 1.5, wheelR - 1.5, [30, 22, 18]);
        for (let sp = 0; sp < 4; sp++) { const an = o.rot + sp * Math.PI / 4, r1 = wheelR - 1.2; line(wx - Math.cos(an) * r1, fy - wheelR - Math.sin(an) * r1, wx + Math.cos(an) * r1, fy - wheelR + Math.sin(an) * r1, [120, 84, 54]); }
        px(wx, fy - wheelR, C.br3);
      }
      const pX = x0 + 1, pY = boxY - hoodH - Math.round(h * 0.16);
      rect(pX, pY, 1, boxY - pY, [64, 41, 30]);
      const sw = rm ? 0 : Math.round(Math.sin(T / 520) * 1.5);
      rect(pX - 1 + sw, pY + 1, 3, 4, [40, 30, 22]); px(pX + sw, pY + 2, [255, 214, 120]); px(pX + sw, pY + 3, [255, 190, 90]);
      /* the goods board down on its side: a plank with one of his packs (the red seal), a green bottle and a rolled
         scroll on it */
      if (o.board) {
        const gx = x0 + w, gy = boxY + boxH - 3, gw = Math.max(12, Math.round(w * 0.28));
        rect(gx, gy, gw, 2, [150, 104, 66]); rect(gx, gy + 2, gw, 1, [74, 48, 32]);
        rect(gx + 1, gy - 3, 3, 3, [196, 160, 110]); px(gx + 2, gy - 2, [170, 40, 40]); rect(gx + 1, gy - 3, 3, 1, [222, 192, 140]);
        rect(gx + 6, gy - 4, 1, 4, [62, 124, 84]); px(gx + 6, gy - 5, [176, 140, 100]); px(gx + 6, gy - 3, [140, 200, 150]);
        rect(gx + 8, gy - 1, 4, 1, [226, 214, 186]); px(gx + 10, gy - 1, [170, 40, 40]); px(gx + 8, gy - 1, [196, 182, 152]);
      }
      /* his boots out of the back flap, soles to us (a broad toe, the waist, the heel), side by side, one a little
         lower; they twitch when poked */
      const bx = x0 + w - 3, bY = boxY - Math.round(hoodH * 0.35) + (o.wig || 0);
      const BOOT = ['.ss.', 'ssss', 'ssss', '.ss.', '.hh.', 'hhhh', 'hhhh'];
      rect(bx - 1, bY - 1, 10, 9, [92, 72, 50], 0.55);
      for (let b = 0; b < 2; b++) {
        const xx = bx + b * 5, yy = bY + b;
        for (let j = 0; j < BOOT.length; j++) for (let i = 0; i < 4; i++) {
          const ch = BOOT[j][i]; if (ch === '.') continue;
          const edge = i === 0 || i === 3 || j === 0 || j === BOOT.length - 1 || BOOT[j][i - 1] === '.' || BOOT[j][i + 1] === '.';
          px(xx + i, yy + j, ch === 's' ? (edge ? [78, 52, 34] : (j === 1 && i === 1 ? [150, 108, 70] : [112, 76, 48])) : (edge ? [46, 30, 22] : [70, 46, 30]));
        }
      }
      /* his hand out of the front of the canvas, a pack in it */
      if (o.hand > 0) {
        const hx = x0 + 3 - Math.round(4 * k * o.hand), hy = boxY - Math.round(hoodH * 0.45);
        rect(hx, hy, Math.round(3 * k) + 1, 2, [214, 164, 120]); rect(hx - Math.round(4 * k), hy - Math.round(3 * k), Math.round(5 * k), Math.round(6 * k), [196, 160, 110]); px(hx - Math.round(2 * k), hy - 1, [170, 40, 40]);
      }
      return { lx: pX + 0.5 + sw, ly: pY + 2.5, hood: [hcx, boxY - hoodH * 0.45], hoodTop: boxY - hoodH, boxY, x0, x1: x0 + w, boots: [bx - 1, bY - 1, 11, 10] };
    }

    /* ================================================================ the moods ================================================================ */
    /* each record: enter(I) sets its own state; beats [ms on its clock, fn(I, quiet)] happen once in order (a quick
       landing runs the ones already past, quietly: the state, no sounds, no cues); tick(I) every frame and every tenth
       of a second; back/mid/front/grade/light/over draw at those points of the painter's draw; spots(I, out) adds what
       can be touched; exit(I, quick) as it leaves; act[name](I, v) answers the page */
    const TH = {};
    TH.quiet = {};

    /* -- Hearthside Echoes: someone lit the hearth (just off the left of the room); embers rise, three slow enough to catch -- */
    TH.hearth = {
      enter(I) { I.d = { caught: [-1, -1, -1] }; },
      cin(I, i) {
        const P = 14000, ph = rm ? [0.3, 0.52, 0.7][i] : ((T - I.t0 + i * P / 3) % P) / P, k = G.k;
        const x = G.cinders[i] + Math.sin(ph * 5 + i * 2) * 5 * k + ph * 14 * k, y = lerp(H * 0.88, H * 0.28, ph);
        const a = ph < 0.08 ? ph / 0.08 : ph > 0.9 ? (1 - ph) / 0.1 : 1;
        return { x, y, a, ph };
      },
      light(I) {
        const a = amt(I, 2000, 800, 0, 400); if (a <= 0) return;
        const ox = 0, oy = H * 0.92, r = H * 0.75, fl = rm ? 1 : 0.85 + 0.15 * Math.sin(T / 230) * Math.sin(T / 610);
        glow(ox, oy, r, [255, 138, 61], 0.16 * a * fl);
        for (let k = 0; k < 8; k++) { const per = 7000 + k * 900, ph = rm ? (k + 0.5) / 8 : ((T + k * 1700) % per) / per; px(ox + 4 + hsh(k, 1) * r * 0.5 + Math.sin(ph * 9 + k) * 3, oy - ph * r * 0.9, [255, 160, 80], a * (1 - ph)); }
        for (let i = 0; i < 3; i++) {
          const c = I.d.caught[i];
          if (c >= 0) { const e = T - c; if (e < 400 && I.d.cx) glow(I.d.cx[i], I.d.cy[i], (3 + e / 40) * G.k, [255, 200, 120], 0.6 * (1 - e / 400)); continue; }
          const q = this.cin(I, i); if (q.a <= 0) continue;
          /* bigger than the hearth's own sparks: a two-pixel coal with a hot heart and a glow */
          const tw = rm ? 1 : 0.75 + 0.25 * Math.sin(T / 160 + i * 2), aa = a * q.a;
          glow(q.x, q.y, 6 * G.k, [255, 140, 60], 0.32 * aa * tw);
          px(q.x, q.y, [255, 150, 70], aa); px(q.x + 1, q.y, [230, 110, 50], aa); px(q.x, q.y + 1, [230, 110, 50], aa); px(q.x + 1, q.y + 1, [190, 80, 40], aa);
          add(q.x, q.y, [255, 230, 170], 0.7 * aa * tw);
          if (!rm) add(q.x + Math.sin(T / 300 + i) * 1.5, q.y + 3, [255, 160, 80], 0.4 * aa);
        }
      },
      spots(I, out) {
        if (!I.settled) return;
        for (let i = 0; i < 3; i++) {
          if (I.d.caught[i] >= 0) continue;
          const q = this.cin(I, i); if (q.ph < 0.06 || q.ph > 0.9) continue;
          out.push({ id: 'jb-cinder-' + i, x: Math.round(q.x / 3) * 3 - 4, y: Math.round(q.y / 3) * 3 - 4, w: 8, h: 8, label: 'A rising ember' });
        }
      },
      act: {
        cinder(I, v) {
          const i = clamp((v && v.i) | 0, 0, 2); if (I.d.caught[i] >= 0) return;
          const q = this.cin(I, i); I.d.cx = I.d.cx || []; I.d.cy = I.d.cy || []; I.d.cx[i] = q.x; I.d.cy[i] = q.y; I.d.caught[i] = T;
          fly(q.x, q.y, [255, 190, 110]);
        }
      }
    };

    /* -- After Hours: rain on the glass, a cup on the window seat, the owl dozing -- */
    TH.after = {
      enter(I) { I.d = { puff: -1e9 }; },
      exit() { st.owlWake = -1e9; },
      light(I) {
        const a = amt(I, 2000, 1200, 0, 300); if (a <= 0) return;
        const wn = G.win;
        for (let k = 0; k < 30; k++) {
          const per = 900 + hsh(k, 2) * 700, ph = rm ? hsh(k, 9) : ((T + k * 377) % per) / per, x = wn.x0 + 2 + hsh(k, 5) * (wn.w - 4), y = wn.T + 6 + ph * (wn.h - 8);
          px(x, y, [150, 172, 204], 0.7 * a); px(x, y - 1, [130, 152, 186], 0.5 * a); px(x, y - 2, [111, 134, 168], 0.3 * a);
        }
        const [cx, cy] = G.cup;
        rect(cx, cy - 3, 3, 3, [210, 200, 186], a); px(cx + 3, cy - 2, [190, 180, 166], a); rect(cx, cy - 3, 3, 1, [120, 84, 54], a);
        const big = T - I.d.puff < 1400 ? 1 : 0;
        for (let s = 0; s < (big ? 7 : 3); s++) { const per = big ? 1400 : 2600, ph = rm ? 0.4 : ((T - (big ? I.d.puff : 0) + s * (big ? 120 : 860)) % per) / per; px(cx + 1 + Math.sin(ph * 6 + s) * (1.5 + big), cy - 4 - ph * (7 + big * 6), [236, 230, 220], 0.45 * a * (1 - ph)); }
      },
      spots(I, out) { if (I.settled) out.push({ id: 'jb-cup', x: G.cup[0] - 2, y: G.cup[1] - 6, w: 8, h: 7, label: 'A steaming cup' }); },
      act: {
        cup(I) { I.d.puff = T; },
        'owl-wake'() { st.owlWake = T; }
      }
    };

    /* -- Regal Wayfarer: the King's Road watch comes in by the door and stands guard, facing the room -- */
    TH.regal = {
      enter(I) { I.d = { salute: -1e9, stamp: -1e9, pikeN: 0, pikeT: -1e9, sneeze: -1e9, give: -1e9 }; },
      beats: [
        [900, (I, q) => { if (!q) snd('whoosh', { g: 0.06 }); }],
        [1400, (I, q) => { if (!q) door(); }],
        [4500, (I, q) => { if (!q) { I.d.stamp = T; cue('guards-in'); } }]
      ],
      exit(I, quick) { if (!quick) later(200, door); },
      pos(I, who) {
        const post = G[who], dcx = G.D.cx, start = who === 'pike' ? 1800 : 2100, dur = 2400;
        if (I.tx != null) {
          const x = T - I.tx, s2 = who === 'maren' ? 300 : 700, p = sat((x - s2) / 1400);
          return { x: lerp(post[0], dcx, eio(p)), fy: lerp(post[1], G.fl + 1, eio(p)), walk: p > 0 && p < 1 && !rm ? x / 760 : -1, a: p < 0.85 ? 1 : 1 - (p - 0.85) / 0.15, look: -1 };
        }
        const e = I.clk, p = sat((e - start) / dur);
        if (p <= 0) return null;
        return { x: lerp(dcx, post[0], eio(p)), fy: lerp(G.fl + 1, post[1], eio(p)), walk: p < 1 && !rm ? (e - start) / 760 : -1, a: p < 0.12 ? p / 0.12 : 1 };
      },
      tick(I, pz) {
        /* the salute on the music's swell, twenty seconds in and on every loop */
        if (pz || !I.settled) return;
        const mt = mtime();
        if (mt >= 20 && mt < 20.5 && T - I.d.salute > 4000) { I.d.salute = T; I.d.stamp = T; cue('salute'); poke(); }
      },
      back(I) {
        const a = amt(I, 400, 900, 0, 900), k = G.k;
        if (a > 0) G.pennants.forEach((pn, n) => {
          const [x, y, len] = pn, pr = sat((I.clk - 400 - n * 120) / 600) * (I.tx == null ? 1 : 1 - sat((T - I.tx - 600 - n * 80) / 500)), ln = Math.round(len * eout(pr));
          if (pr <= 0) return;
          rect(x - 1, y, 7, 1, C.br3);
          for (let j = 0; j < ln; j++) { const wv = rm ? 0 : Math.round(Math.sin(T / 600 + j * 0.4) * 0.6), w = j > ln - 3 ? 5 - (j - (ln - 3)) * 2 : 5; rect(x + wv + (5 - w) / 2, y + 1 + j, Math.max(1, w), 1, j % 7 === 0 ? C.br3 : [78, 42, 122]); }
          if (ln > 8 * k) { px(x + 2, y + 5, C.br4); px(x + 1, y + 6, C.br4); px(x + 3, y + 6, C.br4); px(x + 2, y + 7, C.br4); }
        });
        /* the King's Road outside: torches moving along a far road */
        const wn = G.win, ra = amt(I, 800, 1200, 0, 600);
        if (ra > 0) for (let q = 0; q < 4; q++) { const p = rm ? (q + 0.5) / 4 : ((T / 9000 + q / 4) % 1); px(wn.x0 + 3 + p * (wn.w - 6), wn.T + wn.h * 0.72 - p * 3, [255, 170, 80], 0.8 * ra); }
      },
      mid(I) {
        const u = 1.15 * G.k;
        for (const who of ['pike', 'maren']) {
          const q = this.pos(I, who); if (!q) continue;
          const sal = T - I.d.salute < 1600 ? 1 : 0;
          let look = q.look != null ? q.look : 0, head = 0;
          if (who === 'pike') { if (T - I.d.pikeT < 600) look = I.d.pikeN % 2 ? 1 : -1; if (T - I.d.sneeze < 260) head = 1; }
          else if (q.look == null && !rm && ((T / 7000) % 1) > 0.85) look = -1;
          const hd = guard(q.x, q.fy, u, { kind: who, walk: q.walk, a: q.a < 1 ? 1 : undefined, dz: q.a < 1 ? q.a : null, salute: sal, give: who === 'maren' && T - I.d.give < 1800, head, look, glint: q.walk >= 0 && Math.floor(q.walk * 2) !== Math.floor((q.walk - 0.03) * 2) });
          if (who === 'pike') I.d.pikeHead = hd;
        }
      },
      light(I) {
        const a = amt(I, 900, 300, 1200, 600), k = G.k;
        for (const [x, y] of G.torches) {
          rect(x, y, 1, Math.round(9 * k), [64, 41, 30]);
          if (a > 0) { const f = rm ? 1 : 0.8 + 0.2 * Math.sin(T / 90 + x); px(x, y - 1, [255, 154, 60], a); px(x, y - 2, [255, 210, 120], a * f); glow(x + 0.5, y - 1, 9 * k, [255, 140, 60], 0.18 * a * f); }
        }
        if (T - I.d.stamp < 1400 && !rm) for (let m = 0; m < 14; m++) { const p = (T - I.d.stamp) / 1400; px(G.maren[0] - 8 * k + hsh(m, 1) * 30 * k, G.cor + 4 + p * 60 * k * (0.5 + hsh(m, 2)), C.br5, 1 - p); }
        const mq = this.pos(I, 'maren');
        if (mq && mq.walk < 0 && I.tx == null && !has('paladin-regal')) tapMe(mq.x, mq.fy - 43 * 1.15 * k, [255, 226, 150], 1);
        /* Pike's sneeze */
        const sn = T - I.d.sneeze;
        if (sn >= 120 && sn < 760 && I.d.pikeHead) { const p = (sn - 120) / 640; for (let m = 0; m < 6; m++) px(I.d.pikeHead.hx - 2 - p * 6 * k * (0.6 + hsh(m, 4)), I.d.pikeHead.hy + 1 + (hsh(m, 5) - 0.5) * 4 * k, [236, 232, 224], 0.7 * (1 - p)); }
      },
      spots(I, out) {
        if (I.tx != null) return;
        const u = 1.15 * G.k;
        for (const who of ['maren', 'pike']) {
          const q = this.pos(I, who); if (!q || q.walk >= 0 || q.a < 1) continue;
          out.push({ id: 'jb-' + who, x: q.x - 9 * u, y: q.fy - 40 * u, w: 18 * u, h: 40 * u, label: who === 'maren' ? 'Sergeant Maren Vos' : 'Pike, on guard' });
        }
      },
      act: {
        salute(I) { I.d.salute = T; },
        pike(I, v) { I.d.pikeN = (v && v.n) | 0; I.d.pikeT = T; if (I.d.pikeN === 5) I.d.sneeze = T; },
        'maren-give'(I) { I.d.give = T; }
      }
    };

    /* -- Murmurs in the Bog: the Blackfen comes up through the floor; a frog on the jukebox's crown; fireflies; the
       candles turn to will-o'-wisps, and one wanders off -- */
    TH.bog = {
      enter(I) {
        I.d = { frogT: null, hop: null, at: 0, croak: -1e9, flies: [], caught: [-1, -1, -1], wisp: { n: 0, t0: null, hop: null, gone: -1 } };
        /* kept as shares of the room, so a turned phone (a rebuilt grid) keeps them where they were */
        const N = G && G.flies ? G.flies : 40;
        for (let k = 0; k < N; k++) I.d.flies.push({ x: hsh(k, 11), y: 0.25 + hsh(k, 12) * 0.6, ph: hsh(k, 13) * 6, on: 2000 + k * (1200 / N) });
      },
      beats: [
        [1600, (I, q) => { if (!q) snd('whoosh', { g: 0.05, d: 1.2 }); }],
        [3200, (I, q) => { I.d.frogT = q ? -1e9 : T; if (!q) snd('pop'); }],
        [3460, (I, q) => { if (!q) cue('frog-landed'); }],
        [3500, (I, q) => { I.d.wisp.t0 = q ? -1e9 : T; }]
      ],
      back(I) {
        const a = amt(I, 800, 800, 300, 800), k = G.k;
        if (a > 0) {
          /* moss down the posts */
          for (const p of G.posts) { const len = Math.round(lerp(0, 40 * k, a)); for (let j = 0; j < len; j++) if (hsh(p, j) > 0.35) px(p + (hsh(j, p) > 0.6 ? 1 : 0), G.cor + j, [79, 107, 46], 0.9); }
          /* the window turns to the fen, reeds against it */
          const wn = G.win;
          for (let y = Math.max(0, wn.T); y < Math.min(H, wn.B); y++) for (let x = Math.max(0, wn.x0); x < Math.min(W, wn.x1); x++) { const i = (y * W + x) << 2; if (D[i + 2] > D[i] + 10 && D[i + 2] < 200) { D[i] = D[i] * 0.6 + 20 * a; D[i + 1] = D[i + 1] * 0.8 + 30 * a; D[i + 2] = D[i + 2] * (1 - 0.45 * a); } }
          for (let q = 0; q < 3; q++) { const tx = wn.x0 + 3 + q * (wn.w / 3); for (let j = 0; j < wn.h * 0.4; j++) px(tx + Math.round(Math.sin(j * 0.5 + q)), wn.B - j, [22, 30, 20], a); }
        }
        const pa = amt(I, 1400, 600, 400, 600);
        if (pa > 0) for (const [x, y, r] of G.puddles) { ell(x, y, r * pa, Math.max(1, r * 0.28 * pa), [29, 42, 36]); px(x - r * 0.3, y, [207, 232, 216], pa * 0.8); }
        this.reeds(I, G.reeds);
      },
      /* a clump of reeds: blades of their own heights fanning out from the root, darker at the foot and paler at the tip,
         swaying a little more toward the top; now and then a cattail's brown head */
      reeds(I, list) {
        const ra = amt(I, 800, 800, 400, 300), k = G.k; if (ra <= 0) return;
        const RC = [[46, 66, 34], [70, 98, 42], [104, 132, 56], [140, 162, 78]];
        list.forEach(([x, y], n) => {
          const nb = 4 + Math.floor(hsh(n, 9) * 2), tall = (7 + hsh(n, 4) * 8) * k * ra;
          for (let b = 0; b < nb; b++) {
            const off = b - (nb - 1) / 2, hgt = Math.round(tall * (0.55 + 0.45 * hsh(n * 7 + b, 5))), lean = off * 0.16 + (hsh(n, b + 20) - 0.5) * 0.1;
            for (let j = 0; j < hgt; j++) {
              const sw = rm ? 0 : Math.sin(T / 900 + n + b * 0.7 + j * 0.15) * j * 0.07, t = j / Math.max(1, hgt);
              px(x + off * 1.2 + lean * j + sw, y - j, RC[t < 0.25 ? 0 : t < 0.6 ? 1 : t < 0.88 ? 2 : 3]);
            }
            if (hgt > 7 * k && hsh(n * 3 + b, 11) > 0.72) { const tx = x + off * 1.2 + lean * hgt * 0.8, ty = y - hgt * 0.8; rect(tx - 0.5, ty - Math.max(2, 2.4 * k), 2, Math.max(2, Math.round(2.6 * k)), [96, 62, 36]); }
          }
        });
      },
      front(I) { this.reeds(I, G.reedsNear); },
      frogAt(I) {
        const d = I.d, S = G.frog; if (d.frogT == null) return null;
        const dropP = rm ? 1 : sat((T - d.frogT) / 260);
        let [x, y] = S[d.at];
        if (d.hop) {
          const hp = rm ? 1 : sat((T - d.hop.t0) / 600), A = S[d.hop.from], B = S[d.hop.to];
          x = lerp(A[0], B[0], hp); y = lerp(A[1], B[1], hp) - Math.sin(hp * Math.PI) * 30 * G.k;
          if (hp >= 1) { d.at = d.hop.to; d.hop = null; if (!rm) snd('pop'); poke(); }
        }
        if (I.tx != null) {
          const p = sat((T - I.tx) / 600); return { x: lerp(x, G.D.cx, p), y: lerp(y, G.fl, p) - Math.sin(p * Math.PI) * 6, a: 1 - p };
        }
        return { x, y: y - (1 - dropP) * 10, a: dropP };
      },
      mid(I) {
        const f = this.frogAt(I); if (!f) return;
        const puff = (!rm && (T % 4200) < 400) || T - I.d.croak < 500 ? 1 : 0;
        spr(FROG[puff], f.x - 5, f.y - 6, FROGPAL, { dz: f.a < 1 ? f.a : null });
        I.d.fxy = [f.x, f.y - 4];
      },
      flyAt(I, i) {
        const b = G.flyBase[i], k = G.k, t = rm ? 0 : T;
        return [b[0] + Math.sin(t / (2600 + i * 500) + i * 2) * 7 * k, b[1] + Math.sin(t / (1900 + i * 300) + i) * 4 * k];
      },
      wispAt(I) {
        const w = I.d.wisp, S = G.wisp; if (w.t0 == null || w.gone >= 0) return null;
        const k = G.k, bob = rm ? 0 : Math.sin(T / 700) * 2 * k;
        if (w.hop) {
          const p = rm ? 1 : eio((T - w.hop.t0) / 700), A = w.hop.from, B = S[w.hop.to];
          if (p >= 1) { w.hop = null; if (w.n >= 3) { w.gone = T; fly(B[0], B[1], [170, 240, 140]); return null; } poke(); }
          else return { x: lerp(A[0], B[0], p), y: lerp(A[1], B[1], p) - Math.sin(p * Math.PI) * 12 * k, moving: true };
        }
        if (w.n === 0) { const p = rm ? 1 : eio((T - w.t0) / 1200); return { x: lerp(G.wispFrom[0], S[0][0], p), y: lerp(G.wispFrom[1], S[0][1], p) + bob * p, moving: p < 1 }; }
        const s = S[Math.min(w.n, 2)]; return { x: s[0] + (rm ? 0 : Math.sin(T / 1100) * 3 * k), y: s[1] + bob };
      },
      light(I) {
        const d = I.d, k = G.k;
        /* the candles burn green */
        const wa = amt(I, 1600, 800, 1200, 600);
        if (wa > 0) for (const [cx, cy] of G.cand.concat([[G.lcand[0], G.lcand[1] + 2]])) {
          for (let y = Math.max(0, Math.round(cy) - 9); y < Math.min(H, Math.round(cy) + 2); y++) for (let x = Math.max(0, Math.round(cx) - 3); x < Math.min(W, Math.round(cx) + 4); x++) {
            const i = (y * W + x) << 2, lum = D[i] * 0.3 + D[i + 1] * 0.59 + D[i + 2] * 0.11;
            if (lum > 150 && D[i] >= D[i + 2]) { D[i] = lerp(D[i], 191, wa); D[i + 1] = lerp(D[i + 1], 232, wa); D[i + 2] = lerp(D[i + 2], 160, wa); }
          }
          glow(cx, cy - 3, 7 * k, [140, 230, 120], 0.12 * wa);
        }
        /* fog over the floor: a low pass with two slow waves through it, blended smoothly (no dither grid) */
        const fa = amt(I, 300, 1600, 600, 1200);
        if (fa > 0) {
          const top = Math.floor(H * 0.62), t1 = rm ? 0 : T / 2600, t2 = rm ? 0 : -T / 4100, s1 = G.fa, c1 = G.fb, s2 = G.fc, c2 = G.fd2;
          for (let x = 0; x < W; x++) { s1[x] = Math.sin(x * 0.11 + t1); c1[x] = Math.cos(x * 0.11 + t1); s2[x] = Math.sin(x * 0.043 + t2); c2[x] = Math.cos(x * 0.043 + t2); }
          for (let y = top; y < H; y++) {
            const tt = (y - top) / (H - top), b1 = y * 0.05, b2 = y * 0.09, sb1 = Math.sin(b1), cb1 = Math.cos(b1), sb2 = Math.sin(b2), cb2 = Math.cos(b2), base = fa * 0.16 * tt * (2 - tt);
            for (let x = 0, i = (y * W) << 2; x < W; x++, i += 4) {
              const n = 0.5 + 0.5 * (s1[x] * cb1 + c1[x] * sb1) * (s2[x] * cb2 + c2[x] * sb2), a = base * (0.5 + 0.5 * n);
              D[i] += (127 - D[i]) * a; D[i + 1] += (159 - D[i + 1]) * a; D[i + 2] += (134 - D[i + 2]) * a;
            }
          }
        }
        if (d.fxy && !d.hop && I.tx == null && !has('sorcerer-verdictus')) tapMe(d.fxy[0], d.fxy[1], [200, 250, 160], 3);
        /* fireflies, and the three slow ones */
        d.flies.forEach((fl, n) => {
          const on = sat((I.clk - fl.on) / 300) * (I.tx == null ? 1 : 1 - sat((T - I.tx - 200 - (d.flies.length - n) * 25) / 200));
          if (on <= 0) return;
          const t = rm ? 0 : T, x = fl.x * W + Math.sin(t / 1700 + fl.ph) * 6, y = fl.y * H + Math.sin(t / 1300 + fl.ph * 2) * 4, bl = rm ? 1 : 0.5 + 0.5 * Math.sin(T / 400 + fl.ph * 3);
          add(x, y, [230, 250, 160], on * (0.5 + 0.5 * bl)); glow(x, y, 4, [190, 225, 110], 0.18 * on * bl);
        });
        const fa2 = amt(I, 2600, 600, 0, 400);
        if (fa2 > 0) for (let i = 0; i < 3; i++) {
          if (d.caught[i] >= 0) continue;
          const [x, y] = this.flyAt(I, i), bl = rm ? 1 : 0.7 + 0.3 * Math.sin(T / 520 + i * 2);
          add(x, y, [240, 255, 170], fa2); add(x + 1, y, [240, 255, 170], 0.5 * fa2 * bl); glow(x, y, 5 * k, [190, 235, 110], 0.3 * fa2 * bl);
        }
        /* the stray wisp */
        const wq = this.wispAt(I);
        if (wq && I.tx == null) {
          /* a small green flame with no candle under it, flickering, trailing a mote or two */
          const f = rm ? 1 : 0.8 + 0.2 * Math.sin(T / 120), sw = rm ? 0 : Math.round(Math.sin(T / 260));
          glow(wq.x, wq.y - 2, 9 * k, [140, 230, 120], 0.38 * f);
          rect(wq.x - 1, wq.y - 1, 3, 2, [170, 240, 140]); px(wq.x, wq.y - 2, [210, 255, 190]); px(wq.x + sw, wq.y - 3, [190, 250, 170], 0.9 * f); px(wq.x + sw, wq.y - 4, [140, 230, 120], 0.6 * f);
          add(wq.x, wq.y - 1, [230, 255, 220], 0.8);
          if (!rm) for (let m = 0; m < 2; m++) { const ph = ((T + m * 700) % 1400) / 1400; add(wq.x + Math.sin(ph * 6 + m) * 2, wq.y + 2 + ph * 6, [170, 240, 140], 0.6 * (1 - ph)); }
        }
      },
      spots(I, out) {
        if (I.tx != null) return;
        const d = I.d, f = this.frogAt(I), k = G.k;
        if (f && f.a >= 1 && !d.hop) { const r = 9 * k; out.push({ id: 'jb-frog', x: f.x - r, y: f.y - r - 3, w: r * 2, h: r * 2, label: 'The frog' }); }
        if (I.clk > 3200) for (let i = 0; i < 3; i++) {
          if (d.caught[i] >= 0) continue;
          const [x, y] = this.flyAt(I, i); out.push({ id: 'jb-fly-' + i, x: Math.round(x / 3) * 3 - 4, y: Math.round(y / 3) * 3 - 4, w: 8, h: 8, label: 'A firefly' });
        }
        const wq = this.wispAt(I);
        if (wq && !wq.moving) out.push({ id: 'jb-wisp', x: Math.round(wq.x / 3) * 3 - 5, y: Math.round(wq.y / 3) * 3 - 7, w: 10, h: 10, label: 'A stray wisp' });
      },
      act: {
        'frog-hop'(I, v) {
          const d = I.d, to = clamp((v && v.to) | 0, 0, 2); if (d.frogT == null || d.at === to) return;
          if (d.hop) d.at = d.hop.to;
          d.hop = { t0: T, from: d.at, to };
        },
        'frog-croak'(I) { I.d.croak = T; },
        'frog-give'(I) { const d = I.d; d.croak = T; if (d.frogT != null && d.at !== 0 && !d.hop) d.hop = { t0: T + 500, from: d.at, to: 0 }; },
        'fly-catch'(I, v) { const i = clamp((v && v.i) | 0, 0, 2); if (I.d.caught[i] >= 0) return; const [x, y] = this.flyAt(I, i); I.d.caught[i] = T; fly(x, y, [220, 255, 150]); },
        wisp(I, v) {
          const w = I.d.wisp, n = clamp((v && v.n) | 0, 1, 3); if (w.gone >= 0 || n <= w.n) return;
          const q = this.wispAt(I) || { x: G.wisp[0][0], y: G.wisp[0][1] };
          w.n = n; w.hop = { t0: T, from: [q.x, q.y], to: n };
        }
      }
    };

    /* -- Tinker's Evening Route. Old Yost's cart rolls in by the door and stops where the easel stands; the doorway stays
       open on the night with the mule in it (the same night as the window beside it: cool outside, warm only in the
       lantern and the room's light on the road) -- */
    TH.tinker = {
      enter(I) { I.d = { board: null, up: true, muleN: 0, muleT: -1e9, bootsN: 0, bootsT: -1e9, coin: -1e9, hand: -1e9 }; },
      beats: [
        [600, (I, q) => { if (!q) door(); }],
        [1000, (I, q) => { if (!q) snd('cart', { d: 2 }); }],
        [3300, (I, q) => { if (!q) cue('cart-stopped'); }],
        [3500, (I, q) => { I.d.board = q ? -1e9 : T; }]
      ],
      exit(I, quick) { if (quick) return; later(500, door); later(600, () => snd('cart', { d: 1.6 })); },
      where(I) {
        const c = G.cart, e = I.clk, startX = G.D.cx + c.w * 0.3;
        let p = sat((e - 1200) / 2000);
        if (I.tx != null) p = 1 - sat((T - I.tx - 600) / 1600);
        const x = lerp(startX, c.cx, eout(p)), bump = p >= 1 && e - 3200 < 180 && e > 3200 && !rm ? 1 : 0;
        return { x, fy: c.fy - bump, p, rot: x / 3 };
      },
      mid(I) {
        /* the doorway open on the night (navy overhead to violet, a few stars, the low hills dark under a faint moonlit
           line, the road with the room's light spilling onto it), and the mule standing just outside, looking in */
        const oa = amt(I, 3300, 500, 2300, 500), Dd = G.D;
        if (oa > 0) {
          const top = Dd.top, dh = G.fl - top, k = G.k;
          for (let y = top; y < G.fl; y++) {
            const t = (y - top) / dh;
            for (let x = Dd.x0; x < Dd.x1; x++) {
              if (!inDoor(x, y)) continue;
              const hill =0.66 + 0.035 * Math.sin((x - Dd.x0) * 0.35 / k + 1.3) + 0.02 * Math.sin((x - Dd.x0) * 0.9 / k);
              let c;
              if (t < hill) { const v = t / hill; c = (x * 73 + y * 151) % 233 === 0 && v < 0.8 ? [196, 206, 236] : [lerp(16, 70, v * v), lerp(20, 62, v * v), lerp(44, 118, v * v)]; }
              else if (t < 0.76) c = t < hill + 1 / dh ? [74, 72, 116] : [28, 26, 46];
              else { const g = sat((t - 0.84) / 0.16); c = [lerp(60, 128, g), lerp(42, 80, g), lerp(42, 50, g)]; }
              px(x, y, c, oa);
            }
          }
          const chew = !rm && ((T % 1600) < 300 || (T - I.d.muleT < 900 && (T % 300) < 150)) ? 1 : 0, ear = T - I.d.muleT < 500 && !rm ? 1 : 0;
          const mq = drawMule(Dd.cx, Math.round(top + 0.93 * dh), k, { chew, ear, oa });
          I.d.muleAt = mq;
          if (I.d.muleN >= 3) add(mq.mouth[0], mq.mouth[1] + chew, C.hw, 0.6 + 0.4 * Math.sin(T / 200));
        }
        const q = this.where(I); if (q.p <= 0) return;
        const bt = T - I.d.bootsT, wig = bt < 600 && !rm ? (Math.floor(bt / 100) % 2 ? -1 : 1) : 0, hd = T - I.d.hand;
        ell(q.x, q.fy, G.cart.w * 0.55, Math.max(2, 3 * G.k), C.ol, 0.55 * q.p);
        I.d.c = cart(q.x, q.fy, G.cart.w, G.cart.h, { rot: q.rot, board: I.d.board != null && I.tx == null && I.d.up && I.clk >= 3500, wig, hand: hd < 1800 ? (hd < 300 ? hd / 300 : hd > 1500 ? (1800 - hd) / 300 : 1) : 0 });
      },
      light(I) {
        const c = I.d.c, q = this.where(I), k = G.k; if (!c || q.p <= 0) return;
        const f = rm ? 1 : 0.8 + 0.2 * Math.sin(T / 140);
        glow(c.lx, c.ly, 22 * k, [255, 190, 100], 0.32 * f); add(c.lx, c.ly, [255, 220, 140], 1);
        glow(c.hood[0], c.hood[1], 26 * k, [255, 184, 92], 0.18 * f);
        if (q.p >= 1 && I.tx == null && !kept.pack) tapMe(c.hood[0], c.hoodTop + 2, [255, 214, 140], 2);
        if (!rm) for (let s = 0; s < 6; s++) { const per = 5200, ph = ((T + s * 400) % per) / per; if (ph < 0.6) px(c.hood[0] + 4 + Math.sin(ph * 8 + s) * 2, c.hoodTop - ph * 20 * k, [170, 160, 150], 0.4 * (1 - ph / 0.6)); }
        /* the coin out of his boots, flipping */
        const ce = T - I.d.coin;
        if (ce >= 0 && ce < 1300) { const p = ce / 1300, bx = c.boots[0] + c.boots[2] / 2, by = c.boots[1] - Math.sin(p * Math.PI) * 26 * k, sp = Math.floor(ce / 90) % 3; if (sp !== 1) { px(bx, by, C.br4); px(bx + (sp ? 1 : -1), by, C.br3); } else px(bx, by, C.br5); add(bx, by - 1, C.hw, 0.5 + 0.5 * Math.sin(ce / 60)); }
      },
      spots(I, out) {
        const q = this.where(I), c = G.cart; if (q.p < 1 || I.tx != null) return;
        out.push({ id: 'jb-cart', x: q.x - c.w / 2, y: q.fy - c.h, w: c.w, h: c.h, label: 'Old Yost’s cart' });
        if (I.d.c) { const b = I.d.c.boots; out.push({ id: 'jb-boots', x: b[0] - 1, y: b[1] - 1, w: b[2] + 2, h: b[3] + 2, label: 'Yost’s boots' }); }
        if (I.clk > 4200 && I.d.muleAt) { const b = I.d.muleAt.box; out.push({ id: 'jb-mule', x: b[0], y: b[1], w: b[2], h: b[3], label: 'The mule' }); }
      },
      act: {
        board(I, v) { I.d.up = !!(v && v.up); },
        boots(I, v) { I.d.bootsN = (v && v.n) | 0; I.d.bootsT = T; if (I.d.bootsN === 3) I.d.coin = T + 250; },
        mule(I, v) { I.d.muleN = (v && v.n) | 0; I.d.muleT = T; },
        'yost-hand'(I) { I.d.hand = T; },
        'pack-done'() { keep('pack'); }
      }
    };

    /* -- Shadows in the Tankard: the Hollow Stump's tables slide in, lanterns round the candles, and every regular stares
       at the reader on the Quest's own beats (Zhaunil never does) -- */
    TH.tavern = {
      enter(I) { I.d = { stare: null, next: SET.tavern + 1500, first: true, coins: [0, 0, 0], eyesRed: -1e9, toast: -1e9, heads: [], said: false, looks: {} }; },
      beats: [
        [1500, (I, q) => { if (!q) cue('tables-in'); }],
        [1800, (I, q) => { if (!q) snd('murmur', { d: 2 }); }]
      ],
      exit(I) {
        const d = I.d;
        if (d.stare && d.stare.closing == null) cue('stare-off');
        d.stare = null;
        snd('whoosh', { g: 0.06, d: 0.9 });
      },
      exitTick(I) { if (!I.d.said && T - I.tx > 360 + 70 * 9) { I.d.said = true; cue('vanished', { rec: 'tavern' }); } },
      tick(I) {
        /* the Quest's stare: 1.5 s after settling, held 3.5 s. Then 10 s after they look away, held 1.8 s. On the record's
           own clock, which stops while an overlay is open or the tab is hidden */
        const d = I.d, e = I.clk;
        if (!I.settled) return;
        if (!d.stare && e >= d.next) { d.stare = { t0: e, t1: e + (d.first ? 3500 : 1800), order: [0, 1, 2, 3, 4, 5].sort(() => Math.random() - 0.5), closing: null }; d.first = false; cue('stare-on'); poke(); }
        else if (d.stare && d.stare.closing == null && e >= d.stare.t1) { d.stare.closing = e; cue('stare-off'); poke(); }
        else if (d.stare && d.stare.closing != null && e >= d.stare.closing + 360) { d.stare = null; d.next = e + 10000; poke(); }
        /* a patron the reader tapped looks back on their own (Jan, 2026-10-07: "they turn and look at you for 5 seconds
           then turn back"), apart from the group's stare and the coins */
        for (const i of Object.keys(d.looks)) {
          const L = d.looks[i];
          if (e >= L.t1 + 360) { delete d.looks[i]; poke(); } else if (!L.shut && e >= L.t1) { L.shut = true; poke(); }
        }
      },
      /* one patron's own look: the head turns at once, the eyes open 90 ms later over 90 ms, hold to t1, shut over 120 ms,
         and the head goes back 150 ms after; under reduced motion it all happens at once */
      solo(I, idx) {
        const L = I.d.looks[idx], e = I.clk; if (!L || e < L.t0) return { turn: 0, open: 0 };
        if (rm) return e < L.t1 ? { turn: 1, open: 1 } : { turn: 0, open: 0 };
        if (e < L.t1) return { turn: 1, open: sat((e - L.t0 - 90) / 90) };
        const c = e - L.t1;
        return { turn: c < 150 ? 1 : 0, open: 1 - sat(c / 120) };
      },
      tablePos(I, tb, k) {
        const p = rm ? 1 : sat((I.clk - 600 - k * 160) / 520), off = (1 - eback(p)) * (tb.from > 0 ? W - tb.x + 6 : -(tb.x + tb.w + 6));
        return { x: tb.x + off, p };
      },
      vanishA(I, order) { if (I.tx == null) return 1; return 1 - sat((T - I.tx - order * 70) / 360); },
      /* one head's look. n heads turn within 210 ms, each one's eyes open 40 ms after it turns, shut over 150 ms, and the
         heads go back 150 ms after */
      look(I, idx, n) {
        const S = I.d.stare, e = I.clk; if (!S) return { turn: 0, open: 0 };
        const o = Math.max(0, S.order.indexOf(idx) % Math.max(1, n)), at = S.t0 + 210 * o / Math.max(1, n);
        if (e < at) return { turn: 0, open: 0 };
        let open = rm ? 1 : sat((e - at - 40) / 60), turn = 1;
        if (S.closing != null) { const c = e - S.closing; open *= rm ? 0 : 1 - sat((c - o * (60 / n)) / 90); if (c >= 150 + o * (60 / n)) turn = 0; }
        return { turn, open };
      },
      drawTables(I, which) {
        const d = I.d; let order = 0;
        G.tables.forEach((tb, k) => {
          const near = k > 0; if (near !== (which === 'front')) { order += tb.pats.length + 1; return; }
          /* the back table stands at the back wall: it slides in behind the easel, and the lectern and the easel's
             palette stand in front of it */
          ZT = !near;
          const q = this.tablePos(I, tb, k); if (q.p <= 0) return;
          tb.pats.forEach((pt, pi) => {
            const hi = k * 2 + pi, pa = (rm ? 1 : sat((I.clk - 1800 - hi * 140) / 320)) * this.vanishA(I, order++);
            if (pa <= 0) return;
            const lk = this.look(I, hi, 6), sl = this.solo(I, hi), cxp = q.x + pt.dx, dirIn = cxp < W / 2 ? 1 : -1;
            /* a patron the reader tapped turns further than the group stare does, so the look reads from behind */
            const hd = patron(cxp, tb.y, pt.s, { hood: pt.hood, dz: pa < 1 ? pa : null, side: tb.from, turn: pt.back && sl.turn ? dirIn * 2 : pt.back && lk.turn ? dirIn : 0 });
            d.heads[hi] = { x: hd.ex, y: hd.ey, s: pt.s, a: pa, i: hi, open: Math.max(lk.open, sl.open), solo: sl.open, box: hd.box };
          });
          const ta = this.vanishA(I, order++);
          if (ta > 0) {
            const sc = tb.pats[0].back ? tb.pats[0].s / 1.6 : 1.3 * G.k;
            tableAt(q.x, tb.y, tb.w, sc, ta < 1 ? ta : null);
            if (ta >= 1) { const lift = k === 0 && T - d.toast < 1400 && !rm ? 2 : 0; mug(q.x + 3, tb.y, lift); mug(q.x + tb.w - 6, tb.y, lift); }
          }
          ZT = false;
        });
        ZT = false;
      },
      mid(I) { I.d.heads = []; this.drawTables(I, 'back'); },
      front(I) { this.drawTables(I, 'front'); },
      light(I) {
        const d = I.d, k = G.k, la = amt(I, 300, 600, 600, 500);
        /* the candles' sconces take lantern frames: a cap, two bars, a base ring, fading in (Jan: no chains, no drop) */
        if (la > 0) for (const [cx, cy] of G.cand) {
          const dz = la < 1 ? la : null, top = cy - Math.round(9 * k), fr = [70, 50, 30];
          rect(cx - 2, top, 5, 1, fr, undefined, dz); px(cx, top - 1, fr); rect(cx - 2, cy, 5, 1, fr, undefined, dz);
          for (let y = top + 1; y < cy; y++) { if (bay(cx - 2, y) <= la) px(cx - 2, y, fr); if (bay(cx + 2, y) <= la) px(cx + 2, y, fr); }
          glow(cx, cy - 4, 10 * k, [255, 179, 90], 0.14 * la);
        }
        /* pipe smoke hanging under the ceiling: a slow wave through it, blended smoothly (no dither grid), thinning
           toward head height */
        const ha = amt(I, 0, 1000, 300, 900);
        if (ha > 0) {
          const yb = Math.floor(H * 0.35), tt = rm ? 0 : T / 3000, sa = G.fa, ca = G.fb;
          for (let x = 0; x < W; x++) { sa[x] = Math.sin(x * 0.07 + tt); ca[x] = Math.cos(x * 0.07 + tt); }
          for (let y = 0; y < yb; y++) {
            const sb = Math.sin(y * 0.2), cb = Math.cos(y * 0.2), fall = 1 - Math.pow(y / yb, 2), a0 = 0.075 * ha * fall;
            for (let x = 0, i = (y * W) << 2; x < W; x++, i += 4) {
              const a = a0 * (0.35 + 0.65 * (0.5 + 0.5 * (sa[x] * cb + ca[x] * sb)));
              D[i] += (138 - D[i]) * a; D[i + 1] += (122 - D[i + 1]) * a; D[i + 2] += (104 - D[i + 2]) * a;
            }
          }
        }
        /* their eyes; caught with a coin, every one of them burns red and cools back over the last 300 ms */
        const re = T - d.eyesRed, red = re < 1100, rk = re < 800 || rm ? 1 : 1 - (re - 800) / 300;
        for (const hd of d.heads) {
          if (!hd || hd.a <= 0) continue;
          const open = red ? Math.max(rk, hd.open) : hd.open; if (open <= 0) continue;
          const sp = Math.max(1, Math.round(hd.s)), col = red ? C.red : C.pa;
          px(hd.x - sp, hd.y, col, open * hd.a); px(hd.x + sp, hd.y, col, open * hd.a);
          if (red) { glow(hd.x - sp, hd.y, 3, C.red, 0.4 * rk); glow(hd.x + sp, hd.y, 3, C.red, 0.4 * rk); }
          /* a tapped patron's eyes catch the candlelight, so the reader sees which one is looking */
          else if (hd.solo > 0) { glow(hd.x - sp, hd.y, 3, C.pa, 0.32 * hd.solo * hd.a); glow(hd.x + sp, hd.y, 3, C.pa, 0.32 * hd.solo * hd.a); }
        }
        /* the coins glint while nobody is looking */
        if (I.tx == null && I.settled) G.tables.forEach((tb, n) => {
          const got = d.coins[n]; const q = this.tablePos(I, tb, n), dx = q.x - tb.x, [cx, cy] = tb.coin;
          if (got) { const e = T - got; if (e < 500) glow(cx + dx, cy - e / 60, 3 * k, C.br4, 0.5 * (1 - e / 500)); return; }
          px(cx + dx, cy, C.br4); px(cx + dx + 1, cy, C.br3);
          /* a glint that swells and settles (never a blink), each coin on its own beat */
          const gp = ((T + n * 800) % 2600) / 2600, gk = !d.stare && !rm && gp < 0.24 ? Math.sin(gp / 0.24 * Math.PI) : 0;
          if (gk > 0.02) { add(cx + dx, cy - 1, C.hw, 0.9 * gk); glow(cx + dx, cy, 3, C.br4, 0.4 * gk); }
        });
        if (I.tx != null) for (const hd of d.heads) { if (hd && hd.a < 1 && hd.a > 0) for (let m = 0; m < 6; m++) px(hd.x + (hsh(m, hd.i) - 0.5) * 10 * (1 - hd.a), hd.y + 4 - (1 - hd.a) * 8 * hsh(hd.i, m), [230, 226, 216], hd.a * 0.8); }
      },
      spots(I, out) {
        if (I.tx != null || !I.settled) return;
        const d = I.d, k = G.k;
        if (!d.stare) G.tables.forEach((tb, n) => {
          if (d.coins[n]) return; const q = this.tablePos(I, tb, n), dx = q.x - tb.x, [cx, cy] = tb.coin;
          out.push({ id: 'jb-coin-' + n, x: cx + dx - 4, y: cy - 5, w: 9, h: 8, label: 'A coin on the table' });
        });
        /* the back table is its board, its mugs and its legs (the two regulars above it are their own spots) */
        const bt = G.tables[0], q = this.tablePos(I, bt, 0);
        out.push({ id: 'jb-table', x: q.x, y: bt.y - 4, w: bt.w, h: 6 + Math.round(9 * 1.3 * k), label: 'The back table' });
        /* every regular, on their own outline; the page's CSS keeps a coin over them, and the back table's board too */
        for (const hd of d.heads) {
          if (!hd || !hd.box || hd.a < 0.5) continue;
          const [x0, y0, x1, y1] = hd.box;
          out.push({ id: 'jb-patron-' + hd.i, x: x0, y: y0 - 1, w: x1 - x0, h: y1 - y0 + 1, label: 'A patron' });
        }
      },
      act: {
        /* a second tap while that one still looks keeps them looking for 5 s from the new tap */
        'patron-look'(I, v) {
          const i = clamp((v && v.i) | 0, 0, 5), e = I.clk, L = I.d.looks[i];
          if (L && e < L.t1) L.t1 = e + 5000;
          else I.d.looks[i] = { t0: e, t1: e + 5000, shut: false };
        },
        coin(I, v) { const i = clamp((v && v.i) | 0, 0, 2); if (!I.d.coins[i]) I.d.coins[i] = T; },
        'coins-reset'(I) { I.d.coins = [0, 0, 0]; },
        'eyes-red'(I) { I.d.eyesRed = T; later(1150, poke); },
        toast(I) { I.d.toast = T; }
      }
    };

    /* -- Blackwater Pressure: the room floods to the cornice, like the Quest's memory; the candles go out as it climbs;
       light comes down in shafts, kelp at the bookcases' feet, books drift, and a notebook comes down the moon's light -- */
    TH.flood = {
      enter(I) { I.d = { wl: G ? G.H + 2 : 999, drift: { n: 0, t: -1e9 }, flash: -1e9 }; },
      beats: [
        [4000, (I, q) => { if (!q) cue('flooded'); }],
        [4600, (I, q) => { if (!q) cue('book-up'); }]
      ],
      exit(I, quick) { if (!quick) later(2700, () => cue('drained')); },
      /* kelp at the bookcases' feet: a stalk that sways more toward its tip, leaves off alternate sides, a paler tip.
         It grows at the back of the room, so Zhaunil, the chair and the furniture stand in front of it: drawn here
         through the depth test, each pixel noted (index, the colour left there, its kelp colour) for seen() and light() */
      back(I) {
        const ka = amt(I, 2500, 2000, 0, 600), k = G.k, L = I.d.kelp || (I.d.kelp = []);
        L.length = 0; if (ka <= 0) return;
        const put = (x, y, c) => {
          x = Math.round(x); y = Math.round(y); if (x < 0 || y < 0 || x >= W || y >= H) return;
          const q = y * W + x; if (Z && Z[q] > ZBACK) return;
          px(x, y, KELP[c]); L.push(q, pk(KELP[c]), c);
        };
        G.posts.forEach((kx, n) => {
          for (const [ox, hk] of [[-1, 1], [2, 0.7]]) {
            const hgt = Math.round(28 * k * ka * hk);
            for (let j = 0; j < hgt; j++) {
              const x = kx + ox + (rm ? 0 : Math.sin(T / 800 + j * 0.25 + n + ox) * j * 0.12), y = G.fl - j;
              put(x, y, j > hgt - 3 ? 2 : 0);
              if (j > 2 && j % 4 === (n + ox + 8) % 4) { const sd = (j >> 2) % 2 ? 1 : -1; put(x + sd, y, 1); put(x + sd * 2, y - 1, j > hgt - 6 ? 2 : 1); }
            }
          }
        });
      },
      seen(I) {
        const L = I.d.kelp; if (!L) return;
        for (let q = 0; q < L.length; q += 3) { const i = L[q]; if (i >= 0 && (U32[i] & 0xffffff) !== L[q + 1]) L[q] = -1; }
      },
      level(I) {
        const top = G.waterTop;
        let p = eio(sat((I.clk - 400) / 3600));
        if (I.tx != null) p *= 1 - eio(sat((T - I.tx - 300) / 2400));
        return lerp(H + 2, top, p);
      },
      tick(I) {
        if (!G || !G.wide || I.tx != null) return;
        /* the air goes cold as the water climbs: the candles gutter out one by one, lowest first */
        const wl = this.level(I), p = (H + 2 - wl) / (H + 2 - G.waterTop), quiet = !!I.quick;
        G.cand.map((c, i) => [i, c[1]]).sort((a, b) => b[1] - a[1]).forEach(([i], n) => { if (p > 0.45 + n * 0.14 && st.mc[i]) setCand(i, false, quiet); });
      },
      /* the room as it stood just before the painter's dark (its 'grade' point comes right before it), so the water can
         give some of that dark back */
      grade() {
        if (!G.pre || G.pre.length !== U32.length) G.pre = new Uint32Array(U32.length);
        G.pre.set(U32);
      },
      /* with every candle out the painter's dark goes all the way; under the flood FLOOD_LIFT of it comes back (Jan,
         2026-10-07: "the darkened opacity is too unseeable"), easing off as the water drains and the candles relight.
         Only toward the copy: a flame or anything else brighter than the room before the dark stays as it is */
      lift(I) {
        const P = G.pre; if (!P || P.length !== U32.length) return;
        const a = FLOOD_LIFT * (I.tx == null ? 1 : 1 - sat((T - I.tx) / 2600)), LQ = Math.round(a * 256);
        if (LQ <= 0) return;
        const U = U32, n = U.length;
        for (let q = 0; q < n; q++) {
          const c = U[q], p = P[q]; if (c === p) continue;
          let r = c & 255, g = (c >>> 8) & 255, b = (c >>> 16) & 255;
          const pr = p & 255, pg = (p >>> 8) & 255, pb = (p >>> 16) & 255;
          if (pr > r) r += ((pr - r) * LQ) >> 8; if (pg > g) g += ((pg - g) * LQ) >> 8; if (pb > b) b += ((pb - b) * LQ) >> 8;
          U[q] = (0xff000000 | (b << 16) | (g << 8) | r) >>> 0;
        }
      },
      water(I) {
        this.lift(I);
        const wl = this.level(I); I.d.wl = wl;
        if (wl >= H) return;
        /* the one full-screen pass, after the dark (as the pitch laid it over the finished room): every pixel under the
           surface mapped through the ramp by its brightness, some of its own colour kept, rows wobbling sideways,
           caustics (row and column tables, so no trig per pixel). Jan (2026-10-07) wanted more of the library through
           the water: more of each pixel's own colour is kept (was 0.4, halving with depth, at 0.7/0.75/0.85) and the
           deep dims less (was 0.4) */
        /* the caustics: thin bright lines where three slow waves crossing the room sum to nothing (their zero lines make
           a loose, moving net, never a grid), each bright at its heart and fading to its edge, broken into short wobbly
           segments by a fourth slow wave and the water's own sway. Light through water: strongest just under the surface
           and in a pool on the floor under the window, faint through the middle of the room (and so over Zhaunil and the
           owl), a third as strong on what stands in front of the walls (the critics, 2026-10-10: it read as wire mesh
           laid over the art). Each wave is sin(ax + by + c), split into column and row tables */
        const t = T / 1000, y0 = Math.max(0, Math.floor(wl)), RB = G.row, U = U32, k = G.k;
        const CW = G.cw || (G.cw = [0, 1, 2, 3, 4, 5, 6, 7].map(() => new Float32Array(W)));
        const WA = [[0.2 / k, 0.13 / k, 0.9, 0], [-0.16 / k, 0.22 / k, 1.1, 1.7], [0.07 / k, -0.3 / k, 0.7, 4.1], [0.34 / k, 0.2 / k, 0.5, 2.3]], WG = [1, 1, 0.7, 1];
        for (let n = 0; n < 4; n++) { const a = WA[n][0], sA = CW[n * 2], cA2 = CW[n * 2 + 1]; for (let x = 0; x < W; x++) { sA[x] = Math.sin(a * x) * WG[n]; cA2[x] = Math.cos(a * x) * WG[n]; } }
        const s0 = CW[0], c0 = CW[1], s1 = CW[2], c1 = CW[3], s2 = CW[4], c2 = CW[5], s3 = CW[6], c3 = CW[7], thr = 0.14;
        const PX = G.cpx || (G.cpx = Float32Array.from({ length: W }, (_, x) => Math.exp(-Math.pow((x - G.win.cx) / (G.win.w * 1.3), 2))));
        for (let y = y0; y < H; y++) {
          const f = (y - wl) / (H - wl + 1), off = rm ? 0 : Math.round(Math.sin(y * 0.33 + t * 1.8) * 0.9), keep2 = 0.58 * (1 - 0.4 * f);
          const dimQ = Math.round((1 - 0.22 * f) * 256), ikQ = Math.round((1 - keep2) * 256), krQ = Math.round(keep2 * 0.8 * 256), kgQ = Math.round(keep2 * 0.86 * 256), kbQ = Math.round(keep2 * 0.94 * 256);
          const b0 = WA[0][1] * y + WA[0][2] * t + WA[0][3], b1 = WA[1][1] * y + WA[1][2] * t + WA[1][3], b2 = WA[2][1] * y + WA[2][2] * t + WA[2][3], b3 = WA[3][1] * y + WA[3][2] * t + WA[3][3];
          const cb0 = Math.cos(b0), sb0 = Math.sin(b0), cb1 = Math.cos(b1), sb1 = Math.sin(b1), cb2 = Math.cos(b2), sb2 = Math.sin(b2), cb3 = Math.cos(b3), sb3 = Math.sin(b3), base = y * W;
          const lS = 0.12 + 0.88 * Math.pow(1 - f, 1.8), lF = y > G.fl ? 0.95 * sat((y - G.fl) / (8 * k)) : 0;
          RB.set(U.subarray(base, base + W));
          for (let x = 0; x < W; x++) {
            let sx = x + off; if (sx < 0) sx = 0; else if (sx >= W) sx = W - 1;
            const c = RB[sx], r = c & 255, g = (c >>> 8) & 255, b = (c >>> 16) & 255;
            const q = (((77 * r + 151 * g + 28 * b) * dimQ) >> 16) * 3;
            let nr = (RAMP[q] * ikQ + r * krQ) >> 8, ng = (RAMP[q + 1] * ikQ + g * kgQ) >> 8, nb = (RAMP[q + 2] * ikQ + b * kbQ) >> 8;
            if (!rm) {
              const wv = s0[sx] * cb0 + c0[sx] * sb0 + s1[sx] * cb1 + c1[sx] * sb1 + s2[sx] * cb2 + c2[sx] * sb2, aw = wv < 0 ? -wv : wv;
              if (aw < thr) {
                const e = aw / thr; let li = (lS + lF * PX[x]) * (1 - e * e) * sat((s3[sx] * cb3 + c3[sx] * sb3 + 0.4) * 2);
                if (Z && Z[base + x] > ZBACK) li *= 0.33;
                if (li > 0.03) { nr += 34 * li; ng += 62 * li; nb += 56 * li; if (ng > 255) ng = 255; if (nb > 255) nb = 255; if (nr > 255) nr = 255; nr |= 0; ng |= 0; nb |= 0; }
              }
            }
            U[base + x] = (0xff000000 | (nb << 16) | (ng << 8) | nr) >>> 0;
          }
        }
      },
      light(I) {
        const d = I.d, wl = d.wl, k = G.k; if (wl >= H) return;
        const yl = Math.round(wl);
        /* the surface, and the light on it: sparse glints that each swell and fade on their own slow beat (no marching
           sparkle along the line) */
        for (let x = 0; x < W; x++) {
          const wv = rm ? 0 : Math.round(Math.sin(x * 0.4 + T / 300)); px(x, yl + wv, [207, 238, 232], 0.75);
          const h1 = hsh(x, 77); if (h1 < 0.86) continue;
          const g = rm ? (h1 > 0.95 ? 0.5 : 0) : Math.pow(Math.max(0, Math.sin(T / (700 + h1 * 500) + h1 * 40)), 6);
          if (g > 0.02) add(x, yl + wv, C.hw, 0.85 * g);
        }
        /* light shafts */
        const sa = amt(I, 2500, 2000, 0, 800);
        if (sa > 0) for (let q = 0; q < G.shafts; q++) { const x0 = W * (0.1 + 0.8 * q / G.shafts) + (rm ? 0 : Math.sin(T / 3000 + q) * 4); for (let y = yl + 2; y < H; y++) { const x = x0 + (y - yl) * 0.35, a = 0.05 * sa * (1 - (y - yl) / (H - yl)); for (let w = 0; w < 3; w++) add(x + w, y, C.teal, a); } }
        /* the kelp, drawn at the back (back()), takes its green again over the water where it still shows */
        const KL = I.d.kelp;
        if (KL) for (let q = 0; q < KL.length; q += 3) { const i = KL[q]; if (i < 0) continue; px(i % W, (i / W) | 0, KELP[KL[q + 2]], 0.85); }
        /* bubbles */
        for (let q = 0; q < G.bubN; q++) { const per = 4000 + hsh(q, 9) * 4000, ph = rm ? hsh(q, 8) : ((T + q * 911) % per) / per, x = hsh(q, 3) * W + Math.sin(ph * 10 + q) * 2, y = H - ph * (H - yl); if (y > yl + 1) px(x, y, [191, 233, 226], 0.7); }
        /* drifting books; the middle one is drowned, and turns as it goes */
        const ba = amt(I, 3000, 1500, 0, 900);
        if (ba > 0) G.books.forEach((bk, q) => {
          const p = this.bookAt(I, q);
          if (q === 0) { this.drowned(I, p[0], p[1], ba); return; }
          rect(p[0], p[1], 5, 3, q % 2 ? [120, 40, 40] : [40, 60, 110], ba); rect(p[0], p[1], 5, 1, [200, 190, 160], ba);
        });
        /* the notebook comes down the moon's light and hangs there */
        const [nx, ny, nw, nh] = G.notebook, np = (rm ? 1 : sat((I.clk - 4600) / 2000)) * (I.tx == null ? 1 : 1 - sat((T - I.tx) / 600));
        if (np > 0) {
          const by = lerp(ny - 30 * k, ny, eout(np)) + (rm ? 0 : Math.sin(T / 900) * 1.5), a = np, fl = T - d.flash < 900 ? 1 - (T - d.flash) / 900 : 0;
          rect(nx, by, nw, nh, [60, 74, 82], a); rect(nx + 1, by + 1, Math.floor(nw / 2) - 1, nh - 2, [217, 228, 234], a); rect(nx + Math.ceil(nw / 2), by + 1, Math.floor(nw / 2) - 1, nh - 2, [205, 218, 226], a);
          for (let l = 3; l < nh - 2; l += 2) { rect(nx + 2, by + l, Math.floor(nw / 2) - 3, 1, [150, 164, 174], a * 0.7); rect(nx + Math.ceil(nw / 2) + 1, by + l, Math.floor(nw / 2) - 3, 1, [150, 164, 174], a * 0.7); }
          glow(nx + nw / 2, by + nh / 2, nw * 1.1, [217, 228, 234], (0.28 * (rm ? 1 : 0.8 + 0.2 * Math.sin(T / 500)) + 0.4 * fl) * a);
          d.bookY = by;
          if (np >= 1 && I.tx == null && !kept.book) tapMe(nx + nw / 2, by, [217, 240, 236], 4);
        }
      },
      bookAt(I, q) {
        const b = G.books[q], t = rm ? 0 : T;
        return [b[0] + Math.sin(t / 2400 + q) * 10 * G.k, b[1] + Math.sin(t / 1800 + q * 2) * 4 * G.k];
      },
      drowned(I, x, y, a) {
        /* a book seen turning end over end: its cover narrows to its spine and back, the pages show edge-on; a tap
           spins it, and at the third it falls open with a violet glow */
        const dr = I.d.drift, e = T - dr.t, spin = e < 900 ? 3.2 : 1, ph = rm ? 0.3 : ((T / 1000) * 0.55 * spin + (e < 900 ? e / 300 : 0)) % 1;
        const k = G.k, w = Math.max(1, Math.round(7 * k * Math.abs(Math.cos(ph * Math.PI)))), h = Math.round(4 * k), cx = Math.round(x + 3 * k);
        if (dr.n >= 3) {
          rect(cx - Math.round(5 * k), y, Math.round(5 * k), h, [217, 210, 236], a); rect(cx, y, Math.round(5 * k), h, [200, 192, 226], a); px(cx, y + h, [60, 40, 90], a);
          glow(cx, y + h / 2, 10 * k, [170, 120, 255], 0.35 * a * (rm ? 1 : 0.8 + 0.2 * Math.sin(T / 400)));
          return;
        }
        rect(cx - Math.floor(w / 2), y, w, h, [70, 46, 110], a); rect(cx - Math.floor(w / 2), y, w, 1, [140, 110, 190], a);
        if (w <= 2) rect(cx - 1, y, 3, h, [210, 200, 170], a);
        if (dr.n > 0) glow(cx, y + h / 2, 6 * k, [150, 110, 240], 0.12 * dr.n * a);
      },
      spots(I, out) {
        if (I.tx != null) return;
        const k = G.k;
        if (I.clk >= 6600) { const [nx, , nw, nh] = G.notebook; out.push({ id: 'jb-book', x: nx - 3, y: (I.d.bookY || G.notebook[1]) - 3, w: nw + 6, h: nh + 6, label: 'The floating book' }); }
        if (I.clk >= 4500) { const p = this.bookAt(I, 0); out.push({ id: 'jb-drift', x: Math.round(p[0] / 3) * 3 - 3, y: Math.round(p[1] / 3) * 3 - 4, w: Math.round(13 * k), h: Math.round(11 * k), label: 'A drowned book' }); }
      },
      act: {
        'book-open'(I) { keep('book'); I.d.flash = T; },
        drift(I, v) { const n = (v && v.n) | 0; I.d.drift = { n, t: T }; }
      }
    };

    /* -- Ash in the Alehouse: the candles die from the door toward the jukebox, cloud over the moon, ash falls, the crystal
       is the only light; cold under the door at 10 s, three knocks at 16 s, the door at 22 s, and the Iron Matron walks
       in, a step every 1.1 s, behind the easel, to stand in the shadows. Her eyes shut for 3.6 s of every 10; a second
       after they shut a thorn glints behind her (a dark sprig with a cold sheen sliding along it, a body's width to her side,
       never where her eyes were) and it is gone before they open; her eyes close where they are. Her clock stops while an overlay is open -- */
    const ASH_CANDLE = (n) => [400 + n * 800, (I, q) => { const ord = candOrder(G && G.D ? G.D.cx : 1e9); if (ord[n] != null) setCand(ord[n], false, q); }];
    TH.ash = {
      enter(I) { I.d = { door: null, post: null, gone: null, face: -1e9, thorn: false, blink: false, glint: 0, knockT: -1e9, said: false, m: null, vis: null }; },
      beats: [
        ASH_CANDLE(0), ASH_CANDLE(1), ASH_CANDLE(2), ASH_CANDLE(3),
        [16000, (I, q) => { if (!q) { I.d.knockT = T; cue('knock', { n: 1 }); } }],
        [16700, (I, q) => { if (!q) { I.d.knockT = T; cue('knock', { n: 2 }); } }],
        [17400, (I, q) => { if (!q) { I.d.knockT = T; cue('knock', { n: 3 }); } }],
        [22000, (I, q) => { I.d.door = q ? -1e9 : T; if (!q) { door(); cue('door-open'); } }],
        [30600, (I, q) => { I.d.post = 30600; if (!q) cue('matron-posted'); }]
      ],
      tick(I) {
        const d = I.d, blink = this.shut(I) >= 0, gl = this.glintA(I) >= 0.5 ? 1 : 0;
        if (blink !== d.blink) { d.blink = blink; poke(); }
        if (gl !== d.glint) { d.glint = gl; poke(); }
        if (d.gone != null && !d.said && T - d.gone > 900) { d.said = true; cue('vanished', { rec: 'ash' }); }
      },
      /* ms since her eyes shut, or -1 while they are open (or before she has taken her post) */
      shut(I) { const d = I.d; if (d.post == null || d.gone != null) return -1; const e = ((I.clk - d.post) % MAT_P) - MAT_OPEN; return e >= 0 ? e : -1; },
      /* the thorn's glint, 0..1: GL_IN after her eyes shut it fades in, and it is gone GL_END before they open; never while
         she is being faced (her eyes flare open) or once it is taken. Reduced motion: there or not, no fade */
      glintA(I) {
        const d = I.d; if (d.thorn || I.tx != null || T - d.face < 800) return 0;
        const e = this.shut(I); if (e < 0) return 0;
        const end = MAT_P - MAT_OPEN - GL_END;
        if (rm) return e >= GL_IN && e < end - GL_OUT / 2 ? 1 : 0;
        return eio(sat((e - GL_IN) / GL_FADE)) * (1 - eio(sat((e - (end - GL_OUT)) / GL_OUT)));
      },
      /* where it lies: behind her, at the foot of the bookcase, a full body's width to her side (the lectern's), so it is
         never under her face and never where her eyes were */
      glintAt(I) {
        const a = this.glintA(I); if (a <= 0) return null;
        const f = this.fig(I); if (!f) return null;
        return { a: a * f.a, x: Math.round(f.x - 12.5 * f.u), y: Math.round(f.fy - 1.2 * G.k) };
      },
      fig(I) {
        const d = I.d, e = I.clk, Dd = G.D, u = G.matU; if (d.door == null) return null;
        const s = e - 22000; if (s < 0) return null;
        let x, fy, a = 1;
        if (d.post != null || rm) { x = G.matron[0]; fy = G.matron[1]; }
        else if (s < 2000) { x = Dd.cx; fy = G.fl + 1; a = sat(s / 700); }
        else { const p = sat((s - 2000) / 6600), step = Math.floor(p * 6), sp = p * 6 - step, pp = (step + eio(sp)) / 6; x = lerp(Dd.cx, G.matron[0], pp); fy = lerp(G.fl + 1, G.matron[1], pp); }
        if (I.tx != null) a *= 1 - sat((T - I.tx) / 900);
        if (d.gone != null) { a *= 1 - sat((T - d.gone) / 900); if (a <= 0) return null; }
        return { x, fy, u, a, sway: rm ? 0 : Math.round(Math.sin(T / 3000)) };
      },
      /* her shape goes in at the painter's 'behind' point (before the easel's brush, the lectern's flame and the things on
         the tables), or at 'mid' when the painter has no such point */
      body(I) {
        const f = this.fig(I); if (!f) { I.d.m = null; return; }
        const m = matronFig(f.x, f.fy, f.u, { a: f.a < 1 ? eio(f.a) : null, sway: f.sway, vis: I.d.vis, cw: I.d.cw });
        m.a = f.a; I.d.vis = m.vis; I.d.cw = m.cw; I.d.m = m;
      },
      behind(I) { this.body(I); },
      mid(I) { if (bhd !== fno) this.body(I); },
      seen(I) { if (I.d.m) seenMatron(I.d.m); },
      grade(I) {
        /* the cloud over the moon (the painter's live moon when it gives one, as the moon crosses the window) */
        const [mx, my, mr] = moonNow(), cp = sat((I.clk - 1000) / 2000) * (I.tx == null ? 1 : 1 - sat((T - I.tx) / 1200));
        if (cp > 0) darkDisc(mx + (1 - cp) * -14 * G.k, my, Math.max(7, mr * 2.1), 1 - 0.7 * cp);
        /* the door's warm light runs cold once it opens */
        if (I.d.door != null && I.tx == null) {
          const Dd = G.D, x0 = Math.max(0, Dd.x0 - 6), x1 = Math.min(W, Dd.x1 + 6), y1 = Math.min(H, G.fl + Math.round(36 * G.k));
          for (let y = Math.max(0, Dd.top - 2); y < y1; y++) for (let x = x0, i = (y * W + x0) << 2; x < x1; x++, i += 4) {
            const r = D[i], g = D[i + 1], b = D[i + 2]; if (r <= b + 6) continue;
            const L = 0.3 * r + 0.59 * g + 0.11 * b; D[i] = L * 0.62; D[i + 1] = L * 0.74; D[i + 2] = Math.min(255, L * 0.98 + 8);
          }
        }
      },
      vig(I) {
        const a = amt(I, 1000, 3000, 0, 1600); if (a <= 0) return 0;
        return lerp(0.55, 0.85, sat((I.clk - 2000) / 4000)) * a;
      },
      light(I) {
        const d = I.d, k = G.k, a = amt(I, 3000, 800, 0, 900), e = I.clk;
        /* the crystal: the only light in here */
        const crys = F.get('lbCrys');
        if (a > 0 && crys) { const br = rm ? 1 : 0.75 + 0.25 * Math.sin(T / 700); glow(crys[0], crys[1], 34 * k, [127, 179, 255], 0.22 * a * br); add(crys[0], crys[1], [170, 210, 255], 0.6 * a); }
        /* ash */
        const fa = amt(I, 2000, 2000, 0, 800);
        if (fa > 0) for (let q = 0; q < G.ashN; q++) { const per = 9000 + hsh(q, 4) * 6000, ph = rm ? hsh(q, 5) : ((T + q * 1337) % per) / per; px(hsh(q, 6) * W + Math.sin(ph * 7 + q) * 5, ph * H, [141, 143, 150], 0.7 * fa); }
        /* the door's light gone cold, under it; it swells with each knock and settles back (no flash, and none at all
           under reduced motion, where the room draws only when something changes) */
        const Dd = G.D, dl = amt(I, 10000, 2000, 0, 800), ke = T - d.knockT, kn = rm || ke < 0 || ke >= 700 ? 0 : ke < 60 ? ke / 60 : 1 - eout((ke - 60) / 640);
        if (dl > 0) for (let x = Dd.x0; x < Dd.x1; x++) add(x, G.fl - 1, [120, 150, 200], (0.4 + 0.4 * kn) * dl);
        if (kn > 0) glow(Dd.cx, G.fl - 2, 10 * k, C.cold, 0.18 * kn);
        /* the cold through the door as it opens, easing in and out */
        const de = T - d.door;
        if (d.door != null && d.door > 0 && de < 3400) glow(Dd.cx, Dd.top + (G.fl - Dd.top) * 0.7, Dd.half * 2.4, C.cold, 0.16 * (de < 500 ? eio(de / 500) : 1 - eio(sat((de - 2200) / 1200))));
        /* her rim, then her eyes, red, that shut now and then; only where she shows */
        const f = this.fig(I), m = d.m;
        if (f && m) {
          rimMatron(m);
          /* her eyes close where they are (the glow narrowing over 0.16 s to a dim red slit that stays) and open again
             over 0.2 s, so they are always seen to shut, never to go anywhere */
          const flare = T - d.face < 800 ? 1 - (T - d.face) / 800 : 0, sp = Math.max(1, Math.round(f.u)), ey = m.ey, sh = this.shut(I);
          let ek = 1;
          if (sh >= 0) { const left = MAT_P - MAT_OPEN - sh; ek = rm ? 0 : Math.max(sat(1 - sh / 160), sat(1 - left / 200)); }
          ek = Math.max(ek, flare);
          for (const ex of [m.ex - sp, m.ex + sp]) {
            if (!seenAt(m, ex, ey)) continue;
            if (ek < 1) px(ex, ey, [96, 18, 20], 0.75 * f.a * (1 - ek));
            if (ek > 0) { px(ex, ey, C.red, f.a * ek); glow(ex, ey, (2 + 1.6 * ek) * k + flare * 3 * k, C.red, (0.35 + 0.4 * flare) * f.a * ek); }
          }
        }
        /* while her eyes are shut, a thorn glints behind her, a body's width to her side */
        const gl = this.glintAt(I);
        if (gl) thorn(gl.x, gl.y, gl.a);
        /* once she's gone: ice where she stood, and a glint in it that breathes */
        if (d.gone != null) {
          const ia = sat((T - d.gone) / 900), [mx, my] = G.matron;
          ell(mx, my, 9 * k * ia, 2.2 * k * ia, [170, 200, 230], 0.55 * ia);
          const tw = rm ? 0.7 : 0.5 + 0.5 * Math.sin((T - d.gone) / 650 - 1.6);
          if (ia > 0.6) sparkle(Math.round(mx + 2 * k), Math.round(my - 1), (0.3 + 0.6 * tw * tw) * sat((ia - 0.6) / 0.4));
        }
        void e;
      },
      spots(I, out) {
        const f = this.fig(I), d = I.d; if (!f || d.post == null || I.tx != null || d.gone != null) return;
        out.push({ id: 'jb-matron', x: f.x - 8 * f.u, y: f.fy - 42 * f.u, w: 16 * f.u, h: 42 * f.u, label: 'The shape in the shadows' });
        const gl = this.glintAt(I);
        if (gl && gl.a >= 0.5) out.push({ id: 'jb-thorn', x: gl.x - 6, y: gl.y - 6, w: 13, h: 13, label: 'Something glinting at her feet' });
      },
      act: {
        face(I) { I.d.face = T; },
        gone(I) { if (I.d.gone == null) I.d.gone = T; },
        'thorn-taken'(I) { I.d.thorn = true; }
      }
    };

    /* ================================================================ the passes ================================================================ */
    /* every record's colour in one pass over the room, with the cold's vignette folded in (channel tables; a sweep is
       one amount per row or column). It reads and writes whole pixels (the painter's Uint32 buffer) */
    function gradePass() {
      const list = [];
      let vigA = 0;
      for (const I of st.insts) {
        if (I.id === 'ash') vigA = Math.max(vigA, TH.ash.vig(I));
        const g = GR[I.id]; if (!g) continue;
        const dd = DUR[I.id], k = I.tx == null ? 1 : 1 - sat((T - I.tx - (I.id === 'flood' ? 700 : 300)) / dd[1]), p = sat(I.clk / Math.max(1, dd[0]));
        if (k <= 0 || p <= 0) continue;
        const it = { L: GLUT[I.id], dir: g.dir === '-y' ? 1 : g.dir === 'x' ? 2 : 0, A: null, s: 0, y1: H };
        /* the flood's water remaps everything under its surface itself: its colour only needs the rows above */
        if (I.id === 'flood' && I.tx == null) it.y1 = clamp(Math.ceil(TH.flood.level(I)) + 2, 0, H);
        if (it.dir === 1) { it.A = G.gy; for (let y = 0; y < H; y++) it.A[y] = Math.round(256 * eio(sat((p * 1.4 - (1 - y / H)) / 0.4)) * k); }
        else if (it.dir === 2) { it.A = G.gx; for (let x = 0; x < W; x++) it.A[x] = Math.round(256 * eio(sat((p * 1.4 - x / W) / 0.4)) * k); }
        else it.s = Math.round(256 * eio(p) * k);
        if (!it.A && it.s <= 0) continue;
        list.push(it);
      }
      const vq = Math.round(vigA * 256), M = G.vig, n = list.length, U = U32;
      if (!n && vq <= 0) return;
      /* the common frame: one record's colour, no sweep, no cold */
      if (n === 1 && list[0].dir === 0 && vq <= 0) {
        const it = list[0], L = it.L, aH = it.s, aL = (it.s * 90) >> 8, end = it.y1 * W;
        for (let q = 0; q < end; q++) {
          const c = U[q], r = c & 255, g = (c >>> 8) & 255, b = (c >>> 16) & 255, ap = (77 * r + 151 * g + 28 * b) > 51200 ? aL : aH;
          let nr = r + ((((L[r] + L[256 + g] + L[512 + b]) >> 8) - r) * ap >> 8), ng = g + ((((L[768 + r] + L[1024 + g] + L[1280 + b]) >> 8) - g) * ap >> 8), nb = b + ((((L[1536 + r] + L[1792 + g] + L[2048 + b]) >> 8) - b) * ap >> 8);
          nr = nr < 0 ? 0 : nr > 255 ? 255 : nr; ng = ng < 0 ? 0 : ng > 255 ? 255 : ng; nb = nb < 0 ? 0 : nb > 255 ? 255 : nb;
          U[q] = (0xff000000 | (nb << 16) | (ng << 8) | nr) >>> 0;
        }
        return;
      }
      for (let y = 0, q = 0; y < H; y++) {
        for (let x = 0; x < W; x++, q++) {
          const c = U[q];
          let r = c & 255, g = (c >>> 8) & 255, b = (c >>> 16) & 255;
          if (n) {
            const prot = (77 * r + 151 * g + 28 * b) > 51200 ? 90 : 256;
            for (let m = 0; m < n; m++) {
              const it = list[m]; if (y >= it.y1) continue;
              const a = it.dir === 1 ? it.A[y] : it.dir === 2 ? it.A[x] : it.s;
              if (a <= 0) continue;
              const L = it.L, ap = (a * prot) >> 8;
              const gr = (L[r] + L[256 + g] + L[512 + b]) >> 8, gg = (L[768 + r] + L[1024 + g] + L[1280 + b]) >> 8, gb = (L[1536 + r] + L[1792 + g] + L[2048 + b]) >> 8;
              r += ((gr - r) * ap) >> 8; g += ((gg - g) * ap) >> 8; b += ((gb - b) * ap) >> 8;
              r = r < 0 ? 0 : r > 255 ? 255 : r; g = g < 0 ? 0 : g > 255 ? 255 : g; b = b < 0 ? 0 : b > 255 ? 255 : b;
            }
          }
          if (vq > 0) { const f = 256 - ((vq * M[q]) >> 8); r = (r * f) >> 8; g = (g * f) >> 8; b = (b * f) >> 8; }
          U[q] = (0xff000000 | (b << 16) | (g << 8) | r) >>> 0;
        }
      }
    }

    /* ================================================================ the clock ================================================================ */
    function runBeats(I, quiet) {
      const B = TH[I.id].beats; if (!B) return;
      for (let n = 0; n < B.length; n++) {
        if (I.f[n] || I.clk < B[n][0]) continue;
        I.f[n] = 1;
        try { B[n][1](I, quiet); } catch (e) { console.error(e); }
        poke();
      }
    }
    function update(t) {
      if (closed) return;
      const dt = lastU ? clamp(t - lastU, 0, 250) : 0;
      lastU = t; T = t; rm = !!RM();
      const pz = paused();
      st.insts = st.insts.filter((I) => I.tx == null || T - I.tx < EXIT[I.id] + 400);
      for (const I of st.insts) {
        const th = TH[I.id];
        if (I.tx != null) { if (th.exitTick) { try { th.exitTick(I); } catch (e) { console.error(e); } } continue; }
        if (!pz) I.clk += dt;
        runBeats(I, false);
        if (th.tick && G && G.wide) { try { th.tick(I, pz); } catch (e) { console.error(e); } }
        if (!I.settled && I.clk >= SET[I.id]) { I.settled = true; cue('settled', { rec: I.id }); poke(); }
      }
      waveTick();
      /* the jukebox's crown and its disc */
      st.crown = crownNow();
      if (!rm) st.disc += dt / 1000 * 3.6 * st.crown;
      /* Soryndel dozes through After Hours, and for ten seconds after she's been woken she stays up */
      const A = live('after'), doze = !!(A && A.settled && T - st.owlWake > 10000);
      if (doze !== st.doze) { st.doze = doze; send('lbOwlDoze', doze); }
      sendCand();
    }

    /* ================================================================ the draw ================================================================ */
    function frame(R) {
      const t = now();
      frameT0 = t; frameMs = 0; lastDraw = t;
      if (R.buf !== lastBuf) { lastBuf = R.buf; U32 = R.buf; D = new Uint8ClampedArray(R.buf.buffer, R.buf.byteOffset, R.buf.length * 4); }
      W = R.W; H = R.H; fno = (fno + 1) % 1e9; ZT = false;
      Z = R.z && R.z.length === R.buf.length ? R.z : null;
      const L = F.get('lbLay');
      if (L !== lastLay) { lastLay = L; G = geo(L); if (G && G.cand && st.mc.length !== G.cand.length) { const want = st.mc[0]; st.mc = G.cand.map((_, i) => (st.mc[i] != null ? st.mc[i] : want)); } }
      if (G && (G.W !== W || G.H !== H)) G = null;
      update(t);
    }
    function phase(fn) { const t = now(); try { fn(); } catch (e) { if (!phase.told) { phase.told = 1; console.error(e); } } ZT = false; frameMs += now() - t; }
    function each(name) { for (const I of st.insts) { const th = TH[I.id]; if (th[name]) th[name](I); } }
    function draw(ph, R) {
      if (closed) return null;
      if (ph === 'spots') return spotList();
      if (!R || !R.buf) return null;
      if (ph === 'back') { const t0 = now(); frame(R); frameMs += now() - t0; }
      if (!G || !G.wide || !D) return null;
      if (ph === 'back') phase(() => { drawJuke(); each('back'); });
      else if (ph === 'behind') { bhd = fno; phase(() => each('behind')); }
      else if (ph === 'mid') phase(() => each('mid'));
      else if (ph === 'front') phase(() => each('front'));
      else if (ph === 'grade') phase(() => { each('seen'); gradePass(); each('grade'); });
      else if (ph === 'light') phase(() => { each('water'); each('light'); lightJuke(); drawThread(); drawWave(); });
      else if (ph === 'over') {
        phase(() => { drawFlights(); each('over'); });
        cost.n++; cost.sum += frameMs; cost.last = frameMs; if (frameMs > cost.max) cost.max = frameMs;
      }
      return null;
    }
    function spotList() {
      const out = [];
      if (!G || !G.wide) return out;
      const J = G.J;
      out.push({ id: 'jb-juke', x: J.x - 1, y: J.y - 2, w: J.w + 2, h: J.h + 2, label: 'The jukebox' });
      for (const I of st.insts) { if (I.tx != null) continue; const th = TH[I.id]; if (th.spots) { try { th.spots(I, out); } catch (e) { console.error(e); } } }
      return out;
    }

    /* ================================================================ the page's calls ================================================================ */
    function setAll() {
      fset('lbMood', draw);
      fset('lbMoodCand', st.mc.slice()); st.mcSent = st.mc.map((b) => (b ? 1 : 0)).join('');
      fset('lbMoodDark', 0);
      fset('lbOwlDoze', st.doze);
    }
    const moods = {
      start(o) {
        o = o || {};
        if (closed) return;
        if (o.awake && !st.awake) { st.awake = true; st.wake0 = -1e9; st.mc = st.mc.map(() => !darkRec()); }
        st.started = true;
        setAll();
        try { if (F.ready && F.ready.then) F.ready.then(() => { if (!closed) setAll(); }); } catch (e) { /* fine */ }
        if (!timer) timer = setInterval(() => { if (!closed && now() - lastDraw > 90) update(now()); }, 100);
      },
      record(id, o) {
        o = o || {};
        if (closed || !REC[id]) return;
        T = now(); rm = !!RM();
        const quick = !!o.quick || rm, from = st.rec, old = st.insts.find((I) => I.tx == null);
        if (old && old.id === id && !o.again) return;
        if (old) {
          old.tx = quick ? T - EXIT[old.id] - 1 : T;
          try { if (TH[old.id].exit) TH[old.id].exit(old, quick); } catch (e) { console.error(e); }
        }
        st.rec = id; st.jukeRec = id; st.heard[id] = true;
        send('vistaWx', WXR[id] || 'clear');
        const I = { id, t0: T, clk: 0, tx: null, d: {}, f: {}, settled: false };
        try { if (TH[id].enter) TH[id].enter(I); } catch (e) { console.error(e); }
        st.insts.push(I);
        if (quick) { I.quick = true; I.clk = QUICK[id]; runBeats(I, true); }
        /* the candles: home relights them in one warm wave from the jukebox (after the water has gone); a road record
           that keeps its light lights any that were out; the dark rooms put them out themselves */
        if (REC[id].home) { if (st.awake) { if (quick) relightAll(0, true); else startWave(from === 'flood' ? 2200 : 600); } }
        else if (id !== 'ash' && id !== 'flood') { if (st.awake) relightAll(quick ? 0 : 150, quick); }
        if (!quick) startThread(id);
        sendCand();
        poke();
      },
      juke(action, v) {
        if (closed) return;
        T = now(); rm = !!RM();
        if (action === 'wake') {
          if (st.awake) return;
          st.awake = true; st.wake0 = T + 150;
          if (rm) { st.wake0 = -1e9; if (!darkRec()) st.mc = st.mc.map(() => true); cue('lit'); }
          else startWave(500, { slow: true });
          sendCand();
        } else if (action === 'jolt') st.jolt = T;
        else if (action === 'locked') { st.jolt = T; st.lockT = T; }
        else if (action === 'roulette') {
          const cols = (v && Array.isArray(v.cols) ? v.cols : []).filter((c) => typeof c === 'string' && /^#[0-9a-f]{6}$/i.test(c)).map(hex);
          if (cols.length && !rm) st.roul = { t0: T, cols };
        } else if (action === 'land') { st.roul = null; if (v && REC[v.id]) st.jukeRec = v.id; }
        else if (action === 'lamps') { st.heard = Object.assign({}, v && v.heard); st.gold = Object.assign({}, v && v.gold); }
        else if (action === 'keep') { st.keep = new Set(v && Array.isArray(v.items) ? v.items : []); }
        poke();
      },
      act(name, v) {
        if (closed) return;
        T = now(); rm = !!RM();
        let done = false;
        for (const I of st.insts) {
          if (I.tx != null) continue;
          const A = TH[I.id].act; if (!A || !A[name]) continue;
          try { A[name].call(TH[I.id], I, v || {}); } catch (e) { console.error(e); }
          done = true;
        }
        /* a few answers stand even with their record off (a pack opened later, the owl woken) */
        if (!done) { if (name === 'pack-done') keep('pack'); else if (name === 'book-open') keep('book'); else if (name === 'owl-wake') st.owlWake = T; }
        poke();
      },
      spots: () => spotList(),
      state() {
        const I = st.insts.find((x) => x.tx == null) || null, d = I ? I.d : {};
        return {
          rec: st.rec, settled: !!(I && I.settled),
          stare: !!(I && I.id === 'tavern' && d.stare), blink: !!(I && I.id === 'ash' && d.blink), glint: !!(I && I.id === 'ash' && d.glint),
          posted: !!(I && I.id === 'ash' && d.post != null && d.gone == null), frogAt: I && I.id === 'bog' ? d.at | 0 : 0,
          coins: I && I.id === 'tavern' ? d.coins.map(Boolean) : [false, false, false],
          looks: I && I.id === 'tavern' ? Object.keys(d.looks).filter((i) => I.clk < d.looks[i].t1).map(Number) : []
        };
      },
      on(name, fn) { if (typeof fn !== 'function') return () => {}; (fns[name] = fns[name] || []).push(fn); return () => { const a = fns[name]; const i = a ? a.indexOf(fn) : -1; if (i >= 0) a.splice(i, 1); }; },
      ink: (id) => (REC[id] || REC.quiet).ink,
      /* for checks: depth (the painter gives R.z), behind (this frame had the painter's 'behind'), clk (the playing
         record's own clock); seek(ms) puts that clock there (the beats it passes run quietly) */
      qa: () => ({
        frames: cost.n, avgMs: cost.n ? +(cost.sum / cost.n).toFixed(3) : 0, maxMs: +cost.max.toFixed(3), lastMs: +cost.last.toFixed(3),
        insts: st.insts.map((I) => I.id + (I.tx == null ? '' : '(leaving)')), cand: st.mc.slice(), awake: st.awake, grid: G ? [G.W, G.H, G.wide] : null,
        depth: !!Z, behind: bhd === fno, clk: (st.insts.find((I) => I.tx == null) || { clk: null }).clk,
        resetCost() { cost.n = 0; cost.sum = 0; cost.max = 0; },
        seek(ms) { const I = st.insts.find((x) => x.tx == null); if (!I || closed || !(ms >= 0)) return null; T = now(); I.clk = +ms; runBeats(I, true); poke(); return I.clk; }
      }),
      close() {
        if (closed) return;
        closed = true;
        clearInterval(timer); timer = 0;
        clearTimeout(cqT); cq.length = 0;
        timers.forEach((id) => clearTimeout(id)); timers.clear();
        fset('lbMood', null); fset('lbOwlDoze', false); fset('lbMoodDark', 0);
        st.insts.length = 0;
      }
    };
    return moods;
  };
})();

/* ===== src/scene-pages/pages/library/offer.js ===== */
/* The book Soryndel brings (Jan, 2026-10-28: "clicking on the bookshelfs should do something cool, maybe the owl grabs a
   random blog post to read and asks if they want to read it"). The owl lands it on the lectern; this card rises out of
   the lectern with the article's cover, its title, one line and the time it takes, and two answers: Read it or Another
   book. No typing, nothing kept but what the room already keeps.

   FFD.parts['library/offer']({ F, RM, snd, hold, cover(b, w) -> Promise<url|null>, origin() -> { x, y } | null })
     -> { show(b, { roll, tone }) -> Promise<'read' | 'another' | 'close'>, close(), busy(), destroy() }
   roll is the owl's d20 (a small die on the cover); tone 'pick' (a natural 20, Jan's pick: a gold sweep and motes) or
   'dust' (a natural 1, the dustiest book: a puff of dust). */
(() => {
  'use strict';
  const FFD = window.FFD;
  if (!FFD) return;
  FFD.parts = FFD.parts || {};
  const P = '.ffd-page--library .lbo';
  const CSS = `
${P}{position:fixed;inset:0;z-index:88;display:grid;place-items:center;padding:16px;box-sizing:border-box;color:#eadfc7;font-family:var(--f-body,'Spectral',Georgia,serif)}
${P} *,${P} *::before,${P} *::after{box-sizing:border-box}
${P} .lbo-veil{position:absolute;inset:0;background:radial-gradient(ellipse at 50% 55%,#120e0a99,#07080bd9 75%);opacity:0;transition:opacity .26s ease-out}
${P}.is-in .lbo-veil{opacity:1}
${P} .lbo-card{position:relative;width:min(400px,100%);max-height:calc(100dvh - 32px);overflow:hidden auto;overscroll-behavior:contain;border:1px solid #8f7344;border-radius:4px;background:radial-gradient(ellipse at 50% 0,#3b2c1a55,transparent 65%),#16120e;box-shadow:0 0 0 3px #0d0b09,0 0 0 4px #6e573755,0 30px 80px #000c,0 0 60px #e8b45a14;scrollbar-width:thin;scrollbar-color:#8f7344 #16120e}
${P} .lbo-cover{position:relative;overflow:hidden;background:#211a13;aspect-ratio:var(--ar,16/9)}
${P} .lbo-cover img{display:block;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .3s ease-out}
${P} .lbo-cover img.is-on{opacity:1}
${P} .lbo-cover::after{content:'';position:absolute;inset:auto 0 0;height:42%;background:linear-gradient(transparent,#16120e);pointer-events:none}
${P} .lbo-leather{position:absolute;inset:0;display:grid;place-items:center;padding:22px 34px;text-align:center;background:repeating-linear-gradient(90deg,#0000 0 5px,#ffffff05 5px 6px),radial-gradient(ellipse at 50% 40%,#5a3a22,#2a1a10 80%);box-shadow:inset 0 0 0 6px #241509,inset 0 0 0 7px #b0894f66}
${P} .lbo-leather span{color:#e8c98a;font:600 17px/1.3 var(--f-display,'Cinzel',Georgia,serif);text-shadow:0 1px #0008;text-wrap:balance}
${P} .lbo-sweep{position:absolute;inset:0;z-index:2;pointer-events:none;background:linear-gradient(105deg,transparent 35%,#fff2c855 48%,#ffe3a0aa 50%,#fff2c855 52%,transparent 65%);transform:translateX(-120%)}
${P}.is-in .lbo-sweep{animation:lbo-sweep 1.1s .38s cubic-bezier(.3,.6,.3,1) both}
${P}.is-pick .lbo-sweep{animation-duration:1.4s;animation-iteration-count:2}
${P} .lbo-die{position:absolute;z-index:3;left:12px;top:12px;display:grid;place-items:center;width:44px;height:44px;color:#f3e3bf;font:700 15px/1 var(--f-display,'Cinzel',Georgia,serif);filter:drop-shadow(0 2px 4px #000b)}
${P} .lbo-die svg{position:absolute;inset:0;width:100%;height:100%}
${P} .lbo-die b{position:relative;top:1px}
${P}.is-pick .lbo-die{color:#2a1c0c}
${P} .lbo-tag{position:absolute;z-index:3;left:62px;top:21px;padding:4px 9px;border:1px solid #e3c47f88;border-radius:2px;background:#16120ecc;color:#f2d995;font:600 12px/1.2 var(--f-display,'Cinzel',Georgia,serif);letter-spacing:.04em;opacity:0;transform:translateX(-6px);transition:opacity .25s .7s,transform .25s .7s}
${P}.is-in .lbo-tag{opacity:1;transform:none}
${P}.is-dust .lbo-tag{border-color:#a99c8466;color:#d3c7b0}
${P} .lbo-x{position:absolute;z-index:4;right:8px;top:8px;width:44px;height:44px;display:grid;place-items:center;border:0;border-radius:50%;background:#0f0c09a8;color:#eadfc7;font:22px/1 Georgia,serif;cursor:pointer;transition:background .18s}
${P} .lbo-x:hover{background:#0f0c09e0}
${P} .lbo-body{position:relative;padding:4px 22px 22px}
${P} .lbo-title{margin:0 0 8px;color:#f3e3bf;font:600 21px/1.28 var(--f-display,'Cinzel',Georgia,serif);text-wrap:balance}
${P} .lbo-line{margin:0 0 12px;color:#cbbda2;font:400 15.5px/1.5 var(--f-body,'Spectral',Georgia,serif);display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}
${P} .lbo-meta{display:flex;align-items:center;gap:7px;margin:0 0 18px;color:#a8977a;font:400 13px/1.3 var(--f-body,'Spectral',Georgia,serif)}
${P} .lbo-meta svg{width:14px;height:14px;flex:none;color:#b8955a;shape-rendering:crispEdges}
${P} .lbo-acts{display:grid;grid-template-columns:1fr 1fr;gap:10px}
${P} .lbo-acts button{display:flex;align-items:center;justify-content:center;gap:8px;min-height:48px;padding:10px 12px;border-radius:3px;font:600 14.5px/1.2 var(--f-display,'Cinzel',Georgia,serif);letter-spacing:.02em;cursor:pointer;transition:background .18s,border-color .18s,transform .18s}
${P} .lbo-read{border:1px solid #c9a35d;background:#e9c87a24;color:#f6e3b4}
${P} .lbo-read:hover{background:#e9c87a3d;border-color:#e6c47c}
${P} .lbo-again{border:1px solid #c9a35d4d;background:transparent;color:#d8c7a5}
${P} .lbo-again:hover{background:#ffffff0a;border-color:#c9a35d99}
${P} .lbo-acts button:active{transform:translateY(1px)}
${P} .lbo-again svg{width:16px;height:16px;flex:none;color:#c9a35d;shape-rendering:crispEdges}
${P} button:focus-visible{outline:2px solid #ffe2a0;outline-offset:3px}
${P} .lbo-mote{position:absolute;z-index:5;width:3px;height:3px;left:var(--x);top:var(--y);background:var(--c,#ffe3a0);box-shadow:0 0 6px var(--c,#ffd27a);pointer-events:none;opacity:0;animation:lbo-mote var(--d,1.4s) var(--w,0s) ease-out both}
@keyframes lbo-sweep{to{transform:translateX(120%)}}
@keyframes lbo-mote{0%{opacity:0;transform:translate(0,0)}15%{opacity:1}100%{opacity:0;transform:translate(var(--dx,0px),var(--dy,-60px))}}
@media(max-width:420px){${P}{padding:12px}${P} .lbo-body{padding:2px 18px 18px}${P} .lbo-title{font-size:19.5px}${P} .lbo-line{font-size:15px}${P} .lbo-acts{grid-template-columns:.85fr 1.15fr}${P} .lbo-acts button{gap:6px;padding:10px 8px;font-size:13.5px;letter-spacing:0;white-space:nowrap}}
@media(max-height:560px) and (min-width:560px){${P} .lbo-card{display:grid;grid-template-columns:44% 1fr;width:min(640px,100%)}${P} .lbo-cover{aspect-ratio:auto;min-height:100%}${P} .lbo-cover::after{inset:0 0 0 auto;width:30%;height:auto;background:linear-gradient(90deg,transparent,#16120e)}${P} .lbo-body{padding:20px 20px 18px}}
@media(prefers-reduced-motion:reduce){${P} .lbo-veil,${P} .lbo-tag,${P} .lbo-cover img{transition:none}${P} .lbo-sweep,${P} .lbo-mote{display:none}}
`;
  const DIE = '<svg viewBox="0 0 44 44" aria-hidden="true"><path d="M22 2 40 12.5v19L22 42 4 31.5v-19z" fill="FILL" stroke="EDGE" stroke-width="1.5"/><path d="M22 2 13 17h18zM13 17 4 12.5M31 17l9-4.5M13 17l-4 15M31 17l4 15M9 32h26M13 17l9 25 9-25" fill="none" stroke="EDGE" stroke-width="1" opacity=".55"/></svg>';
  const BOOK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" aria-hidden="true"><path d="M2 3h5l1 1 1-1h5v10H9l-1 1-1-1H2zM8 4v10"/></svg>';
  const WING = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" aria-hidden="true"><path d="M1 9c3-1 5-4 7-6 0 3 1 5 3 6 1 1 3 1 4 0-1 3-4 4-7 4-3 0-5-2-7-4zM6 9h1M11 4l1-2"/></svg>';
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };

  FFD.parts['library/offer'] = (api) => {
    api = api || {};
    const F = api.F;
    const RM = () => { try { return !!(api.RM && api.RM()); } catch (e) { return false; } };
    const snd = (n) => { try { if (api.snd) api.snd(n); } catch (e) { /* silent */ } };
    const hold = (on) => { try { if (api.hold) api.hold(on); } catch (e) { /* the room stays usable */ } };
    if (!document.getElementById('ffd-css-library-offer')) { const s = el('style', '', CSS); s.id = 'ffd-css-library-offer'; document.head.append(s); }
    let cur = null;

    /* a few motes out of the cover: gold for Jan's pick, grey dust for the dustiest book */
    function motes(host, dust) {
      if (RM()) return;
      for (let i = 0; i < (dust ? 9 : 12); i++) {
        const m = el('i', 'lbo-mote');
        const x = dust ? 30 + Math.random() * 40 : 8 + Math.random() * 84, y = dust ? 55 + Math.random() * 25 : 40 + Math.random() * 45;
        m.style.cssText = '--x:' + x + '%;--y:' + y + '%;--dx:' + Math.round((Math.random() - 0.5) * (dust ? 120 : 40)) + 'px;--dy:' + Math.round(dust ? -10 - Math.random() * 40 : -50 - Math.random() * 60) + 'px;--d:' + (1.1 + Math.random() * 0.9).toFixed(2) + 's;--w:' + (0.35 + Math.random() * 0.5).toFixed(2) + 's' + (dust ? ';--c:#cfc3ad' : '');
        host.append(m);
      }
    }
    function finish(s, value) {
      if (cur !== s || s.done) return;
      s.done = true; cur = null;
      document.removeEventListener('keydown', s.key, true);
      const card = s.card, o = api.origin ? api.origin() : null;
      let anim = null;
      if (!RM() && card.animate) {
        if (value === 'another' && o) {
          const r = card.getBoundingClientRect();
          anim = card.animate([{ transform: 'none', opacity: 1 }, { transform: 'translate(' + Math.round(o.x - (r.left + r.width / 2)) + 'px,' + Math.round(o.y - (r.top + r.height / 2)) + 'px) scale(.3)', opacity: 0 }], { duration: 300, easing: 'cubic-bezier(.5,0,.75,.4)', fill: 'forwards' });
        } else if (value === 'read') anim = card.animate([{ transform: 'none', opacity: 1 }, { transform: 'scale(1.04)', opacity: 0 }], { duration: 220, easing: 'ease-out', fill: 'forwards' });
        else anim = card.animate([{ transform: 'none', opacity: 1 }, { transform: 'translateY(14px)', opacity: 0 }], { duration: 200, easing: 'ease-in', fill: 'forwards' });
      }
      s.root.classList.remove('is-in');
      const gone = () => { s.root.remove(); hold(false); if (s.back && s.back.isConnected && typeof s.back.focus === 'function') { try { s.back.focus({ preventScroll: true }); } catch (e) { /* fine */ } } s.resolve(value); };
      if (anim) anim.finished.then(gone, gone); else gone();
    }
    function show(b, o) {
      o = o || {};
      if (cur) finish(cur, 'close');
      const s = { done: false, back: document.activeElement };
      s.promise = new Promise((r) => { s.resolve = r; });
      const root = el('div', 'lbo' + (o.tone === 'pick' ? ' is-pick' : o.tone === 'dust' ? ' is-dust' : ''));
      root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-labelledby', 'lbo-title');
      const veil = el('div', 'lbo-veil'), card = el('article', 'lbo-card');
      const cover = el('div', 'lbo-cover');
      const ar = b.cw > 0 && b.ch > 0 ? Math.max(1.2, Math.min(1.9, b.cw / b.ch)) : 16 / 9;
      cover.style.setProperty('--ar', ar.toFixed(3));
      const leather = el('div', 'lbo-leather'); leather.append(el('span', '', b.t)); leather.setAttribute('aria-hidden', 'true');
      cover.append(leather, el('i', 'lbo-sweep'));
      if (o.roll) {
        const die = el('div', 'lbo-die');
        const pick = o.tone === 'pick', dust = o.tone === 'dust';
        die.innerHTML = DIE.replace(/FILL/g, pick ? '#e9c87a' : dust ? '#4a4338' : '#2b2117').replace(/EDGE/g, pick ? '#fff0c4' : dust ? '#9c917d' : '#c9a35d');
        die.append(el('b', '', String(o.roll)));
        die.setAttribute('aria-label', 'Soryndel rolled ' + o.roll);
        cover.append(die);
        if (pick || dust) cover.append(el('span', 'lbo-tag', pick ? 'Jan’s pick' : 'Dusty'));
      }
      const x = el('button', 'lbo-x', '×'); x.type = 'button'; x.setAttribute('aria-label', 'Put it back');
      const body = el('div', 'lbo-body');
      const title = el('h2', 'lbo-title', b.t); title.id = 'lbo-title';
      body.append(title);
      if (b.d) body.append(el('p', 'lbo-line', b.d));
      if (b.m > 0) { const meta = el('p', 'lbo-meta'); meta.innerHTML = BOOK; meta.append(b.m + ' min read'); body.append(meta); }
      const acts = el('div', 'lbo-acts');
      const read = el('button', 'lbo-read', 'Read it'); read.type = 'button';
      const again = el('button', 'lbo-again'); again.type = 'button'; again.innerHTML = WING; again.append('Another book');
      acts.append(read, again); body.append(acts);
      card.append(cover, x, body); root.append(veil, card);
      s.root = root; s.card = card;
      read.addEventListener('click', () => { snd('flip'); finish(s, 'read'); });
      again.addEventListener('click', () => { snd('wings'); finish(s, 'another'); });
      x.addEventListener('click', () => finish(s, 'close'));
      veil.addEventListener('click', () => finish(s, 'close'));
      root.addEventListener('pointerdown', (e) => e.stopPropagation());
      s.key = (e) => {
        if (cur !== s) return;
        if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); finish(s, 'close'); return; }
        if (e.key === 'Tab') {
          const bs = [x, read, again];
          const i = bs.indexOf(document.activeElement);
          e.preventDefault(); bs[(i + (e.shiftKey ? bs.length - 1 : 1) + bs.length) % bs.length].focus();
        }
        if (e.key === 'Enter' || e.key === ' ' || e.key.startsWith('Arrow')) e.stopPropagation();
      };
      /* the cover: the article's own picture when it loads, the stamped leather until then (or for good) */
      Promise.resolve(api.cover ? api.cover(b, 800) : null).then((u) => {
        if (!u || s.done) return;
        const img = el('img'); img.alt = ''; img.decoding = 'async';
        img.onload = () => { if (!s.done) { img.classList.add('is-on'); setTimeout(() => leather.remove(), 320); } };
        img.onerror = () => img.remove();
        img.src = u; cover.insertBefore(img, leather.nextSibling);
      }).catch(() => {});
      cur = s; hold(true);
      ((F && F.el) || document.body).append(root);
      document.addEventListener('keydown', s.key, true);
      /* it rises out of the lectern: from the book's spot, small, to the middle of the screen */
      const og = api.origin ? api.origin() : null;
      requestAnimationFrame(() => {
        if (s.done) return;
        root.classList.add('is-in');
        if (!RM() && card.animate) {
          const r = card.getBoundingClientRect();
          const from = og ? 'translate(' + Math.round(og.x - (r.left + r.width / 2)) + 'px,' + Math.round(og.y - (r.top + r.height / 2)) + 'px) scale(.28)' : 'translateY(18px) scale(.96)';
          card.animate([{ transform: from, opacity: 0 }, { opacity: 1, offset: 0.35 }, { transform: 'none', opacity: 1 }], { duration: og ? 460 : 280, easing: 'cubic-bezier(.2,.8,.2,1)' });
        }
        if (o.tone) motes(cover, o.tone === 'dust');
        snd(o.tone === 'pick' ? 'crit' : 'land');
        try { read.focus({ preventScroll: true }); } catch (e) { /* fine */ }
      });
      return s.promise;
    }
    return { show, close: () => { if (cur) finish(cur, 'close'); }, busy: () => !!cur, destroy: () => { if (cur) finish(cur, 'close'); } };
  };
})();

/* ===== src/scene-pages/pages/library/pack.js ===== */
/* library/pack.js: the deck's daily pack, opened the way the Hall opens a Mythic Pack (a part of the library page).
   Jan (2026-10-07), showing the Hall's Mythic Pack screen ("Five heroes. Reveal them together.", five face-down cards
   with the FramedFantasy logo backs and rarity edges, a Reveal all button): the library deck's pack "should be like the
   mythic backs", a pack of three cards to click instead of five, confetti and a word from Zhaunil when a Mythic turns,
   and a first button that says "Open a pack".

   It copies the Hall's own opening (hohOpenHeroPack in assets/hoh-section-core.js, its styles in assets/hoh-shop.css)
   through its Battlegrounds copy (assets/bg-pack.js): the 0.58 dim fading in over 0.25 s, the fan deal (0.56 s, 80 ms
   apart), the logo backs with their rarity edge, the aura on Epic and up, rising sparks off Rare and up, the tilted
   turn (0.52 s), the burst with its flash and ring, the shake on Legendary and up, the Mythic rainbow rim, the Hall's
   canvas-confetti 1.5.1 from jsDelivr (fetched only for a pack with a Mythic in it, and the page's window.confetti put
   back as it was), lowest rarity first so the best card turns last, the button turning the rest 300 ms apart.
   Where it differs, on purpose: one to three cards, each the Hall face's own shape (380 by 650, the deck's .lbc-stage)
   so the deck's full face fills it, the fan holds on a phone, and the flash and ring cover the whole card (the Hall's sit
   in a 0 by 0 layer); the shake has its own layer so it plays with the turn instead of after it; Zhaunil's line comes up
   under the fan when a Mythic turns; the cards are already in the binder, so Escape or the last button only closes;
   once every card is up the fan settles side by side, a small gap apart, so no card hides the end of its neighbour's
   lines (reduced motion lays them side by side from the start).

   FFD.parts['library/pack'](api) -> pack
     pack.open(cards, o) -> Promise<void>   resolves once the overlay is gone. cards: 1 to 3 (more are dealt but the
                                            fan is sized for three), each { slug, name, tier, img, thumb, ... }, already
                                            saved. o: { title ('Today’s pack'), sub ('Three heroes for your binder.'),
                                            button ('Open a pack'), back ('Back to the library'), done (the line once
                                            all are up), from (a rect the cards fly in from) }. A second open() while one
                                            is up closes the first at once.
     pack.busy() -> boolean                 the overlay is up (or fading out)
     pack.close(now)                        closes it (now: true skips the 0.25 s fade)
   The room gives: F (the frame: the overlay goes in F.el at z-index 34, over the deck's .lbc layer at 30, under its
   flying motes at 40 and the Enter gate), h, RM(), snd(name, o), buzz(ms), face(card, el) -> Promise (draws the card's
   Hall face into el, which is the card's size with container-type size and --lbc-k = its width / 380 on the overlay;
   without it, or when it fails, a plain face with the portrait and name stands in), zoom(card) (optional: a tap on a
   face-up card; when it returns a Promise the pack steps under the deck's layer, z-index 29, and hands over the keys
   until it settles), mythicLine(card) -> string, zh: { name, img }.
   Per reader nothing is kept here; the deck saved the cards before open() was called. */
(() => {
  'use strict';
  const FFD = window.FFD = window.FFD || {};
  FFD.parts = FFD.parts || {};

  const CSS_ID = 'ffd-css-library-pack';
  const SC = '.ffd-page--library';
  /* the Hall's card-back mark (_HOH_PACK_LOGO) */
  const LOGO = 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/Logo_Clean.webp?v=1775168383';
  /* the Hall's rarity ladder and burst colours (_HOH_PACK_RANK, _HOH_PACK_PALETTES) */
  const TIERS = ['common', 'uncommon', 'rare', 'epic', 'legendary', 'mythic'];
  const WORD = ['Common', 'Uncommon', 'Rare', 'Epic', 'Legendary', 'Mythic'];
  const PALETTES = { common: ['#cfc7da', '#a9a2bd'], uncommon: ['#7ee6a0', '#bdf5cf'], rare: ['#8fc0ff', '#cfe2ff'], epic: ['#d6a4ff', '#b06aff'],
    legendary: ['#ffd27a', '#ffb84a', '#fff0c8'], mythic: ['#ef94ff', '#b3f5ee', '#ffffff'] };
  /* the Hall face's own size (cards.js .lbc-stage at --lbc-k 1) */
  const FACE_W = 380, FACE_H = 650;
  const SUB = ['', 'A hero for your binder.', 'Two heroes for your binder.', 'Three heroes for your binder.'];
  /* Zhaunil, when the deck has no line of its own for a Mythic */
  const SAY = 'Well now. Keep that one somewhere dry.';
  const rankOf = (c) => { const i = TIERS.indexOf(String((c && c.tier) || '').toLowerCase()); return i < 0 ? 0 : i; };

  /* ---------- the Hall's confetti (hohFireConfetti), as bg-pack.js keeps it ----------
     canvas-confetti names itself window.confetti; this part keeps its own hold on it and puts the page back as it was */
  const CONFETTI = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.5.1/dist/confetti.browser.min.js';
  let confetti = null, confettiLoad = null;
  function loadConfetti() {
    if (confetti) return Promise.resolve(true);
    if (!confettiLoad) {
      confettiLoad = new Promise((resolve) => {
        const had = Object.prototype.hasOwnProperty.call(window, 'confetti'), was = window.confetti;
        const s = document.createElement('script');
        s.src = CONFETTI; s.async = true; s.crossOrigin = 'anonymous';
        s.onload = () => {
          if (typeof window.confetti === 'function') confetti = window.confetti;
          if (had) window.confetti = was; else { try { delete window.confetti; } catch (e) { window.confetti = undefined; } }
          resolve(!!confetti);
        };
        s.onerror = () => { confettiLoad = null; s.remove(); resolve(false); };
        document.head.appendChild(s);
      });
    }
    return confettiLoad;
  }
  function fireConfetti() {
    if (!confetti) return;
    const brand = ['#ee99fe', '#affcfe'];
    try {
      if (window.innerWidth >= 768) {
        const common = { particleCount: 270, spread: 160, startVelocity: 130, gravity: 0.25, ticks: 330, colors: brand, zIndex: 999999 };
        confetti(Object.assign({}, common, { origin: { x: 1.2, y: 0.1 }, angle: 210 }));
        confetti(Object.assign({}, common, { origin: { x: -0.2, y: 0.5 }, angle: 20 }));
      } else confetti({ particleCount: 150, spread: 70, startVelocity: 60, gravity: 0.4, ticks: 430, origin: { x: 0.5, y: 1.05 }, angle: 90, colors: brand, zIndex: 999999 });
    } catch (e) { /* no confetti, the rest goes on */ }
  }

  /* ---------- the styles: the Hall's pack (hall-of-heroes.css under hoh-shop.css) on the library's own names ----------
     The card is --w wide: about 30 percent of the width for three (34 for two, 42 for one), never over --lpk-wmax, and
     never taller than the height left once the title, the button (and Zhaunil's line, when the pack holds a Mythic)
     have their room (--lpk-res). Short, wide screens put Zhaunil's line beside the button instead of over it. */
  const CSS = `
${SC} .lpk { position: absolute; inset: 0; z-index: 34; display: flex; flex-direction: column; align-items: center; justify-content: safe center; box-sizing: border-box; overflow: hidden auto; overscroll-behavior: contain; scrollbar-width: none;
  padding: max(12px, env(safe-area-inset-top, 0px)) max(16px, env(safe-area-inset-right, 0px)) max(12px, env(safe-area-inset-bottom, 0px)) max(16px, env(safe-area-inset-left, 0px));
  background: radial-gradient(ellipse 82% 72% at 50% 50%, rgba(8, 6, 12, .6), rgba(5, 4, 8, .9)); opacity: 0; transition: opacity .25s ease; color: #f1e6cf; text-align: center; text-transform: none; letter-spacing: normal; line-height: 1.4;
  -webkit-tap-highlight-color: transparent; -webkit-user-select: none; user-select: none;
  --lpk-h: 100svh; --lpk-wv: 30vw; --lpk-wmax: 236px; --lpk-res: 196px; --lpk-gap: 16px;
  --w: max(64px, min(var(--lpk-wv), var(--lpk-wmax), calc((var(--lpk-h) - var(--lpk-res)) * ${(FACE_W / FACE_H).toFixed(4)})));
  --r: calc(var(--w) * .065); }
@supports not (height: 1svh) { ${SC} .lpk { --lpk-h: 100vh; } }
${SC} .lpk.has-zh { --lpk-res: 278px; }
${SC} .lpk.is-n2 { --lpk-wv: 34vw; --lpk-wmax: 250px; }
${SC} .lpk.is-n1 { --lpk-wv: 42vw; --lpk-wmax: 270px; }
${SC} .lpk.is-open { opacity: 1; }
${SC} .lpk.is-shut { pointer-events: none; }
${SC} .lpk.is-shut .lpk-card { opacity: 1; animation: none; }
${SC} .lpk.is-lent { z-index: 29; }
/* the room's talk box steps back while the pack is up (as it does for a border card), so its last line never shows
   through the dim or peeks round the button; it comes back as the pack fades */
${SC} .ffs.lpk-up > .ffs-box { opacity: 0; visibility: hidden; transition: opacity .2s ease, visibility 0s linear .2s; }
${SC} .lpk-stage { position: relative; display: flex; flex-direction: column; align-items: center; gap: var(--lpk-gap); width: 100%; max-width: 980px; flex: none; }
${SC} .lpk::-webkit-scrollbar { display: none; }
${SC} .lpk-head { position: relative; display: flex; flex-direction: column; align-items: center; gap: 2px; max-width: 100%; }
/* a soft shade behind the words, so the room's bright paintings and spines never fight them */
${SC} .lpk-head::before { content: ''; position: absolute; inset: -16px -48px; z-index: -1; pointer-events: none; background: radial-gradient(closest-side, rgba(5, 4, 8, .72), rgba(5, 4, 8, 0)); }
${SC} .lpk-title { margin: 0; padding-left: .28em; text-shadow: 0 1px 2px rgba(0, 0, 0, .85), 0 0 14px rgba(0, 0, 0, .7); font: 600 14px/1.8 'Cinzel', Georgia, serif; letter-spacing: .28em; text-transform: uppercase; color: #c8a45e; }
${SC} .lpk-sub { margin: 0; min-height: 1.4em; text-shadow: 0 1px 2px rgba(0, 0, 0, .85), 0 0 12px rgba(0, 0, 0, .7); max-width: 520px; text-transform: none; letter-spacing: normal; font: 400 14.5px/1.4 'Spectral', Georgia, serif; color: #cfc3aa; text-wrap: balance; }
${SC} .lpk-row { position: relative; display: flex; justify-content: center; align-items: flex-start; padding-bottom: calc(var(--w) * .06); }

/* the card: the Hall's .hoh-pack-card, dealt into a fan. Where it rests is four numbers (--tx, --ty, --tr, --ts) that
   its glow behind the fan shares, so the two always move together */
${SC} .lpk-card, ${SC} .lpk-glow { --tx: 0px; --ty: calc(var(--w) * .06 * var(--k)); --tr: var(--rot); --ts: 1; }
/* once every card is up they settle side by side, a small gap apart (--sx, measured) and barely tilted, so each card's
   lines read whole; the fan overlaps them only while they are dealt and turned. --lpk-sp shrinks the row a touch when
   three side by side would not quite fit */
${SC} .lpk.is-spread .lpk-card, ${SC} .lpk.is-spread .lpk-glow { --tx: var(--sx, 0px); --ty: calc(var(--w) * .018 * var(--k)); --tr: calc(var(--rot) * .3); --ts: var(--lpk-sp, 1); }
${SC} .lpk-card { position: relative; flex: 0 0 auto; width: var(--w); height: calc(var(--w) * ${(FACE_H / FACE_W).toFixed(4)}); margin: 0 calc(var(--w) * -.04); z-index: calc(var(--i) + 1);
  cursor: pointer; opacity: 0; outline: none; touch-action: manipulation; -webkit-touch-callout: none;
  transform: translate(var(--tx), var(--ty)) rotate(var(--tr)) scale(var(--ts)); transition: transform .26s cubic-bezier(.2, .75, .3, 1.12); }
${SC} .lpk.is-open .lpk-card { opacity: 1; animation: lpkDeal var(--deal, .56s) cubic-bezier(.2, .72, .28, 1.05) calc(var(--i) * 80ms) backwards; }
@keyframes lpkDeal { 0% { opacity: 0; transform: translate(var(--dx), var(--dy)) rotate(0deg) scale(var(--ds)); } 40% { opacity: 1; } 100% { opacity: 1; transform: translate(var(--tx), var(--ty)) rotate(var(--tr)) scale(var(--ts)); } }
@media (hover: hover) { ${SC} .lpk:not(.is-still) .lpk-card:hover { transform: translate(var(--tx), calc(var(--ty) - 6px)) rotate(var(--tr)) scale(calc(var(--ts) * 1.04)); z-index: 5; } }
${SC} .lpk.is-spread .lpk-card { transition: transform .32s cubic-bezier(.22, .8, .24, 1); }
${SC} .lpk-card:focus-visible::after { content: ''; position: absolute; inset: -5px; border-radius: calc(var(--r) + 4px); border: 2px solid #f2d98e; pointer-events: none; z-index: 7; }
${SC} .lpk-card.is-flipping { z-index: 8; }
${SC} .lpk-card.is-up.is-still-card { cursor: default; }
${SC} .lpk-shake { position: absolute; inset: 0; perspective: 900px; }
${SC} .lpk-shake.is-shaking { animation: lpkShake .5s ease; }
@keyframes lpkShake { 0%, 100% { transform: translate(0, 0); } 15% { transform: translate(-3px, 1px) rotate(-1deg); } 30% { transform: translate(3px, -1px) rotate(1deg); } 45% { transform: translate(-2px, -1px); } 60% { transform: translate(2px, 1px); } 80% { transform: translate(-1px, 0); } }
${SC} .lpk-inner { position: absolute; inset: 0; transform-origin: 50% 50%; }
${SC} .lpk-card.is-flipping .lpk-inner { animation: lpkTurn .52s cubic-bezier(.42, 0, .3, 1) both; }
@keyframes lpkTurn { 0% { transform: rotateY(0deg) scale(1); filter: brightness(1); } 46% { transform: rotateY(52deg) scale(1.05); filter: brightness(1.55); } 100% { transform: rotateY(0deg) scale(1); filter: brightness(1); } }
${SC} .lpk-back, ${SC} .lpk-face { position: absolute; inset: 0; box-sizing: border-box; border-radius: var(--r); overflow: hidden; pointer-events: none; transition: opacity .42s ease;
  box-shadow: 0 10px 26px -10px rgba(0, 0, 0, .7), 0 0 0 1px var(--rar, rgba(200, 164, 94, .35)); }
${SC} .lpk-back { display: flex; align-items: center; justify-content: center; background: linear-gradient(165deg, #2c2042, #140d22); border: 1px solid var(--edge, rgba(200, 164, 94, .45)); }
${SC} .lpk-face { opacity: 0; background: #0e0a16; border: 1px solid rgba(255, 255, 255, .08); }
${SC} .lpk-face::after { content: ''; position: absolute; inset: 0; border-radius: inherit; background: radial-gradient(circle at 50% 45%, rgba(255, 255, 255, .55), transparent 68%); opacity: 0; pointer-events: none; z-index: 2; }
${SC} .lpk-card.is-up .lpk-back { opacity: 0; }
${SC} .lpk-card.is-up .lpk-face { opacity: 1; }
${SC} .lpk-card.is-up .lpk-face::after { animation: lpkFlash .6s ease-out .26s; }
@keyframes lpkFlash { 0% { opacity: 0; } 28% { opacity: .75; } 100% { opacity: 0; } }
${SC} .lpk-slot { position: absolute; inset: 0; z-index: 1; display: block; overflow: hidden; border-radius: inherit; container-type: size; }
/* the back: the Hall's .ffshop-miniback */
${SC} .lpk-miniback { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: calc(var(--w) * .05); border-radius: inherit; border: 1px solid rgba(200, 164, 94, .4);
  background: repeating-linear-gradient(45deg, rgba(200, 164, 94, .05) 0 1px, transparent 1px 12px), repeating-linear-gradient(-45deg, rgba(200, 164, 94, .05) 0 1px, transparent 1px 12px), radial-gradient(60% 45% at 50% 50%, rgba(200, 164, 94, .1), transparent 70%), linear-gradient(170deg, #14101e, #0a0a0f 70%); }
${SC} .lpk-miniback img { display: block; width: 46%; height: auto; object-fit: contain; filter: drop-shadow(0 2px 6px rgba(0, 0, 0, .7)); pointer-events: none; -webkit-user-drag: none; }
${SC} .lpk-miniback span { padding-left: .34em; font: 600 max(6px, calc(var(--w) * .043))/1 'Cinzel', Georgia, serif; letter-spacing: .34em; color: #c8a45e; text-transform: uppercase; white-space: nowrap; }
/* the rarity: the back's edge (hall-of-heroes.css) and the glow round it (hoh-shop.css --rar) */
${SC} .lpk-card.is-common { --edge: rgba(184, 176, 206, .42); --rar: rgba(160, 154, 174, .5); }
${SC} .lpk-card.is-uncommon { --edge: rgba(95, 214, 128, .55); --rar: rgba(126, 212, 154, .75); }
${SC} .lpk-card.is-rare { --edge: rgba(90, 154, 255, .62); --rar: rgba(126, 212, 255, .8); }
${SC} .lpk-card.is-epic { --edge: rgba(176, 90, 232, .74); --rar: rgba(183, 148, 244, .8); }
${SC} .lpk-card.is-legendary { --edge: rgba(255, 184, 74, .84); --rar: rgba(255, 179, 71, .85); }
${SC} .lpk-card.is-mythic { --edge: rgba(239, 148, 255, .86); --rar: rgba(239, 148, 255, .9); }
/* each card's light (the Hall's rarity glow, its aura and its face-up glow) on its own layer behind the whole fan, so a
   glow lights the room round the cards and never washes over the card beside it */
${SC} .lpk-glows { position: absolute; inset: 0; z-index: 0; pointer-events: none; }
${SC} .lpk-glow { position: absolute; display: block; border-radius: var(--r); opacity: 0; transform: translate(var(--tx), var(--ty)) rotate(var(--tr)) scale(var(--ts));
  box-shadow: 0 0 18px -4px var(--rar, transparent); transition: opacity .5s ease, box-shadow .45s ease; }
${SC} .lpk.is-spread .lpk-glow { transition: opacity .5s ease, box-shadow .45s ease, transform .32s cubic-bezier(.22, .8, .24, 1); }
${SC} .lpk.is-open .lpk-glow.is-on { opacity: 1; }
${SC} .lpk-glow.is-common { --rar: rgba(160, 154, 174, .5); } ${SC} .lpk-glow.is-uncommon { --rar: rgba(126, 212, 154, .75); } ${SC} .lpk-glow.is-rare { --rar: rgba(126, 212, 255, .8); }
${SC} .lpk-glow.is-epic { --rar: rgba(183, 148, 244, .8); } ${SC} .lpk-glow.is-legendary { --rar: rgba(255, 179, 71, .85); } ${SC} .lpk-glow.is-mythic { --rar: rgba(239, 148, 255, .9); }
${SC} .lpk-glow.is-aura { animation: lpkAura 1.5s ease-in-out infinite; }
${SC} .lpk-glow.is-common.is-up { box-shadow: 0 0 14px rgba(184, 176, 206, .28); }
${SC} .lpk-glow.is-uncommon.is-up { box-shadow: 0 0 20px rgba(95, 214, 128, .45); }
${SC} .lpk-glow.is-rare.is-up { box-shadow: 0 0 24px rgba(90, 154, 255, .5); }
${SC} .lpk-glow.is-epic.is-up { box-shadow: 0 0 28px rgba(176, 90, 232, .55); }
${SC} .lpk-glow.is-legendary.is-up { box-shadow: 0 0 36px rgba(255, 184, 74, .58), 0 0 72px rgba(255, 184, 74, .24); }
${SC} .lpk-glow.is-mythic { box-shadow: 0 0 26px -2px rgba(239, 148, 255, .6), 0 0 56px -10px rgba(126, 212, 255, .45); }
${SC} .lpk-card.is-mythic .lpk-inner::before { content: ''; position: absolute; inset: -3px; border-radius: calc(var(--r) + 3px); pointer-events: none;
  background: conic-gradient(from 140deg, #ef94ff, #ffb347, #ffe27a, #7ed49a, #7ed4ff, #b794f4, #ef94ff);
  box-shadow: 0 10px 26px -10px rgba(0, 0, 0, .7); animation: lpkRim 6s linear infinite; }
@keyframes lpkRim { to { filter: hue-rotate(360deg); } }
${SC} .lpk-card.is-mythic .lpk-back, ${SC} .lpk-card.is-mythic .lpk-face { box-shadow: 0 10px 26px -10px rgba(0, 0, 0, .7); }
@keyframes lpkAura { 0%, 100% { box-shadow: 0 0 14px -2px var(--rar); } 50% { box-shadow: 0 0 30px 4px var(--rar); } }
/* the burst over the card, the sparks rising off the back */
${SC} .lpk-fx { position: absolute; inset: 0; pointer-events: none; z-index: 6; }
${SC} .lpk-p { position: absolute; left: 50%; top: 46%; width: 6px; height: 6px; margin: -3px 0 0 -3px; border-radius: 50%; background: var(--pcol, #fff); box-shadow: 0 0 8px var(--pcol, #fff); opacity: 0; animation: lpkSpark var(--pdur, 900ms) cubic-bezier(.12, .7, .25, 1) forwards; }
@keyframes lpkSpark { 0% { opacity: 1; transform: translate(0, 0) scale(1); } 100% { opacity: 0; transform: translate(var(--pdx, 0), var(--pdy, 0)) scale(.25); } }
${SC} .lpk-ring { position: absolute; left: 50%; top: 46%; width: 74%; aspect-ratio: 1; border-radius: 50%; border: 2px solid var(--rcol, #fff); box-shadow: 0 0 22px var(--rcol, #fff); opacity: .9; transform: translate(-50%, -50%) scale(.25); animation: lpkRing .95s cubic-bezier(.2, .7, .2, 1) forwards; }
@keyframes lpkRing { 0% { opacity: .9; transform: translate(-50%, -50%) scale(.25); } 100% { opacity: 0; transform: translate(-50%, -50%) scale(2.8); } }
${SC} .lpk-flash { position: absolute; inset: 0; border-radius: var(--r); background: radial-gradient(circle, var(--fcol, #fff) 0%, transparent 66%); opacity: 0; animation: lpkFlashA .75s ease forwards; }
@keyframes lpkFlashA { 0% { opacity: .65; } 100% { opacity: 0; } }
${SC} .lpk-idle { position: absolute; inset: -16px 0 0 0; pointer-events: none; z-index: 5; }
${SC} .lpk-i { position: absolute; bottom: 16%; width: 4px; height: 4px; border-radius: 50%; background: var(--icol, #fff); box-shadow: 0 0 8px var(--icol, #fff); opacity: 0; animation: lpkRise var(--idur, 1.4s) ease-out forwards; }
${SC} .lpk-i.is-big { width: 6px; height: 6px; }
@keyframes lpkRise { 0% { opacity: 0; transform: translate(0, 0) scale(.6); } 18% { opacity: .95; } 100% { opacity: 0; transform: translate(var(--idx, 0), -56px) scale(1); } }
/* the plain face, until the deck draws the Hall's (the Hall's .ffshop-mini) */
${SC} .lpk-mini { position: absolute; inset: 0; display: flex; flex-direction: column; background: linear-gradient(170deg, #191325, #0a0a0f 70%); }
${SC} .lpk-mini-art { position: relative; flex: 0 0 74%; overflow: hidden; background: #0a0a0f; }
${SC} .lpk-mini-art img { display: block; width: 100%; height: 100%; object-fit: cover; pointer-events: none; -webkit-user-drag: none; }
${SC} .lpk-mini-body { flex: 1 1 auto; min-height: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: calc(var(--w) * .02); padding: 2px 6px; }
${SC} .lpk-mini-name { max-width: 100%; font: 700 max(10px, calc(var(--w) * .072))/1.15 'Cinzel', Georgia, serif; color: #fff5d8; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; overflow-wrap: anywhere; text-wrap: balance; }
${SC} .lpk-mini-tier { padding-left: .22em; font: 600 max(7px, calc(var(--w) * .045))/1 'Cinzel', Georgia, serif; letter-spacing: .22em; text-transform: uppercase; color: #c8a45e; }

/* under the fan: Zhaunil's line (a pack with a Mythic in it keeps its room from the start) and the button */
${SC} .lpk-foot { display: flex; flex-direction: column; align-items: center; gap: 10px; width: 100%; }
${SC} .lpk-zh { display: flex; align-items: center; gap: 10px; flex: 0 1 auto; min-width: 0; box-sizing: border-box; width: min(440px, 100%); min-height: 62px; margin: 0; padding: 8px 14px 8px 8px; border-radius: 10px; border: 1px solid rgba(232, 198, 116, .42);
  background: rgba(14, 10, 7, .93); box-shadow: 0 10px 30px rgba(0, 0, 0, .5); text-align: left; opacity: 0; visibility: hidden; transform: translateY(6px);
  transition: opacity .28s ease, transform .28s cubic-bezier(.2, .7, .2, 1), visibility 0s linear .28s; }
${SC} .lpk-zh.is-on { opacity: 1; visibility: visible; transform: none; transition: opacity .28s ease, transform .28s cubic-bezier(.2, .7, .2, 1), visibility 0s; }
${SC} .lpk-zh-img { width: 40px; height: 40px; flex: 0 0 auto; object-fit: cover; border-radius: 6px; border: 1.5px solid rgba(200, 164, 94, .8); box-shadow: 0 0 0 2px rgba(200, 164, 94, .12), 0 0 10px rgba(232, 198, 116, .2); }
${SC} .lpk-zh-t { display: block; min-width: 0; }
${SC} .lpk-zh-who { display: block; font: italic 600 13.5px/1.2 'Cormorant Garamond', Georgia, serif; color: #e7c97f; }
${SC} .lpk-zh-line { display: block; margin-top: 2px; font: italic 500 16.5px/1.3 'Cormorant Garamond', Georgia, serif; color: #f1e6cf; text-wrap: pretty; }
/* the Hall's .hoh-pack-done; both labels share one cell so the button never changes width */
${SC} .lpk-go { display: inline-grid; place-items: center; flex: none; white-space: nowrap; min-width: 44px; min-height: 44px; margin: 0; padding: 12px 34px; border: 0; border-radius: 11px; cursor: pointer;
  background: linear-gradient(120deg, #f2d98e, #c8a45e); color: #1a1108; font: 700 13px/1.2 'Cinzel', Georgia, serif; letter-spacing: .12em; text-transform: uppercase;
  box-shadow: 0 6px 20px -8px rgba(242, 217, 142, .6); transition: transform .15s ease, opacity .16s ease; -webkit-tap-highlight-color: transparent; touch-action: manipulation; }
${SC} .lpk-go > span { grid-area: 1 / 1; transition: opacity .2s ease, visibility 0s; }
${SC} .lpk-go-b, ${SC} .lpk-go.is-back .lpk-go-a { opacity: 0; visibility: hidden; transition: opacity .2s ease, visibility 0s linear .2s; }
${SC} .lpk-go.is-back .lpk-go-b { opacity: 1; visibility: visible; transition: opacity .2s ease, visibility 0s; }
@media (hover: hover) { ${SC} .lpk-go:not([aria-disabled="true"]):hover { transform: translateY(-2px); } }
${SC} .lpk-go[aria-disabled="true"] { opacity: .55; cursor: default; }
${SC} .lpk-go:focus-visible { outline: 2px solid #fff3cf; outline-offset: 3px; }
${SC} .lpk-live { position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; overflow: hidden; clip: rect(0 0 0 0); clip-path: inset(50%); white-space: nowrap; border: 0; }

@media (max-width: 560px) { ${SC} .lpk-title { font-size: 12px; } ${SC} .lpk-sub { font-size: 14px; } ${SC} .lpk-zh-line { font-size: 16px; } }
/* short and wide (a phone on its side, a laptop with little height): smaller words, Zhaunil beside the button */
@media (max-height: 540px) and (min-aspect-ratio: 5 / 4) {
  ${SC} .lpk { --lpk-res: 152px; --lpk-gap: 10px; }
  ${SC} .lpk.has-zh { --lpk-res: 160px; }
  ${SC} .lpk-title { font-size: 11px; line-height: 1.6; }
  ${SC} .lpk-sub { font-size: 13px; }
  ${SC} .lpk-foot { flex-direction: row; justify-content: center; gap: 14px; }
  ${SC} .lpk-zh { width: min(400px, 56%); min-height: 52px; padding: 6px 12px 6px 6px; }
  ${SC} .lpk-zh-img { width: 36px; height: 36px; }
  ${SC} .lpk-zh-who { display: none; }
  ${SC} .lpk-zh-line { margin-top: 0; font-size: 14.5px; line-height: 1.28; }
}
/* reduced motion (the device or the room's own RM()): no deal, tilt, flash, sparks or shake; a 0.2 s crossfade */
${SC} .lpk.is-still { transition-duration: .2s; }
${SC} .lpk.is-still .lpk-card { animation-duration: 1ms !important; animation-delay: 0ms !important; transition: none; }
${SC} .lpk.is-still .lpk-card.is-flipping .lpk-inner, ${SC} .lpk.is-still .lpk-card.is-up .lpk-face::after, ${SC} .lpk.is-still .lpk-card.is-mythic .lpk-inner::before, ${SC} .lpk.is-still .lpk-shake, ${SC} .lpk.is-still .lpk-glow { animation: none; }
${SC} .lpk.is-still .lpk-glow { transition: opacity .2s ease; }
${SC} .lpk.is-still .lpk-back, ${SC} .lpk.is-still .lpk-face { transition: opacity .2s ease; }
${SC} .lpk.is-still .lpk-zh, ${SC} .lpk.is-still .lpk-zh.is-on { transform: none; }
@media (prefers-reduced-motion: reduce) { ${SC} .lpk-card, ${SC} .lpk.is-spread .lpk-card, ${SC} .lpk-go { transition: none; } ${SC} .lpk.is-spread .lpk-glow { transition: opacity .2s ease; } }
`;
  function styles() {
    if (document.getElementById(CSS_ID)) return;
    const st = document.createElement('style');
    st.id = CSS_ID; st.textContent = CSS;
    document.head.appendChild(st);
  }

  /* the Hall's reframe (hohImgStyle), as cards.js frameStyle reads it: a stored value only when it is a number in range */
  function frameStyle(c) {
    const ok = (v, lo, hi) => typeof v === 'number' && isFinite(v) && v >= lo && v <= hi;
    const x = ok(c.offX, 0, 100) ? c.offX : 50, y = ok(c.offY, 0, 100) ? c.offY : 50, z = ok(c.zoom, 100, 200) ? c.zoom : 100;
    const pos = x + '% ' + y + '%';
    return 'object-position:' + pos + ';transform-origin:' + pos + ';scale:' + (Math.round(z) / 100) + ';';
  }
  function rectOf(r) {
    if (!r || typeof r !== 'object') return null;
    const left = +(r.left != null ? r.left : r.x), top = +(r.top != null ? r.top : r.y);
    const width = +(r.width != null ? r.width : r.w) || 0, height = +(r.height != null ? r.height : r.h) || 0;
    return isFinite(left) && isFinite(top) ? { left, top, width, height } : null;
  }

  FFD.parts['library/pack'] = function (api) {
    api = api || {};
    const F = api.F || {};
    const h = api.h || FFD.h;
    const RM = () => { try { return typeof api.RM === 'function' ? !!api.RM() : !!(FFD.RM && FFD.RM()); } catch (e) { return false; } };
    const snd = (n, o) => { try { if (typeof api.snd === 'function') api.snd(n, o); } catch (e) { /* silent */ } };
    const buzz = (ms) => { try { if (typeof api.buzz === 'function') api.buzz(ms); } catch (e) { /* silent */ } };
    const zh = Object.assign({ name: 'Zhaunil', img: '' }, api.zh || {});
    /* the card backs' mark is fetched now, so the first pack never deals blank backs */
    try { const im = new Image(); im.decoding = 'async'; im.src = LOGO; } catch (e) { /* fine */ }
    let cur = null;

    function lineFor(card) {
      let t = '';
      try { t = typeof api.mythicLine === 'function' ? String(api.mythicLine(card) || '') : ''; } catch (e) { t = ''; }
      return t.trim() || SAY;
    }
    /* the plain face: the portrait in the Hall's framing, the name, the tier */
    function standIn(card, rank) {
      const src = card.thumb || card.img || '';
      const art = h('div', { class: 'lpk-mini-art' });
      if (src) {
        const im = h('img', { src, alt: '', decoding: 'async', draggable: 'false', style: frameStyle(card) });
        im.addEventListener('error', () => im.remove(), { once: true });
        art.append(im);
      }
      return h('div', { class: 'lpk-mini' }, art, h('div', { class: 'lpk-mini-body' },
        h('div', { class: 'lpk-mini-name', text: card.name || 'Hero' }), h('div', { class: 'lpk-mini-tier', text: WORD[rank] })));
    }

    function open(cards, o) {
      if (cur) shut(cur, true);
      const list = (Array.isArray(cards) ? cards : cards ? [cards] : []).filter((c) => c && typeof c === 'object').slice(0, 5);
      if (!list.length) return Promise.resolve();
      styles();
      o = o || {};
      const still = RM(), n = list.length, mid = (n - 1) / 2;
      const host = F.el || document.querySelector(SC) || document.body;
      const title = String(o.title || 'Today’s pack');
      const S = { t0: performance.now(), gone: false, removed: false, state: 'dealing', finishing: false, lent: false, up: 0, timers: new Set(), intervals: new Set(),
        back: document.activeElement, resolve: null, root: null, made: [], onKey: null, onKeyUp: null, onResize: null, watch: 0 };
      const later = (fn, ms) => { const id = setTimeout(() => { S.timers.delete(id); if (!S.gone) fn(); }, ms); S.timers.add(id); return id; };
      /* the tap or key that opened the pack can land on it too: nothing answers in its first 300 ms */
      const early = () => performance.now() - S.t0 < 300;

      /* lowest rarity first, so the best card is last on the right (the Hall's order) */
      const sorted = list.map((card, k) => ({ card, k, rank: rankOf(card) })).sort((a, b) => (a.rank - b.rank) || (a.k - b.k));
      const mythics = sorted.filter((x) => x.rank === 5);

      const titleEl = h('h2', { class: 'lpk-title', text: title });
      const sub = h('p', { class: 'lpk-sub', text: String(o.sub || SUB[n] || 'Heroes for your binder.') });
      const row = h('div', { class: 'lpk-row' });
      const go = h('button', { type: 'button', class: 'lpk-go' },
        h('span', { class: 'lpk-go-a', text: String(o.button || 'Open a pack') }), h('span', { class: 'lpk-go-b', text: String(o.back || 'Back to the library') }));
      const live = h('p', { class: 'lpk-live', role: 'status', 'aria-live': 'polite' });
      let zhBox = null, zhLine = null;
      if (mythics.length) {
        zhLine = h('span', { class: 'lpk-zh-line', text: lineFor(mythics[0].card) });
        const face = zh.img ? h('img', { class: 'lpk-zh-img', src: zh.img, alt: '', decoding: 'async', draggable: 'false' }) : null;
        if (face) face.addEventListener('error', () => face.remove(), { once: true });
        zhBox = h('p', { class: 'lpk-zh', 'aria-hidden': 'true' }, face, h('span', { class: 'lpk-zh-t' }, h('span', { class: 'lpk-zh-who', text: zh.name }), zhLine));
      }
      const foot = h('div', { class: 'lpk-foot' }, zhBox, go);
      const stage = h('div', { class: 'lpk-stage' }, h('div', { class: 'lpk-head' }, titleEl, sub), row, foot);
      const root = h('div', { class: 'lpk is-n' + Math.min(n, 3) + (still ? ' is-still' : '') + (zhBox ? ' has-zh' : ''), role: 'dialog', 'aria-modal': 'true', 'aria-label': title }, stage, live);
      S.root = root;

      /* ---------- the Hall's card: back, face, idle sparks, aura ---------- */
      function cardEl(x, i) {
        const { card, rank } = x, tier = TIERS[rank];
        const slot = h('div', { class: 'lpk-slot' });
        const face = h('div', { class: 'lpk-face' }, slot);
        const back = h('div', { class: 'lpk-back' }, h('div', { class: 'lpk-miniback' }, h('img', { src: LOGO, alt: '', draggable: 'false' }), h('span', { text: 'Hall of Heroes' })));
        const inner = h('div', { class: 'lpk-inner' }, back, face);
        const shake = h('div', { class: 'lpk-shake' }, inner);
        const fx = h('div', { class: 'lpk-fx', 'aria-hidden': 'true' });
        const rot = n > 1 ? (i - mid) * 4 : 0;
        const el = h('div', { class: 'lpk-card is-' + tier + (!still && rank >= 3 ? ' is-aura' : ''), role: 'button', tabindex: '0', 'aria-label': 'Turn card ' + (i + 1) + ' of ' + n,
          'data-tier': tier, 'data-slug': card.slug || '',
          style: '--i:' + i + ';--rot:' + rot + 'deg;--k:' + Math.abs(i - mid) + ';--dx:' + Math.round((mid - i) * 22) + 'px;--dy:16px;--ds:.9' }, shake, fx);
        el.addEventListener('contextmenu', (e) => e.preventDefault());
        const glow = h('span', { class: 'lpk-glow is-' + tier + (!still && rank >= 3 ? ' is-aura' : ''), style: '--i:' + i + ';--rot:' + rot + 'deg;--k:' + Math.abs(i - mid) });
        const c = { el, inner, shake, fx, slot, card, rank, tier, idle: null, up: false, glow };
        /* Rare and up simmer with sparks off the back until they turn */
        if (!still && rank >= 2) {
          const lay = h('div', { class: 'lpk-idle', 'aria-hidden': 'true' }), cols = PALETTES[tier];
          el.appendChild(lay);
          const id = setInterval(() => {
            if (!lay.isConnected || S.gone) { clearInterval(id); S.intervals.delete(id); return; }
            const s = h('span', { class: 'lpk-i' + (rank >= 5 ? ' is-big' : ''), style: 'left:' + (8 + Math.random() * 84).toFixed(1) + '%;--icol:' + cols[(Math.random() * cols.length) | 0] +
              ';--idur:' + ((1100 + Math.random() * 700) | 0) + 'ms;--idx:' + ((Math.random() * 20 - 10) | 0) + 'px' });
            lay.appendChild(s); later(() => s.remove(), 2000);
          }, rank >= 5 ? 190 : rank === 4 ? 260 : rank === 3 ? 420 : 640);
          S.intervals.add(id); c.idle = { lay, id };
        }
        const act = () => {
          if (S.gone || S.lent) return;
          if (!c.up) { if (S.state !== 'done' && !early()) flip(c); return; }
          if (typeof api.zoom === 'function') lend(c);
        };
        el.addEventListener('click', act);
        return c;
      }
      S.made = sorted.map(cardEl);
      const glows = h('div', { class: 'lpk-glows', 'aria-hidden': 'true' });
      row.appendChild(glows);
      S.made.forEach((c) => { glows.appendChild(c.glow); row.appendChild(c.el); });
      /* each glow sits exactly where its card rests (its layout box; the fan's tilt is the same transform on both) */
      const place = () => S.made.forEach((c) => {
        const e = c.el, st = c.glow.style;
        st.left = e.offsetLeft + 'px'; st.top = e.offsetTop + 'px'; st.width = e.offsetWidth + 'px'; st.height = e.offsetHeight + 'px';
      });

      /* the face: the deck draws the Hall's; the plain one stands under it until then, and stays if it never comes */
      function paintFace(c) {
        const plain = standIn(c.card, c.rank);
        c.slot.parentNode.insertBefore(plain, c.slot);
        if (typeof api.face !== 'function') return;
        let p;
        try { p = api.face(c.card, c.slot); } catch (e) { return; }
        Promise.resolve(p).then(() => { if (c.slot.childNodes.length && plain.isConnected) plain.remove(); }, () => { /* the plain face stays */ });
      }
      const scale = () => { const w = S.made[0] && S.made[0].el.offsetWidth; if (w) root.style.setProperty('--lbc-k', (w / FACE_W).toFixed(4)); };
      /* side by side, once every card is up (reduced motion: from the start, so nothing moves later): each card's centre
         moves to an even step of its width plus a small gap, measured from where the fan put it, and the row shrinks a
         touch (never below 0.8) when the stage is too narrow; narrower than that, the fan stays */
      function spread() {
        if (S.gone || n < 2) return;
        const els = S.made.map((c) => c.el), w = els[0].offsetWidth, room = stage.clientWidth;
        if (!w || !room) return;
        const gap = Math.round(Math.max(8, Math.min(12, w * 0.05)));
        /* the outer cards' slight tilt pokes a corner out by about 2 percent of a width on each side */
        const sp = Math.min(1, (room - (n - 1) * gap) / (n * w + 2 * 0.02 * w));
        if (!(sp >= 0.8)) { root.classList.remove('is-spread'); return; }
        const at = els.map((e) => e.offsetLeft + e.offsetWidth / 2), m = (at[0] + at[n - 1]) / 2, step = w * sp + gap;
        S.made.forEach((c, i) => {
          const v = (Math.round((m + (i - mid) * step - at[i]) * 10) / 10) + 'px';
          c.el.style.setProperty('--sx', v); c.glow.style.setProperty('--sx', v);
        });
        root.style.setProperty('--lpk-sp', sp.toFixed(4));
        root.classList.add('is-spread');
      }

      /* ---------- the Hall's turn and burst ---------- */
      function burst(c) {
        const cols = PALETTES[c.tier], rank = c.rank, k = rank === 5 ? 46 : 8 + rank * 7, kids = [];
        if (rank >= 3) {
          kids.push(h('span', { class: 'lpk-flash', style: '--fcol:' + cols[0] }), h('span', { class: 'lpk-ring', style: '--rcol:' + cols[0] }));
          if (rank === 5) kids.push(h('span', { class: 'lpk-ring', style: '--rcol:' + cols[1] + ';animation-delay:150ms' }));
        }
        for (let i = 0; i < k; i++) {
          const ang = Math.random() * Math.PI * 2, dist = 36 + Math.random() * (rank >= 3 ? 130 : 90);
          kids.push(h('span', { class: 'lpk-p', style: '--pdx:' + (Math.cos(ang) * dist).toFixed(0) + 'px;--pdy:' + (Math.sin(ang) * dist).toFixed(0) + 'px;--pcol:' + cols[i % cols.length] +
            ';--pdur:' + ((700 + Math.random() * (rank >= 3 ? 900 : 700)) | 0) + 'ms' }));
        }
        c.fx.replaceChildren(...kids);
        if (rank >= 4) { c.shake.classList.remove('is-shaking'); void c.shake.offsetWidth; c.shake.classList.add('is-shaking'); later(() => c.shake.classList.remove('is-shaking'), 560); }
        if (rank === 5) { const at = performance.now(); loadConfetti().then((ok) => { if (ok && !S.gone && performance.now() - at < 1200) fireConfetti(); }); }
        later(() => c.fx.replaceChildren(), rank >= 3 ? 2300 : 1800);
      }
      function sayMythic(c) {
        snd('crit'); buzz(30);
        if (!zhBox) return;
        later(() => {
          const t = c === S.made.find((x) => x.rank === 5) ? zhLine.textContent : lineFor(c.card);
          /* his words arrive at the room's own pace as the box comes up (FFD.arrive, the talk box's arrival, when the
             page has it); the status line under the pack says them once, whole */
          if (!still && typeof FFD.arrive === 'function') { try { FFD.arrive(zhLine, t, { delay: 140 }); } catch (e) { zhLine.textContent = t; } }
          else zhLine.textContent = t;
          zhBox.classList.add('is-on'); zhBox.removeAttribute('aria-hidden');
          live.textContent = zh.name + '. ' + t;
        }, still ? 120 : 420);
      }
      function flip(c) {
        if (c.up) return;
        c.up = true; S.up++;
        const el = c.el;
        el.classList.remove('is-aura');
        c.glow.classList.remove('is-aura'); c.glow.classList.add('is-up');
        if (c.idle) { clearInterval(c.idle.id); S.intervals.delete(c.idle.id); c.idle.lay.remove(); c.idle = null; }
        el.classList.remove('is-flipping'); void el.offsetWidth; el.classList.add('is-flipping', 'is-up');
        const named = (c.card.name || 'Hero') + ', ' + WORD[c.rank];
        if (typeof api.zoom === 'function') el.setAttribute('aria-label', named + '. See it up close');
        else {
          /* nothing more to do with it: it leaves the tab order, and the keys move on to the next card down, or the button */
          const had = document.activeElement === el;
          el.setAttribute('role', 'img'); el.setAttribute('aria-label', named); el.removeAttribute('tabindex'); el.classList.add('is-still-card');
          if (had) { const nx = S.made.find((x) => !x.up); try { (nx ? nx.el : go).focus({ preventScroll: true }); } catch (e) { /* fine */ } }
        }
        live.textContent = named + '.';
        snd('flip');
        /* the sparks land over the middle of the turn, where the faces cross */
        if (!still) later(() => burst(c), 160);
        if (c.rank === 3) later(() => snd('chime'), 160);
        else if (c.rank === 4) later(() => { snd('gold'); buzz(18); }, 160);
        else if (c.rank === 5) later(() => sayMythic(c), 160);
        later(() => el.classList.remove('is-flipping'), still ? 200 : 560);
        if (S.up >= S.made.length) finish();
      }
      /* the last button waits until the last card has landed */
      function finish() {
        if (S.finishing) return;
        S.finishing = true;
        S.state = 'turning'; root.setAttribute('data-phase', 'turning'); go.setAttribute('aria-disabled', 'true');
        later(complete, still ? 220 : 600);
      }
      function complete() {
        S.state = 'done'; root.setAttribute('data-phase', 'done');
        go.classList.add('is-back'); go.removeAttribute('aria-disabled');
        spread();
        sub.textContent = String(o.done || (n === 1 ? 'It’s in your binder now.' : 'They’re in your binder now.'));
        if (!still && sub.animate) { try { sub.animate([{ opacity: 0.2 }, { opacity: 1 }], { duration: 240, easing: 'ease-out' }); } catch (e) { /* fine */ } }
        if (!zhBox || !zhBox.classList.contains('is-on')) live.textContent = sub.textContent;
      }
      /* a tap on a face-up card: the deck opens it big. A Promise back means the deck's layer is on top until it settles */
      function lend(c) {
        let r = null;
        try { r = api.zoom(c.card); } catch (e) { return; }
        if (!r || typeof r.then !== 'function') return;
        S.lent = true; root.classList.add('is-lent');
        const back = () => {
          if (S.gone) return;
          S.lent = false; root.classList.remove('is-lent');
          if (c.el.isConnected) { try { c.el.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
        };
        r.then(back, back);
      }

      go.addEventListener('click', () => {
        if (S.gone || S.lent) return;
        if (S.state === 'done') { shut(S); return; }
        if ((S.state !== 'ready' && S.state !== 'dealing') || early()) return;
        S.state = 'turning'; root.setAttribute('data-phase', 'turning'); go.setAttribute('aria-disabled', 'true');
        /* the rest turn a card at a time, 300 ms apart, as the Hall's Reveal does */
        S.made.filter((c) => !c.up).forEach((c, i) => later(() => flip(c), still ? 0 : i * 300));
      });
      /* a tap on the dim closes once every card is up (Escape closes at any time; the cards are already saved) */
      root.addEventListener('click', (e) => { if (S.state === 'done' && !S.lent && (e.target === root || e.target === stage || e.target === row || e.target === foot)) shut(S); });
      S.onKey = (e) => {
        if (S.gone || S.lent) return;
        const t = e.target;
        /* another dialog over the pack (the deck's zoom) keeps its own keys */
        if (t && t.nodeType === 1 && !root.contains(t) && t.closest && t.closest('[role="dialog"],[aria-modal="true"]')) return;
        if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopImmediatePropagation(); shut(S); return; }
        const fs = () => [...root.querySelectorAll('.lpk-card[tabindex="0"], .lpk-go')].filter((x) => x.getClientRects().length);
        const move = (back) => {
          const L = fs();
          if (!L.length) return;
          const i = L.indexOf(document.activeElement);
          const j = back ? (i <= 0 ? L.length - 1 : i - 1) : (i < 0 || i >= L.length - 1 ? 0 : i + 1);
          try { L[j].focus({ preventScroll: true }); } catch (err) { /* fine */ }
        };
        if (e.key === 'Tab') { e.preventDefault(); e.stopImmediatePropagation(); move(e.shiftKey); return; }
        /* the room's own keys (core.js: Enter, Space and the right arrow read on, or open its tap-to-continue gate) never
           reach the room under the dialog; the pack's card or button answers them here, before they could */
        if (!(t && t.nodeType === 1 && root.contains(t))) return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault(); e.stopImmediatePropagation();
          if (e.repeat) return;
          const card = t.closest('.lpk-card');
          if (go.contains(t)) go.click(); else if (card) card.click();
          return;
        }
        if (/^Arrow/.test(e.key)) {
          e.preventDefault(); e.stopImmediatePropagation();
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') move(e.key === 'ArrowLeft');
        }
      };
      /* a Space let go on the button would click it a second time */
      S.onKeyUp = (e) => {
        if (S.gone || S.lent) return;
        const t = e.target;
        if ((e.key === ' ' || e.key === 'Spacebar') && t && t.nodeType === 1 && root.contains(t)) { e.preventDefault(); e.stopImmediatePropagation(); }
      };
      window.addEventListener('keydown', S.onKey, true);
      window.addEventListener('keyup', S.onKeyUp, true);
      let rz = 0;
      S.onResize = () => { if (rz) return; rz = requestAnimationFrame(() => { rz = 0; if (!S.gone) { scale(); place(); if (still || S.state === 'done') spread(); } }); };
      window.addEventListener('resize', S.onResize);
      /* the room went (the page was left or torn down): nothing is left behind */
      S.watch = setInterval(() => { if (!root.isConnected) shut(S, true); }, 700);

      cur = S;
      S.host = host;
      host.appendChild(root);
      host.classList.add('lpk-up');
      scale();
      place();
      if (still) spread();
      S.made.forEach(paintFace);
      /* where the pack flies in from: each card starts over that spot, small, and deals out to its place in the fan */
      const from = rectOf(o.from);
      if (from && !still) {
        const fx = from.left + from.width / 2, fy = from.top + from.height / 2;
        S.made.forEach((c) => {
          const b = c.el.getBoundingClientRect();
          if (!b.width) return;
          const ds = Math.max(0.25, Math.min(0.9, (from.width || b.width * 0.5) / b.width));
          c.el.style.setProperty('--dx', Math.round(fx - (b.left + b.width / 2)) + 'px');
          c.el.style.setProperty('--dy', Math.round(fy - (b.top + b.height / 2)) + 'px');
          c.el.style.setProperty('--ds', ds.toFixed(3));
          c.el.style.setProperty('--deal', '.62s');
        });
      }
      /* the light comes up as each card lands in the fan */
      S.made.forEach((c, i) => later(() => c.glow.classList.add('is-on'), still ? 0 : (from ? 520 : 460) + i * 80));
      if (!still && mythics.length) loadConfetti();
      /* a forced reflow between showing and opening makes the fade and the deal play every time (the Hall's R246 note) */
      void root.offsetWidth; root.classList.add('is-open');
      try { go.focus({ preventScroll: true }); } catch (e) { /* fine */ }
      snd('whoosh');
      later(() => { if (S.state === 'dealing') { S.state = 'ready'; root.setAttribute('data-phase', 'ready'); } }, still ? 0 : (from ? 620 : 560) + Math.max(0, n - 1) * 80);
      root.setAttribute('data-phase', 'dealing');
      return new Promise((resolve) => { S.resolve = resolve; });
    }

    function shut(S, now) {
      if (!S || S.gone) return;
      S.gone = true;
      try { if (S.host) S.host.classList.remove('lpk-up'); } catch (e) { /* fine */ }
      S.timers.forEach(clearTimeout); S.timers.clear();
      S.intervals.forEach(clearInterval); S.intervals.clear();
      clearInterval(S.watch);
      window.removeEventListener('keydown', S.onKey, true); window.removeEventListener('keyup', S.onKeyUp, true);
      window.removeEventListener('resize', S.onResize);
      const root = S.root;
      const end = () => {
        if (S.removed) return;
        S.removed = true;
        const had = root.contains(document.activeElement) || document.activeElement === document.body || !document.activeElement;
        root.remove();
        if (cur === S) cur = null;
        /* focus goes back where it was before the pack, when nothing else has taken it */
        const b = S.back;
        if (had && b && b !== document.body && b.isConnected && typeof b.focus === 'function' && b.getClientRects().length) { try { b.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
        if (S.resolve) S.resolve();
      };
      if (now || !root.isConnected) { end(); return; }
      root.classList.add('is-shut'); root.classList.remove('is-open');
      setTimeout(end, RM() ? 210 : 260);
    }

    return {
      open,
      busy: () => !!cur,
      close: (now) => { if (cur) shut(cur, now === true || !!(now && now.now)); }
    };
  };
})();

/* ===== src/scene-pages/pages/library/study.js ===== */
/* library/study.js: the chair by the window (a part of the library page).
   Jan (2026-10-07): "there should be a chair by the window you can click on and its like study, and it will rotate between
   the chill normal jukebox songs and it changes it to a beautiful scene next to the window ... if its raining outside then
   have rain outside and obviously show the hourglass ... have a subtle counter in the corner like hours studied here by
   adventurers ... have the cat and owl ... subtly appear every like 5 to 15 minutes ... a mostly chill study scene for
   people to leave on."
   Jan (2026-10-08): "have the scene outslide slowly change as well, to different scenic beautiful pixel art and make the
   objects on the table interactiable, and let them cycle between the calm tracks and let them set a timer for how long
   they sit there for with the hour glass, and remember when the leave the table, the outside scene should be maintained
   in the window in obviously a less detailed way". The contract with the art is docs/scene-pages/jukebox/VISTAS.md.
   The reader sits down: the room leans in toward its window (a slow zoom) and the study fades up over it, about 1.2 s
   (under reduced motion a plain crossfade). The study is the painter's 'library-study' (src/scene-pages/scenes/library.js)
   on its own canvas, full screen over the room (z-index 20, under the fight's 30).
     Music   the three calm records in turn, quiet, hearth, after, each played to near the end of its loop and crossed into
             the next (api.calmTo(id) when the jukebox gives it, so the jukebox's record follows, else music.play). A calm
             record already playing carries on, and a road record gives way to Quiet Alehouse. The record's name sits in the
             corner as a button (it shows a few seconds when a record starts, and whenever the corner is awake), and it and
             the music box both play the next calm record, crossfaded the same way, the weather following. The turn of the
             records carries on from there. A record that never sounds is tried again, then the next one, twice at most,
             and never while the browser holds the music back until a tap, so the night never changes every few seconds.
     Weather follows the record, as the room's moods do: After Hours rain, Quiet Alehouse a clear starry night,
             Hearthside Echoes gentle snow.
     Views   the view outside, in turn town, coast, falls, isles, peaks, each held about 8 minutes of sitting (the study's
             clock, so a hidden tab holds it), then the next crossfades in (the scene's 'vista' { id, from, t0 }, 10 s).
             Zhaunil's crystal moves to the next one at once. A change always starts from a settled view: a crystal touched
             while one is still coming in glows and sounds at once, and its view follows as soon as that one has settled
             (the crystal glows again then), and the 8 minute turn waits the same way, so the slow dream never jumps. The
             view showing is kept per browser (localStorage 'ffd-library-vista', 'town' when none): the study starts on it,
             and when the reader stands up the room's window shows it, simpler (FFNoteScenes 'library' 'vista'; library.js
             sets the same on load through study.view()), in the weather of the record that plays on ('library'
             'vistaWx', set with every record and again on standing up).
     Place   the view's name (Town by the lake, Lighthouse by the sea and so on) fades in for about 5 s once a view has
             finished changing, and once after the welcome. Never a tap target, and it waits while Zhaunil talks.
     Words   the moon is the window's brightest thing, so no words sit on it. Upright the moon rides high in the arch, so
             Zhaunil's card and the place's name both live at the foot, on the seat's dark wood under the window (his
             card over the corner's lines, which rest while he talks, the name in the count's row for its few seconds).
             Wide, his card is at the foot and the name over the arch's head. On a phone on its side both sit along the
             top, and anything that would reach the moon or its glow moves aside, to whichever side of the moon has room
             (the moon crosses the window with the reader's clock, and the painter gives its place, lbsLay.moon, read
             in moonAt()).
     The sill every thing on it answers a tap (the scene's boxes, V.lbsLay, mapped to CSS pixels each frame they move).
             Each is a real button, at least 44 CSS px, never on top of another (two that would meet are cut back to the
             line between them), with a soft glow under the finger or the pointer, a brief bloom when it answers (warm by
             lamplight, moonlit in the dark room, except the lamp and the candle, which a touch lights) and a ring for the
             keyboard. Its label follows its state (Put the lamp out, Pour more tea, Water the ivy). Tab goes Back,
             sound, the record, then the sill left to right. Enter or Space taps. A layout the painter has not redrawn yet
             (the first moment after a phone turns) keeps the last good one. Jan (2026-10-11): "some of these items are
             useless and cluttered ... only remove that scroll thing and the random pillows". The seat has no pillows and
             no blanket now, so nothing there takes a tap (a box the scene still gives for them is never read).
     Play    Jan (2026-10-09): "make sure all the objects are dynamically interactable in a fun way". The design is
             PLAY-DESIGN (the play lane's research), and the values the art draws from are in docs/scene-pages/jukebox/
             VISTAS.md. The page decides everything (it counts the taps, rolls the rare things, plays the sounds) and the
             art draws from values, each with its start t0 on the scene's clock:
               ladders  taps on one thing within 2.5 s of each other climb its ladder (the ivy rustles, then lets a leaf
                        go, then two, then shivers; Footnote purrs, blinks slowly, stretches, then turns round; Soryndel
                        looks, knocks back on the glass, fluffs up, swivels her head; a quick tap on the book writes a line)
               lasting  the tea in the cup, the candle burning down, the book's page and its lines, the leaves on the
                        cushion, the pressed flower and the owl's feather stay for the visit (the value 'sill', no t0, so a
                        turned phone never replays them); the ivy's thirst and its flowers stay per browser
               combos   a flame hops from the candle to the lamp (or back), the teapot pours an empty cup and waters a
                        thirsty ivy on its way, Footnote pounces on a falling leaf, Soryndel bobs to the music box and reads
                        along with the book, the crystal in a dark room sends up dancing lights
               dark     the lamp has three steps (bright, low, out). With it and the candle both out the room is moonlit,
                        and on a clear night a falling star crosses every minute or so
               rare     a pixie in the ivy, a brass dragon in the music box, a pressed flower in the book, each with a count
                        kept per browser so a reader who plays is sure to meet it; a smoke ring, Zhaunil's blue candle, a
                        loop of steam, a ripple of stars, a feather on the ledge
               melody   under each sill thing's own sound one very soft note from the playing record's set, climbing while
                        taps follow each other; all eight sill things within 20 s play the set through once a sitting
               calm     a second tap on one thing within 220 ms is the first one's; six within 3 s and it rests for 3 s (only
                        its bloom and a muted note); a sound repeated quickly is a little softer each time, down to half
               hints    at most one line from Zhaunil a sitting, 6 to 12 minutes in, about something not found yet here
             Two answers wait for the art to say it draws them (lbsLay.can): the lamp's third step, out (with the ember
             and the dark room), and the crystal's quick portal (else its change is the 10 s dream, timed as such).
     Sounds  each answer has its own soft sound, made here with Web Audio through FFSound (its unlock and its mute): the
             lamp's wick, the candle snuffed, a flame catching, the cup set down, the teapot's trickle, leaves, the quill,
             the crystal's glass, the music box's comb and its ratchet in the next record's mood, the sand as the glass
             turns, Footnote's purr, Soryndel's hoot, her knock and her feathers, and the hourglass's bell. Each is
             scheduled on the audio clock, so nothing waits behind when the reader stands up. Nothing loud, nothing sharp.
     Hourglass free, it runs through in 25 minutes and turns itself over, one soft bell then (no words). Its panel (a tap
             on it): Set the hourglass, 15, 25, 45 or 60 minutes, or Let it run (the free turns), with a small pointer to
             the hourglass. The arrow keys move through it. The last time chosen is kept per browser and marked with a
             small dot. A time turns it over and starts the timer on the wall clock, so a hidden tab still ends on time;
             the corner shows the minutes left. At the end one soft bell (when it ends, or as soon as the tab shows if the
             page was asleep), the sand rests all in the bottom, the hourglass breathes a slow warm glow until it is
             touched, and Zhaunil's face and one line fade in like the welcome (three lines in turn, per browser).
             Standing up ends a timer quietly. Escape closes the panel first, and a tap anywhere else closes it.
     Visitors Footnote (the cat, a long nap on the sill) or Soryndel (the owl, on the ledge outside) every 5 to 15 minutes
             of study, the first within the first 90 s, and now and then a page of the open book turns. A visit carries its
             start (t0, the scene's clock), so a scene rebuilt mid-visit (a turned phone, a resize) picks it up.
     Counting the minutes spent here while the tab shows go to the shared 'library.study' count, 15 at a time (the key's
             max_step, and on leaving or hiding the tab whatever is waiting). Jan (2026-10-09): "make sure the minutes spent
             here is not minutes studied here, and start it at 830 minutes". Once the count is shared (FFD.tally.shared)
             the corner reads "830 minutes spent here by adventurers" and up, the 830 being the chair's story base
             (FFD.tally.base, shown in the total only, never sent and never the reader's own); the number counts up softly
             and glows warm for a moment when the reader's own minute joins it. Before that, "You’ve spent N minutes
             here", and at first "You’ve just sat down". Always minutes, with commas.
     Corner  "Back to the library", the sound button and the record, all fading after about 4 s without a pointer moving
             or a touch (never while the keyboard is on them). The count and a running timer's line stay, faint on a phone
             and plain on a wide screen (15 px and up there). A touch on the faded corner only shows it: the click of that
             same touch (within 0.6 s of the corner coming back) presses none of the buttons that were not showing, and a
             new touch presses them. On a phone on its side the lines run in one row
             (the count, the timer, the record) along the dark wood under the seat's piping.
     Welcome Jan (2026-10-08): "once they sit down maybe even have the guy say this is where adventurers study or whatever,
             feel free to hang out". Once the room has settled (about 2 s in), Zhaunil's face and one line fade in near the
             foot, hold about 6 s and fade out. It never takes a tap: a tap anywhere lets it go sooner, and so does Escape
             (which then leaves only on the next press). Three lines in turn, kept per browser, the first visit always gets
             the plainest one. Jan (2026-10-09): "the text comes in like kind of all at once and it feels buggy like when
             any character talks". So his card comes in first and his words follow it the way every character's do on
             every scene page (FFD.arrive, the box's own arrival: one word after another at a reading pace, a beat after
             a comma and a longer one after a full stop), the card already at its full size so nothing moves, and a longer
             line stays longer. A tap while his words come in shows them whole and leaves the card up a little longer to
             be read, and the next tap lets it go. Under reduced motion the card and its line only fade, together.
     Moon    the moon crosses the window on the reader's own clock (the scene's 'moon' { h, t0, rate, md }, set on sitting
             down, whenever the tab shows again, and again whenever the scene's clock has drifted over a minute and a half
             from the reader's. The hour is read here and never sent), and a view's change starts a moment after it is
             asked for, so its paint happens out of sight.
     Light   about 12 frames a second (the mount is made still and the part calls its _frame with the clock), none while
             the tab is hidden. The screen kept awake where the browser allows, and the room's own painter rests (its pan is
             moved off screen, so the painter's IntersectionObserver stops its loop) until the reader stands up.
   Every value the part sets carries t0 on the scene's clock (the seconds it passes to _frame), and each sitting starts that
   clock at 0, so opening the study clears the sill's old answers first (a lamp turned down or a snuffed candle stays so for
   the rest of the visit, without replaying its change). A sitting that ends while the next one already began (a quick
   Back and sit again) leaves the room's zoom and the visitors to the new one.
   The interface (library.js creates it once and closes it on teardown):
     FFD.parts['library/study'](api) -> study
       study.open() -> Promise<'left'>   the study until the reader leaves (the button, Escape, or close())
       study.busy() -> true while open   study.close()  take it away at once
       study.state() -> QA numbers, or null when closed (bells rung, the last sound asked for, the place showing, and
                        play { sill, last { k, act, n }, ... } for the sill at play)
       study.heard() -> the last sounds the study asked for, over every sitting (QA)
     FFD.parts['library/study'].view() -> the view kept in this browser ('town' when none)
     FFD.parts['library/study'].sounds(name, o) -> plays one of the study's own sounds (for the checks)
     FFD.parts['library/study'].kept() -> the sill's record kept in this browser, cleaned (for the checks)
   api: F (the room's frame: the overlay goes on F.el; F.art and its .lb-pan are what the zoom moves), h, RM(), snd(name, o),
     music (the room's player), rec() (the jukebox's record), calmTo(id) (optional), tally { add(key, n), total(key),
     mine(key), cap(key, n) optional, base(key, n) optional, on(fn) optional }, zh { name, img } (his face on the welcome).
   QA: window.__studyFast = 60 makes the minutes, the visitors, the views, the hourglass's times, the ivy's thirst and the
   candle's burning come 60 times sooner (the art still moves at its own pace). window.__studyCan = { out: 1, portal: 1 }
   stands in for the art's lbsLay.can, window.__studyCatPose ('sit' or 'curl') for its lbsLay.catPose (whether Footnote
   catches a falling leaf), window.__studyNoVisits = true holds back the visitors that come by themselves
   (for checks that bring their own), and window.__studyHour (0 to 24) stands in for the reader's clock (the moon's place).
   Nothing is sent but the minutes (through FFD.tally). Kept in this browser, and only here: the view, the hourglass's last
   time, which welcome and end line came last, and the sill's record ('ffd-library-study-play': the ivy's flowers, when it
   was last watered and the minutes sat since, the rare things' counts, the day a flower last fell from the book, the
   things already found). */
(() => {
  'use strict';
  const FFD = window.FFD = window.FFD || {};
  FFD.parts = FFD.parts || {};
  const CSS_ID = 'ffd-css-library-study', SK = 'library-study';
  const CALM = ['quiet', 'hearth', 'after'];
  /* the scene's hourglass runs through in 25 minutes (its value 'hour'), so a long sit has a gentle rhythm */
  const HOUR = 1500;
  const WX = { quiet: 'clear', hearth: 'snow', after: 'rain' };
  const NAMES = { quiet: 'Quiet Alehouse', hearth: 'Hearthside Echoes', after: 'After Hours' };
  /* the views outside, in turn (docs/scene-pages/jukebox/VISTAS.md), each held about 8 minutes of sitting */
  const VIEWS = ['town', 'coast', 'falls', 'isles', 'peaks'], VIEW_MS = 8 * 60000, VIEW_KEY = 'ffd-library-vista';
  /* the hourglass's times in minutes, and the scene's turn over (a lift and a half turn) in seconds */
  const TIMES = [15, 25, 45, 60], FLP = 0.8;
  /* the smallest tap target, in CSS px */
  const TAP_MIN = 44;
  /* the sill's things and the two visitors, in the order their buttons are made (Tab follows where they stand, left to
     right). Only these: a box the scene gives for anything else (the old pillows and blanket) is never read */
  const TAPS = ['lamp', 'crystal', 'glass', 'box', 'cup', 'candle', 'ivy', 'book', 'cat', 'owl'];
  /* the eight things on the sill that sing a note and make the sill's song */
  const SONG = ['lamp', 'crystal', 'glass', 'box', 'cup', 'candle', 'ivy', 'book'];
  /* the melody of the sill, from the note sets of the music box (semitones over C6) for each calm record */
  const NOTES = { quiet: [0, 4, 7, 9, 12], hearth: [0, 2, 4, 7], after: [7, 9, 12, 14, 16] };
  /* the timings of the play in seconds. A streak's window, the flame's hop between candle and lamp, the teapot's pour, the
     crystal's portal (the page waits a little longer than the art's 2.4 s), the owl's stay, the candle's life in minutes,
     the ivy's thirst at which it asks for water */
  const STREAK = 2.5, EMBER = 1.4, POUR = 2.6, CPD = 2.6, OWL_STAY = 9.6, BURN = 90, THIRSTY = 0.6;
  const CAT_ACTS = ['purr', 'blink', 'stretch', 'purr', 'turn'], OWL_ACTS = ['look', 'knock', 'fluff', 'swivel'];
  /* the sill's record, kept per browser (a convenience only, nothing of it is sent) */
  const PLAY_KEY = 'ffd-library-study-play', FOUND = ['dark', 'turn', 'water', 'knock', 'pour', 'song'];
  /* Jan (2026-10-09): "start it at 830 minutes". A story base: shown in the shared total only, never sent, never the
     reader's own */
  const START = 830;
  const ICON_ON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9.5h3.2L12 5.6v12.8l-4.8-3.9H4z" fill="currentColor"/><path d="M15.2 9a4.3 4.3 0 0 1 0 6M17.6 6.6a7.6 7.6 0 0 1 0 10.8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  const ICON_OFF = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9.5h3.2L12 5.6v12.8l-4.8-3.9H4z" fill="currentColor"/><path d="M15.5 9.5l5 5M20.5 9.5l-5 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  const ICON_NOTE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 17.5V6.2l10-2v11.3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><ellipse cx="6.6" cy="17.6" rx="2.6" ry="2" fill="currentColor"/><ellipse cx="16.6" cy="15.6" rx="2.6" ry="2" fill="currentColor"/></svg>';
  const ICON_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 6.5l6.5 5.5L5 17.5zM12.5 6.5l6.5 5.5-6.5 5.5z" fill="currentColor"/></svg>';
  const ICON_GLASS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 3.8h11M6.5 20.2h11M8 3.8c0 4.6 8 4.9 8 8.2s-8 3.6-8 8.2M16 3.8c0 4.6-8 4.9-8 8.2s8 3.6 8 8.2" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  const ICON_BACK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14.5 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const P = '.ffd-page--library ';
  const CSS = `
${P}.lbs { position: fixed; left: 0; top: 0; z-index: 20; display: block; width: 100%; height: 100vh; height: 100svh; overflow: hidden; background: #07080c; opacity: 0; transition: opacity .6s ease .45s; -webkit-tap-highlight-color: transparent; user-select: none; -webkit-user-select: none; outline: none; }
${P}.lbs.is-in { opacity: 1; }
${P}.lbs.is-out { opacity: 0; transition: opacity .5s ease; }
/* the study fading away takes no tap (its buttons neither), so the chair answers at once when tapped again */
${P}.lbs.is-out, ${P}.lbs.is-out * { pointer-events: none !important; }
${P}.lbs-art { position: absolute; inset: 0; display: block; overflow: hidden; transform: scale(1.08); transform-origin: 50% 40%; transition: transform 1s cubic-bezier(.25, .1, .2, 1) .35s; }
${P}.lbs.is-in .lbs-art { transform: none; }
${P}.lbs-shade { position: absolute; inset: 0; display: block; pointer-events: none; background: linear-gradient(to bottom, rgba(5, 6, 9, .42) 0, rgba(5, 6, 9, 0) 16%, rgba(5, 6, 9, 0) 80%, rgba(5, 6, 9, .5) 100%); }
${P}.lbs-taps { position: absolute; inset: 0; display: block; pointer-events: none; }
${P}.lbs-tap { position: absolute; left: 0; top: 0; display: block; box-sizing: border-box; width: 44px; height: 44px; min-width: 0; margin: 0; padding: 0; border: 0; border-radius: 12px; background: transparent; box-shadow: none; color: inherit; font: inherit; cursor: pointer; pointer-events: auto; touch-action: manipulation; -webkit-tap-highlight-color: transparent; -webkit-appearance: none; appearance: none; outline: none; }
${P}.lbs-tap[hidden] { display: none; }
${P}.lbs-tap { --g: 255, 214, 150; }
${P}.lbs-tap[data-k="crystal"] { --g: 150, 205, 255; }
${P}.lbs-tap[data-k="ivy"] { --g: 200, 236, 170; }
${P}.lbs-tap[data-k="owl"] { --g: 196, 214, 255; }
${P}.lbs-tap[data-k="book"] { --g: 255, 236, 204; }
${P}.lbs-tap[data-k="box"] { --g: 255, 206, 120; }
/* in the dark room (the lamp and the candle out) a touch glows like moonlight, so no warm light comes on where none is;
   the lamp and the candle keep their warm glow (a touch lights them) */
${P}.lbs.is-dark .lbs-tap:not([data-k="lamp"]):not([data-k="candle"]):not([data-k="crystal"]) { --g: 188, 204, 255; }
/* the glows add light to the night (screen), only while one shows, so a still frame costs nothing extra */
${P}.lbs-tap::after { content: ''; position: absolute; inset: -18px; border-radius: 50%; background: radial-gradient(closest-side, rgba(var(--g), .6), rgba(var(--g), .26) 48%, rgba(var(--g), 0)); opacity: 0; pointer-events: none; transition: opacity .22s ease; }
@media (hover: hover) and (pointer: fine) { ${P}.lbs-tap:hover::after { opacity: .55; mix-blend-mode: screen; } }
${P}.lbs-tap:active::after { opacity: 1; mix-blend-mode: screen; transition: opacity .06s ease; }
${P}.lbs-tap.is-hit::after { mix-blend-mode: screen; animation: lbs-hit .9s cubic-bezier(.2, .7, .2, 1) both; }
${P}.lbs-tap.is-done::before { content: ''; position: absolute; inset: -40px -34px; border-radius: 50%; background: radial-gradient(closest-side, rgba(255, 196, 112, .62), rgba(255, 176, 92, .26) 45%, rgba(255, 170, 90, 0)); mix-blend-mode: screen; pointer-events: none; animation: lbs-breathe 3.4s ease-in-out 6 both; }
@keyframes lbs-hit { 0% { opacity: 0; transform: scale(.7); } 20% { opacity: 1; transform: scale(1); } 100% { opacity: 0; transform: scale(1.35); } }
@keyframes lbs-breathe { 0%, 100% { opacity: .3; transform: scale(.94); } 50% { opacity: 1; transform: scale(1.06); } }
${P}.lbs-tap:focus-visible { outline: 2px solid #e7c97f; outline-offset: 2px; }
${P}.lbs-ui { position: absolute; inset: 0; display: block; pointer-events: none; transition: opacity .32s ease; }
${P}.lbs.is-idle .lbs-ui { opacity: 0; }
${P}.lbs.is-idle .lbs-ui button { pointer-events: none; }
${P}.lbs-top { position: absolute; left: 0; right: 0; top: 0; display: flex; justify-content: space-between; align-items: center; gap: 12px; padding: max(12px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right)) 0 max(16px, env(safe-area-inset-left)); }
${P}.lbs-back, ${P}.lbs-snd { pointer-events: auto; margin: 0; min-height: 44px; border-radius: 999px; border: 1px solid rgba(255, 236, 200, .2); background: rgba(9, 8, 7, .52); color: #eadfc6; cursor: pointer; -webkit-appearance: none; appearance: none; transition: background .2s ease, border-color .2s ease, color .2s ease, transform .12s ease; }
${P}.lbs-back { display: inline-flex; align-items: center; gap: 4px; padding: 6px 16px 6px 10px; font: 600 14px/1.2 var(--f-body, 'Spectral', Georgia, serif); }
${P}.lbs-back svg { width: 18px; height: 18px; flex: none; }
${P}.lbs-snd { display: inline-grid; place-items: center; width: 44px; padding: 0; }
${P}.lbs-snd svg { width: 22px; height: 22px; }
${P}.lbs-back:hover, ${P}.lbs-snd:hover { background: rgba(30, 22, 12, .78); border-color: rgba(231, 201, 127, .6); color: #fff6dc; }
${P}.lbs-back:active, ${P}.lbs-snd:active { transform: scale(.97); }
${P}.lbs-back:focus-visible, ${P}.lbs-snd:focus-visible { outline: 2px solid #e7c97f; outline-offset: 3px; }
${P}.lbs-low { position: absolute; left: 0; bottom: 0; display: grid; justify-items: start; gap: 4px; max-width: min(92vw, 520px); padding: 0 max(16px, env(safe-area-inset-right)) max(14px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left)); pointer-events: none; transition: opacity .5s ease; }
${P}.lbs-rec { pointer-events: auto; display: inline-flex; align-items: center; gap: 7px; box-sizing: border-box; min-height: 44px; margin: -10px 0 -8px -10px; padding: 0 12px 0 10px; border: 0; border-radius: 999px; background: transparent; box-shadow: none; font: italic 500 clamp(16px, .85vw, 21px)/1.25 var(--f-aside, 'Cormorant Garamond', Georgia, serif); letter-spacing: normal; text-transform: none; color: #f6e9cb; text-shadow: 0 1px 8px rgba(0, 0, 0, .9); cursor: pointer; opacity: .9; transform: none; -webkit-appearance: none; appearance: none; transition: opacity .32s ease, background .2s ease, transform .7s ease; }
${P}.lbs-rec svg { width: 15px; height: 15px; color: #e7c97f; flex: none; }
${P}.lbs-rec-x { display: inline-grid; place-items: center; margin-left: 1px; opacity: .72; transition: opacity .2s ease, transform .2s ease; }
${P}.lbs-rec-x svg { width: 13px; height: 13px; color: #f6e9cb; }
${P}.lbs-rec-w { position: relative; display: inline-block; }
${P}.lbs-rec-n.is-in { animation: lbs-up .3s cubic-bezier(.2, .7, .2, 1) .06s both; }
${P}.lbs-rec-old { position: absolute; left: 0; top: 0; white-space: nowrap; pointer-events: none; animation: lbs-rec-out .26s ease forwards; }
@keyframes lbs-rec-out { to { opacity: 0; transform: translateY(-7px); } }
${P}.lbs-rec:hover { background: rgba(20, 14, 8, .55); }
${P}.lbs-rec:hover .lbs-rec-x { opacity: 1; transform: translateX(1px); }
${P}.lbs-rec:active { transform: scale(.98); transition: transform .12s ease; }
${P}.lbs-rec:focus-visible { outline: 2px solid #e7c97f; outline-offset: 1px; }
${P}.lbs.is-idle .lbs-rec:not(.is-on) { opacity: 0; pointer-events: none; }
${P}.lbs-rec.is-on { opacity: .96; }
${P}.lbs-rec.is-new { animation: lbs-rec-in .7s ease both; }
@keyframes lbs-rec-in { from { opacity: 0; transform: translateY(5px); } to { opacity: .96; transform: none; } }
${P}.lbs-left { display: inline-flex; align-items: center; gap: 6px; margin: 0; font: 500 clamp(12.5px, .7vw, 16px)/1.35 var(--f-body, 'Spectral', Georgia, serif); letter-spacing: .02em; color: rgba(246, 226, 186, .92); text-shadow: 0 1px 5px rgba(0, 0, 0, .95); font-variant-numeric: tabular-nums; transition: opacity .6s ease; }
${P}.lbs-left[hidden] { display: none; }
${P}.lbs-left.is-new { animation: lbs-up .6s ease; }
@keyframes lbs-up { from { opacity: 0; transform: translateY(4px); } }
${P}.lbs-left svg { width: 14px; height: 14px; color: #e7c97f; flex: none; }
${P}.lbs.is-idle .lbs-left { opacity: .7; }
${P}.lbs-count { margin: 0; font: 500 clamp(12.5px, .7vw, 16px)/1.35 var(--f-body, 'Spectral', Georgia, serif); letter-spacing: .02em; color: rgba(242, 230, 206, .86); text-shadow: 0 1px 5px rgba(0, 0, 0, .95); font-variant-numeric: tabular-nums; transition: opacity .6s ease; }
${P}.lbs.is-idle .lbs-count { opacity: .55; }
${P}.lbs-n { display: inline-block; border-radius: 4px; }
/* the reader's own minute joins everyone's: the number warms for a moment (no flash, it rises and settles) */
${P}.lbs-n.is-mine { animation: lbs-mine 1.6s ease both; }
@keyframes lbs-mine { 0% { color: inherit; text-shadow: 0 1px 5px rgba(0, 0, 0, .95); } 35% { color: #ffe2a2; text-shadow: 0 0 9px rgba(255, 190, 104, .7), 0 1px 5px rgba(0, 0, 0, .95); } 100% { color: inherit; text-shadow: 0 1px 5px rgba(0, 0, 0, .95); } }
${P}.lbs.is-idle .lbs-count.is-mine { opacity: .86; }
${P}.lbs-sr { position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; border: 0; }
${P}.lbs-place { position: absolute; left: 50%; top: max(12px, env(safe-area-inset-top)); z-index: 2; display: flex; align-items: center; gap: 12px; box-sizing: border-box; height: 44px; max-width: calc(100% - 32px); margin: 0; padding: 0 22px; background: radial-gradient(50% 50% at 50% 50%, rgba(7, 7, 12, .5), rgba(7, 7, 12, .28) 62%, rgba(7, 7, 12, 0)); font: italic 500 clamp(18px, 1.3vw, 26px)/1.1 var(--f-aside, 'Cormorant Garamond', Georgia, serif); letter-spacing: .01em; color: #f3e8cf; text-shadow: 0 1px 10px rgba(0, 0, 0, .95), 0 0 2px rgba(0, 0, 0, .7); white-space: nowrap; pointer-events: none; opacity: 0; visibility: hidden; transform: translate(-50%, 5px); transition: opacity 1.3s ease, transform 1.3s ease, visibility 0s linear 1.3s; }
${P}.lbs-place::before, ${P}.lbs-place::after { content: ''; flex: none; width: clamp(14px, 2vw, 34px); height: 1px; background: linear-gradient(to right, rgba(231, 201, 127, 0), rgba(231, 201, 127, .75)); }
${P}.lbs-place::after { background: linear-gradient(to left, rgba(231, 201, 127, 0), rgba(231, 201, 127, .75)); }
${P}.lbs-place.is-on { opacity: .96; visibility: visible; transform: translate(-50%, 0); transition: opacity 1s ease, transform 1s cubic-bezier(.2, .7, .2, 1), visibility 0s; }
${P}.lbs.is-talk .lbs-place { opacity: 0; visibility: hidden; }
${P}.lbs-hello { position: absolute; left: 50%; bottom: calc(max(14px, env(safe-area-inset-bottom)) + 58px); display: flex; align-items: center; gap: 10px; box-sizing: border-box; width: max-content; max-width: min(460px, calc(100% - 32px)); margin: 0; padding: 8px 16px 8px 8px; border-radius: 12px; border: 1px solid rgba(232, 198, 116, .3); background: rgba(14, 10, 7, .74); box-shadow: 0 10px 30px rgba(0, 0, 0, .45); text-align: left; pointer-events: none; opacity: 0; visibility: hidden; transform: translate(-50%, 8px); transition: opacity .7s ease, transform .7s cubic-bezier(.2, .7, .2, 1), visibility 0s linear .7s; }
${P}.lbs-hello.is-on { opacity: 1; visibility: visible; transform: translate(-50%, 0); transition: opacity .7s ease, transform .7s cubic-bezier(.2, .7, .2, 1), visibility 0s; }
${P}.lbs-hello.is-off { opacity: 0; visibility: hidden; transform: translate(-50%, 0); transition: opacity .8s ease, visibility 0s linear .8s; }
${P}.lbs-hello-img { width: 40px; height: 40px; flex: 0 0 auto; object-fit: cover; border-radius: 6px; border: 1.5px solid rgba(200, 164, 94, .8); box-shadow: 0 0 0 2px rgba(200, 164, 94, .12), 0 0 10px rgba(232, 198, 116, .2); }
${P}.lbs-hello-t { display: block; min-width: 0; }
${P}.lbs-hello-who { display: block; font: italic 600 13.5px/1.2 var(--f-aside, 'Cormorant Garamond', Georgia, serif); color: #e7c97f; }
${P}.lbs-hello-line { display: block; margin-top: 2px; font: italic 500 16.5px/1.3 var(--f-aside, 'Cormorant Garamond', Georgia, serif); color: #f1e6cf; text-wrap: pretty; }
/* his words come in one after another once the card is there (each already holds its place, so nothing moves) */
${P}.lbs-w { display: inline-block; animation: lbs-w .46s cubic-bezier(.2, .7, .2, 1) both; }
@keyframes lbs-w { from { opacity: 0; transform: translateY(3px); } }
${P}.lbs-hg { --ax: 50%; --ay: 50%; position: absolute; left: 16px; top: 16px; z-index: 3; display: block; box-sizing: border-box; width: max-content; max-width: calc(100% - 24px); margin: 0; padding: 13px 13px 13px; border-radius: 16px; border: 1px solid rgba(232, 198, 116, .36); background: linear-gradient(180deg, rgb(33, 24, 15), rgb(17, 12, 9)); box-shadow: 0 18px 44px rgba(0, 0, 0, .55), 0 0 0 4px rgba(232, 198, 116, .05), inset 0 1px 0 rgba(255, 236, 200, .08); text-align: left; opacity: 0; visibility: hidden; transform: translateY(8px) scale(.98); transform-origin: var(--ax) 100%; pointer-events: none; transition: opacity .2s ease, transform .26s cubic-bezier(.2, .7, .2, 1), visibility 0s linear .26s; }
${P}.lbs-hg[data-side="right"] { transform: translateX(-8px) scale(.98); transform-origin: 0 var(--ay); }
${P}.lbs-hg[data-side="left"] { transform: translateX(8px) scale(.98); transform-origin: 100% var(--ay); }
${P}.lbs-hg.is-on { opacity: 1; visibility: visible; transform: none; pointer-events: auto; transition: opacity .2s ease, transform .26s cubic-bezier(.2, .7, .2, 1), visibility 0s; }
${P}.lbs-hg::before { content: ''; position: absolute; left: calc(var(--ax) - 7px); bottom: -7px; width: 12px; height: 12px; border: 1px solid rgba(232, 198, 116, .36); border-width: 0 1px 1px 0; background: rgb(17, 12, 9); transform: rotate(45deg); pointer-events: none; }
${P}.lbs-hg[data-side="right"]::before { left: -7px; top: calc(var(--ay) - 7px); bottom: auto; border-width: 0 0 1px 1px; background: rgb(25, 18, 12); }
${P}.lbs-hg[data-side="left"]::before { left: auto; right: -7px; top: calc(var(--ay) - 7px); bottom: auto; border-width: 1px 1px 0 0; background: rgb(25, 18, 12); }
${P}.lbs-hg-t { display: flex; align-items: center; gap: 8px; margin: 0 3px 11px; font: italic 600 17px/1.2 var(--f-aside, 'Cormorant Garamond', Georgia, serif); letter-spacing: .01em; color: #e7c97f; }
${P}.lbs-hg-t svg { width: 16px; height: 16px; flex: none; opacity: .9; }
${P}.lbs-hg-row { display: grid; grid-template-columns: repeat(4, 56px); gap: 7px; }
${P}.lbs-hg button { position: relative; display: grid; place-items: center; align-content: center; gap: 3px; box-sizing: border-box; min-width: 44px; min-height: 54px; margin: 0; padding: 4px 2px; border-radius: 12px; border: 1px solid rgba(255, 236, 200, .16); background: linear-gradient(180deg, rgba(255, 240, 210, .08), rgba(255, 240, 210, .03)); box-shadow: inset 0 1px 0 rgba(255, 240, 210, .05); color: #f1e6cf; font: 600 19px/1 var(--f-body, 'Spectral', Georgia, serif); letter-spacing: normal; text-transform: none; font-variant-numeric: tabular-nums; cursor: pointer; -webkit-appearance: none; appearance: none; transition: background .18s ease, border-color .18s ease, color .18s ease, transform .12s ease, opacity .2s ease; }
${P}.lbs-hg button small { display: block; font: 500 11px/1 var(--f-body, 'Spectral', Georgia, serif); letter-spacing: .06em; color: rgba(241, 230, 207, .62); }
${P}.lbs-hg button[data-last]::after { content: ''; position: absolute; right: 7px; top: 7px; width: 5px; height: 5px; border-radius: 50%; background: #e7c97f; box-shadow: 0 0 6px rgba(231, 201, 127, .7); opacity: .85; }
${P}.lbs-hg button:hover { border-color: rgba(231, 201, 127, .6); background: rgba(231, 201, 127, .13); color: #fff6dc; }
${P}.lbs-hg button:active { transform: scale(.95); }
${P}.lbs-hg button[aria-pressed="true"] { border-color: #e7c97f; background: linear-gradient(180deg, rgba(231, 201, 127, .28), rgba(231, 201, 127, .14)); color: #fff6dc; box-shadow: inset 0 1px 0 rgba(255, 240, 210, .12), 0 0 14px rgba(231, 201, 127, .18); }
${P}.lbs-hg button[aria-pressed="true"] small { color: rgba(255, 246, 220, .8); }
${P}.lbs-hg button:focus-visible { outline: 2px solid #e7c97f; outline-offset: 2px; }
${P}.lbs-hg .lbs-hg-free { width: 100%; min-height: 46px; margin-top: 7px; font: italic 500 17px/1.2 var(--f-aside, 'Cormorant Garamond', Georgia, serif); }
${P}.lbs-hg .lbs-hg-row button, ${P}.lbs-hg .lbs-hg-free { opacity: 0; transform: translateY(4px); }
${P}.lbs-hg.is-on .lbs-hg-row button, ${P}.lbs-hg.is-on .lbs-hg-free { opacity: 1; transform: none; transition: background .18s ease, border-color .18s ease, color .18s ease, transform .2s cubic-bezier(.2, .7, .2, 1), opacity .2s ease; }
${P}.lbs-hg.is-on .lbs-hg-row button:nth-child(2) { transition-delay: 0s, 0s, 0s, .03s, .03s; }
${P}.lbs-hg.is-on .lbs-hg-row button:nth-child(3) { transition-delay: 0s, 0s, 0s, .06s, .06s; }
${P}.lbs-hg.is-on .lbs-hg-row button:nth-child(4) { transition-delay: 0s, 0s, 0s, .09s, .09s; }
${P}.lbs-hg.is-on .lbs-hg-free { transition-delay: 0s, 0s, 0s, .12s, .12s; }
${P}.lbs-hg.is-on .lbs-hg-row button:active, ${P}.lbs-hg.is-on .lbs-hg-free:active { transform: scale(.95); transition-delay: 0s; }
@media (min-width: 1000px) {
  ${P}.lbs-hello { bottom: max(18px, env(safe-area-inset-bottom)); max-width: min(clamp(460px, 26vw, 620px), calc(100% - 32px)); }
  ${P}.lbs-hello-img { width: clamp(40px, 2vw, 52px); height: clamp(40px, 2vw, 52px); }
  ${P}.lbs-hello-who { font-size: clamp(13.5px, .72vw, 17px); }
  ${P}.lbs-hello-line { font-size: clamp(16.5px, .9vw, 22px); }
  ${P}.lbs-hg { padding: 15px 15px 15px; }
  ${P}.lbs-hg-t { font-size: 18px; margin-bottom: 12px; }
  ${P}.lbs-hg-row { grid-template-columns: repeat(4, 62px); gap: 8px; }
  ${P}.lbs-hg button { min-height: 58px; font-size: 21px; }
  ${P}.lbs-hg .lbs-hg-free { min-height: 48px; font-size: 18px; }
  /* on a wide screen the corner's two lines (the minutes and the hourglass's) read at a glance: larger, and plain at rest,
     since they are words to read and not controls that wait for a hand (only the record's name fades with the buttons).
     The record's name, in the narrower italic, grows with them so the three read as one family */
  ${P}.lbs-left, ${P}.lbs-count { font-size: clamp(15px, .82vw, 19px); }
  ${P}.lbs-rec { font-size: clamp(18px, .95vw, 23px); }
  ${P}.lbs-left svg { width: 16px; height: 16px; }
  ${P}.lbs-count { color: rgba(244, 233, 210, .94); }
  ${P}.lbs.is-idle .lbs-left, ${P}.lbs.is-idle .lbs-count, ${P}.lbs.is-idle .lbs-count.is-mine { opacity: .9; }
}
/* on an upright phone the top bar is full, so the place's name sits just under it, over the sky */
@media (max-width: 560px) { ${P}.lbs-place { top: calc(max(12px, env(safe-area-inset-top)) + 54px); } }
/* on phones and narrow windows the welcome sits high, over the sky under the Back button, clear of the sill and the book;
   on a phone on its side it sits in the top bar between the Back and sound buttons */
@media (max-width: 999px) { ${P}.lbs-hello { top: calc(max(12px, env(safe-area-inset-top)) + 60px); bottom: auto; } }
/* upright (the painter's tall arch, under 4 wide to 5 high) the moon rides high in the arch, right where words under the
   top bar would fall. So Zhaunil's card and the place's name live at the foot, on the seat's dark wood under the window.
   His card lies over the corner's lines, which rest (and take no tap) while he talks. The name takes the count's row,
   the count resting for the few seconds it shows */
@media (max-aspect-ratio: 4/5) {
  ${P}.lbs-hello { top: auto; bottom: max(14px, env(safe-area-inset-bottom)); }
  ${P}.lbs-place { top: auto; bottom: calc(max(14px, env(safe-area-inset-bottom)) - 13px); }
  ${P}.lbs.is-talk .lbs-low { opacity: 0; }
  ${P}.lbs.is-talk .lbs-low button { pointer-events: none; }
  ${P}.lbs.is-place .lbs-count, ${P}.lbs.is-idle.is-place .lbs-count { opacity: 0; transition: opacity .8s ease; }
  /* they take turns in the row: the name comes once the count has gone (0.8 s), and the count comes back once the name
     has gone (the study keeps is-place until then) */
  ${P}.lbs-place.is-on { transition-delay: .8s; }
}
@media (max-height: 500px) {
  ${P}.lbs-place { padding: 0 14px; }
  ${P}.lbs-hello { top: max(12px, env(safe-area-inset-top)); bottom: auto; max-width: min(420px, calc(100% - 380px)); gap: 8px; padding: 5px 12px 5px 5px; }
  ${P}.lbs-hello-img { width: 32px; height: 32px; }
  ${P}.lbs-hello-who { font-size: 12.5px; }
  ${P}.lbs-hello-line { margin-top: 1px; font-size: 14.5px; line-height: 1.25; }
  ${P}.lbs-hg { padding: 10px 11px 11px; }
  ${P}.lbs-hg-t { margin-bottom: 8px; }
  ${P}.lbs-hg button { min-height: 47px; }
  ${P}.lbs-hg .lbs-hg-free { min-height: 44px; margin-top: 6px; }
}
/* a phone on its side: the seat comes down near the screen's foot, so a stack of lines would lie across the seat's gold
   piping. The corner's lines run in one row along the dark wood under the piping instead, the minutes first (always
   there), then the hourglass's time, then the record's name (which fades at rest and so leaves no gap at the start of the
   row). A screen too narrow for the row lifts the record above it */
@media (max-height: 500px) and (min-aspect-ratio: 3/2) {
  ${P}.lbs-low { right: 0; display: flex; flex-wrap: wrap-reverse; align-items: center; justify-content: flex-start; gap: 0 20px; max-width: none; padding-bottom: max(6px, env(safe-area-inset-bottom)); }
  ${P}.lbs-count { order: 1; white-space: nowrap; }
  ${P}.lbs-left { order: 2; white-space: nowrap; }
  ${P}.lbs-rec { order: 3; margin: 0 0 0 -10px; }
}
@media (prefers-reduced-motion: reduce) {
  ${P}.lbs { transition: opacity .35s ease; }
  ${P}.lbs-art, ${P}.lbs.is-in .lbs-art { transform: none; transition: none; }
  ${P}.lbs-rec, ${P}.lbs-rec:active, ${P}.lbs-rec:hover .lbs-rec-x { transform: none; }
  ${P}.lbs-rec.is-new, ${P}.lbs-left.is-new { animation: none; }
  ${P}.lbs-hello, ${P}.lbs-hello.is-on, ${P}.lbs-hello.is-off { transform: translate(-50%, 0); }
  ${P}.lbs-hg, ${P}.lbs-hg.is-on, ${P}.lbs-hg[data-side] { transform: none; transition: opacity .2s ease, visibility 0s linear .2s; }
  ${P}.lbs-hg.is-on { transition: opacity .2s ease, visibility 0s; }
  ${P}.lbs-hg button:active, ${P}.lbs-hg .lbs-hg-row button, ${P}.lbs-hg .lbs-hg-free, ${P}.lbs-hg.is-on .lbs-hg-row button:active, ${P}.lbs-hg.is-on .lbs-hg-free:active { transform: none; }
  ${P}.lbs-place, ${P}.lbs-place.is-on { transform: translate(-50%, 0); }
  ${P}.lbs-tap.is-hit::after { animation-name: lbs-hit-still; }
  ${P}.lbs-tap.is-done::before { animation: none; opacity: .75; }
  ${P}.lbs-n.is-mine, ${P}.lbs-w { animation: none; }
  @keyframes lbs-hit-still { 0% { opacity: 0; } 22% { opacity: 1; } 100% { opacity: 0; } }
}`;
  /* Zhaunil's welcome, in his voice: the first one is the plainest, then they take turns (kept per browser) */
  const HELLO = [
    'This is where adventurers come to study. Stay as long as you like, the music plays on.',
    'Best seat in the library. I’d charge rent, but nobody ever has the coin. Stay a while.',
    'Read, doze or watch the night go by. Every minute in this chair counts.'
  ];
  const HELLO_KEY = 'ffd-library-study-hello';
  /* and when the reader's hourglass has run, in turn (kept per browser); the first one knows when the lamp is out */
  const DONE = [
    'That’s your time, and well spent. I’ll keep the lamp lit if you want another turn.',
    'The sand’s all down. Stretch your legs if you like, the books will wait for you.',
    'Time’s up. I like having you in that chair, so turn the glass again whenever you want.'
  ];
  const DONE_DARK = 'That’s your time, and well spent. I can light the lamp again if you want another turn.';
  const DONE_KEY = 'ffd-library-study-done';
  /* his one hint a sitting, about something not found yet in this browser (each switched on with its thing) */
  const HINTS = {
    dark: 'Put the lamp out for a while. The night shows you more when the room is dark.',
    turn: 'Footnote likes a scratch behind the ears. He’ll tell you when he’s had enough.',
    water: 'That ivy drinks more tea than I do. If it looks tired, give it some.',
    knock: 'Tap the glass when Soryndel’s out there. She always taps back.',
    pour: 'I taught that teapot a cantrip years ago. Empty your cup and it still comes running.',
    song: 'Touch everything on the sill, one after another, and listen.'
  };
  /* the last time the reader chose on the hourglass (kept per browser, marked in the panel) */
  const GLASS_KEY = 'ffd-library-study-glass';
  /* each view's name, shown quietly once it has finished coming in */
  const PLACES = { town: 'Town by the lake', coast: 'Lighthouse by the sea', falls: 'Falls in the pines', isles: 'Isles in the clouds', peaks: 'Monastery in the peaks' };
  /* the music box plays a few notes in the mood of the record it starts (semitones over C6) */
  const TUNES = { quiet: [0, 4, 7, 9, 7, 4, 12], hearth: [7, 4, 0, 2, 4, 2, 0], after: [9, 12, 16, 14, 12, 7, 9] };
  /* the music box's beat in seconds, and when its first note sounds after the lid opens (and after a wind). Soryndel bobs
     on this beat from the first note (the art bobs once every 0.37 s of her 'bob'), so she keeps time with the tune */
  const BEAT = 0.37, COMB0 = 0.38, WIND0 = 0.26;
  const fast = () => { const f = +window.__studyFast; return f > 0 && isFinite(f) ? f : 1; };
  const rand = (a, b) => a + Math.random() * (b - a);
  const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
  /* the view kept in this browser, or the town */
  function viewKept() { try { const v = localStorage.getItem(VIEW_KEY); return VIEWS.indexOf(v) >= 0 ? v : 'town'; } catch (e) { return 'town'; } }
  function viewKeep(id) { try { localStorage.setItem(VIEW_KEY, id); } catch (e) { /* the view simply isn't kept */ } }
  function glassKept() { try { const m = +localStorage.getItem(GLASS_KEY); return TIMES.indexOf(m) >= 0 ? m : 0; } catch (e) { return 0; } }
  function glassKeep(m) { try { localStorage.setItem(GLASS_KEY, String(m)); } catch (e) { /* not kept, fine */ } }
  /* the record of the sill in this browser, cleaned (anything odd in it takes the value of a fresh sill) */
  function playKept() {
    const o = { blooms: 0, watered: 0, sat: 0, pity: { pixie: 0, dragon: 0, flower: 0 }, flowerDay: '', found: {} };
    try {
      const v = JSON.parse(localStorage.getItem(PLAY_KEY) || 'null');
      if (!v || typeof v !== 'object') return o;
      const int = (x, a, b) => (typeof x === 'number' && isFinite(x) ? clamp(Math.floor(x), a, b) : a);
      o.blooms = int(v.blooms, 0, 9);
      if (typeof v.watered === 'number' && isFinite(v.watered) && v.watered > 0) o.watered = Math.min(v.watered, Date.now());
      o.sat = int(v.sat, 0, 100000);
      if (v.pity && typeof v.pity === 'object') Object.keys(o.pity).forEach((k) => { o.pity[k] = int(v.pity[k], 0, 99); });
      if (typeof v.flowerDay === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v.flowerDay)) o.flowerDay = v.flowerDay;
      if (v.found && typeof v.found === 'object') FOUND.forEach((k) => { if (v.found[k] === 1 || v.found[k] === true) o.found[k] = 1; });
    } catch (e) { /* a fresh sill */ }
    return o;
  }
  function playKeep(o) { try { localStorage.setItem(PLAY_KEY, JSON.stringify(o)); } catch (e) { /* kept for this visit only */ } }
  /* the reader's own date and hour, read here only (the flower's day, the moon) */
  const today = () => { const d = new Date(); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); };
  const localHours = () => { const q = +window.__studyHour; if (window.__studyHour != null && q >= 0 && q < 24) return q; const d = new Date(); return d.getHours() + d.getMinutes() / 60 + d.getSeconds() / 3600; };
  /* each sitting gets a number, so one that ends after the next began leaves the room to the new one */
  let uid = 0, seat = 0;

  /* ---- the study's own soft sounds, made in the browser like FFSound's (src/scene-pages/sound.js), through its audio
     context (so the first tap's unlock counts) and silent while it is muted. Each is scheduled on the audio clock, so
     nothing is left waiting when the reader stands up ---- */
  const tones = (() => {
    /* D: this sound's start in seconds from now, G: its share of its own loudness (o.at and o.vol, set by play) */
    let ac = null, bus = null, hiss = null, D = 0, G = 1;
    function go() {
      try {
        const S = window.FFSound;
        if (!S || S.muted || typeof S.wake !== 'function') return null;
        const c = S.wake();
        if (!c || c.state === 'closed' || typeof c.createGain !== 'function') return null;
        if (c !== ac) {
          const b = c.createGain(), k = c.createDynamicsCompressor(), n = c.createBuffer(1, c.sampleRate, c.sampleRate), d = n.getChannelData(0);
          for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
          k.threshold.value = -20; k.ratio.value = 3; b.gain.value = 0.8;
          b.connect(k); k.connect(c.destination);
          ac = c; bus = b; hiss = n;
        }
        return c;
      } catch (e) { return null; }
    }
    /* a tone t seconds from now: f Hz, peak g, d seconds long; o.a its rise, o.f2 a glide, o.det a detune in cents */
    function tn(c, t, f, g, d, o) {
      o = o || {};
      const s = c.createOscillator(), v = c.createGain(), at = c.currentTime + 0.01 + D + t;
      g *= G;
      s.type = o.type || 'sine'; s.frequency.setValueAtTime(f, at);
      if (o.f2) s.frequency.exponentialRampToValueAtTime(o.f2, at + (o.glide || d));
      if (o.det) s.detune.value = o.det;
      /* (a gain is 1 until its first event: start it silent, or a sound beginning between two samples clicks) */
      v.gain.value = 0.0001; v.gain.setValueAtTime(0.0001, at); v.gain.linearRampToValueAtTime(g, at + (o.a || 0.006)); v.gain.exponentialRampToValueAtTime(0.0001, at + d);
      s.connect(v); v.connect(bus); s.start(at); s.stop(at + d + 0.05);
    }
    /* filtered noise t seconds from now; o.am a slow pulse in Hz (a purr) */
    function nz(c, t, o) {
      const s = c.createBufferSource(), f = c.createBiquadFilter(), v = c.createGain(), at = c.currentTime + 0.01 + D + t, d = o.d || 0.1;
      s.buffer = hiss; s.loop = true;
      f.type = o.type || 'bandpass'; f.frequency.setValueAtTime(o.f, at); f.Q.value = o.q || 0.8;
      if (o.f2) f.frequency.exponentialRampToValueAtTime(o.f2, at + d);
      v.gain.value = 0.0001; v.gain.setValueAtTime(0.0001, at); v.gain.linearRampToValueAtTime(Math.max(0.0002, o.g * G), at + (o.a || 0.004)); v.gain.exponentialRampToValueAtTime(0.0001, at + d);
      s.connect(f); f.connect(v);
      let last = v;
      if (o.am) {
        const lfo = c.createOscillator(), dep = c.createGain(), m = c.createGain();
        lfo.frequency.value = o.am; dep.gain.value = 0.5; m.gain.value = 0.5;
        lfo.connect(dep); dep.connect(m.gain); v.connect(m); last = m;
        lfo.start(at); lfo.stop(at + d + 0.05);
      }
      last.connect(bus); s.start(at, Math.random() * 0.5); s.stop(at + d + 0.05);
    }
    const SET = {
      /* one soft bell: a warm struck note with a bell's partials, long and quiet (o.q under 1 for the free turns) */
      bell(c, o) {
        const q = o.q || 1, f = 587.33;
        [[1, 0.055, 3.6], [2, 0.022, 2.4], [2.76, 0.014, 1.6], [3.94, 0.007, 1], [5.43, 0.004, 0.6], [0.5, 0.02, 4.2]].forEach((p) => tn(c, 0, f * p[0], p[1] * q, p[2], { det: p[0] === 1 ? 0 : 3 }));
        tn(c, 0, f * 1.003, 0.02 * q, 3.2);
      },
      /* the music box's comb while its lid is up (0.35 to 3 s): seven plucked notes on the beat, the last one left to ring */
      comb(c, o) {
        const tune = TUNES[o.rec] || TUNES.quiet;
        tune.forEach((n, i) => {
          const f = 1046.5 * Math.pow(2, n / 12), t = COMB0 + i * BEAT, last = i === tune.length - 1;
          tn(c, t, f, 0.04, last ? 1.6 : 1.1); tn(c, t, f * 2, 0.012, 0.3); tn(c, t, f * 3.01, 0.005, 0.14);
          nz(c, t, { type: 'highpass', f: 5000, g: 0.012, d: 0.015 });
        });
      },
      /* a sip (the cup lifts and sets down in about a second): a breath, then a small clink on the wood (lighter for the
         last sip, the cup nearly weightless) */
      cup(c, o) {
        const k = o.light ? 0.6 : 1;
        nz(c, 0.22, { f: 900, f2: 1700, q: 0.7, g: 0.012, a: 0.08, d: 0.32 });
        [[2380, 0.03, 0.2], [3510, 0.016, 0.14], [5160, 0.007, 0.08]].forEach((p) => tn(c, 0.93, p[0] * (o.light ? 1.06 : 1), p[1] * k, p[2]));
        nz(c, 0.93, { type: 'lowpass', f: 320, q: 1, g: 0.05 * k, d: 0.06 });
      },
      /* the crystal: a slow swell of glass, high and calm, over a low hum (o.up semitones higher for a touch while its
         window opens) */
      crystal(c, o) {
        const u = Math.pow(2, (o.up || 0) / 12);
        [[1046.5, 0.022, 2.4, 0], [1568, 0.018, 2.1, 4], [2093, 0.012, 1.8, -3], [3136, 0.006, 1.4, 2]].forEach((p, i) => tn(c, i * 0.06, p[0] * u, p[1], p[2], { a: 0.14, det: p[3] }));
        tn(c, 0, 261.6 * u, 0.016, 1.8, { a: 0.4 });
      },
      /* the lamp's wick turned: small clicks and a warm hum going up or down */
      wick(c, o) {
        [0, 0.05, 0.1].forEach((t, i) => nz(c, t, { type: 'highpass', f: 3200 + i * 300, g: 0.035, d: 0.014 }));
        tn(c, 0.05, o.up ? 196 : 247, 0.014, 0.55, { f2: o.up ? 247 : 175, a: 0.08, type: 'triangle' });
      },
      /* the candle snuffed: a soft breath */
      snuff(c) { nz(c, 0, { f: 1100, f2: 380, q: 0.6, g: 0.08, a: 0.03, d: 0.38 }); },
      /* the hourglass turned over (0.8 s): sand sliding as it lifts and turns, a soft knock as it sets down */
      sand(c) {
        nz(c, 0.05, { type: 'lowpass', f: 2400, f2: 600, q: 0.5, g: 0.03, a: 0.18, d: 0.8 });
        nz(c, 0.8, { type: 'lowpass', f: 300, q: 1.2, g: 0.08, d: 0.07 }); tn(c, 0.8, 180, 0.03, 0.1, { type: 'triangle' });
      },
      /* the ivy: leaves brushing (o.n brushes, 8 when not said) */
      leaves(c, o) { const n = o.n || 8; for (let i = 0; i < n; i++) nz(c, i * 0.045 + Math.random() * 0.02, { type: 'highpass', f: 2200 + Math.random() * 2400, q: 0.7, g: 0.02 + Math.random() * 0.025, d: 0.05 + Math.random() * 0.05 }); },
      /* Footnote purrs: two slow breaths of a low rumble */
      purr(c) { nz(c, 0, { type: 'lowpass', f: 300, q: 0.7, g: 0.16, a: 0.3, d: 0.95, am: 24 }); nz(c, 1.05, { type: 'lowpass', f: 260, q: 0.7, g: 0.13, a: 0.3, d: 0.95, am: 22 }); },
      /* Soryndel hoots, soft and low, one long and two together */
      hoot(c) { [[0.08, 0.34], [0.62, 0.16], [0.84, 0.42]].forEach((p) => { tn(c, p[0], 392, 0.05, p[1], { f2: 352, glide: p[1], a: 0.07 }); tn(c, p[0], 784, 0.008, p[1] * 0.8, { f2: 704, glide: p[1], a: 0.07 }); nz(c, p[0], { f: 420, q: 2, g: 0.01, a: 0.06, d: p[1] }); }); },
      /* the hourglass touched: a small glass note */
      tink(c) { tn(c, 0, 2637, 0.03, 0.4); tn(c, 0, 3951, 0.011, 0.22); },
      /* the melody of the sill, one very soft note from the playing record's set (o.n semitones over C6), its octave above */
      note(c, o) { const f = 1046.5 * Math.pow(2, (o.n || 0) / 12); tn(c, 0, f, 0.018, 0.9, { a: 0.012 }); tn(c, 0, f * 2, 0.005, 0.5, { a: 0.012 }); },
      /* the song of the sill, the record's set as a slow arpeggio, then its root an octave up, held */
      sing(c, o) {
        const set = NOTES[o.rec] || NOTES.quiet, top = set.indexOf(set[0] + 12) >= 0 ? set[1] + 12 : set[0] + 12;
        set.concat([top]).forEach((n, i, a) => { const f = 1046.5 * Math.pow(2, n / 12), t = i * 0.17, last = i === a.length - 1; tn(c, t, f, last ? 0.024 : 0.02, last ? 2.6 : 1.2, { a: 0.015 }); tn(c, t, f * 2, 0.005, last ? 1.4 : 0.5, { a: 0.015, det: 3 }); });
      },
      /* the lamp put out: the snuff's lower cousin, and the warm hum going down to nothing */
      out(c) { nz(c, 0, { f: 800, f2: 260, q: 0.6, g: 0.06, a: 0.04, d: 0.5 }); tn(c, 0.02, 196, 0.01, 0.55, { f2: 147, type: 'triangle', a: 0.06 }); },
      /* a flame hopping over the sill: a soft rising breath */
      hop(c) { nz(c, 0, { f: 600, f2: 1500, q: 0.9, g: 0.015, a: 0.5, d: 1.4 }); },
      /* a flame catching: a small warm flare */
      flare(c) { nz(c, 0, { f: 500, f2: 1800, q: 0.7, g: 0.09, a: 0.03, d: 0.35 }); tn(c, 0.05, 392, 0.03, 0.6, { type: 'triangle' }); },
      /* the teapot pours (it floats down for 0.8 s first): a trickle rising as the cup fills, then a small glass note */
      pour(c) { nz(c, 0.8, { f: 500, f2: 1400, q: 1.4, g: 0.025, a: 0.12, d: 1.2, am: 9 }); tn(c, 2.05, 2637, 0.022, 0.4); tn(c, 2.05, 3951, 0.008, 0.22); },
      /* three drops on the ivy's soil */
      drip(c) { [0, 0.25, 0.5].forEach((t) => tn(c, t, 1400, 0.012, 0.14, { f2: 900, glide: 0.08 })); },
      /* a flower opening */
      bloom(c) { tn(c, 0, 1046.5, 0.012, 0.8, { a: 0.03 }); tn(c, 0.18, 1568, 0.012, 0.8, { a: 0.03 }); },
      /* the pixie: five tiny bell notes rising, and a few glints as it dives back */
      pixie(c) { [2637, 3136, 3520, 3951, 4186].forEach((f, i) => tn(c, i * 0.09, f, 0.01, 0.35)); for (let i = 0; i < 4; i++) nz(c, 0.55 + i * 0.07, { type: 'highpass', f: 5200, g: 0.008, d: 0.02 }); },
      /* the quill writing a line: seven short scratches, softer than a pen */
      quill(c) { for (let i = 0; i < 7; i++) nz(c, 0.1 + i * 0.17 + Math.random() * 0.04, { type: 'highpass', f: 4000 + Math.random() * 2000, q: 0.8, g: 0.015, d: 0.05 + Math.random() * 0.03 }); },
      /* paper sliding (a pressed flower slipping out of a page) */
      slide(c) { nz(c, 0, { f: 1500, q: 0.6, g: 0.02, a: 0.08, d: 0.4 }); },
      /* Soryndel knocks back: two soft taps on the glass */
      knock(c) { [0, 0.18].forEach((t) => { tn(c, t, 1500, 0.02, 0.06); nz(c, t, { type: 'highpass', f: 2500, g: 0.008, d: 0.03 }); }); },
      /* Soryndel fluffs up: three soft puffs of feathers */
      fluff(c) { [0, 0.11, 0.2].forEach((t) => nz(c, t, { f: 700, q: 0.8, g: 0.025, a: 0.02, d: 0.1 })); },
      /* Footnote lands on a leaf: a soft pat */
      paw(c) { nz(c, 0, { type: 'lowpass', f: 700, q: 0.8, g: 0.14, d: 0.07 }); tn(c, 0, 150, 0.03, 0.09, { type: 'triangle' }); },
      /* the music box wound: four small ratchet clicks, then three notes of the record's tune (o.i the wind) */
      wind(c, o) {
        for (let i = 0; i < 4; i++) nz(c, i * 0.05, { type: 'highpass', f: 3500, g: 0.02, d: 0.012 });
        const tune = TUNES[o.rec] || TUNES.quiet, i0 = ((o.i || 0) * 3) % tune.length;
        for (let j = 0; j < 3; j++) { const f = 1046.5 * Math.pow(2, tune[(i0 + j) % tune.length] / 12), t = WIND0 + j * BEAT; tn(c, t, f, 0.035, 1); tn(c, t, f * 2, 0.01, 0.3); nz(c, t, { type: 'highpass', f: 5000, g: 0.01, d: 0.015 }); }
      },
      /* a falling star: two high soft notes rising in */
      wish(c) { tn(c, 0, 2093, 0.012, 1.6, { a: 0.3 }); tn(c, 0.06, 3136, 0.008, 1.4, { a: 0.3 }); },
      /* the dancing lights rising from the crystal: three small glass notes */
      motes(c) { [0, 0.3, 0.6].forEach((t, i) => { tn(c, t, 2637 * Math.pow(2, i * 3 / 12), 0.01, 0.4); tn(c, t, 3951 * Math.pow(2, i * 3 / 12), 0.004, 0.22); }); }
    };
    return {
      play(n, o) {
        const c = go(); if (!c || !SET[n]) return false;
        o = o || {}; D = Math.max(0, +o.at || 0); G = o.vol > 0 ? Math.min(1.5, +o.vol) : 1;
        try { SET[n](c, o); return true; } catch (e) { return false; } finally { D = 0; G = 1; }
      },
      hush(m) { try { if (bus) bus.gain.value = m ? 0 : 0.8; } catch (e) { /* fine */ } }
    };
  })();

  FFD.parts['library/study'] = function (api) {
    api = api || {};
    const RM = typeof api.RM === 'function' ? api.RM : () => false;
    const snd = (n, o) => { try { if (typeof api.snd === 'function') api.snd(n, o); } catch (e) { /* a sound is a nicety */ } };
    const T = api.tally || {};
    const tAdd = (n) => { try { if (T.add) T.add('study', n); } catch (e) { /* the count waits */ } };
    const tTotal = () => { try { return +(T.total ? T.total('study') : 0) || 0; } catch (e) { return 0; } };
    const tMine = () => { try { return +(T.mine ? T.mine('study') : 0) || 0; } catch (e) { return 0; } };
    /* the most one reader's minutes may add up to (FFD.tally keeps 500 a key unless a page raises it) */
    try { if (typeof T.cap === 'function') T.cap('study', 100000); else if (FFD.tally && typeof FFD.tally.cap === 'function') FFD.tally.cap('library', 'study', 100000); } catch (e) { /* fine */ }
    /* the chair's story base (START): shown in the shared total only, never sent, never part of the reader's own count */
    try { if (typeof T.base === 'function') T.base('study', START); else if (FFD.tally && typeof FFD.tally.base === 'function') FFD.tally.base('library', 'study', START); } catch (e) { /* fine */ }
    const NS = () => window.FFNoteScenes || null;
    const nsSet = (n, v) => { try { const ns = NS(); if (ns && ns.set) ns.set(SK, n, v); } catch (e) { /* fine */ } };
    const nsGet = (k, n) => { try { const ns = NS(); return ns && ns.get ? ns.get(k, n) : undefined; } catch (e) { return undefined; } };
    if (!document.getElementById(CSS_ID)) { const st = document.createElement('style'); st.id = CSS_ID; st.textContent = CSS; document.head.append(st); }
    /* the sill as the reader left it, for the rest of this visit (the page load): the lamp ('bright', 'low' or 'out'), the
       candle and the minutes it has burnt, the tea in the cup (3 full to 0), the book's spread and the lines written on
       it, the leaves on the cushion, the pressed flower */
    const visit = { lamp: 'bright', candle: true, burnMin: 0, cup: 3, page: 0, lines: 0, leaves: 0, flower: false };
    /* the last few sounds the study asked for, over every sitting (for the checks) */
    const heard = [];
    const hear = (n) => { heard.push(n); if (heard.length > 60) heard.shift(); };

    /* the scene says when a visitor has gone; registered once (FFNoteScenes keeps listeners for good) */
    let cur = null, listening = false;
    function listen() {
      if (listening) return;
      const ns = NS(); if (!ns || typeof ns.on !== 'function') return;
      listening = true;
      ns.on(SK, (type, d) => { if (cur && type === 'visit' && d) cur.visit(d); });
    }

    function open() {
      if (cur) return cur.p;
      const F = api.F || {}, host = F.el || document.querySelector('.ffd-page--library .ffs') || document.body;
      const reduced = !!RM(), back = document.activeElement, mySeat = ++seat;
      let res = null;
      const p = new Promise((r) => { res = r; });
      listen();

      /* every piece of the sitting's state, before anything can call tick() */
      const timers = new Set();
      const later = (fn, ms) => { const id = setTimeout(() => { timers.delete(id); if (!over) fn(); }, ms); timers.add(id); return id; };
      let over = false, scene = null, frameT = 0, lastNow = 0, sec = 0, studyMs = 0, minuteMs = 0, pending = 0, lock = null, idleT = 0, kb = false;
      let recId = null, lastMt = 0, stallAt = 0, retried = false, switching = false, switchTok = 0, lastStep = -1e9, nextVisit = 0, nextTurn = 0, catOut = false, catAt = 0, catNap = 0, lastWho = '', turnN = 0, offTally = null;
      let freeBase = 0, freeN = 0, tm = null, endT = 0, hgOn = false, helloOn = false, helloIdx = 0, helloT = 0, said = '', leftNow = '', tapSig = '', tabOrder = [], hgSig = '';
      let vId = viewKept(), vFrom = null, vT0 = -1e9, vSince = 0, lastCrystal = -1e9, vPend = false;
      let placeT = 0, placeOffT = 0, placeGoneT = 0, placeOn = '', bells = 0, lastSnd = '', glassLast = glassKept(), helloOff = -1e9;
      const hitT = {};
      /* the sill at play (see Play in the head): the record kept in this browser, then this sitting's own numbers */
      const store = playKept();
      /* an ivy never watered in this browser starts a little thirsty, so a long first sitting finds it asking */
      if (!store.watered) { store.watered = Date.now() - 0.3 * 24 * 3600000; playKeep(store); }
      const TP = {}, rep = {}, songSeen = {}, labels = {};
      let lastAct = null, songDone = false, nIdx = -1, nDir = 1, nLast = -1e9, notes = [], sillSig = '', vBy = '', crystalUp = 0;
      let boxT0 = -1e9, boxUntil = -1e9, boxV = '', boxWinds = 0, pourUntil = -1e9, quillUntil = -1e9, bookLast = -1e9, lightsUntil = -1e9;
      let dark = false, nextWish = 0, catPet = 0, catPetAt = -1e9, catNap0 = 0, catAsleep = false, catSits = false;
      let owlPet = 0, owlPetAt = -1e9, owlT0 = null, owlN = 0, owlStay = OWL_STAY, owlFeather = false, owlGreeted = false, feather = false;
      let canBloom = false, bloomAt = 0, bloomsNew = 0, pixieDone = false, leafTimes = [], leavesDue = 0, waterUntil = -1e9, thirstFrom = 0;
      let hintAt = rand(6, 12) * 60000, hinted = false, hintSaid = '', labelT = 0, moonV = null, moonCheck = 0, helloArr = null;
      let wokeAt = -1e9, wokeRec = false;

      /* ---- the overlay ---- */
      const o = document.createElement('div');
      o.className = 'lbs';
      o.setAttribute('role', 'dialog'); o.setAttribute('aria-modal', 'true'); o.setAttribute('aria-label', 'Sitting by the window'); o.tabIndex = -1;
      o.innerHTML = '<div class="lbs-art" aria-hidden="true"></div><div class="lbs-shade" aria-hidden="true"></div><div class="lbs-taps"></div>' +
        '<p class="lbs-place" aria-hidden="true"><span></span></p>' +
        '<div class="lbs-ui"><div class="lbs-top"><button type="button" class="lbs-back">' + ICON_BACK + '<span>Back to the library</span></button>' +
        '<button type="button" class="lbs-snd"></button></div></div>' +
        '<div class="lbs-low"><button type="button" class="lbs-rec">' + ICON_NOTE + '<span class="lbs-rec-w"><span class="lbs-rec-n"></span></span><span class="lbs-rec-x" aria-hidden="true">' + ICON_NEXT + '</span></button>' +
        '<p class="lbs-left" role="timer" hidden>' + ICON_GLASS + '<span></span></p><p class="lbs-count"></p><span class="lbs-sr" aria-live="polite"></span></div>';
      const $ = (s) => o.querySelector(s);
      const artEl = $('.lbs-art'), tapsEl = $('.lbs-taps'), topEl = $('.lbs-top'), backBtn = $('.lbs-back'), sndBtn = $('.lbs-snd'), recBtn = $('.lbs-rec'), recTxt = $('.lbs-rec-n'), leftEl = $('.lbs-left'), leftTxt = leftEl.querySelector('span'), countEl = $('.lbs-count'), srEl = $('.lbs-sr');
      const placeEl = $('.lbs-place'), placeTxt = placeEl.querySelector('span');
      /* a sound for an answer: the study's own when Web Audio is there, else FFSound's nearest (alt). Asked for again
         within a streak's window, it plays 15 percent softer each time, down to half */
      const play = (n, opt, alt, altOpt) => {
        lastSnd = n; hear(n);
        const t = performance.now(), r = rep[n] || (rep[n] = { t: -1e9, k: 0 });
        r.k = t - r.t < STREAK * 1000 ? r.k + 1 : 0; r.t = t;
        const o2 = Object.assign({}, opt || {});
        o2.vol = (o2.vol || 1) * Math.max(0.5, Math.pow(0.85, r.k));
        if (!tones.play(n, o2) && alt) snd(alt, altOpt);
      };
      const sndAs = (n, opt) => { lastSnd = n; hear(n); snd(n, opt); };
      /* Zhaunil's welcome (see the head): his face, his name, one line; shown once the room has settled */
      const zh = Object.assign({ name: 'Zhaunil', img: '' }, api.zh || {});
      const hello = document.createElement('p'), helloT2 = document.createElement('span'), helloWho = document.createElement('span'), helloLine = document.createElement('span');
      hello.className = 'lbs-hello'; hello.setAttribute('aria-live', 'polite');
      if (zh.img) { const im = document.createElement('img'); im.className = 'lbs-hello-img'; im.src = zh.img; im.alt = ''; im.decoding = 'async'; im.draggable = false; hello.append(im); }
      helloT2.className = 'lbs-hello-t'; helloWho.className = 'lbs-hello-who'; helloLine.className = 'lbs-hello-line';
      helloWho.textContent = zh.name || 'Zhaunil';
      helloT2.append(helloWho, helloLine); hello.append(helloT2);
      /* the hourglass's panel (hidden until its tap) */
      const hg = document.createElement('div');
      hg.className = 'lbs-hg'; hg.id = 'lbs-hg-' + (++uid); hg.setAttribute('role', 'group'); hg.setAttribute('aria-label', 'Set the hourglass');
      hg.innerHTML = '<p class="lbs-hg-t">' + ICON_GLASS + '<span>Set the hourglass</span></p><div class="lbs-hg-row">' +
        TIMES.map((m) => '<button type="button" data-min="' + m + '" aria-label="' + m + ' minutes" aria-pressed="false">' + m + '<small>min</small></button>').join('') +
        '</div><button type="button" class="lbs-hg-free" data-min="0" aria-pressed="true">Let it run</button>';
      o.append(hello, hg);
      /* a button for each thing on the sill (placed and shown by layTaps once the scene says where they stand) */
      const tapB = {};
      TAPS.forEach((k) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'lbs-tap'; b.dataset.k = k; b.hidden = true;
        b.addEventListener('click', (e) => tapThing(k, e.detail === 0));
        tapsEl.append(b); tapB[k] = b;
      });
      tapB.glass.setAttribute('aria-expanded', 'false'); tapB.glass.setAttribute('aria-controls', hg.id);
      /* the study's taps and keys stay the study's: the room under it never sees them */
      ['pointerdown', 'mousedown', 'touchstart', 'click', 'wheel', 'contextmenu'].forEach((t) => o.addEventListener(t, (e) => e.stopPropagation(), { passive: t === 'touchstart' || t === 'wheel' }));
      host.append(o);

      /* ---- the scene: still (the part keeps its clock), the record's weather and the kept view from the first frame.
         The record is the one playing when it's a calm one (the jukebox's own idea of its record can lag the player),
         else the jukebox's. Each sitting's clock starts at 0, so the sill's old answers are cleared first ---- */
      const music = api.music || null;
      const mid = music && music.id, now0 = CALM.indexOf(mid) >= 0 ? mid : (api.rec ? api.rec() : null);
      recId = CALM.indexOf(now0) >= 0 ? now0 : 'quiet';
      if (mid === recId && api.rec && api.rec() !== mid && typeof api.calmTo === 'function') { try { api.calmTo(mid); } catch (e) { /* the jukebox catches up later */ } }
      const viewOk = (id) => id === 'town' || !!nsGet('library-vistas', id);
      if (!viewOk(vId)) vId = 'town';
      const turn0 = nsGet(SK, 'turn');
      turnN = turn0 && typeof turn0 === 'object' ? +turn0.n || 0 : +turn0 || 0;
      nsSet('weather', WX[recId]); nsSet('still', reduced); nsSet('cat', null); nsSet('owl', null);
      nsSet('vista', vId); nsSet('glass', null);
      ['cup', 'ivy', 'crystal', 'box', 'pet', 'quill', 'wobble', 'wish', 'lights', 'song'].forEach((n) => nsSet(n, null));
      /* the lamp and the candle as the reader left them, without replaying their change; the lasting sill; the moon */
      nsSet('lamp', visit.lamp !== 'bright' ? { lvl: visit.lamp, t0: -99 } : null); nsSet('candle', !visit.candle ? { lit: false, t0: -99 } : null);
      setSill();
      moonNow();
      darkNow();
      const ns = NS();
      /* the study's grid is finer than the room's, so building its scene takes a moment (a tenth to a quarter of a second
         on a phone). It is built just after the tap's first frame has shown the room leaning in, and the study's fade
         waits for its first frame (see the lean below). Until then nothing is drawn and the sill has no tap areas */
      let canStep = false;
      function mountArt() {
        try { if (ns && typeof ns.mount === 'function' && (!ns.keys || ns.keys().indexOf(SK) >= 0)) scene = ns.mount(artEl, SK, { reduced: true }); } catch (e) { scene = null; }
        canStep = !!(scene && typeof scene._frame === 'function');
        if (scene && !canStep) { try { scene.destroy(); } catch (e) { /* fine */ } try { scene = ns.mount(artEl, SK, { reduced }); } catch (e) { scene = null; } }
      }
      const draw = () => { if (canStep && !over) { try { scene._frame(sec); } catch (e) { /* the art is a nicety */ } } layTaps(); };

      /* ---- the frames: about 12 a second while the tab shows; under reduced motion one a second (what shows changes
         only when a visitor comes or goes, the weather turns or a thing on the sill answers) ---- */
      /* the clock moves on to now: each frame, and each tap first (so an answer's t0 is the moment of the tap, also under
         reduced motion's one frame a second). False while the tab is hidden */
      function advance() {
        const t = performance.now(), dt = lastNow ? Math.min(reduced ? 1500 : 250, t - lastNow) : 0;
        lastNow = t;
        if (document.hidden) { lastNow = 0; return false; }
        sec += dt / 1000;
        studyMs += dt * fast();
        minuteMs += dt * fast();
        while (minuteMs >= 60000) { minuteMs -= 60000; pending++; minute(); if (pending >= 15) flush(); paintCount(); }
        return true;
      }
      function tick() {
        frameT = 0;
        if (over) return;
        if (!advance()) return;
        follow();
        visitors();
        views();
        timerCheck();
        night();
        hints();
        moonKeep();
        /* the labels that follow time (the music box shutting, the ivy getting thirsty), about once a second */
        if (sec - labelT >= 1) { labelT = sec; TAPS.forEach(label); }
        draw();
        frameT = setTimeout(tick, reduced ? 1000 : 80);
      }
      const flush = () => { if (pending > 0) { const n = pending; pending = 0; tAdd(n); } };
      /* each minute spent here: the candle burns a little lower while it is lit, and the ivy gets a little thirstier (the
         minutes sat since its last drink are kept with its record, so it never gets less thirsty by itself) */
      function minute() {
        if (visit.candle) visit.burnMin = Math.min(BURN, visit.burnMin + 1);
        if (sec >= waterUntil && store.sat < 100000) { store.sat++; playKeep(store); }
        setSill();
      }

      /* ---- the corner: everyone's minutes once they're shared (from the chair's story base, START), before that the
         reader's own. The number has its own span, so it counts up softly and warms when the reader's minute lands ---- */
      const minutes = (m) => (m === 1 ? ' minute' : ' minutes');
      let countMode = '', countN = null, ownSeen = -1;
      function countLine(mode, n) {
        countMode = mode;
        countEl.textContent = '';
        countN = null;
        if (mode === 'none') { countEl.textContent = 'You’ve just sat down'; return; }
        countN = document.createElement('span'); countN.className = 'lbs-n';
        if (mode === 'all') countEl.append(countN, minutes(n) + ' spent here by adventurers');
        else countEl.append('You’ve spent ', countN, minutes(n) + ' here');
      }
      function paintCount() {
        if (over) return;
        const shared = !!(FFD.tally && FFD.tally.shared), all = tTotal() + pending, own = tMine() + pending;
        const mode = shared ? 'all' : own >= 1 ? 'own' : 'none', n = mode === 'all' ? all : own;
        /* the line's words change only with its mode or a one turning into many */
        const fresh = mode !== countMode || (mode === 'own' && (n === 1) !== (ownSeen === 1));
        if (fresh) countLine(mode, n);
        if (countN) {
          const mine = own > ownSeen && ownSeen >= 0 && !fresh;
          if (fresh) {
            /* a shared total arriving counts up the last few minutes softly; the reader's own starts as it is */
            if (mode === 'all' && !reduced) { countN.dataset.n = String(Math.max(0, n - Math.min(60, Math.round(n * 0.04)))); countN.textContent = Number(countN.dataset.n).toLocaleString('en-US'); }
            else { countN.dataset.n = String(n); countN.textContent = n.toLocaleString('en-US'); }
          }
          if (+countN.dataset.n !== n) { if (typeof FFD.countUp === 'function') FFD.countUp(countN, n, { quiet: true }); else { countN.dataset.n = String(n); countN.textContent = n.toLocaleString('en-US'); } }
          /* the reader's own minute joining the count: the number warms for a moment */
          if (mine && !reduced) { countN.classList.remove('is-mine'); countEl.classList.remove('is-mine'); void countN.offsetWidth; countN.classList.add('is-mine'); countEl.classList.add('is-mine'); later(() => { if (countN) countN.classList.remove('is-mine'); countEl.classList.remove('is-mine'); }, 1700); }
        }
        ownSeen = own;
      }
      paintCount();
      try { if (typeof T.on === 'function') offTally = T.on(paintCount); else if (FFD.tally && typeof FFD.tally.on === 'function') offTally = FFD.tally.on(paintCount); } catch (e) { offTally = null; }

      /* ---- the records: the calm three in turn, each nearly to the end of its loop ---- */
      const TR = (FFD.music && FFD.music.TRACKS) || {};
      let recOff = 0, stuck = 0;
      function showRec(id) {
        const n = NAMES[id] || '', prev = recTxt.textContent, seen = !o.classList.contains('is-idle') || recBtn.classList.contains('is-on');
        recBtn.setAttribute('aria-label', n + ', play the next record');
        srEl.textContent = n;
        if (prev && prev !== n && seen && !reduced) {
          /* the name already showing: the old one slides up and away as the new one comes in */
          const g = document.createElement('span');
          g.className = 'lbs-rec-old'; g.textContent = prev; g.setAttribute('aria-hidden', 'true');
          recTxt.parentNode.append(g); later(() => g.remove(), 420);
          recTxt.textContent = n;
          recTxt.classList.remove('is-in'); void recTxt.offsetWidth; recTxt.classList.add('is-in');
          recBtn.classList.add('is-on');
        } else {
          recTxt.textContent = n;
          recBtn.classList.remove('is-new'); void recBtn.offsetWidth; recBtn.classList.add('is-on', 'is-new');
        }
        clearTimeout(recOff);
        recOff = later(() => recBtn.classList.remove('is-on', 'is-new'), 5200);
      }
      /* the room's window rains or snows with the record that plays on (VISTAS.md, 'vistaWx'), set with every record and
         again on standing up */
      const roomWx = () => { try { const n2 = NS(); if (n2 && n2.set) n2.set('library', 'vistaWx', WX[recId] || 'clear'); } catch (e) { /* the room keeps its weather */ } };
      function setRec(id, change) {
        recId = id;
        nsSet('weather', WX[id]);
        roomWx();
        if (change) {
          switching = true;
          const tok = ++switchTok;
          try { if (typeof api.calmTo === 'function') api.calmTo(id); else if (music && music.play) music.play(id, 4); } catch (e) { /* the room's music carries on */ }
          /* a calmTo that declined (the jukebox thought it was already there) must not stall the rotation */
          if (music && music.id !== id && music.play) { try { music.play(id, 4); } catch (e) { /* fine */ } }
          /* settled: the new record's own time from here (so its start is not taken for a seam, nor for sound) */
          later(() => { if (tok === switchTok) { switching = false; lastMt = music ? +music.time() || 0 : 0; } }, 4500);
        }
        showRec(id);
        if (reduced) draw();
      }
      /* the music box or the record's name: the next calm record (a double tap moves one record, not two) */
      function nextRec() {
        const n = performance.now();
        if (n - lastStep < 700) return false;
        lastStep = n; stallAt = 0; retried = false; stuck = 0;
        setRec(CALM[(CALM.indexOf(recId) + 1) % CALM.length], true);
        return true;
      }
      function follow() {
        if (!music || switching) return;
        const id = music.id;
        /* the jukebox moved the record some other way: follow it when it's a calm one */
        if (id && id !== recId && CALM.indexOf(id) >= 0) { setRec(id, false); return; }
        const L = TR[recId] && TR[recId].loop, mt = +music.time() || 0;
        if (!L || id !== recId) { lastMt = mt; stallAt = 0; return; }
        /* a record that never started (a refused play or a lost load): try it once more, then move to the next one, so
           the study never sits silent. Twice moved on with nothing playing, or the player saying the browser refuses it
           until a tap, and the record and the night stay as they are (the player starts again on the next tap) */
        const nowMs = Date.now(), moving = Math.abs(mt - lastMt) >= 0.01;
        if (moving) stuck = 0;
        if (!document.hidden && !music.muted && !music.blocked && !moving && stuck < 2) {
          if (!stallAt) stallAt = nowMs;
          else if (nowMs - stallAt > 12000) {
            stallAt = 0;
            if (!retried) { retried = true; try { music.play(recId, 2); } catch (e) { /* fine */ } }
            else { retried = false; stuck++; setRec(CALM[(CALM.indexOf(recId) + 1) % CALM.length], true); }
            lastMt = mt; return;
          }
        } else { stallAt = 0; retried = false; }
        /* near the end of the loop (or already past its seam, should a hidden tab have slept through it): the next one */
        if (mt >= L[1] - 7 || (lastMt > L[0] + 20 && mt < lastMt - 20)) setRec(CALM[(CALM.indexOf(recId) + 1) % CALM.length], true);
        lastMt = mt;
      }

      /* ---- the views: each about 8 minutes of sitting, then the next crossfades in; the crystal moves on at once.
         A change is the scene's slow dream (VFD, 10 s), and a new one sent while it runs starts over from a whole view
         with no mist, a jump in one frame. So a change only ever starts from a settled view: the crystal touched in the
         middle of one is remembered (vPend) and its view begins as soon as this one has settled, and the 8 minute turn
         waits the same way (under reduced motion a view cuts, so nothing waits) ---- */
      /* A crystal's change is a quick portal (2.4 s in the art, CPD here) once the art says it draws one (lbsLay.can
         portal), else the same dream. Each change starts a moment after it is asked for (a second for the turns, less for
         the crystal, which is answering a finger), so the new view's first paint happens before it shows */
      const VFD = 10.3;
      const changing = () => !reduced && sec - vT0 < (vBy ? CPD : VFD);
      function views() {
        if (changing()) return;
        /* the crystal touched while the last view came in: its view now, and the crystal glows again as it starts */
        if (vPend) { vPend = false; if (stepView(true)) nsSet('crystal', { t0: sec }); return; }
        if (studyMs - vSince >= VIEW_MS) stepView(false);
      }
      function stepView(byCrystal) {
        if (changing()) { vPend = true; return false; }
        const L = VIEWS.filter(viewOk);
        if (L.length < 2) { vSince = studyMs; return false; }
        const to = L[(L.indexOf(vId) + 1) % L.length], from = vId, portal = !!byCrystal && can('portal'), lead = byCrystal ? 0.3 : 1;
        vFrom = from; vId = to; vT0 = sec + lead; vSince = studyMs; vBy = portal ? 'crystal' : '';
        const v = { id: to, from, t0: vT0 };
        if (byCrystal) v.by = 'crystal';
        nsSet('vista', v);
        viewKeep(to);
        /* its name once it has finished coming in (a cut under reduced motion) */
        showPlace(reduced ? 300 : Math.round((lead + (portal ? CPD : VFD)) * 1000) - 100);
        return true;
      }
      /* the place's name, quietly, for about 5 s; it waits while Zhaunil talks, and a newer change replaces it. Upright it
         shares the foot's row with the count, so the count comes back only once the name has faded (1.3 s, is-place) */
      function placeHide() {
        clearTimeout(placeOffT); placeOffT = 0; placeOn = '';
        placeEl.classList.remove('is-on');
        clearTimeout(placeGoneT); placeGoneT = 0;
        if (o.classList.contains('is-place')) placeGoneT = later(() => { placeGoneT = 0; o.classList.remove('is-place'); }, 1300);
      }
      function showPlace(ms) {
        clearTimeout(placeT); placeHide();
        let tries = 0;
        const go = () => {
          placeT = 0;
          /* while Zhaunil talks, and until his line has faded (0.8 s), the name waits */
          if ((helloOn || performance.now() - helloOff < 900) && tries++ < 30) { placeT = later(go, helloOn ? 700 : 300); return; }
          /* (a view the crystal asked for is about to begin: its own name comes after it) */
          const n = PLACES[vId];
          if (!n || vPend) return;
          placeTxt.textContent = n; placeOn = vId; srEl.textContent = n;
          offMoon(placeEl, false);
          clearTimeout(placeGoneT); placeGoneT = 0;
          placeEl.classList.add('is-on'); o.classList.add('is-place');
          placeOffT = later(placeHide, 5200);
        };
        placeT = later(go, ms);
      }

      /* ---- the words never sit on the moon (see Words in the head) ---- */
      const tallQ = (() => { try { return window.matchMedia ? window.matchMedia('(max-aspect-ratio: 4/5)') : null; } catch (e) { return null; } })();
      const upright = () => !!(tallQ && tallQ.matches);
      /* the moon and its box in CSS px, relative to the study: lbsLay.moon [x, y, r] in grid px, written by the scene every
         frame (the moon moves with the reader's clock), so it is read each time and never worked out here */
      function moonAt() {
        try {
          const lay = nsGet(SK, 'lbsLay'), cv = artEl.querySelector('canvas');
          if (!lay || !cv || !(lay.W > 0) || !(lay.H > 0)) return null;
          const W = lay.W, H = lay.H, cr = cv.getBoundingClientRect(), orr = o.getBoundingClientRect(), m = lay.moon;
          if (cr.width < 10 || cr.height < 10 || !Array.isArray(m) || m.length < 3 || !(m[2] > 0)) return null;
          const sx = cr.width / W, sy = cr.height / H, x = cr.left - orr.left + m[0] * sx, y = cr.top - orr.top + m[1] * sy;
          return { l: x - m[2] * sx, t: y - m[2] * sy, r: x + m[2] * sx, b: y + m[2] * sy };
        } catch (e) { return null; }
      }
      const rel = (el) => { const r = el.getBoundingClientRect(), q = o.getBoundingClientRect(); return { l: r.left - q.left, t: r.top - q.top, r: r.right - q.left, b: r.bottom - q.top }; };
      /* a card that would reach the moon or its glow moves aside, to whichever side of the moon has room (the moon crosses
         the window with the reader's clock, so it can stand at either side): in the top bar between Back and the moon or
         between the moon and the sound button, lower down between an edge and the moon. The side where the card fits whole
         and moves least wins; else the widest, the card narrower there when it can wrap (Zhaunil's). Measured as it is
         about to show, its words already in it */
      function offMoon(el, wrap) {
        el.style.left = ''; el.style.maxWidth = '';
        if (upright()) return;
        const m = moonAt();
        if (!m) return;
        const e = rel(el), pad = (m.r - m.l) / 4;
        if (e.b <= m.t - pad || e.t >= m.b + pad || e.r <= m.l - pad || e.l >= m.r + pad) return;
        const bk = rel(backBtn), sn = rel(sndBtn), bar = e.t < bk.b, w = e.r - e.l, cx = (e.l + e.r) / 2;
        const L0 = bar ? bk.r + 12 : 16, R0 = bar ? sn.l - 12 : o.clientWidth - 16;
        const sides = [[L0, Math.min(m.l - pad, R0)], [Math.max(m.r + pad, L0), R0]].filter((sd) => sd[1] - sd[0] >= 120);
        if (!sides.length) return;
        const at = (sd) => clamp(cx, sd[0] + w / 2, sd[1] - w / 2);
        const fit = sides.filter((sd) => sd[1] - sd[0] >= w).sort((a, b) => Math.abs(at(a) - cx) - Math.abs(at(b) - cx))[0];
        if (fit) { el.style.left = Math.round(at(fit)) + 'px'; return; }
        const wide = sides.sort((a, b) => (b[1] - b[0]) - (a[1] - a[0]))[0];
        if (wrap) { el.style.maxWidth = Math.floor(wide[1] - wide[0]) + 'px'; el.style.left = Math.round((wide[0] + wide[1]) / 2) + 'px'; }
        else el.style.left = Math.round(at(wide)) + 'px';
      }
      /* after a turn of the phone or a resize, whatever shows is placed again */
      function wordsAt() { if (helloOn) offMoon(hello, true); if (placeOn) offMoon(placeEl, false); }

      /* ---- visitors: Footnote or Soryndel every 5 to 15 minutes, the first within 90 s; a page turns now and then ---- */
      nextVisit = rand(25, 90) * 1000 / fast();
      nextTurn = rand(70, 160) * 1000;
      let visitClock = 0;
      function visitors() {
        visitClock = studyMs / fast();
        /* a cat visit the scene lost (it should never happen now; a visit carries its start, so a rebuilt scene resumes it) */
        if (catOut && sec - catAt > catNap + 90) catOut = false;
        if (visitClock >= nextVisit && !window.__studyNoVisits) {
          let who = Math.random() < 0.5 ? 'cat' : 'owl';
          if (who === lastWho && Math.random() < 0.7) who = who === 'cat' ? 'owl' : 'cat';
          if (who === 'cat' && catOut) who = 'owl';
          lastWho = who;
          /* t0 is the scene's clock (the part's sec): a scene rebuilt by a turn of the phone or a resize picks the visit up */
          if (who === 'cat') {
            catOut = true; catAt = sec; catNap = catNap0 = Math.round(rand(70, 160) / Math.max(1, fast() / 4)); catPet = 0; catAsleep = false;
            nsSet('cat', { nap: catNap, t0: sec });
          } else {
            owlT0 = sec; owlN = Math.random(); owlStay = OWL_STAY; owlPet = 0; owlGreeted = false; owlFeather = false;
            nsSet('owl', owlVal());
          }
          nextVisit = visitClock + rand(300, 900) * 1000 / fast();
        }
        if (!reduced && sec * 1000 >= nextTurn) turnPage(false);
        /* the free hourglass turns itself over every 25 minutes (the scene's hour): one soft bell, no words */
        if (!tm) {
          const gt = sec - freeBase, gn = gt >= 0 ? Math.floor(gt / HOUR) : 0;
          if (gn !== freeN) { freeN = gn; if (!reduced && gn > 0) { bells++; play('bell', { q: 0.6 }, 'ring'); } }
        }
      }

      /* ---- the hourglass: a timer on the wall clock, or the free turns ---- */
      function timerStart(min) {
        const f = fast(), ms = min * 60000 / f, now = Date.now();
        tm = { min, f, start: now, end: now + ms, t0: sec, dur: Math.max(1, ms / 1000 - FLP), done: false, rung: false, told: false };
        nsSet('glass', { mode: 'timer', t0: sec, dur: tm.dur });
        glassLast = min; glassKeep(min);
        tapB.glass.classList.remove('is-done');
        leftEl.classList.remove('is-new'); void leftEl.offsetWidth; leftEl.classList.add('is-new');
        armEnd(); paintLeft(); draw();
      }
      function timerFree() {
        tm = null; clearTimeout(endT); endT = 0;
        tapB.glass.classList.remove('is-done');
        freeBase = sec + FLP; freeN = 0;
        nsSet('glass', { mode: 'free', t0: sec });
        paintLeft(); draw();
      }
      function armEnd() {
        clearTimeout(endT); endT = 0;
        if (tm && !tm.done) endT = later(() => { endT = 0; timerCheck(); if (tm && !tm.done) armEnd(); }, Math.max(0, tm.end - Date.now()) + 40);
      }
      function timerCheck() {
        if (!tm || tm.done || over) return;
        const now = Date.now();
        if (now >= tm.end) { timerDone(); return; }
        /* the sand keeps to the wall clock: a hidden tab stops the scene's clock, so the glass catches up when it shows */
        const el = (now - tm.start) / 1000;
        if (!document.hidden && el > FLP + 0.5 && Math.abs(sec - tm.t0 - el) > 1) { tm.t0 = sec - el; nsSet('glass', { mode: 'timer', t0: tm.t0, dur: tm.dur }); }
        paintLeft();
      }
      function timerDone() {
        tm.done = true; clearTimeout(endT); endT = 0;
        /* the sand all in the bottom, to stay until the reader sets the glass again */
        nsSet('glass', { mode: 'timer', t0: sec - tm.dur - FLP - 0.05, dur: tm.dur });
        /* one soft bell when it ends (a hidden tab that still runs its timers rings then; one that slept rings as it shows),
           and the hourglass breathes a slow warm glow until it is touched */
        if (!tm.rung) { tm.rung = true; bells++; play('bell', null, 'ring'); }
        tapB.glass.classList.add('is-done');
        paintLeft();
        if (!document.hidden) tellDone();
        if (reduced) draw();
      }
      function tellDone() {
        if (!tm || tm.told || over) return;
        tm.told = true;
        let i = 0;
        try { const n = +localStorage.getItem(DONE_KEY) || 0; i = n % DONE.length; localStorage.setItem(DONE_KEY, String(n + 1)); } catch (e) { i = 0; }
        say(i === 0 && visit.lamp === 'out' ? DONE_DARK : DONE[i]);
      }
      function paintLeft() {
        let t = '';
        if (tm && !tm.done) { const m = Math.max(1, Math.ceil((tm.end - Date.now()) * tm.f / 60000)); t = m === 1 ? '1 minute left' : m + ' minutes left'; }
        if (t === leftNow) return;
        leftNow = t; leftTxt.textContent = t; leftEl.hidden = !t;
      }

      /* ---- the panel: a calm card by the hourglass ---- */
      function hgMark() {
        const on = tm && !tm.done ? tm.min : tm ? -1 : 0;
        hg.querySelectorAll('button').forEach((b) => {
          const m = +b.dataset.min;
          b.setAttribute('aria-pressed', m === on ? 'true' : 'false');
          /* the time chosen last (in this browser), a small dot */
          if (m > 0 && m === glassLast) b.dataset.last = '1'; else delete b.dataset.last;
        });
      }
      function hgShow(viaKb) {
        if (over || hgOn || tapB.glass.hidden) return;
        hgOn = true; hgSig = '';
        hgMark(); hgPlace();
        hg.classList.add('is-on'); tapB.glass.setAttribute('aria-expanded', 'true');
        /* by keyboard the focus starts on the running time, else on the last one chosen */
        if (viaKb) { const f = (tm && !tm.done && hg.querySelector('[aria-pressed="true"]')) || hg.querySelector('[data-last]') || hg.querySelector('[aria-pressed="true"]') || hg.querySelector('button'); try { f.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
        wake();
      }
      function hgHide(refocus) {
        if (!hgOn) return;
        hgOn = false;
        hg.classList.remove('is-on'); tapB.glass.setAttribute('aria-expanded', 'false');
        try {
          if (refocus && !tapB.glass.hidden) tapB.glass.focus({ preventScroll: true });
          else if (hg.contains(document.activeElement)) o.focus({ preventScroll: true });
        } catch (e) { /* fine */ }
      }
      /* above the hourglass, or beside it when the top bar is in the way (a phone on its side), always on the screen,
         with its small pointer at the hourglass's middle */
      function hgPlace() {
        if (!hgOn || tapB.glass.hidden) return;
        const orr = o.getBoundingClientRect(), gr = tapB.glass.getBoundingClientRect(), w = hg.offsetWidth, h = hg.offsetHeight, m = 12;
        const minT = Math.max(m, topEl.getBoundingClientRect().bottom - orr.top + 8), maxT = orr.height - h - m;
        const gx = gr.left - orr.left + gr.width / 2, gy = gr.top - orr.top + gr.height / 2;
        let x = gx - w / 2, y = gr.top - orr.top - h - 12, side = 'above';
        if (y < minT) {
          y = gy - h / 2; side = 'right';
          x = gr.right - orr.left + 12;
          if (x + w > orr.width - m) { x = gr.left - orr.left - w - 12; side = 'left'; }
        }
        x = clamp(x, m, Math.max(m, orr.width - w - m)); y = clamp(y, Math.min(minT, maxT), Math.max(m, maxT));
        const ax = Math.round(clamp(gx - x, 22, w - 22)), ay = Math.round(clamp(gy - y, 22, h - 22));
        const sig = Math.round(x) + ',' + Math.round(y) + side + ax + ',' + ay;
        if (sig === hgSig) return;
        hgSig = sig; hg.style.left = Math.round(x) + 'px'; hg.style.top = Math.round(y) + 'px';
        hg.dataset.side = side; hg.style.setProperty('--ax', ax + 'px'); hg.style.setProperty('--ay', ay + 'px');
      }
      hg.addEventListener('click', (e) => {
        const b = e.target && e.target.closest ? e.target.closest('button') : null;
        if (!b || !hg.contains(b) || over) return;
        const m = +b.dataset.min || 0;
        if (m > 0) timerStart(m); else timerFree();
        /* the glass lifts and turns over: sand sliding, then a soft knock as it sets down */
        play('sand', null, 'whoosh', { g: 0.05, d: 0.5 });
        hit('glass');
        hgHide(e.detail === 0);
      });

      /* ---- the sill at play: each thing answers its tap at once (its value, its sound, the frame drawn now). The page
         decides it all and the art draws from the values (see Play in the head, and VISTAS.md for each value) ---- */
      /* what the art says it draws (lbsLay.can, { out, portal } or a list), or the checks' stand-in (window.__studyCan) */
      function can(f) {
        try {
          const q = window.__studyCan;
          if (q && typeof q === 'object') return !!q[f];
          const lay = nsGet(SK, 'lbsLay'), c = lay && lay.can;
          return !!(c && (Array.isArray(c) ? c.indexOf(f) >= 0 : c[f]));
        } catch (e) { return false; }
      }
      function found(k) { if (!store.found[k]) { store.found[k] = 1; playKeep(store); } }
      /* a rare thing: one in n, and sure by the given try in this browser (its count kept per browser) */
      function rare(name, n, by) {
        const p = store.pity;
        p[name] = Math.min(99, (p[name] || 0) + 1);
        const yes = Math.random() < 1 / n || p[name] >= by;
        if (yes) p[name] = 0;
        playKeep(store);
        return yes;
      }
      /* the ivy's thirst, 0 to 1: a day since this browser last watered it, or 25 minutes of sitting since then */
      function thirst() { return clamp(Math.max(0, Date.now() - store.watered) / 3600000 / 24 + store.sat / 25, 0, 1); }
      function owlHere() { return !tapB.owl.hidden; }
      function catHere() { return !tapB.cat.hidden; }
      /* Soryndel answers something on the sill while she perches (reads along, bobs to the tune) */
      function owlDo(act, at) { if (owlHere()) nsSet('pet', { who: 'owl', t0: sec + (at || 0), act }); }
      function owlVal() { const v = { n: owlN, t0: owlT0, stay: owlStay }; if (owlFeather) v.feather = true; return v; }
      /* the lasting sill: no t0, drawn as it stands, so nothing replays when the scene is rebuilt */
      function sillNow() {
        return {
          cup: visit.cup, thirst: Math.round((sec < waterUntil ? thirstFrom : thirst()) * 100) / 100, blooms: store.blooms,
          burn: Math.round(visit.burnMin / BURN * 100) / 100, page: visit.page, lines: visit.lines, leaves: visit.leaves, flower: visit.flower, feather
        };
      }
      function setSill() { const s = sillNow(), sig = JSON.stringify(s); if (sig !== sillSig) { sillSig = sig; nsSet('sill', s); } }
      /* the moon on the reader's own clock (the hour now, the scene's clock, the speed of the checks, and the month and day
         for the nights of the meteor showers) */
      function moonNow() { const d = new Date(); moonV = { h: Math.round(localHours() * 1e4) / 1e4, t0: sec, rate: fast(), md: (d.getMonth() + 1) * 100 + d.getDate() }; nsSet('moon', moonV); }
      /* about once a minute: the scene's clock runs only while frames come, so a long sitting with a few slow frames can fall
         behind the reader's own. Over a minute and a half behind (or ahead), the moon is set again (the art eases it over
         4 s). Not while the checks speed the clock or pin the hour */
      function moonKeep() {
        if (sec - moonCheck < 60) return;
        moonCheck = sec;
        if (!moonV || fast() !== 1 || window.__studyHour != null) return;
        let dh = ((moonV.h + (sec - moonV.t0) / 3600) - localHours()) % 24;
        if (dh > 12) dh -= 24; else if (dh < -12) dh += 24;
        if (Math.abs(dh) > 0.025) moonNow();
      }

      /* each button's name follows its thing's state */
      const LABEL = {
        lamp: () => (visit.lamp === 'bright' ? 'Turn the lamp down' : visit.lamp === 'out' ? 'Light the lamp' : can('out') ? 'Put the lamp out' : 'Turn the lamp up'),
        crystal: () => 'Touch the crystal for a new view',
        glass: () => 'Set the hourglass',
        box: () => (sec < boxUntil ? 'Wind the music box' : 'Wind the music box for the next record'),
        cup: () => (visit.cup > 0 ? 'Take a sip of tea' : 'Pour more tea'),
        candle: () => (visit.candle ? 'Snuff the candle' : visit.burnMin >= BURN ? 'Put in a fresh candle' : 'Light the candle'),
        ivy: () => (thirst() >= THIRSTY && sec >= waterUntil ? 'Water the ivy' : 'Brush the ivy'),
        book: () => 'Turn a page',
        cat: () => 'Pet Footnote the cat',
        owl: () => 'Greet Soryndel the owl'
      };
      function label(k) { const l = LABEL[k](); if (labels[k] !== l) { labels[k] = l; tapB[k].setAttribute('aria-label', l); } }
      TAPS.forEach(label);
      /* a brief soft bloom where the thing stands, so a tap always shows (the art answers too) */
      function hit(k) {
        const b = tapB[k];
        if (!b || b.hidden) return;
        b.classList.remove('is-hit'); void b.offsetWidth; b.classList.add('is-hit');
        clearTimeout(hitT[k]); hitT[k] = later(() => b.classList.remove('is-hit'), 950);
      }
      /* the calm guards: 0 for a second tap within 220 ms (the first one answered it), -1 while the thing rests (six taps
         within 3 s rest it for 3 s), else the streak (1 after a pause, one more for each tap within STREAK s of the last) */
      function guard(k, wind) {
        const t = performance.now(), g = TP[k] || (TP[k] = { last: -1e9, n: 0, hist: [], rest: 0 });
        if (t < g.rest) return -1;
        if (!wind && t - g.last < 220) return 0;
        g.n = t - g.last <= STREAK * 1000 ? g.n + 1 : 1;
        g.last = t;
        g.hist.push(t);
        while (g.hist.length && t - g.hist[0] > 3000) g.hist.shift();
        if (g.hist.length >= 6) { g.rest = t + 3000; g.hist.length = 0; return -1; }
        return g.n;
      }
      /* the melody of the sill, one very soft note of the playing record's set under a thing's own sound, climbing while taps
         follow each other within a streak's window (and stepping back down from the top), from the bottom after a pause */
      function note(q) {
        const t = performance.now(), set = NOTES[recId] || NOTES.quiet;
        if (t - nLast > STREAK * 1000) { nIdx = 0; nDir = 1; }
        else {
          nIdx += nDir;
          if (nIdx >= set.length) { nIdx = Math.max(0, set.length - 2); nDir = -1; } else if (nIdx < 0) { nIdx = Math.min(1, set.length - 1); nDir = 1; }
        }
        nLast = t;
        notes.push(set[nIdx]); if (notes.length > 12) notes.shift();
        tones.play('note', { n: set[nIdx], vol: q });
      }
      /* the sill's song: all eight sill things touched within 20 s, once a sitting. The set played through, the crystal
         and the hourglass glowing together, and on a clear night a falling star */
      function songTap(k) {
        if (songDone || SONG.indexOf(k) < 0) return;
        const t = performance.now();
        songSeen[k] = t;
        if (!SONG.every((x) => songSeen[x] && t - songSeen[x] <= 20000)) return;
        songDone = true; found('song');
        later(() => {
          play('sing', { rec: recId });
          nsSet('song', { t0: sec });
          hit('crystal'); hit('glass');
          if (WX[recId] === 'clear' && !reduced) nsSet('wish', { t0: sec + 0.8 });
          draw();
        }, 450);
      }

      /* the oil lamp: bright, low, out (once the art draws out), and lit again. The candle's flame lights it when the
         candle burns (an ember hops over the sill and lands EMBER s later), else Zhaunil's blue snap */
      function lampTap() {
        const from = visit.lamp, to = from === 'bright' ? 'low' : from === 'low' && can('out') ? 'out' : 'bright', v = { lvl: to, t0: sec };
        visit.lamp = to;
        if (from === 'out') {
          v.by = visit.candle ? 'candle' : 'spark';
          if (v.by === 'candle') { play('flare', { at: EMBER }); play('hop'); } else { play('flare', { at: 0.3 }); play('tink', { vol: 0.8 }); }
        } else if (to === 'out') play('out', null, 'candle', { warm: false });
        else play('wick', { up: to === 'bright' }, 'latch');
        nsSet('lamp', v);
        darkNow();
        return from === 'out' ? 'light' : to;
      }
      /* the candle: snuffed (a smoke ring now and then) or lit, from the lamp's flame when it burns (the same ember the
         other way) else the blue snap, now and then Zhaunil's blue flame. It burns down while lit (BURN minutes to a
         stub), and a stub snuffed and touched again is a fresh tall candle */
      function candleTap() {
        const v = { lit: !visit.candle, t0: sec };
        if (visit.candle) {
          visit.candle = false;
          if (!reduced && Math.random() < 1 / 6) v.v = 'ring';
          play('snuff', v.v ? { vol: 0.75 } : null, 'candle', { warm: false });
        } else {
          visit.candle = true;
          if (visit.burnMin >= BURN) { v.v = 'fresh'; visit.burnMin = 0; } else if (!reduced && Math.random() < 1 / 8) v.v = 'blue';
          const ember = can('out');
          if (ember) v.by = visit.lamp !== 'out' ? 'lamp' : 'spark';
          const at = !ember ? 0 : v.by === 'lamp' ? EMBER : 0.3;
          if (v.v === 'blue') play('crystal', { vol: 0.33, at });
          if (v.v === 'fresh') sndAs('pat');
          if (ember) { play('flare', { at }); if (v.by === 'lamp') play('hop'); else play('tink', { vol: 0.8 }); } else sndAs('candle');
        }
        nsSet('candle', v);
        darkNow();
        return v.lit ? (v.v === 'fresh' ? 'fresh' : 'light') : 'snuff';
      }
      /* the dark room: the lamp and the candle both out. On a clear night a falling star soon, then about every 50 s */
      function darkNow() {
        const d = visit.lamp === 'out' && !visit.candle;
        if (d === dark) return;
        dark = d;
        o.classList.toggle('is-dark', d);
        if (d) { found('dark'); nextWish = sec + rand(3, 8); }
      }
      function night() {
        if (!dark || reduced || WX[recId] !== 'clear' || sec < nextWish) return;
        nsSet('wish', { t0: sec }); play('wish'); nextWish = sec + rand(44, 58);
      }
      /* the cup: three sips empty it, then Zhaunil's teapot pours (POUR s) and glides on to water a thirsty ivy */
      function cupTap() {
        if (sec < pourUntil) { play('tink', { vol: 0.5 }); return 'wait'; }
        if (visit.cup > 0) {
          visit.cup--;
          nsSet('cup', { t0: sec, act: 'sip' });
          play('cup', visit.cup === 0 ? { light: 1 } : null, 'pat');
          return 'sip';
        }
        const v = { t0: sec, act: 'pour' };
        if (!reduced && Math.random() < 0.1) v.v = 'loop';
        visit.cup = 3; pourUntil = sec + POUR; found('pour');
        nsSet('cup', v);
        if (thirst() >= THIRSTY && sec >= waterUntil) water(sec + POUR - 0.2, 'cup');
        play('pour');
        return 'pour';
      }
      /* the teapot gives the ivy three drops (from the cup it glides on after the pour, else it floats down): a drink runs
         through the leaves, and its thirst is gone once it has. The next touch at least 5 s later opens a flower */
      function water(t0, from) {
        const wait = Math.max(0, t0 - sec), v = { t0, act: 'water' };
        if (from) v.from = from;
        thirstFrom = thirst(); waterUntil = t0 + 2.2;
        store.watered = Date.now() + wait * 1000; store.sat = 0; canBloom = true; bloomAt = performance.now() + wait * 1000;
        playKeep(store); found('water');
        nsSet('ivy', v);
        play('drip', { at: wait + (from ? 0.35 : 0.8) });
        later(() => { setSill(); label('ivy'); }, (waterUntil - sec) * 1000 + 120);
      }
      /* the ivy: a rustle, a leaf, two leaves, then a shiver (at most three leaves a minute); water when it is thirsty; a
         flower after a drink (kept per browser, up to nine, three new a sitting); and the pixie now and then (more often
         the more it flowers, sure by the 15th touch in this browser, once a sitting) */
      function ivyTap(n) {
        if (sec < waterUntil) { play('leaves', { vol: 0.4, n: 3 }); return 'wait'; }
        store.pity.pixie = Math.min(99, store.pity.pixie + 1);
        if (thirst() >= THIRSTY) { water(sec, ''); play('leaves', { vol: 0.5, n: 4 }); return 'water'; }
        const t = performance.now();
        if (canBloom && t >= bloomAt + 5000 && bloomsNew < 3 && store.blooms < 9) {
          canBloom = false; bloomsNew++; store.blooms++; playKeep(store);
          nsSet('ivy', { t0: sec, act: 'bloom' });
          play('bloom', { at: 0.2 }); play('leaves', { vol: 0.5, n: 4 });
          return 'bloom';
        }
        leafTimes = leafTimes.filter((x) => t - x < 60000);
        let act = n <= 1 ? 'rustle' : n === 2 ? 'leaf' : n === 3 ? 'leaves' : 'shiver', fall = act === 'leaf' ? 1 : act === 'leaves' ? 2 : 0;
        if (fall && leafTimes.length + fall > 3) { act = n === 2 ? 'rustle' : 'shiver'; fall = 0; }
        if (act === 'rustle' && !pixieDone && (Math.random() < 1 / Math.max(3, 12 - store.blooms) || store.pity.pixie >= 15)) { act = 'pixie'; pixieDone = true; store.pity.pixie = 0; }
        playKeep(store);
        nsSet('ivy', { t0: sec, act });
        if (fall) { for (let i = 0; i < fall; i++) leafTimes.push(t); leafFall(fall); }
        if (act === 'pixie') { play('pixie', { at: 0.25 }); play('leaves'); }
        else if (act === 'shiver') { play('leaves', { vol: 0.5, at: 0.14, n: 5 }); play('leaves', { vol: 0.5, n: 5 }); }
        else play('leaves', act === 'leaf' ? { vol: 0.7, n: 5 } : null, 'rustle');
        return act;
      }
      /* falling leaves land on the cushion after their drift (about 4 s) and stay for the visit, up to six. Footnote on the
         sill pounces on the first just before it lands (POUNCE s after the tap). Whether he catches it is decided then, not
         at the tap: he sits up for only a few seconds after he arrives and after his nap, and curled up he only flicks his
         tail and the leaf lands. The art's own pose decides when it gives it (lbsLay.catPose, 'sit' catches), else he must
         be up and not napping. A pet in between takes the pounce's place, and then nothing is caught */
      const POUNCE = 3.2;
      function catCatches(pv) {
        if (reduced || nsGet(SK, 'pet') !== pv) return false;
        const q = window.__studyCatPose, lay = nsGet(SK, 'lbsLay');
        if (typeof q === 'string') return q === 'sit';
        if (lay && typeof lay.catPose === 'string') return lay.catPose === 'sit';
        return catHere() && !catAsleep;
      }
      function leafFall(f) {
        let caught = 0;
        leavesDue += f;
        if (catHere()) {
          const pv = { who: 'cat', act: 'pounce', t0: sec + POUNCE };
          nsSet('pet', pv);
          later(() => { if (catCatches(pv)) { caught = 1; leavesDue--; play('paw'); } }, POUNCE * 1000);
        }
        later(() => { const land = f - caught; leavesDue -= land; visit.leaves = Math.min(6, visit.leaves + land); setSill(); }, 4200);
      }
      /* the book: a touch after a pause turns a page; quick touches after a turn or a line write lines on the left page
         with the quill (up to four a spread, 1.4 s each), and a quick touch after the fourth turns it. Soryndel reads along
         and hoots after the fourth line. Now and then a pressed flower slides out (sure by the 25th turn here, once a day) */
      function bookTap() {
        const t = performance.now(), quick = t - bookLast <= STREAK * 1000;
        bookLast = t;
        if (sec < quillUntil) { play('quill', { vol: 0.35 }); return 'wait'; }
        if (quick && visit.lines < 4) {
          visit.lines++;
          nsSet('quill', { t0: sec, line: visit.lines }); quillUntil = sec + 1.4;
          owlDo('read');
          if (visit.lines === 4 && owlHere()) later(() => { if (owlHere()) { owlDo('look'); play('hoot', { vol: 0.7 }); } }, 1600);
          play('quill');
          return 'line';
        }
        return turnPage(true);
      }
      function turnPage(byReader) {
        visit.page++; visit.lines = 0;
        const v = { n: ++turnN, t0: sec };
        if (byReader && !visit.flower && store.flowerDay !== today() && rare('flower', 15, 25)) { v.v = 'flower'; visit.flower = true; store.flowerDay = today(); playKeep(store); play('slide', { at: 0.45 }); }
        nsSet('turn', v);
        nextTurn = sec * 1000 + rand(120, 300) * 1000;
        if (byReader) { owlDo('read'); sndAs('flip'); } else snd('flip');
        setSill();
        return v.v ? 'flower' : 'turn';
      }
      /* Zhaunil's crystal: the next view at once (a portal when the art draws one, now and then ending in a ripple of stars
         on a clear night); touched again while a view comes in it flares again, a note higher each time, and its view
         waits for this one to settle. In the dark room three dancing lights rise from it */
      function crystalTap() {
        const v = { t0: sec };
        let up = 0;
        if (dark && sec >= lightsUntil) { nsSet('lights', { t0: sec }); lightsUntil = sec + 8; play('motes', { at: 0.3 }); }
        if (sec - lastCrystal > 1.2) {
          lastCrystal = sec;
          if (changing()) { vPend = true; clearTimeout(placeT); placeT = 0; placeHide(); up = ++crystalUp; }
          else {
            crystalUp = 0;
            if (stepView(true) && vBy) {
              if (WX[recId] === 'clear' && !reduced && Math.random() < 1 / 8) v.v = 'ripple';
              sndAs('whoosh', { g: 0.03, d: 2.2 });
            }
          }
        } else up = ++crystalUp;
        nsSet('crystal', v);
        play('crystal', { up: Math.min(7, up * 2) }, 'chime');
        return vPend ? 'wait' : 'view';
      }
      /* the music box: shut, a touch opens it and plays the next calm record (a brass dragon turns in it now and then, sure
         by the 12th opening here); open, a touch winds it (1.6 s more, up to 9 s from opening) with a run of its tune and
         never skips a second record. The record's name always plays the next record, the box opening (or staying open) */
      function boxTap(fromRec) {
        const open = sec < boxUntil;
        let act = 'wind';
        if (!open || fromRec) {
          if (!nextRec()) { play('tink', null, 'tap'); hit('box'); return 'wait'; }
          if (open) boxUntil = Math.min(boxT0 + 9, Math.max(boxUntil, sec + 3));
          else { boxT0 = sec; boxUntil = sec + 3; boxWinds = 0; boxV = rare('dragon', 8, 12) ? 'dragon' : ''; }
          play('comb', { rec: recId }, 'lights');
          act = 'open';
        } else {
          boxUntil = Math.min(boxT0 + 9, boxUntil + 1.6);
          play('wind', { rec: recId, i: boxWinds++ });
        }
        const v = { t0: boxT0, until: Math.round(boxUntil * 100) / 100, wt: sec };
        if (boxV) v.v = boxV;
        nsSet('box', v);
        /* Soryndel bobs in time from the first note (the lid's notes or the wind's) */
        owlDo('bob', act === 'open' ? COMB0 : WIND0);
        hit('box');
        return act;
      }
      /* the hourglass: it rocks a little at every touch, and offers its panel */
      function glassTap(viaKb) {
        tapB.glass.classList.remove('is-done');
        nsSet('wobble', { t0: sec });
        play('tink', null, 'tap');
        if (hgOn) hgHide(viaKb); else hgShow(viaKb);
        return hgOn ? 'panel' : 'shut';
      }
      /* Footnote: a purr, a slow blink, a stretch, a purr, then he turns round once (enough); the ladder starts again after
         20 s without a pet. Each pet keeps him 25 s longer, up to 2 minutes more (his visit's t0 kept, so it carries on) */
      function catTap() {
        const t = performance.now(), cv = nsGet(SK, 'cat');
        if (t - catPetAt > 20000) catPet = 0;
        catPetAt = t;
        const act = CAT_ACTS[Math.min(catPet, CAT_ACTS.length - 1)];
        catPet = act === 'turn' ? 0 : catPet + 1;
        if (act === 'turn') found('turn');
        nsSet('pet', { who: 'cat', t0: sec, act });
        if (cv && cv.t0 != null) {
          if (+cv.t0 !== catAt || !catNap0) { catAt = +cv.t0; catNap = catNap0 = +cv.nap || 90; }
          const k = Math.max(1, fast() / 4);
          catNap = Math.min(catNap0 + Math.round(120 / k), catNap + Math.round(25 / k));
          if (catNap !== +cv.nap) nsSet('cat', { nap: catNap, t0: cv.t0 });
        }
        if (act === 'stretch' || act === 'turn') { play('purr', { vol: 0.35 }); play('leaves', { vol: 0.33, n: 5 }); }
        else play('purr', act === 'blink' ? { vol: 0.55 } : null, 'heart');
        return act;
      }
      /* Soryndel: she looks at you (her breath fogs the glass), knocks back on it, fluffs up, swivels her head right round,
         then from the start with a softer hoot; each greeting keeps her 6 s longer, up to 30 s more. A visit she was greeted
         in leaves a feather on the ledge one time in three */
      function owlTap() {
        const t = performance.now(), ov = nsGet(SK, 'owl');
        if (ov && ov.t0 != null && +ov.t0 !== owlT0) { owlT0 = +ov.t0; owlN = +ov.n || 0; owlStay = +ov.stay || OWL_STAY; owlPet = 0; owlGreeted = false; owlFeather = false; }
        if (t - owlPetAt > 20000) owlPet = 0;
        owlPetAt = t;
        const act = OWL_ACTS[owlPet % OWL_ACTS.length], again = owlPet >= OWL_ACTS.length;
        owlPet++;
        if (act === 'knock') found('knock');
        if (!owlGreeted) { owlGreeted = true; owlFeather = !reduced && Math.random() < 1 / 3; }
        nsSet('pet', { who: 'owl', t0: sec, act });
        if (ov && owlT0 != null) { owlStay = Math.min(OWL_STAY + 30, owlStay + 6); nsSet('owl', owlVal()); }
        if (act === 'knock') play('knock'); else if (act === 'fluff') play('fluff'); else if (act === 'swivel') play('fluff', { vol: 0.45 }); else play('hoot', again ? { vol: 0.7 } : null, 'pass');
        return act;
      }
      function tapThing(k, viaKb) {
        if (over || TAPS.indexOf(k) < 0) return;
        wake();
        if (k !== 'glass') hgHide(false);
        advance();
        const g = guard(k, k === 'box' && sec < boxUntil), sings = SONG.indexOf(k) >= 0;
        if (g === 0) return;
        /* resting: only the bloom and a muted note */
        if (g < 0) { hit(k); if (sings) note(0.35); lastAct = { k, act: 'rest', n: 0 }; draw(); return; }
        if (sings) note(1);
        let act = '';
        switch (k) {
          case 'lamp': act = lampTap(); break;
          case 'candle': act = candleTap(); break;
          case 'cup': act = cupTap(); break;
          case 'ivy': act = ivyTap(g); break;
          case 'book': act = bookTap(); break;
          case 'crystal': act = crystalTap(); break;
          case 'box': act = boxTap(false); break;
          case 'glass': act = glassTap(viaKb); break;
          case 'cat': act = catTap(); break;
          case 'owl': act = owlTap(); break;
        }
        lastAct = { k, act, n: g };
        if (k !== 'box' && k !== 'glass') hit(k);
        songTap(k);
        TAPS.forEach(label);
        setSill();
        draw();
      }
      /* the record's name: the music box opens on the sill (or stays open) and the next record starts */
      recBtn.addEventListener('click', (e) => { if (over || unseen(e, recBtn)) return; wake(); advance(); lastAct = { k: 'rec', act: boxTap(true), n: 1 }; TAPS.forEach(label); draw(); });

      /* ---- the tap areas: the scene's boxes (grid px) to CSS px, grown about their middles to 44 px and moved onto the
         screen whole (a thing drawn against the frame's edge keeps its 44 px). Two that would meet are parted. The sill's
         things keep theirs, a visitor gives way to them (Footnote sitting up reaches the candle's and the ivy's for a moment
         on an upright phone), and all of them give way to the corner's buttons. The one that gives way steps back to the
         other's edge and, where the screen allows, reaches a little further away so it keeps its 44 px; two of a kind part
         halfway the same way. Written to the buttons only when one moves (a visitor, the record's name) ---- */
      const rank = (k) => (k === 'cat' || k === 'owl' ? 1 : 2);
      function split(rs, BW, BH) {
        /* M steps back from S on one side (ox <= oy: sideways), keeping TAP_MIN by reaching away from S */
        const back = (M, S, side) => {
          if (side === 'x') {
            if (M.cx <= S.cx) { M.r = Math.min(M.r, S.l); M.l = Math.max(0, Math.min(M.l, M.r - TAP_MIN)); }
            else { M.l = Math.max(M.l, S.r); M.r = Math.min(BW, Math.max(M.r, M.l + TAP_MIN)); }
            if (M.r - M.l < 1) M.r = M.l + 1;
          } else {
            if (M.cy <= S.cy) { M.b = Math.min(M.b, S.t); M.t = Math.max(0, Math.min(M.t, M.b - TAP_MIN)); }
            else { M.t = Math.max(M.t, S.b); M.b = Math.min(BH, Math.max(M.b, M.t + TAP_MIN)); }
            if (M.b - M.t < 1) M.b = M.t + 1;
          }
        };
        for (let pass = 0; pass < 4; pass++) {
          let moved = false;
          for (let i = 0; i < rs.length; i++) for (let j = i + 1; j < rs.length; j++) {
            const a = rs[i], b = rs[j], ox = Math.min(a.r, b.r) - Math.max(a.l, b.l), oy = Math.min(a.b, b.b) - Math.max(a.t, b.t);
            if (ox <= 0 || oy <= 0 || (a.ui && b.ui)) continue;
            moved = true;
            const side = ox <= oy ? 'x' : 'y';
            if (a.rank !== b.rank) { const S = a.rank > b.rank ? a : b; back(S === a ? b : a, S, side); }
            else if (side === 'x') {
              const L = a.cx <= b.cx ? a : b, R = L === a ? b : a, m = (Math.max(L.l, R.l) + Math.min(L.r, R.r)) / 2;
              back(L, { l: m, r: m, cx: Infinity }, 'x'); back(R, { l: m, r: m, cx: -Infinity }, 'x');
            } else {
              const U = a.cy <= b.cy ? a : b, D = U === a ? b : a, m = (Math.max(U.t, D.t) + Math.min(U.b, D.b)) / 2;
              back(U, { t: m, b: m, cy: Infinity }, 'y'); back(D, { t: m, b: m, cy: -Infinity }, 'y');
            }
          }
          if (!moved) break;
        }
      }
      /* an element's box in the study's own space as laid out (its offsets add up to the overlay, which never moves) */
      function laid(el) {
        let l = 0, t = 0, e = el;
        while (e && e !== o) { l += e.offsetLeft; t += e.offsetTop; e = e.offsetParent; }
        return e === o ? { l, t, w: el.offsetWidth, h: el.offsetHeight } : null;
      }
      /* the corner's lines change width (a minute lands, a shared total counts up, the timer's line comes or goes, the
         next record's name): in the row of a phone on its side the record's button moves with them, so the tap areas
         follow before the next paint, not a frame (or under reduced motion a second) later */
      let ro = null;
      try { if (typeof ResizeObserver === 'function') { ro = new ResizeObserver(() => layTaps()); [countEl, leftEl, recBtn].forEach((el) => ro.observe(el)); } } catch (e) { ro = null; }
      function layTaps() {
        if (over) return;
        const lay = nsGet(SK, 'lbsLay'), cv = artEl.querySelector('canvas');
        /* the canvas is the grid, pixel for pixel: one that does not match yet is the old one, still there for a moment
           after a phone turns (the painter rebuilds it), so the last good places stay until the new one is drawn */
        if (lay && cv && tapSig && (cv.width !== lay.W || cv.height !== lay.H)) { if (hgOn) hgPlace(); return; }
        const rs = [];
        let orr = null;
        if (lay && cv && lay.W > 0 && lay.H > 0) {
          const cr = cv.getBoundingClientRect();
          orr = o.getBoundingClientRect();
          if (cr.width > 10 && cr.height > 10) {
            const sx = cr.width / lay.W, sy = cr.height / lay.H;
            TAPS.forEach((k) => {
              const g = lay[k];
              if (!Array.isArray(g) || g.length < 4 || !(g[2] > 0) || !(g[3] > 0)) return;
              const l = cr.left - orr.left + g[0] * sx, t = cr.top - orr.top + g[1] * sy, w = g[2] * sx, h = g[3] * sy, cx = l + w / 2, cy = t + h / 2;
              const W = Math.max(w, TAP_MIN), H = Math.max(h, TAP_MIN);
              /* whole on the screen: moved in, never cut (a box wider than the screen keeps the screen) */
              const l0 = clamp(cx - W / 2, 0, Math.max(0, orr.width - W)), t0 = clamp(cy - H / 2, 0, Math.max(0, orr.height - H));
              rs.push({ k, rank: rank(k), cx, cy, l: l0, t: t0, r: Math.min(orr.width, l0 + W), b: Math.min(orr.height, t0 + H) });
            });
            /* the corner's buttons (Back, sound, the record's name) lie over the art: the sill's areas give way to them, each
               where it is laid out and not where a moment's animation draws it (the record's name rises 5 px as it comes in) */
            [backBtn, sndBtn, recBtn].forEach((el) => {
              const q = laid(el);
              if (q && q.w > 0 && q.h > 0) rs.push({ k: '', ui: true, rank: 3, cx: q.l + q.w / 2, cy: q.t + q.h / 2, l: q.l, t: q.t, r: q.l + q.w, b: q.t + q.h });
            });
            split(rs, orr.width, orr.height);
          }
        }
        const px = rs.filter((r) => !r.ui).map((r) => { const l = Math.round(r.l), t = Math.round(r.t); return { k: r.k, cx: r.cx, cy: r.cy, l, t, w: Math.round(r.r) - l, h: Math.round(r.b) - t }; });
        const sig = px.map((r) => r.k + r.l + ',' + r.t + ',' + r.w + ',' + r.h).join('|');
        if (sig !== tapSig) {
          tapSig = sig;
          const seen = {};
          px.forEach((r) => {
            const b = tapB[r.k];
            b.style.left = r.l + 'px'; b.style.top = r.t + 'px'; b.style.width = r.w + 'px'; b.style.height = r.h + 'px';
            b.hidden = false; seen[r.k] = 1;
          });
          TAPS.forEach((k) => {
            const b = tapB[k];
            if (seen[k] || b.hidden) return;
            if (document.activeElement === b) { try { o.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
            b.hidden = true;
            if (k === 'glass') hgHide(false);
          });
          tabOrder = px.slice().sort((a, b) => a.cx - b.cx || a.cy - b.cy).map((r) => tapB[r.k]);
        }
        if (hgOn) hgPlace();
      }

      /* ---- the corner fades when nothing moves for about 4 s (never under the keyboard). A touch on the faded corner only
         brings it back: the click that same touch makes is let go by a button the reader could not see (Back, the sound,
         the record's name unless it was showing), so one touch never leaves the study unseen. The moment the corner comes
         back is noted (by a touch or a pen, or the page taking the focus as a touch lands), and a click within 0.6 s of it
         is let go unless a new touch began after it (80 ms on), so a second tap presses at once. A mouse shows the corner
         as it moves, well before it clicks, so it never waits, and nor does a key ---- */
      function wake(e) {
        /* (the focus going back to the room as the study ends must not start a new wait) */
        if (over) return;
        const now = performance.now();
        if (o.classList.contains('is-idle')) { if (!(e && (e.pointerType === 'mouse' || e.type === 'wheel'))) { wokeAt = now; wokeRec = recBtn.classList.contains('is-on'); } }
        else if (e && (e.type === 'pointerdown' || e.type === 'touchstart') && now - wokeAt > 80) wokeAt = -1e9;
        o.classList.remove('is-idle');
        clearTimeout(idleT);
        idleT = setTimeout(() => { if (!over && !kb && !hgOn) o.classList.add('is-idle'); }, 4000);
      }
      /* the click of the touch that woke the corner, on a button that was not showing (a key's click has no detail) */
      function unseen(e, el) {
        if (!e || e.detail === 0 || performance.now() - wokeAt > 600 || (el === recBtn && wokeRec)) return false;
        wokeAt = -1e9;
        return true;
      }
      ['pointermove', 'pointerdown', 'touchstart', 'wheel'].forEach((t) => o.addEventListener(t, wake, { passive: true }));
      o.addEventListener('focusin', (e) => { kb = !!(e.target && e.target.matches && e.target.matches(':focus-visible')); if (kb) wake(); });
      o.addEventListener('focusout', () => { kb = false; wake(); });

      /* ---- sound ---- */
      const paintSnd = () => { const m = !!(window.FFSound && FFSound.muted); sndBtn.innerHTML = m ? ICON_OFF : ICON_ON; sndBtn.setAttribute('aria-label', m ? 'Turn sound on' : 'Turn sound off'); sndBtn.setAttribute('aria-pressed', m ? 'true' : 'false'); };
      sndBtn.addEventListener('click', (e) => {
        const S = window.FFSound; if (!S || unseen(e, sndBtn)) return;
        try { S.wake(); S.setMuted(!S.muted); } catch (e) { /* fine */ }
        paintSnd(); wake();
      });
      /* a mute stops the study's own sounds at once too (a bell still ringing out) */
      const onMute = () => { paintSnd(); tones.hush(!!(window.FFSound && FFSound.muted)); };
      document.addEventListener('ffsound:mute', onMute);
      paintSnd();

      /* ---- the screen stays awake while studying, where the browser lets it ---- */
      function keepAwake() {
        try {
          if (lock || document.hidden || !navigator.wakeLock || typeof navigator.wakeLock.request !== 'function') return;
          navigator.wakeLock.request('screen').then((l) => { if (over) { l.release().catch(() => {}); return; } lock = l; l.addEventListener('release', () => { if (lock === l) lock = null; }); }).catch(() => {});
        } catch (e) { /* refused: fine */ }
      }
      function onVis() {
        if (document.hidden) { flush(); paintCount(); clearTimeout(frameT); frameT = 0; lastNow = 0; }
        else {
          lastNow = 0; keepAwake();
          /* the moon where the reader's clock has it now (the scene's clock stood still while the tab was hidden) */
          moonNow();
          /* a timer that ended while the tab was hidden: its bell now if the page slept through it, and Zhaunil's line */
          timerCheck();
          if (tm && tm.done && !tm.told) tellDone();
          if (!frameT && !over) tick();
        }
      }
      document.addEventListener('visibilitychange', onVis);
      /* a resize or a turn of the phone: the painter rebuilds its grid a moment later (about 160 ms), so the frame and the
         tap areas follow at once and again as it settles (under reduced motion the clock draws only once a second) */
      let rzT = [];
      const onResize = () => { if (over) return; rzT.forEach((id) => clearTimeout(id)); rzT = [60, 260, 520, 900].map((ms) => later(() => { draw(); wordsAt(); }, ms)); };
      const vvp = window.visualViewport || null;
      window.addEventListener('resize', onResize);
      if (vvp && vvp.addEventListener) vvp.addEventListener('resize', onResize);
      /* some in-app browsers close a page without a visibilitychange: hand the waiting minutes over on pagehide too */
      const onHide = () => { try { flush(); } catch (e) { /* fine */ } };
      window.addEventListener('pagehide', onHide);
      keepAwake();

      /* ---- the room leans in toward its window, then rests while the study covers it ---- */
      const pan = (F.el && F.el.querySelector('.lb-pan')) || F.art || null;
      function windowAt() {
        try {
          const lay = ns && ns.get ? ns.get('library', 'lbLay') : null, art = F.art;
          if (!lay || !lay.win || !art || typeof F.toCss !== 'function') return null;
          const pt = F.toCss((lay.win[0] + lay.win[2]) / 2, (lay.win[1] + lay.win[3]) / 2), ar = art.getBoundingClientRect(), pr = pan.getBoundingClientRect();
          return [ar.left + pt.x - pr.left, ar.top + pt.y - pr.top];
        } catch (e) { return null; }
      }
      function lean(on, ms) {
        if (!pan || reduced) return;
        const at = windowAt();
        pan.style.transformOrigin = at ? at[0] + 'px ' + at[1] + 'px' : '50% 40%';
        pan.style.transition = ms ? 'transform ' + ms + 'ms cubic-bezier(.45, 0, .2, 1)' : 'none';
        pan.style.transform = on ? 'scale(1.55)' : '';
      }
      function rest(on) {
        if (!pan) return;
        if (on) { pan.style.transition = 'none'; pan.style.transform = 'translate3d(0, 300vh, 0)'; pan.dataset.studyRest = '1'; }
        else if (pan.dataset.studyRest) { delete pan.dataset.studyRest; pan.style.transition = 'none'; pan.style.transform = ''; pan.style.transformOrigin = ''; }
      }
      /* the tap answers in its first frame: the room starts to lean in. Once that frame has shown, the scene is built and
         its first frame drawn, and only then does the study fade up over the leaning room. The fade (and the art's settle
         inside it) waits 0.45 s (0.35 s) after the lean began as it always has, less the time the build took, so the
         timing is the same and the study never shows before its first frame (under reduced motion it simply crossfades
         once drawn) */
      requestAnimationFrame(() => {
        if (over) return;
        lean(true, 1100);
        const leanAt = performance.now();
        later(() => {
          mountArt();
          clearTimeout(frameT); frameT = 0;
          tick();
          const took = performance.now() - leanAt, wait = reduced ? 0 : Math.max(0, Math.round(450 - took));
          if (!reduced) { o.style.transitionDelay = wait + 'ms'; artEl.style.transitionDelay = Math.max(0, Math.round(350 - took)) + 'ms'; }
          o.classList.add('is-in');
          later(() => { o.style.transitionDelay = ''; rest(true); }, reduced ? 450 : wait + 700);
        }, 0);
      });

      /* ---- Zhaunil's lines, the welcome once the room has settled and the hourglass's end. About 6 s each, then gone;
         a tap anywhere or Escape lets one go sooner. The first visit in this browser gets the plainest welcome ---- */
      try { const seen = +localStorage.getItem(HELLO_KEY) || 0; helloIdx = seen % HELLO.length; localStorage.setItem(HELLO_KEY, String(seen + 1)); } catch (e) { helloIdx = 0; }
      function helloGo() { if (!helloOn) return; helloOn = false; helloOff = performance.now(); clearTimeout(helloT); hello.classList.remove('is-on'); hello.classList.add('is-off'); o.classList.remove('is-talk'); }
      function say(line) {
        /* a place's name showing gives way at once (they share the top on a phone) */
        if (placeOn) { placeHide(); placeEl.style.transition = 'none'; void placeEl.offsetWidth; placeEl.style.transition = ''; }
        said = line; lineIn(line);
        offMoon(hello, true);
        hello.classList.remove('is-off');
        helloOn = true; hello.classList.add('is-on'); o.classList.add('is-talk');
        /* a longer line stays longer (about a quarter second a word, 5.6 to 9.2 s) */
        clearTimeout(helloT); helloT = later(helloGo, clamp(2400 + line.split(/\s+/).length * 260, 5600, 9200));
      }
      /* his words once the card is in: the box's own arrival (FFD.arrive, core.js), so Zhaunil talks here as every
         character does on every scene page, one word after another at a reading pace with a beat after a comma and a
         longer one after a full stop. The line is laid out whole first, so the card never changes size. Without it, each
         word rises in its place on a short stagger; under reduced motion the line is simply there */
      function lineIn(line) {
        if (helloArr) { helloArr.stop(); helloArr = null; }
        helloLine.textContent = '';
        if (reduced) { helloLine.textContent = line; return; }
        if (typeof FFD.arrive === 'function') { helloArr = FFD.arrive(helloLine, line, { delay: 380 }); return; }
        const ws = line.split(' ');
        ws.forEach((w, i) => {
          const s = document.createElement('span');
          s.className = 'lbs-w'; s.textContent = w; s.style.animationDelay = (0.22 + i * 0.065).toFixed(3) + 's';
          helloLine.append(s);
          if (i < ws.length - 1) helloLine.append(' ');
        });
      }
      /* still arriving: a tap shows the words whole (the card stays a moment longer, so they can be read); arrived, a tap
         lets the card go */
      function helloTap() {
        if (!helloOn) return;
        const a = helloArr;
        if (a && helloLine.querySelector('.ffs-w:not(.is-on)')) {
          a.finish();
          clearTimeout(helloT); helloT = later(helloGo, 2600);
          return;
        }
        helloGo();
      }
      /* ---- Zhaunil's one hint a sitting (6 to 12 minutes in), about something not yet found in this browser. It waits
         while he talks, a place's name shows or the hourglass's panel is open ---- */
      function hints() {
        if (hinted || studyMs < hintAt) return;
        if (helloOn || placeOn || hgOn || performance.now() - helloOff < 1500 || (tm && tm.done && !tm.told)) return;
        hinted = true;
        const open = FOUND.filter((k) => !store.found[k] && (k !== 'dark' || can('out')));
        if (!open.length) return;
        hintSaid = open[Math.floor(Math.random() * open.length)];
        say(HINTS[hintSaid]);
      }
      later(() => { if (!helloOn) say(HELLO[helloIdx]); }, reduced ? 900 : 2200);
      /* and the place's name once he has had his say */
      showPlace(reduced ? 1400 : 2700);
      o.addEventListener('pointerdown', (e) => {
        helloTap();
        /* a tap off the panel closes it (a tap on the hourglass is the hourglass's own) */
        if (hgOn && !hg.contains(e.target) && e.target !== tapB.glass) hgHide(false);
      }, { passive: true });

      /* ---- the music: a calm record already on carries on; otherwise Quiet Alehouse ---- */
      if (music && music.id === recId) showRec(recId);
      else setRec(recId, true);
      try { o.focus({ preventScroll: true }); } catch (e) { /* fine */ }
      wake();

      /* ---- the way out ---- */
      function end(now) {
        if (over) return;
        hgHide(false);
        over = true;
        flush(); paintCount();
        /* a timer ends quietly; the room's window keeps the view that was showing, and this browser keeps it too; leaves
           still drifting lie on the cushion next time */
        tm = null;
        visit.leaves = Math.min(6, visit.leaves + leavesDue); leavesDue = 0;
        viewKeep(vId);
        try { const n2 = NS(); if (n2 && n2.set) n2.set('library', 'vista', vId); } catch (e) { /* the room shows the town */ }
        roomWx();
        timers.forEach((id) => clearTimeout(id)); timers.clear();
        clearTimeout(frameT); clearTimeout(idleT); frameT = 0;
        window.removeEventListener('keydown', onKey, true);
        document.removeEventListener('visibilitychange', onVis);
        window.removeEventListener('resize', onResize);
        if (vvp && vvp.removeEventListener) vvp.removeEventListener('resize', onResize);
        window.removeEventListener('pagehide', onHide);
        document.removeEventListener('ffsound:mute', onMute);
        try { if (offTally) offTally(); } catch (e) { /* fine */ }
        try { if (ro) ro.disconnect(); } catch (e) { /* fine */ }
        ro = null;
        if (lock) { try { lock.release().catch(() => {}); } catch (e) { /* fine */ } lock = null; }
        /* the room comes back: its painter wakes; it leans back from the window as the study fades */
        rest(false);
        const gone = () => {
          try { if (scene && scene.destroy) scene.destroy(); } catch (e) { /* fine */ }
          o.remove();
          /* a new sitting already began (Back, then the chair again within half a second): the room and the visitors are its */
          if (seat !== mySeat) return;
          nsSet('cat', null); nsSet('owl', null);
          if (pan) { pan.style.transition = ''; pan.style.transform = ''; pan.style.transformOrigin = ''; }
        };
        if (now || reduced) gone();
        else {
          lean(true, 0);
          void (pan && pan.offsetWidth);
          lean(false, 800);
          o.style.transitionDelay = '';
          o.classList.add('is-out');
          setTimeout(gone, 560);
        }
        if (cur && cur.p === p) cur = null;
        try { if (back && back.isConnected && typeof back.focus === 'function') back.focus({ preventScroll: true }); } catch (e) { /* fine */ }
        res('left');
      }
      backBtn.addEventListener('click', (e) => { if (unseen(e, backBtn)) return; snd('tap'); end(false); });
      /* keys: Escape closes the hourglass's panel, else lets Zhaunil's line go, else leaves. Tab stays in the study (in the
         panel while it's open). The room's continue keys are held back while the study is open */
      const focusList = () => (hgOn ? [...hg.querySelectorAll('button')] : [backBtn, sndBtn, recBtn].concat(tabOrder.filter((b) => !b.hidden)));
      function onKey(e) {
        if (over) return;
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); if (hgOn) hgHide(true); else if (helloOn) helloGo(); else end(false); return; }
        /* in the open panel the arrows move through its five choices (Home and End to either end) */
        if (hgOn && /^(ArrowLeft|ArrowRight|ArrowUp|ArrowDown|Home|End)$/.test(e.key)) {
          const bs = [...hg.querySelectorAll('button')], i = bs.indexOf(document.activeElement), n = bs.length;
          const j = e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : i < 0 ? 0 : (i + (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? n - 1 : 1)) % n;
          e.preventDefault(); e.stopPropagation();
          try { bs[j].focus({ preventScroll: true }); } catch (err) { /* fine */ }
          kb = true; wake();
          return;
        }
        if (e.key === 'Tab') {
          const fs = focusList(), i = fs.indexOf(document.activeElement);
          e.preventDefault(); e.stopPropagation();
          if (fs.length) fs[e.shiftKey ? (i <= 0 ? fs.length - 1 : i - 1) : (i < 0 || i === fs.length - 1 ? 0 : i + 1)].focus({ preventScroll: true });
          kb = true; wake();
          return;
        }
        e.stopPropagation();
      }
      window.addEventListener('keydown', onKey, true);

      cur = {
        p, end,
        /* a finished visit is cleared from the scene's values, so a later rebuild never replays it */
        visit: (d) => {
          if (d.who === 'cat' && d.at === 'asleep') catAsleep = true;
          if (d.at === 'gone') {
            if (d.who === 'cat') { catOut = false; catAsleep = false; }
            /* a feather she left drifts down as she goes and stays on the ledge for the rest of the sitting */
            else if (owlFeather) { owlFeather = false; feather = true; setSill(); }
            nsSet(d.who, null);
          }
          if (reduced) draw();
        },
        state: () => ({
          rec: recId, weather: WX[recId], sec: Math.round(sec * 10) / 10, minutes: Math.floor(studyMs / 60000), pending, nextVisit: Math.round((nextVisit - studyMs / fast()) / 1000), catOut,
          idle: o.classList.contains('is-idle'), resting: !!(pan && pan.dataset.studyRest), wakeLock: !!lock, stepped: canStep, count: countEl.textContent, hello: helloOn ? helloIdx : null, said: helloOn ? said : '',
          vista: vId, vistaFrom: vFrom, viewPending: vPend, changing: changing(), nextView: Math.max(0, Math.round((VIEW_MS - (studyMs - vSince)) / fast() / 1000)),
          timer: tm ? { min: tm.min, left: Math.max(0, tm.end - Date.now()), done: tm.done, rung: tm.rung, told: tm.told } : null,
          left: leftEl.hidden ? '' : leftTxt.textContent, panel: hgOn, lamp: visit.lamp, candle: visit.candle,
          bells, snd: lastSnd, place: placeOn, glassLast, seat: mySeat,
          play: {
            sill: sillNow(), last: lastAct, dark, song: songDone, songSeen: Object.keys(songSeen).length, notes: notes.slice(), hint: hintSaid, hinted,
            rest: Object.keys(TP).filter((k) => performance.now() < TP[k].rest), thirst: Math.round(thirst() * 100) / 100, canBloom, bloomsNew, pixie: pixieDone,
            box: sec < boxUntil ? { t0: boxT0, until: boxUntil, winds: boxWinds, v: boxV } : null, pour: sec < pourUntil, quill: sec < quillUntil,
            cat: { pet: catPet, nap: catNap, asleep: catAsleep }, owl: { pet: owlPet, stay: owlStay, feather: owlFeather }, feather,
            can: { out: can('out'), portal: can('portal') }, labels: Object.assign({}, labels), kept: JSON.parse(JSON.stringify(store))
          },
          taps: TAPS.filter((k) => !tapB[k].hidden).map((k) => { const r = tapB[k].getBoundingClientRect(); return { k, l: r.left, t: r.top, w: r.width, h: r.height }; })
        })
      };
      return p;
    }

    function close() { if (cur) cur.end(true); }
    return { open, busy: () => !!cur, close, state: () => (cur ? cur.state() : null), heard: () => heard.slice() };
  };
  /* the view kept in this browser: library.js gives it to the room's window on load */
  FFD.parts['library/study'].view = viewKept;
  /* QA: the sill's record kept in this browser, cleaned as the study reads it */
  FFD.parts['library/study'].kept = playKept;
  /* QA: one of the study's own sounds by name (harness/library-study.test.cjs renders each one offline) */
  FFD.parts['library/study'].sounds = (n, o) => tones.play(n, o);
})();

/* ===== src/scene-pages/pages/library/waitlist.js ===== */
/* library/waitlist.js: Ember's waitlist sheet (a part of the library page). Jan (2026-10-07): Ember's easel "captures
   phone and email into Klaviyo and the PDP waitlist", and after the pitch: the sheet centered with padding, one short
   consent line with a "Full terms" toggle, centered buttons.

   The sheet, centered over the room (library-only CSS, core.css untouched): Ember's portrait and her line, First name,
   Mobile number, Email (optional), the short consent line with "Full terms" (the Quest's full wording from
   assets/ff-quest-phone-card.js, with its Terms and Privacy Policy links), then "Join the waitlist" and "Not now". The
   phone field is the product page's own: intl-tel-input limited to the 22 countries Klaviyo can text, a number turned
   into E.164, the same checks and the same error wording (sections/ff-turn-queue.liquid, assets/ff-fast-pass.js). Its
   files load the first time the sheet opens (ff-intl-tel-input.min.js and .css, about 70 KB), and its 269 KB number
   rules (ff-intl-tel-utils.js) through the store's shared window.ffqPhoneUtilsPromise, so the room loads nothing more.

   The join is the product page's and the fast pass's own door: POST { first_name, phone, email? } to
   FFD_SITE.waitlist.api + '/queue/join' (the quest-ai Worker, printed by sections/ff-scene-site.liquid), which makes the
   same queue row, Klaviyo profile, SMS consent (list UVuMqw) and welcome texts. It gives up after 30 s and counts only
   with a real spot (you.token a UUID). The spot is merged into ffq_live_v1 and ffq_prior_v1 exactly as the fast pass
   does, so the product page then shows "Your Spot #N". A browser that already holds a spot hears it's in line instead of
   seeing the form. An email saved with another number offers "Use just my number", which joins with the number alone
   (the queue gives an existing spot back, so the resend is safe). On a join: one Meta Lead (content_name 'Library
   Waitlist') with an event id, its CAPI twin with the same id through the Worker's /capi relay (no contact details,
   only the browser's user agent and the _fbp/_fbc cookies) and a dataLayer push { event: 'ff_library',
   ff_library_step: 'waitlist_joined' }. All three only on the store (FFD.live === true) and never for the debug name
   "jangela". Without FFD_SITE.waitlist (the review demo) nothing is sent, and Ember says so.

   What stays in this browser: the store's own waitlist record (ffq_live_v1: the spot's token, the first name and the
   number, as the product page and the fast pass keep it) and nothing else. Nothing typed goes into the library's own
   storage, a URL or a log, and the sheet's inputs are removed when it closes.

   FFD.parts['library/waitlist'](api) -> { open() -> Promise<'joined' | 'closed'>, busy(), close() }
   The room gives: F, RM(), snd(name), SITE (FFD_SITE), live, talk(lines, who) (the room's own talk), hold(on) (the room
   holds still while the sheet is open, so a stray tap can't throw away what was typed), and optionally who (Ember's
   speaker in the box, { name, img }; Jan with Ember's portrait by default, as the room's JAN). */
(() => {
  'use strict';
  const FFD = window.FFD = window.FFD || {};
  const CSS_ID = 'ffd-css-library-waitlist';
  const LIVE_KEY = 'ffq_live_v1', PRIOR_KEY = 'ffq_prior_v1';
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  /* Klaviyo can text only these countries, so the picker offers only these (the product page's own list and order) */
  const SMS_COUNTRIES = ['us', 'ca', 'gb', 'au', 'nz', 'at', 'be', 'dk', 'fi', 'fr', 'de', 'hu', 'ie', 'it', 'lu', 'nl', 'no', 'pl', 'pt', 'es', 'se', 'ch'];
  const SMS_MAP = {}; SMS_COUNTRIES.forEach((c) => { SMS_MAP[c] = true; });
  const JOIN_MS = 30000;

  /* every word a reader sees. The consent lines are Jan's (README fixes) and the Quest's own (ff-quest-phone-card.js),
     the errors are the product page's and the fast pass's */
  const L = {
    who: 'Ember',
    line: 'Leave me a name and a number. Jan texts you when your turn opens.',
    label: 'Join the waitlist',
    first: 'First name', phone: 'Mobile number', email: 'Email', optional: '(optional)',
    sms: 'By joining, you agree to get texts from FramedFantasy, including one when your turn opens. Msg & data rates may apply. Reply STOP to opt out.',
    more: 'Full terms', less: 'Hide terms',
    full: 'By entering your number, you agree to receive recurring automated marketing texts from FramedFantasy at this number, including a text when your portrait turn opens. Consent is not a condition of purchase. Msg frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help. See our <a href="/policies/terms-of-service" target="_blank" rel="noopener">Terms</a> and <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.',
    join: 'Join the waitlist', joining: 'Saving your spot…', checking: 'Checking…', not: 'Not now', just: 'Use just my number',
    still: 'Still saving. Keep this open a moment longer.',
    noName: 'Add your first name.',
    noPhone: 'Add your mobile number.',
    badEmail: 'Check your email address, or leave it blank.',
    country: 'Choose a country that can receive texts.',
    code: 'Choose the correct country code.',
    short: 'That number is too short for {c}.', long: 'That number is too long for {c}.',
    invalid: 'That doesn’t look like a valid mobile number.',
    incomplete: 'That phone number doesn’t look complete.',
    noTexts: 'Texts aren’t supported for that country yet.',
    withCode: 'Add your mobile number with its country code.',
    phoneBad: 'That phone number doesn’t look right.',
    clash: 'That email is already saved with a different number. I can save your spot with just your number, or you can use another email.',
    provider: 'I couldn’t save your email just now. Try again in a moment.',
    offline: 'You look offline. Your details are still here, so try again when you’re back.',
    failed: 'That didn’t go through. Try again, or email Jan@framedfantasy.com and I’ll help you join.',
    joined: 'You’re in line, {first}. I’ll text you when it’s your turn.',
    joinedNo: 'You’re in line. I’ll text you when it’s your turn.',
    open: 'Your turn is already open, {first}. Check your texts for your private link.',
    already: 'You’re already in line, {first}. I’ll text you when it’s your turn.',
    alreadyNo: 'You’re already in line. I’ll text you when it’s your turn.',
    demo: '(Demo. Nothing was sent.)'
  };

  /* ---------- the look: a centered card over the room, scoped to the library ---------- */
  /* core.css's sheet rules sit in the section's stylesheet, after this style in the document, so every rule here carries
     .ffd.ffd-page--library to outrank them */
  const CSS = `
/* an empty div: Dawn's div:empty { display: none } would hide it on the store, so it says its display */
.ffd.ffd-page--library .lb-wl-scrim { display: block; position: absolute; inset: 0; z-index: 8; background: rgba(6, 4, 2, .58); opacity: 0; transition: opacity .26s ease; }
.ffd.ffd-page--library .lb-wl-scrim.is-in { opacity: 1; }
/* the card: a gilt hairline along its top and a little candlelight behind Ember's face, on the room's dark wood */
.ffd.ffd-page--library .ffs-sheet.lb-wl { top: 50%; bottom: auto; left: 50%; right: auto; z-index: 9; width: min(440px, calc(100% - 32px)); max-height: calc(100% - 32px);
  padding: 22px 20px 20px; border-radius: 16px; border: 1px solid rgba(231, 201, 127, .3);
  background: linear-gradient(90deg, rgba(231, 201, 127, 0), rgba(231, 201, 127, .6), rgba(231, 201, 127, 0)) 50% 0 / 62% 1px no-repeat, radial-gradient(70% 34% at 50% 0, rgba(232, 168, 90, .13), rgba(232, 168, 90, 0) 75%), linear-gradient(180deg, #1f170e, #120d08 72%);
  box-shadow: 0 26px 70px rgba(0, 0, 0, .66), 0 0 0 1px rgba(231, 201, 127, .06) inset; text-align: center;
  transform: translate(-50%, calc(-50% + 16px)); opacity: 0; transition: transform .3s cubic-bezier(.2, .8, .2, 1), opacity .24s ease; }
.ffd.ffd-page--library .ffs-sheet.lb-wl.is-in { transform: translate(-50%, -50%); opacity: 1; }
.ffd.ffd-page--library .ffs-sheet.lb-wl.is-out { transform: translate(-50%, calc(-50% + 16px)); opacity: 0; transition-duration: .22s; }
/* the phone's keyboard is up: the card sits at the top of what's left of the screen and scrolls inside */
.ffd.ffd-page--library .ffs-sheet.lb-wl.is-kb, .ffd.ffd-page--library .ffs-sheet.lb-wl.is-kb.is-in { top: var(--lbwl-top, 8px); max-height: var(--lbwl-h, calc(100% - 16px)); transform: translate(-50%, 0); transition: opacity .24s ease; }
.ffd.ffd-page--library .lb-wl-h { display: grid; justify-items: center; gap: 6px; margin: 0 0 16px; }
.ffd.ffd-page--library .lb-wl-h img { display: block; width: 58px; height: 58px; border-radius: 50%; object-fit: cover; object-position: 50% 24%; border: 1px solid rgba(231, 201, 127, .55); box-shadow: 0 0 0 3px rgba(231, 201, 127, .08); }
.ffd.ffd-page--library .lb-wl-h b { display: block; font: 600 14px/1.2 var(--f-display); letter-spacing: .08em; color: var(--gold-hi); }
.ffd.ffd-page--library .lb-wl-h p { margin: 0; font: italic 500 18px/1.35 var(--f-aside); color: var(--fg); max-width: 22em; text-wrap: balance; }
.ffd.ffd-page--library .lb-wl-form { display: grid; gap: 12px; margin: 0; text-align: left; }
.ffd.ffd-page--library .lb-wl-f { display: grid; gap: 6px; min-width: 0; }
.ffd.ffd-page--library .lb-wl-f label { font: 600 13.5px/1.2 var(--f-body); letter-spacing: .01em; color: var(--fg-2); white-space: nowrap; }
.ffd.ffd-page--library .lb-wl-f label small { font: inherit; font-weight: 400; color: var(--fg-3); }
.ffd.ffd-page--library .lb-wl-f input { width: 100%; min-height: 48px; margin: 0; padding: 10px 12px; border-radius: 10px; border: 1px solid rgba(231, 201, 127, .3);
  background: #0e0a06; color: var(--fg); font: 500 16px/1.2 var(--f-body); box-shadow: none; -webkit-appearance: none; appearance: none; }
.ffd.ffd-page--library .lb-wl-f input:focus { outline: none; border-color: var(--gold); box-shadow: 0 0 0 3px rgba(200, 164, 94, .2); }
.ffd.ffd-page--library .lb-wl-f input[aria-invalid="true"] { border-color: #e0806e; box-shadow: 0 0 0 3px rgba(224, 128, 110, .16); }
.ffd.ffd-page--library .lb-wl-f input::placeholder { color: rgba(201, 190, 168, .42); }
.ffd.ffd-page--library .lb-wl-f .iti { display: block; width: 100%; }
/* Dawn hides every empty div on the store, and intl-tel-input draws its flag and arrow on empty divs */
.ffd.ffd-page--library .lb-wl-f .iti__flag, .ffd.ffd-page--library .lb-wl-f .iti__arrow { display: block; flex: none; }
.ffd.ffd-page--library .lb-wl-f .iti__selected-country { border-radius: 10px 0 0 10px; }
.ffd.ffd-page--library .lb-wl-f .iti__selected-country:hover, .ffd.ffd-page--library .lb-wl-f .iti__selected-country[aria-expanded="true"] { background: rgba(231, 201, 127, .1); }
.ffd.ffd-page--library .lb-wl-f .iti__selected-dial-code { margin-left: 8px; color: rgba(236, 230, 218, .74); font-size: 15px; font-variant-numeric: tabular-nums; }
.ffd.ffd-page--library .lb-wl-sms { margin: 4px auto 0; max-width: 30em; font: 13px/1.5 var(--f-body); color: #b9ad97; text-align: center; text-wrap: pretty; }
.ffd.ffd-page--library .lb-wl-more { position: relative; display: inline; margin: 0; padding: 0; border: 0; background: none; color: var(--gold-hi); font: inherit; font-weight: 600;
  text-decoration: underline; text-underline-offset: 3px; text-decoration-color: rgba(231, 201, 127, .5); cursor: pointer; white-space: nowrap; }
/* the toggle reads as a word in the line, but takes a 44 px tap */
.ffd.ffd-page--library .lb-wl-more::after { content: ''; position: absolute; left: -10px; right: -10px; top: 50%; height: 44px; transform: translateY(-50%); }
.ffd.ffd-page--library .lb-wl-full { margin: 0 auto; max-width: 32em; font: 12.5px/1.55 var(--f-body); color: #a99d87; text-align: center; text-wrap: pretty; }
.ffd.ffd-page--library .lb-wl-full a { color: var(--gold-hi); }
.ffd.ffd-page--library .lb-wl-msg { margin: 0; font: 14.5px/1.4 var(--f-body); text-align: center; color: var(--fg-2); }
.ffd.ffd-page--library .lb-wl-msg:empty { display: none; }
.ffd.ffd-page--library .lb-wl-msg.is-bad { color: #ffa493; }
/* the buttons span the fields' width, and stay pinned to the card's foot whenever the card has to scroll (a phone on its
   side, the full terms open, an error line), so "Not now" can always be reached */
.ffd.ffd-page--library .lb-wl-btns { position: sticky; bottom: -20px; z-index: 1; display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; margin: 4px -20px -20px; padding: 10px 20px 20px;
  background: linear-gradient(180deg, rgba(18, 13, 8, 0), #120d08 12px); }
.ffd.ffd-page--library .lb-wl-btns .ffd-btn { flex: 1 1 auto; min-height: 48px; padding-inline: 22px; border-color: rgba(231, 201, 127, .28); background: transparent; color: var(--fg-2); }
/* the pitch's main button: a gold-lit edge on a warm tint (core keeps sheet buttons quiet, this one leads) */
.ffd.ffd-page--library .lb-wl-btns .ffd-btn--solid { border-color: var(--gold-hi); background: linear-gradient(180deg, rgba(231, 201, 127, .24), rgba(231, 201, 127, .1)); color: #fff6dc; }
.ffd.ffd-page--library .lb-wl-btns .ffd-btn:hover { border-color: var(--gold); color: #fff1cc; background: rgba(200, 164, 94, .12); }
.ffd.ffd-page--library .lb-wl-btns .ffd-btn[hidden] { display: none; }
.ffd.ffd-page--library .lb-wl-form[aria-busy="true"] .ffd-btn--solid { opacity: .78; }
@media (max-height: 640px) {
  .ffd.ffd-page--library .ffs-sheet.lb-wl { padding: 16px 16px 16px; }
  .ffd.ffd-page--library .lb-wl-h { grid-template-columns: auto 1fr; justify-items: start; align-items: center; column-gap: 12px; margin-bottom: 12px; text-align: left; }
  .ffd.ffd-page--library .lb-wl-h img { width: 48px; height: 48px; grid-row: span 2; }
  .ffd.ffd-page--library .lb-wl-h p { font-size: 16.5px; }
  .ffd.ffd-page--library .lb-wl-form { gap: 8px; }
  .ffd.ffd-page--library .lb-wl-f { gap: 4px; }
  .ffd.ffd-page--library .lb-wl-f input { min-height: 44px; padding-block: 8px; }
  .ffd.ffd-page--library .lb-wl-sms { font-size: 12.5px; line-height: 1.45; }
  .ffd.ffd-page--library .lb-wl-btns { bottom: -16px; margin: 2px -16px -16px; padding: 10px 16px 16px; }
  .ffd.ffd-page--library .lb-wl-btns .ffd-btn { min-height: 46px; }
}
/* a phone on its side: a wider card, each label beside its field and Ember's line beside her face, so the whole form and
   its buttons fit without scrolling (at 844 by 390 and up; anything shorter scrolls with the buttons pinned) */
@media (max-height: 500px) {
  .ffd.ffd-page--library .ffs-sheet.lb-wl { width: min(620px, calc(100% - 32px)); max-height: calc(100% - 16px); padding: 12px 18px 14px; }
  .ffd.ffd-page--library .lb-wl-h { margin-bottom: 8px; }
  .ffd.ffd-page--library .lb-wl-h img { width: 42px; height: 42px; }
  .ffd.ffd-page--library .lb-wl-h p { max-width: none; font-size: 16px; }
  .ffd.ffd-page--library .lb-wl-f { grid-template-columns: 118px minmax(0, 1fr); align-items: center; column-gap: 12px; }
  .ffd.ffd-page--library .lb-wl-f label { text-align: right; }
  .ffd.ffd-page--library .lb-wl-sms { max-width: none; margin-top: 2px; }
  .ffd.ffd-page--library .lb-wl-btns { bottom: -14px; margin: 0 -18px -14px; padding: 8px 18px 14px; }
}
@media (prefers-reduced-motion: reduce) {
  .ffd.ffd-page--library .ffs-sheet.lb-wl, .ffd.ffd-page--library .ffs-sheet.lb-wl.is-in, .ffd.ffd-page--library .ffs-sheet.lb-wl.is-out { transition: none; transform: translate(-50%, -50%); }
  .ffd.ffd-page--library .ffs-sheet.lb-wl.is-kb { transform: translate(-50%, 0); }
  .ffd.ffd-page--library .lb-wl-scrim { transition: none; }
}
/* the country list hangs off document.body, outside the frame: over the room and the card, in the room's colours. Each
   rule starts at .iti so it outranks intl-tel-input's own sheet (loaded later) and Dawn's div:empty (its flags are empty
   divs) */
.iti.iti--detached-country-selector { z-index: 10030; }
.iti.iti--fullscreen-popup.iti--detached-country-selector { background: rgba(6, 4, 2, .82); }
.iti .iti__country-selector { color: rgba(236, 230, 218, .9); border-color: rgba(231, 201, 127, .28) !important; border-radius: 10px; box-shadow: 0 18px 48px rgba(0, 0, 0, .6) !important; }
.iti .iti__search-input { background: #0e0a06; color: #ece6da; border: 0; outline: 0; font: 15px/1.35 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
.iti .iti__search-input::placeholder { color: rgba(236, 230, 218, .4); }
.iti .iti__country { font: 14px/1.35 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
.iti .iti__country.iti__highlight { background: rgba(231, 201, 127, .12); }
.iti .iti__dial-code { color: rgba(231, 201, 127, .72); }
.iti .iti__flag, .iti .iti__arrow { display: block; flex: none; }`;
  /* the flag sprite and the dark field colours; :root:root outranks the library's own :root, whichever loads last */
  function itiVars(I) {
    const u = (s) => String(s || '').replace(/["\\\n\r()]/g, '');
    return ':root:root{' + (I && I.flags ? '--iti-path-flags-1x:url("' + u(I.flags) + '");' : '') + (I && I.flags2x ? '--iti-path-flags-2x:url("' + u(I.flags2x) + '");' : '') +
      '--iti-hover-color:rgba(231,201,127,.12);--iti-border-color:rgba(231,201,127,.3);--iti-country-selector-bg:#17110a;--iti-icon-color:rgba(236,230,218,.6);--iti-strict-reject-flash-color:rgba(255,138,128,.16)}';
  }

  /* ---------- small helpers ---------- */
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  /* a typed name inside a line: escaped for the box's HTML, and never a {token} the frame would fill */
  const nameIn = (s) => esc(String(s || '').replace(/[{}]/g, '').trim());
  function readJSON(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function writeJSON(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage blocked: the spot is still saved on the server */ } }
  function cookie(n) { try { const m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]+)')); return m ? m[2] : null; } catch (e) { return null; } }
  function el(tag, a, ...kids) {
    const e = document.createElement(tag);
    if (a) Object.keys(a).forEach((k) => {
      const v = a[k]; if (v == null || v === false) return;
      if (k === 'class') e.className = v; else if (k === 'text') e.textContent = v; else if (k === 'html') e.innerHTML = v;
      else e.setAttribute(k, v === true ? '' : v);
    });
    kids.forEach((c) => { if (c != null && c !== false) e.append(c.nodeType ? c : document.createTextNode(String(c))); });
    return e;
  }

  /* ---------- the phone field: loaded once, the first time the sheet opens ---------- */
  let itiP = null;
  function loadIti(I) {
    if (window.intlTelInput) return Promise.resolve(true);
    if (itiP) return itiP;
    if (!I || !I.js) return Promise.resolve(false);
    itiP = new Promise((res) => {
      if (I.css && !document.querySelector('link[data-lb-iti]')) {
        const ln = el('link', { rel: 'stylesheet', href: I.css, 'data-lb-iti': '' });
        document.head.append(ln);
      }
      const s = el('script', { src: I.js });
      s.async = true;
      s.onload = () => res(!!window.intlTelInput);
      s.onerror = () => { itiP = null; s.remove(); res(false); };
      document.head.append(s);
    });
    return itiP;
  }
  /* the number rules, shared with the product page's own field (window.ffqPhoneUtilsPromise) */
  function utilsP(I) {
    if (window.intlTelInput && window.intlTelInput.utils) return Promise.resolve(true);
    if (window.ffqPhoneUtilsPromise) return window.ffqPhoneUtilsPromise;
    if (window.intlTelInput && window.intlTelInput.attachUtils && I && I.utils) {
      try { window.ffqPhoneUtilsPromise = window.intlTelInput.attachUtils(() => import(I.utils)); } catch (e) { return null; }
      try { window.ffqPhoneUtilsPromise.catch(() => {}); } catch (e) { /* fine */ }
      return window.ffqPhoneUtilsPromise;
    }
    return null;
  }
  function initPhone(input, country) {
    if (!input || input._lbIti || !window.intlTelInput) return input && input._lbIti;
    try {
      input._lbIti = window.intlTelInput(input, {
        initialCountry: country, onlyCountries: SMS_COUNTRIES, countryOrder: ['us', 'ca', 'gb', 'au', 'nz'], countrySelectorMode: 'AUTO',
        dropdownParent: document.body, separateDialCode: true, showFlags: true, formatAsYouType: true, strictMode: true,
        strictRejectAnimation: true, placeholderNumberPolicy: 'AGGRESSIVE', placeholderNumberType: 'MOBILE',
        allowedNumberTypes: ['MOBILE', 'FIXED_LINE_OR_MOBILE', 'VOIP']
      });
    } catch (e) { input._lbIti = null; }
    return input._lbIti;
  }
  /* before the field's files arrive: a full +number, or ten US/Canada digits */
  function fallbackPhone(input) {
    const raw = String((input && input.value) || '').trim().replace(/[\s().-]/g, '');
    if (/^\+[1-9]\d{6,14}$/.test(raw)) return { number: raw };
    let d = raw.replace(/\D/g, '');
    const c = input && input._lbIti ? input._lbIti.getSelectedCountry() : { iso2: 'us' };
    if (!c || c.iso2 === 'us' || c.iso2 === 'ca') {
      if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
      if (d.length === 10) return { number: '+1' + d };
    }
    return { error: L.withCode };
  }
  /* countries that share a dial code (Puerto Rico shares +1): the area code says which one it really is */
  function actualCountryIso(number, selected) {
    if (!number || !selected || !window.intlTelInput || !window.intlTelInput.getAllCountries) return selected && selected.iso2;
    const all = window.intlTelInput.getAllCountries(), digits = String(number).replace(/\D/g, ''), dial = String(selected.dialCode || '');
    const national = digits.indexOf(dial) === 0 ? digits.slice(dial.length) : digits;
    let found = null, len = 0;
    for (let i = 0; i < all.length; i++) {
      const c = all[i]; if (String(c.dialCode) !== dial || !c.areaCodes) continue;
      for (let j = 0; j < c.areaCodes.length; j++) { const pre = String(c.areaCodes[j]); if (pre.length > len && national.indexOf(pre) === 0) { found = c.iso2; len = pre.length; } }
    }
    return found || selected.iso2;
  }
  function readPhone(input, country) {
    if (!String((input && input.value) || '').trim()) return { error: L.noPhone };
    const iti = initPhone(input, country);
    if (!iti || !window.intlTelInput || !window.intlTelInput.utils) return fallbackPhone(input);
    const sel = iti.getSelectedCountry();
    if (!sel || !SMS_MAP[sel.iso2]) return { error: L.country };
    if (!iti.isValidNumber()) {
      const code = iti.getValidationError(), V = window.intlTelInput.VALIDATION_ERROR || {};
      if (code === V.INVALID_COUNTRY_CODE) return { error: L.code };
      if (code === V.TOO_SHORT) return { error: L.short.replace('{c}', sel.name) };
      if (code === V.TOO_LONG) return { error: L.long.replace('{c}', sel.name) };
      return { error: L.invalid };
    }
    const number = iti.getNumber();
    if (!/^\+[1-9][0-9]{6,14}$/.test(number)) return { error: L.incomplete };
    if (!SMS_MAP[actualCountryIso(number, sel)]) return { error: L.noTexts };
    return { number };
  }

  /* ---------- the door: the product page's /queue/join ---------- */
  function workerJoin(base, body) {
    const ctl = window.AbortController ? new AbortController() : null;
    const t = setTimeout(() => { try { if (ctl) ctl.abort(); } catch (e) { /* fine */ } }, JOIN_MS);
    return fetch(base + '/queue/join', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: ctl ? ctl.signal : undefined
    }).then((r) => r.json().catch(() => ({ error: 'bad reply' })).then((j) => { clearTimeout(t); return { status: r.status, j }; }),
      (e) => { clearTimeout(t); throw e; });
  }
  /* the spot, kept as the fast pass keeps it (assets/ff-fast-pass.js joinInBackground), so the product page knows it */
  function keepSpot(j, first, phone) {
    const live = readJSON(LIVE_KEY) || {};
    live.token = j.you.token; live.name = first; live.phone = phone;
    if (!j.total || (j.you.position || 0) >= j.total - 2) live.joinedAt = Date.now();
    writeJSON(LIVE_KEY, live);
    try { localStorage.setItem(PRIOR_KEY, localStorage.getItem(PRIOR_KEY) ? 'again' : 'first'); } catch (e) { /* fine */ }
  }
  /* one Lead, browser and server halves sharing an id (the Quest's pattern, assets/quest-one-v2-live.js), plus GTM */
  function lead(base, first) {
    if (FFD.live !== true) return;
    if (String(first || '').trim().toLowerCase() === 'jangela') return;
    const id = 'Lead_' + Date.now() + '_' + Math.random().toString(36).substring(2, 11);
    const params = { content_name: 'Library Waitlist', content_category: 'DnD Character Art' };
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', params, { eventID: id }); } catch (e) { /* the pixel is optional */ }
    try {
      const ud = { client_user_agent: navigator.userAgent }, fbp = cookie('_fbp'), fbc = cookie('_fbc');
      if (fbp) ud.fbp = fbp; if (fbc) ud.fbc = fbc;
      fetch(base + '/capi', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: [{ event_name: 'Lead', event_time: Math.floor(Date.now() / 1000), action_source: 'website', event_source_url: location.href, event_id: id, user_data: ud, custom_data: params }] })
      }).catch(() => { /* Meta's half can fail quietly */ });
    } catch (e) { /* fine */ }
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'ff_library', ff_library_step: 'waitlist_joined' }); } catch (e) { /* fine */ }
  }
  /* the server's reply, in the product page's words */
  function replyError(res) {
    const j = (res && res.j) || {};
    if (j.error === 'phone invalid') return { text: L.phoneBad, field: 'phone' };
    if (j.error === 'first_name required') return { text: L.noName, field: 'first' };
    if (j.error === 'email_invalid') return { text: L.badEmail, field: 'email' };
    if (j.error === 'identity_conflict') return { text: L.clash, field: 'email', clash: true };
    if (j.error === 'provider_unavailable') return { text: L.provider };
    return { text: L.failed };
  }

  (FFD.parts = FFD.parts || {})['library/waitlist'] = function makeWaitlist(api) {
    api = api || {};
    const F = api.F, RM = api.RM || (() => false);
    const snd = (n) => { try { if (api.snd) api.snd(n); } catch (e) { /* fine */ } };
    const SITE = api.SITE || window.FFD_SITE || null, W = (SITE && SITE.waitlist) || null;
    const base = W && W.api ? String(W.api).trim().replace(/\/+$/, '') : '';
    const country = (() => { const c = String((W && W.country) || 'us').toLowerCase(); return SMS_MAP[c] ? c : 'us'; })();
    const who = api.who || { name: 'Jan', img: (SITE && SITE.portraits && SITE.portraits.ember) || null };
    const say = async (lines) => { try { if (api.talk) await api.talk(lines, who); } catch (e) { /* the room moved on */ } };
    let running = false, shut = null, closed = false, n = 0;

    function css() {
      if (!document.getElementById(CSS_ID)) document.head.append(el('style', { id: CSS_ID, text: CSS + itiVars(W && W.iti) }));
    }
    /* a spot this browser already holds: the product page's own record (a left spot is cleared there; a bought or
       timed-out one may join again) */
    function heldSpot() {
      const live = readJSON(LIVE_KEY);
      if (!live || !UUID.test(String(live.token || ''))) return null;
      if (live.lastState === 'converted' || live.lastState === 'inactive') return null;
      return live;
    }

    function sheet() {
      css();
      const k = ++n, id = (s) => 'lbwl-' + k + '-' + s;
      const scrim = el('div', { class: 'lb-wl-scrim', 'aria-hidden': 'true' });
      F.el.append(scrim);
      requestAnimationFrame(() => scrim.classList.add('is-in'));
      let parts = null, sh = null, inerted = [], offs = [], isOpen = true, sending = false;
      const done = F.sheet((body, close) => {
        sh = body.parentNode;
        sh.setAttribute('aria-modal', 'true'); sh.setAttribute('aria-label', L.label);
        sh.setAttribute('aria-describedby', id('line') + ' ' + id('sms'));
        const img = who && who.img ? el('img', { src: who.img, alt: '', width: '58', height: '58', decoding: 'async' }) : null;
        const head = el('div', { class: 'lb-wl-h' }, img, el('div', null, el('b', { text: L.who }), el('p', { id: id('line'), text: L.line })));
        const field = (key, label, attrs, opt) => {
          const input = el('input', Object.assign({ id: id(key), name: key }, attrs));
          const lab = el('label', { for: id(key) }, label, opt ? ' ' : null, opt ? el('small', { text: opt }) : null);
          return { box: el('div', { class: 'lb-wl-f' + (key === 'phone' ? ' lb-wl-f--ph' : '') }, lab, input), input };
        };
        const fFirst = field('first', L.first, { type: 'text', autocomplete: 'given-name', autocapitalize: 'words', maxlength: '60', enterkeyhint: 'next', spellcheck: 'false' });
        const fPhone = field('phone', L.phone, { type: 'tel', autocomplete: 'tel', inputmode: 'tel', enterkeyhint: 'next' });
        const fEmail = field('email', L.email, { type: 'email', autocomplete: 'email', inputmode: 'email', maxlength: '254', enterkeyhint: 'go', spellcheck: 'false', autocapitalize: 'off' }, L.optional);
        const more = el('button', { type: 'button', class: 'lb-wl-more', 'aria-expanded': 'false', 'aria-controls': id('full'), text: L.more });
        const sms = el('p', { class: 'lb-wl-sms', id: id('sms') }, L.sms + ' ', more);
        const full = el('p', { class: 'lb-wl-full', id: id('full'), html: L.full, hidden: true });
        const msg = el('p', { class: 'lb-wl-msg', id: id('msg'), role: 'status', 'aria-live': 'polite' });
        const go = el('button', { type: 'submit', class: 'ffd-btn ffd-btn--solid', text: L.join });
        const just = el('button', { type: 'button', class: 'ffd-btn', text: L.just, hidden: true });
        const no = el('button', { type: 'button', class: 'ffd-btn', text: L.not });
        const form = el('form', { class: 'lb-wl-form', novalidate: true, 'aria-labelledby': id('line') },
          fFirst.box, fPhone.box, fEmail.box, sms, full, msg, el('div', { class: 'lb-wl-btns' }, just, go, no));
        body.append(head, form);
        parts = { fFirst, fPhone, fEmail, msg, go, just, no, form };

        /* the sheet closes once: "Not now", Escape, a join, or the room closing it (F.cancel resolves `done` below) */
        const finish = (v) => { if (!isOpen) return; isOpen = false; close(v); };
        shut = () => finish(null);
        const show = (text, bad, field) => {
          msg.textContent = text || '';
          msg.className = 'lb-wl-msg' + (bad ? ' is-bad' : '');
          msg.setAttribute('role', bad ? 'alert' : 'status');
          [fFirst, fPhone, fEmail].forEach((f) => { f.input.removeAttribute('aria-invalid'); f.input.removeAttribute('aria-describedby'); });
          const f = field === 'first' ? fFirst : field === 'phone' ? fPhone : field === 'email' ? fEmail : null;
          if (f && bad) { f.input.setAttribute('aria-invalid', 'true'); f.input.setAttribute('aria-describedby', id('msg')); }
          /* on a short screen the card scrolls: the words and the buttons under them come into view */
          if (text) requestAnimationFrame(() => reveal(msg.nextElementSibling || msg));
          return f;
        };
        /* an email saved with another number: "Use just my number" leads until the email is changed */
        const clash = (on) => {
          just.hidden = !on;
          just.classList.toggle('ffd-btn--solid', on); go.classList.toggle('ffd-btn--solid', !on);
        };
        [fFirst, fPhone, fEmail].forEach((f) => f.input.addEventListener('input', () => {
          if (f.input.getAttribute('aria-invalid') === 'true') show('');
          if (f === fEmail) clash(false);
        }));
        /* Enter moves down the form; only the last field (or the button) sends it */
        [[fFirst, fPhone], [fPhone, fEmail]].forEach(([a, b]) => a.input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' && !e.isComposing) { e.preventDefault(); b.input.focus({ preventScroll: true }); reveal(b.input); }
        }));
        more.addEventListener('click', () => {
          full.hidden = !full.hidden;
          more.setAttribute('aria-expanded', full.hidden ? 'false' : 'true');
          more.textContent = full.hidden ? L.more : L.less;
          snd('tap');
          if (!full.hidden) reveal(full);
        });
        no.addEventListener('click', () => { snd('tap'); finish(null); });

        /* the phone field's files, now (a reader who types before they land keeps what they typed) */
        loadIti(W && W.iti).then((ok) => {
          if (!ok || !fPhone.input.isConnected) return;
          initPhone(fPhone.input, country);
          utilsP(W && W.iti);
        });

        /* one send at a time, from the first check to the reply; the buttons say what's happening */
        let stillT = null;
        const state = (s) => {
          go.disabled = !!s; just.disabled = !!s;
          go.textContent = s === 'check' ? L.checking : s === 'send' ? L.joining : L.join;
          if (s) form.setAttribute('aria-busy', 'true'); else form.removeAttribute('aria-busy');
          clearTimeout(stillT);
          if (s === 'send') stillT = setTimeout(() => { if (sending && isOpen) show(L.still); }, 8000);
        };
        async function send(withEmail) {
          if (sending || !isOpen) return;
          const first = fFirst.input.value.trim().replace(/\s+/g, ' ').slice(0, 60);
          if (!first) { show(L.noName, true, 'first'); fFirst.input.focus({ preventScroll: true }); return; }
          const email = withEmail ? String(fEmail.input.value || '').trim().toLowerCase() : '';
          if (email && (email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) { show(L.badEmail, true, 'email'); fEmail.input.focus({ preventScroll: true }); return; }
          show('');
          sending = true;
          try {
            /* the number: wait a moment for the field's rules, as the product page does */
            state('check');
            await Promise.race([loadIti(W && W.iti), wait(4000)]);
            initPhone(fPhone.input, country);
            const up = utilsP(W && W.iti);
            if (up && window.intlTelInput && !window.intlTelInput.utils) await Promise.race([up.catch(() => {}), wait(5000)]);
            if (!isOpen) return;
            const phone = readPhone(fPhone.input, country);
            if (phone.error) { state(null); show(phone.error, true, 'phone'); fPhone.input.focus({ preventScroll: true }); return; }

            /* the review demo: nothing leaves the page */
            if (!base) {
              state('send'); await wait(RM() ? 0 : 600);
              finish({ first, demo: true });
              return;
            }
            if (navigator.onLine === false) { state(null); show(L.offline, true); return; }
            state('send');
            const req = { first_name: first, phone: phone.number };
            if (email) req.email = email;
            let res = null;
            try { res = await workerJoin(base, req); } catch (e) { res = null; }
            const ok = !!(res && res.j && res.j.you && UUID.test(String(res.j.you.token || '')));
            if (ok) {
              /* the spot is real now, whatever happens to the sheet */
              keepSpot(res.j, first, phone.number);
              if (api.live !== false) lead(base, first);
            }
            if (!isOpen) return;
            state(null);
            if (ok) { finish({ first, state: res.j.you.state }); return; }
            if (!res && navigator.onLine === false) { show(L.offline, true); return; }
            const er = replyError(res), f = show(er.text, true, er.field);
            clash(!!er.clash);
            if (er.clash) just.focus({ preventScroll: true }); else if (f) f.input.focus({ preventScroll: true });
          } finally { sending = false; }
        }
        form.addEventListener('submit', (e) => { e.preventDefault(); snd('tap'); send(true); });
        just.addEventListener('click', () => { snd('tap'); send(false); });
      }, { cls: 'lb-wl' });

      /* modal while it's open: everything else in the frame steps back (no taps, no Tab stops), Escape is "Not now" */
      [...F.el.children].forEach((c) => { if (c !== sh && c !== scrim && !c.inert) { c.inert = true; inerted.push(c); } });
      const onKey = (e) => {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        if (!sh || !sh.isConnected) return;
        /* Escape closes an open country list first */
        if (sh.querySelector('.iti__selected-country[aria-expanded="true"]') || document.querySelector('.iti--detached-country-selector:not(.iti__hide) .iti__dropdown-content:not(.iti__hide)')) return;
        e.preventDefault(); if (shut) shut();
      };
      document.addEventListener('keydown', onKey, true);
      offs.push(() => document.removeEventListener('keydown', onKey, true));
      /* the phone's keyboard: keep the field being typed in on screen */
      const vv = window.visualViewport;
      const fitKb = () => {
        if (!sh || !sh.isConnected || !vv) return;
        const kb = window.innerHeight - vv.height > 120;
        sh.classList.toggle('is-kb', kb);
        if (kb) {
          const r = F.el.getBoundingClientRect();
          sh.style.setProperty('--lbwl-top', Math.max(8, vv.offsetTop - r.top + 8) + 'px');
          sh.style.setProperty('--lbwl-h', Math.max(200, vv.height - 16) + 'px');
        }
      };
      if (vv) { vv.addEventListener('resize', fitKb); vv.addEventListener('scroll', fitKb); offs.push(() => { vv.removeEventListener('resize', fitKb); vv.removeEventListener('scroll', fitKb); }); }
      const onFocus = (e) => { const t = e.target; if (t && t.tagName === 'INPUT') setTimeout(() => { fitKb(); reveal(t); }, 320); };
      sh.addEventListener('focusin', onFocus);
      function reveal(t) {
        /* scroll the card itself, never the frame round it (the room would slide out of line) */
        if (!sh || !sh.isConnected || !t || !t.isConnected) return;
        const a = sh.getBoundingClientRect(), b = t.getBoundingClientRect();
        if (b.bottom > a.bottom - 12) sh.scrollTop += b.bottom - a.bottom + 12;
        else if (b.top < a.top + 12) sh.scrollTop -= a.top + 12 - b.top;
      }
      return done.then((v) => {
        isOpen = false; shut = null;
        offs.splice(0).forEach((f) => { try { f(); } catch (e) { /* fine */ } });
        inerted.forEach((c) => { c.inert = false; }); inerted = [];
        scrim.classList.remove('is-in');
        setTimeout(() => scrim.remove(), RM() ? 0 : 260);
        /* the phone field lets go of its input once the card has faded */
        const iti = parts && parts.fPhone.input._lbIti;
        if (iti) setTimeout(() => { try { iti.destroy(); } catch (e) { /* fine */ } }, RM() ? 0 : 300);
        return v;
      });
    }

    async function open() {
      if (running || closed || !F) return 'closed';
      running = true;
      try {
        const held = heldSpot();
        if (held) {
          const nm = nameIn(held.name);
          await say([nm ? L.already.replace('{first}', () => nm) : L.alreadyNo]);
          return 'joined';
        }
        /* the room holds still from the sheet until Ember's answer has been read */
        if (api.hold) api.hold(true);
        const v = await sheet().catch(() => null);
        if (!v || closed) { if (api.hold) api.hold(false); return 'closed'; }
        snd('chime');
        const nm = nameIn(v.first);
        const lines = [v.state === 'turn_open' && nm ? L.open.replace('{first}', () => nm) : nm ? L.joined.replace('{first}', () => nm) : L.joinedNo];
        if (v.demo) lines.push({ text: L.demo, cls: 'dim' });
        await say(lines);
        if (api.hold) api.hold(false);
        return 'joined';
      } finally { running = false; }
    }

    return {
      open,
      busy: () => running,
      /* the room is going: the sheet goes with it (a join already sent still keeps its spot) */
      close() {
        if (closed) return;
        closed = true;
        if (shut) shut();
      }
    };
  };
})();

/* ===== src/scene-pages/pages/library.js ===== */
/* library: "Zhaunil's library" (id library, section new, order 0.5, kind toy), version two: a room to explore.
   Jan (2026-10-05): "try to make the experiece immersive ... try to not have a text panel constantly be showing ... all of
   zhaunils texts and words he says should show up at the bottom not above his head ... dont open anothe rpage until you
   confirm with them they are leaving the library". The spec is docs/scene-pages/demo2/research/LIBRARY-V2-SPEC.md; the
   art is SC['library'] (src/scene-pages/scenes/library.js, whose header lists its values, events and hotspots).

   The room is quiet (ctx.frame({ quiet: true })): no title, no labels on things, and no box until someone speaks or a
   choice waits. Every word anyone says lands in that box with the speaker's portrait (F.say, F.talk), never in a bubble.
   The page's name is a visually hidden h1. Nothing leaves the page until the reader says yes in the box: one line on
   where it leads, then the way out named plainly and "Stay in the library". The yes makes a real link and follows it,
   after the frame's fade (FFD.leaveTo); through a painting the room first zooms into that painting.
     first visit    (localStorage 'ffd-library' visits) the room lights up (event 'intro', one tap skips it) and Zhaunil
                    says two lines; later visits get one short greeting that goes at the reader's next touch
     the Guide      the lectern (the whole Guide), a bay (that shelf), Soryndel's d20 and Ask Zhaunil (the owl fetches the
                    book to the lectern), the cat's book and the binder's books all open the Guide book (library/book.js)
     the deck       the first tap each day opens today's pack of three Hall cards for the binder (library/cards.js and
                    library/pack.js); after that it deals cards to look at, one at a time, never kept. The binder opens
                    the collection (one grid the reader can rearrange) and the books read
     the curios     globe, hourglass and its feather hunt, mimic, skull, potions, cat, candles and Zhaunil's journal, the
                    shooting star (library/games.js); they speak through the room's talk and ask
     the borders    Jan's free token borders, eight sets hidden behind the curios, the ledger, the door and the window
                    (library/borders.js); the games and the ledger tell it what happened, Ask Zhaunil gives its hints
     the easel      Jan walks in as Ember and answers questions about a commission (live prices on the store)
     the door       a hero from the Hall walks in: their card and their story; once both are seen they say goodbye, and
                    they leave as soon as you turn to something else
     a painting     a door into that scene: Zhaunil names the place, "Step through" zooms into it and goes; coming back,
                    the room zooms out of the same painting
     the gallery    (Jan, 2026-10-07: only Quest takers open the extra scenes; library/gallery.js keeps the state). Old
                    Yost's cart is open to everyone. The moment the room knows the reader took the Character Quest the
                    next painting opens, then one more on each new day they come back. A locked painting rattles and
                    climbs Zhaunil's ladder of nudges toward the poster, and never leads out. The locks are a game: every
                    scene page, the Guide's band and the room list below still link every scene
     the poster     the Character Quest's WANTED posting over the room (Jan, 2026-10-07: "this poster, and when they pres
                    take this poster then ask them if they want to leave the page and go to the quest for the iron
                    matron"): "Take the posting" tears it off, then Zhaunil asks whether to go after the Iron Matron. A
                    reader who already went after her signs Zhaunil's ledger (library/ledger.js). For a Quest taker the
                    same paper shows her likeness inked in, crossed out and stamped Eliminated, paid to their hero
     ledger, ladder Zhaunil's asides (and the window's, when the games aren't there to answer it)
   Switching (Jan, 2026-10-06, "when you click something else while a current dialogue is open, fade that dialogue
   away so the new thing the user clicks on opens instead"). Every flow runs with a token. A tap on another thing gives
   way (F.cancel fades the box in about 180 ms, the old flow stops at its next await, a walker or Ember walks out) and
   the tapped thing opens. What is mid-motion or covers the room never gives way (the owl's d20 and fetch, a book, a
   card, the binder, the posting, a border card or the ring, the feather hunt and the journal).
   The four parts register factories in FFD.parts ('library/book', 'library/cards', 'library/games', 'library/borders'); render() calls
   each once with the api the spec lists. A missing part falls back to one spoken line, so the room never breaks.
   Under the frame, "Everything in this room" is a short list of plain links, for readers without the art and for search.
   One module, two homes. window.FFD_SITE (sections/ff-scene-site.liquid) means the store: routes, the Guide's two data
   views, the Hall's public rows (in cards.js), the heroes Jan allows to walk in, the published scenes and their stills.
   Without it this is the review demo: js/library-data.js and js/library/ for the books, '#<id>' for the scenes, '#heroes'
   for the Hall and Jan's featured heroes as walkers.
   Shared results (FFD.tally, page 'library'): 'read' books finished, 'w-<shelf>' what readers came for (Zhaunil's ledger
   in the picture), and the parts' own ('cards', 'feathers', 'wishes'). Per reader, in this browser only (localStorage
   'ffd-library'): visits, the books read and opened, the heroes who came in; 'ffd-library-gallery': which paintings are
   open. Nothing typed is kept or sent, with two exceptions: Ember's waitlist (library/waitlist.js) sends a first name and
   number to the waitlist, and keeps the spot's token in the store's ffq_live_v1, as the product page does; and Zhaunil's
   ledger (library/ledger.js) sends the email the reader types (and a Hall PIN, if they use one) only to the Hall's own
   reads, to find their Quest hero.
   Who the reader is comes from FFD.quest (src/scene-pages/quest-id.js): this browser's own claimed Quest run, its lead
   flag, or a ledger pick. The room reads only the copy quest-id keeps (name, class, race, pronouns, level, the public
   picture), never the Quest's run itself, its email, memory or uploaded picture, and it fires no Quest event. */
(() => {
  'use strict';
  const ID = 'library', KEY = 'library';
  const SITE = window.FFD_SITE && typeof window.FFD_SITE === 'object' ? window.FFD_SITE : null;
  const STORE = 'https://framedfantasy.com';
  const DEMO_ROUTES = {
    quest: STORE + '/pages/dnd-character-quest', product: STORE + '/products/dnd-character-commission', hall: '#heroes',
    hero: STORE + '/pages/hero?h=', battlegrounds: STORE + '/pages/battlegrounds', gift: STORE + '/pages/design-their-gift',
    reviews: STORE + '/pages/reviews', guide: STORE + '/blogs/character-commission-blog', unbound: STORE + '/pages/unbound'
  };
  const ROUTES = Object.assign({}, DEMO_ROUTES, SITE && SITE.routes ? SITE.routes : {});
  if (!SITE) ROUTES.hall = '#heroes';
  const BAYS = ['character', 'prices', 'gifts', 'table'];
  /* the shelf a first visit's ring breathes on when nothing is touched */
  const BEACON = 'bay-character';
  const SHELF = {
    character: { name: 'Books on your character', ask: 'Commissioning my character', said: 'Your own character. Let me see.', topic: 'commissioning a character', from: 'From the shelf about your character' },
    prices: { name: 'Books on prices and time', ask: 'What it costs and how long', said: 'Coin and time. Let me see.', topic: 'prices and timing', from: 'From the shelf on prices and time' },
    gifts: { name: 'Books on gifts', ask: 'A gift for someone', said: 'A gift. Let me see.', topic: 'gifts', from: 'From the gift shelf' },
    table: { name: 'Books for the table', ask: 'Ideas for my table', said: 'Something for the table. Let me see.', topic: 'ideas for the table', from: 'From the shelf for the table' }
  };
  /* Zhaunil's words, all said in the box with his portrait */
  const L = {
    intro: ['Welcome in. Tap any shelf and Soryndel will fetch you a book.'],
    /* what Zhaunil offers when he's tapped, and the portal's question (Jan, 2026-10-28: no menus to work through, the
       room itself is the way in) */
    help: 'What can I find for you?',
    helpStory: 'A book to read',
    helpHeroes: 'Jan’s favorite heroes',
    helpNo: 'Just looking',
    unbound: ['That door opens on Unbound, a game you play with Hall heroes.'],
    unboundGo: 'Step through',
    back: ['Back again. Soryndel kept your shelf warm.', 'There you are. The candles held out for you.', 'Welcome back. Soryndel heard you on the stairs.', 'Back so soon. The books noticed.', 'You again. Good, I left the best candle burning.'],
    late: 'You’re up late. So am I.',
    /* about one return greeting in three, for a reader the room doesn't know yet */
    stillUp: 'The Reeve’s posting is still up. Three nails, and nobody brave enough.',
    /* back through a painting this browser shows locked (its gallery storage was cleared mid-visit, say): no door to zoom out of */
    another: 'You found another way in. The lock never noticed.',
    /* after the reader takes the WANTED posting: the way out to the Character Quest, asked first */
    posting: ['Word in Marrow’s End is that the Iron Matron is behind it.', 'Do you want to leave the library and go after her in the Character Quest?'],
    postingYes: 'Go after the Iron Matron',
    stakes: 'Roll a 20 and Soryndel brings one of Jan’s picks.',
    crit: 'A natural 20. Soryndel goes straight for Jan’s picks.',
    fumble: 'A 1. Soryndel brings the dustiest book in the room.',
    owl: ['Soryndel knows the way. Watch.', 'Go on, Soryndel. Something good.', 'Soryndel follows the smell of old paper.', 'Soryndel circles once, then drops toward a shelf.'],
    owlFor: 'Soryndel picks one for {Name}. It seems to know them already.',
    ask: 'May I ask what you came for? It’s for research, and I’ll write it down kindly.',
    found: 'I think this is the one.',
    none: 'Nothing on these shelves says that yet. Soryndel will choose instead.',
    done: 'Finished. Soryndel will leave a ribbon in it.',
    again: ['Another, then. The shelves are patient.', 'Soryndel was hoping you’d say that.', 'One more. I’ll keep the candle lit.'],
    dark: 'The shelves won’t open for me tonight. The whole Guide is one link away.',
    deckless: 'The deck won’t shuffle for me tonight. Every card in it waits in the Hall.',
    binderless: 'The binder’s clasp is stuck tonight. Your cards are safe inside.',
    window: ['Soryndel hunts by that moon. Books, mostly.', 'The moon keeps better hours than I do.'],
    ladder: ['The ladder is for me. Soryndel finds it insulting.', 'It runs the whole wall. I’ve never seen the top shelf dusted.'],
    hallQuiet: 'The Hall is quiet tonight, but its door still opens. Every hero waits inside with their card and story.',
    /* the ledger in the picture, for a reader the room knows */
    visitors: 'Visitors. {Name}, {aclass}. Visit number {n}.',
    ledgerAsk: 'The ledger, then. Sign it the way you signed the Reeve’s posting, and I’ll know you.'
  };
  /* the locked gallery. No word here says "unlock": a painting opens, its lock comes off, Soryndel has the key */
  const LOCK = {
    /* the ladder for a reader the room doesn't know yet, one rung a tap, kept across visits */
    ladder: ['Locked. I open those for readers who’ve been somewhere.', 'Someone took that posting off the wall once. Came back with a story, and I gave them a key.', 'The posting by the jukebox. See it through, and the gallery opens for you, one painting a day.'],
    poster: 'The posting, then', went: 'I already went after her', not: 'Not now',
    jokes: ['Soryndel sat on that lock for a week. It never hatched.', 'Yost sold me that padlock. The only thing of his that ever worked.', 'Knock all you like. The painting can’t hear you through the chain.', 'That lock is older than the frame. I bought them separately.'],
    /* for a reader who took the Quest */
    next: 'That one’s next. Come back tomorrow and Soryndel will have the key.',
    glow: 'Tomorrow. Soryndel is still polishing the key.',
    later: 'Not yet. A few more nights.',
    label: 'A locked painting', labelNext: 'A locked painting. It opens tomorrow.',
    /* the first time the room knows the reader's hero (about 10 s, every beat waits for a tap) */
    known: '{Name}. Word came up the road before you did.', knownNo: 'Word came up the road before you did.',
    off: 'The Iron Matron is off the Reeve’s board. Marrow’s End sleeps tonight.',
    key: 'I open the gallery for readers who’ve been somewhere. Soryndel, the key.',
    /* the first recognition opens nothing new: Old Yost's cart is the first painting, the next comes tomorrow */
    tomorrow: 'The gallery’s yours now. Old Yost’s cart is open, and Soryndel brings another key each day you come back.',
    parcel: 'Nella’s counter. Something came for {Name}.', parcelNo: 'Nella’s counter. Something came for you.',
    /* a later new day */
    again: 'Soryndel found another key.',
    /* Ask Zhaunil: where the open paintings go once the wall is full */
    where: 'Where do the paintings go?',
    rehang: 'I rehang them when I can’t sleep. Every open one is still a door.',
    never: 'Never mind'
  };
  /* Ask Zhaunil's one secret chip. A taker hears the borders' riddles while any are left, else a line of the room's lore
     (one a day). A reader the room doesn't know yet hears that the room keeps its secrets for readers who've been somewhere */
  const SECRET = {
    ask: 'Tell me a secret', hidden: 'Is anything hidden in here?', locks: 'What’s behind the locks?',
    me: '{Name}, {arace}. Soryndel likes {them} already.',
    yesMe: 'That’s me', notMeAsk: 'That’s not me',
    notMe: 'My mistake. Someone else signed that name on this device. Sign the ledger whenever you like, and I’ll know you.',
    plenty: 'Plenty. I tell where to readers who’ve been somewhere.',
    behind: ['Scenes from the road. A chapel, a courier, a sheriff with ink on his thumbs.', 'I open one a day for readers who’ve finished something worth a painting.'],
    lore: [
      'The ladder used to reach the top shelf. Then the shelves kept growing.',
      'Soryndel can read. She pretends she can’t, so I keep reading to her.',
      'The candles light themselves at dusk. Nobody here has ever seen it happen.',
      'Bartholomew was a librarian once. He still shushes people. You just can’t hear it.',
      'The cat isn’t mine. She came with a book about cats and never left.',
      'Yost paid for a book with that jukebox. I still haven’t found which book.',
      'Some nights the window shows a different moon. I stopped writing down which.',
      'Every book on the bottom shelf has a feather in it. Soryndel’s bookmarks.',
      'The mimic only bites readers who forget to say goodnight to it.',
      'Every question asked in here goes in the ledger. Soryndel reads it back to me at night.'
    ]
  };
  /* the WANTED posting for a reader who took the Quest: the same paper, her likeness inked in, crossed out, stamped */
  const DONE = {
    face: 'The Iron Matron', stamp: 'Eliminated', paid: 'Paid to ', paidNo: 'Paid in full',
    back: 'Back to the library', again: 'Play the Quest with another hero'
  };
  /* the door, once a day, when the reader's own hero is in the Hall for all to see */
  const OWN_HELLO = 'There you are. The Hall sent you back to us.';
  /* the gate's plate when the browser held the music back */
  const MPLATE = { click: 'Click anywhere for music.', tap: 'Tap anywhere for music.' };
  /* each painting's place, in one line (section 9), and a word for coming back from it */
  const DOORS = {
    coin: 'That’s Old Yost’s back road. Tailspin’s table is just past it.',
    death: 'Sister Maren’s chapel. Someone in there is making death saves.',
    parcel: 'Nella the courier’s counter. There’s a parcel with your character’s name on it.',
    bounty: 'The sheriff’s board. He’s putting a price on someone’s head.',
    inn: 'Orin’s inn, the night after the party left. Put your ear to the door.',
    mystery: 'The Hall, the night its lantern went missing.',
    sellsword: 'A sellsword who charges by the scar. Mind her prices.',
    adventures: 'Ember’s forge, where the Hall’s gear gets mended.',
    jobs: 'A town’s job board in the rain. Tear one off for your table.',
    heroes: 'The Hall’s heroes in pixels, each beside their painting.'
  };
  const RETURNS = {
    coin: 'Back from Tailspin’s table. Did the coin land your way?',
    death: 'Back on your feet. Sister Maren does good work.',
    parcel: 'Back from Nella’s counter. Was the parcel yours?'
  };
  /* Jan, as Ember, at the easel (section 8): Jan speaks in the first person, from the live product page's facts */
  const EMBER = {
    first: 'Oh, you found my easel. I’m Jan. When I visit, I come as Ember, the character I play at my own table.',
    asks: [
      { id: 'how', label: 'How does a commission work?', lines: [
        'You join the waitlist once and see your place in line, and I text you when it’s your turn.',
        'While you wait, the Character Quest takes five minutes and gives me your character’s blueprint.',
        'When your turn comes, you claim your spot, and my team and I get to work with you in the loop. About two weeks later you see your character, and we refine until it feels right.'] },
      { id: 'sizes', label: 'What sizes are there?', lines: [
        'Half body is chest up, best for tokens.',
        'Thigh up shows the outfit and the weapon. It’s the most popular.',
        'Full body is head to boots, with a full scene.'] },
      { id: 'cost', label: 'What does it cost?' },
      { id: 'like', label: 'What if it doesn’t look like them?', lines: [
        'Unlimited revisions until it feels right.',
        'And if the first version doesn’t capture your character, you get every dollar back.'] },
      { id: 'who', label: 'Who paints it?', lines: ['I work on every portrait with my team of vetted artists, and you talk to me the whole way.'] },
      { id: 'send', label: 'What do I need to send?', lines: ['Nothing special. Take the Character Quest.', 'It asks the questions, and I read every word.'] },
      { id: 'ready', label: 'I’m ready, save my spot.' },
      { id: 'bye', label: 'Just looking, thanks.' }
    ],
    ask: 'Ask me anything about a commission.',
    more: ['What else can I tell you?', 'Ask me anything else.', 'Anything else on your mind?'],
    ready: 'Then let’s get you in line.',
    readyHere: 'Save my spot here',
    readyWhere: 'The commission page is where you secure your spot.',
    readyYes: 'Go to the commission page',
    bye: 'Take your time. The easel isn’t going anywhere.',
    booked: 'Right now every size is booked, so you join the waitlist and I text you when it’s your turn.',
    open: ' open right now, so you can secure your spot today.',
    noPrices: 'Each size has its own price, and the commission page lists them all.'
  };
  /* the demo's prices (the store reads its own, live) */
  const DEMO_SIZES = [{ name: 'half body', cents: 9900, open: false }, { name: 'thigh up', cents: 13900, open: false }, { name: 'full body', cents: 19900, open: false }];
  /* a hero who walks in through the door */
  const WALK = {
    hello: 'Evening. Zhaunil said I’d find a reader in here.',
    more: ['Anything else?', 'I’m in no hurry.', 'What else would you like to know?'],
    story: 'My whole story is in the Hall, with my card.',
    /* the visit ends by itself once the reader has seen what they offer (Jan, 2026-10-06: "just show card tell story
       dont visit the hall") */
    bye: ['I’ll leave you to your reading.', 'Good reading. Zhaunil keeps a good fire.', 'Until next time. The door knows my knock.'],
    hallYes: 'Go to the Hall'
  };
  const STAY = 'Stay in the library';
  /* ---- the poster opens the Character Quest's WANTED posting (Jan, 2026-10-07: "for this page i dont mean bring up
     this whole page i mean, this poster, and when they pres take this poster then ask them if they want to leave the
     page and go to the quest for the iron matron"). A copy of the quest's second screen, so it reads as the same paper:
     the words and the likeness sketch from assets/quest-one-v2.js Posting (:1125-1150) and UNKNOWN_FACE (:1086), the
     look from assets/quest-one-v2.css. No quest script loads and no quest event fires. Whether the reader took the Quest
     comes from FFD.quest's own copy (never the Quest's run); a taker sees the Iron Matron's likeness from the Quest's art
     (QOArt.mountMatron, already on every scene page) inked in, crossed out and stamped ---- */
  const POSTING = {
    lead: 'Someone nailed this one up <b>three times</b>.',
    sub: 'The villain behind the bog disappearances',
    body: 'Twelve gone on the road to the Hollow Stump.<br>Find who took them.',
    foot: 'By order of the Reeve of Marrow’s End',
    take: 'Take the posting',
    stay: 'Leave it on the wall'
  };
  /* markup, not words: the quest's own sketch, its attributes as they are */
  const POSTING_FACE = `<svg class="qo-poster__sketch" viewBox="0 0 72 84" aria-hidden="true" focusable="false"><defs><clipPath id="qoSkFrame"><path d="M5.5 5.6C24.2 5.2 46.8 4.7 66.7 4.9C66.9 30.2 67.2 55.1 67.1 79.3C46.2 79.6 24.9 79.9 5.1 79.6C5.3 55.2 5.2 30.1 5.5 5.6Z" /></clipPath><clipPath id="qoSkBody"><path d="M36.2 12.4C45.9 12.8 52.9 24.3 53.6 40.1C54 47.6 53.3 53.2 52.1 57.1C58.8 59.5 64.2 64 65.7 71.5L66.5 79.3L5.6 79.5L6.3 71.3C7.9 64.1 13.1 59.7 19.9 57.2C18.6 53 18.1 47.2 18.6 40.2C19.7 24.5 26.5 12.1 36.2 12.4Z" /></clipPath><mask id="qoSkGap" maskUnits="userSpaceOnUse" x="0" y="0" width="72" height="84"><rect width="72" height="84" fill="#fff" /><g transform="translate(37 39.5) scale(1.15) translate(-37 -43.5)"><path d="M31.6 39.2C31.5 34.6 34.9 32.6 37.8 33C41.2 33.5 43 36.2 42.1 39.1C41.4 41.4 39.3 42.2 38 43.7C37 44.8 36.7 46.1 36.9 48" fill="none" stroke="#000" stroke-width="5.4" stroke-linecap="round" stroke-linejoin="round" /><circle cx="37" cy="52.6" r="3.25" fill="#000" /></g></mask></defs><path class="qo-sk-frame" d="M5.5 5.6C24.2 5.2 46.8 4.7 66.7 4.9C66.9 30.2 67.2 55.1 67.1 79.3C46.2 79.6 24.9 79.9 5.1 79.6C5.3 55.2 5.2 30.1 5.5 5.6Z" /><g clipPath="url(#qoSkFrame)"><path class="qo-sk-bg" d="M5.75 3.97L5.87 80.73M8.84 4.01L8.86 80.98M11.17 4.13L11.06 80.93M14.14 3.93L13.69 80.83M16.81 4.03L16.75 80.84M19.36 3.71L19.00 81.05M21.74 3.93L22.25 81.01M24.32 4.28L24.14 81.24M26.60 4.18L26.80 80.87M28.98 4.27L28.99 81.30M31.63 3.85L31.74 80.71M34.78 3.91L34.88 80.70M37.57 4.03L37.47 81.01M40.19 4.26L40.57 80.96M43.07 3.84L42.75 80.73M45.72 3.91L45.96 80.93M48.30 3.93L48.27 81.04M51.35 3.76L51.47 81.30M53.98 3.92L54.20 81.09M56.46 4.02L56.38 81.28M59.41 3.79L58.97 81.28M61.85 4.20L61.86 81.23M64.55 3.84L64.26 81.18" /></g><path class="qo-sk-frame2" d="M7.3 7.4C25.1 7.1 46.5 6.8 64.9 6.9C65 30.6 65.2 54.7 65.2 77.4C45.7 77.6 25.8 77.8 7.1 77.6C7.2 54.3 7.2 30.4 7.3 7.4Z" /><path class="qo-sk-base" d="M36.2 12.4C45.9 12.8 52.9 24.3 53.6 40.1C54 47.6 53.3 53.2 52.1 57.1C58.8 59.5 64.2 64 65.7 71.5L66.5 79.3L5.6 79.5L6.3 71.3C7.9 64.1 13.1 59.7 19.9 57.2C18.6 53 18.1 47.2 18.6 40.2C19.7 24.5 26.5 12.1 36.2 12.4Z" /><g clipPath="url(#qoSkBody)"><path class="qo-sk-hatch" d="M-84.21 86.15L1.86 0.22M-82.19 85.71L3.83 0.03M-79.31 85.89L6.54 0.29M-77.06 85.80L8.85 -0.00M-75.38 86.00L10.94 -0.02M-73.01 86.01L12.65 0.08M-70.49 86.04L15.26 0.16M-68.63 86.04L17.62 -0.18M-65.59 85.94L19.73 0.20M-63.23 85.84L22.37 -0.16M-60.89 86.11L24.79 -0.05M-59.01 86.15L26.61 0.17M-56.89 86.17L29.53 0.07M-54.19 86.29L31.86 -0.15M-52.55 85.99L34.02 0.15M-50.43 86.04L35.94 0.30M-48.35 85.98L38.44 0.20M-45.90 86.13L40.35 -0.00M-44.05 86.25L42.37 -0.22M-41.57 86.09L44.88 -0.28M-38.75 86.18L47.16 -0.20M-36.77 86.16L48.65 0.13M-34.56 85.91L51.55 -0.18M-32.41 86.17L54.00 0.02M-29.48 85.92L56.54 -0.02M-27.23 86.20L58.27 0.22M-25.60 86.29L60.73 0.26M-23.40 85.71L63.05 -0.30M-20.56 86.00L65.34 -0.15M-18.28 85.77L67.04 0.24M-15.93 85.91L69.55 0.24M-14.19 85.95L71.64 0.28M-12.13 86.03L74.32 0.09M-10.10 85.77L75.88 0.19M-7.77 86.00L78.55 0.07M-5.08 86.14L81.60 0.20M-2.73 85.95L84.05 0.09M0.23 85.87L85.96 0.28M2.54 86.00L88.47 0.12M4.52 86.17L90.26 -0.02M7.22 86.04L93.26 -0.10M9.69 85.78L94.95 -0.01M11.86 85.95L97.55 0.12M14.36 85.74L99.88 0.25M15.95 85.74L102.48 -0.26M18.56 85.96L104.80 -0.29M21.16 85.74L107.12 0.02M23.43 85.86L109.19 0.10M25.94 85.92L112.05 0.28M27.93 85.80L113.84 -0.26M29.87 86.26L116.39 0.13M32.50 85.71L118.82 -0.15M35.12 86.17L121.14 -0.06M37.38 86.09L122.63 -0.12M39.17 85.97L125.92 0.18M42.28 85.83L128.45 -0.26M44.61 86.14L130.86 -0.13M46.41 86.24L132.42 0.18M48.86 86.29L134.87 0.03M51.12 85.79L137.68 0.02M53.82 86.17L139.96 0.28M55.91 85.85L141.44 0.13M58.59 85.79L144.15 0.09M60.64 86.09L146.77 0.21M62.84 85.95L149.11 -0.21M65.35 85.78L151.47 0.24M67.58 86.12L153.33 0.22M70.36 85.93L155.82 -0.00M-84.25 -1.87L2.31 84.16M-81.19 -1.77L4.59 83.92M-78.76 -1.76L6.65 83.87M-77.24 -2.29L8.59 84.26M-74.43 -1.76L11.40 83.78M-72.69 -1.88L13.28 84.23M-70.34 -2.14L15.92 84.27M-68.04 -2.15L17.87 84.00M-65.95 -1.98L20.09 83.81M-63.52 -2.25L22.20 84.04M-61.40 -2.19L24.54 84.01M-59.66 -2.04L26.30 84.20M-57.83 -1.98L28.84 83.98M-54.87 -1.87L30.80 84.13M-52.41 -2.21L33.47 84.24M-50.78 -1.77L35.08 83.90M-47.91 -1.84L37.69 84.17M-45.53 -2.21L40.08 83.73M-43.20 -1.79L42.57 84.05M-41.37 -1.88L44.70 83.87M-38.25 -1.74L46.87 83.95M-35.91 -1.92L49.44 83.81M-34.33 -1.81L52.05 83.91M-31.76 -1.80L54.43 83.83M-29.75 -1.96L56.87 83.94M-26.99 -2.11L58.78 83.73M-25.03 -1.85L60.91 84.23M-22.41 -1.81L63.15 84.06M-20.87 -1.71L65.53 84.19M-17.97 -2.03L68.20 83.96M-15.36 -2.17L70.39 83.85M-12.74 -1.84L73.03 84.23M-10.70 -2.18L75.66 84.18M-8.35 -1.85L78.03 83.93M-5.98 -2.13L80.16 83.73M-3.41 -1.76L82.76 83.96M-0.78 -2.09L85.13 83.96M1.91 -2.28L87.17 83.85M4.28 -1.73L89.67 84.15M5.66 -1.87L92.04 84.17M7.79 -1.88L93.95 83.81M10.60 -2.05L96.08 84.11M12.21 -2.07L98.83 84.14M14.56 -2.04L100.60 83.97M17.24 -1.94L103.32 84.21M19.96 -2.19L105.72 84.14M21.99 -2.23L108.42 84.28M24.67 -1.83L110.97 83.89M27.03 -1.89L112.57 83.74M28.90 -2.09L114.65 83.87M31.30 -1.90L117.01 83.73M33.24 -1.85L119.20 83.93M35.33 -2.17L121.23 84.04M37.88 -2.00L124.20 83.91M40.28 -2.01L126.00 83.87M42.98 -2.27L128.79 83.75M45.41 -2.11L131.19 84.03M47.56 -2.23L133.46 83.72M50.00 -1.95L136.32 84.16M51.63 -2.12L137.61 83.97M54.02 -1.95L139.91 84.05M56.77 -2.19L142.43 83.76M59.30 -2.14L144.89 84.13M61.54 -2.12L147.29 83.84M63.77 -1.99L149.49 83.72M66.37 -1.85L152.23 84.09M67.89 -1.87L154.32 84.02M70.14 -1.90L156.65 84.22" mask="url(#qoSkGap)" /></g><path class="qo-sk-line" d="M36.2 12.4C45.9 12.8 52.9 24.3 53.6 40.1C54 47.6 53.3 53.2 52.1 57.1C58.8 59.5 64.2 64 65.7 71.5L66.5 79.3L5.6 79.5L6.3 71.3C7.9 64.1 13.1 59.7 19.9 57.2C18.6 53 18.1 47.2 18.6 40.2C19.7 24.5 26.5 12.1 36.2 12.4Z" /><path class="qo-sk-line2" d="M36.2 12.4C45.9 12.8 52.9 24.3 53.6 40.1C54 47.6 53.3 53.2 52.1 57.1C58.8 59.5 64.2 64 65.7 71.5L66.5 79.3L5.6 79.5L6.3 71.3C7.9 64.1 13.1 59.7 19.9 57.2C18.6 53 18.1 47.2 18.6 40.2C19.7 24.5 26.5 12.1 36.2 12.4Z" transform="translate(0.5 -0.35)" /><g transform="translate(37 39.5) scale(1.15) translate(-37 -43.5)"><path class="qo-sk-q" d="M31.6 39.2C31.5 34.6 34.9 32.6 37.8 33C41.2 33.5 43 36.2 42.1 39.1C41.4 41.4 39.3 42.2 38 43.7C37 44.8 36.7 46.1 36.9 48" /><path class="qo-sk-q2" d="M31.6 39.2C31.5 34.6 34.9 32.6 37.8 33C41.2 33.5 43 36.2 42.1 39.1C41.4 41.4 39.3 42.2 38 43.7C37 44.8 36.7 46.1 36.9 48" /><circle class="qo-sk-dot" cx="37" cy="52.6" r="1.8" /></g></svg>`;
  /* never walks in, whatever any list says (and Zhaunil is already here) */
  const DENY = ['ford', 'allagis', 'zhaunil'];
  /* Jan's rule is that a customer's Hall hero shows on a public scene page only after its owner says yes. On the live store
     (FFD.live) a hero is drawn, named or quoted only when its id is in window.FFD_HEROES_OK (sections/ff-scene-page.liquid
     prints it from a template setting); Ember is Jan's own. The review demo keeps everyone */
  const heroOk = (id) => {
    id = String(id || '').toLowerCase();
    if (id === 'ember' || !(window.FFD && window.FFD.live)) return true;
    const ok = Array.isArray(window.FFD_HEROES_OK) ? window.FFD_HEROES_OK.map((x) => String(x).toLowerCase()) : [];
    return ok.includes(id) || ok.includes(id.split('-')[0]);
  };
  /* a store walker is a Hall slug; the pixel heroes go by short ids. Most slugs start with the id ('gillic-grimson'),
     these don't */
  const WALK_ALIAS = { 'laith-whiskers-reed': 'whiskers', 'jehn-to-ne': 'jehnto', 'dame-nemia-the-merciful': 'nemia', 'alexandra-axe-moxley': 'axe', 'leonorin-leo-misthaven': 'leo' };
  const QUIET = new Set('a an and the to of for in on at my me i you your is are it its do does how what why who with about some something that this be can want need get from by or so just d&d dnd dungeons dragons character characters portrait portraits art fantasy custom'.split(' '));
  const SYN = {
    cost: ['price', 'prices', 'pay', 'budget', 'quote', 'deposit', 'worth', 'cheap', 'afford'], much: ['cost', 'price', 'pay'], expensive: ['cost', 'price', 'worth'], cheap: ['cost', 'price', 'budget'], price: ['cost', 'pay', 'budget', 'quote'], money: ['cost', 'price', 'pay', 'budget'],
    long: ['timeline', 'time', 'deadline', 'weeks', 'calendar'], time: ['timeline', 'deadline', 'long', 'calendar'], deadline: ['timeline', 'long', 'time'], fast: ['deadline', 'timeline', 'long'],
    gift: ['gifts', 'giving', 'present', 'surprise'], present: ['gift'], birthday: ['gift'], christmas: ['gift', 'holiday'], partner: ['gift', 'boyfriend'], girlfriend: ['gift'], wife: ['gift'], husband: ['gift', 'boyfriend'], dad: ['father', 'gift'], boyfriend: ['gift'],
    dm: ['npc', 'campaign', 'table', 'scene', 'session'], npc: ['npcs', 'dm', 'cast'], party: ['group', 'party'], group: ['party'], campaign: ['story', 'table', 'session'],
    describe: ['brief', 'details', 'explain', 'words', 'questions', 'references'], brief: ['describe', 'checklist', 'details'], reference: ['references', 'mood', 'photo'], photo: ['likeness', 'photo'],
    scam: ['scammer', 'reliable', 'red', 'flags', 'fiverr'], artist: ['artist', 'platform', 'fiverr', 'etsy', 'marketplace', 'studio'], fiverr: ['fiverr', 'marketplace'], etsy: ['etsy', 'marketplace'],
    bg3: ['bg3', 'baldur'], baldur: ['bg3'], animated: ['moving', 'breathing'], moving: ['breathing', 'moving'], horns: ['horns', 'wings', 'anatomy'], wings: ['horns', 'anatomy'], tiefling: ['horns', 'anatomy'], dragonborn: ['anatomy', 'horns'],
    ai: ['ai'], book: ['author', 'book'], author: ['book'], share: ['share', 'online', 'noticed'], inspiration: ['inspiration', 'ideas', 'gallery'], hall: ['hall', 'heroes'],
    pose: ['body', 'full', 'half', 'thigh'], size: ['body', 'full', 'half', 'thigh', 'formats'], full: ['body', 'thigh'], half: ['body', 'thigh']
  };
  /* Jan's picks, what a natural 20 brings (the store's own list comes from the section's setting) */
  const PICKS = SITE && Array.isArray(SITE.picks) ? SITE.picks.map(String) : [
    'character-art-formats-review-2026-09-30', 'how-much-does-dnd-character-art-cost-2026-pricing-guide-1',
    'best-gifts-for-dnd-players-in-2026-from-a-fellow-player', 'the-dnd-character-commission-checklist-most-players-skip',
    'how-to-describe-your-dnd-character-to-an-artist-even-if-words-arent-your-thing', 'how-to-bring-your-dnd-character-to-life-beyond-the-sheet',
    'where-to-share-your-dnd-character-online-and-actually-get-noticed', 'how-to-commission-a-dnd-character-portrait-in-2026'
  ];
  /* the scenes that play here, in the gallery's order (the store lists only the published ones it was given) */
  /* no 'sign': Jan retired that scene from the site (2026-10-28) */
  const SCENE_IDS = ['coin', 'death', 'parcel', 'bounty', 'inn', 'mystery', 'sellsword', 'adventures', 'jobs', 'heroes'];
  const SCENES = {
    coin: { title: 'the coin nobody can lose' }, death: { title: 'three rolls at death’s door' }, parcel: { title: 'a parcel for your character' },
    bounty: { title: 'a price on your character’s head' }, inn: { title: 'what the inn says after you leave' },
    mystery: { title: 'mystery at the hall' }, sellsword: { title: 'the sellsword who charges by the scar' }, adventures: { title: 'mini adventures in the hall' },
    jobs: { title: 'the job board in the rain' }, heroes: { title: 'hall heroes in pixels' }
  };
  const ALT = 'A candlelit library at night. Tall bookcases full of old spines, with a few curios among them. Zhaunil, a drow wizard in blue robes, stands with a white owl on his shoulder by a lectern. Hall cards and a binder wait on a side table. A portrait stands on the easel with an art guide beside it, and a violet Unbound portal opens on the right. Small framed paintings, a wanted poster, a moonlit window and floating candles fill the room.';

  const SK = 'ffd-library';
  const arr = (v) => (Array.isArray(v) ? v.filter((x) => typeof x === 'string') : []);
  /* a reader from before version two (a saved list but no count) has been here: no intro for them */
  const store = () => {
    try {
      const v = JSON.parse(localStorage.getItem(SK) || 'null');
      if (v && typeof v === 'object') return { read: arr(v.read), seen: arr(v.seen), cards: arr(v.cards), came: arr(v.came), visits: v.visits != null && isFinite(+v.visits) ? Math.max(0, +v.visits) : 1 };
    } catch (e) { /* fine */ }
    return { read: [], seen: [], cards: [], came: [], visits: 0 };
  };
  const keep = (v) => { try { localStorage.setItem(SK, JSON.stringify({ read: v.read.slice(-400), seen: v.seen.slice(-60), cards: v.cards.slice(-400), came: v.came.slice(-80), visits: v.visits })); } catch (e) { /* fine */ } };
  /* the painting the reader walked through, for the zoom back out of it (this tab only) */
  const DOOR_KEY = 'ffd-library-door';
  const doorKeep = (id) => { try { sessionStorage.setItem(DOOR_KEY, JSON.stringify({ id, t: Date.now() })); } catch (e) { /* fine */ } };
  const doorTake = () => {
    try {
      const v = JSON.parse(sessionStorage.getItem(DOOR_KEY) || 'null');
      sessionStorage.removeItem(DOOR_KEY);
      if (v && typeof v.id === 'string' && Date.now() - (+v.t || 0) < 30 * 60e3) return v.id;
    } catch (e) { /* fine */ }
    return null;
  };
  const rnd = (n) => Math.floor(Math.random() * n);
  const pickOf = (list) => list[rnd(list.length)];
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const RM = () => FFD.RM();
  let wideMQ = null;
  const WIDE = () => { try { return (wideMQ || (wideMQ = matchMedia('(min-width: 720px)'))).matches; } catch (e) { return false; } };
  const cap1 = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
  const esc = (v) => String(v == null ? '' : v).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  /* who the reader is: FFD.quest (src/scene-pages/quest-id.js), which the review demo may not carry */
  const Q = () => { try { return window.FFD && FFD.quest && FFD.quest.v === 1 ? FFD.quest : null; } catch (e) { return null; } };
  const tookQuest = () => { const q = Q(); try { return !!(q && q.took()); } catch (e) { return false; } };
  const questHero = () => { const q = Q(); try { return q ? q.hero() : null; } catch (e) { return null; } };
  /* a Quest or Hall name put into a line: F.say reads HTML and fills {tokens}, so the name is escaped and its braces made
     inert (as library/ledger.js said() does), and the hero's own pronoun is used, whoever FFD.char is now */
  const inert = (s) => esc(String(s == null ? '' : s)).replace(/\{/g, '&#123;').replace(/\}/g, '&#125;');
  const anA = (w) => (/^[aeiou]/i.test(String(w || '')) ? 'an ' : 'a ') + w;
  const OBJ = { he: 'him', she: 'her', they: 'them' };
  function heroLine(tpl, hero, more) {
    hero = hero || {};
    const cls = String(hero.clsLabel || 'adventurer').toLowerCase(), race = String(hero.race || '').trim(), nm = inert(hero.name || '');
    const map = Object.assign({ Name: nm, aclass: anA(inert(cls)), arace: anA(inert(race ? race + ' ' + cls : cls)), them: OBJ[hero.pr] || nm || 'them', n: '' }, more || {});
    return String(tpl).replace(/\{(Name|aclass|arace|them|n)\}/g, (m, k) => (map[k] != null ? String(map[k]) : m));
  }
  const burst = (k, ms) => { try { return window.FFD && typeof FFD.burst === 'function' ? FFD.burst(k, ms) : 1; } catch (e) { return 1; } };
  const egg = () => { try { return window.FFD && typeof FFD.egg === 'function' ? FFD.egg('library') : null; } catch (e) { return null; } };
  /* FFSound by name; a name it doesn't know is silent */
  const sound = (n) => { try { const s = window.FFSound; if (s && typeof s[n] === 'function') s[n](); } catch (e) { /* silent */ } };
  const joinAnd = (list) => (list.length < 2 ? list.join('') : list.length === 2 ? list.join(' and ') : list.slice(0, -1).join(', ') + ', and ' + list[list.length - 1]);
  const money = (cents) => '$' + (cents % 100 ? (cents / 100).toFixed(2) : String(Math.round(cents / 100)));
  /* the first one or two sentences of a story */
  const sentences = (s, n) => { const m = String(s || '').replace(/\s+/g, ' ').trim().match(/[^.?!]+[.?!]+["”’]?/g); return m ? m.slice(0, n).join(' ').trim() : String(s || '').trim(); };
  /* the bottom of any bar that stays at the top of the window (the review demo's bar, the store's sticky header), found
     by what sits at the window's top edge; nothing inside `skip` (the frame) counts */
  function topInset(skip) {
    const vw = window.innerWidth || 0, vh = window.innerHeight || 0, seen = new Set();
    let inset = 0;
    [0.2, 0.5, 0.8].forEach((fx) => {
      let at = [];
      try { at = document.elementsFromPoint(Math.round(vw * fx), 2); } catch (e) { at = []; }
      for (const el of at) {
        if (skip && skip.contains(el)) continue;
        for (let n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
          if (seen.has(n)) break;
          seen.add(n);
          const pos = getComputedStyle(n).position;
          if (pos !== 'fixed' && pos !== 'sticky') continue;
          const r = n.getBoundingClientRect();
          if (r.top <= 2 && r.bottom > inset && r.bottom < vh * 0.5) inset = r.bottom;
          break;
        }
      }
    });
    return Math.ceil(inset);
  }
  /* the page moves at once (never smoothly, and never through a theme's smooth-scroll setting) */
  const goTo = (y) => { y = Math.max(0, Math.round(y)); try { window.scrollTo({ top: y, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); } };

  /* ---- files the demo reads (fetch can't read file://, so data comes as scripts) ---- */
  const BASE = () => window.FFD_LIBRARY_BASE || 'js/library/';
  const loaded = {};
  function loadFile(src) {
    if (loaded[src]) return loaded[src];
    return (loaded[src] = new Promise((res) => {
      const s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = () => res(true);
      s.onerror = () => { delete loaded[src]; res(false); };
      document.head.appendChild(s);
    }));
  }
  const textOf = (hd) => { for (const m of (window.FFD_LIBRARY_TEXT || [])) if (m[hd] != null) return m[hd]; return null; };
  const picOf = (id) => { for (const m of (window.FFD_LIBRARY_PICS || [])) if (m[id] != null) return m[id]; return null; };
  /* the demo's books (js/library-data.js) arrive as window.FFD_LIBRARY_DATA; window.FFD_LIBRARY is only the way home
     ({ url }, core.js FFD.libraryHref) */
  async function demoData() {
    const has = () => !!(window.FFD_LIBRARY_DATA && Array.isArray(window.FFD_LIBRARY_DATA.books));
    if (!has()) await loadFile('js/library-data.js');
    return has() ? window.FFD_LIBRARY_DATA : { books: [] };
  }
  /* the store's two Guide views come as text/html; a Liquid error prints inline text, so parse inside try */
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then((r) => { if (!r.ok) throw new Error('status ' + r.status); return r.text(); }).then((t) => JSON.parse(t));
  }
  const withQuery = (u, q) => u + (u.indexOf('?') >= 0 ? '&' : '?') + q;

  /* Shopify CDN pictures at the width a place needs (tools/library-data.cjs sized() does the same) */
  function sized(u, w) {
    if (!u) return u;
    try {
      const x = new URL(u, location.href);
      if (!/\/cdn\/shop\/|cdn\.shopify\.com/.test(x.href)) return u;
      x.searchParams.set('width', String(w)); return x.href;
    } catch (e) { return u; }
  }

  /* twins: near-identical titles share a group (tools/library-data.cjs twins(), worked out here in both homes, so the
     demo and the store can't drift) */
  const STOP = new Set('a an and the to of for in on your you my with how what why is are it its do does d&d dnd character art portrait portraits fantasy commission commissions guide 2025 2026 vs or by from that this'.split(' '));
  const wordsOf = (t) => new Set(String(t).toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').split(/\s+/).filter((w) => w && !STOP.has(w)));
  function twins(list) {
    const W = list.map((a) => wordsOf(a.t)), g = list.map((_, i) => i);
    const find = (i) => (g[i] === i ? i : (g[i] = find(g[i])));
    for (let i = 0; i < list.length; i++) for (let j = i + 1; j < list.length; j++) {
      const A = W[i], B = W[j]; if (!A.size || !B.size) continue;
      let both = 0; A.forEach((w) => { if (B.has(w)) both++; });
      if (both / (A.size + B.size - both) >= 0.6) g[find(j)] = find(i);
    }
    list.forEach((b, i) => { b.g = find(i); });
  }

  /* an article body from the store's read view, cleaned on the device before it goes in (tools/library-data.cjs) */
  function cleanBody(html) {
    const d = new DOMParser().parseFromString('<!doctype html><body><div id="lb-x">' + String(html || '') + '</div>', 'text/html');
    const c = d.getElementById('lb-x'); if (!c) return '';
    c.querySelectorAll('script, style, noscript, iframe, frame, frameset, object, embed, form, input, select, textarea, button, nav, link, meta, base, svg, math, map, area, video, audio, source, template, .ffb-toc, .toc, .table-of-contents, .ffb-share').forEach((x) => x.remove());
    c.querySelectorAll('h1').forEach((x) => { const h2 = d.createElement('h2'); h2.innerHTML = x.innerHTML; x.replaceWith(h2); });
    c.querySelectorAll('*').forEach((el) => {
      const tag = el.tagName;
      [...el.attributes].forEach((a) => {
        const k = a.name.toLowerCase();
        if (tag === 'IMG') { if (!['src', 'alt', 'width', 'height'].includes(k)) el.removeAttribute(a.name); return; }
        if (k.startsWith('on') || k === 'style' || k === 'id' || k.startsWith('data-') || k === 'loading' || k === 'srcset' || k === 'sizes' || k === 'fetchpriority' || k === 'decoding' || k === 'tabindex' || k === 'role' || k.startsWith('aria-') || k === 'target' || k === 'rel' || k === 'formaction' || k === 'action') el.removeAttribute(a.name);
      });
      if (tag === 'IMG') {
        const src = el.getAttribute('src') || '';
        if (!src || /^(javascript|data):/i.test(src)) { el.remove(); return; }
        el.setAttribute('src', sized(src, 720)); el.setAttribute('loading', 'lazy'); el.setAttribute('decoding', 'async');
      } else if (tag === 'A') {
        /* the address as the browser will read it (a tab or a control character inside a scheme doesn't hide it): only
           web, mail and phone links stay links, anything else becomes plain text */
        const hr = (el.getAttribute('href') || '').trim();
        let u = null;
        if (hr && !hr.startsWith('#')) { try { u = new URL(hr, location.href); } catch (e) { u = null; } }
        if (!u || !/^(https?|mailto|tel):$/.test(u.protocol)) {
          /* the children move (not a copy of their markup), so the clean-up still visits each one */
          const s = d.createElement('span'); while (el.firstChild) s.append(el.firstChild); el.replaceWith(s); return;
        }
      }
    });
    return c.innerHTML;
  }

  const CSS = `
/* the page's name: there for screen readers and search, never on screen (the room is quiet) */
.ffd-page--library .lb-h1 { position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; border: 0; overflow: hidden; clip: rect(0 0 0 0); clip-path: inset(50%); white-space: nowrap; }
/* the intro: one tap anywhere skips it */
.ffd-page--library .lb-skip { position: absolute; inset: 0; z-index: 8; display: block; width: 100%; height: 100%; margin: 0; padding: 0; border: 0; background: transparent; cursor: pointer; -webkit-tap-highlight-color: transparent; }
.ffd-page--library .lb-skip:focus { outline: none; }
.ffd-page--library .lb-skip:focus-visible { outline: 2px solid #7ee6df; outline-offset: -6px; }
/* the real link made only after a yes (a click on it is a link click to any tracking, and Back comes home) */
.ffd-page--library .lb-go { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
/* through a painting: the art zooms into it (and out of it on the way back); its corner and its buttons stay still */
.ffd-page--library .ffs.lb-portal .ffs-art { will-change: transform, opacity; }
.ffd-page--library .ffs.lb-portal .ffs-top, .ffd-page--library .ffs.lb-portal .ffs-hots, .ffd-page--library .ffs.lb-portal .ffs-tag, .ffd-page--library .ffs.lb-portal .ffs-beacon { visibility: hidden; }
/* asking in your own words */
.ffd-page--library .lb-ask { display: grid; gap: 10px; }
.ffd-page--library .lb-ask label { font: italic 500 16px/1.4 var(--f-aside); color: #eadfc9; text-align: center; }
.ffd-page--library .lb-ask input { min-height: 48px; padding: 10px 14px; border-radius: 8px; border: 1px solid rgba(200, 164, 94, .32); background: rgba(10, 8, 6, .6); color: #f4efe6; font: 400 16px/1.3 var(--f-body); }
.ffd-page--library .lb-ask input:focus { outline: none; border-color: rgba(232, 198, 116, .75); box-shadow: 0 0 0 3px rgba(232, 198, 116, .14); }
.ffd-page--library .lb-ask-row { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
.ffd-page--library .lb-askmsg { display: block; min-height: 1.3em; margin: 0; text-align: center; font: italic 500 15px/1.3 var(--f-aside); color: #e7c97f; }
/* a sheet on its way out never takes a tap (the second tap of a double tap) */
.ffd-page--library .ffs-sheet.is-out { pointer-events: none; }
/* a short wide frame (a laptop under the store's header) takes the window while the Guide book is open: its top just
   under any bar that stays at the top (tallOn below sets --lb-inset and moves the page there) */
@media (min-width: 720px) { .ffd-page--library .ffs.lb-tall { --ffs-hh: calc(100svh - var(--lb-inset, 0px)); } }
/* on a phone the box floats over the room: its choices sit a little tighter (each still 44 px tall), so Jan's eight
   questions leave the easel in view */
@media (max-width: 719px) { .ffd-page--library .ffs.is-quiet .ffs-acts .ffs-chip { padding: 5px 10px; line-height: 1.15; } }

/* everything in this room, under the frame: plain links in a short ruled list, two columns on a wide screen */
.ffd-page--library .lb-room { width: 100%; max-width: 760px; margin: 0 auto; }
.ffd-page--library .lb-room h2 { margin: 0 0 16px; font: 600 18px/1.3 var(--f-display); letter-spacing: .01em; color: #efe7d6; text-align: center; text-wrap: balance; }
.ffd-page--library .lb-room h2::before { content: ''; display: block; width: 36px; height: 2px; margin: 0 auto 12px; border-radius: 2px; background: linear-gradient(90deg, #e7c97f, #c8a45e); }
.ffd-page--library .lb-roomlist { list-style: none; margin: 0; padding: 0; display: grid; grid-template-columns: minmax(0, 1fr); border-top: 1px solid rgba(200, 164, 94, .14); }
.ffd-page--library .lb-roomlist li { display: block; border-bottom: 1px solid rgba(200, 164, 94, .14); }
.ffd-page--library .lb-roomlist a { display: grid; grid-template-columns: minmax(0, 1fr) auto; align-items: center; column-gap: 14px; min-height: 48px; padding: 9px 10px; border-radius: 6px; color: #efe7d6; text-decoration: none; transition: background-color .2s ease; }
.ffd-page--library .lb-roomlist .lb-rt { grid-column: 1; font: 600 14.5px/1.3 var(--f-display); letter-spacing: .015em; color: #efe7d6; transition: color .2s ease; }
.ffd-page--library .lb-roomlist .lb-rl { grid-column: 1; margin-top: 2px; font: italic 500 14.5px/1.35 var(--f-aside); color: #b9ad95; text-wrap: pretty; }
.ffd-page--library .lb-roomlist .lb-rd { grid-column: 2; grid-row: 1 / span 2; width: 6px; height: 6px; transform: rotate(45deg); background: #c8a45e; opacity: .45; transition: opacity .2s ease, box-shadow .2s ease; }
.ffd-page--library .lb-roomlist a:hover { background: rgba(200, 164, 94, .05); }
.ffd-page--library .lb-roomlist a:hover .lb-rt { color: #f3dfa8; }
.ffd-page--library .lb-roomlist a:hover .lb-rd { opacity: 1; box-shadow: 0 0 8px rgba(232, 198, 116, .7); }
.ffd-page--library .lb-roomlist a:focus-visible { outline: 2px solid #7ee6df; outline-offset: -2px; }
@media (min-width: 720px) { .ffd-page--library .lb-roomlist { grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 28px; } }

/* the poster: the Character Quest's WANTED posting over the whole window (on document.body, like core's .ffd-overlay).
   The values are the quest's own (assets/quest-one-v2.css: .qo-parch.qo-poster :783-806 and its phone sizes :2176-2187,
   the seal :1554-1556, the likeness sketch :2304-2315, the lead line .qo-story :90 with .qo-accent :1261, the button
   .qo-btn :103). Decorative layers are <i>, never empty divs (the store's theme hides div:empty) */
html.lbp-open, html.lbp-open body { overflow: hidden; }
.lbp { position: fixed; inset: 0; z-index: 90; display: grid; place-items: center; box-sizing: border-box; overflow-x: hidden; overflow-y: auto; overscroll-behavior: contain; padding: calc(env(safe-area-inset-top, 0px) + 20px) 16px calc(env(safe-area-inset-bottom, 0px) + 24px); background: radial-gradient(90% 70% at 50% 42%, rgba(24, 22, 36, .84), rgba(5, 5, 10, .95) 76%); color: #e8e0d0; text-align: center; letter-spacing: normal; -webkit-tap-highlight-color: transparent; opacity: 0; transition: opacity .26s ease; }
.lbp *, .lbp *::before, .lbp *::after { box-sizing: border-box; }
.lbp.is-in { opacity: 1; }
.lbp.is-out { opacity: 0; transition-duration: .22s; pointer-events: none; }
.lbp .lbp-main { display: flex; flex-direction: column; align-items: center; width: min(100%, 420px); }
.lbp .lbp-lead { margin: 0; font: 500 20px/1.55 'Cormorant Garamond', Georgia, serif; color: #efe6d4; text-shadow: 0 1px 2px rgba(0, 0, 0, .9), 0 0 18px rgba(0, 0, 0, .85); transition: opacity .25s ease; }
.lbp .lbp-lead b { font-weight: 700; color: #f4dc9c; }
.lbp .lbp-wrap { display: flex; justify-content: center; margin: 18px 0 12px; filter: drop-shadow(0 18px 24px rgba(0, 0, 0, .6)); }
.lbp .lbp-poster { position: relative; display: block; width: min(80vw, 306px); margin: 0; padding: 30px 16px 20px; text-align: center; color: #2a1a0e;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='3' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 .32 0 0 0 0 .2 0 0 0 0 .08 0 0 0 .34 0'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>"),
    radial-gradient(ellipse at 12% 8%,rgba(122,78,30,.24),transparent 36%),
    radial-gradient(ellipse at 90% 94%,rgba(110,66,22,.28),transparent 40%),
    radial-gradient(ellipse at 58% 34%,rgba(255,250,232,.42),transparent 55%),
    linear-gradient(172deg,#f2e5c4 0%,#e4d1a2 55%,#cfb47c 100%);
  box-shadow: inset 0 0 44px rgba(92, 56, 20, .46), inset 0 0 8px rgba(60, 35, 10, .55);
  clip-path: polygon(0% 1.6%,5% 0.2%,11% 1.4%,18% 0%,26% 1.1%,33% 0.2%,41% 1.5%,49% 0.3%,57% 1.2%,64% 0%,72% 1.4%,80% 0.4%,88% 1.3%,95% 0%,100% 1.2%,99.3% 11%,100% 22%,99.1% 34%,100% 47%,99.2% 60%,100% 73%,99.1% 86%,100% 98.6%,94% 100%,86% 98.7%,78% 100%,70% 98.9%,61% 100%,53% 98.6%,45% 99.9%,37% 98.8%,28% 100%,20% 98.7%,12% 99.9%,5% 98.8%,0% 100%,0.8% 88%,0% 75%,0.9% 62%,0% 49%,0.8% 36%,0% 24%,0.9% 12%);
  transform: rotate(-1.4deg); animation: lbpIn .7s cubic-bezier(.2, .7, .2, 1) both; }
.lbp .lbp-nail { position: absolute; top: 9px; display: block; width: 12px; height: 12px; margin-left: -6px; border-radius: 50%; background: radial-gradient(circle at 35% 30%, #d6d0c4, #6e685e 52%, #2b2824); box-shadow: 0 2px 3px rgba(0, 0, 0, .55), 0 0 0 3px rgba(92, 56, 20, .2); }
.lbp .lbp-rule { display: block; height: 5px; margin: 6px 2px; border-top: 2px solid #3a2311; border-bottom: 1px solid #3a2311; }
.lbp .lbp-h { margin: 4px 0; font: 900 clamp(36px, 12.5vw, 52px)/1 'Cinzel', Georgia, 'Times New Roman', serif; letter-spacing: .1em; text-transform: uppercase; white-space: nowrap; color: #5b1d10; text-shadow: 0 1px 0 rgba(255, 244, 214, .5); }
.lbp .lbp-sub { margin: 10px auto; max-width: 28ch; font: 700 12px/1.45 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif; letter-spacing: .14em; text-transform: uppercase; color: #3a2311; text-wrap: balance; }
.lbp .lbp-face { display: flex; flex-direction: column; align-items: center; gap: 4px; width: 50px; margin: 0 auto 12px; }
.lbp .lbp-face svg { display: block; width: 100%; height: auto; overflow: visible; }
.lbp .lbp-face small { font: 700 7.5px/1 'Inter', system-ui, sans-serif; letter-spacing: .14em; text-transform: uppercase; color: #5a3a1c; }
.lbp .qo-sk-frame{fill:rgba(92,58,24,.07);stroke:#3a2311;stroke-width:1.1;stroke-linejoin:round;opacity:.8}
.lbp .qo-sk-frame2{fill:none;stroke:#3a2311;stroke-width:.5;opacity:.45}
.lbp .qo-sk-bg{fill:none;stroke:#5a3a1c;stroke-width:.55;stroke-linecap:round;opacity:.17}
.lbp .qo-sk-base{fill:#e3d3ac}
.lbp .qo-sk-hatch{fill:none;stroke:#2b1a0d;stroke-width:.7;stroke-linecap:round;opacity:.76}
.lbp .qo-sk-line{fill:none;stroke:#24160b;stroke-width:1.15;stroke-linejoin:round;stroke-linecap:round;opacity:.9}
.lbp .qo-sk-line2{fill:none;stroke:#3a2311;stroke-width:.6;stroke-linejoin:round;opacity:.5}
.lbp .qo-sk-q{fill:none;stroke:#5b1d10;stroke-width:3.3;stroke-linecap:round;stroke-linejoin:round}
.lbp .qo-sk-q2{fill:none;stroke:#5b1d10;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;opacity:.45}
.lbp .qo-sk-dot{fill:#5b1d10}
/* the second stroke of the sketch's question mark sits a hair off the first (the quest's own offset) */
.lbp .qo-sk-q2 { transform: translate(-.35px, .25px); }
.lbp .lbp-body { margin: 0 auto 10px; padding: 0 2px; font: 600 17px/1.34 'Cormorant Garamond', Georgia, serif; color: #24160b; text-wrap: balance; }
.lbp .lbp-reward { display: flex; flex-direction: column; align-items: center; gap: 3px; margin: 2px 0 8px; }
.lbp .lbp-reward small { font: 700 11.5px/1 'Inter', system-ui, sans-serif; letter-spacing: .32em; text-transform: uppercase; color: #3a2311; }
.lbp .lbp-reward b { font: 900 34px/1 'Cinzel', Georgia, serif; letter-spacing: .04em; color: #5b1d10; }
.lbp .lbp-foot { display: flex; align-items: center; justify-content: center; gap: 10px; margin-top: 4px; }
.lbp .lbp-foot > span { max-width: 20ch; font: italic 500 14.5px/1.25 'Cormorant Garamond', Georgia, serif; color: #4a2f16; text-align: right; }
.lbp .lbp-seal { position: relative; flex: none; display: grid; place-items: center; width: 50px; height: 50px; font-style: normal; transform: rotate(-12deg); filter: drop-shadow(0 2px 1.5px rgba(40, 10, 4, .55));
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'><defs><radialGradient id='w' cx='36%25' cy='30%25' r='72%25'><stop offset='0' stop-color='%23e46a5c'/><stop offset='.42' stop-color='%23b3322a'/><stop offset='.78' stop-color='%23791812'/><stop offset='1' stop-color='%23500d08'/></radialGradient><radialGradient id='p' cx='50%25' cy='44%25' r='60%25'><stop offset='0' stop-color='%23a52a21'/><stop offset='1' stop-color='%23861d16'/></radialGradient></defs><path fill='url(%23w)' d='M61.7 32C62 34.1 61.6 36.6 60.8 38.6C59.9 40.5 57.8 42.1 56.5 43.8C55.3 45.6 54.3 47.1 53.4 49.1C52.5 51.1 52.7 54.8 51.1 56C49.5 57.1 45.8 55.8 43.6 56.1C41.4 56.4 39.8 57.4 37.9 57.7C35.9 58.1 33.9 58.5 32 58.4C30.1 58.3 28.3 57.2 26.3 57C24.3 56.7 22.2 57 20 56.8C17.8 56.7 14.9 56.8 13 55.8C11.2 54.7 9.8 52.5 8.7 50.5C7.7 48.6 7.5 46.2 6.6 44.2C5.6 42.3 2.9 40.7 2.9 38.6C2.9 36.6 6 34.1 6.7 32C7.4 29.9 7.1 28.3 7.1 26.3C7.2 24.3 6.4 21.9 7 20C7.5 18 9.1 16.3 10.4 14.8C11.8 13.3 13.6 12.3 15.2 10.9C16.7 9.5 18 7.7 19.7 6.5C21.5 5.4 23.6 5.1 25.6 4.1C27.7 3.2 29.8 .9 32 .8C34.2 .7 36.6 2.3 38.5 3.3C40.5 4.4 42.4 5.7 43.9 7.3C45.4 8.9 46 11.3 47.3 12.8C48.6 14.3 50.3 15 51.7 16.3C53.2 17.5 54.9 18.8 56.1 20.4C57.3 22 58.1 23.9 59.1 25.8C60 27.8 61.4 29.9 61.7 32Z'/><circle cx='32' cy='30.5' r='18.5' fill='url(%23p)'/><circle cx='32' cy='30.5' r='18.5' fill='none' stroke='%234a0a06' stroke-opacity='.6' stroke-width='2.4'/><circle cx='32.8' cy='31.6' r='19.6' fill='none' stroke='%23ff9e8c' stroke-opacity='.32' stroke-width='1'/><circle cx='32' cy='30.5' r='14.6' fill='none' stroke='%234a0a06' stroke-opacity='.35' stroke-width='.8' stroke-dasharray='1.4 1.6'/><ellipse cx='21' cy='15' rx='7.5' ry='3.2' fill='%23fff' fill-opacity='.24' transform='rotate(-32 21 15)'/></svg>") center/contain no-repeat; }
.lbp .lbp-seal b { margin-top: -2px; font: 900 17px/1 'Cinzel', Georgia, serif; color: #5e0e09; text-shadow: 0 1px 0 rgba(255, 160, 140, .38), 0 -1px 0 rgba(40, 0, 0, .55); }
.lbp .lbp-take { display: inline-flex; align-items: center; justify-content: center; width: 100%; max-width: 360px; min-height: 52px; margin: 8px 0 0; padding: 10px 26px; border: 1px solid #c9a84c; border-radius: 12px; background: linear-gradient(180deg, #e8c674, #c9a84c); color: #1a1206; font: 700 15px/1.18 'Cinzel', Georgia, serif; letter-spacing: .06em; text-transform: none; cursor: pointer; box-shadow: 0 6px 24px rgba(201, 168, 76, .22), inset 0 1px 0 rgba(255, 255, 255, .35); transition: transform .12s, filter .2s, opacity .25s ease; -webkit-user-select: none; user-select: none; }
.lbp .lbp-take:hover { filter: brightness(1.06); }
.lbp .lbp-take:active { transform: scale(.98); }
.lbp .lbp-take:focus-visible, .lbp .lbp-stay:focus-visible { outline: 2px solid #f4dc9c; outline-offset: 3px; }
.lbp .lbp-stay { min-height: 44px; margin: 6px 0 0; padding: 0 14px; border: 0; background: none; color: #d9cfbd; font: italic 500 17px/1.3 var(--f-aside, 'Cormorant Garamond', Georgia, serif); text-decoration: underline; text-underline-offset: 4px; text-decoration-color: rgba(231, 201, 127, .5); cursor: pointer; transition: opacity .25s ease; }
.lbp.is-taken .lbp-poster { animation: lbpTake .68s cubic-bezier(.5, 0, .75, 0) forwards; }
.lbp.is-taken .lbp-take, .lbp.is-taken .lbp-stay, .lbp.is-taken .lbp-lead { opacity: 0; pointer-events: none; }
@keyframes lbpIn { from { opacity: 0; transform: translateY(26px) rotate(3deg); } to { opacity: 1; transform: rotate(-1.4deg); } }
@keyframes lbpTake { 0% { opacity: 1; transform: rotate(-1.4deg); } 24% { opacity: 1; transform: translate(-4px, -16px) rotate(-5deg); } 100% { opacity: 0; transform: translate(46px, 130px) rotate(16deg) scale(.86); } }
@media (max-height: 700px) {
  .lbp .lbp-wrap { margin: 10px 0 6px; }
  .lbp .lbp-poster { width: min(74vw, 282px); padding: 22px 14px 16px; }
  .lbp .lbp-h { font-size: clamp(30px, 9vw, 40px); }
  .lbp .lbp-face { width: 40px; margin-bottom: 6px; }
  .lbp .lbp-face small { display: none; }
  .lbp .lbp-body { font-size: 16px; line-height: 1.3; margin-bottom: 6px; }
  .lbp .lbp-reward b { font-size: 28px; }
}
/* a reader who already went after her: a third, quiet way, to Zhaunil's ledger */
.lbp .lbp-went { margin-top: 0; font-size: 16px; color: #bfb39e; }
/* the posting for a reader who took the Quest. The Iron Matron's likeness (the Quest's own art, QOArt.mountMatron) inks
   into the sketch's frame in sepia, two red strokes cross her out, the stamp lands, and the reward says who was paid */
.lbp .lbp-face.is-done { width: 84px; gap: 5px; }
.lbp .lbp-lk { position: relative; display: block; width: 100%; aspect-ratio: 72 / 84; }
.lbp .lbp-lk > svg { position: absolute; inset: 0; width: 100%; height: 100%; }
.lbp .lbp-mat { position: absolute; left: 7.6%; top: 6.6%; right: 7.6%; bottom: 6.4%; overflow: hidden; mix-blend-mode: multiply; opacity: 0; }
.lbp .lbp-mat-in { position: absolute; width: 270%; left: -85%; top: -3%; }
.lbp .lbp-mat canvas { filter: grayscale(1) sepia(1) saturate(1.3) hue-rotate(-8deg) contrast(1.3) brightness(1.02); }
.lbp.has-mat .lbp-mat { opacity: 1; }
.lbp.has-mat .lbp-lk .qo-sk-q, .lbp.has-mat .lbp-lk .qo-sk-q2, .lbp.has-mat .lbp-lk .qo-sk-dot, .lbp.has-mat .lbp-lk .qo-sk-hatch, .lbp.has-mat .lbp-lk .qo-sk-line, .lbp.has-mat .lbp-lk .qo-sk-line2 { opacity: 0; transition: opacity .6s ease .9s; }
.lbp .lbp-x { position: absolute; left: 4%; top: 5%; width: 92%; height: 90%; overflow: visible; pointer-events: none; }
.lbp .lbp-x path { fill: none; stroke: #ad241a; stroke-width: 4px; stroke-linecap: round; vector-effect: non-scaling-stroke; stroke-dasharray: 1; stroke-dashoffset: 0; }
.lbp .lbp-reward.is-paid b { text-decoration: line-through; text-decoration-thickness: 2px; text-decoration-color: rgba(122, 26, 16, .75); }
.lbp .lbp-paid { display: block; max-width: 24ch; margin: 5px auto 0; font: italic 700 16px/1.2 'Cormorant Garamond', Georgia, serif; color: #7a1a10; text-wrap: balance; overflow-wrap: anywhere; }
.lbp .lbp-stamp { position: absolute; left: 50%; top: 68%; z-index: 3; display: block; padding: 6px 12px 5px; border: 4px double #ab2419; border-radius: 5px; background: rgba(246, 232, 200, .34); color: #ab2419; font: 900 22px/1 'Cinzel', Georgia, serif; letter-spacing: .12em; text-transform: uppercase; white-space: nowrap; text-shadow: 0 0 1px rgba(255, 244, 220, .6); transform: translate(-50%, -50%) rotate(-12deg); opacity: .92; pointer-events: none; }
.lbp .lbp-dot { position: absolute; display: block; width: 4px; height: 4px; border-radius: 50%; background: #a3221a; opacity: .7; pointer-events: none; }
.lbp .lbp-btns { display: flex; flex-direction: column; align-items: center; width: 100%; }
.lbp.is-moment .lbp-mat { -webkit-mask-image: linear-gradient(to bottom, #000 0 40%, transparent 60% 100%); mask-image: linear-gradient(to bottom, #000 0 40%, transparent 60% 100%); -webkit-mask-size: 100% 250%; mask-size: 100% 250%; -webkit-mask-repeat: no-repeat; mask-repeat: no-repeat; animation: lbpInk .9s ease-out .75s both; }
.lbp.is-moment .lbp-x1 { animation: lbpStroke .22s ease-in 1.72s both; }
.lbp.is-moment .lbp-x2 { animation: lbpStroke .22s ease-in 1.98s both; }
.lbp.is-moment .lbp-stamp { animation: lbpStamp .38s cubic-bezier(.3, .8, .35, 1) 2.32s both; }
.lbp.is-moment .lbp-wrap { animation: lbpShake .24s ease-out 2.52s; }
.lbp.is-moment .lbp-dot { animation: lbpDot .3s ease-out 2.54s both; }
/* nothing gives the ending away early: the strike through the reward draws as the stamp lands, and her name comes
   under the frame once her face has inked in (keyframes, because both are made already set) */
.lbp.is-moment .lbp-reward.is-paid b { animation: lbpStrike .3s ease 2.6s both; }
.lbp.is-moment .lbp-face small { animation: lbpCap .3s ease 1.5s both; }
@keyframes lbpStrike { from { text-decoration-color: transparent; } }
@keyframes lbpCap { from { opacity: 0; } }
.lbp.is-moment .lbp-paid { animation: lbpUp .4s ease 2.72s both; }
.lbp.is-moment .lbp-btns { animation: lbpUp .4s ease 2.95s both; }
.lbp.is-moment:not(.is-landed) .lbp-btns { pointer-events: none; }
@keyframes lbpInk { from { -webkit-mask-position: 0 100%; mask-position: 0 100%; } to { -webkit-mask-position: 0 0; mask-position: 0 0; } }
@keyframes lbpStroke { from { stroke-dashoffset: 1; } to { stroke-dashoffset: 0; } }
@keyframes lbpStamp { 0% { opacity: 0; transform: translate(-50%, -50%) rotate(-12deg) scale(1.5); } 60% { opacity: .92; transform: translate(-50%, -50%) rotate(-12deg) scale(.97); } 100% { opacity: .92; transform: translate(-50%, -50%) rotate(-12deg) scale(1); } }
@keyframes lbpShake { 0%, 100% { transform: translate(0, 0); } 25% { transform: translate(-3px, 1px); } 55% { transform: translate(3px, -1px); } 80% { transform: translate(-1px, 0); } }
@keyframes lbpDot { from { opacity: 0; transform: scale(.2); } to { opacity: .7; transform: scale(1); } }
@keyframes lbpUp { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }
/* a phone on its side: the buttons beside the paper (both postings), so they are in view while the paper scrolls */
@media (max-height: 520px) and (orientation: landscape) {
  .lbp .lbp-main { flex-direction: row; flex-wrap: wrap; justify-content: center; align-items: flex-start; column-gap: 28px; width: min(100%, 760px); }
  .lbp .lbp-lead { flex: 0 0 100%; }
  .lbp .lbp-btns { position: sticky; top: calc(50vh - 60px); width: 290px; margin-top: 18px; }
}
@media (max-height: 700px) {
  .lbp .lbp-face.is-done { width: 66px; }
  .lbp .lbp-stamp { font-size: 19px; }
  .lbp .lbp-paid { font-size: 15px; }
}
@media (prefers-reduced-motion: reduce) {
  .lbp, .lbp.is-out { transition-duration: .12s; }
  .lbp .lbp-poster, .lbp.is-taken .lbp-poster { animation: none; }
  .lbp.is-moment .lbp-mat, .lbp.is-moment .lbp-x path, .lbp.is-moment .lbp-stamp, .lbp.is-moment .lbp-wrap, .lbp.is-moment .lbp-dot, .lbp.is-moment .lbp-paid, .lbp.is-moment .lbp-btns, .lbp.is-moment .lbp-reward.is-paid b, .lbp.is-moment .lbp-face small { animation: none; -webkit-mask-image: none; mask-image: none; }
  .lbp.has-mat .lbp-lk .qo-sk-q, .lbp.has-mat .lbp-lk .qo-sk-q2, .lbp.has-mat .lbp-lk .qo-sk-dot, .lbp.has-mat .lbp-lk .qo-sk-hatch, .lbp.has-mat .lbp-lk .qo-sk-line, .lbp.has-mat .lbp-lk .qo-sk-line2 { transition: none; }
}
/* the full-screen room (data-ffd-full, Jan 2026-10-07): the frame is the screen, the art pans sideways inside .lb-pan
   on an upright phone (the same wide room as a laptop), the page takes the record's ink, and the room list stays for
   screen readers and search only */
.ffd-page--library[data-ffd-full] .ffs.ffs { display: block; height: 100svh; min-height: 0; max-height: none; transition: background-color 1.4s ease; }
.ffd-page--library[data-ffd-full] { transition: background-color 1.4s ease; }
.ffd-page--library[data-ffd-full] .lb-pan { position: absolute; inset: 0; z-index: 1; overflow-x: auto; overflow-y: hidden; scrollbar-width: none; overscroll-behavior-x: contain; -webkit-overflow-scrolling: touch; }
.ffd-page--library[data-ffd-full] .lb-pan::-webkit-scrollbar { display: none; }
.ffd-page--library[data-ffd-full] .lb-pan.is-drag { cursor: grabbing; }
.ffd-page--library[data-ffd-full] .lb-pan .ffs-art.ffs-art { position: relative; inset: auto; top: auto; right: auto; bottom: auto; left: auto; transform: none; height: 100%; width: auto; max-width: none; min-width: 100%; aspect-ratio: 16 / 10; margin: 0 auto; }
.ffd-page--library[data-ffd-full] .ffs > .ffs-top { justify-content: flex-end; }
@media (hover: hover) and (pointer: fine) { .ffd-page--library[data-ffd-full] .lb-pan .ffs-art.ffs-art { aspect-ratio: 13 / 10; } }
.ffd-page--library[data-ffd-full] > .ffd-after { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); clip-path: inset(50%); white-space: nowrap; }
.ffd-page--library .lb-plate { position: absolute; left: 50%; top: 14px; z-index: 5; transform: translate(-50%, -6px); padding: 7px 16px 6px; border-radius: 6px; background: rgba(10, 8, 6, .82); border: 1px solid rgba(231, 201, 127, .28); border-bottom: 2px solid var(--pc, #e8a85a); font: 600 12px/1.2 var(--f-display); letter-spacing: .14em; text-transform: uppercase; color: #fff3d6; white-space: nowrap; opacity: 0; pointer-events: none; transition: opacity .32s ease, transform .32s ease; }
.ffd-page--library .lb-plate.is-on { opacity: 1; transform: translate(-50%, 0); }
/* the browser held the music back (the gate's 'silent' way, or a refused record): a small plate beside the sound
   button, top right, until the first press */
.ffd-page--library .lb-mplate { position: absolute; right: 64px; top: 16px; z-index: 5; transform: translateY(-6px); max-width: calc(100% - 84px); padding: 8px 16px; border-radius: 16px; background: rgba(10, 8, 6, .82); border: 1px solid rgba(231, 201, 127, .3); color: #f3e6c8; font: italic 500 15px/1.25 var(--f-aside); white-space: nowrap; opacity: 0; pointer-events: none; transition: opacity .28s ease, transform .28s ease; }
.ffd-page--library .lb-mplate.is-on { opacity: 1; transform: none; }
.ffd-page--library .lb-panhint { position: absolute; left: 50%; top: 13%; z-index: 5; transform: translate(-50%, -4px); width: max-content; max-width: 84%; padding: 8px 16px; border-radius: 16px; background: rgba(10, 8, 6, .8); border: 1px solid rgba(231, 201, 127, .3); color: #f3e6c8; font: italic 500 16px/1.3 var(--f-aside); text-align: center; opacity: 0; pointer-events: none; transition: opacity .4s ease, transform .4s ease; }
.ffd-page--library .lb-panhint.is-on { opacity: 1; transform: translate(-50%, 0); }
.ffd-page--library .lb-panhint b { font-style: normal; color: var(--gold-hi, #e7c97f); font-weight: 500; }
/* on the floor above the words, clear of the poster, the jukebox's face and the skull's shelf */
.ffd-page--library .lb-panhint.is-turn { top: 70%; display: flex; align-items: center; gap: 14px; text-align: left; }
.ffd-page--library .lb-panhint.is-turn span { text-wrap: balance; }
.ffd-page--library .lb-turn { display: none; flex: none; position: relative; width: 16px; height: 26px; border: 2px solid var(--gold-hi, #e7c97f); border-radius: 4px; animation: lb-turn 2.8s ease-in-out infinite; }
.ffd-page--library .lb-turn::after { content: ''; position: absolute; left: 50%; bottom: 2px; width: 4px; height: 2px; margin-left: -2px; border-radius: 1px; background: var(--gold-hi, #e7c97f); }
.ffd-page--library .lb-panhint.is-turn .lb-turn { display: block; }
@keyframes lb-turn { 0%, 25% { transform: rotate(0); } 50%, 80% { transform: rotate(-90deg); } 100% { transform: rotate(0); } }
@media (prefers-reduced-motion: reduce) { .ffd-page--library .lb-plate, .ffd-page--library .lb-mplate, .ffd-page--library .lb-panhint { transition-duration: .01s; } .ffd-page--library .lb-turn { animation: none; } }
`;

  FFD.page({
    id: ID, order: 0.5, section: 'new', kind: 'toy',
    title: 'Zhaunil’s library',
    hook: 'The Guide’s books, the Hall’s cards and the scenes to play, all in one candlelit room.',
    thumb: { key: KEY },
    async render(ctx) {
      const h = FFD.h, title = this.title;
      if (!document.getElementById('ffd-css-' + ID)) document.head.append(h('style', { id: 'ffd-css-' + ID, text: CSS }));
      const st = store();
      st.visits += 1; keep(st);
      const firstVisit = st.visits === 1;
      const backFrom = doorTake();
      const heroOf = (slug) => (window.FFD_HEROES || []).find((x) => x && x.slug === slug) || null;
      const zh = heroOf('zhaunil'), em = heroOf('ember');
      /* on the store the portraits come only from the theme's own assets, never a demo path */
      const ZH = SITE ? { name: 'Zhaunil', img: (SITE.portraits && SITE.portraits.zhaunil) || null } : { name: 'Zhaunil', img: (zh && zh.img) || 'img/heroes/zhaunil.jpg' };
      const JAN = SITE ? { name: 'Jan', img: (SITE.portraits && SITE.portraits.ember) || null } : { name: 'Jan', img: (em && em.img) || 'img/heroes/ember.jpg' };
      let cycle = {};
      const next = (k, list) => { cycle[k] = ((cycle[k] == null ? -1 : cycle[k]) + 1) % list.length; return list[cycle[k]]; };

      /* ================= the books ================= */
      const books = [], shelf = {}, byH = new Map(), pfKnown = new Map();
      BAYS.forEach((k) => { shelf[k] = []; });
      let libState = 'idle', allDone = false, libPages = 1, guideCount = SITE && SITE.guide ? (+SITE.guide.count || 0) : 0;
      const pickSet = new Set(PICKS);
      function addBooks(list) {
        (list || []).forEach((x) => {
          /* the store's article.handle carries its blog in front ("character-commission-blog/<handle>"): the book's own
             handle is the last part, the same as the demo's and Jan's picks */
          const hd = x && x.h ? String(x.h).split('/').pop() : '';
          if (!x || !hd || !x.t || !(+x.w > 80) || byH.has(hd)) return;
          const b = {
            h: hd, t: String(x.t).replace(/&amp;/g, '&'), d: x.d ? String(x.d) : '', m: +x.m || 0, w: +x.w || 0, dt: String(x.dt || '').slice(0, 10),
            k: BAYS.includes(x.k) ? x.k : 'character', alt: x.alt ? String(x.alt) : '', cw: +x.cw || 0, ch: +x.ch || 0, u: String(x.u || ''),
            c: x.c || null, f: x.f || null, ci: x.ci != null ? +x.ci : -1, b: x.b, i: Array.isArray(x.i) ? x.i : [], pf: x.pf === true ? true : (x.pf === false ? false : null)
          };
          books.push(b); byH.set(b.h, b); shelf[b.k].push(b);
        });
        twins(books);
        books.forEach((b) => { b.pick = pickSet.has(b.h); });
      }
      /* a load that failed is never kept: the tap that failed shows the fallback, and the next tap asks again */
      let p1 = null, pAll = null;
      const libFirst = () => p1 || (p1 = (async () => {
        libState = 'loading';
        try {
          if (!SITE) {
            const D = await demoData();
            addBooks(D.books || []);
            guideCount = books.length;
            allDone = true;
          } else {
            const j = await getJSON(withQuery(SITE.guide.index, 'page=1'));
            libPages = Math.max(1, +j.pages || 1);
            if (+j.total) guideCount = guideCount || +j.total;
            addBooks(Array.isArray(j.books) ? j.books : []);
            if (libPages <= 1) allDone = true;
          }
          libState = books.length ? 'ok' : 'fail';
        } catch (e) { libState = books.length ? 'ok' : 'fail'; }
        return books;
      })().then((r) => { if (!books.length) { p1 = null; pAll = null; } return r; }));
      const libAll = () => pAll || (pAll = libFirst().then(async () => {
        let missed = false;
        if (SITE && libState === 'ok' && !allDone) {
          const rest = [];
          for (let n = 2; n <= libPages; n++) rest.push(getJSON(withQuery(SITE.guide.index, 'page=' + n)).then((j) => (Array.isArray(j.books) ? j.books : [])).catch(() => { missed = true; return []; }));
          const lists = await Promise.all(rest);
          lists.forEach((l) => addBooks(l));
          if (!missed) allDone = true;
        }
        if (ctx.alive() && sceneOk && books.length) { F.set('shelves', counts()); F.set('read', readMap()); }
        if (!books.length || missed) pAll = null;
        return books;
      }));

      /* the store's article view: { h, t, b, pf }, cleaned here; a pf book opens with its cover, title and the link */
      const reads = new Map();
      function readOf(b) {
        if (!SITE) return Promise.resolve(null);
        if (reads.has(b.h)) return reads.get(b.h);
        const p = getJSON(withQuery(b.u, String(SITE.guide.read || '?view=ffd-data-read').replace(/^\?/, '')))
          .then((j) => { const pf = j.pf === true; pfKnown.set(b.h, pf); if (pf) b.pf = true; return { html: pf ? '' : cleanBody(j.b), pf }; })
          .catch(() => { reads.delete(b.h); return null; });
        reads.set(b.h, p);
        return p;
      }
      const isPf = (b) => b.pf === true || pfKnown.get(b.h) === true;
      /* the text for the book: { html, pf } or null. The demo's pictures come as scripts: each img[data-i] takes its
         file's picture, or goes */
      function textFor(b) {
        if (SITE) return readOf(b);
        const files = [loadFile(BASE() + 't-' + b.b + '.js')].concat(b.i.map((n) => loadFile(BASE() + 'i-' + n + '.js')));
        return Promise.all(files).then(() => {
          const t = textOf(b.h);
          if (t == null) return null;
          const tpl = document.createElement('template');
          tpl.innerHTML = t;
          tpl.content.querySelectorAll('img[data-i]').forEach((im) => {
            const u = picOf(+im.getAttribute('data-i'));
            if (!u) { im.remove(); return; }
            im.setAttribute('src', u); im.removeAttribute('data-i'); im.setAttribute('loading', 'lazy'); im.setAttribute('decoding', 'async');
          });
          return { html: tpl.innerHTML, pf: false };
        });
      }
      /* a cover: the store's picture at the width asked, or the demo's own (its first picture file holds it) */
      function coverOf(b, w) {
        if (SITE) return Promise.resolve(b.c ? sized(b.c, w || 800) : null);
        if (!(b.ci >= 0)) return Promise.resolve(null);
        const have = picOf(b.ci); if (have) return Promise.resolve(have);
        return (b.i.length ? loadFile(BASE() + 'i-' + b.i[0] + '.js') : Promise.resolve()).then(() => picOf(b.ci) || (b.i.length > 1 ? Promise.all(b.i.slice(1).map((n) => loadFile(BASE() + 'i-' + n + '.js'))).then(() => picOf(b.ci)) : null));
      }

      /* ---- what the scene shows: spines, ribbons, the ledger ---- */
      const counts = () => { const o = {}; BAYS.forEach((k) => { o[k] = shelf[k].length; }); return o; };
      const readMap = () => { const o = {}; BAYS.forEach((k) => { o[k] = []; }); st.read.forEach((hd) => { const b = byH.get(hd); if (b) o[b.k].push(shelf[b.k].indexOf(b)); }); return o; };
      const ledger = () => { const o = {}; BAYS.forEach((k) => { o[k] = FFD.tally.total(ID, 'w-' + k); }); return o; };

      /* ---- choosing a book (the owl, Zhaunil, the cat) ---- */
      const twinsOf = (list) => new Set(list.map((hd) => byH.get(hd)).filter(Boolean).map((b) => b.g));
      function candidates(bay) {
        let pool = (bay ? shelf[bay] : books).filter((b) => !isPf(b));
        if (!pool.length) pool = (bay ? shelf[bay] : books).slice();
        const readG = twinsOf(st.read), seenG = twinsOf(st.seen.slice(-12));
        let fresh = pool.filter((b) => !readG.has(b.g) && !seenG.has(b.g));
        if (!fresh.length) fresh = pool.filter((b) => !st.read.includes(b.h) && st.seen[st.seen.length - 1] !== b.h);
        if (!fresh.length) fresh = pool.filter((b) => st.seen[st.seen.length - 1] !== b.h);
        return fresh.length ? fresh : pool;
      }
      function weight(b, o) {
        const age = Math.max(0, (Date.now() - Date.parse(b.dt + 'T12:00:00Z')) / 864e5) || 400;
        let w = 1 + 1.4 * Math.exp(-age / 300);
        if (b.w >= 700 && b.w <= 2600) w *= 1.3; else if (b.w < 450) w *= 0.6;
        const mo = new Date().getMonth(), gifty = mo >= 9;
        if (b.k === 'gifts' && gifty && !o.bay) w *= 1.5;
        if (/father|dad\b/i.test(b.t)) w *= (mo === 4 || mo === 5) ? 2.2 : 0.4;
        if (/christmas|holiday/i.test(b.t)) w *= gifty ? 1.6 : 0.4;
        if (/\b2025\b/.test(b.t)) w *= 0.7;
        if (b.pick) w *= 1.3;
        if (o.char && b.k === 'character') w *= 1.3;
        return w;
      }
      function smart(o) {
        o = o || {};
        const list = candidates(o.bay);
        if (!list.length) return null;
        const ws = list.map((b) => weight(b, o)), sum = ws.reduce((a, x) => a + x, 0);
        let r = Math.random() * sum;
        for (let i = 0; i < list.length; i++) { r -= ws[i]; if (r <= 0) return list[i]; }
        return list[list.length - 1];
      }
      function janPick() {
        const picks = books.filter((b) => b.pick && !isPf(b));
        const fresh = picks.filter((b) => !st.read.includes(b.h) && st.seen[st.seen.length - 1] !== b.h);
        return pickOf(fresh.length ? fresh : picks) || smart();
      }
      function dusty() {
        const list = candidates(null).slice().sort((a, b) => a.dt.localeCompare(b.dt));
        return list[0] || smart();
      }
      /* your own words: every word (and a few it brings to mind) against each title, standfirst and shelf */
      function search(q) {
        const words = String(q || '').toLowerCase().replace(/[^a-z0-9& ]+/g, ' ').split(/\s+/).filter((w) => w && !QUIET.has(w));
        if (!words.length) return null;
        const terms = new Map();
        words.forEach((w) => { terms.set(w, 3); (SYN[w] || []).forEach((s) => { if (!terms.has(s)) terms.set(s, 1.6); }); if (w.endsWith('s') && w.length > 3) terms.set(w.slice(0, -1), 2.6); });
        let best = null, bestS = 0;
        books.forEach((b) => {
          if (isPf(b)) return;
          const t = b.t.toLowerCase(), d = (b.d || '').toLowerCase(), k = SHELF[b.k].ask.toLowerCase();
          let s = 0;
          terms.forEach((wt, w) => { const re = new RegExp('\\b' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')); if (re.test(t)) s += wt * 2; if (re.test(d)) s += wt; if (re.test(k)) s += wt * 0.6; });
          if (s > 0) { s *= 1 + 0.2 * Math.exp(-Math.max(0, (Date.now() - Date.parse(b.dt + 'T12:00:00Z')) / 864e5) / 300); if (st.read.includes(b.h)) s *= 0.5; }
          if (s > bestS) { bestS = s; best = b; }
        });
        return bestS >= 4 ? best : null;
      }

      /* ---- the contents' four ----
         For the whole Guide, the newest four in the Guide's own order. For a shelf, its newest unread (one of Jan's picks
         when one is unread) leads, then the next three unread, never near twins of each other or of a book already read;
         read ones fill in, newest first. A pf book never leads or fills a row. */
      function frontSel(bay) {
        const pool = (bay ? shelf[bay] : books).filter((b) => !isPf(b));
        if (!bay) return pool.slice(0, 4);
        const readG = twinsOf(st.read), out = [], gs = new Set();
        const take = (b) => { out.push(b); gs.add(b.g); };
        const unread = pool.filter((b) => !st.read.includes(b.h) && !readG.has(b.g));
        const lead = unread.find((b) => b.pick) || unread[0];
        if (lead) take(lead);
        unread.forEach((b) => { if (out.length < 4 && !out.includes(b) && !gs.has(b.g)) take(b); });
        pool.filter((b) => st.read.includes(b.h)).forEach((b) => { if (out.length < 4 && !out.includes(b) && !gs.has(b.g)) take(b); });
        pool.forEach((b) => { if (out.length < 4 && !out.includes(b)) take(b); });
        return out;
      }
      async function stories(bay) {
        await (bay ? libAll() : libFirst());
        if (!books.length) return null;
        let sel = frontSel(bay);
        /* on the store pf is known only from each article's view: look at the four chosen (it also warms the book) */
        for (let round = 0; SITE && round < 3; round++) {
          const unknown = sel.filter((b) => b.pf == null && !pfKnown.has(b.h));
          if (!unknown.length) break;
          await Promise.race([Promise.all(unknown.map(readOf)), sleep(1600)]);
          const again = frontSel(bay);
          if (again.map((b) => b.h).join() === sel.map((b) => b.h).join()) break;
          sel = again;
        }
        return sel.length ? sel : null;
      }
      /* every readable book on a shelf (or the whole Guide), newest first, for turning the contents' pages */
      async function shelfList(bay) {
        await libAll();
        return (bay ? shelf[bay] : books).filter((b) => !isPf(b)).slice().sort((a, b) => (b.dt || '').localeCompare(a.dt || ''));
      }

      /* ================= the frame ================= */
      /* the room's state is the flow that runs (one at a time), a game's words or question in the box (hold), a game
         that holds the room (the feather hunt), and a book asked for while the room was busy */
      let flow = null, hold = 0, gameHold = false, pendingBook = null, pendingFrom = '', sceneOk = false, cast = null, walkerIn = null, pendingArrival = false;
      /* a scene page's "sign Zhaunil's ledger" line brings the reader here to sign it (core.js FFD.ledgerIntent, taken once,
         10 minutes); a reader the room already knows skips it */
      let pendingLedger = false;
      try { pendingLedger = !!(typeof FFD.ledgerIntent === 'function' && FFD.ledgerIntent()); } catch (e) { pendingLedger = false; }
      let signLedger = null;
      /* the painter has one walker slot: whoever walks in next waits until the last one has gone (walkOutNow) */
      let walkerGone = Promise.resolve(), walkerLeaving = false;
      let book = null, cards = null, games = null, borders = null, lastTap = Date.now(), beaconLit = false;
      let music = null, moods = null, jukebox = null, waitlist = null, memories = null, fight = null, study = null, partHold = 0;
      let favorites = null, offer = null;
      /* the full-screen room (the section's full_screen setting): the Enter gate, the jukebox and its records */
      const FULL = !!(ctx.root && ctx.root.hasAttribute && ctx.root.hasAttribute('data-ffd-full'));
      const pBusy = (p) => { try { return !!(p && typeof p.busy === 'function' && p.busy()); } catch (e) { return false; } };
      const partsBusy = () => partHold > 0 || pBusy(favorites) || pBusy(offer) || pBusy(cards) || pBusy(waitlist) || pBusy(memories) || pBusy(fight) || pBusy(study) || pBusy(jukebox);
      const gBusy = () => { try { return !!(games && typeof games.busy === 'function' && games.busy()); } catch (e) { return false; } };
      const bBusy = () => { try { return !!(borders && borders.busy()); } catch (e) { return false; } };
      const free = () => !flow && !hold && !gameHold && !gBusy() && !bBusy() && !partsBusy();
      /* what the token borders wait on (library/borders.js) */
      const bnote = (what, d) => { try { if (borders) borders.note(what, d || {}); } catch (e) { /* fine */ } };
      /* a thing's own small answer in the art. A locked painting rattles its lock instead (the 'hot' poke would play an
         open painting's gilt pulse and chime) */
      const poke = (id) => {
        const m = /^paint-(.+)$/.exec(String(id || ''));
        if (m && lockOn(m[1])) { F.act('lock-rattle', { id: m[1] }); return; }
        F.act('hot', id);
      };
      /* every flow runs with a token: { name, dead, can, ends }. A dropped flow (dead) stops at its next await, because
         every await in a flow that can give way goes through step(), which throws HALT once the token is dead. can says
         whether a tap on another thing may drop it now; ends are its clean-ups when it is dropped (a walker walks out).
         Only the token that is current clears the room's state, so a dropped flow that finishes late (a 7 s F.once)
         never clears the flow that replaced it */
      const HALT = new Error('library flow gave way');
      let cur = null, gaveWay = 0, swap = null, want = null;
      function run(name, fn, ro) {
        if (!ctx.alive() || !free()) return false;
        const tok = cur = { name, dead: false, can: !(ro && ro.can === false), ends: [] };
        flow = name;
        hush();
        (async () => {
          try { await fn(tok); } catch (e) { if (e !== HALT) console.error(e); }
          finally { if (cur === tok) { cur = null; flow = null; if (ctx.alive()) { F.busy(false); drain(); if (!flow) tallOff(); } } }
        })();
        return true;
      }
      const step = async (tok, p) => { const v = await p; if (tok.dead || !ctx.alive()) throw HALT; return v; };
      /* the room gives way to a new tap: the running flow may be dropped (cur.can), or a game's words or question are in
         the box (hold); never while a game holds the room (the feather hunt, the journal, the relighting candles, the
         mimic's card) or a border card or the ring is open. Resolves when the box has faded (F.cancel, about 180 ms) */
      const canGive = () => !gameHold && !gBusy() && !bBusy() && !partsBusy() && (cur ? cur.can : hold > 0);
      function giveWay() {
        if (swap) return swap;
        if (!canGive()) return null;
        gaveWay++;
        const tok = cur;
        if (tok) {
          tok.dead = true; cur = null; flow = null;
          tok.ends.splice(0).reverse().forEach((f) => { try { f(); } catch (e) { console.error(e); } });
          F.busy(false);
        }
        asideOn = false;
        swap = F.cancel().then(() => { swap = null; });
        return swap;
      }
      /* a tap on a thing: its flow when the room is free. Otherwise the thing's own small answer in the art, and when the
         dialogue can give way it fades and the thing opens (the last thing tapped during the fade is the one that opens).
         The thing that started the running flow (the door while a walker visits) only answers in the art */
      /* the box names who speaks: a tap on that speaker while their line waits only continues (the first visit's intro
         never drops its second line because the reader touched Zhaunil) */
      const speaking = (name) => { try { const w = F.box && F.box.querySelector('.ffs-who'); return !!(w && !w.hidden && name && w.textContent.indexOf(name) >= 0); } catch (e) { return false; } };
      const tapTo = (id, name, fn, ro) => () => {
        if (!swap && run(name, fn, ro)) return;
        poke(id);
        if (cur && cur.name === name) return;
        if (id === 'zhaunil' && F.el.classList.contains('is-gate') && speaking(ZH.name)) return;
        const w = giveWay();
        if (!w) return;
        want = () => run(name, fn, ro);
        w.then(() => { const go = want; want = null; if (go && ctx.alive()) go(); });
      };
      const NOGIVE = { can: false };
      const roomHots = {
        owl: { label: 'Soryndel', tap: (() => { const t = tapTo('owl', 'owl', () => owlRead(), NOGIVE); return () => { if (jukebox && free() && jukebox.owlTap()) return; t(); }; })() },
        zhaunil: { label: 'Zhaunil', tap: tapTo('zhaunil', 'ask', (tok) => askZhaunil(tok)) },
        lectern: { label: 'The lectern', tap: tapTo('lectern', 'lectern', () => { poke('lectern'); return openContents(null); }, NOGIVE) },
        ledger: { label: 'Zhaunil’s ledger', tap: () => { bnote('ledger'); tapTo('ledger', 'ledger', () => { poke('ledger'); return aside(ledgerLine()); })(); } },
        window: { label: 'The window', tap: tapTo('window', 'aside', () => { poke('window'); return aside(next('window', L.window)); }) },
        ladder: { label: 'The ladder', tap: tapTo('ladder', 'aside', () => { poke('ladder'); return aside(next('ladder', L.ladder)); }) },
        deck: { label: 'The deck', tap: tapTo('deck', 'deck', () => drawCards(), NOGIVE) },
        binder: { label: 'The card binder', tap: tapTo('binder', 'binder', () => openBinder(), NOGIVE) },
        /* no 'gallery': the art's spot for the whole row lies over the paintings, and each painting is its own door */
        poster: { label: 'The poster', tap: tapTo('poster', 'poster', (tok) => posterFlow(tok), NOGIVE) },
        /* the easel holds Jan's favorite portraits (library/favorites.js); its "Ask Jan" brings Ember in to it */
        easel: { label: 'Jan’s favorite portraits', tap: tapTo('easel', 'heroes', (tok) => openHeroes(tok)) },
        artguide: { label: 'Jan’s guide to character art', tap: tapTo('artguide', 'artguide', () => { poke('artguide'); return openContents(null); }, NOGIVE) },
        door: { label: 'Unbound', tap: tapTo('door', 'unbound', (tok) => unboundFlow(tok)) },
        walker: { label: 'A visitor', tap: () => poke('walker') }
      };
      /* the book bays are the room's largest things (on an upright phone one fills the middle of the screen, right where a
         reader taps to read on). So while a line arrives or waits for its tap, a tap through the reading layer onto a bay
         only stirs it and the line reads on (core.js); the bay opens on a tap of its own. A bay chosen with the keyboard
         still opens */
      const reading = () => !!F.el && (F.el.classList.contains('is-gate') || F.el.classList.contains('is-reading'));
      const keyed = (id) => { const a = document.activeElement; return !!(a && a.getAttribute && a.getAttribute('data-hot') === id); };
      BAYS.forEach((k) => {
        const id = 'bay-' + k, t = tapTo(id, 'shelf', () => openShelf(k), NOGIVE);
        roomHots[id] = { label: SHELF[k].name, tap: () => { if (reading() && !keyed(id)) { poke(id); return; } t(); } };
      });
      const scenesHere = () => {
        if (SITE) {
          const have = SITE.scenes && typeof SITE.scenes === 'object' ? SITE.scenes : {};
          return SCENE_IDS.filter((id) => have[id]).concat(Object.keys(have).filter((id) => !SCENE_IDS.includes(id) && SCENES[id]));
        }
        return SCENE_IDS.slice();
      };
      const sceneHref = (id) => (SITE ? String((SITE.scenes || {})[id] || '') : '#' + id);
      const sceneTitle = (id) => { const p = !SITE ? FFD.pages.find((x) => x.id === id) : null; return (p && p.title) || (SCENES[id] && SCENES[id].title) || id; };
      /* the gallery's locks (library/gallery.js), read before the frame so its first frame already wears them */
      const galleryMake = FFD.parts && FFD.parts['library/gallery'];
      let gallery = null;
      try { gallery = typeof galleryMake === 'function' ? galleryMake({ scenes: scenesHere, took: tookQuest, day: () => (typeof FFD.day === 'function' ? FFD.day() : ''), info: () => { const q = Q(); return q ? q.info() : null; } }) : null; } catch (e) { console.error('library/gallery', e); gallery = null; }
      const gstate = (id) => { try { return gallery ? gallery.state(id) : 'open'; } catch (e) { return 'open'; } };
      const shut = (id) => { const s = gstate(id); return s === 'locked' || s === 'next'; };
      /* the painter still draws a lock on it: shut, or open with the moment its lock comes off still to play */
      const lockOn = (id) => { try { return !!gallery && (shut(id) || gallery.keyed(id)); } catch (e) { return false; } };
      /* each painting is its own flow, so a tap on another painting while one is named switches to it. A locked one is
         named for what it is, and its lock makes its own sound */
      scenesHere().forEach((id) => {
        roomHots['paint-' + id] = {
          get label() { return shut(id) ? (gstate(id) === 'next' ? LOCK.labelNext : LOCK.label) : cap1(sceneTitle(id)); },
          get sound() { return lockOn(id) ? false : undefined; },
          tap: tapTo('paint-' + id, 'portal-' + id, (tok) => portalFlow(tok, id))
        };
      });
      /* the chair by the window: the study (library/study.js, Jan 2026-10-07). The painter draws it in the wide room only;
         a tap while the jukebox turns only stirs it */
      if (FULL) roomHots.chair = { label: 'The chair by the window', tap: tapTo('chair', 'study', () => { poke('chair'); if (pBusy(jukebox)) return null; return study ? study.open() : null; }, NOGIVE) };
      /* a first visit starts dark from the very first frame (the painter's 'intro' value), so no lit frame shows before the
         intro dims the room; under reduced motion the room simply opens lit. tapThrough: a tap squarely on another thing
         while a line waits for its tap reaches that thing (core.js), and a sparkle under that layer is taken the same way */
      /* ---- does the room know the reader? (FFD.quest: this browser's own claimed run, its lead flag, or the ledger) ----
         The first time it does, the next painting opens at once and the WANTED poster's moment is due; on a later new
         day one more painting opens. Each new one keeps its lock until Soryndel brings the key on screen */
      let knowFresh = false;
      try { const q0 = Q(); if (q0) knowFresh = !!q0.scan().fresh; } catch (e) { knowFresh = false; }
      function knowNow() {
        if (!gallery || !tookQuest()) return null;
        try { if (!gallery.quest()) return { first: true, opened: gallery.questOpen() }; return { first: false, opened: gallery.roll() }; } catch (e) { console.error(e); return null; }
      }
      knowNow();
      /* the moment still to play: the poster (the room knows the reader, or a new hero, and the stamp never landed) or a
         painting whose lock hasn't come off on screen yet */
      const recogDue = () => { try { return !!gallery && tookQuest() && (knowFresh || !gallery.stamped()); } catch (e) { return false; } };
      const keyDue = () => { try { return !!gallery && tookQuest() && gallery.keys().length > 0; } catch (e) { return false; } };
      /* what the wall shows: the thumbs (the painter cuts them to the wall), the locks on the hung frames, the next lock's
         breathing keyhole, the fresh glint and the crossed-out poster. capNow is the wall's real size once measured */
      let capNow = 6, galSig = '', opening = 0, hungNow = [];
      function galVals() {
        if (!gallery) {
          let t = scenesHere(); const at = backFrom ? t.indexOf(backFrom) : -1;
          if (at > 0) t = t.slice(at).concat(t.slice(0, at));
          return { thumbs: t, locks: null, nextLock: null, fresh: [], posterDone: false };
        }
        const list = gallery.hang(backFrom, capNow), hung = list.slice(0, capNow);
        return { thumbs: list, locks: gallery.locks(hung), nextLock: gallery.nextLock(hung), fresh: gallery.glint(hung), posterDone: tookQuest() && gallery.stamped() };
      }
      const galFirst = galVals();
      galSig = JSON.stringify(galFirst); hungNow = galFirst.thumbs.slice(0, capNow);
      /* the window shows the view the reader last studied by (library/study.js keeps it per browser and sets it again when
         they stand up; Jan 2026-10-08), simpler than the study's. None kept is the town, the painter's own default */
      const viewKept = (() => { try { const sp = FFD.parts && FFD.parts['library/study']; const v = sp && typeof sp.view === 'function' ? sp.view() : null; return v && v !== 'town' ? v : null; } catch (e) { return null; } })();
      const F = ctx.frame({
        /* toolsAt: the full-screen room keeps its tools top right, so the painter leaves the top left's spots alone */
        key: KEY, label: title, quiet: true, hint: false, alt: ALT, hots: roomHots, set: Object.assign((FULL || firstVisit) && !RM() ? { intro: true } : {}, galFirst, FULL ? { toolsAt: 'right' } : {}, viewKept ? { vista: viewKept } : {}),
        tapThrough: (el) => { const g = el && el.closest ? el.closest('.lbb-g') : null; if (g && giveWay()) g.click(); }
      });
      /* the page's name, for screen readers and search (no title in the box: the room is quiet) */
      ctx.root.insertBefore(h('h1', { class: 'lb-h1', text: title }), F.el);
      /* the full-screen room: the art sits in a pan that scrolls sideways on an upright phone (the same wide room as a
         laptop; Jan 2026-10-07 "the phone shouldnt be illustrated differently ... scroll to look around"), and the
         corner tools, dice, captions and live region move out of it so they stay on the screen */
      let pan = null, panAnim = 0, panning = false, userPan = -1e9, panned = false;
      const plateEl = FULL ? h('div', { class: 'lb-plate', 'aria-hidden': 'true' }) : null;
      const mplateEl = FULL ? h('div', { class: 'lb-mplate', 'aria-hidden': 'true' }) : null;
      /* an upright phone is asked to turn sideways each time the reader steps in (Jan, 2026-10-07); anything else that
         pans is told once that it can drag */
      const hintTxt = FULL ? h('span') : null;
      const hintEl = FULL ? h('p', { class: 'lb-panhint', 'aria-hidden': 'true' }, h('i', { class: 'lb-turn' }), hintTxt) : null;
      const upright = () => { try { return matchMedia('(orientation: portrait) and (pointer: coarse)').matches; } catch (e) { return false; } };
      if (FULL) {
        pan = h('div', { class: 'lb-pan' });
        F.art.parentNode.insertBefore(pan, F.art);
        pan.append(F.art);
        ['ffs-top', 'ffs-fx', 'ffs-result', 'ffs-sr'].forEach((c) => { const n = [].find.call(F.art.children, (x) => x.classList && x.classList.contains(c)); if (n) F.el.insertBefore(n, pan.nextSibling); });
        F.el.append(mplateEl, plateEl, hintEl);
        pan.addEventListener('scroll', () => {
          if (panning) return;
          userPan = Date.now();
          if (!panned) { panned = true; if (!hintEl.classList.contains('is-turn')) hintEl.classList.remove('is-on'); }
        }, { passive: true });
        /* a mouse drags the room too, and a drag is never a tap */
        let dr = null, moved = false;
        pan.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse' || e.button !== 0 || pan.scrollWidth - pan.clientWidth < 3) return; dr = { x: e.clientX, s: pan.scrollLeft }; moved = false; });
        const pm = (e) => { if (!dr) return; const dx = e.clientX - dr.x; if (Math.abs(dx) > 5) { moved = true; pan.classList.add('is-drag'); } if (moved) { cancelAnimationFrame(panAnim); pan.scrollLeft = dr.s - dx; } };
        const pu = () => { if (!dr) return; dr = null; pan.classList.remove('is-drag'); if (moved) { const kill = (ev) => { ev.stopPropagation(); ev.preventDefault(); }; window.addEventListener('click', kill, { capture: true, once: true }); setTimeout(() => window.removeEventListener('click', kill, { capture: true }), 60); } };
        window.addEventListener('pointermove', pm); window.addEventListener('pointerup', pu);
        ctx.onKill(() => { window.removeEventListener('pointermove', pm); window.removeEventListener('pointerup', pu); cancelAnimationFrame(panAnim); });
      }
      /* the camera on a phone: it glides to wherever something new happens, unless the reader has just looked around.
         x is a grid x, or a share of the room's width with o.share */
      function lookAt(x, o) {
        o = o || {};
        if (!pan) return;
        const max = pan.scrollWidth - pan.clientWidth; if (max <= 2) return;
        if (!o.force && Date.now() - userPan < 2600) return;
        let cx;
        if (o.share) cx = x * F.art.clientWidth; else { const p = F.toCss(x, 0); if (!p) return; cx = p.x; }
        const to = Math.max(0, Math.min(max, cx - pan.clientWidth / 2)), from = pan.scrollLeft;
        cancelAnimationFrame(panAnim);
        if (o.instant || RM()) { panning = true; pan.scrollLeft = to; requestAnimationFrame(() => { panning = false; }); return; }
        const t0 = performance.now(), dur = o.dur || 900, ease = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
        const go = (n) => { const q = Math.min(1, (n - t0) / dur); panning = true; pan.scrollLeft = from + (to - from) * ease(q); if (q < 1) panAnim = requestAnimationFrame(go); else requestAnimationFrame(() => { panning = false; }); };
        panAnim = requestAnimationFrame(go);
      }
      function panHint() {
        if (!pan || pan.scrollWidth - pan.clientWidth < 3) return;
        const turn = upright();
        if (!turn && panned) return;
        hintTxt.replaceChildren(turn ? 'Swipe to look around the room.' : 'Drag to look around the room.');
        hintEl.classList.remove('is-turn');
        /* it waits for a quiet moment (nobody speaking, nothing open, for 0.75 s; it gives up after 30 s), never sits
           over the words, a card, a pack, a sheet or the open book (it would wait under the book and show through as
           the frame fades to the next page), never comes while the frame leaves, and goes the moment the phone turns */
        const bookOpen = () => { try { return !!(book && typeof book.isOpen === 'function' && book.isOpen()); } catch (e) { return false; } };
        const t0 = Date.now(), away = () => partsBusy() || F.el.classList.contains('has-sheet') || F.el.classList.contains('is-leaving') || bookOpen() || F.el.querySelector('.lbc') || opening > 0 || pScreen;
        let shown = 0, calm = 0;
        const stop = () => { clearInterval(iv); hintEl.classList.remove('is-on'); };
        const iv = setInterval(() => {
          if (!ctx.alive() || (turn && !upright()) || (!turn && panned)) { stop(); return; }
          if (!shown) {
            if (Date.now() - t0 > 30000) { stop(); return; }
            if (boxUp() || !free() || away()) { calm = 0; return; }
            if ((calm += 250) < 750) return;
            shown = Date.now(); hintEl.classList.add('is-on');
            return;
          }
          if (Date.now() - shown > (turn ? 8000 : 7000) || boxUp() || away()) stop();
        }, 250);
        ctx.onKill(() => clearInterval(iv));
      }
      /* words in the box (the quiet room empties it between lines) */
      function boxUp() {
        try {
          const b = F.box;
          if (!b || b.classList.contains('is-empty')) return false;
          const cs = getComputedStyle(b);
          return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05;
        } catch (e) { return false; }
      }
      const plate = (name, col) => {
        if (!plateEl) return;
        plateEl.textContent = name; plateEl.style.setProperty('--pc', col || '#e8a85a');
        plateEl.classList.remove('is-on'); void plateEl.offsetWidth; plateEl.classList.add('is-on');
        clearTimeout(plate.t); plate.t = setTimeout(() => plateEl.classList.remove('is-on'), 2600);
      };
      /* the browser held the music back (the gate's 'silent' way on a computer, or any refused record): "Click anywhere
         for music." ("Tap" on a touch screen) until the record plays. Never while the sound is off, and the gate never
         comes back. The press itself is music.js's own (and onPress below) */
      let mOn = false;
      const touchy = () => { try { return !matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) { return false; } };
      function musicPlate(on) {
        if (!mplateEl) return;
        try { if (on && music && music.muted) on = false; } catch (e) { /* fine */ }
        if (on === mOn) return;
        mOn = on;
        if (on) mplateEl.textContent = touchy() ? MPLATE.tap : MPLATE.click;
        mplateEl.classList.toggle('is-on', on);
      }
      /* right after the jukebox starts its record: the refusal can come before anyone listens for it */
      function musicCheck() {
        if (!FULL) return;
        if (window.FFD_GATE_MODE === 'silent') musicPlate(true);
        setTimeout(() => { try { if (ctx.alive() && music && music.blocked) musicPlate(true); } catch (e) { /* fine */ } }, 400);
      }
      if (FULL) {
        const onB = () => musicPlate(true), onU = () => musicPlate(false), onM = (e) => { if (e && e.detail && e.detail.muted) musicPlate(false); };
        document.addEventListener('ffd:music-blocked', onB); document.addEventListener('ffd:music-unblocked', onU); document.addEventListener('ffsound:mute', onM);
        ctx.onKill(() => { document.removeEventListener('ffd:music-blocked', onB); document.removeEventListener('ffd:music-unblocked', onU); document.removeEventListener('ffsound:mute', onM); });
      }
      const inkTo = (hex) => {
        try { F.el.style.setProperty('--ink', hex); F.el.style.backgroundColor = hex; ctx.root.style.backgroundColor = hex; const m = document.querySelector('meta[name="theme-color"]'); if (m) m.setAttribute('content', hex); } catch (e) { /* fine */ }
      };
      const liveSay = (t) => { try { const n = F.el.querySelector('.ffs-sr'); if (n) n.textContent = t; } catch (e) { /* fine */ } };
      /* read-only, for the review harness: which flow runs, a game's hold, who stands in the room (the page never reads it) */
      try {
        Object.defineProperty(F.el, '__lbState', { value: () => ({ flow, hold, gameHold, cur: cur ? cur.name : null, walker: walkerIn, leaving: walkerLeaving, swap: !!swap, quest: tookQuest(),
          gallery: gallery ? gallery.snapshot() : null, cap: capNow, hung: hungNow.slice(), opening, plate: !!(mplateEl && mplateEl.classList.contains('is-on')), arrival: pendingArrival,
          paint: (() => { try { return { thumbs: F.get('thumbs'), locks: F.get('locks'), nextLock: F.get('nextLock'), fresh: F.get('fresh'), posterDone: F.get('posterDone') }; } catch (er) { return null; } })() }) });
      } catch (e) { /* fine */ }
      /* coming back through a painting: the room stays dark until it zooms out of that painting */
      if (backFrom && !RM()) F.art.style.opacity = '0';

      /* ---- the box: Zhaunil (or whoever speaks) and nothing else ----
         A spoken line is in curly quotes and the 'say' style, as on every scene page (and the games); a line given as an
         object ({ text, cls }) goes in as it is, so narration and the d20's stakes keep their own look */
      const quote = (t) => '“' + String(t).trim().replace(/^["“”]+|["“”]+$/g, '') + '”';
      const line = (t, who) => (t && typeof t === 'object' ? Object.assign({ who: who || ZH }, t) : { text: quote(t), cls: 'say', who: who || ZH });
      /* lines that wait for the reader's tap, then the box goes */
      async function talk(lines, who) {
        if (!ctx.alive()) return;
        clearAside();
        const list = [].concat(lines).filter(Boolean).map((t) => line(t, who));
        if (!list.length) return;
        await F.talk(list, { who: list[0].who, now: true });
      }
      /* the box fades out (about 180 ms, at once under reduced motion), and a line still on its way in never arrives
         (F.cancel stops it and drops anything the box was waiting on) */
      let asideOn = false;
      function hush() { asideOn = false; return F.cancel(); }
      /* a line in passing: it stays until the reader's next touch (or until anyone speaks), then the box goes. It never
         holds the room: a flow ends as soon as its aside starts */
      function clearAside() { if (asideOn) hush(); }
      function aside(t, who) {
        if (!ctx.alive()) return;
        asideOn = true;
        F.say([line(t, who)], { who: who || ZH, now: true });
      }
      const onTouch = () => { lastTap = Date.now(); if (beaconLit) { beaconLit = false; F.beacon([BEACON], false); } clearAside(); };
      const onTouchKey = (e) => { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') onTouch(); };
      F.el.addEventListener('pointerdown', onTouch, true);
      F.el.addEventListener('keydown', onTouchKey, true);
      /* the music after the browser held it back, or after the back/forward cache: on a real press anywhere (a click,
         touchend or key, never pointerdown, which allows no sound on a touch screen) */
      const NOT_PRESS = /^(Shift|Control|Alt|Meta|Tab|Escape|Esc|CapsLock)$/;
      const onPress = (e) => {
        if (e && e.type === 'keydown' && NOT_PRESS.test(e.key || '')) return;
        if (jukebox) { try { jukebox.touched(); } catch (er) { /* fine */ } }
        try { if (music && music.blocked && typeof music.kick === 'function') music.kick(); } catch (er) { /* fine */ }
        /* the plate goes once the record plays (a 'silent' gate whose record was never refused sends no event) */
        if (mOn) setTimeout(() => { try { if (ctx.alive() && music && !music.blocked && (music.on || music.muted)) musicPlate(false); } catch (er) { /* fine */ } }, 350);
      };
      const PRESS_OPT = { capture: true, passive: true };
      ['click', 'touchend', 'keydown'].forEach((t) => document.addEventListener(t, onPress, PRESS_OPT));
      ctx.onKill(() => ['click', 'touchend', 'keydown'].forEach((t) => document.removeEventListener(t, onPress, PRESS_OPT)));
      /* a question with its choices under it. The room gave way while the question was said: no chips come at all
         (a chip made after the box faded would wait for ever, its hotspots still live) */
      async function ask(prompt, options, o, who) {
        clearAside();
        const g = gaveWay;
        if (prompt) await F.say([].concat(prompt).map((t) => line(t, who)), { who: who || ZH, now: true });
        if (!ctx.alive()) return null;
        if (g !== gaveWay) return { index: -1, label: '', value: undefined, cancelled: true };
        return F.ask(options, Object.assign({ sheet: false }, o || {}));
      }

      /* ---- every way out asks once (section 3): where it leads in one line, then the way out named plainly and
         "Stay in the library". Only the yes goes: 'away' (this tab, after the fade), 'tab' (a new tab, the demo's links
         to the store and links off the site), or false (stayed). A choice that already named the way out (Ember's "Go to
         the commission page", the posting's "Play the Quest with another hero", "Go after her in the Quest" before the
         Iron Matron, a painting picked from "Where do the paintings go?") was that one ask: it goes through leaveNow,
         straight to the fade. The book's "The whole Guide on FramedFantasy" and "Read it in the Guide" do the same
         through api.go ---- */
      const isHash = (u) => /^#/.test(u || '');
      const offSite = (u) => { try { return new URL(u, location.href).origin !== location.origin; } catch (e) { return false; } };
      const newTab = (u) => !isHash(u) && (!SITE || offSite(u));
      async function leaveAsk(o) {
        const r = await ask(o.lines || o.line, [{ label: o.yes, value: 'go' }, { label: STAY, value: 'stay', used: false }], { cols: 2, used: false }, o.who);
        /* given way: the box is already fading, so it is never wiped here */
        if (!r || !ctx.alive() || r.cancelled) return false;
        F.clear();
        if (r.value !== 'go') return false;
        return leaveNow(o);
      }
      /* a way out the reader has already chosen by name (Ember's "Go to the commission page") is its own yes: no second
         question, straight to the fade (Jan, 2026-10-11: "it says the same thing again then you click it again to open
         the page"). After it nothing interrupts the way out (the zoom into a painting, the fade to the next page) */
      async function leaveNow(o) {
        if (o.tok) o.tok.can = false;
        const tab = newTab(o.href);
        if (o.before && !tab) { try { await o.before(); } catch (e) { /* fine */ } }
        if (!ctx.alive()) return 'away';
        leave(o.href);
        return tab ? 'tab' : 'away';
      }
      /* the real link, made and followed only after the yes: in this tab it waits for the frame's fade (FFD.leaveTo),
         and Back brings the reader home; the demo opens the store in a new tab and the room stays */
      function leave(href) {
        if (!href) return;
        const tab = newTab(href);
        const a = h('a', { href, class: 'lb-go', target: tab ? '_blank' : null, rel: tab ? 'noopener' : null, tabindex: '-1', 'aria-hidden': 'true', text: 'Go' });
        if (!tab) a.addEventListener('click', (e) => { e.preventDefault(); FFD.leaveTo(href, F.el); });
        /* the drag hint goes with the room, never lit over the fade */
        if (!tab && hintEl) hintEl.classList.remove('is-on');
        after.append(a);
        a.click();
        setTimeout(() => a.remove(), 0);
        /* a new tab leaves the room as it was; in this tab the room comes back only if the next page never came */
        if (tab) unzoom();
        else setTimeout(() => { if (ctx.alive()) unzoom(); }, 8000);
      }

      /* ---- the parts ---- */
      const vpRect = (id) => {
        const r = F.spotCss(id); if (!r) return null;
        const ar = F.art.getBoundingClientRect();
        return new DOMRect(ar.left + r.x, ar.top + r.y, r.w, r.h);
      };
      /* a frame partly scrolled away comes back into view before an overlay opens in it */
      function frameIntoView() {
        try {
          const r = F.el.getBoundingClientRect(), ins = topInset(F.el), vh = window.innerHeight || 0;
          if (r.top < ins - 1 || r.bottom > vh + 1) { const top = r.top + (window.scrollY || 0); goTo(top <= vh * 0.35 ? 0 : top - ins); }
        } catch (e) { /* fine */ }
      }
      let lectern = false, finishedNow = 0;
      const bookApi = {
        h, esc, RM, WIDE, alive: ctx.alive, F, snd: sound,
        stories: (bay) => stories(bay || null).catch(() => null),
        shelf: (bay) => shelfList(bay || null).catch(() => []),
        text: (b) => Promise.resolve(b ? textFor(b) : null).catch(() => null),
        cover: (b, w) => Promise.resolve(b ? coverOf(b, w) : null).catch(() => null),
        bookByHandle: (hd) => byH.get(String(hd || '').split(/[?#]/)[0].split('/').filter(Boolean).pop() || '') || null,
        mins: (b) => (b ? +b.m || 0 : 0),
        isRead: (b) => !!(b && st.read.includes(b.h)),
        opened: (b) => {
          if (!b || !b.h) return;
          st.seen.push(b.h); keep(st);
          /* the spine leaves its shelf while the reader has it open (the owl's book stays out from the lectern) */
          if (sceneOk && !lectern && shelf[b.k]) F.set('out', { bay: b.k, i: shelf[b.k].indexOf(b) });
        },
        finished: (b) => {
          if (!b || !b.h) return;
          finishedNow++;
          if (!st.read.includes(b.h)) { st.read.push(b.h); keep(st); FFD.tally.add(ID, 'read'); }
          if (sceneOk) { F.set('read', readMap()); poke('owl'); }
        },
        shelfName: (bay) => (bay && SHELF[bay] ? SHELF[bay].from : ''),
        count: () => guideCount || books.length,
        guideHref: ROUTES.guide,
        go: (href) => leave(href)
      };
      const cardCount = () => { try { return cards ? +(typeof cards.countAll === 'function' ? cards.countAll() : cards.count()) || 0 : 0; } catch (e) { return 0; } };
      const cardsApi = {
        h, esc, RM, WIDE, alive: ctx.alive, F, snd: sound, SITE, zh: ZH,
        booksRead: () => st.read.slice().reverse().map((hd) => byH.get(hd)).filter(Boolean),
        cover: (b, w) => Promise.resolve(b ? coverOf(b, w) : null).catch(() => null),
        openBook: (b) => openBook(b, 'One you’ve read before'),
        added: () => { if (sceneOk) F.set('binderCount', cardCount()); },
        /* the gold feathers the hunt put in the binder (games.js), read when the album opens */
        trophies: () => { try { return games && typeof games.trophies === 'function' ? games.trophies() : null; } catch (e) { return null; } }
      };
      const part = (name, api) => {
        const make = FFD.parts && FFD.parts['library/' + name];
        if (typeof make !== 'function') return null;
        try { return make(api) || null; } catch (e) { console.error('library/' + name, e); return null; }
      };
      book = part('book', bookApi);
      cards = part('cards', cardsApi);
      /* a game waits for the room's own flow to end before it speaks (never over Jan, a walker or the owl's book); after
         a while it lets the words go */
      const flowEnds = async (ms) => { const t0 = Date.now(); while (flow && ctx.alive() && Date.now() - t0 < ms) await sleep(150); return !flow && ctx.alive(); };
      const gamesApi = {
        h, esc, RM, WIDE, alive: ctx.alive, F, snd: sound, ZH, cards,
        /* a tap on another thing while a game speaks fades its words: it throws, so a game never says its next line
           (games.js speak() and borders.js catch it) */
        talk: async (lines, who) => {
          if (!(await flowEnds(6000))) return;
          const g = gaveWay;
          hold++;
          try { await talk(lines, who); } finally { hold = Math.max(0, hold - 1); drain(); }
          if (g !== gaveWay) throw HALT;
        },
        /* o.lines (or o.prompt, o.line) are said above the choices, by o.who (Zhaunil by default) */
        ask: async (options, o) => {
          o = Object.assign({}, o || {});
          const said = o.lines || o.prompt || o.line || null, who = o.who || ZH;
          delete o.lines; delete o.prompt; delete o.line; delete o.who;
          const last = options.length - 1, lo = options[last];
          if (!(await flowEnds(6000))) return { index: last, label: lo && typeof lo === 'object' ? lo.label : String(lo || ''), value: lo && typeof lo === 'object' ? lo.value : undefined };
          const g = gaveWay;
          hold++;
          /* given way: null (the cat stays quiet), and the fading box is left alone */
          try { const r = await ask(said, options, o, who); if (!r || r.cancelled || g !== gaveWay) return null; if (ctx.alive()) F.clear(); return r; }
          finally { hold = Math.max(0, hold - 1); drain(); }
        },
        busy: (on) => { gameHold = !!on; if (!gameHold) drain(); },
        pickUnread: () => (books.length ? smart() : null),
        openBook: (b, from) => openBook(b, from || 'The cat chose this one'),
        tally: (key, n) => FFD.tally.add(ID, key, n),
        note: bnote
      };
      games = part('games', gamesApi);
      borders = part('borders', {
        h, RM, WIDE, alive: ctx.alive, F, snd: sound, SITE, ZH, cards,
        talk: gamesApi.talk, free: () => free(), sceneOk: () => sceneOk, intoView: frameIntoView,
        rec: () => (jukebox ? jukebox.rec() : 'quiet'), calm: () => (jukebox ? jukebox.calm() : true),
        /* a sparkle taken while someone speaks: their words give way first, when they can */
        yield: () => { if (flow || hold) giveWay(); },
        tally: (key, n) => FFD.tally.add(ID, key, n), total: (key) => FFD.tally.total(ID, key)
      });
      /* a part's sheet over the room holds it (no other thing opens under it) */
      const holdOn = (on) => { partHold = Math.max(0, partHold + (on ? 1 : -1)); if (!partHold) drain(); };
      /* the wall's "Ask Jan" closes it, and Ember walks in to the easel in the same flow (openHeroes) */
      let emberNext = false;
      favorites = part('favorites', { F, RM, snd: sound, hold: holdOn, SITE,
        heroHref: (slug) => (ROUTES.hero ? ROUTES.hero + encodeURIComponent(slug) : ''),
        onEasel: () => { emberNext = true; }
      });
      /* the owl's book rises from the lectern (its spot on the screen) */
      offer = part('offer', { F, RM, snd: sound, hold: holdOn,
        cover: (b, w) => Promise.resolve(b ? coverOf(b, w) : null).catch(() => null),
        origin: () => {
          const r = F.spotCss('lectern'); if (!r || !F.art) return null;
          const a = F.art.getBoundingClientRect();
          return { x: a.left + r.cx, y: a.top + r.y + r.h * 0.2 };
        }
      });
      /* Zhaunil's ledger (library/ledger.js): the reader finds their Quest hero by the Quest's email, or signs in with a
         Hall PIN. It speaks in the box itself (escaped), and points at the poster after an email it doesn't know */
      signLedger = part('ledger', {
        h, esc, F, RM, snd: sound, SITE, live: FFD.live === true, hall: window.FFD_HALL || (SITE && SITE.hall) || null,
        talk: (lines, who) => talk(lines, who), ask: null, hold: holdOn, who: ZH, poster: () => pointPoster()
      });
      if (FULL) {
        const sndO = (n, o) => { try { const sd = window.FFSound; if (sd && typeof sd[n] === 'function') sd[n](o || {}); } catch (e) { /* silent */ } };
        /* the records and their names live with the shared player (src/scene-pages/music.js); the store may point them elsewhere */
        music = part('music', { urls: SITE && SITE.music ? SITE.music : {}, art: ZH.img, album: 'Zhaunil’s Library' });
        const quietMusic = { level: () => 0.35, time: () => 0, needle() {}, play() {}, start() {}, duck() {}, lpTo() {}, prefetch() {}, wake() {}, setMuted() {}, muted: true, on: false };
        if (!music) music = quietMusic;
        const overlayOpen = () => document.hidden || partHold > 0 || pBusy(cards) || pBusy(waitlist) || pBusy(memories) || pBusy(fight) || pBusy(study) || bBusy() || F.el.classList.contains('has-sheet');
        moods = part('moods', { F, RM, snd: sndO, level: () => music.level(), time: () => music.time(), has: (k) => { try { return !!(borders && borders.has && borders.has(k)); } catch (e) { return false; } }, paused: overlayOpen, reduced: RM() });
        waitlist = part('waitlist', { F, RM, snd: sndO, SITE, live: FFD.live === true, talk: (lines, who) => talk(lines, who || JAN), hold: holdOn, who: JAN });
        memories = part('memories', { F, RM, snd: sndO, SITE, live: FFD.live === true, hall: window.FFD_HALL || (SITE && SITE.hall) || null, talk: (lines, who) => talk(lines, who), hold: holdOn });
        fight = part('fight', { F, RM, snd: sndO, bonus: () => (jukebox ? jukebox.bonus() : { road: false, saw: false, mem: false }), music });
        jukebox = part('jukebox', {
          F, h, RM, snd: sndO, buzz: (ms) => { try { if (FFD.buzz) FFD.buzz(ms); } catch (e) { /* fine */ } }, ZH, talk, ask, aside, tapTo, step, NOGIVE, free, leaveAsk, leaveNow,
          hots: (map) => F.hots(map, { merge: true }), lookAt, music, moods, borders, cards, memories, fight, live: liveSay, plate, ink: inkTo
        });
        study = part('study', {
          F, h, RM, snd: sndO, music, zh: ZH,
          rec: () => (jukebox ? jukebox.rec() : 'quiet'),
          calmTo: (id) => { try { if (jukebox && jukebox.calmTo) jukebox.calmTo(id); else music.play(id, 4); } catch (e) { /* fine */ } },
          tally: { add: (k, n) => FFD.tally.add(ID, k, n), total: (k) => FFD.tally.total(ID, k), mine: (k) => FFD.tally.mine(ID, k), cap: (k, n) => FFD.tally.cap(ID, k, n), base: (k, n) => FFD.tally.base(ID, k, n), on: (fn) => FFD.tally.on(fn) }
        });
        /* a handle for checks, as the borders keep one (F.el.__lbBorders) */
        try { Object.defineProperty(F.el, '__lbJuke', { configurable: true, value: { jukebox, moods, music, fight, memories, waitlist, cards, study } }); } catch (e) { /* fine */ }
      }
      ctx.onKill(() => [offer, favorites, signLedger, study, jukebox, fight, memories, waitlist, moods, music, borders, games, cards, book].forEach((p) => { try { if (p && typeof p.destroy === 'function') p.destroy(); else if (p && typeof p.close === 'function') p.close(); } catch (e) { /* fine */ } }));
      /* the curios' hotspots join the room's (never in place of the room's own). Each keeps the game's own object for
         its name and sound (a name changes as the reader meets a curio), and taps through while nothing else runs */
      const ROOM_IDS = new Set(['owl', 'zhaunil', 'lectern', 'ledger', 'deck', 'binder', 'gallery', 'poster', 'easel', 'artguide', 'door', 'walker']);
      /* the curio whose words are in the box: a second tap on it only stirs it (its rumour or question stays, and a waiting
         line continues), while any other curio still gives way */
      let lastCurio = null;
      if (games && typeof games.hots === 'function') {
        let gh = null;
        try { gh = games.hots(); } catch (e) { console.error(e); }
        const add = {};
        Object.keys(gh || {}).forEach((id) => {
          const d = gh[id];
          if (!d || ROOM_IDS.has(id) || /^(bay|paint)-/.test(id)) return;
          add[id] = {
            get label() { return d.label || id; },
            get sound() { return d.sound; },
            /* while someone speaks the curio answers at once and their words fade (a candle goes out the moment it is
               tapped); while the room can't give way (the owl's fetch, a book) it only stirs in the art */
            tap: (hid, FF) => {
              if (hold > 0 && !flow && id === lastCurio && !(games && typeof games.wantsEveryTap === 'function' && games.wantsEveryTap(id))) { poke(id); return; }
              if ((flow || hold) && !giveWay()) { poke(id); return; }
              clearAside();
              lastCurio = id;
              if (typeof d.tap === 'function') { try { d.tap(hid, FF); } catch (e) { console.error(e); } }
            }
          };
        });
        F.hots(add, { merge: true });
      }
      /* a book asked for by the binder or the cat opens as soon as the room is free */
      function openBook(b, from) {
        if (!b) return;
        pendingBook = b; pendingFrom = from || '';
        if (flow === 'binder') { try { if (cards && typeof cards.close === 'function') cards.close(); } catch (e) { /* fine */ } return; }
        drain();
      }
      function drain() {
        if (!free() || !ctx.alive()) return;
        if (pendingBook) {
          const b = pendingBook, from = pendingFrom;
          pendingBook = null;
          run('book', async () => { const res = await readIn({ book: b, from }); return afterBook(res); }, NOGIVE);
          return;
        }
        /* the gallery's moment, once the greeting (or whatever the reader opened first) is over */
        if (pendingArrival) { pendingArrival = false; if (recogDue() || keyDue()) { run('arrival', (tok) => arrivalFlow(tok)); return; } }
        if (pendingLedger) { pendingLedger = false; if (signLedger && !tookQuest()) run('ledger', (tok) => ledgerFlow(tok, { line: L.ledgerAsk })); }
      }
      const queueArrival = () => { if (recogDue() || keyDue()) pendingArrival = true; if (pendingArrival || pendingLedger) setTimeout(drain, 0); };
      /* the greeting gave way to another tap: the moment still comes, once the room is free and nobody has touched it
         for 4 s (it never interrupts what the reader opened) */
      function arriveWhenStill() {
        const t = setInterval(() => {
          if (!ctx.alive() || !(recogDue() || keyDue())) { clearInterval(t); return; }
          if (!free() || Date.now() - lastTap < 4000) return;
          clearInterval(t); queueArrival();
        }, 500);
        ctx.onKill(() => clearInterval(t));
      }

      /* ---- everything in this room: plain links under the frame, there even if the art never loads ---- */
      const after = ctx.block('ffd-after');
      (function roomList() {
        const row = (text, line2, href) => {
          const t = newTab(href);
          return h('li', null, h('a', { href, target: t ? '_blank' : null, rel: t ? 'noopener' : null },
            h('span', { class: 'lb-rt', text }), line2 ? h('span', { class: 'lb-rl', text: line2 }) : null, h('i', { class: 'lb-rd', 'aria-hidden': 'true' })));
        };
        const ul = h('ul', { class: 'lb-roomlist' },
          row('The Commissioner’s Guide', 'Straight answers on commissioning your character.', ROUTES.guide),
          scenesHere().map((id) => row(cap1(sceneTitle(id)), null, sceneHref(id))),
          row('The Character Quest', 'Real dice, a D&D adventure, and your character at the end.', FFD.questHref(ID, 'list')),
          row('Commission your character', 'Jan paints D&D characters from the stories their players tell.', ROUTES.product),
          row('The Hall of Heroes', 'Every hero players have added, with their cards and stories.', ROUTES.hall),
          row('Reviews', 'Delivery day, in their words.', ROUTES.reviews));
        after.append(h('nav', { class: 'lb-room', 'aria-label': 'Everything in this room' }, h('h2', { text: 'Everything in this room' }), ul));
      })();

      /* ---- the store keeps its header: the frame fills the screen under it, measured again as the page settles ---- */
      if (!FULL && SITE && ctx.root && ctx.root.hasAttribute && ctx.root.hasAttribute('data-ffd-live')) {
        let mq = 0;
        const measure = () => {
          mq = 0;
          let top = Math.max(0, Math.round(ctx.root.getBoundingClientRect().top + (window.scrollY || 0)));
          if (top > window.innerHeight * 0.35) top = 0;
          ctx.root.style.setProperty('--ffs-top', top + 'px');
        };
        const soon = () => { if (!mq) mq = requestAnimationFrame(measure); };
        window.addEventListener('load', soon); window.addEventListener('resize', soon); window.addEventListener('orientationchange', soon);
        ctx.onKill(() => { window.removeEventListener('load', soon); window.removeEventListener('resize', soon); window.removeEventListener('orientationchange', soon); if (mq) cancelAnimationFrame(mq); });
        soon();
      }
      /* back from another page through the browser's cache: the room as it was, never mid-fade or mid-zoom, and never
         under the Quest's first screen */
      const onShow = (e) => {
        if (!e.persisted || !ctx.alive()) return;
        unzoom();
        posterClose(true);
        if (walkerIn) walkOutNow();
        if (jukebox) jukebox.resume();
        /* the door key is spent, so a reload later isn't taken for a walk back through a painting */
        doorTake();
        /* back from the Quest in this tab: the room may know the reader now (quest-id read storage again on this
           pageshow), so the poster's moment and the next painting come after the room settles */
        try { const q = Q(); if (q && q.scan().fresh) knowFresh = true; } catch (er) { /* fine */ }
        knowNow();
        paintGallery();
        queueArrival();
      };
      window.addEventListener('pageshow', onShow);
      ctx.onKill(() => window.removeEventListener('pageshow', onShow));
      /* the browser's cross-page fade plays only toward a scene page (core.js skips it toward any other page) */

      /* the painter tells which pixel heroes it can draw (minus Zhaunil); walkers come only from those */
      const takeCast = (d) => {
        const ids = Array.isArray(d) ? d : (d && (Array.isArray(d.ids) ? d.ids : Array.isArray(d.cast) ? d.cast : Array.isArray(d.heroes) ? d.heroes : null));
        if (ids) cast = ids.map(String);
      };
      F.on('cast', takeCast);

      if (!SITE) libFirst();
      /* the painting the reader came back through hangs first, so the room can zoom out of it (gallery.hang) */
      try { await F.ready; sceneOk = true; } catch (e) { sceneOk = false; }
      if (!ctx.alive()) return;
      if (sceneOk) {
        paintGallery(true);
        [250, 800, 1600].forEach((ms) => setTimeout(wallCheck, ms));
        F.set('ledger', ledger());
        F.set('out', null);
        F.set('binderCount', cardCount());
        if (!cast) { try { takeCast(F.get('cast')); } catch (e) { /* fine */ } }
        if (!SITE) libFirst().then(() => { if (ctx.alive()) { F.set('shelves', counts()); F.set('read', readMap()); } });
      } else F.art.style.opacity = '';
      const offTally = FFD.tally.on(() => { if (ctx.alive() && sceneOk) F.set('ledger', ledger()); });
      ctx.onKill(offTally);
      /* warm the Guide's first page, the shelves and the deck while the reader looks around */
      const idle = window.requestIdleCallback ? (fn) => window.requestIdleCallback(fn, { timeout: 2500 }) : (fn) => setTimeout(fn, 1200);
      idle(() => {
        if (!ctx.alive()) return;
        libFirst().then(() => { if (ctx.alive() && sceneOk && SITE && books.length) { F.set('shelves', counts()); F.set('read', readMap()); } });
        if (cards && typeof cards.ready === 'function') { try { Promise.resolve(cards.ready()).catch(() => {}); } catch (e) { /* fine */ } }
      });

      /* ================= coming in ================= */
      /* a first visit: the shelves glint once as Zhaunil names them, and if nothing is touched for about 8 seconds after,
         one soft ring breathes on the nearest shelf, once (the room is the way in: no menu, Jan 2026-10-28) */
      function shelfGlint() {
        if (!sceneOk || !ctx.alive()) return;
        const ids = BAYS.map((k) => 'bay-' + k).filter((id) => F.spotCss(id));
        if (ids.length) F.hint(ids);
      }
      function beaconLater() {
        if (!firstVisit) return;
        lastTap = Date.now();
        const t = setInterval(() => {
          if (!ctx.alive()) { clearInterval(t); return; }
          if (!free() || Date.now() - lastTap < 8000 || !F.spotCss(BEACON)) return;
          clearInterval(t);
          beaconLit = true; F.beacon([BEACON], true);
        }, 500);
        ctx.onKill(() => clearInterval(t));
      }
      /* the intro: the room lights up (the painter's 'intro', 'introed' at its end); a tap anywhere skips to the end */
      async function introFlow(tok) {
        let skipped = null;
        const skipP = new Promise((r) => { skipped = r; });
        const btn = h('button', { type: 'button', class: 'lb-skip', 'aria-label': 'Skip the intro' });
        btn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); skipped(); });
        const onKey = (e) => {
          const ae = document.activeElement;
          if (ae && ae !== document.body && ae !== document.documentElement && !F.el.contains(ae)) return;
          if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); skipped(); }
        };
        document.addEventListener('keydown', onKey, true);
        const off = () => { document.removeEventListener('keydown', onKey, true); btn.remove(); };
        ctx.onKill(off);
        F.el.append(btn);
        /* the frame's idle sparkle waits until the room is lit */
        F.busy(true);
        let how = 'done';
        if (sceneOk) {
          const done = F.once('introed', 8000);
          F.act('intro');
          how = await Promise.race([done.then(() => 'done'), skipP.then(() => 'skip')]);
        }
        off();
        F.busy(false);
        if (!ctx.alive()) return;
        /* skipped: the art cuts to the lit room (its 'introed' comes too, and nothing waits on it any more) */
        if (how === 'skip') F.act('intro', { skip: true });
        /* the room is lit: Zhaunil's two lines give way to whatever the reader touches (the deck's ring still comes) */
        tok.can = true;
        tok.ends.push(beaconLater);
        tok.ends.push(arriveWhenStill);
        for (const t of L.intro) {
          await step(tok, F.say([line(t)], { who: ZH, now: true }));
          shelfGlint();
          await step(tok, F.cont({ always: true }));
        }
        F.clear();
        tok.ends.length = 0;
        beaconLater();
      }
      /* walking back in through a painting: the room zooms out of it */
      async function arrive(id) {
        const art = F.art;
        let r = null;
        const t0 = Date.now();
        /* a painting still locked here (played from the Guide or a link) has no door to come out of: a plain fade */
        while (ctx.alive() && !shut(id) && !(r = F.spotCss('paint-' + id)) && Date.now() - t0 < 900) await new Promise((res) => requestAnimationFrame(res));
        if (!ctx.alive()) return;
        if (!r) {
          art.style.opacity = '';
          await art.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, easing: 'ease-out' }).finished.catch(() => {});
          return;
        }
        const z = zoomOf(r);
        F.el.classList.add('lb-portal');
        art.style.transformOrigin = r.cx + 'px ' + r.cy + 'px';
        art.style.opacity = '';
        sound('whoosh');
        await art.animate([{ transform: z, opacity: 0 }, { opacity: 1, offset: 0.3 }, { transform: 'translate(0px, 0px) scale(1)', opacity: 1 }], { duration: 850, easing: 'cubic-bezier(.2, .7, .25, 1)' }).finished.catch(() => {});
        F.el.classList.remove('lb-portal'); art.style.transformOrigin = '';
      }
      /* the full-screen room waits dark under the Enter gate; the tap starts the first record (the gate's own script),
         and the jukebox wakes and lights the room */
      const entered = () => new Promise((res) => {
        if (window.FFD_ENTERED) { res(); return; }
        const on = () => { document.removeEventListener('ffd:enter', on); res(); };
        document.addEventListener('ffd:enter', on);
        ctx.onKill(() => document.removeEventListener('ffd:enter', on));
      });
      async function enterFlow(tok) {
        F.busy(true);
        await entered();
        if (!ctx.alive()) return;
        if (backFrom && sceneOk && !RM()) { F.art.style.opacity = '0'; }
        if (jukebox && sceneOk) jukebox.enter({ first: firstVisit });
        if (sceneOk) {
          const done = F.once('introed', 8000);
          F.act('intro');
          if (backFrom && !RM()) { await arrive(backFrom); F.act('intro', { skip: true }); } else await step(tok, done);
        }
        F.art.style.opacity = '';
        F.busy(false);
        if (!ctx.alive()) return;
        if (pan && !backFrom && !panned) {
          const host = F.spotCss('zhaunil');
          if (host && F.art.clientWidth) lookAt(host.cx / F.art.clientWidth, { share: true, instant: true, force: true });
        }
        setTimeout(panHint, 1200);
        musicCheck();
        idle(refreshLedger);
        tok.can = true;
        tok.ends.push(beaconLater);
        tok.ends.push(arriveWhenStill);
        const lines = firstVisit ? L.intro : [greetLine()];
        /* a first visit on a screen that shows only part of the room (an upright phone): "The paintings take longer"
           glides to the wall of locks, and the jukebox's line glides back. Never once the reader has looked around */
        let home = null;
        for (let i = 0; i < lines.length; i++) {
          if (firstVisit && !panned && i === 1) home = wallTour();
          else if (firstVisit && !panned && i === 2 && home != null) lookAt(home, { share: true, force: true, dur: 1100 });
          await step(tok, F.say([line(lines[i])], { who: ZH, now: true }));
          if (firstVisit) shelfGlint();
          await step(tok, F.cont({ always: true }));
        }
        F.clear();
        tok.ends.length = 0;
        beaconLater();
        queueArrival();
      }
      /* a returning reader's greeting: back through a painting, late at night, now and then the poster, or one of his
         usual ones */
      function greetLine() {
        if (backFrom && shut(backFrom)) return L.another;
        if (backFrom && RETURNS[backFrom]) return RETURNS[backFrom];
        try { if (typeof FFD.when === 'function' && FFD.when().late) return L.late; } catch (e) { /* fine */ }
        if (gallery && !tookQuest() && st.visits % 3 === 0) return L.stillUp;
        return pickOf(L.back);
      }
      /* the ledger's quiet daily look at the Hall, for a reader already signed in there (library/ledger.js refresh) */
      function refreshLedger() {
        if (!signLedger || !ctx.alive()) return;
        Promise.resolve().then(() => signLedger.refresh()).then((r) => {
          if (!r || !ctx.alive() || !r.took) return;
          if (r.fresh) knowFresh = true;
          knowNow();
          paintGallery();
          if (recogDue()) queueArrival();
        }).catch(() => {});
      }
      if (FULL) run('enter', enterFlow, NOGIVE);
      else if (firstVisit) run('intro', async (tok) => { await introFlow(tok); queueArrival(); idle(refreshLedger); }, NOGIVE);
      else run('greet', async () => {
        if (backFrom && sceneOk && !RM()) await arrive(backFrom);
        F.art.style.opacity = '';
        /* the gallery's moment greets the reader itself when it is due */
        if (ctx.alive() && !recogDue() && !keyDue()) aside(greetLine());
        idle(refreshLedger);
        queueArrival();
      }, NOGIVE);

      /* ================= the Guide book ================= */
      /* A short wide frame (under 620 px: a laptop under the store's header) takes the window while the book is open
         (.lb-tall): its top goes just under any bar that stays at the top, it grows to the window's foot, and the page
         moves there at once (the book's dim is rising over it). It stays tall until the room is free again, so the owl
         carries its book home in it, then the art fades, the frame shrinks, the page goes back to where the reader had
         it (unless the reader moved it) and the art fades in once the scene has redrawn at its own size. A phone's book
         already has the whole frame. */
      let tall = null, shrinking = null;
      function tallOn() {
        if (tall || !WIDE() || !ctx.alive()) return;
        const h0 = F.el.offsetHeight, ins = topInset(F.el), vh = window.innerHeight || 0;
        if (h0 >= 620 || vh - ins < h0 + 24) return;
        tall = { y: window.scrollY || 0, to: 0 };
        F.el.style.setProperty('--lb-inset', ins + 'px');
        F.el.classList.add('lb-tall');
        goTo(tall.y + F.el.getBoundingClientRect().top - ins);
        tall.to = window.scrollY || 0;
        /* a header that shows itself when the page moves up moved the frame too: once more after it settles */
        setTimeout(() => {
          if (!tall || !ctx.alive()) return;
          const ins2 = topInset(F.el), t = F.el.getBoundingClientRect().top;
          if (Math.abs(t - ins2) > 1) { F.el.style.setProperty('--lb-inset', ins2 + 'px'); goTo((window.scrollY || 0) + t - ins2); tall.to = window.scrollY || 0; }
        }, 220);
      }
      function tallOff() {
        if (!tall || shrinking) return shrinking;
        const t = tall;
        tall = null;
        shrinking = (async () => {
          const art = F.art, fade = sceneOk && !RM();
          let out = null;
          if (fade) { out = art.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 140, easing: 'ease-in', fill: 'forwards' }); await out.finished.catch(() => {}); }
          if (!ctx.alive()) return;
          const cv = () => { const l = art.querySelectorAll('canvas.qo-scenes__cv'); return l.length ? l[l.length - 1] : null; };
          const sig = () => { const c = cv(); return c ? c.style.top + c.style.height + c.width : ''; };
          const was = sig();
          F.el.classList.remove('lb-tall');
          F.el.style.removeProperty('--lb-inset');
          if (Math.abs((window.scrollY || 0) - t.to) < 4) goTo(t.y);
          if (!fade) return;
          /* the scene redraws at its own size about 180 ms after the frame changes: the art comes back once it has */
          const t0 = Date.now();
          while (ctx.alive() && sig() === was && Date.now() - t0 < 420) await new Promise((r) => requestAnimationFrame(r));
          if (!ctx.alive()) return;
          const back = art.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
          out.cancel();
          await back.finished.catch(() => {});
        })().catch(() => {}).then(() => { shrinking = null; });
        return shrinking;
      }
      /* the window resized while the frame is tall: a phone-sized window has its own full frame; a wide one keeps the
         frame just under the bar at the top */
      let tallRz = 0;
      const onTallRz = () => {
        cancelAnimationFrame(tallRz);
        tallRz = requestAnimationFrame(() => {
          if (!tall || !ctx.alive()) return;
          if (!WIDE()) { F.el.classList.remove('lb-tall'); F.el.style.removeProperty('--lb-inset'); tall = null; return; }
          const ins = topInset(F.el), top = F.el.getBoundingClientRect().top;
          F.el.style.setProperty('--lb-inset', ins + 'px');
          if (Math.abs(top - ins) > 1) { goTo((window.scrollY || 0) + top - ins); tall.to = window.scrollY || 0; }
        });
      };
      window.addEventListener('resize', onTallRz);
      ctx.onKill(() => { window.removeEventListener('resize', onTallRz); cancelAnimationFrame(tallRz); });
      /* the book over the room; resolves 'library' or 'another' */
      async function readIn(o) {
        if (!book) { await noBook(); return 'library'; }
        finishedNow = 0;
        F.clear();
        if (shrinking) await shrinking;
        if (!ctx.alive()) return 'library';
        tallOn();
        frameIntoView();
        F.busy(true);
        let res = 'library';
        try { res = await book.open(o); } catch (e) { console.error(e); }
        F.busy(false);
        if (sceneOk && !lectern) F.set('out', null);
        return res === 'another' ? 'another' : 'library';
      }
      const noBook = () => leaveAsk({ line: L.dark, yes: 'Go to the Guide', href: ROUTES.guide });
      /* what comes after a book: another (the owl fetches again), or a word when one was finished */
      async function afterBook(res, bay) {
        if (!ctx.alive()) return;
        if (res === 'another') return owlFetch({ bay: bay || null });
        if (finishedNow) { finishedNow = 0; return aside(L.done); }
      }
      async function openContents(bay) {
        if (!book) return noBook();
        const res = await readIn({ bay: bay || null, from: bay ? SHELF[bay].from : '' });
        return afterBook(res, bay);
      }
      /* a shelf (Jan, 2026-10-28): the owl flies to it and brings one of its books to the lectern, offered on its card */
      async function openShelf(k) {
        poke('bay-' + k);
        FFD.tally.add(ID, 'w-' + k);
        if (sceneOk) { F.act('ink', { bay: k }); F.set('ledger', ledger()); }
        F.clear();
        return owlFetch({ bay: k });
      }
      /* a book for the owl to fetch: from one shelf or the whole room, a natural 20 brings one of Jan's picks and a 1 the
         dustiest book. The first page of the Guide is usually warm already; a shelf it lacks waits for the rest */
      async function owlFetch(o) {
        o = o || {};
        if (!book || !offer) return noBook();
        const pick = () => (o.tone === 'pick' ? janPick() : o.tone === 'dust' ? dusty() : smart({ bay: o.bay, char: !!(FFD.char && FFD.char.name) }));
        await libFirst();
        let b = pick();
        if (!b) { await libAll(); b = pick(); }
        if (!ctx.alive()) return;
        if (!b) return dark();
        return fetchAndOffer(b, o);
      }
      /* Soryndel fetches the book to the lectern and it rises on its card (library/offer.js): Read it opens it in the
         Guide book over the room, Another book sends her straight back to the same shelf (the first book slips home on
         its own), and closing lets her return it while the room is already free */
      let fetchN = 0, putAt = -1e9;
      async function fetchAndOffer(b, o) {
        o = o || {};
        const bay = b.k, i = shelf[bay].indexOf(b), mine = ++fetchN;
        textFor(b);
        coverOf(b, 800);
        st.seen.push(b.h); keep(st);
        /* every wait is listening before its event is sent (under reduced motion the painter answers at once). A book
           put back moments ago is still on its way home, and the painter starts this fetch only after it (up to 3.2 s),
           so the card waits that long too rather than rising before the owl lands */
        if (sceneOk) {
          const landed = F.once('landed', 5200 + Math.max(0, 3300 - (Date.now() - putAt)));
          F.act('fetch', { bay, i, dust: o.tone === 'dust' });
          await landed;
          if (!ctx.alive()) return;
          lectern = true;
          F.set('out', { bay, i });
        }
        const said = await offer.show(b, { roll: o.roll || 0, tone: o.tone || '' });
        if (!ctx.alive()) return;
        const putBack = () => {
          lectern = false;
          if (!sceneOk) return;
          putAt = Date.now();
          F.once('shelved', 5200).then(() => { if (ctx.alive() && fetchN === mine && !lectern) F.set('out', null); });
          F.act('shut');
          F.act('return', { bay, i });
        };
        if (said === 'another') return owlFetch({ bay: o.bay || null });
        if (said !== 'read') { putBack(); return; }
        if (sceneOk) {
          const opened = F.once('opened', 1400);
          F.act('open');
          await opened;
          if (!ctx.alive()) return;
        }
        const res = await readIn({ book: b, from: 'Soryndel brought this one' });
        if (!ctx.alive()) return;
        putBack();
        return afterBook(res, o.bay);
      }
      /* Soryndel's d20: a 20 brings one of Jan's picks, a 1 the dustiest book, anything else a good one. The die says it
         (on the card), nobody has to */
      async function owlRead() {
        const r = await F.roll({ dice: [{ sides: 20 }], now: true, hot: 'owl' });
        if (!ctx.alive() || !r) return;
        poke('owl');
        /* the d20 stays in view long enough to read */
        await sleep(RM() ? 600 : 900);
        if (!ctx.alive()) return;
        F.clearDice(); F.clear();
        const nat = r.nat || r.total || 0;
        return owlFetch({ roll: nat, tone: nat === 20 || r.crit ? 'pick' : nat === 1 || r.fumble ? 'dust' : '' });
      }
      /* no books came: say so kindly; the whole Guide is the way on, after a yes */
      async function dark() { return leaveAsk({ line: L.dark, yes: 'Go to the Guide', href: ROUTES.guide }); }
      /* Zhaunil is the room's guide: a book, Jan's favorite heroes, or his secret for a reader the room knows. It gives
         way to another tap until something is chosen */
      async function askZhaunil(tok) {
        poke('zhaunil');
        const sec = secretOpt();
        const opts = [{ label: L.helpStory, value: 'story', hot: 'owl' }]
          .concat(favorites ? [{ label: L.helpHeroes, value: 'heroes', hot: 'easel' }] : [], sec ? [sec] : [], [{ label: L.helpNo, used: false, value: 'no' }]);
        const r = await step(tok, ask(L.help, opts, { used: true }));
        if (!r || !ctx.alive() || r.cancelled) return;
        F.clear();
        if (r.value === 'story') { tok.can = false; return owlFetch({}); }
        if (r.value === 'heroes') return openHeroes(tok);
        /* the secret for a Quest taker: their own line first, then the riddles for the hidden token borders, then the lore */
        if (r.value === 'secret') {
          const ls = secretLines();
          if (!ls.isMe) { await step(tok, talk(ls)); return; }
          /* the first secret names the reader: on a shared phone it can be someone else's hero, so they can say so
             (FFD.quest.forget, the "Not you?" of the scene pages; open paintings stay open) */
          const r2 = await step(tok, ask(ls, [{ label: SECRET.yesMe, value: 'yes' }, { label: SECRET.notMeAsk, value: 'not' }], { cols: 2 }));
          if (!r2 || r2.value !== 'not') { F.clear(); return; }
          F.clear();
          try { if (FFD.quest && FFD.quest.v === 1) FFD.quest.forget(); } catch (e) { /* fine */ }
          knowNow(); paintGallery();
          await step(tok, talk([SECRET.notMe]));
          return;
        }
        /* the room keeps its secrets for readers who've been somewhere: Zhaunil looks at the poster */
        if (r.value === 'hidden' || r.value === 'locks') {
          if (sceneOk) F.act('glance', { to: 'poster' });
          await step(tok, talk(r.value === 'hidden' ? [SECRET.plenty] : SECRET.behind));
        }
      }
      /* Jan's favorite portraits on their gallery wall (library/favorites.js); its "Ask Jan" brings Ember in to the easel */
      async function openHeroes(tok) {
        poke('easel');
        if (!favorites) return emberFlow(tok);
        F.clear();
        emberNext = false;
        await favorites.open();
        if (!ctx.alive() || !emberNext) return;
        emberNext = false;
        return emberFlow(tok);
      }
      /* the violet door: one question, then Unbound */
      async function unboundFlow(tok) {
        poke('door');
        return leaveAsk({ tok, lines: L.unbound, yes: L.unboundGo, href: ROUTES.unbound });
      }

      /* ================= the Hall cards ================= */
      /* the deck (Jan, 2026-10-07): the first tap each day opens today's pack of three for the binder; after that it
         deals single cards to look at, never kept, with Draw another and the time to tomorrow's pack under each.
         cont: a draw after Draw another, which opens nothing if the reader closed the waiting dim meanwhile */
      async function drawCards() {
        if (!cards) return aside(L.deckless);
        const due = () => { try { return typeof cards.openPack === 'function' && typeof cards.today === 'function' && cards.today().pack === true; } catch (e) { return false; } };
        frameIntoView();
        for (let cont = false; ; cont = true) {
          const drawn = sceneOk ? F.once('drawn', 1400) : Promise.resolve();
          if (sceneOk) F.act('draw');
          if (due()) {
            await drawn;
            if (!ctx.alive()) return;
            F.busy(true);
            let r = 'cancelled';
            try { r = await cards.openPack({ from: vpRect('deck'), cont }); } catch (e) { console.error(e); }
            F.busy(false);
            if (r === 'empty' && ctx.alive()) aside(L.deckless);
            return;
          }
          const [, c] = await Promise.all([drawn, Promise.resolve().then(() => cards.next()).catch(() => null)]);
          if (!ctx.alive()) return;
          if (!c) return aside(L.deckless);
          F.busy(true);
          let r = 'library';
          try { r = await cards.show(c, { from: vpRect('deck'), label: 'A card from the Hall of Heroes', draw: true, cont }); } catch (e) { console.error(e); }
          F.busy(false);
          if (!ctx.alive() || r !== 'again') return;
        }
      }
      async function openBinder() {
        poke('binder');
        if (!cards || typeof cards.binder !== 'function') return aside(L.binderless);
        await Promise.race([libAll(), sleep(1500)]);
        if (!ctx.alive()) return;
        frameIntoView();
        F.busy(true);
        try { await cards.binder(); } catch (e) { console.error(e); }
        F.busy(false);
      }

      /* ================= Jan, as Ember, at the easel ================= */
      /* the sizes and their prices: the store's own product, live (Shopify's product JSON, prices in cents); the demo's
         are fixed. Every size's price is its cheapest variant's, and a size is open when any of its variants is */
      let priceP = null;
      function prices() {
        if (!SITE) return Promise.resolve(DEMO_SIZES);
        if (priceP) return priceP;
        const url = String(ROUTES.product || '').replace(/[?#].*$/, '').replace(/\/$/, '') + '.js';
        priceP = fetch(url, { credentials: 'same-origin' }).then((r) => { if (!r.ok) throw new Error('status ' + r.status); return r.json(); }).then((j) => {
          const by = new Map();
          (Array.isArray(j && j.variants) ? j.variants : []).forEach((v) => {
            const t = String(v.option1 || v.title || '').split(' / ')[0].trim();
            const cents = Math.round(+v.price);
            if (!t || !isFinite(cents) || cents <= 0) return;
            const s = by.get(t) || { name: t.toLowerCase().replace(/-/g, ' '), cents, open: false };
            s.cents = Math.min(s.cents, cents);
            s.open = s.open || v.available === true;
            by.set(t, s);
          });
          const list = [...by.values()].sort((a, b) => a.cents - b.cents);
          if (!list.length) throw new Error('no sizes');
          return list;
        }).catch(() => { priceP = null; return null; });
        return priceP;
      }
      function costLines(sizes) {
        if (!sizes || !sizes.length) return [EMBER.noPrices];
        const first = cap1(joinAnd(sizes.map((s) => s.name + ' is ' + money(s.cents)))) + '.';
        const open = sizes.filter((s) => s.open);
        if (!open.length) return [first, EMBER.booked];
        if (open.length === sizes.length) return [first, 'Every size is' + EMBER.open];
        return [first, cap1(joinAnd(open.map((s) => s.name))) + (open.length === 1 ? ' is' : ' are') + EMBER.open];
      }
      /* Jan walks in as Ember. Any tap on another thing before 'ready' gets its yes sends her back out the door and opens
         that thing; after 'Just looking' she says goodbye and goes */
      async function emberFlow(tok) {
        poke('easel');
        const pricesP = prices();
        tok.ends.push(walkOutNow);
        await step(tok, walkerGone);
        if (sceneOk) {
          const came = F.once('arrived', 7000);
          F.act('walk-in', { id: 'ember', to: 'easel' });
          walkerIn = 'ember';
          await step(tok, came);
        }
        /* her hello is its own beat, so the eight questions come under one short line and the box stays low enough to
           keep her in view on a phone */
        await step(tok, talk(EMBER.first, JAN));
        for (let n = 0; ; n++) {
          await step(tok, F.say([line(n ? next('em', EMBER.more) : EMBER.ask, JAN)], { who: JAN, now: true }));
          const r = await step(tok, F.ask(EMBER.asks.map((q) => ({ label: q.label, key: 'em-' + q.id, value: q.id })), { used: true, sheet: false }));
          if (r.value === 'bye') { await step(tok, talk(EMBER.bye, JAN)); break; }
          if (r.value === 'ready' && waitlist) {
            const c = await step(tok, ask([EMBER.ready], [{ label: EMBER.readyHere, value: 'here' }, { label: EMBER.readyYes, value: 'page' }], { cols: 1 }, JAN));
            if (!c || c.cancelled) return;
            F.clear();
            if (c.value === 'here') {
              tok.can = false;
              const res = await step(tok, waitlist.open());
              tok.can = true;
              if (res === 'joined') continue;
              continue;
            }
            const how2 = await step(tok, leaveNow({ tok, href: ROUTES.product }));
            if (how2 === 'away') return;
            if (how2 === 'tab') break;
            continue;
          }
          if (r.value === 'ready') {
            const how = await step(tok, leaveAsk({ tok, who: JAN, lines: [EMBER.ready, EMBER.readyWhere], yes: EMBER.readyYes, href: ROUTES.product }));
            if (how === 'away') return;
            if (how === 'tab') break;
            continue;
          }
          const q = EMBER.asks.find((x) => x.id === r.value) || {};
          const lines = r.value === 'cost' ? costLines(await step(tok, Promise.race([pricesP, sleep(2500).then(() => null)]))) : q.lines;
          await step(tok, talk(lines, JAN));
        }
        F.clear();
        tok.ends.length = 0;
        walkOutNow();
      }
      /* whoever stands in the room walks out, once (a second 'walk-out' would jump them back to their spot), and the
         next walker waits for 'gone' (the painter has one walker slot) */
      function walkOutNow() {
        if (!walkerIn || walkerLeaving) return walkerGone;
        const id = walkerIn;
        if (F.hot) F.hot('walker', roomHots.walker);
        if (!sceneOk) { walkerIn = null; return walkerGone; }
        walkerLeaving = true;
        /* on a phone the Guide book parks the scene while it is open (library/book.js), so the walk finishes only once
           the book has gone: keep listening until then */
        const waitGone = () => F.once('gone', 7000).then((d) => (d && d.timeout && ctx.alive() && F.el.querySelector('.lbk') ? waitGone() : d));
        const gone = waitGone();
        F.act('walker-give', { off: true });
        F.act('walk-out');
        walkerGone = gone.then(() => { walkerLeaving = false; if (walkerIn === id) walkerIn = null; });
        return walkerGone;
      }

      /* ================= a hero from the Hall, at the door ================= */
      /* a Hall slug to the pixel hero the painter draws: the same id, a known alias, or the id the slug starts with */
      function pixOf(slug) {
        slug = String(slug || '').trim().toLowerCase();
        if (!slug) return null;
        if (WALK_ALIAS[slug]) return WALK_ALIAS[slug];
        if (cast) {
          if (cast.includes(slug)) return slug;
          const hit = cast.filter((c) => slug.startsWith(c + '-')).sort((a, b) => b.length - a.length)[0];
          return hit || null;
        }
        return slug.split('-')[0] || null;
      }
      /* who may walk in: on the store only the heroes Jan listed (their players said yes), in the demo Jan's featured
         heroes; always ones the painter can draw, never ford or allagis */
      function walkPool() {
        const can = (id) => !!id && !DENY.includes(id) && (!cast || cast.includes(id)) && heroOk(id);
        if (SITE) {
          const list = Array.isArray(SITE.walkers) ? SITE.walkers : ['ember'];
          return list.map((s) => String(s || '').trim().toLowerCase()).filter((s) => s && !DENY.includes(s))
            .map((slug) => ({ slug, pix: pixOf(slug) })).filter((w) => can(w.pix));
        }
        return (window.FFD_HEROES || []).filter((x) => x && x.featured === true && x.ff !== false && can(x.slug)).map((x) => ({ slug: x.slug, pix: x.slug, hero: x }));
      }
      /* nobody twice until everyone has come (in this browser) */
      function pickWalker(pool) {
        let fresh = pool.filter((w) => !st.came.includes(w.pix));
        if (!fresh.length) {
          const last = st.came[st.came.length - 1];
          st.came = st.came.filter((id) => !pool.some((w) => w.pix === id));
          fresh = pool.length > 1 ? pool.filter((w) => w.pix !== last) : pool.slice();
        }
        const w = pickOf(fresh);
        st.came.push(w.pix); keep(st);
        return w;
      }
      const shortName = (n, hero) => {
        if (hero && hero.short) return hero.short;
        n = String(n || (hero && hero.name) || 'A hero').split(',')[0].trim();
        if (n.length <= 22) return n;
        const nick = n.match(/["“]([^"”]+)["”]/);
        return nick ? nick[1] : n.split(/\s+/)[0];
      };
      const POSS = { she: 'her', he: 'his', they: 'their' };
      /* the walker's hand, at chest height, where the card comes from */
      function handRect() {
        const r = F.spotCss('walker') || F.spotCss('door');
        if (!r) return null;
        const ar = F.art.getBoundingClientRect();
        return new DOMRect(ar.left + r.x + r.w * 0.25, ar.top + r.y + r.h * 0.3, r.w * 0.5, r.h * 0.3);
      }
      const safe = (fn, d) => { try { const v = fn(); return v == null ? d : v; } catch (e) { return d; } };
      /* a hero walks in and offers their card and their story (Jan, 2026-10-06: "just show card tell story dont visit the
         hall"). Once the reader has seen both (or the story, when their card wasn't found) they say goodbye and walk out;
         a tap on anything else sends them out the door at once (only their card, while it is up, holds the room) */
      /* the reader's own hero, once a day, when it is in the Hall for everyone to see and the painter can draw it */
      function ownWalker() {
        const me = questHero();
        if (!me || me.public !== true || !me.slug || !tookQuest()) return null;
        const pix = pixOf(me.slug);
        if (!pix || DENY.includes(pix) || (cast && !cast.includes(pix))) return null;
        const e = egg();
        if (!e || !e.daily('walker-me')) return null;
        return { slug: me.slug, pix, own: true };
      }
      async function walkerFlow(tok) {
        const pool = walkPool(), own = ownWalker();
        if (!pool.length && !own) { poke('door'); await step(tok, leaveAsk({ tok, line: L.hallQuiet, yes: WALK.hallYes, href: ROUTES.hall })); return; }
        const w = own || pickWalker(pool);
        const cardP = cards && typeof cards.find === 'function' ? Promise.resolve().then(() => cards.find(w.slug)).catch(() => null) : Promise.resolve(null);
        tok.ends.push(walkOutNow);
        await step(tok, walkerGone);
        let came = Promise.resolve();
        if (sceneOk) { came = F.once('arrived', 7000); F.act('walk-in', { id: w.pix, to: 'mid' }); walkerIn = w.pix; }
        const [card] = await step(tok, Promise.all([cardP, came]));
        const hero = w.hero || heroOf(w.pix);
        const name = shortName(card && card.name, hero);
        const img = (card && cards ? safe(() => cards.portrait(card), null) : null) || (hero && hero.img) || (SITE && SITE.portraits && SITE.portraits[w.pix]) || null;
        const who = { name, img };
        const pr = hero ? hero.pronouns : (w.pix === 'ember' ? 'she' : null);
        F.hot('walker', { label: name, tap: () => poke('walker') });
        /* their card's quote when it reads as something said (an epithet alone isn't), else their catchphrase */
        const said = (s) => (/[.?!…]["”’)]*$/.test(String(s || '').trim()) ? String(s).trim() : '');
        const hello = w.own ? OWN_HELLO : said(card && cards ? safe(() => cards.line(card), '') : '') || said(hero && hero.attitude && hero.attitude.catchphrase) || WALK.hello;
        /* the reader's own hero is greeted by Zhaunil; anyone else says hello themselves */
        const greeter = w.own ? ZH : who;
        await step(tok, F.say([line(hello, greeter)], { who: greeter, now: true }));
        const k = 'wk-' + w.pix + '-';
        /* two choices sit on one row on a phone, so the box stays low and the walker stays in view. A used one greys
           with its tick and still works */
        const offer = card && cards ? ['card', 'story'] : ['story'], seen = new Set();
        for (let n = 0; !offer.every((v) => seen.has(v)); n++) {
          if (n) await step(tok, F.say([line(next('wk', WALK.more), who)], { who, now: true }));
          const opts = [];
          if (offer.includes('card')) opts.push({ label: 'Show me your card', key: k + 'card', value: 'card', hot: 'walker' });
          opts.push({ label: 'Tell me your story', key: k + 'story', value: 'story' });
          const r = await step(tok, F.ask(opts, { used: true, sheet: false }));
          seen.add(r.value);
          if (r.value === 'card') {
            F.clear();
            if (sceneOk) F.act('walker-give');
            await step(tok, sleep(RM() ? 0 : 280));
            frameIntoView();
            /* their card covers the room: nothing interrupts it */
            tok.can = false;
            F.busy(true);
            /* their card is a gift: it goes in the binder, and the line under it says so */
            try { await cards.show(card, { from: handRect(), again: false, free: true, by: POSS[pr] ? name + ' gives you ' + POSS[pr] + ' card' : name + ' hands you a card' }); } catch (e) { console.error(e); }
            F.busy(false);
            tok.can = true;
            if (!ctx.alive()) return;
            /* the card is back with them: their hand comes down */
            if (sceneOk) F.act('walker-give', { off: true });
            continue;
          }
          /* the legend reads as the card tells it (a narration line beside their portrait), not as a quote */
          const s = (card && cards ? safe(() => cards.story(card), '') : '') || (hero && hero.story ? sentences(hero.story, 2) : '');
          await step(tok, talk(s ? { text: s } : WALK.story, who));
        }
        await step(tok, talk(next('wkbye', WALK.bye), who));
        F.clear();
        tok.ends.length = 0;
        walkOutNow();
      }

      /* ================= the gallery ================= */
      /* the wall's values to the painter, only when they changed (a NEW locks object each time: a lock that came off
         stays off in the art until the next one, which must leave its id out). Never in the middle of a lock coming off */
      function paintGallery(force) {
        if (!sceneOk || opening || !ctx.alive()) return;
        const v = galVals(), sig = JSON.stringify(v);
        hungNow = v.thumbs.slice(0, capNow);
        if (!force && sig === galSig) return;
        galSig = sig;
        Object.keys(v).forEach((k) => F.set(k, v[k]));
        if (F.relayout) F.relayout();
      }
      /* how many frames the wall really holds (about 5 on a phone, 6 on a laptop): the painted spots tell */
      function wallCheck() {
        if (!sceneOk || !ctx.alive()) return;
        const n = scenesHere().filter((id) => F.spotCss('paint-' + id)).length;
        if (n > 0 && n !== capNow) { capNow = n; paintGallery(); }
      }
      let wallRz = 0;
      const onWallRz = () => { clearTimeout(wallRz); wallRz = setTimeout(wallCheck, 500); };
      window.addEventListener('resize', onWallRz);
      ctx.onKill(() => { window.removeEventListener('resize', onWallRz); clearTimeout(wallRz); });
      /* the camera on a phone finds a painting before something happens to it */
      function lookAtPainting(id) {
        const r = F.spotCss('paint-' + id);
        if (r && F.art.clientWidth) lookAt(r.cx / F.art.clientWidth, { share: true, force: true, dur: 700 });
      }
      /* the camera to the middle of today's wall, when some of it is out of view: where it was, as a share of the room
         (to glide back to), or null when there was nothing to show */
      function wallTour() {
        if (!pan || pan.scrollWidth - pan.clientWidth <= 2 || !F.art.clientWidth) return null;
        const rs = hungNow.map((id) => F.spotCss('paint-' + id)).filter(Boolean);
        if (!rs.length) return null;
        const a = Math.min(...rs.map((r) => r.x)), b = Math.max(...rs.map((r) => r.x + r.w)), l = pan.scrollLeft, w = pan.clientWidth;
        if (a >= l && b <= l + w) return null;
        const home = (l + w / 2) / F.art.clientWidth;
        lookAt((a + b) / 2 / F.art.clientWidth, { share: true, force: true, dur: 1100 });
        return home;
      }
      /* the poster hangs at the room's far left: the camera finds it before anything points there (instant under
         reduced motion) */
      function lookAtPoster() {
        const r = F.spotCss('poster');
        lookAt(r && F.art.clientWidth ? r.cx / F.art.clientWidth : 0, { share: true, force: true });
      }
      /* Soryndel brings the key and the lock comes off (the painter's lock-open, about 1.6 s). Nothing gives way to a tap
         meanwhile; afterwards the wall gets a new locks object without it, and the painting glints until walked through */
      async function openLock(tok, id) {
        tok.can = false;
        opening++;
        /* the drag hint never covers Soryndel and the key */
        if (hintEl) hintEl.classList.remove('is-on');
        try {
          if (sceneOk) {
            lookAtPainting(id);
            await sleep(RM() ? 0 : pan && pan.scrollWidth - pan.clientWidth > 2 ? 420 : 0);
            const done = F.once('lockopened', 3400);
            F.act('lock-open', { id });
            await done;
          }
        } finally { opening = Math.max(0, opening - 1); }
        if (!ctx.alive()) return;
        try { gallery.unkey(id); } catch (e) { /* fine */ }
        paintGallery();
        sound('gold');
        tok.can = true;
      }
      /* a locked painting never leads out: its lock answers, and Zhaunil says something. A reader the room doesn't know
         yet climbs his ladder toward the poster (one rung a tap, kept across visits); a Quest taker hears when it opens */
      async function lockFlow(tok, id, s) {
        if (sceneOk) F.act('lock-rattle', { id });
        if (!gallery) return;
        gallery.tapped();
        if (tookQuest()) {
          if (s === 'next') {
            if (burst('lock-' + id, 1600) >= 3) {
              try { if (FFD.burst && FFD.burst.clear) FFD.burst.clear('lock-' + id); } catch (e) { /* fine */ }
              if (sceneOk) F.act('lock-glow', { id });
              return aside(LOCK.glow);
            }
            return aside(LOCK.next);
          }
          return aside(LOCK.later);
        }
        const rung = gallery.nudge();
        if (rung === 1) { if (sceneOk) F.act('glance', { to: 'poster' }); return aside(LOCK.ladder[0]); }
        if (rung === 2) return aside(LOCK.ladder[1]);
        if (rung === 3) {
          lookAtPoster();
          const r = await step(tok, ask(LOCK.ladder[2], [{ label: LOCK.poster, key: 'lk-poster', value: 'poster', hot: 'poster' }, { label: LOCK.went, key: 'lk-went', value: 'went' }, { label: LOCK.not, value: 'no', used: false }], { cols: 1, beaconAfter: 0 }));
          if (!r || r.cancelled || !ctx.alive()) return;
          F.clear();
          if (r.value === 'poster') { tok.can = false; return posterFlow(tok, { medium: 'lock' }); }
          if (r.value === 'went') return ledgerFlow(tok);
          return;
        }
        return aside(next('lockjoke', LOCK.jokes));
      }
      /* "I already went after her": Zhaunil's ledger over the room. A hero found plays the room's own recognition */
      async function ledgerFlow(tok, o) {
        tok.can = false;
        F.clear();
        if (!signLedger) return;
        let r = null;
        try { r = await signLedger.open(o && o.line ? { line: o.line } : undefined); } catch (e) { console.error(e); r = null; }
        if (!ctx.alive() || !r || !r.took) return;
        if (r.fresh) knowFresh = true;
        knowNow();
        paintGallery();
        return arrivalFlow(tok);
      }
      /* the poster's corner lifts and its beacon breathes for a moment (after an email the ledger doesn't know) */
      function pointPoster() {
        try {
          if (!ctx.alive()) return;
          lookAtPoster();
          if (sceneOk) F.act('glance', { to: 'poster' });
          F.beacon(['poster'], true);
          setTimeout(() => { try { if (ctx.alive()) F.beacon(['poster'], false); } catch (e) { /* fine */ } }, 4000);
        } catch (e) { /* fine */ }
      }
      /* the moment the room knows the reader (about 10 s, every beat waits for a tap): Zhaunil names them, the WANTED
         posting rises and the Iron Matron is inked in, crossed out and stamped, then Soryndel brings the key to the next
         painting and its door is offered. On a later new day: "Soryndel found another key", the lock, the door.
         o.fromPoster: the reader tapped the poster themselves, so the posting opens at once */
      async function arrivalFlow(tok, o) {
        o = o || {};
        if (!gallery || !tookQuest()) return;
        const hero = questHero(), named = !!(hero && hero.name);
        let met = false;
        tok.can = true;
        if (recogDue()) {
          if (!o.fromPoster) {
            await step(tok, F.say([line(heroLine(named ? LOCK.known : LOCK.knownNo, hero))], { who: ZH, now: true }));
            await step(tok, F.cont({ always: true }));
            F.clear();
          }
          tok.can = false;
          paintGallery();
          F.busy(true);
          let res = 'back';
          try { res = await postingDone({ moment: true }); } finally { F.busy(false); }
          if (!ctx.alive()) return;
          /* the paper went before the stamp landed (Back from the browser's cache): onShow plays the moment again from
             the start, so nothing here goes on as if it had */
          if (!gallery.stamped()) { F.clear(); return; }
          knowFresh = false;
          met = true;
          tok.can = true;
          if (res === 'again') return questAgain(tok);
          await step(tok, F.say([line(LOCK.off)], { who: ZH, now: true }));
          await step(tok, F.cont({ always: true }));
        }
        /* every lock still waiting comes off (a visit cut short leaves one), oldest first; the newest is the door offered */
        const ids = gallery.keys();
        if (!ids.length) {
          F.clear();
          /* the first recognition: the cart is the way in today, the next key comes tomorrow */
          if (met && sceneHref('coin')) return goThrough(tok, 'coin', LOCK.tomorrow);
          return;
        }
        /* the recognition's own painting (the first opened after the cart) still waits for its key: the last visit
           ended after the stamp, so this is still the first key, and the parcel still names the hero */
        const first = gallery.open()[1] || null, firstKey = !met && !!first && ids.includes(first);
        await step(tok, F.say([line(met || firstKey ? LOCK.key : LOCK.again)], { who: ZH, now: true }));
        await step(tok, F.cont({ always: true }));
        F.clear();
        for (const k of ids) await step(tok, openLock(tok, k));
        const id = ids[ids.length - 1];
        const door = id === 'parcel' && (met || firstKey) ? heroLine(named ? LOCK.parcel : LOCK.parcelNo, hero) : (DOORS[id] || 'That painting opens onto ' + sceneTitle(id) + '.');
        return goThrough(tok, id, door);
      }
      /* the way through a painting, after a yes (now: the reader's pick already was the yes, so no question) */
      async function goThrough(tok, id, said, now) {
        const href = sceneHref(id);
        if (sceneOk) F.act('portal', { id });
        if (!href) return;
        const o = { tok, line: said, yes: 'Step through', href, before: async () => { walked(id); doorKeep(id); await zoomInto(id); } };
        const how = await step(tok, now ? leaveNow(o) : leaveAsk(o));
        if (how === 'tab') { walked(id); paintGallery(); }
      }
      const walked = (id) => { try { if (gallery) gallery.walked(id); } catch (e) { /* fine */ } };
      /* the Quest again, with a new hero: the posting's own button already says so ("Play the Quest with another hero"),
         so it leaves at once, with the fade, and asks nothing more */
      const questAgain = (tok) => step(tok, leaveNow({ tok, href: FFD.questHref(ID, 'poster-again') }));
      /* Ask Zhaunil's "Where do the paintings go?": the open paintings that aren't on the wall today. "Every open one is
         still a door", so the painting picked by its name is the reader's yes and goes through at once: its door line
         and "Step through" after it said the same thing again (Jan, 2026-10-11) */
      async function whereFlow(tok) {
        const off = gallery ? gallery.offWall(capNow) : [];
        if (!off.length) return;
        const r = await step(tok, ask(LOCK.rehang, off.map((id) => ({ label: cap1(sceneTitle(id)), key: 'wh-' + id, value: id })).concat([{ label: LOCK.never, value: 'no', used: false }]), { cols: WIDE() ? 2 : 1 }));
        if (!r || r.cancelled || !ctx.alive()) return;
        F.clear();
        if (r.value === 'no') return;
        return goThrough(tok, r.value, null, true);
      }
      /* the one secret in Ask Zhaunil, for a Quest taker (their own line first, then the riddles of the borders, then the
         lore of the room, one a day), or the room keeping its secrets from a reader it does not know yet */
      function secretOpt() {
        if (tookQuest()) return { label: SECRET.ask, key: 'ask-secret', value: 'secret' };
        if (gallery && gallery.locksTapped() > 0) return { label: SECRET.locks, key: 'ask-locks', value: 'locks' };
        if (borders && borders.left() > 0) return { label: SECRET.hidden, key: 'ask-hidden', value: 'hidden' };
        return null;
      }
      function secretLines() {
        const hero = questHero(), e = egg();
        if (hero && hero.name && e && !e.get('zh-me', false)) { e.set('zh-me', true); const me = [heroLine(SECRET.me, hero)]; me.isMe = true; return me; }
        if (borders && borders.left() > 0) { const l = borders.hint(); if (l) return l; }
        let n = 0;
        try { const d = typeof FFD.day === 'function' ? FFD.day() : ''; n = Math.floor(Date.parse(d + 'T12:00:00Z') / 864e5) || 0; } catch (e2) { n = 0; }
        return [SECRET.lore[((n % SECRET.lore.length) + SECRET.lore.length) % SECRET.lore.length]];
      }

      /* ================= through a painting ================= */
      /* the art's transform that puts painting r in the middle of the frame, big enough to fill it */
      function zoomOf(r) {
        const W = F.art.clientWidth, H = F.art.clientHeight;
        /* under the pan the frame is the part of the room on screen */
        const vw = pan ? pan.clientWidth : W, cxv = pan ? pan.scrollLeft + pan.clientWidth / 2 : W / 2;
        const s = Math.min(10, Math.max(vw / Math.max(8, r.w), H / Math.max(8, r.h)) * 1.08);
        return 'translate(' + Math.round(cxv - r.cx) + 'px, ' + Math.round(H / 2 - r.cy) + 'px) scale(' + s.toFixed(3) + ')';
      }
      async function zoomInto(id) {
        const r = F.spotCss('paint-' + id);
        if (!r || RM()) return;
        const art = F.art;
        F.el.classList.add('lb-portal');
        art.style.transformOrigin = r.cx + 'px ' + r.cy + 'px';
        sound('whoosh');
        await art.animate([{ transform: 'translate(0px, 0px) scale(1)' }, { transform: zoomOf(r) }], { duration: 900, easing: 'cubic-bezier(.55, 0, .9, .45)', fill: 'forwards' }).finished.catch(() => {});
      }
      function unzoom() {
        try { F.art.getAnimations().forEach((a) => a.cancel()); } catch (e) { /* fine */ }
        F.art.style.transformOrigin = ''; F.art.style.opacity = '';
        F.el.classList.remove('lb-portal', 'is-leaving');
      }
      /* open: Zhaunil names the place and offers the way through. Just opened, its lock still on: Soryndel brings the key
         first. Locked: the lock answers and it never leads out */
      async function portalFlow(tok, id) {
        const s = gstate(id);
        if (s === 'locked' || s === 'next') return lockFlow(tok, id, s);
        if (gallery && gallery.keyed(id)) await step(tok, openLock(tok, id));
        return goThrough(tok, id, DOORS[id] || 'That painting opens onto ' + sceneTitle(id) + '.');
      }

      /* ================= the poster: the Character Quest's WANTED posting ================= */
      /* the posting comes up over the room. "Take the posting" tears it off the wall, then Zhaunil asks in the box whether
         to leave for the quest (every way out asks first, spec section 3); "Leave it on the wall", a tap beside it,
         Escape and Back from the browser's cache put it back */
      let pScreen = null;
      async function posterFlow(tok, o) {
        o = o || {};
        poke('poster');
        /* a Quest taker: the moment, if it never played here (or the room learned a new hero), else the stamped paper */
        if (gallery && tookQuest()) {
          if (recogDue()) { await sleep(RM() ? 0 : 160); if (!ctx.alive()) return; return arrivalFlow(tok, { fromPoster: true }); }
          F.busy(true);
          await sleep(RM() ? 0 : 160);
          if (!ctx.alive()) { F.busy(false); return; }
          let res = 'back';
          try { res = await postingDone({ moment: false }); } finally { F.busy(false); }
          if (!ctx.alive() || res !== 'again') return;
          tok.can = true;
          return questAgain(tok);
        }
        F.busy(true);
        await sleep(RM() ? 0 : 160);
        if (!ctx.alive()) { F.busy(false); return; }
        const r = await postingScreen({ went: !!signLedger });
        F.busy(false);
        if (!ctx.alive()) return;
        if (r === 'went') return ledgerFlow(tok);
        if (r !== 'take') return;
        /* the question gives way to a tap on anything else, as every way out does, until the yes */
        tok.can = true;
        await step(tok, leaveAsk({ tok, lines: L.posting, yes: L.postingYes, href: FFD.questHref(ID, o.medium || 'poster') }));
      }
      /* the paper as the quest prints it. done: the likeness frame holds a crop box for the Iron Matron and the two
         strokes, and the reward is struck through */
      const X_SVG = '<svg class="lbp-x" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path class="lbp-x1" pathLength="1" d="M9 8C36 35 63 62 91 92" /><path class="lbp-x2" pathLength="1" d="M90 9C63 37 36 63 10 91" /></svg>';
      function paperOf(done) {
        const nail = (x) => h('i', { class: 'lbp-nail', style: 'left:' + x + '%' });
        let face, mat = null, lk = null;
        if (!done) face = h('span', { class: 'lbp-face', 'aria-hidden': 'true', html: POSTING_FACE + '<small>Likeness unknown</small>' });
        else {
          mat = h('span', { class: 'lbp-mat' }, h('span', { class: 'lbp-mat-in' }));
          lk = h('span', { class: 'lbp-lk', html: POSTING_FACE + X_SVG });
          lk.insertBefore(mat, lk.lastChild);
          /* not hidden from screen readers: the Matron's canvas names her (QOArt's own label), the stamp says Eliminated */
          face = h('span', { class: 'lbp-face is-done' }, lk, h('small', { text: DONE.face }));
        }
        const reward = h('span', { class: 'lbp-reward' + (done ? ' is-paid' : '') }, h('small', { text: 'Reward' }), h('b', { text: '200 Gold' }));
        const poster = h('div', { class: 'lbp-poster' },
          nail(14), nail(50), nail(86),
          h('i', { class: 'lbp-rule' }),
          h('p', { class: 'lbp-h', id: 'lbp-h', text: 'Wanted' }),
          h('i', { class: 'lbp-rule' }),
          h('p', { class: 'lbp-sub', text: POSTING.sub }),
          face,
          h('p', { class: 'lbp-body', html: POSTING.body }),
          reward,
          h('span', { class: 'lbp-foot' }, h('span', { text: POSTING.foot }), h('i', { class: 'lbp-seal', 'aria-hidden': 'true' }, h('b', { text: 'M' }))));
        return { poster, reward, lk, matIn: mat ? mat.firstChild : null };
      }
      /* the overlay both papers share: on document.body over the room, Escape and a tap beside it as "back" (o.canBack()
         says when), Tab kept on its buttons, and the focus back on the poster after */
      function overlay(o) {
        const lastFocus = document.activeElement;
        const ov = h('div', { class: 'lbp' + (o.cls ? ' ' + o.cls : ''), role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'lbp-h' },
          h('div', { class: 'lbp-main' }, h('p', { class: 'lbp-lead', html: POSTING.lead }), h('div', { class: 'lbp-wrap' }, o.poster), ...o.below));
        let shut = false;
        const canBack = () => !o.canBack || o.canBack();
        const close = (v, fast) => {
          if (shut) return;
          shut = true; pScreen = null;
          document.removeEventListener('keydown', onKey, true);
          document.documentElement.classList.remove('lbp-open');
          ov.classList.remove('is-in'); ov.classList.add('is-out');
          if (fast || RM()) ov.remove(); else setTimeout(() => ov.remove(), 240);
          /* the reader's place in the room comes back with the focus: the poster */
          const back = F.el.querySelector('.ffs-hot[data-hot="poster"]') || (lastFocus && document.contains(lastFocus) ? lastFocus : null);
          try { if (back && back.focus) back.focus({ preventScroll: true }); } catch (e) { /* fine */ }
          try { if (o.onClose) o.onClose(); } catch (e) { /* fine */ }
          o.resolve(v);
        };
        const onKey = (e) => {
          if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); if (canBack()) { sound('tap'); close(o.back); } return; }
          if (e.key === 'Tab') { const f = o.focusables().filter((b) => b && !b.disabled), i = f.indexOf(document.activeElement); e.preventDefault(); if (f.length) f[i < 0 ? 0 : (i + 1) % f.length].focus({ preventScroll: true }); }
        };
        ov.addEventListener('click', (e) => { if (e.target === ov && !ov.classList.contains('is-taken') && canBack()) { sound('tap'); close(o.back); } });
        pScreen = { close: (v, fast) => close(v == null ? o.back : v, fast) };
        document.addEventListener('keydown', onKey, true);
        document.documentElement.classList.add('lbp-open');
        document.body.append(ov);
        requestAnimationFrame(() => { ov.classList.add('is-in'); });
        return { ov, close, isShut: () => shut };
      }
      /* the posting for a reader the room doesn't know yet: 'take', 'stay' (left on the wall) or 'went' (the ledger) */
      function postingScreen(o) {
        o = o || {};
        return new Promise((resolve) => {
          if (pScreen) { resolve('stay'); return; }
          const P = paperOf(false);
          const take = h('button', { type: 'button', class: 'lbp-take', text: POSTING.take });
          const stay = h('button', { type: 'button', class: 'lbp-stay', text: POSTING.stay });
          const went = o.went ? h('button', { type: 'button', class: 'lbp-stay lbp-went', text: LOCK.went }) : null;
          let takeT = 0;
          const W = overlay({ poster: P.poster, below: [h('div', { class: 'lbp-btns' }, ...[take, stay, went].filter(Boolean))], back: 'stay', resolve, focusables: () => [take, stay, went], onClose: () => clearTimeout(takeT) });
          stay.addEventListener('click', (e) => { e.stopPropagation(); sound('tap'); W.close('stay'); });
          if (went) went.addEventListener('click', (e) => { e.stopPropagation(); sound('tap'); W.close('went'); });
          take.addEventListener('click', (e) => {
            e.stopPropagation();
            if (W.ov.classList.contains('is-taken')) return;
            take.disabled = true;
            sound('rip');
            W.ov.classList.add('is-taken');
            takeT = setTimeout(() => W.close('take'), RM() ? 0 : 660);
          });
          setTimeout(() => { try { if (!W.isShut()) take.focus({ preventScroll: true }); } catch (e) { /* fine */ } }, RM() ? 0 : 60);
        });
      }
      /* the posting for a Quest taker: 'back' or 'again' (the Quest with another hero). o.moment: the likeness inks in,
         two strokes cross her out, the stamp lands with a hammer, the reward says who was paid, and only then the
         buttons (about 3.2 s; under reduced motion the end at once). Without QOArt the "?" stays, and the strokes and the
         stamp still come */
      function postingDone(o) {
        o = o || {};
        return new Promise((resolve) => {
          if (pScreen) { resolve('back'); return; }
          const hero = questHero(), P = paperOf(true), moment = !!o.moment && !RM();
          /* the stamp lands across the likeness, over her shoulders, with a few ink specks round it */
          const stamp = h('span', { class: 'lbp-stamp', role: 'img', 'aria-label': DONE.stamp, text: DONE.stamp });
          const dots = [[-40, 38], [134, 50], [-30, 96], [126, 98], [140, 22]].map(([x, y]) => h('i', { class: 'lbp-dot', 'aria-hidden': 'true', style: 'left:' + x + '%;top:' + y + '%' }));
          P.lk.append(stamp, ...dots);
          /* the name as text, never markup */
          P.reward.append(h('span', { class: 'lbp-paid', text: hero && hero.name ? DONE.paid + hero.name : DONE.paidNo }));
          const back = h('button', { type: 'button', class: 'lbp-take', text: DONE.back });
          const again = h('button', { type: 'button', class: 'lbp-stay', text: DONE.again });
          let landed = !moment, M = null;
          const timers = [];
          const later = (ms, fn) => timers.push(setTimeout(fn, ms));
          const W = overlay({
            poster: P.poster, below: [h('div', { class: 'lbp-btns' }, back, again)], cls: 'is-done' + (moment ? ' is-moment' : ''), back: 'back', resolve,
            canBack: () => landed, focusables: () => [back, again],
            onClose: () => { timers.forEach(clearTimeout); try { if (M && M.destroy) M.destroy(); } catch (e) { /* fine */ } }
          });
          try { if (window.QOArt && typeof QOArt.mountMatron === 'function') M = QOArt.mountMatron(P.matIn, { state: 'matron', reduced: true }); } catch (e) { M = null; }
          if (P.matIn.querySelector('canvas')) W.ov.classList.add('has-mat');
          /* the wall's own poster is crossed out once the stamp has landed (a page hidden mid-moment plays it again) */
          const stampIt = () => { try { if (o.moment && gallery) gallery.stamp(); } catch (e) { /* fine */ } paintGallery(); };
          /* a short screen (a phone on its side) has the paid line under the fold: the paper moves up just enough to show
             it, which keeps the stamped face in view */
          const showPaid = () => {
            try {
              const p = W.ov.querySelector('.lbp-paid');
              if (!p || W.ov.scrollHeight - W.ov.clientHeight < 2) return;
              const over = p.getBoundingClientRect().bottom - (W.ov.clientHeight - 12);
              if (over > 0) W.ov.scrollBy({ top: Math.ceil(over), behavior: RM() ? 'auto' : 'smooth' });
            } catch (e) { /* fine */ }
          };
          const land = () => { if (landed && !moment) return; landed = true; W.ov.classList.add('is-landed'); stampIt(); try { back.focus({ preventScroll: true }); } catch (e) { /* fine */ } showPaid(); };
          back.addEventListener('click', (e) => { e.stopPropagation(); if (!landed) return; sound('tap'); W.close('back'); });
          again.addEventListener('click', (e) => { e.stopPropagation(); if (!landed) return; sound('tap'); W.close('again'); });
          if (moment) {
            later(1720, () => sound('pen'));
            later(1980, () => sound('pen'));
            later(2500, () => { sound('hammer'); try { if (FFD.buzz) FFD.buzz(14); } catch (e) { /* fine */ } });
            later(3200, land);
          } else {
            if (o.moment) stampIt();
            setTimeout(() => { try { if (!W.isShut()) back.focus({ preventScroll: true }); } catch (e) { /* fine */ } }, RM() ? 0 : 60);
            /* once the paper has risen (its 0.7 s entrance moves it) */
            later(RM() ? 0 : 720, () => { if (!W.isShut()) showPaid(); });
          }
        });
      }
      /* the posting goes at once (Back from the browser's cache, the page going away) */
      function posterClose(fast) { if (pScreen) pScreen.close(null, fast); }
      ctx.onKill(() => posterClose(true));

      /* ================= the ledger ================= */
      /* the ledger reads out. While the totals are this browser's own (FFD.tally.shared false, as on the store until the
         shared results are installed), it says only what this reader asked most, never a count that reads as everyone's */
      function ledgerLine() {
        /* a reader the room knows finds their own line in it (L.visitors) */
        const me = questHero();
        if (me && me.name && tookQuest()) {
          /* the room's own count of visits goes back further than FFD.visitDays (new this round), so the larger one wins */
          let n = 0; try { n = typeof FFD.visitDays === 'function' ? FFD.visitDays(ID) : 0; } catch (e) { n = 0; }
          return heroLine(L.visitors, me, { n: String(Math.max(1, n || 0, st.visits || 0)) });
        }
        const Lg = ledger(), total = BAYS.reduce((a, k) => a + Lg[k], 0);
        if (!total) return 'The ledger is empty. Your question would be its first line.';
        const top = BAYS.slice().sort((a, b) => Lg[b] - Lg[a])[0];
        if (!FFD.tally.shared) return 'You’ve asked about ' + SHELF[top].topic + ' most.';
        return total + ' ' + (total === 1 ? 'question' : 'questions') + ' in the ledger so far. ' + (total === 1 ? 'It’s about ' : 'Most are about ') + SHELF[top].topic + '.';
      }
    }
  });
})();
